var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/*! @iceteachain/web3 v0.2.5 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.icetea = t() : e.icetea = t();
}(this, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var i = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        r.d(n, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 92);
  }([function (e, t) {
    "function" == typeof Object.create ? e.exports = function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : e.exports = function (e, t) {
      e.super_ = t;

      var r = function r() {};

      r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
    };
  }, function (e, t, r) {
    var n = r(2),
        i = n.Buffer;

    function o(e, t) {
      for (var r in e) {
        t[r] = e[r];
      }
    }

    function a(e, t, r) {
      return i(e, t, r);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = n : (o(n, t), t.Buffer = a), o(i, a), a.from = function (e, t, r) {
      if ("number" == typeof e) throw new TypeError("Argument must not be a number");
      return i(e, t, r);
    }, a.alloc = function (e, t, r) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      var n = i(e);
      return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
    }, a.allocUnsafe = function (e) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      return i(e);
    }, a.allocUnsafeSlow = function (e) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      return n.SlowBuffer(e);
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var n = r(93),
          i = r(94),
          o = r(46);

      function a() {
        return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function s(e, t) {
        if (a() < t) throw new RangeError("Invalid typed array length");
        return f.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = f.prototype : (null === e && (e = new f(t)), e.length = t), e;
      }

      function f(e, t, r) {
        if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(e, t, r);

        if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
          return d(this, e);
        }

        return c(this, e, t, r);
      }

      function c(e, t, r, n) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, r, n) {
          if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n);
          f.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = f.prototype : e = h(e, t);
          return e;
        }(e, t, r, n) : "string" == typeof t ? function (e, t, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | p(t, r),
              i = (e = s(e, n)).write(t, r);
          i !== n && (e = e.slice(0, i));
          return e;
        }(e, t, r) : function (e, t) {
          if (f.isBuffer(t)) {
            var r = 0 | l(t.length);
            return 0 === (e = s(e, r)).length || t.copy(e, 0, 0, r), e;
          }

          if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (n = t.length) != n ? s(e, 0) : h(e, t);
            if ("Buffer" === t.type && o(t.data)) return h(e, t.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }

      function u(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative');
      }

      function d(e, t) {
        if (u(t), e = s(e, t < 0 ? 0 : 0 | l(t)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < t; ++r) {
          e[r] = 0;
        }
        return e;
      }

      function h(e, t) {
        var r = t.length < 0 ? 0 : 0 | l(t.length);
        e = s(e, r);

        for (var n = 0; n < r; n += 1) {
          e[n] = 255 & t[n];
        }

        return e;
      }

      function l(e) {
        if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | e;
      }

      function p(e, t) {
        if (f.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var r = e.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return q(e).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return z(e).length;

            default:
              if (n) return q(e).length;
              t = ("" + t).toLowerCase(), n = !0;
          }
        }
      }

      function b(e, t, r) {
        var n = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (t >>>= 0)) return "";

        for (e || (e = "utf8");;) {
          switch (e) {
            case "hex":
              return j(this, t, r);

            case "utf8":
            case "utf-8":
              return M(this, t, r);

            case "ascii":
              return x(this, t, r);

            case "latin1":
            case "binary":
              return I(this, t, r);

            case "base64":
              return S(this, t, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return B(this, t, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + e);
              e = (e + "").toLowerCase(), n = !0;
          }
        }
      }

      function m(e, t, r) {
        var n = e[t];
        e[t] = e[r], e[r] = n;
      }

      function y(e, t, r, n, i) {
        if (0 === e.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
          if (i) return -1;
          r = e.length - 1;
        } else if (r < 0) {
          if (!i) return -1;
          r = 0;
        }

        if ("string" == typeof t && (t = f.from(t, n)), f.isBuffer(t)) return 0 === t.length ? -1 : v(e, t, r, n, i);
        if ("number" == typeof t) return t &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : v(e, [t], r, n, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function v(e, t, r, n, i) {
        var o,
            a = 1,
            s = e.length,
            f = t.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (e.length < 2 || t.length < 2) return -1;
          a = 2, s /= 2, f /= 2, r /= 2;
        }

        function c(e, t) {
          return 1 === a ? e[t] : e.readUInt16BE(t * a);
        }

        if (i) {
          var u = -1;

          for (o = r; o < s; o++) {
            if (c(e, o) === c(t, -1 === u ? 0 : o - u)) {
              if (-1 === u && (u = o), o - u + 1 === f) return u * a;
            } else -1 !== u && (o -= o - u), u = -1;
          }
        } else for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
          for (var d = !0, h = 0; h < f; h++) {
            if (c(e, o + h) !== c(t, h)) {
              d = !1;
              break;
            }
          }

          if (d) return o;
        }

        return -1;
      }

      function g(e, t, r, n) {
        r = Number(r) || 0;
        var i = e.length - r;
        n ? (n = Number(n)) > i && (n = i) : n = i;
        var o = t.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        n > o / 2 && (n = o / 2);

        for (var a = 0; a < n; ++a) {
          var s = parseInt(t.substr(2 * a, 2), 16);
          if (isNaN(s)) return a;
          e[r + a] = s;
        }

        return a;
      }

      function _(e, t, r, n) {
        return F(q(t, e.length - r), e, r, n);
      }

      function w(e, t, r, n) {
        return F(function (e) {
          for (var t = [], r = 0; r < e.length; ++r) {
            t.push(255 & e.charCodeAt(r));
          }

          return t;
        }(t), e, r, n);
      }

      function k(e, t, r, n) {
        return w(e, t, r, n);
      }

      function E(e, t, r, n) {
        return F(z(t), e, r, n);
      }

      function A(e, t, r, n) {
        return F(function (e, t) {
          for (var r, n, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
            r = e.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
          }

          return o;
        }(t, e.length - r), e, r, n);
      }

      function S(e, t, r) {
        return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
      }

      function M(e, t, r) {
        r = Math.min(e.length, r);

        for (var n = [], i = t; i < r;) {
          var o,
              a,
              s,
              f,
              c = e[i],
              u = null,
              d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (i + d <= r) switch (d) {
            case 1:
              c < 128 && (u = c);
              break;

            case 2:
              128 == (192 & (o = e[i + 1])) && (f = (31 & c) << 6 | 63 & o) > 127 && (u = f);
              break;

            case 3:
              o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (u = f);
              break;

            case 4:
              o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (u = f);
          }
          null === u ? (u = 65533, d = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += d;
        }

        return function (e) {
          var t = e.length;
          if (t <= 4096) return String.fromCharCode.apply(String, e);
          var r = "",
              n = 0;

          for (; n < t;) {
            r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
          }

          return r;
        }(n);
      }

      t.Buffer = f, t.SlowBuffer = function (e) {
        +e != e && (e = 0);
        return f.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);
          return e.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = a(), f.poolSize = 8192, f._augment = function (e) {
        return e.__proto__ = f.prototype, e;
      }, f.from = function (e, t, r) {
        return c(null, e, t, r);
      }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
        value: null,
        configurable: !0
      })), f.alloc = function (e, t, r) {
        return function (e, t, r, n) {
          return u(t), t <= 0 ? s(e, t) : void 0 !== r ? "string" == typeof n ? s(e, t).fill(r, n) : s(e, t).fill(r) : s(e, t);
        }(null, e, t, r);
      }, f.allocUnsafe = function (e) {
        return d(null, e);
      }, f.allocUnsafeSlow = function (e) {
        return d(null, e);
      }, f.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, f.compare = function (e, t) {
        if (!f.isBuffer(e) || !f.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;

        for (var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (e[i] !== t[i]) {
            r = e[i], n = t[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, f.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, f.concat = function (e, t) {
        if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return f.alloc(0);
        var r;
        if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) {
          t += e[r].length;
        }
        var n = f.allocUnsafe(t),
            i = 0;

        for (r = 0; r < e.length; ++r) {
          var a = e[r];
          if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(n, i), i += a.length;
        }

        return n;
      }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var t = 0; t < e; t += 2) {
          m(this, t, t + 1);
        }

        return this;
      }, f.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var t = 0; t < e; t += 4) {
          m(this, t, t + 3), m(this, t + 1, t + 2);
        }

        return this;
      }, f.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var t = 0; t < e; t += 8) {
          m(this, t, t + 7), m(this, t + 1, t + 6), m(this, t + 2, t + 5), m(this, t + 3, t + 4);
        }

        return this;
      }, f.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? M(this, 0, e) : b.apply(this, arguments);
      }, f.prototype.equals = function (e) {
        if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === f.compare(this, e);
      }, f.prototype.inspect = function () {
        var e = "",
            r = t.INSPECT_MAX_BYTES;
        return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
      }, f.prototype.compare = function (e, t, r, n, i) {
        if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
        if (n >= i && t >= r) return 0;
        if (n >= i) return -1;
        if (t >= r) return 1;
        if (this === e) return 0;

        for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), s = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), d = 0; d < s; ++d) {
          if (c[d] !== u[d]) {
            o = c[d], a = u[d];
            break;
          }
        }

        return o < a ? -1 : a < o ? 1 : 0;
      }, f.prototype.includes = function (e, t, r) {
        return -1 !== this.indexOf(e, t, r);
      }, f.prototype.indexOf = function (e, t, r) {
        return y(this, e, t, r, !0);
      }, f.prototype.lastIndexOf = function (e, t, r) {
        return y(this, e, t, r, !1);
      }, f.prototype.write = function (e, t, r, n) {
        if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var i = this.length - t;
        if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var o = !1;;) {
          switch (n) {
            case "hex":
              return g(this, e, t, r);

            case "utf8":
            case "utf-8":
              return _(this, e, t, r);

            case "ascii":
              return w(this, e, t, r);

            case "latin1":
            case "binary":
              return k(this, e, t, r);

            case "base64":
              return E(this, e, t, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return A(this, e, t, r);

            default:
              if (o) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), o = !0;
          }
        }
      }, f.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function x(e, t, r) {
        var n = "";
        r = Math.min(e.length, r);

        for (var i = t; i < r; ++i) {
          n += String.fromCharCode(127 & e[i]);
        }

        return n;
      }

      function I(e, t, r) {
        var n = "";
        r = Math.min(e.length, r);

        for (var i = t; i < r; ++i) {
          n += String.fromCharCode(e[i]);
        }

        return n;
      }

      function j(e, t, r) {
        var n = e.length;
        (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);

        for (var i = "", o = t; o < r; ++o) {
          i += D(e[o]);
        }

        return i;
      }

      function B(e, t, r) {
        for (var n = e.slice(t, r), i = "", o = 0; o < n.length; o += 2) {
          i += String.fromCharCode(n[o] + 256 * n[o + 1]);
        }

        return i;
      }

      function R(e, t, r) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function P(e, t, r, n, i, o) {
        if (!f.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
        if (r + n > e.length) throw new RangeError("Index out of range");
      }

      function T(e, t, r, n) {
        t < 0 && (t = 65535 + t + 1);

        for (var i = 0, o = Math.min(e.length - r, 2); i < o; ++i) {
          e[r + i] = (t & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
        }
      }

      function L(e, t, r, n) {
        t < 0 && (t = 4294967295 + t + 1);

        for (var i = 0, o = Math.min(e.length - r, 4); i < o; ++i) {
          e[r + i] = t >>> 8 * (n ? i : 3 - i) & 255;
        }
      }

      function C(e, t, r, n, i, o) {
        if (r + n > e.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function O(e, t, r, n, o) {
        return o || C(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
      }

      function N(e, t, r, n, o) {
        return o || C(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
      }

      f.prototype.slice = function (e, t) {
        var r,
            n = this.length;
        if ((e = ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), (t = void 0 === t ? n : ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(e, t)).__proto__ = f.prototype;else {
          var i = t - e;
          r = new f(i, void 0);

          for (var o = 0; o < i; ++o) {
            r[o] = this[o + e];
          }
        }
        return r;
      }, f.prototype.readUIntLE = function (e, t, r) {
        e |= 0, t |= 0, r || R(e, t, this.length);

        for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          n += this[e + o] * i;
        }

        return n;
      }, f.prototype.readUIntBE = function (e, t, r) {
        e |= 0, t |= 0, r || R(e, t, this.length);

        for (var n = this[e + --t], i = 1; t > 0 && (i *= 256);) {
          n += this[e + --t] * i;
        }

        return n;
      }, f.prototype.readUInt8 = function (e, t) {
        return t || R(e, 1, this.length), this[e];
      }, f.prototype.readUInt16LE = function (e, t) {
        return t || R(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, f.prototype.readUInt16BE = function (e, t) {
        return t || R(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, f.prototype.readUInt32LE = function (e, t) {
        return t || R(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, f.prototype.readUInt32BE = function (e, t) {
        return t || R(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, f.prototype.readIntLE = function (e, t, r) {
        e |= 0, t |= 0, r || R(e, t, this.length);

        for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          n += this[e + o] * i;
        }

        return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
      }, f.prototype.readIntBE = function (e, t, r) {
        e |= 0, t |= 0, r || R(e, t, this.length);

        for (var n = t, i = 1, o = this[e + --n]; n > 0 && (i *= 256);) {
          o += this[e + --n] * i;
        }

        return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
      }, f.prototype.readInt8 = function (e, t) {
        return t || R(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, f.prototype.readInt16LE = function (e, t) {
        t || R(e, 2, this.length);
        var r = this[e] | this[e + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, f.prototype.readInt16BE = function (e, t) {
        t || R(e, 2, this.length);
        var r = this[e + 1] | this[e] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, f.prototype.readInt32LE = function (e, t) {
        return t || R(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, f.prototype.readInt32BE = function (e, t) {
        return t || R(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, f.prototype.readFloatLE = function (e, t) {
        return t || R(e, 4, this.length), i.read(this, e, !0, 23, 4);
      }, f.prototype.readFloatBE = function (e, t) {
        return t || R(e, 4, this.length), i.read(this, e, !1, 23, 4);
      }, f.prototype.readDoubleLE = function (e, t) {
        return t || R(e, 8, this.length), i.read(this, e, !0, 52, 8);
      }, f.prototype.readDoubleBE = function (e, t) {
        return t || R(e, 8, this.length), i.read(this, e, !1, 52, 8);
      }, f.prototype.writeUIntLE = function (e, t, r, n) {
        (e = +e, t |= 0, r |= 0, n) || P(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
        var i = 1,
            o = 0;

        for (this[t] = 255 & e; ++o < r && (i *= 256);) {
          this[t + o] = e / i & 255;
        }

        return t + r;
      }, f.prototype.writeUIntBE = function (e, t, r, n) {
        (e = +e, t |= 0, r |= 0, n) || P(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
        var i = r - 1,
            o = 1;

        for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
          this[t + i] = e / o & 255;
        }

        return t + r;
      }, f.prototype.writeUInt8 = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, f.prototype.writeUInt16LE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : T(this, e, t, !0), t + 2;
      }, f.prototype.writeUInt16BE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : T(this, e, t, !1), t + 2;
      }, f.prototype.writeUInt32LE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : L(this, e, t, !0), t + 4;
      }, f.prototype.writeUInt32BE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4;
      }, f.prototype.writeIntLE = function (e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          P(this, e, t, r, i - 1, -i);
        }

        var o = 0,
            a = 1,
            s = 0;

        for (this[t] = 255 & e; ++o < r && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
        }

        return t + r;
      }, f.prototype.writeIntBE = function (e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          P(this, e, t, r, i - 1, -i);
        }

        var o = r - 1,
            a = 1,
            s = 0;

        for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
        }

        return t + r;
      }, f.prototype.writeInt8 = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, f.prototype.writeInt16LE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : T(this, e, t, !0), t + 2;
      }, f.prototype.writeInt16BE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : T(this, e, t, !1), t + 2;
      }, f.prototype.writeInt32LE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : L(this, e, t, !0), t + 4;
      }, f.prototype.writeInt32BE = function (e, t, r) {
        return e = +e, t |= 0, r || P(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4;
      }, f.prototype.writeFloatLE = function (e, t, r) {
        return O(this, e, t, !0, r);
      }, f.prototype.writeFloatBE = function (e, t, r) {
        return O(this, e, t, !1, r);
      }, f.prototype.writeDoubleLE = function (e, t, r) {
        return N(this, e, t, !0, r);
      }, f.prototype.writeDoubleBE = function (e, t, r) {
        return N(this, e, t, !1, r);
      }, f.prototype.copy = function (e, t, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
        var i,
            o = n - r;
        if (this === e && r < t && t < n) for (i = o - 1; i >= 0; --i) {
          e[i + t] = this[i + r];
        } else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          e[i + t] = this[i + r];
        } else Uint8Array.prototype.set.call(e, this.subarray(r, r + o), t);
        return o;
      }, f.prototype.fill = function (e, t, r, n) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
            var i = e.charCodeAt(0);
            i < 256 && (e = i);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof e && (e &= 255);

        if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
        if (r <= t) return this;
        var o;
        if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < r; ++o) {
          this[o] = e;
        } else {
          var a = f.isBuffer(e) ? e : q(new f(e, n).toString()),
              s = a.length;

          for (o = 0; o < r - t; ++o) {
            this[o + t] = a[o % s];
          }
        }
        return this;
      };
      var U = /[^+\/0-9A-Za-z-_]/g;

      function D(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }

      function q(e, t) {
        var r;
        t = t || 1 / 0;

        for (var n = e.length, i = null, o = [], a = 0; a < n; ++a) {
          if ((r = e.charCodeAt(a)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (a + 1 === n) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = r;
              continue;
            }

            if (r < 56320) {
              (t -= 3) > -1 && o.push(239, 191, 189), i = r;
              continue;
            }

            r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (t -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, r < 128) {
            if ((t -= 1) < 0) break;
            o.push(r);
          } else if (r < 2048) {
            if ((t -= 2) < 0) break;
            o.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((t -= 3) < 0) break;
            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((t -= 4) < 0) break;
            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return o;
      }

      function z(e) {
        return n.toByteArray(function (e) {
          if ((e = function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(U, "")).length < 2) return "";

          for (; e.length % 4 != 0;) {
            e += "=";
          }

          return e;
        }(e));
      }

      function F(e, t, r, n) {
        for (var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i) {
          t[i + r] = e[i];
        }

        return i;
      }
    }).call(this, r(6));
  }, function (e, t, r) {
    (function (e) {
      !function (e, t) {
        "use strict";

        function n(e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }

        function i(e, t) {
          e.super_ = t;

          var r = function r() {};

          r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
        }

        function o(e, t, r) {
          if (o.isBN(e)) return e;
          this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
        }

        var a;
        "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;

        try {
          a = r(133).Buffer;
        } catch (e) {}

        function s(e, t, r) {
          for (var n = 0, i = Math.min(e.length, r), o = t; o < i; o++) {
            var a = e.charCodeAt(o) - 48;
            n <<= 4, n |= a >= 49 && a <= 54 ? a - 49 + 10 : a >= 17 && a <= 22 ? a - 17 + 10 : 15 & a;
          }

          return n;
        }

        function f(e, t, r, n) {
          for (var i = 0, o = Math.min(e.length, r), a = t; a < o; a++) {
            var s = e.charCodeAt(a) - 48;
            i *= n, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
          }

          return i;
        }

        o.isBN = function (e) {
          return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
        }, o.max = function (e, t) {
          return e.cmp(t) > 0 ? e : t;
        }, o.min = function (e, t) {
          return e.cmp(t) < 0 ? e : t;
        }, o.prototype._init = function (e, t, r) {
          if ("number" == typeof e) return this._initNumber(e, t, r);
          if ("object" == typeof e) return this._initArray(e, t, r);
          "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
          var i = 0;
          "-" === (e = e.toString().replace(/\s+/g, ""))[0] && i++, 16 === t ? this._parseHex(e, i) : this._parseBase(e, t, i), "-" === e[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), t, r);
        }, o.prototype._initNumber = function (e, t, r) {
          e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
        }, o.prototype._initArray = function (e, t, r) {
          if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
          this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var o,
              a,
              s = 0;
          if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) {
            a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
          } else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) {
            a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
          }
          return this.strip();
        }, o.prototype._parseHex = function (e, t) {
          this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

          for (var r = 0; r < this.length; r++) {
            this.words[r] = 0;
          }

          var n,
              i,
              o = 0;

          for (r = e.length - 6, n = 0; r >= t; r -= 6) {
            i = s(e, r, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
          }

          r + 6 !== t && (i = s(e, t, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303), this.strip();
        }, o.prototype._parseBase = function (e, t, r) {
          this.words = [0], this.length = 1;

          for (var n = 0, i = 1; i <= 67108863; i *= t) {
            n++;
          }

          n--, i = i / t | 0;

          for (var o = e.length - r, a = o % n, s = Math.min(o, o - a) + r, c = 0, u = r; u < s; u += n) {
            c = f(e, u, u + n, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
          }

          if (0 !== a) {
            var d = 1;

            for (c = f(e, u, e.length, t), u = 0; u < a; u++) {
              d *= t;
            }

            this.imuln(d), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
          }
        }, o.prototype.copy = function (e) {
          e.words = new Array(this.length);

          for (var t = 0; t < this.length; t++) {
            e.words[t] = this.words[t];
          }

          e.length = this.length, e.negative = this.negative, e.red = this.red;
        }, o.prototype.clone = function () {
          var e = new o(null);
          return this.copy(e), e;
        }, o.prototype._expand = function (e) {
          for (; this.length < e;) {
            this.words[this.length++] = 0;
          }

          return this;
        }, o.prototype.strip = function () {
          for (; this.length > 1 && 0 === this.words[this.length - 1];) {
            this.length--;
          }

          return this._normSign();
        }, o.prototype._normSign = function () {
          return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, o.prototype.inspect = function () {
          return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        };
        var c = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

        function h(e, t, r) {
          r.negative = t.negative ^ e.negative;
          var n = e.length + t.length | 0;
          r.length = n, n = n - 1 | 0;
          var i = 0 | e.words[0],
              o = 0 | t.words[0],
              a = i * o,
              s = 67108863 & a,
              f = a / 67108864 | 0;
          r.words[0] = s;

          for (var c = 1; c < n; c++) {
            for (var u = f >>> 26, d = 67108863 & f, h = Math.min(c, t.length - 1), l = Math.max(0, c - e.length + 1); l <= h; l++) {
              var p = c - l | 0;
              u += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[l]) + d) / 67108864 | 0, d = 67108863 & a;
            }

            r.words[c] = 0 | d, f = 0 | u;
          }

          return 0 !== f ? r.words[c] = 0 | f : r.length--, r.strip();
        }

        o.prototype.toString = function (e, t) {
          var r;

          if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
            r = "";

            for (var i = 0, o = 0, a = 0; a < this.length; a++) {
              var s = this.words[a],
                  f = (16777215 & (s << i | o)).toString(16);
              r = 0 !== (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? c[6 - f.length] + f + r : f + r, (i += 2) >= 26 && (i -= 26, a--);
            }

            for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          if (e === (0 | e) && e >= 2 && e <= 36) {
            var h = u[e],
                l = d[e];
            r = "";
            var p = this.clone();

            for (p.negative = 0; !p.isZero();) {
              var b = p.modn(l).toString(e);
              r = (p = p.idivn(l)).isZero() ? b + r : c[h - b.length] + b + r;
            }

            for (this.isZero() && (r = "0" + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          n(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function () {
          var e = this.words[0];
          return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
        }, o.prototype.toJSON = function () {
          return this.toString(16);
        }, o.prototype.toBuffer = function (e, t) {
          return n(void 0 !== a), this.toArrayLike(a, e, t);
        }, o.prototype.toArray = function (e, t) {
          return this.toArrayLike(Array, e, t);
        }, o.prototype.toArrayLike = function (e, t, r) {
          var i = this.byteLength(),
              o = r || Math.max(1, i);
          n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
          var a,
              s,
              f = "le" === t,
              c = new e(o),
              u = this.clone();

          if (f) {
            for (s = 0; !u.isZero(); s++) {
              a = u.andln(255), u.iushrn(8), c[s] = a;
            }

            for (; s < o; s++) {
              c[s] = 0;
            }
          } else {
            for (s = 0; s < o - i; s++) {
              c[s] = 0;
            }

            for (s = 0; !u.isZero(); s++) {
              a = u.andln(255), u.iushrn(8), c[o - s - 1] = a;
            }
          }

          return c;
        }, Math.clz32 ? o.prototype._countBits = function (e) {
          return 32 - Math.clz32(e);
        } : o.prototype._countBits = function (e) {
          var t = e,
              r = 0;
          return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
        }, o.prototype._zeroBits = function (e) {
          if (0 === e) return 26;
          var t = e,
              r = 0;
          return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
        }, o.prototype.bitLength = function () {
          var e = this.words[this.length - 1],
              t = this._countBits(e);

          return 26 * (this.length - 1) + t;
        }, o.prototype.zeroBits = function () {
          if (this.isZero()) return 0;

          for (var e = 0, t = 0; t < this.length; t++) {
            var r = this._zeroBits(this.words[t]);

            if (e += r, 26 !== r) break;
          }

          return e;
        }, o.prototype.byteLength = function () {
          return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function (e) {
          return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function (e) {
          return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function () {
          return 0 !== this.negative;
        }, o.prototype.neg = function () {
          return this.clone().ineg();
        }, o.prototype.ineg = function () {
          return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function (e) {
          for (; this.length < e.length;) {
            this.words[this.length++] = 0;
          }

          for (var t = 0; t < e.length; t++) {
            this.words[t] = this.words[t] | e.words[t];
          }

          return this.strip();
        }, o.prototype.ior = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuor(e);
        }, o.prototype.or = function (e) {
          return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
        }, o.prototype.uor = function (e) {
          return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
        }, o.prototype.iuand = function (e) {
          var t;
          t = this.length > e.length ? e : this;

          for (var r = 0; r < t.length; r++) {
            this.words[r] = this.words[r] & e.words[r];
          }

          return this.length = t.length, this.strip();
        }, o.prototype.iand = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuand(e);
        }, o.prototype.and = function (e) {
          return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
        }, o.prototype.uand = function (e) {
          return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
        }, o.prototype.iuxor = function (e) {
          var t, r;
          this.length > e.length ? (t = this, r = e) : (t = e, r = this);

          for (var n = 0; n < r.length; n++) {
            this.words[n] = t.words[n] ^ r.words[n];
          }

          if (this !== t) for (; n < t.length; n++) {
            this.words[n] = t.words[n];
          }
          return this.length = t.length, this.strip();
        }, o.prototype.ixor = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuxor(e);
        }, o.prototype.xor = function (e) {
          return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
        }, o.prototype.uxor = function (e) {
          return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
        }, o.prototype.inotn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = 0 | Math.ceil(e / 26),
              r = e % 26;
          this._expand(t), r > 0 && t--;

          for (var i = 0; i < t; i++) {
            this.words[i] = 67108863 & ~this.words[i];
          }

          return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
        }, o.prototype.notn = function (e) {
          return this.clone().inotn(e);
        }, o.prototype.setn = function (e, t) {
          n("number" == typeof e && e >= 0);
          var r = e / 26 | 0,
              i = e % 26;
          return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
        }, o.prototype.iadd = function (e) {
          var t, r, n;
          if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
          if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
          this.length > e.length ? (r = this, n = e) : (r = e, n = this);

          for (var i = 0, o = 0; o < n.length; o++) {
            t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
          }

          for (; 0 !== i && o < r.length; o++) {
            t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
          }

          if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
            this.words[o] = r.words[o];
          }
          return this;
        }, o.prototype.add = function (e) {
          var t;
          return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
        }, o.prototype.isub = function (e) {
          if (0 !== e.negative) {
            e.negative = 0;
            var t = this.iadd(e);
            return e.negative = 1, t._normSign();
          }

          if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
          var r,
              n,
              i = this.cmp(e);
          if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
          i > 0 ? (r = this, n = e) : (r = e, n = this);

          for (var o = 0, a = 0; a < n.length; a++) {
            o = (t = (0 | r.words[a]) - (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
          }

          for (; 0 !== o && a < r.length; a++) {
            o = (t = (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
          }

          if (0 === o && a < r.length && r !== this) for (; a < r.length; a++) {
            this.words[a] = r.words[a];
          }
          return this.length = Math.max(this.length, a), r !== this && (this.negative = 1), this.strip();
        }, o.prototype.sub = function (e) {
          return this.clone().isub(e);
        };

        var l = function l(e, t, r) {
          var n,
              i,
              o,
              a = e.words,
              s = t.words,
              f = r.words,
              c = 0,
              u = 0 | a[0],
              d = 8191 & u,
              h = u >>> 13,
              l = 0 | a[1],
              p = 8191 & l,
              b = l >>> 13,
              m = 0 | a[2],
              y = 8191 & m,
              v = m >>> 13,
              g = 0 | a[3],
              _ = 8191 & g,
              w = g >>> 13,
              k = 0 | a[4],
              E = 8191 & k,
              A = k >>> 13,
              S = 0 | a[5],
              M = 8191 & S,
              x = S >>> 13,
              I = 0 | a[6],
              j = 8191 & I,
              B = I >>> 13,
              R = 0 | a[7],
              P = 8191 & R,
              T = R >>> 13,
              L = 0 | a[8],
              C = 8191 & L,
              O = L >>> 13,
              N = 0 | a[9],
              U = 8191 & N,
              D = N >>> 13,
              q = 0 | s[0],
              z = 8191 & q,
              F = q >>> 13,
              Y = 0 | s[1],
              K = 8191 & Y,
              V = Y >>> 13,
              H = 0 | s[2],
              W = 8191 & H,
              G = H >>> 13,
              X = 0 | s[3],
              Z = 8191 & X,
              J = X >>> 13,
              $ = 0 | s[4],
              Q = 8191 & $,
              ee = $ >>> 13,
              te = 0 | s[5],
              re = 8191 & te,
              ne = te >>> 13,
              ie = 0 | s[6],
              oe = 8191 & ie,
              ae = ie >>> 13,
              se = 0 | s[7],
              fe = 8191 & se,
              ce = se >>> 13,
              ue = 0 | s[8],
              de = 8191 & ue,
              he = ue >>> 13,
              le = 0 | s[9],
              pe = 8191 & le,
              be = le >>> 13;

          r.negative = e.negative ^ t.negative, r.length = 19;
          var me = (c + (n = Math.imul(d, z)) | 0) + ((8191 & (i = (i = Math.imul(d, F)) + Math.imul(h, z) | 0)) << 13) | 0;
          c = ((o = Math.imul(h, F)) + (i >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, F)) + Math.imul(b, z) | 0, o = Math.imul(b, F);
          var ye = (c + (n = n + Math.imul(d, K) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, V) | 0) + Math.imul(h, K) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, V) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(y, z), i = (i = Math.imul(y, F)) + Math.imul(v, z) | 0, o = Math.imul(v, F), n = n + Math.imul(p, K) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(b, K) | 0, o = o + Math.imul(b, V) | 0;
          var ve = (c + (n = n + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, G) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(_, z), i = (i = Math.imul(_, F)) + Math.imul(w, z) | 0, o = Math.imul(w, F), n = n + Math.imul(y, K) | 0, i = (i = i + Math.imul(y, V) | 0) + Math.imul(v, K) | 0, o = o + Math.imul(v, V) | 0, n = n + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(b, W) | 0, o = o + Math.imul(b, G) | 0;
          var ge = (c + (n = n + Math.imul(d, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, J) | 0) + Math.imul(h, Z) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, J) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(E, z), i = (i = Math.imul(E, F)) + Math.imul(A, z) | 0, o = Math.imul(A, F), n = n + Math.imul(_, K) | 0, i = (i = i + Math.imul(_, V) | 0) + Math.imul(w, K) | 0, o = o + Math.imul(w, V) | 0, n = n + Math.imul(y, W) | 0, i = (i = i + Math.imul(y, G) | 0) + Math.imul(v, W) | 0, o = o + Math.imul(v, G) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, J) | 0) + Math.imul(b, Z) | 0, o = o + Math.imul(b, J) | 0;

          var _e = (c + (n = n + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(h, Q) | 0)) << 13) | 0;

          c = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, F)) + Math.imul(x, z) | 0, o = Math.imul(x, F), n = n + Math.imul(E, K) | 0, i = (i = i + Math.imul(E, V) | 0) + Math.imul(A, K) | 0, o = o + Math.imul(A, V) | 0, n = n + Math.imul(_, W) | 0, i = (i = i + Math.imul(_, G) | 0) + Math.imul(w, W) | 0, o = o + Math.imul(w, G) | 0, n = n + Math.imul(y, Z) | 0, i = (i = i + Math.imul(y, J) | 0) + Math.imul(v, Z) | 0, o = o + Math.imul(v, J) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(b, Q) | 0, o = o + Math.imul(b, ee) | 0;
          var we = (c + (n = n + Math.imul(d, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ne) | 0) + Math.imul(h, re) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, ne) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(j, z), i = (i = Math.imul(j, F)) + Math.imul(B, z) | 0, o = Math.imul(B, F), n = n + Math.imul(M, K) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(x, K) | 0, o = o + Math.imul(x, V) | 0, n = n + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, G) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, G) | 0, n = n + Math.imul(_, Z) | 0, i = (i = i + Math.imul(_, J) | 0) + Math.imul(w, Z) | 0, o = o + Math.imul(w, J) | 0, n = n + Math.imul(y, Q) | 0, i = (i = i + Math.imul(y, ee) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(b, re) | 0, o = o + Math.imul(b, ne) | 0;
          var ke = (c + (n = n + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, ae) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, z), i = (i = Math.imul(P, F)) + Math.imul(T, z) | 0, o = Math.imul(T, F), n = n + Math.imul(j, K) | 0, i = (i = i + Math.imul(j, V) | 0) + Math.imul(B, K) | 0, o = o + Math.imul(B, V) | 0, n = n + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, G) | 0, n = n + Math.imul(E, Z) | 0, i = (i = i + Math.imul(E, J) | 0) + Math.imul(A, Z) | 0, o = o + Math.imul(A, J) | 0, n = n + Math.imul(_, Q) | 0, i = (i = i + Math.imul(_, ee) | 0) + Math.imul(w, Q) | 0, o = o + Math.imul(w, ee) | 0, n = n + Math.imul(y, re) | 0, i = (i = i + Math.imul(y, ne) | 0) + Math.imul(v, re) | 0, o = o + Math.imul(v, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0;
          var Ee = (c + (n = n + Math.imul(d, fe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(h, fe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, ce) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, F)) + Math.imul(O, z) | 0, o = Math.imul(O, F), n = n + Math.imul(P, K) | 0, i = (i = i + Math.imul(P, V) | 0) + Math.imul(T, K) | 0, o = o + Math.imul(T, V) | 0, n = n + Math.imul(j, W) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(B, W) | 0, o = o + Math.imul(B, G) | 0, n = n + Math.imul(M, Z) | 0, i = (i = i + Math.imul(M, J) | 0) + Math.imul(x, Z) | 0, o = o + Math.imul(x, J) | 0, n = n + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, ee) | 0, n = n + Math.imul(_, re) | 0, i = (i = i + Math.imul(_, ne) | 0) + Math.imul(w, re) | 0, o = o + Math.imul(w, ne) | 0, n = n + Math.imul(y, oe) | 0, i = (i = i + Math.imul(y, ae) | 0) + Math.imul(v, oe) | 0, o = o + Math.imul(v, ae) | 0, n = n + Math.imul(p, fe) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(b, fe) | 0, o = o + Math.imul(b, ce) | 0;
          var Ae = (c + (n = n + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, he) | 0) + Math.imul(h, de) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(U, z), i = (i = Math.imul(U, F)) + Math.imul(D, z) | 0, o = Math.imul(D, F), n = n + Math.imul(C, K) | 0, i = (i = i + Math.imul(C, V) | 0) + Math.imul(O, K) | 0, o = o + Math.imul(O, V) | 0, n = n + Math.imul(P, W) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(T, W) | 0, o = o + Math.imul(T, G) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, J) | 0) + Math.imul(B, Z) | 0, o = o + Math.imul(B, J) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(x, Q) | 0, o = o + Math.imul(x, ee) | 0, n = n + Math.imul(E, re) | 0, i = (i = i + Math.imul(E, ne) | 0) + Math.imul(A, re) | 0, o = o + Math.imul(A, ne) | 0, n = n + Math.imul(_, oe) | 0, i = (i = i + Math.imul(_, ae) | 0) + Math.imul(w, oe) | 0, o = o + Math.imul(w, ae) | 0, n = n + Math.imul(y, fe) | 0, i = (i = i + Math.imul(y, ce) | 0) + Math.imul(v, fe) | 0, o = o + Math.imul(v, ce) | 0, n = n + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, he) | 0;
          var Se = (c + (n = n + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, be) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(h, be) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(U, K), i = (i = Math.imul(U, V)) + Math.imul(D, K) | 0, o = Math.imul(D, V), n = n + Math.imul(C, W) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(O, W) | 0, o = o + Math.imul(O, G) | 0, n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, J) | 0) + Math.imul(T, Z) | 0, o = o + Math.imul(T, J) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(B, Q) | 0, o = o + Math.imul(B, ee) | 0, n = n + Math.imul(M, re) | 0, i = (i = i + Math.imul(M, ne) | 0) + Math.imul(x, re) | 0, o = o + Math.imul(x, ne) | 0, n = n + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, n = n + Math.imul(_, fe) | 0, i = (i = i + Math.imul(_, ce) | 0) + Math.imul(w, fe) | 0, o = o + Math.imul(w, ce) | 0, n = n + Math.imul(y, de) | 0, i = (i = i + Math.imul(y, he) | 0) + Math.imul(v, de) | 0, o = o + Math.imul(v, he) | 0;
          var Me = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(b, be) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(U, W), i = (i = Math.imul(U, G)) + Math.imul(D, W) | 0, o = Math.imul(D, G), n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, J) | 0) + Math.imul(O, Z) | 0, o = o + Math.imul(O, J) | 0, n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(T, Q) | 0, o = o + Math.imul(T, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(B, re) | 0, o = o + Math.imul(B, ne) | 0, n = n + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, ae) | 0, n = n + Math.imul(E, fe) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(A, fe) | 0, o = o + Math.imul(A, ce) | 0, n = n + Math.imul(_, de) | 0, i = (i = i + Math.imul(_, he) | 0) + Math.imul(w, de) | 0, o = o + Math.imul(w, he) | 0;
          var xe = (c + (n = n + Math.imul(y, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(y, be) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(v, be) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(U, Z), i = (i = Math.imul(U, J)) + Math.imul(D, Z) | 0, o = Math.imul(D, J), n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(O, Q) | 0, o = o + Math.imul(O, ee) | 0, n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(T, re) | 0, o = o + Math.imul(T, ne) | 0, n = n + Math.imul(j, oe) | 0, i = (i = i + Math.imul(j, ae) | 0) + Math.imul(B, oe) | 0, o = o + Math.imul(B, ae) | 0, n = n + Math.imul(M, fe) | 0, i = (i = i + Math.imul(M, ce) | 0) + Math.imul(x, fe) | 0, o = o + Math.imul(x, ce) | 0, n = n + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, he) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, he) | 0;
          var Ie = (c + (n = n + Math.imul(_, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, be) | 0) + Math.imul(w, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(w, be) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(U, Q), i = (i = Math.imul(U, ee)) + Math.imul(D, Q) | 0, o = Math.imul(D, ee), n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(O, re) | 0, o = o + Math.imul(O, ne) | 0, n = n + Math.imul(P, oe) | 0, i = (i = i + Math.imul(P, ae) | 0) + Math.imul(T, oe) | 0, o = o + Math.imul(T, ae) | 0, n = n + Math.imul(j, fe) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(B, fe) | 0, o = o + Math.imul(B, ce) | 0, n = n + Math.imul(M, de) | 0, i = (i = i + Math.imul(M, he) | 0) + Math.imul(x, de) | 0, o = o + Math.imul(x, he) | 0;
          var je = (c + (n = n + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, be) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(A, be) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(U, re), i = (i = Math.imul(U, ne)) + Math.imul(D, re) | 0, o = Math.imul(D, ne), n = n + Math.imul(C, oe) | 0, i = (i = i + Math.imul(C, ae) | 0) + Math.imul(O, oe) | 0, o = o + Math.imul(O, ae) | 0, n = n + Math.imul(P, fe) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(T, fe) | 0, o = o + Math.imul(T, ce) | 0, n = n + Math.imul(j, de) | 0, i = (i = i + Math.imul(j, he) | 0) + Math.imul(B, de) | 0, o = o + Math.imul(B, he) | 0;
          var Be = (c + (n = n + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, be) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(x, be) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(U, oe), i = (i = Math.imul(U, ae)) + Math.imul(D, oe) | 0, o = Math.imul(D, ae), n = n + Math.imul(C, fe) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(O, fe) | 0, o = o + Math.imul(O, ce) | 0, n = n + Math.imul(P, de) | 0, i = (i = i + Math.imul(P, he) | 0) + Math.imul(T, de) | 0, o = o + Math.imul(T, he) | 0;
          var Re = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, be) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(B, be) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(U, fe), i = (i = Math.imul(U, ce)) + Math.imul(D, fe) | 0, o = Math.imul(D, ce), n = n + Math.imul(C, de) | 0, i = (i = i + Math.imul(C, he) | 0) + Math.imul(O, de) | 0, o = o + Math.imul(O, he) | 0;
          var Pe = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, be) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(T, be) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, n = Math.imul(U, de), i = (i = Math.imul(U, he)) + Math.imul(D, de) | 0, o = Math.imul(D, he);
          var Te = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, be) | 0) + Math.imul(O, pe) | 0)) << 13) | 0;
          c = ((o = o + Math.imul(O, be) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863;
          var Le = (c + (n = Math.imul(U, pe)) | 0) + ((8191 & (i = (i = Math.imul(U, be)) + Math.imul(D, pe) | 0)) << 13) | 0;
          return c = ((o = Math.imul(D, be)) + (i >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, f[0] = me, f[1] = ye, f[2] = ve, f[3] = ge, f[4] = _e, f[5] = we, f[6] = ke, f[7] = Ee, f[8] = Ae, f[9] = Se, f[10] = Me, f[11] = xe, f[12] = Ie, f[13] = je, f[14] = Be, f[15] = Re, f[16] = Pe, f[17] = Te, f[18] = Le, 0 !== c && (f[19] = c, r.length++), r;
        };

        function p(e, t, r) {
          return new b().mulp(e, t, r);
        }

        function b(e, t) {
          this.x = e, this.y = t;
        }

        Math.imul || (l = h), o.prototype.mulTo = function (e, t) {
          var r = this.length + e.length;
          return 10 === this.length && 10 === e.length ? l(this, e, t) : r < 63 ? h(this, e, t) : r < 1024 ? function (e, t, r) {
            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;

            for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
              var a = i;
              i = 0;

              for (var s = 67108863 & n, f = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= f; c++) {
                var u = o - c,
                    d = (0 | e.words[u]) * (0 | t.words[c]),
                    h = 67108863 & d;
                s = 67108863 & (h = h + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, a &= 67108863;
              }

              r.words[o] = s, n = a, a = i;
            }

            return 0 !== n ? r.words[o] = n : r.length--, r.strip();
          }(this, e, t) : p(this, e, t);
        }, b.prototype.makeRBT = function (e) {
          for (var t = new Array(e), r = o.prototype._countBits(e) - 1, n = 0; n < e; n++) {
            t[n] = this.revBin(n, r, e);
          }

          return t;
        }, b.prototype.revBin = function (e, t, r) {
          if (0 === e || e === r - 1) return e;

          for (var n = 0, i = 0; i < t; i++) {
            n |= (1 & e) << t - i - 1, e >>= 1;
          }

          return n;
        }, b.prototype.permute = function (e, t, r, n, i, o) {
          for (var a = 0; a < o; a++) {
            n[a] = t[e[a]], i[a] = r[e[a]];
          }
        }, b.prototype.transform = function (e, t, r, n, i, o) {
          this.permute(o, e, t, r, n, i);

          for (var a = 1; a < i; a <<= 1) {
            for (var s = a << 1, f = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), u = 0; u < i; u += s) {
              for (var d = f, h = c, l = 0; l < a; l++) {
                var p = r[u + l],
                    b = n[u + l],
                    m = r[u + l + a],
                    y = n[u + l + a],
                    v = d * m - h * y;
                y = d * y + h * m, m = v, r[u + l] = p + m, n[u + l] = b + y, r[u + l + a] = p - m, n[u + l + a] = b - y, l !== s && (v = f * d - c * h, h = f * h + c * d, d = v);
              }
            }
          }
        }, b.prototype.guessLen13b = function (e, t) {
          var r = 1 | Math.max(t, e),
              n = 1 & r,
              i = 0;

          for (r = r / 2 | 0; r; r >>>= 1) {
            i++;
          }

          return 1 << i + 1 + n;
        }, b.prototype.conjugate = function (e, t, r) {
          if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
            var i = e[n];
            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
          }
        }, b.prototype.normalize13b = function (e, t) {
          for (var r = 0, n = 0; n < t / 2; n++) {
            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
          }

          return e;
        }, b.prototype.convert13b = function (e, t, r, i) {
          for (var o = 0, a = 0; a < t; a++) {
            o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
          }

          for (a = 2 * t; a < i; ++a) {
            r[a] = 0;
          }

          n(0 === o), n(0 == (-8192 & o));
        }, b.prototype.stub = function (e) {
          for (var t = new Array(e), r = 0; r < e; r++) {
            t[r] = 0;
          }

          return t;
        }, b.prototype.mulp = function (e, t, r) {
          var n = 2 * this.guessLen13b(e.length, t.length),
              i = this.makeRBT(n),
              o = this.stub(n),
              a = new Array(n),
              s = new Array(n),
              f = new Array(n),
              c = new Array(n),
              u = new Array(n),
              d = new Array(n),
              h = r.words;
          h.length = n, this.convert13b(e.words, e.length, a, n), this.convert13b(t.words, t.length, c, n), this.transform(a, o, s, f, n, i), this.transform(c, o, u, d, n, i);

          for (var l = 0; l < n; l++) {
            var p = s[l] * u[l] - f[l] * d[l];
            f[l] = s[l] * d[l] + f[l] * u[l], s[l] = p;
          }

          return this.conjugate(s, f, n), this.transform(s, f, h, o, n, i), this.conjugate(h, o, n), this.normalize13b(h, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
        }, o.prototype.mul = function (e) {
          var t = new o(null);
          return t.words = new Array(this.length + e.length), this.mulTo(e, t);
        }, o.prototype.mulf = function (e) {
          var t = new o(null);
          return t.words = new Array(this.length + e.length), p(this, e, t);
        }, o.prototype.imul = function (e) {
          return this.clone().mulTo(e, this);
        }, o.prototype.imuln = function (e) {
          n("number" == typeof e), n(e < 67108864);

          for (var t = 0, r = 0; r < this.length; r++) {
            var i = (0 | this.words[r]) * e,
                o = (67108863 & i) + (67108863 & t);
            t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[r] = 67108863 & o;
          }

          return 0 !== t && (this.words[r] = t, this.length++), this;
        }, o.prototype.muln = function (e) {
          return this.clone().imuln(e);
        }, o.prototype.sqr = function () {
          return this.mul(this);
        }, o.prototype.isqr = function () {
          return this.imul(this.clone());
        }, o.prototype.pow = function (e) {
          var t = function (e) {
            for (var t = new Array(e.bitLength()), r = 0; r < t.length; r++) {
              var n = r / 26 | 0,
                  i = r % 26;
              t[r] = (e.words[n] & 1 << i) >>> i;
            }

            return t;
          }(e);

          if (0 === t.length) return new o(1);

          for (var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr()) {
            ;
          }

          if (++n < t.length) for (var i = r.sqr(); n < t.length; n++, i = i.sqr()) {
            0 !== t[n] && (r = r.mul(i));
          }
          return r;
        }, o.prototype.iushln = function (e) {
          n("number" == typeof e && e >= 0);
          var t,
              r = e % 26,
              i = (e - r) / 26,
              o = 67108863 >>> 26 - r << 26 - r;

          if (0 !== r) {
            var a = 0;

            for (t = 0; t < this.length; t++) {
              var s = this.words[t] & o,
                  f = (0 | this.words[t]) - s << r;
              this.words[t] = f | a, a = s >>> 26 - r;
            }

            a && (this.words[t] = a, this.length++);
          }

          if (0 !== i) {
            for (t = this.length - 1; t >= 0; t--) {
              this.words[t + i] = this.words[t];
            }

            for (t = 0; t < i; t++) {
              this.words[t] = 0;
            }

            this.length += i;
          }

          return this.strip();
        }, o.prototype.ishln = function (e) {
          return n(0 === this.negative), this.iushln(e);
        }, o.prototype.iushrn = function (e, t, r) {
          var i;
          n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
          var o = e % 26,
              a = Math.min((e - o) / 26, this.length),
              s = 67108863 ^ 67108863 >>> o << o,
              f = r;

          if (i -= a, i = Math.max(0, i), f) {
            for (var c = 0; c < a; c++) {
              f.words[c] = this.words[c];
            }

            f.length = a;
          }

          if (0 === a) ;else if (this.length > a) for (this.length -= a, c = 0; c < this.length; c++) {
            this.words[c] = this.words[c + a];
          } else this.words[0] = 0, this.length = 1;
          var u = 0;

          for (c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--) {
            var d = 0 | this.words[c];
            this.words[c] = u << 26 - o | d >>> o, u = d & s;
          }

          return f && 0 !== u && (f.words[f.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
        }, o.prototype.ishrn = function (e, t, r) {
          return n(0 === this.negative), this.iushrn(e, t, r);
        }, o.prototype.shln = function (e) {
          return this.clone().ishln(e);
        }, o.prototype.ushln = function (e) {
          return this.clone().iushln(e);
        }, o.prototype.shrn = function (e) {
          return this.clone().ishrn(e);
        }, o.prototype.ushrn = function (e) {
          return this.clone().iushrn(e);
        }, o.prototype.testn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          return !(this.length <= r) && !!(this.words[r] & i);
        }, o.prototype.imaskn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26;
          if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

          if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
            var i = 67108863 ^ 67108863 >>> t << t;
            this.words[this.length - 1] &= i;
          }

          return this.strip();
        }, o.prototype.maskn = function (e) {
          return this.clone().imaskn(e);
        }, o.prototype.iaddn = function (e) {
          return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
        }, o.prototype._iaddn = function (e) {
          this.words[0] += e;

          for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) {
            this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
          }

          return this.length = Math.max(this.length, t + 1), this;
        }, o.prototype.isubn = function (e) {
          if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
          if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
          if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
            this.words[t] += 67108864, this.words[t + 1] -= 1;
          }
          return this.strip();
        }, o.prototype.addn = function (e) {
          return this.clone().iaddn(e);
        }, o.prototype.subn = function (e) {
          return this.clone().isubn(e);
        }, o.prototype.iabs = function () {
          return this.negative = 0, this;
        }, o.prototype.abs = function () {
          return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function (e, t, r) {
          var i,
              o,
              a = e.length + r;

          this._expand(a);

          var s = 0;

          for (i = 0; i < e.length; i++) {
            o = (0 | this.words[i + r]) + s;
            var f = (0 | e.words[i]) * t;
            s = ((o -= 67108863 & f) >> 26) - (f / 67108864 | 0), this.words[i + r] = 67108863 & o;
          }

          for (; i < this.length - r; i++) {
            s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
          }

          if (0 === s) return this.strip();

          for (n(-1 === s), s = 0, i = 0; i < this.length; i++) {
            s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
          }

          return this.negative = 1, this.strip();
        }, o.prototype._wordDiv = function (e, t) {
          var r = (this.length, e.length),
              n = this.clone(),
              i = e,
              a = 0 | i.words[i.length - 1];
          0 !== (r = 26 - this._countBits(a)) && (i = i.ushln(r), n.iushln(r), a = 0 | i.words[i.length - 1]);
          var s,
              f = n.length - i.length;

          if ("mod" !== t) {
            (s = new o(null)).length = f + 1, s.words = new Array(s.length);

            for (var c = 0; c < s.length; c++) {
              s.words[c] = 0;
            }
          }

          var u = n.clone()._ishlnsubmul(i, 1, f);

          0 === u.negative && (n = u, s && (s.words[f] = 1));

          for (var d = f - 1; d >= 0; d--) {
            var h = 67108864 * (0 | n.words[i.length + d]) + (0 | n.words[i.length + d - 1]);

            for (h = Math.min(h / a | 0, 67108863), n._ishlnsubmul(i, h, d); 0 !== n.negative;) {
              h--, n.negative = 0, n._ishlnsubmul(i, 1, d), n.isZero() || (n.negative ^= 1);
            }

            s && (s.words[d] = h);
          }

          return s && s.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
            div: s || null,
            mod: n
          };
        }, o.prototype.divmod = function (e, t, r) {
          return n(!e.isZero()), this.isZero() ? {
            div: new o(0),
            mod: new o(0)
          } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (i = s.div.neg()), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
            div: i,
            mod: a
          }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (i = s.div.neg()), {
            div: i,
            mod: s.mod
          }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
            div: s.div,
            mod: a
          }) : e.length > this.length || this.cmp(e) < 0 ? {
            div: new o(0),
            mod: this
          } : 1 === e.length ? "div" === t ? {
            div: this.divn(e.words[0]),
            mod: null
          } : "mod" === t ? {
            div: null,
            mod: new o(this.modn(e.words[0]))
          } : {
            div: this.divn(e.words[0]),
            mod: new o(this.modn(e.words[0]))
          } : this._wordDiv(e, t);
          var i, a, s;
        }, o.prototype.div = function (e) {
          return this.divmod(e, "div", !1).div;
        }, o.prototype.mod = function (e) {
          return this.divmod(e, "mod", !1).mod;
        }, o.prototype.umod = function (e) {
          return this.divmod(e, "mod", !0).mod;
        }, o.prototype.divRound = function (e) {
          var t = this.divmod(e);
          if (t.mod.isZero()) return t.div;
          var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
              n = e.ushrn(1),
              i = e.andln(1),
              o = r.cmp(n);
          return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
        }, o.prototype.modn = function (e) {
          n(e <= 67108863);

          for (var t = (1 << 26) % e, r = 0, i = this.length - 1; i >= 0; i--) {
            r = (t * r + (0 | this.words[i])) % e;
          }

          return r;
        }, o.prototype.idivn = function (e) {
          n(e <= 67108863);

          for (var t = 0, r = this.length - 1; r >= 0; r--) {
            var i = (0 | this.words[r]) + 67108864 * t;
            this.words[r] = i / e | 0, t = i % e;
          }

          return this.strip();
        }, o.prototype.divn = function (e) {
          return this.clone().idivn(e);
        }, o.prototype.egcd = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i = new o(1), a = new o(0), s = new o(0), f = new o(1), c = 0; t.isEven() && r.isEven();) {
            t.iushrn(1), r.iushrn(1), ++c;
          }

          for (var u = r.clone(), d = t.clone(); !t.isZero();) {
            for (var h = 0, l = 1; 0 == (t.words[0] & l) && h < 26; ++h, l <<= 1) {
              ;
            }

            if (h > 0) for (t.iushrn(h); h-- > 0;) {
              (i.isOdd() || a.isOdd()) && (i.iadd(u), a.isub(d)), i.iushrn(1), a.iushrn(1);
            }

            for (var p = 0, b = 1; 0 == (r.words[0] & b) && p < 26; ++p, b <<= 1) {
              ;
            }

            if (p > 0) for (r.iushrn(p); p-- > 0;) {
              (s.isOdd() || f.isOdd()) && (s.iadd(u), f.isub(d)), s.iushrn(1), f.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), i.isub(s), a.isub(f)) : (r.isub(t), s.isub(i), f.isub(a));
          }

          return {
            a: s,
            b: f,
            gcd: r.iushln(c)
          };
        }, o.prototype._invmp = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i, a = new o(1), s = new o(0), f = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
            for (var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1) {
              ;
            }

            if (c > 0) for (t.iushrn(c); c-- > 0;) {
              a.isOdd() && a.iadd(f), a.iushrn(1);
            }

            for (var d = 0, h = 1; 0 == (r.words[0] & h) && d < 26; ++d, h <<= 1) {
              ;
            }

            if (d > 0) for (r.iushrn(d); d-- > 0;) {
              s.isOdd() && s.iadd(f), s.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), a.isub(s)) : (r.isub(t), s.isub(a));
          }

          return (i = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && i.iadd(e), i;
        }, o.prototype.gcd = function (e) {
          if (this.isZero()) return e.abs();
          if (e.isZero()) return this.abs();
          var t = this.clone(),
              r = e.clone();
          t.negative = 0, r.negative = 0;

          for (var n = 0; t.isEven() && r.isEven(); n++) {
            t.iushrn(1), r.iushrn(1);
          }

          for (;;) {
            for (; t.isEven();) {
              t.iushrn(1);
            }

            for (; r.isEven();) {
              r.iushrn(1);
            }

            var i = t.cmp(r);

            if (i < 0) {
              var o = t;
              t = r, r = o;
            } else if (0 === i || 0 === r.cmpn(1)) break;

            t.isub(r);
          }

          return r.iushln(n);
        }, o.prototype.invm = function (e) {
          return this.egcd(e).a.umod(e);
        }, o.prototype.isEven = function () {
          return 0 == (1 & this.words[0]);
        }, o.prototype.isOdd = function () {
          return 1 == (1 & this.words[0]);
        }, o.prototype.andln = function (e) {
          return this.words[0] & e;
        }, o.prototype.bincn = function (e) {
          n("number" == typeof e);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

          for (var o = i, a = r; 0 !== o && a < this.length; a++) {
            var s = 0 | this.words[a];
            o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
          }

          return 0 !== o && (this.words[a] = o, this.length++), this;
        }, o.prototype.isZero = function () {
          return 1 === this.length && 0 === this.words[0];
        }, o.prototype.cmpn = function (e) {
          var t,
              r = e < 0;
          if (0 !== this.negative && !r) return -1;
          if (0 === this.negative && r) return 1;
          if (this.strip(), this.length > 1) t = 1;else {
            r && (e = -e), n(e <= 67108863, "Number is too big");
            var i = 0 | this.words[0];
            t = i === e ? 0 : i < e ? -1 : 1;
          }
          return 0 !== this.negative ? 0 | -t : t;
        }, o.prototype.cmp = function (e) {
          if (0 !== this.negative && 0 === e.negative) return -1;
          if (0 === this.negative && 0 !== e.negative) return 1;
          var t = this.ucmp(e);
          return 0 !== this.negative ? 0 | -t : t;
        }, o.prototype.ucmp = function (e) {
          if (this.length > e.length) return 1;
          if (this.length < e.length) return -1;

          for (var t = 0, r = this.length - 1; r >= 0; r--) {
            var n = 0 | this.words[r],
                i = 0 | e.words[r];

            if (n !== i) {
              n < i ? t = -1 : n > i && (t = 1);
              break;
            }
          }

          return t;
        }, o.prototype.gtn = function (e) {
          return 1 === this.cmpn(e);
        }, o.prototype.gt = function (e) {
          return 1 === this.cmp(e);
        }, o.prototype.gten = function (e) {
          return this.cmpn(e) >= 0;
        }, o.prototype.gte = function (e) {
          return this.cmp(e) >= 0;
        }, o.prototype.ltn = function (e) {
          return -1 === this.cmpn(e);
        }, o.prototype.lt = function (e) {
          return -1 === this.cmp(e);
        }, o.prototype.lten = function (e) {
          return this.cmpn(e) <= 0;
        }, o.prototype.lte = function (e) {
          return this.cmp(e) <= 0;
        }, o.prototype.eqn = function (e) {
          return 0 === this.cmpn(e);
        }, o.prototype.eq = function (e) {
          return 0 === this.cmp(e);
        }, o.red = function (e) {
          return new k(e);
        }, o.prototype.toRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
        }, o.prototype.fromRed = function () {
          return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function (e) {
          return this.red = e, this;
        }, o.prototype.forceRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
        }, o.prototype.redAdd = function (e) {
          return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
        }, o.prototype.redIAdd = function (e) {
          return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
        }, o.prototype.redSub = function (e) {
          return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
        }, o.prototype.redISub = function (e) {
          return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
        }, o.prototype.redShl = function (e) {
          return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
        }, o.prototype.redMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
        }, o.prototype.redIMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
        }, o.prototype.redSqr = function () {
          return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function () {
          return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function () {
          return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function () {
          return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function () {
          return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function (e) {
          return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
        };
        var m = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        function y(e, t) {
          this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }

        function v() {
          y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }

        function g() {
          y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }

        function _() {
          y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }

        function w() {
          y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }

        function k(e) {
          if ("string" == typeof e) {
            var t = o._prime(e);

            this.m = t.p, this.prime = t;
          } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
        }

        function E(e) {
          k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }

        y.prototype._tmp = function () {
          var e = new o(null);
          return e.words = new Array(Math.ceil(this.n / 13)), e;
        }, y.prototype.ireduce = function (e) {
          var t,
              r = e;

          do {
            this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
          } while (t > this.n);

          var n = t < this.n ? -1 : r.ucmp(this.p);
          return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
        }, y.prototype.split = function (e, t) {
          e.iushrn(this.n, 0, t);
        }, y.prototype.imulK = function (e) {
          return e.imul(this.k);
        }, i(v, y), v.prototype.split = function (e, t) {
          for (var r = Math.min(e.length, 9), n = 0; n < r; n++) {
            t.words[n] = e.words[n];
          }

          if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
          var i = e.words[9];

          for (t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++) {
            var o = 0 | e.words[n];
            e.words[n - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
          }

          i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
        }, v.prototype.imulK = function (e) {
          e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 0 | e.words[r];
            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
          }

          return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
        }, i(g, y), i(_, y), i(w, y), w.prototype.imulK = function (e) {
          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 19 * (0 | e.words[r]) + t,
                i = 67108863 & n;
            n >>>= 26, e.words[r] = i, t = n;
          }

          return 0 !== t && (e.words[e.length++] = t), e;
        }, o._prime = function (e) {
          if (m[e]) return m[e];
          var t;
          if ("k256" === e) t = new v();else if ("p224" === e) t = new g();else if ("p192" === e) t = new _();else {
            if ("p25519" !== e) throw new Error("Unknown prime " + e);
            t = new w();
          }
          return m[e] = t, t;
        }, k.prototype._verify1 = function (e) {
          n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
        }, k.prototype._verify2 = function (e, t) {
          n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
        }, k.prototype.imod = function (e) {
          return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
        }, k.prototype.neg = function (e) {
          return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
        }, k.prototype.add = function (e, t) {
          this._verify2(e, t);

          var r = e.add(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
        }, k.prototype.iadd = function (e, t) {
          this._verify2(e, t);

          var r = e.iadd(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r;
        }, k.prototype.sub = function (e, t) {
          this._verify2(e, t);

          var r = e.sub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
        }, k.prototype.isub = function (e, t) {
          this._verify2(e, t);

          var r = e.isub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r;
        }, k.prototype.shl = function (e, t) {
          return this._verify1(e), this.imod(e.ushln(t));
        }, k.prototype.imul = function (e, t) {
          return this._verify2(e, t), this.imod(e.imul(t));
        }, k.prototype.mul = function (e, t) {
          return this._verify2(e, t), this.imod(e.mul(t));
        }, k.prototype.isqr = function (e) {
          return this.imul(e, e.clone());
        }, k.prototype.sqr = function (e) {
          return this.mul(e, e);
        }, k.prototype.sqrt = function (e) {
          if (e.isZero()) return e.clone();
          var t = this.m.andln(3);

          if (n(t % 2 == 1), 3 === t) {
            var r = this.m.add(new o(1)).iushrn(2);
            return this.pow(e, r);
          }

          for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) {
            a++, i.iushrn(1);
          }

          n(!i.isZero());
          var s = new o(1).toRed(this),
              f = s.redNeg(),
              c = this.m.subn(1).iushrn(1),
              u = this.m.bitLength();

          for (u = new o(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(f);) {
            u.redIAdd(f);
          }

          for (var d = this.pow(u, i), h = this.pow(e, i.addn(1).iushrn(1)), l = this.pow(e, i), p = a; 0 !== l.cmp(s);) {
            for (var b = l, m = 0; 0 !== b.cmp(s); m++) {
              b = b.redSqr();
            }

            n(m < p);
            var y = this.pow(d, new o(1).iushln(p - m - 1));
            h = h.redMul(y), d = y.redSqr(), l = l.redMul(d), p = m;
          }

          return h;
        }, k.prototype.invm = function (e) {
          var t = e._invmp(this.m);

          return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
        }, k.prototype.pow = function (e, t) {
          if (t.isZero()) return new o(1).toRed(this);
          if (0 === t.cmpn(1)) return e.clone();
          var r = new Array(16);
          r[0] = new o(1).toRed(this), r[1] = e;

          for (var n = 2; n < r.length; n++) {
            r[n] = this.mul(r[n - 1], e);
          }

          var i = r[0],
              a = 0,
              s = 0,
              f = t.bitLength() % 26;

          for (0 === f && (f = 26), n = t.length - 1; n >= 0; n--) {
            for (var c = t.words[n], u = f - 1; u >= 0; u--) {
              var d = c >> u & 1;
              i !== r[0] && (i = this.sqr(i)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++s || 0 === n && 0 === u) && (i = this.mul(i, r[a]), s = 0, a = 0)) : s = 0;
            }

            f = 26;
          }

          return i;
        }, k.prototype.convertTo = function (e) {
          var t = e.umod(this.m);
          return t === e ? t.clone() : t;
        }, k.prototype.convertFrom = function (e) {
          var t = e.clone();
          return t.red = null, t;
        }, o.mont = function (e) {
          return new E(e);
        }, i(E, k), E.prototype.convertTo = function (e) {
          return this.imod(e.ushln(this.shift));
        }, E.prototype.convertFrom = function (e) {
          var t = this.imod(e.mul(this.rinv));
          return t.red = null, t;
        }, E.prototype.imul = function (e, t) {
          if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
          var r = e.imul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              o = i;
          return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, E.prototype.mul = function (e, t) {
          if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
          var r = e.mul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              a = i;
          return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
        }, E.prototype.invm = function (e) {
          return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
        };
      }(e, this);
    }).call(this, r(69)(e));
  }, function (e, t) {
    function r(e, t) {
      if (!e) throw new Error(t || "Assertion failed");
    }

    e.exports = r, r.equal = function (e, t, r) {
      if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
    };
  }, function (e, t, r) {
    "use strict";

    var n = t,
        i = r(3),
        o = r(4),
        a = r(71);
    n.assert = o, n.toArray = a.toArray, n.zero2 = a.zero2, n.toHex = a.toHex, n.encode = a.encode, n.getNAF = function (e, t, r) {
      var n = new Array(Math.max(e.bitLength(), r) + 1);
      n.fill(0);

      for (var i = 1 << t + 1, o = e.clone(), a = 0; a < n.length; a++) {
        var s,
            f = o.andln(i - 1);
        o.isOdd() ? (s = f > (i >> 1) - 1 ? (i >> 1) - f : f, o.isubn(s)) : s = 0, n[a] = s, o.iushrn(1);
      }

      return n;
    }, n.getJSF = function (e, t) {
      var r = [[], []];
      e = e.clone(), t = t.clone();

      for (var n = 0, i = 0; e.cmpn(-n) > 0 || t.cmpn(-i) > 0;) {
        var o,
            a,
            s,
            f = e.andln(3) + n & 3,
            c = t.andln(3) + i & 3;
        if (3 === f && (f = -1), 3 === c && (c = -1), 0 == (1 & f)) o = 0;else o = 3 !== (s = e.andln(7) + n & 7) && 5 !== s || 2 !== c ? f : -f;
        if (r[0].push(o), 0 == (1 & c)) a = 0;else a = 3 !== (s = t.andln(7) + i & 7) && 5 !== s || 2 !== f ? c : -c;
        r[1].push(a), 2 * n === o + 1 && (n = 1 - n), 2 * i === a + 1 && (i = 1 - i), e.iushrn(1), t.iushrn(1);
      }

      return r;
    }, n.cachedProperty = function (e, t, r) {
      var n = "_" + t;

      e.prototype[t] = function () {
        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
      };
    }, n.parseBytes = function (e) {
      return "string" == typeof e ? n.toArray(e, "hex") : e;
    }, n.intFromLE = function (e) {
      return new i(e, "hex", "le");
    };
  }, function (e, t) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (r = window);
    }

    e.exports = r;
  }, function (e, t) {
    var r,
        n,
        i = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(e) {
      if (r === setTimeout) return setTimeout(e, 0);
      if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

      try {
        return r(e, 0);
      } catch (t) {
        try {
          return r.call(null, e, 0);
        } catch (t) {
          return r.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        r = o;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        n = a;
      }
    }();
    var f,
        c = [],
        u = !1,
        d = -1;

    function h() {
      u && f && (u = !1, f.length ? c = f.concat(c) : d = -1, c.length && l());
    }

    function l() {
      if (!u) {
        var e = s(h);
        u = !0;

        for (var t = c.length; t;) {
          for (f = c, c = []; ++d < t;) {
            f && f[d].run();
          }

          d = -1, t = c.length;
        }

        f = null, u = !1, function (e) {
          if (n === clearTimeout) return clearTimeout(e);
          if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);

          try {
            n(e);
          } catch (t) {
            try {
              return n.call(null, e);
            } catch (t) {
              return n.call(this, e);
            }
          }
        }(e);
      }
    }

    function p(e, t) {
      this.fun = e, this.array = t;
    }

    function b() {}

    i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }
      c.push(new p(e, t)), 1 !== c.length || u || s(l);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = b, i.addListener = b, i.once = b, i.off = b, i.removeListener = b, i.removeAllListeners = b, i.emit = b, i.prependListener = b, i.prependOnceListener = b, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        i = r(0);

    function o(e, t) {
      return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
    }

    function a(e) {
      return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
    }

    function s(e) {
      return 1 === e.length ? "0" + e : e;
    }

    function f(e) {
      return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
    }

    t.inherits = i, t.toArray = function (e, t) {
      if (Array.isArray(e)) return e.slice();
      if (!e) return [];
      var r = [];
      if ("string" == typeof e) {
        if (t) {
          if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2) {
            r.push(parseInt(e[i] + e[i + 1], 16));
          }
        } else for (var n = 0, i = 0; i < e.length; i++) {
          var a = e.charCodeAt(i);
          a < 128 ? r[n++] = a : a < 2048 ? (r[n++] = a >> 6 | 192, r[n++] = 63 & a | 128) : o(e, i) ? (a = 65536 + ((1023 & a) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = a >> 18 | 240, r[n++] = a >> 12 & 63 | 128, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128) : (r[n++] = a >> 12 | 224, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128);
        }
      } else for (i = 0; i < e.length; i++) {
        r[i] = 0 | e[i];
      }
      return r;
    }, t.toHex = function (e) {
      for (var t = "", r = 0; r < e.length; r++) {
        t += s(e[r].toString(16));
      }

      return t;
    }, t.htonl = a, t.toHex32 = function (e, t) {
      for (var r = "", n = 0; n < e.length; n++) {
        var i = e[n];
        "little" === t && (i = a(i)), r += f(i.toString(16));
      }

      return r;
    }, t.zero2 = s, t.zero8 = f, t.join32 = function (e, t, r, i) {
      var o = r - t;
      n(o % 4 == 0);

      for (var a = new Array(o / 4), s = 0, f = t; s < a.length; s++, f += 4) {
        var c;
        c = "big" === i ? e[f] << 24 | e[f + 1] << 16 | e[f + 2] << 8 | e[f + 3] : e[f + 3] << 24 | e[f + 2] << 16 | e[f + 1] << 8 | e[f], a[s] = c >>> 0;
      }

      return a;
    }, t.split32 = function (e, t) {
      for (var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4) {
        var o = e[n];
        "big" === t ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
      }

      return r;
    }, t.rotr32 = function (e, t) {
      return e >>> t | e << 32 - t;
    }, t.rotl32 = function (e, t) {
      return e << t | e >>> 32 - t;
    }, t.sum32 = function (e, t) {
      return e + t >>> 0;
    }, t.sum32_3 = function (e, t, r) {
      return e + t + r >>> 0;
    }, t.sum32_4 = function (e, t, r, n) {
      return e + t + r + n >>> 0;
    }, t.sum32_5 = function (e, t, r, n, i) {
      return e + t + r + n + i >>> 0;
    }, t.sum64 = function (e, t, r, n) {
      var i = e[t],
          o = n + e[t + 1] >>> 0,
          a = (o < n ? 1 : 0) + r + i;
      e[t] = a >>> 0, e[t + 1] = o;
    }, t.sum64_hi = function (e, t, r, n) {
      return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
    }, t.sum64_lo = function (e, t, r, n) {
      return t + n >>> 0;
    }, t.sum64_4_hi = function (e, t, r, n, i, o, a, s) {
      var f = 0,
          c = t;
      return f += (c = c + n >>> 0) < t ? 1 : 0, f += (c = c + o >>> 0) < o ? 1 : 0, e + r + i + a + (f += (c = c + s >>> 0) < s ? 1 : 0) >>> 0;
    }, t.sum64_4_lo = function (e, t, r, n, i, o, a, s) {
      return t + n + o + s >>> 0;
    }, t.sum64_5_hi = function (e, t, r, n, i, o, a, s, f, c) {
      var u = 0,
          d = t;
      return u += (d = d + n >>> 0) < t ? 1 : 0, u += (d = d + o >>> 0) < o ? 1 : 0, u += (d = d + s >>> 0) < s ? 1 : 0, e + r + i + a + f + (u += (d = d + c >>> 0) < c ? 1 : 0) >>> 0;
    }, t.sum64_5_lo = function (e, t, r, n, i, o, a, s, f, c) {
      return t + n + o + s + c >>> 0;
    }, t.rotr64_hi = function (e, t, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    }, t.rotr64_lo = function (e, t, r) {
      return (e << 32 - r | t >>> r) >>> 0;
    }, t.shr64_hi = function (e, t, r) {
      return e >>> r;
    }, t.shr64_lo = function (e, t, r) {
      return (e << 32 - r | t >>> r) >>> 0;
    };
  }, function (e, t, r) {
    var n = r(1).Buffer,
        i = r(28).Transform,
        o = r(32).StringDecoder;

    function a(e) {
      i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
    }

    r(0)(a, i), a.prototype.update = function (e, t, r) {
      "string" == typeof e && (e = n.from(e, t));

      var i = this._update(e);

      return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
    }, a.prototype.setAutoPadding = function () {}, a.prototype.getAuthTag = function () {
      throw new Error("trying to get auth tag in unsupported state");
    }, a.prototype.setAuthTag = function () {
      throw new Error("trying to set auth tag in unsupported state");
    }, a.prototype.setAAD = function () {
      throw new Error("trying to set aad in unsupported state");
    }, a.prototype._transform = function (e, t, r) {
      var n;

      try {
        this.hashMode ? this._update(e) : this.push(this._update(e));
      } catch (e) {
        n = e;
      } finally {
        r(n);
      }
    }, a.prototype._flush = function (e) {
      var t;

      try {
        this.push(this.__final());
      } catch (e) {
        t = e;
      }

      e(t);
    }, a.prototype._finalOrDigest = function (e) {
      var t = this.__final() || n.alloc(0);
      return e && (t = this._toString(t, e, !0)), t;
    }, a.prototype._toString = function (e, t, r) {
      if (this._decoder || (this._decoder = new o(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");

      var n = this._decoder.write(e);

      return r && (n += this._decoder.end()), n;
    }, e.exports = a;
  }, function (e, t, r) {
    /*! @iceteachain/common v0.1.6 */
    var n;
    n = function n() {
      return function (e) {
        var t = {};

        function r(n) {
          if (t[n]) return t[n].exports;
          var i = t[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }

        return r.m = e, r.c = t, r.d = function (e, t, n) {
          r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
          });
        }, r.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, r.t = function (e, t) {
          if (1 & t && (e = r(e)), 8 & t) return e;
          if (4 & t && "object" == typeof e && e && e.__esModule) return e;
          var n = Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var i in e) {
            r.d(n, i, function (t) {
              return e[t];
            }.bind(null, i));
          }
          return n;
        }, r.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return r.d(t, "a", t), t;
        }, r.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = "./src/index.js");
      }({
        "./node_modules/base-x/src/index.js":
        /*!******************************************!*\
          !*** ./node_modules/base-x/src/index.js ***!
          \******************************************/

        /*! no static exports found */
        function node_modulesBaseXSrcIndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer;

          e.exports = function (e) {
            if (e.length >= 255) throw new TypeError("Alphabet too long");

            for (var t = new Uint8Array(256), r = 0; r < t.length; r++) {
              t[r] = 255;
            }

            for (var i = 0; i < e.length; i++) {
              var o = e.charAt(i),
                  a = o.charCodeAt(0);
              if (255 !== t[a]) throw new TypeError(o + " is ambiguous");
              t[a] = i;
            }

            var s = e.length,
                f = e.charAt(0),
                c = Math.log(s) / Math.log(256),
                u = Math.log(256) / Math.log(s);

            function d(e) {
              if ("string" != typeof e) throw new TypeError("Expected String");
              if (0 === e.length) return n.alloc(0);
              var r = 0;

              if (" " !== e[r]) {
                for (var i = 0, o = 0; e[r] === f;) {
                  i++, r++;
                }

                for (var a = (e.length - r) * c + 1 >>> 0, u = new Uint8Array(a); e[r];) {
                  var d = t[e.charCodeAt(r)];
                  if (255 === d) return;

                  for (var h = 0, l = a - 1; (0 !== d || h < o) && -1 !== l; l--, h++) {
                    d += s * u[l] >>> 0, u[l] = d % 256 >>> 0, d = d / 256 >>> 0;
                  }

                  if (0 !== d) throw new Error("Non-zero carry");
                  o = h, r++;
                }

                if (" " !== e[r]) {
                  for (var p = a - o; p !== a && 0 === u[p];) {
                    p++;
                  }

                  var b = n.allocUnsafe(i + (a - p));
                  b.fill(0, 0, i);

                  for (var m = i; p !== a;) {
                    b[m++] = u[p++];
                  }

                  return b;
                }
              }
            }

            return {
              encode: function encode(t) {
                if ((Array.isArray(t) || t instanceof Uint8Array) && (t = n.from(t)), !n.isBuffer(t)) throw new TypeError("Expected Buffer");
                if (0 === t.length) return "";

                for (var r = 0, i = 0, o = 0, a = t.length; o !== a && 0 === t[o];) {
                  o++, r++;
                }

                for (var c = (a - o) * u + 1 >>> 0, d = new Uint8Array(c); o !== a;) {
                  for (var h = t[o], l = 0, p = c - 1; (0 !== h || l < i) && -1 !== p; p--, l++) {
                    h += 256 * d[p] >>> 0, d[p] = h % s >>> 0, h = h / s >>> 0;
                  }

                  if (0 !== h) throw new Error("Non-zero carry");
                  i = l, o++;
                }

                for (var b = c - i; b !== c && 0 === d[b];) {
                  b++;
                }

                for (var m = f.repeat(r); b < c; ++b) {
                  m += e.charAt(d[b]);
                }

                return m;
              },
              decodeUnsafe: d,
              decode: function decode(e) {
                var t = d(e);
                if (t) return t;
                throw new Error("Non-base" + s + " character");
              }
            };
          };
        },
        "./node_modules/base64-js/index.js":
        /*!*****************************************!*\
          !*** ./node_modules/base64-js/index.js ***!
          \*****************************************/

        /*! no static exports found */
        function node_modulesBase64JsIndexJs(e, t, r) {
          "use strict";

          t.byteLength = function (e) {
            var t = c(e),
                r = t[0],
                n = t[1];
            return 3 * (r + n) / 4 - n;
          }, t.toByteArray = function (e) {
            var t,
                r,
                n = c(e),
                a = n[0],
                s = n[1],
                f = new o(function (e, t, r) {
              return 3 * (t + r) / 4 - r;
            }(0, a, s)),
                u = 0,
                d = s > 0 ? a - 4 : a;

            for (r = 0; r < d; r += 4) {
              t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], f[u++] = t >> 16 & 255, f[u++] = t >> 8 & 255, f[u++] = 255 & t;
            }

            return 2 === s && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, f[u++] = 255 & t), 1 === s && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, f[u++] = t >> 8 & 255, f[u++] = 255 & t), f;
          }, t.fromByteArray = function (e) {
            for (var t, r = e.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
              o.push(u(e, a, a + 16383 > s ? s : a + 16383));
            }

            return 1 === i ? (t = e[r - 1], o.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], o.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "=")), o.join("");
          };

          for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) {
            n[s] = a[s], i[a.charCodeAt(s)] = s;
          }

          function c(e) {
            var t = e.length;
            if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var r = e.indexOf("=");
            return -1 === r && (r = t), [r, r === t ? 0 : 4 - r % 4];
          }

          function u(e, t, r) {
            for (var i, o, a = [], s = t; s < r; s += 3) {
              i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
            }

            return a.join("");
          }

          i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
        },
        "./node_modules/bip66/index.js":
        /*!*************************************!*\
          !*** ./node_modules/bip66/index.js ***!
          \*************************************/

        /*! no static exports found */
        function node_modulesBip66IndexJs(e, t, r) {
          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer;
          e.exports = {
            check: function check(e) {
              if (e.length < 8) return !1;
              if (e.length > 72) return !1;
              if (48 !== e[0]) return !1;
              if (e[1] !== e.length - 2) return !1;
              if (2 !== e[2]) return !1;
              var t = e[3];
              if (0 === t) return !1;
              if (5 + t >= e.length) return !1;
              if (2 !== e[4 + t]) return !1;
              var r = e[5 + t];
              return !(0 === r || 6 + t + r !== e.length || 128 & e[4] || t > 1 && 0 === e[4] && !(128 & e[5]) || 128 & e[t + 6] || r > 1 && 0 === e[t + 6] && !(128 & e[t + 7]));
            },
            decode: function decode(e) {
              if (e.length < 8) throw new Error("DER sequence length is too short");
              if (e.length > 72) throw new Error("DER sequence length is too long");
              if (48 !== e[0]) throw new Error("Expected DER sequence");
              if (e[1] !== e.length - 2) throw new Error("DER sequence length is invalid");
              if (2 !== e[2]) throw new Error("Expected DER integer");
              var t = e[3];
              if (0 === t) throw new Error("R length is zero");
              if (5 + t >= e.length) throw new Error("R length is too long");
              if (2 !== e[4 + t]) throw new Error("Expected DER integer (2)");
              var r = e[5 + t];
              if (0 === r) throw new Error("S length is zero");
              if (6 + t + r !== e.length) throw new Error("S length is invalid");
              if (128 & e[4]) throw new Error("R value is negative");
              if (t > 1 && 0 === e[4] && !(128 & e[5])) throw new Error("R value excessively padded");
              if (128 & e[t + 6]) throw new Error("S value is negative");
              if (r > 1 && 0 === e[t + 6] && !(128 & e[t + 7])) throw new Error("S value excessively padded");
              return {
                r: e.slice(4, 4 + t),
                s: e.slice(6 + t)
              };
            },
            encode: function encode(e, t) {
              var r = e.length,
                  i = t.length;
              if (0 === r) throw new Error("R length is zero");
              if (0 === i) throw new Error("S length is zero");
              if (r > 33) throw new Error("R length is too long");
              if (i > 33) throw new Error("S length is too long");
              if (128 & e[0]) throw new Error("R value is negative");
              if (128 & t[0]) throw new Error("S value is negative");
              if (r > 1 && 0 === e[0] && !(128 & e[1])) throw new Error("R value excessively padded");
              if (i > 1 && 0 === t[0] && !(128 & t[1])) throw new Error("S value excessively padded");
              var o = n.allocUnsafe(6 + r + i);
              return o[0] = 48, o[1] = o.length - 2, o[2] = 2, o[3] = e.length, e.copy(o, 4), o[4 + r] = 2, o[5 + r] = t.length, t.copy(o, 6 + r), o;
            }
          };
        },
        "./node_modules/bn.js/lib/bn.js":
        /*!**************************************!*\
          !*** ./node_modules/bn.js/lib/bn.js ***!
          \**************************************/

        /*! no static exports found */
        function node_modulesBnJsLibBnJs(e, t, r) {
          (function (e) {
            !function (e, t) {
              "use strict";

              function n(e, t) {
                if (!e) throw new Error(t || "Assertion failed");
              }

              function i(e, t) {
                e.super_ = t;

                var r = function r() {};

                r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
              }

              function o(e, t, r) {
                if (o.isBN(e)) return e;
                this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
              }

              var a;
              "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;

              try {
                a = r(
                /*! buffer */
                2).Buffer;
              } catch (e) {}

              function s(e, t, r) {
                for (var n = 0, i = Math.min(e.length, r), o = t; o < i; o++) {
                  var a = e.charCodeAt(o) - 48;
                  n <<= 4, n |= a >= 49 && a <= 54 ? a - 49 + 10 : a >= 17 && a <= 22 ? a - 17 + 10 : 15 & a;
                }

                return n;
              }

              function f(e, t, r, n) {
                for (var i = 0, o = Math.min(e.length, r), a = t; a < o; a++) {
                  var s = e.charCodeAt(a) - 48;
                  i *= n, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
                }

                return i;
              }

              o.isBN = function (e) {
                return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
              }, o.max = function (e, t) {
                return e.cmp(t) > 0 ? e : t;
              }, o.min = function (e, t) {
                return e.cmp(t) < 0 ? e : t;
              }, o.prototype._init = function (e, t, r) {
                if ("number" == typeof e) return this._initNumber(e, t, r);
                if ("object" == typeof e) return this._initArray(e, t, r);
                "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                var i = 0;
                "-" === (e = e.toString().replace(/\s+/g, ""))[0] && i++, 16 === t ? this._parseHex(e, i) : this._parseBase(e, t, i), "-" === e[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), t, r);
              }, o.prototype._initNumber = function (e, t, r) {
                e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
              }, o.prototype._initArray = function (e, t, r) {
                if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
                this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

                for (var i = 0; i < this.length; i++) {
                  this.words[i] = 0;
                }

                var o,
                    a,
                    s = 0;
                if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) {
                  a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
                } else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) {
                  a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
                }
                return this.strip();
              }, o.prototype._parseHex = function (e, t) {
                this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

                for (var r = 0; r < this.length; r++) {
                  this.words[r] = 0;
                }

                var n,
                    i,
                    o = 0;

                for (r = e.length - 6, n = 0; r >= t; r -= 6) {
                  i = s(e, r, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
                }

                r + 6 !== t && (i = s(e, t, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303), this.strip();
              }, o.prototype._parseBase = function (e, t, r) {
                this.words = [0], this.length = 1;

                for (var n = 0, i = 1; i <= 67108863; i *= t) {
                  n++;
                }

                n--, i = i / t | 0;

                for (var o = e.length - r, a = o % n, s = Math.min(o, o - a) + r, c = 0, u = r; u < s; u += n) {
                  c = f(e, u, u + n, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
                }

                if (0 !== a) {
                  var d = 1;

                  for (c = f(e, u, e.length, t), u = 0; u < a; u++) {
                    d *= t;
                  }

                  this.imuln(d), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
                }
              }, o.prototype.copy = function (e) {
                e.words = new Array(this.length);

                for (var t = 0; t < this.length; t++) {
                  e.words[t] = this.words[t];
                }

                e.length = this.length, e.negative = this.negative, e.red = this.red;
              }, o.prototype.clone = function () {
                var e = new o(null);
                return this.copy(e), e;
              }, o.prototype._expand = function (e) {
                for (; this.length < e;) {
                  this.words[this.length++] = 0;
                }

                return this;
              }, o.prototype.strip = function () {
                for (; this.length > 1 && 0 === this.words[this.length - 1];) {
                  this.length--;
                }

                return this._normSign();
              }, o.prototype._normSign = function () {
                return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
              }, o.prototype.inspect = function () {
                return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
              };
              var c = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
                  u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
                  d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

              function h(e, t, r) {
                r.negative = t.negative ^ e.negative;
                var n = e.length + t.length | 0;
                r.length = n, n = n - 1 | 0;
                var i = 0 | e.words[0],
                    o = 0 | t.words[0],
                    a = i * o,
                    s = 67108863 & a,
                    f = a / 67108864 | 0;
                r.words[0] = s;

                for (var c = 1; c < n; c++) {
                  for (var u = f >>> 26, d = 67108863 & f, h = Math.min(c, t.length - 1), l = Math.max(0, c - e.length + 1); l <= h; l++) {
                    var p = c - l | 0;
                    u += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[l]) + d) / 67108864 | 0, d = 67108863 & a;
                  }

                  r.words[c] = 0 | d, f = 0 | u;
                }

                return 0 !== f ? r.words[c] = 0 | f : r.length--, r.strip();
              }

              o.prototype.toString = function (e, t) {
                var r;

                if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                  r = "";

                  for (var i = 0, o = 0, a = 0; a < this.length; a++) {
                    var s = this.words[a],
                        f = (16777215 & (s << i | o)).toString(16);
                    r = 0 != (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? c[6 - f.length] + f + r : f + r, (i += 2) >= 26 && (i -= 26, a--);
                  }

                  for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) {
                    r = "0" + r;
                  }

                  return 0 !== this.negative && (r = "-" + r), r;
                }

                if (e === (0 | e) && e >= 2 && e <= 36) {
                  var h = u[e],
                      l = d[e];
                  r = "";
                  var p = this.clone();

                  for (p.negative = 0; !p.isZero();) {
                    var b = p.modn(l).toString(e);
                    r = (p = p.idivn(l)).isZero() ? b + r : c[h - b.length] + b + r;
                  }

                  for (this.isZero() && (r = "0" + r); r.length % t != 0;) {
                    r = "0" + r;
                  }

                  return 0 !== this.negative && (r = "-" + r), r;
                }

                n(!1, "Base should be between 2 and 36");
              }, o.prototype.toNumber = function () {
                var e = this.words[0];
                return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
              }, o.prototype.toJSON = function () {
                return this.toString(16);
              }, o.prototype.toBuffer = function (e, t) {
                return n(void 0 !== a), this.toArrayLike(a, e, t);
              }, o.prototype.toArray = function (e, t) {
                return this.toArrayLike(Array, e, t);
              }, o.prototype.toArrayLike = function (e, t, r) {
                var i = this.byteLength(),
                    o = r || Math.max(1, i);
                n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
                var a,
                    s,
                    f = "le" === t,
                    c = new e(o),
                    u = this.clone();

                if (f) {
                  for (s = 0; !u.isZero(); s++) {
                    a = u.andln(255), u.iushrn(8), c[s] = a;
                  }

                  for (; s < o; s++) {
                    c[s] = 0;
                  }
                } else {
                  for (s = 0; s < o - i; s++) {
                    c[s] = 0;
                  }

                  for (s = 0; !u.isZero(); s++) {
                    a = u.andln(255), u.iushrn(8), c[o - s - 1] = a;
                  }
                }

                return c;
              }, Math.clz32 ? o.prototype._countBits = function (e) {
                return 32 - Math.clz32(e);
              } : o.prototype._countBits = function (e) {
                var t = e,
                    r = 0;
                return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
              }, o.prototype._zeroBits = function (e) {
                if (0 === e) return 26;
                var t = e,
                    r = 0;
                return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
              }, o.prototype.bitLength = function () {
                var e = this.words[this.length - 1],
                    t = this._countBits(e);

                return 26 * (this.length - 1) + t;
              }, o.prototype.zeroBits = function () {
                if (this.isZero()) return 0;

                for (var e = 0, t = 0; t < this.length; t++) {
                  var r = this._zeroBits(this.words[t]);

                  if (e += r, 26 !== r) break;
                }

                return e;
              }, o.prototype.byteLength = function () {
                return Math.ceil(this.bitLength() / 8);
              }, o.prototype.toTwos = function (e) {
                return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
              }, o.prototype.fromTwos = function (e) {
                return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
              }, o.prototype.isNeg = function () {
                return 0 !== this.negative;
              }, o.prototype.neg = function () {
                return this.clone().ineg();
              }, o.prototype.ineg = function () {
                return this.isZero() || (this.negative ^= 1), this;
              }, o.prototype.iuor = function (e) {
                for (; this.length < e.length;) {
                  this.words[this.length++] = 0;
                }

                for (var t = 0; t < e.length; t++) {
                  this.words[t] = this.words[t] | e.words[t];
                }

                return this.strip();
              }, o.prototype.ior = function (e) {
                return n(0 == (this.negative | e.negative)), this.iuor(e);
              }, o.prototype.or = function (e) {
                return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
              }, o.prototype.uor = function (e) {
                return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
              }, o.prototype.iuand = function (e) {
                var t;
                t = this.length > e.length ? e : this;

                for (var r = 0; r < t.length; r++) {
                  this.words[r] = this.words[r] & e.words[r];
                }

                return this.length = t.length, this.strip();
              }, o.prototype.iand = function (e) {
                return n(0 == (this.negative | e.negative)), this.iuand(e);
              }, o.prototype.and = function (e) {
                return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
              }, o.prototype.uand = function (e) {
                return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
              }, o.prototype.iuxor = function (e) {
                var t, r;
                this.length > e.length ? (t = this, r = e) : (t = e, r = this);

                for (var n = 0; n < r.length; n++) {
                  this.words[n] = t.words[n] ^ r.words[n];
                }

                if (this !== t) for (; n < t.length; n++) {
                  this.words[n] = t.words[n];
                }
                return this.length = t.length, this.strip();
              }, o.prototype.ixor = function (e) {
                return n(0 == (this.negative | e.negative)), this.iuxor(e);
              }, o.prototype.xor = function (e) {
                return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
              }, o.prototype.uxor = function (e) {
                return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
              }, o.prototype.inotn = function (e) {
                n("number" == typeof e && e >= 0);
                var t = 0 | Math.ceil(e / 26),
                    r = e % 26;
                this._expand(t), r > 0 && t--;

                for (var i = 0; i < t; i++) {
                  this.words[i] = 67108863 & ~this.words[i];
                }

                return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
              }, o.prototype.notn = function (e) {
                return this.clone().inotn(e);
              }, o.prototype.setn = function (e, t) {
                n("number" == typeof e && e >= 0);
                var r = e / 26 | 0,
                    i = e % 26;
                return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
              }, o.prototype.iadd = function (e) {
                var t, r, n;
                if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                this.length > e.length ? (r = this, n = e) : (r = e, n = this);

                for (var i = 0, o = 0; o < n.length; o++) {
                  t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                }

                for (; 0 !== i && o < r.length; o++) {
                  t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                }

                if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
                  this.words[o] = r.words[o];
                }
                return this;
              }, o.prototype.add = function (e) {
                var t;
                return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
              }, o.prototype.isub = function (e) {
                if (0 !== e.negative) {
                  e.negative = 0;
                  var t = this.iadd(e);
                  return e.negative = 1, t._normSign();
                }

                if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                var r,
                    n,
                    i = this.cmp(e);
                if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                i > 0 ? (r = this, n = e) : (r = e, n = this);

                for (var o = 0, a = 0; a < n.length; a++) {
                  o = (t = (0 | r.words[a]) - (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
                }

                for (; 0 !== o && a < r.length; a++) {
                  o = (t = (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
                }

                if (0 === o && a < r.length && r !== this) for (; a < r.length; a++) {
                  this.words[a] = r.words[a];
                }
                return this.length = Math.max(this.length, a), r !== this && (this.negative = 1), this.strip();
              }, o.prototype.sub = function (e) {
                return this.clone().isub(e);
              };

              var l = function l(e, t, r) {
                var n,
                    i,
                    o,
                    a = e.words,
                    s = t.words,
                    f = r.words,
                    c = 0,
                    u = 0 | a[0],
                    d = 8191 & u,
                    h = u >>> 13,
                    l = 0 | a[1],
                    p = 8191 & l,
                    b = l >>> 13,
                    m = 0 | a[2],
                    y = 8191 & m,
                    v = m >>> 13,
                    g = 0 | a[3],
                    _ = 8191 & g,
                    w = g >>> 13,
                    k = 0 | a[4],
                    E = 8191 & k,
                    A = k >>> 13,
                    S = 0 | a[5],
                    M = 8191 & S,
                    x = S >>> 13,
                    I = 0 | a[6],
                    j = 8191 & I,
                    B = I >>> 13,
                    R = 0 | a[7],
                    P = 8191 & R,
                    T = R >>> 13,
                    L = 0 | a[8],
                    C = 8191 & L,
                    O = L >>> 13,
                    N = 0 | a[9],
                    U = 8191 & N,
                    D = N >>> 13,
                    q = 0 | s[0],
                    z = 8191 & q,
                    F = q >>> 13,
                    Y = 0 | s[1],
                    K = 8191 & Y,
                    V = Y >>> 13,
                    H = 0 | s[2],
                    W = 8191 & H,
                    G = H >>> 13,
                    X = 0 | s[3],
                    Z = 8191 & X,
                    J = X >>> 13,
                    $ = 0 | s[4],
                    Q = 8191 & $,
                    ee = $ >>> 13,
                    te = 0 | s[5],
                    re = 8191 & te,
                    ne = te >>> 13,
                    ie = 0 | s[6],
                    oe = 8191 & ie,
                    ae = ie >>> 13,
                    se = 0 | s[7],
                    fe = 8191 & se,
                    ce = se >>> 13,
                    ue = 0 | s[8],
                    de = 8191 & ue,
                    he = ue >>> 13,
                    le = 0 | s[9],
                    pe = 8191 & le,
                    be = le >>> 13;

                r.negative = e.negative ^ t.negative, r.length = 19;
                var me = (c + (n = Math.imul(d, z)) | 0) + ((8191 & (i = (i = Math.imul(d, F)) + Math.imul(h, z) | 0)) << 13) | 0;
                c = ((o = Math.imul(h, F)) + (i >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, F)) + Math.imul(b, z) | 0, o = Math.imul(b, F);
                var ye = (c + (n = n + Math.imul(d, K) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, V) | 0) + Math.imul(h, K) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, V) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(y, z), i = (i = Math.imul(y, F)) + Math.imul(v, z) | 0, o = Math.imul(v, F), n = n + Math.imul(p, K) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(b, K) | 0, o = o + Math.imul(b, V) | 0;
                var ve = (c + (n = n + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, G) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(_, z), i = (i = Math.imul(_, F)) + Math.imul(w, z) | 0, o = Math.imul(w, F), n = n + Math.imul(y, K) | 0, i = (i = i + Math.imul(y, V) | 0) + Math.imul(v, K) | 0, o = o + Math.imul(v, V) | 0, n = n + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(b, W) | 0, o = o + Math.imul(b, G) | 0;
                var ge = (c + (n = n + Math.imul(d, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, J) | 0) + Math.imul(h, Z) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, J) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(E, z), i = (i = Math.imul(E, F)) + Math.imul(A, z) | 0, o = Math.imul(A, F), n = n + Math.imul(_, K) | 0, i = (i = i + Math.imul(_, V) | 0) + Math.imul(w, K) | 0, o = o + Math.imul(w, V) | 0, n = n + Math.imul(y, W) | 0, i = (i = i + Math.imul(y, G) | 0) + Math.imul(v, W) | 0, o = o + Math.imul(v, G) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, J) | 0) + Math.imul(b, Z) | 0, o = o + Math.imul(b, J) | 0;

                var _e = (c + (n = n + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(h, Q) | 0)) << 13) | 0;

                c = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, F)) + Math.imul(x, z) | 0, o = Math.imul(x, F), n = n + Math.imul(E, K) | 0, i = (i = i + Math.imul(E, V) | 0) + Math.imul(A, K) | 0, o = o + Math.imul(A, V) | 0, n = n + Math.imul(_, W) | 0, i = (i = i + Math.imul(_, G) | 0) + Math.imul(w, W) | 0, o = o + Math.imul(w, G) | 0, n = n + Math.imul(y, Z) | 0, i = (i = i + Math.imul(y, J) | 0) + Math.imul(v, Z) | 0, o = o + Math.imul(v, J) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(b, Q) | 0, o = o + Math.imul(b, ee) | 0;
                var we = (c + (n = n + Math.imul(d, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ne) | 0) + Math.imul(h, re) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, ne) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(j, z), i = (i = Math.imul(j, F)) + Math.imul(B, z) | 0, o = Math.imul(B, F), n = n + Math.imul(M, K) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(x, K) | 0, o = o + Math.imul(x, V) | 0, n = n + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, G) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, G) | 0, n = n + Math.imul(_, Z) | 0, i = (i = i + Math.imul(_, J) | 0) + Math.imul(w, Z) | 0, o = o + Math.imul(w, J) | 0, n = n + Math.imul(y, Q) | 0, i = (i = i + Math.imul(y, ee) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(b, re) | 0, o = o + Math.imul(b, ne) | 0;
                var ke = (c + (n = n + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, ae) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, z), i = (i = Math.imul(P, F)) + Math.imul(T, z) | 0, o = Math.imul(T, F), n = n + Math.imul(j, K) | 0, i = (i = i + Math.imul(j, V) | 0) + Math.imul(B, K) | 0, o = o + Math.imul(B, V) | 0, n = n + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, G) | 0, n = n + Math.imul(E, Z) | 0, i = (i = i + Math.imul(E, J) | 0) + Math.imul(A, Z) | 0, o = o + Math.imul(A, J) | 0, n = n + Math.imul(_, Q) | 0, i = (i = i + Math.imul(_, ee) | 0) + Math.imul(w, Q) | 0, o = o + Math.imul(w, ee) | 0, n = n + Math.imul(y, re) | 0, i = (i = i + Math.imul(y, ne) | 0) + Math.imul(v, re) | 0, o = o + Math.imul(v, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0;
                var Ee = (c + (n = n + Math.imul(d, fe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(h, fe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, ce) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, F)) + Math.imul(O, z) | 0, o = Math.imul(O, F), n = n + Math.imul(P, K) | 0, i = (i = i + Math.imul(P, V) | 0) + Math.imul(T, K) | 0, o = o + Math.imul(T, V) | 0, n = n + Math.imul(j, W) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(B, W) | 0, o = o + Math.imul(B, G) | 0, n = n + Math.imul(M, Z) | 0, i = (i = i + Math.imul(M, J) | 0) + Math.imul(x, Z) | 0, o = o + Math.imul(x, J) | 0, n = n + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, ee) | 0, n = n + Math.imul(_, re) | 0, i = (i = i + Math.imul(_, ne) | 0) + Math.imul(w, re) | 0, o = o + Math.imul(w, ne) | 0, n = n + Math.imul(y, oe) | 0, i = (i = i + Math.imul(y, ae) | 0) + Math.imul(v, oe) | 0, o = o + Math.imul(v, ae) | 0, n = n + Math.imul(p, fe) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(b, fe) | 0, o = o + Math.imul(b, ce) | 0;
                var Ae = (c + (n = n + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, he) | 0) + Math.imul(h, de) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(U, z), i = (i = Math.imul(U, F)) + Math.imul(D, z) | 0, o = Math.imul(D, F), n = n + Math.imul(C, K) | 0, i = (i = i + Math.imul(C, V) | 0) + Math.imul(O, K) | 0, o = o + Math.imul(O, V) | 0, n = n + Math.imul(P, W) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(T, W) | 0, o = o + Math.imul(T, G) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, J) | 0) + Math.imul(B, Z) | 0, o = o + Math.imul(B, J) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(x, Q) | 0, o = o + Math.imul(x, ee) | 0, n = n + Math.imul(E, re) | 0, i = (i = i + Math.imul(E, ne) | 0) + Math.imul(A, re) | 0, o = o + Math.imul(A, ne) | 0, n = n + Math.imul(_, oe) | 0, i = (i = i + Math.imul(_, ae) | 0) + Math.imul(w, oe) | 0, o = o + Math.imul(w, ae) | 0, n = n + Math.imul(y, fe) | 0, i = (i = i + Math.imul(y, ce) | 0) + Math.imul(v, fe) | 0, o = o + Math.imul(v, ce) | 0, n = n + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, he) | 0;
                var Se = (c + (n = n + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, be) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(h, be) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(U, K), i = (i = Math.imul(U, V)) + Math.imul(D, K) | 0, o = Math.imul(D, V), n = n + Math.imul(C, W) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(O, W) | 0, o = o + Math.imul(O, G) | 0, n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, J) | 0) + Math.imul(T, Z) | 0, o = o + Math.imul(T, J) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(B, Q) | 0, o = o + Math.imul(B, ee) | 0, n = n + Math.imul(M, re) | 0, i = (i = i + Math.imul(M, ne) | 0) + Math.imul(x, re) | 0, o = o + Math.imul(x, ne) | 0, n = n + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, n = n + Math.imul(_, fe) | 0, i = (i = i + Math.imul(_, ce) | 0) + Math.imul(w, fe) | 0, o = o + Math.imul(w, ce) | 0, n = n + Math.imul(y, de) | 0, i = (i = i + Math.imul(y, he) | 0) + Math.imul(v, de) | 0, o = o + Math.imul(v, he) | 0;
                var Me = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(b, be) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(U, W), i = (i = Math.imul(U, G)) + Math.imul(D, W) | 0, o = Math.imul(D, G), n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, J) | 0) + Math.imul(O, Z) | 0, o = o + Math.imul(O, J) | 0, n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(T, Q) | 0, o = o + Math.imul(T, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(B, re) | 0, o = o + Math.imul(B, ne) | 0, n = n + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, ae) | 0, n = n + Math.imul(E, fe) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(A, fe) | 0, o = o + Math.imul(A, ce) | 0, n = n + Math.imul(_, de) | 0, i = (i = i + Math.imul(_, he) | 0) + Math.imul(w, de) | 0, o = o + Math.imul(w, he) | 0;
                var xe = (c + (n = n + Math.imul(y, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(y, be) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(v, be) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(U, Z), i = (i = Math.imul(U, J)) + Math.imul(D, Z) | 0, o = Math.imul(D, J), n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(O, Q) | 0, o = o + Math.imul(O, ee) | 0, n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(T, re) | 0, o = o + Math.imul(T, ne) | 0, n = n + Math.imul(j, oe) | 0, i = (i = i + Math.imul(j, ae) | 0) + Math.imul(B, oe) | 0, o = o + Math.imul(B, ae) | 0, n = n + Math.imul(M, fe) | 0, i = (i = i + Math.imul(M, ce) | 0) + Math.imul(x, fe) | 0, o = o + Math.imul(x, ce) | 0, n = n + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, he) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, he) | 0;
                var Ie = (c + (n = n + Math.imul(_, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, be) | 0) + Math.imul(w, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(w, be) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(U, Q), i = (i = Math.imul(U, ee)) + Math.imul(D, Q) | 0, o = Math.imul(D, ee), n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(O, re) | 0, o = o + Math.imul(O, ne) | 0, n = n + Math.imul(P, oe) | 0, i = (i = i + Math.imul(P, ae) | 0) + Math.imul(T, oe) | 0, o = o + Math.imul(T, ae) | 0, n = n + Math.imul(j, fe) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(B, fe) | 0, o = o + Math.imul(B, ce) | 0, n = n + Math.imul(M, de) | 0, i = (i = i + Math.imul(M, he) | 0) + Math.imul(x, de) | 0, o = o + Math.imul(x, he) | 0;
                var je = (c + (n = n + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, be) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(A, be) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(U, re), i = (i = Math.imul(U, ne)) + Math.imul(D, re) | 0, o = Math.imul(D, ne), n = n + Math.imul(C, oe) | 0, i = (i = i + Math.imul(C, ae) | 0) + Math.imul(O, oe) | 0, o = o + Math.imul(O, ae) | 0, n = n + Math.imul(P, fe) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(T, fe) | 0, o = o + Math.imul(T, ce) | 0, n = n + Math.imul(j, de) | 0, i = (i = i + Math.imul(j, he) | 0) + Math.imul(B, de) | 0, o = o + Math.imul(B, he) | 0;
                var Be = (c + (n = n + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, be) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(x, be) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(U, oe), i = (i = Math.imul(U, ae)) + Math.imul(D, oe) | 0, o = Math.imul(D, ae), n = n + Math.imul(C, fe) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(O, fe) | 0, o = o + Math.imul(O, ce) | 0, n = n + Math.imul(P, de) | 0, i = (i = i + Math.imul(P, he) | 0) + Math.imul(T, de) | 0, o = o + Math.imul(T, he) | 0;
                var Re = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, be) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(B, be) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(U, fe), i = (i = Math.imul(U, ce)) + Math.imul(D, fe) | 0, o = Math.imul(D, ce), n = n + Math.imul(C, de) | 0, i = (i = i + Math.imul(C, he) | 0) + Math.imul(O, de) | 0, o = o + Math.imul(O, he) | 0;
                var Pe = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, be) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(T, be) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, n = Math.imul(U, de), i = (i = Math.imul(U, he)) + Math.imul(D, de) | 0, o = Math.imul(D, he);
                var Te = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, be) | 0) + Math.imul(O, pe) | 0)) << 13) | 0;
                c = ((o = o + Math.imul(O, be) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863;
                var Le = (c + (n = Math.imul(U, pe)) | 0) + ((8191 & (i = (i = Math.imul(U, be)) + Math.imul(D, pe) | 0)) << 13) | 0;
                return c = ((o = Math.imul(D, be)) + (i >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, f[0] = me, f[1] = ye, f[2] = ve, f[3] = ge, f[4] = _e, f[5] = we, f[6] = ke, f[7] = Ee, f[8] = Ae, f[9] = Se, f[10] = Me, f[11] = xe, f[12] = Ie, f[13] = je, f[14] = Be, f[15] = Re, f[16] = Pe, f[17] = Te, f[18] = Le, 0 !== c && (f[19] = c, r.length++), r;
              };

              function p(e, t, r) {
                return new b().mulp(e, t, r);
              }

              function b(e, t) {
                this.x = e, this.y = t;
              }

              Math.imul || (l = h), o.prototype.mulTo = function (e, t) {
                var r = this.length + e.length;
                return 10 === this.length && 10 === e.length ? l(this, e, t) : r < 63 ? h(this, e, t) : r < 1024 ? function (e, t, r) {
                  r.negative = t.negative ^ e.negative, r.length = e.length + t.length;

                  for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
                    var a = i;
                    i = 0;

                    for (var s = 67108863 & n, f = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= f; c++) {
                      var u = o - c,
                          d = (0 | e.words[u]) * (0 | t.words[c]),
                          h = 67108863 & d;
                      s = 67108863 & (h = h + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, a &= 67108863;
                    }

                    r.words[o] = s, n = a, a = i;
                  }

                  return 0 !== n ? r.words[o] = n : r.length--, r.strip();
                }(this, e, t) : p(this, e, t);
              }, b.prototype.makeRBT = function (e) {
                for (var t = new Array(e), r = o.prototype._countBits(e) - 1, n = 0; n < e; n++) {
                  t[n] = this.revBin(n, r, e);
                }

                return t;
              }, b.prototype.revBin = function (e, t, r) {
                if (0 === e || e === r - 1) return e;

                for (var n = 0, i = 0; i < t; i++) {
                  n |= (1 & e) << t - i - 1, e >>= 1;
                }

                return n;
              }, b.prototype.permute = function (e, t, r, n, i, o) {
                for (var a = 0; a < o; a++) {
                  n[a] = t[e[a]], i[a] = r[e[a]];
                }
              }, b.prototype.transform = function (e, t, r, n, i, o) {
                this.permute(o, e, t, r, n, i);

                for (var a = 1; a < i; a <<= 1) {
                  for (var s = a << 1, f = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), u = 0; u < i; u += s) {
                    for (var d = f, h = c, l = 0; l < a; l++) {
                      var p = r[u + l],
                          b = n[u + l],
                          m = r[u + l + a],
                          y = n[u + l + a],
                          v = d * m - h * y;
                      y = d * y + h * m, m = v, r[u + l] = p + m, n[u + l] = b + y, r[u + l + a] = p - m, n[u + l + a] = b - y, l !== s && (v = f * d - c * h, h = f * h + c * d, d = v);
                    }
                  }
                }
              }, b.prototype.guessLen13b = function (e, t) {
                var r = 1 | Math.max(t, e),
                    n = 1 & r,
                    i = 0;

                for (r = r / 2 | 0; r; r >>>= 1) {
                  i++;
                }

                return 1 << i + 1 + n;
              }, b.prototype.conjugate = function (e, t, r) {
                if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
                  var i = e[n];
                  e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                }
              }, b.prototype.normalize13b = function (e, t) {
                for (var r = 0, n = 0; n < t / 2; n++) {
                  var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                  e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                }

                return e;
              }, b.prototype.convert13b = function (e, t, r, i) {
                for (var o = 0, a = 0; a < t; a++) {
                  o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
                }

                for (a = 2 * t; a < i; ++a) {
                  r[a] = 0;
                }

                n(0 === o), n(0 == (-8192 & o));
              }, b.prototype.stub = function (e) {
                for (var t = new Array(e), r = 0; r < e; r++) {
                  t[r] = 0;
                }

                return t;
              }, b.prototype.mulp = function (e, t, r) {
                var n = 2 * this.guessLen13b(e.length, t.length),
                    i = this.makeRBT(n),
                    o = this.stub(n),
                    a = new Array(n),
                    s = new Array(n),
                    f = new Array(n),
                    c = new Array(n),
                    u = new Array(n),
                    d = new Array(n),
                    h = r.words;
                h.length = n, this.convert13b(e.words, e.length, a, n), this.convert13b(t.words, t.length, c, n), this.transform(a, o, s, f, n, i), this.transform(c, o, u, d, n, i);

                for (var l = 0; l < n; l++) {
                  var p = s[l] * u[l] - f[l] * d[l];
                  f[l] = s[l] * d[l] + f[l] * u[l], s[l] = p;
                }

                return this.conjugate(s, f, n), this.transform(s, f, h, o, n, i), this.conjugate(h, o, n), this.normalize13b(h, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
              }, o.prototype.mul = function (e) {
                var t = new o(null);
                return t.words = new Array(this.length + e.length), this.mulTo(e, t);
              }, o.prototype.mulf = function (e) {
                var t = new o(null);
                return t.words = new Array(this.length + e.length), p(this, e, t);
              }, o.prototype.imul = function (e) {
                return this.clone().mulTo(e, this);
              }, o.prototype.imuln = function (e) {
                n("number" == typeof e), n(e < 67108864);

                for (var t = 0, r = 0; r < this.length; r++) {
                  var i = (0 | this.words[r]) * e,
                      o = (67108863 & i) + (67108863 & t);
                  t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[r] = 67108863 & o;
                }

                return 0 !== t && (this.words[r] = t, this.length++), this;
              }, o.prototype.muln = function (e) {
                return this.clone().imuln(e);
              }, o.prototype.sqr = function () {
                return this.mul(this);
              }, o.prototype.isqr = function () {
                return this.imul(this.clone());
              }, o.prototype.pow = function (e) {
                var t = function (e) {
                  for (var t = new Array(e.bitLength()), r = 0; r < t.length; r++) {
                    var n = r / 26 | 0,
                        i = r % 26;
                    t[r] = (e.words[n] & 1 << i) >>> i;
                  }

                  return t;
                }(e);

                if (0 === t.length) return new o(1);

                for (var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr()) {
                  ;
                }

                if (++n < t.length) for (var i = r.sqr(); n < t.length; n++, i = i.sqr()) {
                  0 !== t[n] && (r = r.mul(i));
                }
                return r;
              }, o.prototype.iushln = function (e) {
                n("number" == typeof e && e >= 0);
                var t,
                    r = e % 26,
                    i = (e - r) / 26,
                    o = 67108863 >>> 26 - r << 26 - r;

                if (0 !== r) {
                  var a = 0;

                  for (t = 0; t < this.length; t++) {
                    var s = this.words[t] & o,
                        f = (0 | this.words[t]) - s << r;
                    this.words[t] = f | a, a = s >>> 26 - r;
                  }

                  a && (this.words[t] = a, this.length++);
                }

                if (0 !== i) {
                  for (t = this.length - 1; t >= 0; t--) {
                    this.words[t + i] = this.words[t];
                  }

                  for (t = 0; t < i; t++) {
                    this.words[t] = 0;
                  }

                  this.length += i;
                }

                return this.strip();
              }, o.prototype.ishln = function (e) {
                return n(0 === this.negative), this.iushln(e);
              }, o.prototype.iushrn = function (e, t, r) {
                var i;
                n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                var o = e % 26,
                    a = Math.min((e - o) / 26, this.length),
                    s = 67108863 ^ 67108863 >>> o << o,
                    f = r;

                if (i -= a, i = Math.max(0, i), f) {
                  for (var c = 0; c < a; c++) {
                    f.words[c] = this.words[c];
                  }

                  f.length = a;
                }

                if (0 === a) ;else if (this.length > a) for (this.length -= a, c = 0; c < this.length; c++) {
                  this.words[c] = this.words[c + a];
                } else this.words[0] = 0, this.length = 1;
                var u = 0;

                for (c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--) {
                  var d = 0 | this.words[c];
                  this.words[c] = u << 26 - o | d >>> o, u = d & s;
                }

                return f && 0 !== u && (f.words[f.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
              }, o.prototype.ishrn = function (e, t, r) {
                return n(0 === this.negative), this.iushrn(e, t, r);
              }, o.prototype.shln = function (e) {
                return this.clone().ishln(e);
              }, o.prototype.ushln = function (e) {
                return this.clone().iushln(e);
              }, o.prototype.shrn = function (e) {
                return this.clone().ishrn(e);
              }, o.prototype.ushrn = function (e) {
                return this.clone().iushrn(e);
              }, o.prototype.testn = function (e) {
                n("number" == typeof e && e >= 0);
                var t = e % 26,
                    r = (e - t) / 26,
                    i = 1 << t;
                return !(this.length <= r || !(this.words[r] & i));
              }, o.prototype.imaskn = function (e) {
                n("number" == typeof e && e >= 0);
                var t = e % 26,
                    r = (e - t) / 26;
                if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

                if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                  var i = 67108863 ^ 67108863 >>> t << t;
                  this.words[this.length - 1] &= i;
                }

                return this.strip();
              }, o.prototype.maskn = function (e) {
                return this.clone().imaskn(e);
              }, o.prototype.iaddn = function (e) {
                return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
              }, o.prototype._iaddn = function (e) {
                this.words[0] += e;

                for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) {
                  this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                }

                return this.length = Math.max(this.length, t + 1), this;
              }, o.prototype.isubn = function (e) {
                if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
                  this.words[t] += 67108864, this.words[t + 1] -= 1;
                }
                return this.strip();
              }, o.prototype.addn = function (e) {
                return this.clone().iaddn(e);
              }, o.prototype.subn = function (e) {
                return this.clone().isubn(e);
              }, o.prototype.iabs = function () {
                return this.negative = 0, this;
              }, o.prototype.abs = function () {
                return this.clone().iabs();
              }, o.prototype._ishlnsubmul = function (e, t, r) {
                var i,
                    o,
                    a = e.length + r;

                this._expand(a);

                var s = 0;

                for (i = 0; i < e.length; i++) {
                  o = (0 | this.words[i + r]) + s;
                  var f = (0 | e.words[i]) * t;
                  s = ((o -= 67108863 & f) >> 26) - (f / 67108864 | 0), this.words[i + r] = 67108863 & o;
                }

                for (; i < this.length - r; i++) {
                  s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
                }

                if (0 === s) return this.strip();

                for (n(-1 === s), s = 0, i = 0; i < this.length; i++) {
                  s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
                }

                return this.negative = 1, this.strip();
              }, o.prototype._wordDiv = function (e, t) {
                var r = (this.length, e.length),
                    n = this.clone(),
                    i = e,
                    a = 0 | i.words[i.length - 1];
                0 != (r = 26 - this._countBits(a)) && (i = i.ushln(r), n.iushln(r), a = 0 | i.words[i.length - 1]);
                var s,
                    f = n.length - i.length;

                if ("mod" !== t) {
                  (s = new o(null)).length = f + 1, s.words = new Array(s.length);

                  for (var c = 0; c < s.length; c++) {
                    s.words[c] = 0;
                  }
                }

                var u = n.clone()._ishlnsubmul(i, 1, f);

                0 === u.negative && (n = u, s && (s.words[f] = 1));

                for (var d = f - 1; d >= 0; d--) {
                  var h = 67108864 * (0 | n.words[i.length + d]) + (0 | n.words[i.length + d - 1]);

                  for (h = Math.min(h / a | 0, 67108863), n._ishlnsubmul(i, h, d); 0 !== n.negative;) {
                    h--, n.negative = 0, n._ishlnsubmul(i, 1, d), n.isZero() || (n.negative ^= 1);
                  }

                  s && (s.words[d] = h);
                }

                return s && s.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                  div: s || null,
                  mod: n
                };
              }, o.prototype.divmod = function (e, t, r) {
                return n(!e.isZero()), this.isZero() ? {
                  div: new o(0),
                  mod: new o(0)
                } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (i = s.div.neg()), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
                  div: i,
                  mod: a
                }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (i = s.div.neg()), {
                  div: i,
                  mod: s.mod
                }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
                  div: s.div,
                  mod: a
                }) : e.length > this.length || this.cmp(e) < 0 ? {
                  div: new o(0),
                  mod: this
                } : 1 === e.length ? "div" === t ? {
                  div: this.divn(e.words[0]),
                  mod: null
                } : "mod" === t ? {
                  div: null,
                  mod: new o(this.modn(e.words[0]))
                } : {
                  div: this.divn(e.words[0]),
                  mod: new o(this.modn(e.words[0]))
                } : this._wordDiv(e, t);
                var i, a, s;
              }, o.prototype.div = function (e) {
                return this.divmod(e, "div", !1).div;
              }, o.prototype.mod = function (e) {
                return this.divmod(e, "mod", !1).mod;
              }, o.prototype.umod = function (e) {
                return this.divmod(e, "mod", !0).mod;
              }, o.prototype.divRound = function (e) {
                var t = this.divmod(e);
                if (t.mod.isZero()) return t.div;
                var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
                    n = e.ushrn(1),
                    i = e.andln(1),
                    o = r.cmp(n);
                return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
              }, o.prototype.modn = function (e) {
                n(e <= 67108863);

                for (var t = (1 << 26) % e, r = 0, i = this.length - 1; i >= 0; i--) {
                  r = (t * r + (0 | this.words[i])) % e;
                }

                return r;
              }, o.prototype.idivn = function (e) {
                n(e <= 67108863);

                for (var t = 0, r = this.length - 1; r >= 0; r--) {
                  var i = (0 | this.words[r]) + 67108864 * t;
                  this.words[r] = i / e | 0, t = i % e;
                }

                return this.strip();
              }, o.prototype.divn = function (e) {
                return this.clone().idivn(e);
              }, o.prototype.egcd = function (e) {
                n(0 === e.negative), n(!e.isZero());
                var t = this,
                    r = e.clone();
                t = 0 !== t.negative ? t.umod(e) : t.clone();

                for (var i = new o(1), a = new o(0), s = new o(0), f = new o(1), c = 0; t.isEven() && r.isEven();) {
                  t.iushrn(1), r.iushrn(1), ++c;
                }

                for (var u = r.clone(), d = t.clone(); !t.isZero();) {
                  for (var h = 0, l = 1; 0 == (t.words[0] & l) && h < 26; ++h, l <<= 1) {
                    ;
                  }

                  if (h > 0) for (t.iushrn(h); h-- > 0;) {
                    (i.isOdd() || a.isOdd()) && (i.iadd(u), a.isub(d)), i.iushrn(1), a.iushrn(1);
                  }

                  for (var p = 0, b = 1; 0 == (r.words[0] & b) && p < 26; ++p, b <<= 1) {
                    ;
                  }

                  if (p > 0) for (r.iushrn(p); p-- > 0;) {
                    (s.isOdd() || f.isOdd()) && (s.iadd(u), f.isub(d)), s.iushrn(1), f.iushrn(1);
                  }
                  t.cmp(r) >= 0 ? (t.isub(r), i.isub(s), a.isub(f)) : (r.isub(t), s.isub(i), f.isub(a));
                }

                return {
                  a: s,
                  b: f,
                  gcd: r.iushln(c)
                };
              }, o.prototype._invmp = function (e) {
                n(0 === e.negative), n(!e.isZero());
                var t = this,
                    r = e.clone();
                t = 0 !== t.negative ? t.umod(e) : t.clone();

                for (var i, a = new o(1), s = new o(0), f = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
                  for (var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1) {
                    ;
                  }

                  if (c > 0) for (t.iushrn(c); c-- > 0;) {
                    a.isOdd() && a.iadd(f), a.iushrn(1);
                  }

                  for (var d = 0, h = 1; 0 == (r.words[0] & h) && d < 26; ++d, h <<= 1) {
                    ;
                  }

                  if (d > 0) for (r.iushrn(d); d-- > 0;) {
                    s.isOdd() && s.iadd(f), s.iushrn(1);
                  }
                  t.cmp(r) >= 0 ? (t.isub(r), a.isub(s)) : (r.isub(t), s.isub(a));
                }

                return (i = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && i.iadd(e), i;
              }, o.prototype.gcd = function (e) {
                if (this.isZero()) return e.abs();
                if (e.isZero()) return this.abs();
                var t = this.clone(),
                    r = e.clone();
                t.negative = 0, r.negative = 0;

                for (var n = 0; t.isEven() && r.isEven(); n++) {
                  t.iushrn(1), r.iushrn(1);
                }

                for (;;) {
                  for (; t.isEven();) {
                    t.iushrn(1);
                  }

                  for (; r.isEven();) {
                    r.iushrn(1);
                  }

                  var i = t.cmp(r);

                  if (i < 0) {
                    var o = t;
                    t = r, r = o;
                  } else if (0 === i || 0 === r.cmpn(1)) break;

                  t.isub(r);
                }

                return r.iushln(n);
              }, o.prototype.invm = function (e) {
                return this.egcd(e).a.umod(e);
              }, o.prototype.isEven = function () {
                return 0 == (1 & this.words[0]);
              }, o.prototype.isOdd = function () {
                return 1 == (1 & this.words[0]);
              }, o.prototype.andln = function (e) {
                return this.words[0] & e;
              }, o.prototype.bincn = function (e) {
                n("number" == typeof e);
                var t = e % 26,
                    r = (e - t) / 26,
                    i = 1 << t;
                if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

                for (var o = i, a = r; 0 !== o && a < this.length; a++) {
                  var s = 0 | this.words[a];
                  o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
                }

                return 0 !== o && (this.words[a] = o, this.length++), this;
              }, o.prototype.isZero = function () {
                return 1 === this.length && 0 === this.words[0];
              }, o.prototype.cmpn = function (e) {
                var t,
                    r = e < 0;
                if (0 !== this.negative && !r) return -1;
                if (0 === this.negative && r) return 1;
                if (this.strip(), this.length > 1) t = 1;else {
                  r && (e = -e), n(e <= 67108863, "Number is too big");
                  var i = 0 | this.words[0];
                  t = i === e ? 0 : i < e ? -1 : 1;
                }
                return 0 !== this.negative ? 0 | -t : t;
              }, o.prototype.cmp = function (e) {
                if (0 !== this.negative && 0 === e.negative) return -1;
                if (0 === this.negative && 0 !== e.negative) return 1;
                var t = this.ucmp(e);
                return 0 !== this.negative ? 0 | -t : t;
              }, o.prototype.ucmp = function (e) {
                if (this.length > e.length) return 1;
                if (this.length < e.length) return -1;

                for (var t = 0, r = this.length - 1; r >= 0; r--) {
                  var n = 0 | this.words[r],
                      i = 0 | e.words[r];

                  if (n !== i) {
                    n < i ? t = -1 : n > i && (t = 1);
                    break;
                  }
                }

                return t;
              }, o.prototype.gtn = function (e) {
                return 1 === this.cmpn(e);
              }, o.prototype.gt = function (e) {
                return 1 === this.cmp(e);
              }, o.prototype.gten = function (e) {
                return this.cmpn(e) >= 0;
              }, o.prototype.gte = function (e) {
                return this.cmp(e) >= 0;
              }, o.prototype.ltn = function (e) {
                return -1 === this.cmpn(e);
              }, o.prototype.lt = function (e) {
                return -1 === this.cmp(e);
              }, o.prototype.lten = function (e) {
                return this.cmpn(e) <= 0;
              }, o.prototype.lte = function (e) {
                return this.cmp(e) <= 0;
              }, o.prototype.eqn = function (e) {
                return 0 === this.cmpn(e);
              }, o.prototype.eq = function (e) {
                return 0 === this.cmp(e);
              }, o.red = function (e) {
                return new k(e);
              }, o.prototype.toRed = function (e) {
                return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
              }, o.prototype.fromRed = function () {
                return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
              }, o.prototype._forceRed = function (e) {
                return this.red = e, this;
              }, o.prototype.forceRed = function (e) {
                return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
              }, o.prototype.redAdd = function (e) {
                return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
              }, o.prototype.redIAdd = function (e) {
                return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
              }, o.prototype.redSub = function (e) {
                return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
              }, o.prototype.redISub = function (e) {
                return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
              }, o.prototype.redShl = function (e) {
                return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
              }, o.prototype.redMul = function (e) {
                return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
              }, o.prototype.redIMul = function (e) {
                return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
              }, o.prototype.redSqr = function () {
                return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
              }, o.prototype.redISqr = function () {
                return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
              }, o.prototype.redSqrt = function () {
                return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
              }, o.prototype.redInvm = function () {
                return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
              }, o.prototype.redNeg = function () {
                return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
              }, o.prototype.redPow = function (e) {
                return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
              };
              var m = {
                k256: null,
                p224: null,
                p192: null,
                p25519: null
              };

              function y(e, t) {
                this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
              }

              function v() {
                y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
              }

              function g() {
                y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
              }

              function _() {
                y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
              }

              function w() {
                y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
              }

              function k(e) {
                if ("string" == typeof e) {
                  var t = o._prime(e);

                  this.m = t.p, this.prime = t;
                } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
              }

              function E(e) {
                k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
              }

              y.prototype._tmp = function () {
                var e = new o(null);
                return e.words = new Array(Math.ceil(this.n / 13)), e;
              }, y.prototype.ireduce = function (e) {
                var t,
                    r = e;

                do {
                  this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                } while (t > this.n);

                var n = t < this.n ? -1 : r.ucmp(this.p);
                return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
              }, y.prototype.split = function (e, t) {
                e.iushrn(this.n, 0, t);
              }, y.prototype.imulK = function (e) {
                return e.imul(this.k);
              }, i(v, y), v.prototype.split = function (e, t) {
                for (var r = Math.min(e.length, 9), n = 0; n < r; n++) {
                  t.words[n] = e.words[n];
                }

                if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                var i = e.words[9];

                for (t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++) {
                  var o = 0 | e.words[n];
                  e.words[n - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
                }

                i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
              }, v.prototype.imulK = function (e) {
                e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

                for (var t = 0, r = 0; r < e.length; r++) {
                  var n = 0 | e.words[r];
                  t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                }

                return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
              }, i(g, y), i(_, y), i(w, y), w.prototype.imulK = function (e) {
                for (var t = 0, r = 0; r < e.length; r++) {
                  var n = 19 * (0 | e.words[r]) + t,
                      i = 67108863 & n;
                  n >>>= 26, e.words[r] = i, t = n;
                }

                return 0 !== t && (e.words[e.length++] = t), e;
              }, o._prime = function (e) {
                if (m[e]) return m[e];
                var t;
                if ("k256" === e) t = new v();else if ("p224" === e) t = new g();else if ("p192" === e) t = new _();else {
                  if ("p25519" !== e) throw new Error("Unknown prime " + e);
                  t = new w();
                }
                return m[e] = t, t;
              }, k.prototype._verify1 = function (e) {
                n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
              }, k.prototype._verify2 = function (e, t) {
                n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
              }, k.prototype.imod = function (e) {
                return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
              }, k.prototype.neg = function (e) {
                return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
              }, k.prototype.add = function (e, t) {
                this._verify2(e, t);

                var r = e.add(t);
                return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
              }, k.prototype.iadd = function (e, t) {
                this._verify2(e, t);

                var r = e.iadd(t);
                return r.cmp(this.m) >= 0 && r.isub(this.m), r;
              }, k.prototype.sub = function (e, t) {
                this._verify2(e, t);

                var r = e.sub(t);
                return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
              }, k.prototype.isub = function (e, t) {
                this._verify2(e, t);

                var r = e.isub(t);
                return r.cmpn(0) < 0 && r.iadd(this.m), r;
              }, k.prototype.shl = function (e, t) {
                return this._verify1(e), this.imod(e.ushln(t));
              }, k.prototype.imul = function (e, t) {
                return this._verify2(e, t), this.imod(e.imul(t));
              }, k.prototype.mul = function (e, t) {
                return this._verify2(e, t), this.imod(e.mul(t));
              }, k.prototype.isqr = function (e) {
                return this.imul(e, e.clone());
              }, k.prototype.sqr = function (e) {
                return this.mul(e, e);
              }, k.prototype.sqrt = function (e) {
                if (e.isZero()) return e.clone();
                var t = this.m.andln(3);

                if (n(t % 2 == 1), 3 === t) {
                  var r = this.m.add(new o(1)).iushrn(2);
                  return this.pow(e, r);
                }

                for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) {
                  a++, i.iushrn(1);
                }

                n(!i.isZero());
                var s = new o(1).toRed(this),
                    f = s.redNeg(),
                    c = this.m.subn(1).iushrn(1),
                    u = this.m.bitLength();

                for (u = new o(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(f);) {
                  u.redIAdd(f);
                }

                for (var d = this.pow(u, i), h = this.pow(e, i.addn(1).iushrn(1)), l = this.pow(e, i), p = a; 0 !== l.cmp(s);) {
                  for (var b = l, m = 0; 0 !== b.cmp(s); m++) {
                    b = b.redSqr();
                  }

                  n(m < p);
                  var y = this.pow(d, new o(1).iushln(p - m - 1));
                  h = h.redMul(y), d = y.redSqr(), l = l.redMul(d), p = m;
                }

                return h;
              }, k.prototype.invm = function (e) {
                var t = e._invmp(this.m);

                return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
              }, k.prototype.pow = function (e, t) {
                if (t.isZero()) return new o(1).toRed(this);
                if (0 === t.cmpn(1)) return e.clone();
                var r = new Array(16);
                r[0] = new o(1).toRed(this), r[1] = e;

                for (var n = 2; n < r.length; n++) {
                  r[n] = this.mul(r[n - 1], e);
                }

                var i = r[0],
                    a = 0,
                    s = 0,
                    f = t.bitLength() % 26;

                for (0 === f && (f = 26), n = t.length - 1; n >= 0; n--) {
                  for (var c = t.words[n], u = f - 1; u >= 0; u--) {
                    var d = c >> u & 1;
                    i !== r[0] && (i = this.sqr(i)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 == ++s || 0 === n && 0 === u) && (i = this.mul(i, r[a]), s = 0, a = 0)) : s = 0;
                  }

                  f = 26;
                }

                return i;
              }, k.prototype.convertTo = function (e) {
                var t = e.umod(this.m);
                return t === e ? t.clone() : t;
              }, k.prototype.convertFrom = function (e) {
                var t = e.clone();
                return t.red = null, t;
              }, o.mont = function (e) {
                return new E(e);
              }, i(E, k), E.prototype.convertTo = function (e) {
                return this.imod(e.ushln(this.shift));
              }, E.prototype.convertFrom = function (e) {
                var t = this.imod(e.mul(this.rinv));
                return t.red = null, t;
              }, E.prototype.imul = function (e, t) {
                if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                var r = e.imul(t),
                    n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                    i = r.isub(n).iushrn(this.shift),
                    o = i;
                return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
              }, E.prototype.mul = function (e, t) {
                if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
                var r = e.mul(t),
                    n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                    i = r.isub(n).iushrn(this.shift),
                    a = i;
                return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
              }, E.prototype.invm = function (e) {
                return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
              };
            }(e, this);
          }).call(this, r(
          /*! ./../../webpack/buildin/module.js */
          "./node_modules/webpack/buildin/module.js")(e));
        },
        "./node_modules/brorand/index.js":
        /*!***************************************!*\
          !*** ./node_modules/brorand/index.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesBrorandIndexJs(e, t, r) {
          var n;

          function i(e) {
            this.rand = e;
          }

          if (e.exports = function (e) {
            return n || (n = new i(null)), n.generate(e);
          }, e.exports.Rand = i, i.prototype.generate = function (e) {
            return this._rand(e);
          }, i.prototype._rand = function (e) {
            if (this.rand.getBytes) return this.rand.getBytes(e);

            for (var t = new Uint8Array(e), r = 0; r < t.length; r++) {
              t[r] = this.rand.getByte();
            }

            return t;
          }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (e) {
            var t = new Uint8Array(e);
            return self.crypto.getRandomValues(t), t;
          } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (e) {
            var t = new Uint8Array(e);
            return self.msCrypto.getRandomValues(t), t;
          } : "object" == typeof window && (i.prototype._rand = function () {
            throw new Error("Not implemented yet");
          });else try {
            var o = r(
            /*! crypto */
            3);
            if ("function" != typeof o.randomBytes) throw new Error("Not supported");

            i.prototype._rand = function (e) {
              return o.randomBytes(e);
            };
          } catch (e) {}
        },
        "./node_modules/buffer/index.js":
        /*!**************************************!*\
          !*** ./node_modules/buffer/index.js ***!
          \**************************************/

        /*! no static exports found */
        function node_modulesBufferIndexJs(e, t, r) {
          "use strict";

          (function (e) {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <http://feross.org>
             * @license  MIT
             */
            var n = r(
            /*! base64-js */
            "./node_modules/base64-js/index.js"),
                i = r(
            /*! ieee754 */
            "./node_modules/ieee754/index.js"),
                o = r(
            /*! isarray */
            "./node_modules/isarray/index.js");

            function a() {
              return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
            }

            function s(e, t) {
              if (a() < t) throw new RangeError("Invalid typed array length");
              return f.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = f.prototype : (null === e && (e = new f(t)), e.length = t), e;
            }

            function f(e, t, r) {
              if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(e, t, r);

              if ("number" == typeof e) {
                if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
                return d(this, e);
              }

              return c(this, e, t, r);
            }

            function c(e, t, r, n) {
              if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
              return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, r, n) {
                if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
                if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                return t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n), f.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = f.prototype : e = h(e, t), e;
              }(e, t, r, n) : "string" == typeof t ? function (e, t, r) {
                if ("string" == typeof r && "" !== r || (r = "utf8"), !f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                var n = 0 | p(t, r),
                    i = (e = s(e, n)).write(t, r);
                return i !== n && (e = e.slice(0, i)), e;
              }(e, t, r) : function (e, t) {
                if (f.isBuffer(t)) {
                  var r = 0 | l(t.length);
                  return 0 === (e = s(e, r)).length || t.copy(e, 0, 0, r), e;
                }

                if (t) {
                  if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (n = t.length) != n ? s(e, 0) : h(e, t);
                  if ("Buffer" === t.type && o(t.data)) return h(e, t.data);
                }

                var n;
                throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
              }(e, t);
            }

            function u(e) {
              if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
              if (e < 0) throw new RangeError('"size" argument must not be negative');
            }

            function d(e, t) {
              if (u(t), e = s(e, t < 0 ? 0 : 0 | l(t)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < t; ++r) {
                e[r] = 0;
              }
              return e;
            }

            function h(e, t) {
              var r = t.length < 0 ? 0 : 0 | l(t.length);
              e = s(e, r);

              for (var n = 0; n < r; n += 1) {
                e[n] = 255 & t[n];
              }

              return e;
            }

            function l(e) {
              if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
              return 0 | e;
            }

            function p(e, t) {
              if (f.isBuffer(e)) return e.length;
              if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
              "string" != typeof e && (e = "" + e);
              var r = e.length;
              if (0 === r) return 0;

              for (var n = !1;;) {
                switch (t) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return r;

                  case "utf8":
                  case "utf-8":
                  case void 0:
                    return D(e).length;

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return 2 * r;

                  case "hex":
                    return r >>> 1;

                  case "base64":
                    return q(e).length;

                  default:
                    if (n) return D(e).length;
                    t = ("" + t).toLowerCase(), n = !0;
                }
              }
            }

            function b(e, t, r) {
              var n = !1;
              if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
              if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
              if ((r >>>= 0) <= (t >>>= 0)) return "";

              for (e || (e = "utf8");;) {
                switch (e) {
                  case "hex":
                    return j(this, t, r);

                  case "utf8":
                  case "utf-8":
                    return M(this, t, r);

                  case "ascii":
                    return x(this, t, r);

                  case "latin1":
                  case "binary":
                    return I(this, t, r);

                  case "base64":
                    return S(this, t, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return B(this, t, r);

                  default:
                    if (n) throw new TypeError("Unknown encoding: " + e);
                    e = (e + "").toLowerCase(), n = !0;
                }
              }
            }

            function m(e, t, r) {
              var n = e[t];
              e[t] = e[r], e[r] = n;
            }

            function y(e, t, r, n, i) {
              if (0 === e.length) return -1;

              if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                if (i) return -1;
                r = e.length - 1;
              } else if (r < 0) {
                if (!i) return -1;
                r = 0;
              }

              if ("string" == typeof t && (t = f.from(t, n)), f.isBuffer(t)) return 0 === t.length ? -1 : v(e, t, r, n, i);
              if ("number" == typeof t) return t &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : v(e, [t], r, n, i);
              throw new TypeError("val must be string, number or Buffer");
            }

            function v(e, t, r, n, i) {
              var o,
                  a = 1,
                  s = e.length,
                  f = t.length;

              if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                if (e.length < 2 || t.length < 2) return -1;
                a = 2, s /= 2, f /= 2, r /= 2;
              }

              function c(e, t) {
                return 1 === a ? e[t] : e.readUInt16BE(t * a);
              }

              if (i) {
                var u = -1;

                for (o = r; o < s; o++) {
                  if (c(e, o) === c(t, -1 === u ? 0 : o - u)) {
                    if (-1 === u && (u = o), o - u + 1 === f) return u * a;
                  } else -1 !== u && (o -= o - u), u = -1;
                }
              } else for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
                for (var d = !0, h = 0; h < f; h++) {
                  if (c(e, o + h) !== c(t, h)) {
                    d = !1;
                    break;
                  }
                }

                if (d) return o;
              }

              return -1;
            }

            function g(e, t, r, n) {
              r = Number(r) || 0;
              var i = e.length - r;
              n ? (n = Number(n)) > i && (n = i) : n = i;
              var o = t.length;
              if (o % 2 != 0) throw new TypeError("Invalid hex string");
              n > o / 2 && (n = o / 2);

              for (var a = 0; a < n; ++a) {
                var s = parseInt(t.substr(2 * a, 2), 16);
                if (isNaN(s)) return a;
                e[r + a] = s;
              }

              return a;
            }

            function _(e, t, r, n) {
              return z(D(t, e.length - r), e, r, n);
            }

            function w(e, t, r, n) {
              return z(function (e) {
                for (var t = [], r = 0; r < e.length; ++r) {
                  t.push(255 & e.charCodeAt(r));
                }

                return t;
              }(t), e, r, n);
            }

            function k(e, t, r, n) {
              return w(e, t, r, n);
            }

            function E(e, t, r, n) {
              return z(q(t), e, r, n);
            }

            function A(e, t, r, n) {
              return z(function (e, t) {
                for (var r, n, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
                  r = e.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
                }

                return o;
              }(t, e.length - r), e, r, n);
            }

            function S(e, t, r) {
              return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
            }

            function M(e, t, r) {
              r = Math.min(e.length, r);

              for (var n = [], i = t; i < r;) {
                var o,
                    a,
                    s,
                    f,
                    c = e[i],
                    u = null,
                    d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                if (i + d <= r) switch (d) {
                  case 1:
                    c < 128 && (u = c);
                    break;

                  case 2:
                    128 == (192 & (o = e[i + 1])) && (f = (31 & c) << 6 | 63 & o) > 127 && (u = f);
                    break;

                  case 3:
                    o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (u = f);
                    break;

                  case 4:
                    o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (u = f);
                }
                null === u ? (u = 65533, d = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += d;
              }

              return function (e) {
                var t = e.length;
                if (t <= 4096) return String.fromCharCode.apply(String, e);

                for (var r = "", n = 0; n < t;) {
                  r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
                }

                return r;
              }(n);
            }

            function x(e, t, r) {
              var n = "";
              r = Math.min(e.length, r);

              for (var i = t; i < r; ++i) {
                n += String.fromCharCode(127 & e[i]);
              }

              return n;
            }

            function I(e, t, r) {
              var n = "";
              r = Math.min(e.length, r);

              for (var i = t; i < r; ++i) {
                n += String.fromCharCode(e[i]);
              }

              return n;
            }

            function j(e, t, r) {
              var n,
                  i = e.length;
              (!t || t < 0) && (t = 0), (!r || r < 0 || r > i) && (r = i);

              for (var o = "", a = t; a < r; ++a) {
                o += (n = e[a]) < 16 ? "0" + n.toString(16) : n.toString(16);
              }

              return o;
            }

            function B(e, t, r) {
              for (var n = e.slice(t, r), i = "", o = 0; o < n.length; o += 2) {
                i += String.fromCharCode(n[o] + 256 * n[o + 1]);
              }

              return i;
            }

            function R(e, t, r) {
              if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
              if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
            }

            function P(e, t, r, n, i, o) {
              if (!f.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
              if (r + n > e.length) throw new RangeError("Index out of range");
            }

            function T(e, t, r, n) {
              t < 0 && (t = 65535 + t + 1);

              for (var i = 0, o = Math.min(e.length - r, 2); i < o; ++i) {
                e[r + i] = (t & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
              }
            }

            function L(e, t, r, n) {
              t < 0 && (t = 4294967295 + t + 1);

              for (var i = 0, o = Math.min(e.length - r, 4); i < o; ++i) {
                e[r + i] = t >>> 8 * (n ? i : 3 - i) & 255;
              }
            }

            function C(e, t, r, n, i, o) {
              if (r + n > e.length) throw new RangeError("Index out of range");
              if (r < 0) throw new RangeError("Index out of range");
            }

            function O(e, t, r, n, o) {
              return o || C(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
            }

            function N(e, t, r, n, o) {
              return o || C(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
            }

            t.Buffer = f, t.SlowBuffer = function (e) {
              return +e != e && (e = 0), f.alloc(+e);
            }, t.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
              try {
                var e = new Uint8Array(1);
                return e.__proto__ = {
                  __proto__: Uint8Array.prototype,
                  foo: function foo() {
                    return 42;
                  }
                }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
              } catch (e) {
                return !1;
              }
            }(), t.kMaxLength = a(), f.poolSize = 8192, f._augment = function (e) {
              return e.__proto__ = f.prototype, e;
            }, f.from = function (e, t, r) {
              return c(null, e, t, r);
            }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
              value: null,
              configurable: !0
            })), f.alloc = function (e, t, r) {
              return function (e, t, r, n) {
                return u(t), t <= 0 ? s(e, t) : void 0 !== r ? "string" == typeof n ? s(e, t).fill(r, n) : s(e, t).fill(r) : s(e, t);
              }(null, e, t, r);
            }, f.allocUnsafe = function (e) {
              return d(null, e);
            }, f.allocUnsafeSlow = function (e) {
              return d(null, e);
            }, f.isBuffer = function (e) {
              return !(null == e || !e._isBuffer);
            }, f.compare = function (e, t) {
              if (!f.isBuffer(e) || !f.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
              if (e === t) return 0;

              for (var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i) {
                if (e[i] !== t[i]) {
                  r = e[i], n = t[i];
                  break;
                }
              }

              return r < n ? -1 : n < r ? 1 : 0;
            }, f.isEncoding = function (e) {
              switch (String(e).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;

                default:
                  return !1;
              }
            }, f.concat = function (e, t) {
              if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
              if (0 === e.length) return f.alloc(0);
              var r;
              if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) {
                t += e[r].length;
              }
              var n = f.allocUnsafe(t),
                  i = 0;

              for (r = 0; r < e.length; ++r) {
                var a = e[r];
                if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                a.copy(n, i), i += a.length;
              }

              return n;
            }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
              var e = this.length;
              if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

              for (var t = 0; t < e; t += 2) {
                m(this, t, t + 1);
              }

              return this;
            }, f.prototype.swap32 = function () {
              var e = this.length;
              if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

              for (var t = 0; t < e; t += 4) {
                m(this, t, t + 3), m(this, t + 1, t + 2);
              }

              return this;
            }, f.prototype.swap64 = function () {
              var e = this.length;
              if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

              for (var t = 0; t < e; t += 8) {
                m(this, t, t + 7), m(this, t + 1, t + 6), m(this, t + 2, t + 5), m(this, t + 3, t + 4);
              }

              return this;
            }, f.prototype.toString = function () {
              var e = 0 | this.length;
              return 0 === e ? "" : 0 === arguments.length ? M(this, 0, e) : b.apply(this, arguments);
            }, f.prototype.equals = function (e) {
              if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
              return this === e || 0 === f.compare(this, e);
            }, f.prototype.inspect = function () {
              var e = "",
                  r = t.INSPECT_MAX_BYTES;
              return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
            }, f.prototype.compare = function (e, t, r, n, i) {
              if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
              if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
              if (n >= i && t >= r) return 0;
              if (n >= i) return -1;
              if (t >= r) return 1;
              if (this === e) return 0;

              for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), s = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), d = 0; d < s; ++d) {
                if (c[d] !== u[d]) {
                  o = c[d], a = u[d];
                  break;
                }
              }

              return o < a ? -1 : a < o ? 1 : 0;
            }, f.prototype.includes = function (e, t, r) {
              return -1 !== this.indexOf(e, t, r);
            }, f.prototype.indexOf = function (e, t, r) {
              return y(this, e, t, r, !0);
            }, f.prototype.lastIndexOf = function (e, t, r) {
              return y(this, e, t, r, !1);
            }, f.prototype.write = function (e, t, r, n) {
              if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
                if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
              }
              var i = this.length - t;
              if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
              n || (n = "utf8");

              for (var o = !1;;) {
                switch (n) {
                  case "hex":
                    return g(this, e, t, r);

                  case "utf8":
                  case "utf-8":
                    return _(this, e, t, r);

                  case "ascii":
                    return w(this, e, t, r);

                  case "latin1":
                  case "binary":
                    return k(this, e, t, r);

                  case "base64":
                    return E(this, e, t, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return A(this, e, t, r);

                  default:
                    if (o) throw new TypeError("Unknown encoding: " + n);
                    n = ("" + n).toLowerCase(), o = !0;
                }
              }
            }, f.prototype.toJSON = function () {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            }, f.prototype.slice = function (e, t) {
              var r,
                  n = this.length;
              if ((e = ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), (t = void 0 === t ? n : ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(e, t)).__proto__ = f.prototype;else {
                var i = t - e;
                r = new f(i, void 0);

                for (var o = 0; o < i; ++o) {
                  r[o] = this[o + e];
                }
              }
              return r;
            }, f.prototype.readUIntLE = function (e, t, r) {
              e |= 0, t |= 0, r || R(e, t, this.length);

              for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
                n += this[e + o] * i;
              }

              return n;
            }, f.prototype.readUIntBE = function (e, t, r) {
              e |= 0, t |= 0, r || R(e, t, this.length);

              for (var n = this[e + --t], i = 1; t > 0 && (i *= 256);) {
                n += this[e + --t] * i;
              }

              return n;
            }, f.prototype.readUInt8 = function (e, t) {
              return t || R(e, 1, this.length), this[e];
            }, f.prototype.readUInt16LE = function (e, t) {
              return t || R(e, 2, this.length), this[e] | this[e + 1] << 8;
            }, f.prototype.readUInt16BE = function (e, t) {
              return t || R(e, 2, this.length), this[e] << 8 | this[e + 1];
            }, f.prototype.readUInt32LE = function (e, t) {
              return t || R(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
            }, f.prototype.readUInt32BE = function (e, t) {
              return t || R(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
            }, f.prototype.readIntLE = function (e, t, r) {
              e |= 0, t |= 0, r || R(e, t, this.length);

              for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
                n += this[e + o] * i;
              }

              return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
            }, f.prototype.readIntBE = function (e, t, r) {
              e |= 0, t |= 0, r || R(e, t, this.length);

              for (var n = t, i = 1, o = this[e + --n]; n > 0 && (i *= 256);) {
                o += this[e + --n] * i;
              }

              return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
            }, f.prototype.readInt8 = function (e, t) {
              return t || R(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
            }, f.prototype.readInt16LE = function (e, t) {
              t || R(e, 2, this.length);
              var r = this[e] | this[e + 1] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, f.prototype.readInt16BE = function (e, t) {
              t || R(e, 2, this.length);
              var r = this[e + 1] | this[e] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, f.prototype.readInt32LE = function (e, t) {
              return t || R(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
            }, f.prototype.readInt32BE = function (e, t) {
              return t || R(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
            }, f.prototype.readFloatLE = function (e, t) {
              return t || R(e, 4, this.length), i.read(this, e, !0, 23, 4);
            }, f.prototype.readFloatBE = function (e, t) {
              return t || R(e, 4, this.length), i.read(this, e, !1, 23, 4);
            }, f.prototype.readDoubleLE = function (e, t) {
              return t || R(e, 8, this.length), i.read(this, e, !0, 52, 8);
            }, f.prototype.readDoubleBE = function (e, t) {
              return t || R(e, 8, this.length), i.read(this, e, !1, 52, 8);
            }, f.prototype.writeUIntLE = function (e, t, r, n) {
              e = +e, t |= 0, r |= 0, n || P(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
              var i = 1,
                  o = 0;

              for (this[t] = 255 & e; ++o < r && (i *= 256);) {
                this[t + o] = e / i & 255;
              }

              return t + r;
            }, f.prototype.writeUIntBE = function (e, t, r, n) {
              e = +e, t |= 0, r |= 0, n || P(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
              var i = r - 1,
                  o = 1;

              for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
                this[t + i] = e / o & 255;
              }

              return t + r;
            }, f.prototype.writeUInt8 = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
            }, f.prototype.writeUInt16LE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : T(this, e, t, !0), t + 2;
            }, f.prototype.writeUInt16BE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : T(this, e, t, !1), t + 2;
            }, f.prototype.writeUInt32LE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : L(this, e, t, !0), t + 4;
            }, f.prototype.writeUInt32BE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4;
            }, f.prototype.writeIntLE = function (e, t, r, n) {
              if (e = +e, t |= 0, !n) {
                var i = Math.pow(2, 8 * r - 1);
                P(this, e, t, r, i - 1, -i);
              }

              var o = 0,
                  a = 1,
                  s = 0;

              for (this[t] = 255 & e; ++o < r && (a *= 256);) {
                e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
              }

              return t + r;
            }, f.prototype.writeIntBE = function (e, t, r, n) {
              if (e = +e, t |= 0, !n) {
                var i = Math.pow(2, 8 * r - 1);
                P(this, e, t, r, i - 1, -i);
              }

              var o = r - 1,
                  a = 1,
                  s = 0;

              for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) {
                e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
              }

              return t + r;
            }, f.prototype.writeInt8 = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
            }, f.prototype.writeInt16LE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : T(this, e, t, !0), t + 2;
            }, f.prototype.writeInt16BE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : T(this, e, t, !1), t + 2;
            }, f.prototype.writeInt32LE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : L(this, e, t, !0), t + 4;
            }, f.prototype.writeInt32BE = function (e, t, r) {
              return e = +e, t |= 0, r || P(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4;
            }, f.prototype.writeFloatLE = function (e, t, r) {
              return O(this, e, t, !0, r);
            }, f.prototype.writeFloatBE = function (e, t, r) {
              return O(this, e, t, !1, r);
            }, f.prototype.writeDoubleLE = function (e, t, r) {
              return N(this, e, t, !0, r);
            }, f.prototype.writeDoubleBE = function (e, t, r) {
              return N(this, e, t, !1, r);
            }, f.prototype.copy = function (e, t, r, n) {
              if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
              if (0 === e.length || 0 === this.length) return 0;
              if (t < 0) throw new RangeError("targetStart out of bounds");
              if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
              if (n < 0) throw new RangeError("sourceEnd out of bounds");
              n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
              var i,
                  o = n - r;
              if (this === e && r < t && t < n) for (i = o - 1; i >= 0; --i) {
                e[i + t] = this[i + r];
              } else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
                e[i + t] = this[i + r];
              } else Uint8Array.prototype.set.call(e, this.subarray(r, r + o), t);
              return o;
            }, f.prototype.fill = function (e, t, r, n) {
              if ("string" == typeof e) {
                if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
                  var i = e.charCodeAt(0);
                  i < 256 && (e = i);
                }

                if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
              } else "number" == typeof e && (e &= 255);

              if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
              if (r <= t) return this;
              var o;
              if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < r; ++o) {
                this[o] = e;
              } else {
                var a = f.isBuffer(e) ? e : D(new f(e, n).toString()),
                    s = a.length;

                for (o = 0; o < r - t; ++o) {
                  this[o + t] = a[o % s];
                }
              }
              return this;
            };
            var U = /[^+\/0-9A-Za-z-_]/g;

            function D(e, t) {
              var r;
              t = t || 1 / 0;

              for (var n = e.length, i = null, o = [], a = 0; a < n; ++a) {
                if ((r = e.charCodeAt(a)) > 55295 && r < 57344) {
                  if (!i) {
                    if (r > 56319) {
                      (t -= 3) > -1 && o.push(239, 191, 189);
                      continue;
                    }

                    if (a + 1 === n) {
                      (t -= 3) > -1 && o.push(239, 191, 189);
                      continue;
                    }

                    i = r;
                    continue;
                  }

                  if (r < 56320) {
                    (t -= 3) > -1 && o.push(239, 191, 189), i = r;
                    continue;
                  }

                  r = 65536 + (i - 55296 << 10 | r - 56320);
                } else i && (t -= 3) > -1 && o.push(239, 191, 189);

                if (i = null, r < 128) {
                  if ((t -= 1) < 0) break;
                  o.push(r);
                } else if (r < 2048) {
                  if ((t -= 2) < 0) break;
                  o.push(r >> 6 | 192, 63 & r | 128);
                } else if (r < 65536) {
                  if ((t -= 3) < 0) break;
                  o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                } else {
                  if (!(r < 1114112)) throw new Error("Invalid code point");
                  if ((t -= 4) < 0) break;
                  o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                }
              }

              return o;
            }

            function q(e) {
              return n.toByteArray(function (e) {
                if ((e = function (e) {
                  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
                }(e).replace(U, "")).length < 2) return "";

                for (; e.length % 4 != 0;) {
                  e += "=";
                }

                return e;
              }(e));
            }

            function z(e, t, r, n) {
              for (var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i) {
                t[i + r] = e[i];
              }

              return i;
            }
          }).call(this, r(
          /*! ./../webpack/buildin/global.js */
          "./node_modules/webpack/buildin/global.js"));
        },
        "./node_modules/cipher-base/index.js":
        /*!*******************************************!*\
          !*** ./node_modules/cipher-base/index.js ***!
          \*******************************************/

        /*! no static exports found */
        function node_modulesCipherBaseIndexJs(e, t, r) {
          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              i = r(
          /*! stream */
          "./node_modules/stream-browserify/index.js").Transform,
              o = r(
          /*! string_decoder */
          "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;

          function a(e) {
            i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
          }

          r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js")(a, i), a.prototype.update = function (e, t, r) {
            "string" == typeof e && (e = n.from(e, t));

            var i = this._update(e);

            return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
          }, a.prototype.setAutoPadding = function () {}, a.prototype.getAuthTag = function () {
            throw new Error("trying to get auth tag in unsupported state");
          }, a.prototype.setAuthTag = function () {
            throw new Error("trying to set auth tag in unsupported state");
          }, a.prototype.setAAD = function () {
            throw new Error("trying to set aad in unsupported state");
          }, a.prototype._transform = function (e, t, r) {
            var n;

            try {
              this.hashMode ? this._update(e) : this.push(this._update(e));
            } catch (e) {
              n = e;
            } finally {
              r(n);
            }
          }, a.prototype._flush = function (e) {
            var t;

            try {
              this.push(this.__final());
            } catch (e) {
              t = e;
            }

            e(t);
          }, a.prototype._finalOrDigest = function (e) {
            var t = this.__final() || n.alloc(0);
            return e && (t = this._toString(t, e, !0)), t;
          }, a.prototype._toString = function (e, t, r) {
            if (this._decoder || (this._decoder = new o(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");

            var n = this._decoder.write(e);

            return r && (n += this._decoder.end()), n;
          }, e.exports = a;
        },
        "./node_modules/core-util-is/lib/util.js":
        /*!***********************************************!*\
          !*** ./node_modules/core-util-is/lib/util.js ***!
          \***********************************************/

        /*! no static exports found */
        function node_modulesCoreUtilIsLibUtilJs(e, t, r) {
          (function (e) {
            function r(e) {
              return Object.prototype.toString.call(e);
            }

            t.isArray = function (e) {
              return Array.isArray ? Array.isArray(e) : "[object Array]" === r(e);
            }, t.isBoolean = function (e) {
              return "boolean" == typeof e;
            }, t.isNull = function (e) {
              return null === e;
            }, t.isNullOrUndefined = function (e) {
              return null == e;
            }, t.isNumber = function (e) {
              return "number" == typeof e;
            }, t.isString = function (e) {
              return "string" == typeof e;
            }, t.isSymbol = function (e) {
              return "symbol" == typeof e;
            }, t.isUndefined = function (e) {
              return void 0 === e;
            }, t.isRegExp = function (e) {
              return "[object RegExp]" === r(e);
            }, t.isObject = function (e) {
              return "object" == typeof e && null !== e;
            }, t.isDate = function (e) {
              return "[object Date]" === r(e);
            }, t.isError = function (e) {
              return "[object Error]" === r(e) || e instanceof Error;
            }, t.isFunction = function (e) {
              return "function" == typeof e;
            }, t.isPrimitive = function (e) {
              return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
            }, t.isBuffer = e.isBuffer;
          }).call(this, r(
          /*! ./../../buffer/index.js */
          "./node_modules/buffer/index.js").Buffer);
        },
        "./node_modules/create-hash/browser.js":
        /*!*********************************************!*\
          !*** ./node_modules/create-hash/browser.js ***!
          \*********************************************/

        /*! no static exports found */
        function node_modulesCreateHashBrowserJs(e, t, r) {
          "use strict";

          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! md5.js */
          "./node_modules/md5.js/index.js"),
              o = r(
          /*! ripemd160 */
          "./node_modules/ripemd160/index.js"),
              a = r(
          /*! sha.js */
          "./node_modules/sha.js/index.js"),
              s = r(
          /*! cipher-base */
          "./node_modules/cipher-base/index.js");

          function f(e) {
            s.call(this, "digest"), this._hash = e;
          }

          n(f, s), f.prototype._update = function (e) {
            this._hash.update(e);
          }, f.prototype._final = function () {
            return this._hash.digest();
          }, e.exports = function (e) {
            return "md5" === (e = e.toLowerCase()) ? new i() : "rmd160" === e || "ripemd160" === e ? new o() : new f(a(e));
          };
        },
        "./node_modules/elliptic/lib/elliptic.js":
        /*!***********************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic.js ***!
          \***********************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticJs(e, t, r) {
          "use strict";

          var n = t;
          n.version = r(
          /*! ../package.json */
          "./node_modules/elliptic/package.json").version, n.utils = r(
          /*! ./elliptic/utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"), n.rand = r(
          /*! brorand */
          "./node_modules/brorand/index.js"), n.curve = r(
          /*! ./elliptic/curve */
          "./node_modules/elliptic/lib/elliptic/curve/index.js"), n.curves = r(
          /*! ./elliptic/curves */
          "./node_modules/elliptic/lib/elliptic/curves.js"), n.ec = r(
          /*! ./elliptic/ec */
          "./node_modules/elliptic/lib/elliptic/ec/index.js"), n.eddsa = r(
          /*! ./elliptic/eddsa */
          "./node_modules/elliptic/lib/elliptic/eddsa/index.js");
        },
        "./node_modules/elliptic/lib/elliptic/curve/base.js":
        /*!**********************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/curve/base.js ***!
          \**********************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticCurveBaseJs(e, t, r) {
          "use strict";

          var n = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              i = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              o = i.getNAF,
              a = i.getJSF,
              s = i.assert;

          function f(e, t) {
            this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
            var r = this.n && this.p.div(this.n);
            !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
          }

          function c(e, t) {
            this.curve = e, this.type = t, this.precomputed = null;
          }

          e.exports = f, f.prototype.point = function () {
            throw new Error("Not implemented");
          }, f.prototype.validate = function () {
            throw new Error("Not implemented");
          }, f.prototype._fixedNafMul = function (e, t) {
            s(e.precomputed);

            var r = e._getDoubles(),
                n = o(t, 1, this._bitLength),
                i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);

            i /= 3;

            for (var a = [], f = 0; f < n.length; f += r.step) {
              var c = 0;

              for (t = f + r.step - 1; t >= f; t--) {
                c = (c << 1) + n[t];
              }

              a.push(c);
            }

            for (var u = this.jpoint(null, null, null), d = this.jpoint(null, null, null), h = i; h > 0; h--) {
              for (f = 0; f < a.length; f++) {
                (c = a[f]) === h ? d = d.mixedAdd(r.points[f]) : c === -h && (d = d.mixedAdd(r.points[f].neg()));
              }

              u = u.add(d);
            }

            return u.toP();
          }, f.prototype._wnafMul = function (e, t) {
            var r = 4,
                n = e._getNAFPoints(r);

            r = n.wnd;

            for (var i = n.points, a = o(t, r, this._bitLength), f = this.jpoint(null, null, null), c = a.length - 1; c >= 0; c--) {
              for (t = 0; c >= 0 && 0 === a[c]; c--) {
                t++;
              }

              if (c >= 0 && t++, f = f.dblp(t), c < 0) break;
              var u = a[c];
              s(0 !== u), f = "affine" === e.type ? u > 0 ? f.mixedAdd(i[u - 1 >> 1]) : f.mixedAdd(i[-u - 1 >> 1].neg()) : u > 0 ? f.add(i[u - 1 >> 1]) : f.add(i[-u - 1 >> 1].neg());
            }

            return "affine" === e.type ? f.toP() : f;
          }, f.prototype._wnafMulAdd = function (e, t, r, n, i) {
            for (var s = this._wnafT1, f = this._wnafT2, c = this._wnafT3, u = 0, d = 0; d < n; d++) {
              var h = (S = t[d])._getNAFPoints(e);

              s[d] = h.wnd, f[d] = h.points;
            }

            for (d = n - 1; d >= 1; d -= 2) {
              var l = d - 1,
                  p = d;

              if (1 === s[l] && 1 === s[p]) {
                var b = [t[l], null, null, t[p]];
                0 === t[l].y.cmp(t[p].y) ? (b[1] = t[l].add(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg())) : 0 === t[l].y.cmp(t[p].y.redNeg()) ? (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].add(t[p].neg())) : (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg()));
                var m = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
                    y = a(r[l], r[p]);
                u = Math.max(y[0].length, u), c[l] = new Array(u), c[p] = new Array(u);

                for (var v = 0; v < u; v++) {
                  var g = 0 | y[0][v],
                      _ = 0 | y[1][v];

                  c[l][v] = m[3 * (g + 1) + (_ + 1)], c[p][v] = 0, f[l] = b;
                }
              } else c[l] = o(r[l], s[l], this._bitLength), c[p] = o(r[p], s[p], this._bitLength), u = Math.max(c[l].length, u), u = Math.max(c[p].length, u);
            }

            var w = this.jpoint(null, null, null),
                k = this._wnafT4;

            for (d = u; d >= 0; d--) {
              for (var E = 0; d >= 0;) {
                var A = !0;

                for (v = 0; v < n; v++) {
                  k[v] = 0 | c[v][d], 0 !== k[v] && (A = !1);
                }

                if (!A) break;
                E++, d--;
              }

              if (d >= 0 && E++, w = w.dblp(E), d < 0) break;

              for (v = 0; v < n; v++) {
                var S,
                    M = k[v];
                0 !== M && (M > 0 ? S = f[v][M - 1 >> 1] : M < 0 && (S = f[v][-M - 1 >> 1].neg()), w = "affine" === S.type ? w.mixedAdd(S) : w.add(S));
              }
            }

            for (d = 0; d < n; d++) {
              f[d] = null;
            }

            return i ? w : w.toP();
          }, f.BasePoint = c, c.prototype.eq = function () {
            throw new Error("Not implemented");
          }, c.prototype.validate = function () {
            return this.curve.validate(this);
          }, f.prototype.decodePoint = function (e, t) {
            e = i.toArray(e, t);
            var r = this.p.byteLength();
            if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? s(e[e.length - 1] % 2 == 0) : 7 === e[0] && s(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
            if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
            throw new Error("Unknown point format");
          }, c.prototype.encodeCompressed = function (e) {
            return this.encode(e, !0);
          }, c.prototype._encode = function (e) {
            var t = this.curve.p.byteLength(),
                r = this.getX().toArray("be", t);
            return e ? [this.getY().isEven() ? 2 : 3].concat(r) : [4].concat(r, this.getY().toArray("be", t));
          }, c.prototype.encode = function (e, t) {
            return i.encode(this._encode(t), e);
          }, c.prototype.precompute = function (e) {
            if (this.precomputed) return this;
            var t = {
              doubles: null,
              naf: null,
              beta: null
            };
            return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
          }, c.prototype._hasDoubles = function (e) {
            if (!this.precomputed) return !1;
            var t = this.precomputed.doubles;
            return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
          }, c.prototype._getDoubles = function (e, t) {
            if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

            for (var r = [this], n = this, i = 0; i < t; i += e) {
              for (var o = 0; o < e; o++) {
                n = n.dbl();
              }

              r.push(n);
            }

            return {
              step: e,
              points: r
            };
          }, c.prototype._getNAFPoints = function (e) {
            if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

            for (var t = [this], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++) {
              t[i] = t[i - 1].add(n);
            }

            return {
              wnd: e,
              points: t
            };
          }, c.prototype._getBeta = function () {
            return null;
          }, c.prototype.dblp = function (e) {
            for (var t = this, r = 0; r < e; r++) {
              t = t.dbl();
            }

            return t;
          };
        },
        "./node_modules/elliptic/lib/elliptic/curve/edwards.js":
        /*!*************************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/curve/edwards.js ***!
          \*************************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticCurveEdwardsJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              i = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              o = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              a = r(
          /*! ./base */
          "./node_modules/elliptic/lib/elliptic/curve/base.js"),
              s = n.assert;

          function f(e) {
            this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, a.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), s(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
          }

          function c(e, t, r, n, o) {
            a.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = o && new i(o, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
          }

          o(f, a), e.exports = f, f.prototype._mulA = function (e) {
            return this.mOneA ? e.redNeg() : this.a.redMul(e);
          }, f.prototype._mulC = function (e) {
            return this.oneC ? e : this.c.redMul(e);
          }, f.prototype.jpoint = function (e, t, r, n) {
            return this.point(e, t, r, n);
          }, f.prototype.pointFromX = function (e, t) {
            (e = new i(e, 16)).red || (e = e.toRed(this.red));
            var r = e.redSqr(),
                n = this.c2.redSub(this.a.redMul(r)),
                o = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
                a = n.redMul(o.redInvm()),
                s = a.redSqrt();
            if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
            var f = s.fromRed().isOdd();
            return (t && !f || !t && f) && (s = s.redNeg()), this.point(e, s);
          }, f.prototype.pointFromY = function (e, t) {
            (e = new i(e, 16)).red || (e = e.toRed(this.red));
            var r = e.redSqr(),
                n = r.redSub(this.c2),
                o = r.redMul(this.d).redMul(this.c2).redSub(this.a),
                a = n.redMul(o.redInvm());

            if (0 === a.cmp(this.zero)) {
              if (t) throw new Error("invalid point");
              return this.point(this.zero, e);
            }

            var s = a.redSqrt();
            if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
            return s.fromRed().isOdd() !== t && (s = s.redNeg()), this.point(s, e);
          }, f.prototype.validate = function (e) {
            if (e.isInfinity()) return !0;
            e.normalize();
            var t = e.x.redSqr(),
                r = e.y.redSqr(),
                n = t.redMul(this.a).redAdd(r),
                i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
            return 0 === n.cmp(i);
          }, o(c, a.BasePoint), f.prototype.pointFromJSON = function (e) {
            return c.fromJSON(this, e);
          }, f.prototype.point = function (e, t, r, n) {
            return new c(this, e, t, r, n);
          }, c.fromJSON = function (e, t) {
            return new c(e, t[0], t[1], t[2]);
          }, c.prototype.inspect = function () {
            return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
          }, c.prototype.isInfinity = function () {
            return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
          }, c.prototype._extDbl = function () {
            var e = this.x.redSqr(),
                t = this.y.redSqr(),
                r = this.z.redSqr();
            r = r.redIAdd(r);

            var n = this.curve._mulA(e),
                i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
                o = n.redAdd(t),
                a = o.redSub(r),
                s = n.redSub(t),
                f = i.redMul(a),
                c = o.redMul(s),
                u = i.redMul(s),
                d = a.redMul(o);

            return this.curve.point(f, c, d, u);
          }, c.prototype._projDbl = function () {
            var e,
                t,
                r,
                n = this.x.redAdd(this.y).redSqr(),
                i = this.x.redSqr(),
                o = this.y.redSqr();

            if (this.curve.twisted) {
              var a = (c = this.curve._mulA(i)).redAdd(o);

              if (this.zOne) e = n.redSub(i).redSub(o).redMul(a.redSub(this.curve.two)), t = a.redMul(c.redSub(o)), r = a.redSqr().redSub(a).redSub(a);else {
                var s = this.z.redSqr(),
                    f = a.redSub(s).redISub(s);
                e = n.redSub(i).redISub(o).redMul(f), t = a.redMul(c.redSub(o)), r = a.redMul(f);
              }
            } else {
              var c = i.redAdd(o);
              s = this.curve._mulC(this.z).redSqr(), f = c.redSub(s).redSub(s), e = this.curve._mulC(n.redISub(c)).redMul(f), t = this.curve._mulC(c).redMul(i.redISub(o)), r = c.redMul(f);
            }

            return this.curve.point(e, t, r);
          }, c.prototype.dbl = function () {
            return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
          }, c.prototype._extAdd = function (e) {
            var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
                r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
                n = this.t.redMul(this.curve.dd).redMul(e.t),
                i = this.z.redMul(e.z.redAdd(e.z)),
                o = r.redSub(t),
                a = i.redSub(n),
                s = i.redAdd(n),
                f = r.redAdd(t),
                c = o.redMul(a),
                u = s.redMul(f),
                d = o.redMul(f),
                h = a.redMul(s);
            return this.curve.point(c, u, h, d);
          }, c.prototype._projAdd = function (e) {
            var t,
                r,
                n = this.z.redMul(e.z),
                i = n.redSqr(),
                o = this.x.redMul(e.x),
                a = this.y.redMul(e.y),
                s = this.curve.d.redMul(o).redMul(a),
                f = i.redSub(s),
                c = i.redAdd(s),
                u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),
                d = n.redMul(f).redMul(u);
            return this.curve.twisted ? (t = n.redMul(c).redMul(a.redSub(this.curve._mulA(o))), r = f.redMul(c)) : (t = n.redMul(c).redMul(a.redSub(o)), r = this.curve._mulC(f).redMul(c)), this.curve.point(d, t, r);
          }, c.prototype.add = function (e) {
            return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
          }, c.prototype.mul = function (e) {
            return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
          }, c.prototype.mulAdd = function (e, t, r) {
            return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !1);
          }, c.prototype.jmulAdd = function (e, t, r) {
            return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !0);
          }, c.prototype.normalize = function () {
            if (this.zOne) return this;
            var e = this.z.redInvm();
            return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
          }, c.prototype.neg = function () {
            return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
          }, c.prototype.getX = function () {
            return this.normalize(), this.x.fromRed();
          }, c.prototype.getY = function () {
            return this.normalize(), this.y.fromRed();
          }, c.prototype.eq = function (e) {
            return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
          }, c.prototype.eqXToP = function (e) {
            var t = e.toRed(this.curve.red).redMul(this.z);
            if (0 === this.x.cmp(t)) return !0;

            for (var r = e.clone(), n = this.curve.redN.redMul(this.z);;) {
              if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
              if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
            }
          }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
        },
        "./node_modules/elliptic/lib/elliptic/curve/index.js":
        /*!***********************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/curve/index.js ***!
          \***********************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticCurveIndexJs(e, t, r) {
          "use strict";

          var n = t;
          n.base = r(
          /*! ./base */
          "./node_modules/elliptic/lib/elliptic/curve/base.js"), n.short = r(
          /*! ./short */
          "./node_modules/elliptic/lib/elliptic/curve/short.js"), n.mont = r(
          /*! ./mont */
          "./node_modules/elliptic/lib/elliptic/curve/mont.js"), n.edwards = r(
          /*! ./edwards */
          "./node_modules/elliptic/lib/elliptic/curve/edwards.js");
        },
        "./node_modules/elliptic/lib/elliptic/curve/mont.js":
        /*!**********************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/curve/mont.js ***!
          \**********************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticCurveMontJs(e, t, r) {
          "use strict";

          var n = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              i = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              o = r(
          /*! ./base */
          "./node_modules/elliptic/lib/elliptic/curve/base.js"),
              a = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js");

          function s(e) {
            o.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
          }

          function f(e, t, r) {
            o.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
          }

          i(s, o), e.exports = s, s.prototype.validate = function (e) {
            var t = e.normalize().x,
                r = t.redSqr(),
                n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
            return 0 === n.redSqrt().redSqr().cmp(n);
          }, i(f, o.BasePoint), s.prototype.decodePoint = function (e, t) {
            return this.point(a.toArray(e, t), 1);
          }, s.prototype.point = function (e, t) {
            return new f(this, e, t);
          }, s.prototype.pointFromJSON = function (e) {
            return f.fromJSON(this, e);
          }, f.prototype.precompute = function () {}, f.prototype._encode = function () {
            return this.getX().toArray("be", this.curve.p.byteLength());
          }, f.fromJSON = function (e, t) {
            return new f(e, t[0], t[1] || e.one);
          }, f.prototype.inspect = function () {
            return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
          }, f.prototype.isInfinity = function () {
            return 0 === this.z.cmpn(0);
          }, f.prototype.dbl = function () {
            var e = this.x.redAdd(this.z).redSqr(),
                t = this.x.redSub(this.z).redSqr(),
                r = e.redSub(t),
                n = e.redMul(t),
                i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
            return this.curve.point(n, i);
          }, f.prototype.add = function () {
            throw new Error("Not supported on Montgomery curve");
          }, f.prototype.diffAdd = function (e, t) {
            var r = this.x.redAdd(this.z),
                n = this.x.redSub(this.z),
                i = e.x.redAdd(e.z),
                o = e.x.redSub(e.z).redMul(r),
                a = i.redMul(n),
                s = t.z.redMul(o.redAdd(a).redSqr()),
                f = t.x.redMul(o.redISub(a).redSqr());
            return this.curve.point(s, f);
          }, f.prototype.mul = function (e) {
            for (var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) {
              i.push(t.andln(1));
            }

            for (var o = i.length - 1; o >= 0; o--) {
              0 === i[o] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
            }

            return n;
          }, f.prototype.mulAdd = function () {
            throw new Error("Not supported on Montgomery curve");
          }, f.prototype.jumlAdd = function () {
            throw new Error("Not supported on Montgomery curve");
          }, f.prototype.eq = function (e) {
            return 0 === this.getX().cmp(e.getX());
          }, f.prototype.normalize = function () {
            return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
          }, f.prototype.getX = function () {
            return this.normalize(), this.x.fromRed();
          };
        },
        "./node_modules/elliptic/lib/elliptic/curve/short.js":
        /*!***********************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/curve/short.js ***!
          \***********************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticCurveShortJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              i = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              o = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              a = r(
          /*! ./base */
          "./node_modules/elliptic/lib/elliptic/curve/base.js"),
              s = n.assert;

          function f(e) {
            a.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
          }

          function c(e, t, r, n) {
            a.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
          }

          function u(e, t, r, n) {
            a.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
          }

          o(f, a), e.exports = f, f.prototype._getEndomorphism = function (e) {
            if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
              var t, r;
              if (e.beta) t = new i(e.beta, 16).toRed(this.red);else {
                var n = this._getEndoRoots(this.p);

                t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
              }
              if (e.lambda) r = new i(e.lambda, 16);else {
                var o = this._getEndoRoots(this.n);

                0 === this.g.mul(o[0]).x.cmp(this.g.x.redMul(t)) ? r = o[0] : (r = o[1], s(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
              }
              return {
                beta: t,
                lambda: r,
                basis: e.basis ? e.basis.map(function (e) {
                  return {
                    a: new i(e.a, 16),
                    b: new i(e.b, 16)
                  };
                }) : this._getEndoBasis(r)
              };
            }
          }, f.prototype._getEndoRoots = function (e) {
            var t = e === this.p ? this.red : i.mont(e),
                r = new i(2).toRed(t).redInvm(),
                n = r.redNeg(),
                o = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
            return [n.redAdd(o).fromRed(), n.redSub(o).fromRed()];
          }, f.prototype._getEndoBasis = function (e) {
            for (var t, r, n, o, a, s, f, c, u, d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), h = e, l = this.n.clone(), p = new i(1), b = new i(0), m = new i(0), y = new i(1), v = 0; 0 !== h.cmpn(0);) {
              var g = l.div(h);
              c = l.sub(g.mul(h)), u = m.sub(g.mul(p));

              var _ = y.sub(g.mul(b));

              if (!n && c.cmp(d) < 0) t = f.neg(), r = p, n = c.neg(), o = u;else if (n && 2 == ++v) break;
              f = c, l = h, h = c, m = p, p = u, y = b, b = _;
            }

            a = c.neg(), s = u;
            var w = n.sqr().add(o.sqr());
            return a.sqr().add(s.sqr()).cmp(w) >= 0 && (a = t, s = r), n.negative && (n = n.neg(), o = o.neg()), a.negative && (a = a.neg(), s = s.neg()), [{
              a: n,
              b: o
            }, {
              a: a,
              b: s
            }];
          }, f.prototype._endoSplit = function (e) {
            var t = this.endo.basis,
                r = t[0],
                n = t[1],
                i = n.b.mul(e).divRound(this.n),
                o = r.b.neg().mul(e).divRound(this.n),
                a = i.mul(r.a),
                s = o.mul(n.a),
                f = i.mul(r.b),
                c = o.mul(n.b);
            return {
              k1: e.sub(a).sub(s),
              k2: f.add(c).neg()
            };
          }, f.prototype.pointFromX = function (e, t) {
            (e = new i(e, 16)).red || (e = e.toRed(this.red));
            var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
                n = r.redSqrt();
            if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
            var o = n.fromRed().isOdd();
            return (t && !o || !t && o) && (n = n.redNeg()), this.point(e, n);
          }, f.prototype.validate = function (e) {
            if (e.inf) return !0;
            var t = e.x,
                r = e.y,
                n = this.a.redMul(t),
                i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
            return 0 === r.redSqr().redISub(i).cmpn(0);
          }, f.prototype._endoWnafMulAdd = function (e, t, r) {
            for (var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++) {
              var a = this._endoSplit(t[o]),
                  s = e[o],
                  f = s._getBeta();

              a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), f = f.neg(!0)), n[2 * o] = s, n[2 * o + 1] = f, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
            }

            for (var c = this._wnafMulAdd(1, n, i, 2 * o, r), u = 0; u < 2 * o; u++) {
              n[u] = null, i[u] = null;
            }

            return c;
          }, o(c, a.BasePoint), f.prototype.point = function (e, t, r) {
            return new c(this, e, t, r);
          }, f.prototype.pointFromJSON = function (e, t) {
            return c.fromJSON(this, e, t);
          }, c.prototype._getBeta = function () {
            if (this.curve.endo) {
              var e = this.precomputed;
              if (e && e.beta) return e.beta;
              var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

              if (e) {
                var r = this.curve,
                    n = function n(e) {
                  return r.point(e.x.redMul(r.endo.beta), e.y);
                };

                e.beta = t, t.precomputed = {
                  beta: null,
                  naf: e.naf && {
                    wnd: e.naf.wnd,
                    points: e.naf.points.map(n)
                  },
                  doubles: e.doubles && {
                    step: e.doubles.step,
                    points: e.doubles.points.map(n)
                  }
                };
              }

              return t;
            }
          }, c.prototype.toJSON = function () {
            return this.precomputed ? [this.x, this.y, this.precomputed && {
              doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
              },
              naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
              }
            }] : [this.x, this.y];
          }, c.fromJSON = function (e, t, r) {
            "string" == typeof t && (t = JSON.parse(t));
            var n = e.point(t[0], t[1], r);
            if (!t[2]) return n;

            function i(t) {
              return e.point(t[0], t[1], r);
            }

            var o = t[2];
            return n.precomputed = {
              beta: null,
              doubles: o.doubles && {
                step: o.doubles.step,
                points: [n].concat(o.doubles.points.map(i))
              },
              naf: o.naf && {
                wnd: o.naf.wnd,
                points: [n].concat(o.naf.points.map(i))
              }
            }, n;
          }, c.prototype.inspect = function () {
            return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
          }, c.prototype.isInfinity = function () {
            return this.inf;
          }, c.prototype.add = function (e) {
            if (this.inf) return e;
            if (e.inf) return this;
            if (this.eq(e)) return this.dbl();
            if (this.neg().eq(e)) return this.curve.point(null, null);
            if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
            var t = this.y.redSub(e.y);
            0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
            var r = t.redSqr().redISub(this.x).redISub(e.x),
                n = t.redMul(this.x.redSub(r)).redISub(this.y);
            return this.curve.point(r, n);
          }, c.prototype.dbl = function () {
            if (this.inf) return this;
            var e = this.y.redAdd(this.y);
            if (0 === e.cmpn(0)) return this.curve.point(null, null);
            var t = this.curve.a,
                r = this.x.redSqr(),
                n = e.redInvm(),
                i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n),
                o = i.redSqr().redISub(this.x.redAdd(this.x)),
                a = i.redMul(this.x.redSub(o)).redISub(this.y);
            return this.curve.point(o, a);
          }, c.prototype.getX = function () {
            return this.x.fromRed();
          }, c.prototype.getY = function () {
            return this.y.fromRed();
          }, c.prototype.mul = function (e) {
            return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
          }, c.prototype.mulAdd = function (e, t, r) {
            var n = [this, t],
                i = [e, r];
            return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
          }, c.prototype.jmulAdd = function (e, t, r) {
            var n = [this, t],
                i = [e, r];
            return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
          }, c.prototype.eq = function (e) {
            return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
          }, c.prototype.neg = function (e) {
            if (this.inf) return this;
            var t = this.curve.point(this.x, this.y.redNeg());

            if (e && this.precomputed) {
              var r = this.precomputed,
                  n = function n(e) {
                return e.neg();
              };

              t.precomputed = {
                naf: r.naf && {
                  wnd: r.naf.wnd,
                  points: r.naf.points.map(n)
                },
                doubles: r.doubles && {
                  step: r.doubles.step,
                  points: r.doubles.points.map(n)
                }
              };
            }

            return t;
          }, c.prototype.toJ = function () {
            return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
          }, o(u, a.BasePoint), f.prototype.jpoint = function (e, t, r) {
            return new u(this, e, t, r);
          }, u.prototype.toP = function () {
            if (this.isInfinity()) return this.curve.point(null, null);
            var e = this.z.redInvm(),
                t = e.redSqr(),
                r = this.x.redMul(t),
                n = this.y.redMul(t).redMul(e);
            return this.curve.point(r, n);
          }, u.prototype.neg = function () {
            return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
          }, u.prototype.add = function (e) {
            if (this.isInfinity()) return e;
            if (e.isInfinity()) return this;
            var t = e.z.redSqr(),
                r = this.z.redSqr(),
                n = this.x.redMul(t),
                i = e.x.redMul(r),
                o = this.y.redMul(t.redMul(e.z)),
                a = e.y.redMul(r.redMul(this.z)),
                s = n.redSub(i),
                f = o.redSub(a);
            if (0 === s.cmpn(0)) return 0 !== f.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
            var c = s.redSqr(),
                u = c.redMul(s),
                d = n.redMul(c),
                h = f.redSqr().redIAdd(u).redISub(d).redISub(d),
                l = f.redMul(d.redISub(h)).redISub(o.redMul(u)),
                p = this.z.redMul(e.z).redMul(s);
            return this.curve.jpoint(h, l, p);
          }, u.prototype.mixedAdd = function (e) {
            if (this.isInfinity()) return e.toJ();
            if (e.isInfinity()) return this;
            var t = this.z.redSqr(),
                r = this.x,
                n = e.x.redMul(t),
                i = this.y,
                o = e.y.redMul(t).redMul(this.z),
                a = r.redSub(n),
                s = i.redSub(o);
            if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
            var f = a.redSqr(),
                c = f.redMul(a),
                u = r.redMul(f),
                d = s.redSqr().redIAdd(c).redISub(u).redISub(u),
                h = s.redMul(u.redISub(d)).redISub(i.redMul(c)),
                l = this.z.redMul(a);
            return this.curve.jpoint(d, h, l);
          }, u.prototype.dblp = function (e) {
            if (0 === e) return this;
            if (this.isInfinity()) return this;
            if (!e) return this.dbl();

            if (this.curve.zeroA || this.curve.threeA) {
              for (var t = this, r = 0; r < e; r++) {
                t = t.dbl();
              }

              return t;
            }

            var n = this.curve.a,
                i = this.curve.tinv,
                o = this.x,
                a = this.y,
                s = this.z,
                f = s.redSqr().redSqr(),
                c = a.redAdd(a);

            for (r = 0; r < e; r++) {
              var u = o.redSqr(),
                  d = c.redSqr(),
                  h = d.redSqr(),
                  l = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(f)),
                  p = o.redMul(d),
                  b = l.redSqr().redISub(p.redAdd(p)),
                  m = p.redISub(b),
                  y = l.redMul(m);
              y = y.redIAdd(y).redISub(h);
              var v = c.redMul(s);
              r + 1 < e && (f = f.redMul(h)), o = b, s = v, c = y;
            }

            return this.curve.jpoint(o, c.redMul(i), s);
          }, u.prototype.dbl = function () {
            return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
          }, u.prototype._zeroDbl = function () {
            var e, t, r;

            if (this.zOne) {
              var n = this.x.redSqr(),
                  i = this.y.redSqr(),
                  o = i.redSqr(),
                  a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
              a = a.redIAdd(a);
              var s = n.redAdd(n).redIAdd(n),
                  f = s.redSqr().redISub(a).redISub(a),
                  c = o.redIAdd(o);
              c = (c = c.redIAdd(c)).redIAdd(c), e = f, t = s.redMul(a.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
            } else {
              var u = this.x.redSqr(),
                  d = this.y.redSqr(),
                  h = d.redSqr(),
                  l = this.x.redAdd(d).redSqr().redISub(u).redISub(h);
              l = l.redIAdd(l);
              var p = u.redAdd(u).redIAdd(u),
                  b = p.redSqr(),
                  m = h.redIAdd(h);
              m = (m = m.redIAdd(m)).redIAdd(m), e = b.redISub(l).redISub(l), t = p.redMul(l.redISub(e)).redISub(m), r = (r = this.y.redMul(this.z)).redIAdd(r);
            }

            return this.curve.jpoint(e, t, r);
          }, u.prototype._threeDbl = function () {
            var e, t, r;

            if (this.zOne) {
              var n = this.x.redSqr(),
                  i = this.y.redSqr(),
                  o = i.redSqr(),
                  a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
              a = a.redIAdd(a);
              var s = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a),
                  f = s.redSqr().redISub(a).redISub(a);
              e = f;
              var c = o.redIAdd(o);
              c = (c = c.redIAdd(c)).redIAdd(c), t = s.redMul(a.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
            } else {
              var u = this.z.redSqr(),
                  d = this.y.redSqr(),
                  h = this.x.redMul(d),
                  l = this.x.redSub(u).redMul(this.x.redAdd(u));
              l = l.redAdd(l).redIAdd(l);
              var p = h.redIAdd(h),
                  b = (p = p.redIAdd(p)).redAdd(p);
              e = l.redSqr().redISub(b), r = this.y.redAdd(this.z).redSqr().redISub(d).redISub(u);
              var m = d.redSqr();
              m = (m = (m = m.redIAdd(m)).redIAdd(m)).redIAdd(m), t = l.redMul(p.redISub(e)).redISub(m);
            }

            return this.curve.jpoint(e, t, r);
          }, u.prototype._dbl = function () {
            var e = this.curve.a,
                t = this.x,
                r = this.y,
                n = this.z,
                i = n.redSqr().redSqr(),
                o = t.redSqr(),
                a = r.redSqr(),
                s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),
                f = t.redAdd(t),
                c = (f = f.redIAdd(f)).redMul(a),
                u = s.redSqr().redISub(c.redAdd(c)),
                d = c.redISub(u),
                h = a.redSqr();
            h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
            var l = s.redMul(d).redISub(h),
                p = r.redAdd(r).redMul(n);
            return this.curve.jpoint(u, l, p);
          }, u.prototype.trpl = function () {
            if (!this.curve.zeroA) return this.dbl().add(this);
            var e = this.x.redSqr(),
                t = this.y.redSqr(),
                r = this.z.redSqr(),
                n = t.redSqr(),
                i = e.redAdd(e).redIAdd(e),
                o = i.redSqr(),
                a = this.x.redAdd(t).redSqr().redISub(e).redISub(n),
                s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
                f = n.redIAdd(n);
            f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
            var c = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(f),
                u = t.redMul(c);
            u = (u = u.redIAdd(u)).redIAdd(u);
            var d = this.x.redMul(s).redISub(u);
            d = (d = d.redIAdd(d)).redIAdd(d);
            var h = this.y.redMul(c.redMul(f.redISub(c)).redISub(a.redMul(s)));
            h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
            var l = this.z.redAdd(a).redSqr().redISub(r).redISub(s);
            return this.curve.jpoint(d, h, l);
          }, u.prototype.mul = function (e, t) {
            return e = new i(e, t), this.curve._wnafMul(this, e);
          }, u.prototype.eq = function (e) {
            if ("affine" === e.type) return this.eq(e.toJ());
            if (this === e) return !0;
            var t = this.z.redSqr(),
                r = e.z.redSqr();
            if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
            var n = t.redMul(this.z),
                i = r.redMul(e.z);
            return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
          }, u.prototype.eqXToP = function (e) {
            var t = this.z.redSqr(),
                r = e.toRed(this.curve.red).redMul(t);
            if (0 === this.x.cmp(r)) return !0;

            for (var n = e.clone(), i = this.curve.redN.redMul(t);;) {
              if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
              if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
            }
          }, u.prototype.inspect = function () {
            return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
          }, u.prototype.isInfinity = function () {
            return 0 === this.z.cmpn(0);
          };
        },
        "./node_modules/elliptic/lib/elliptic/curves.js":
        /*!******************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/curves.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticCurvesJs(e, t, r) {
          "use strict";

          var n,
              i = t,
              o = r(
          /*! hash.js */
          "./node_modules/hash.js/lib/hash.js"),
              a = r(
          /*! ./curve */
          "./node_modules/elliptic/lib/elliptic/curve/index.js"),
              s = r(
          /*! ./utils */
          "./node_modules/elliptic/lib/elliptic/utils.js").assert;

          function f(e) {
            "short" === e.type ? this.curve = new a.short(e) : "edwards" === e.type ? this.curve = new a.edwards(e) : this.curve = new a.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, s(this.g.validate(), "Invalid curve"), s(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
          }

          function c(e, t) {
            Object.defineProperty(i, e, {
              configurable: !0,
              enumerable: !0,
              get: function get() {
                var r = new f(t);
                return Object.defineProperty(i, e, {
                  configurable: !0,
                  enumerable: !0,
                  value: r
                }), r;
              }
            });
          }

          i.PresetCurve = f, c("p192", {
            type: "short",
            prime: "p192",
            p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
            a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
            b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
            n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
            hash: o.sha256,
            gRed: !1,
            g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
          }), c("p224", {
            type: "short",
            prime: "p224",
            p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
            a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
            b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
            n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
            hash: o.sha256,
            gRed: !1,
            g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
          }), c("p256", {
            type: "short",
            prime: null,
            p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
            a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
            b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
            n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
            hash: o.sha256,
            gRed: !1,
            g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
          }), c("p384", {
            type: "short",
            prime: null,
            p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
            a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
            b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
            n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
            hash: o.sha384,
            gRed: !1,
            g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
          }), c("p521", {
            type: "short",
            prime: null,
            p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
            a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
            b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
            n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
            hash: o.sha512,
            gRed: !1,
            g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
          }), c("curve25519", {
            type: "mont",
            prime: "p25519",
            p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "76d06",
            b: "1",
            n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: o.sha256,
            gRed: !1,
            g: ["9"]
          }), c("ed25519", {
            type: "edwards",
            prime: "p25519",
            p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "-1",
            c: "1",
            d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
            n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: o.sha256,
            gRed: !1,
            g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
          });

          try {
            n = r(
            /*! ./precomputed/secp256k1 */
            "./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js");
          } catch (e) {
            n = void 0;
          }

          c("secp256k1", {
            type: "short",
            prime: "k256",
            p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
            a: "0",
            b: "7",
            n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
            h: "1",
            hash: o.sha256,
            beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
            lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
            basis: [{
              a: "3086d221a7d46bcde86c90e49284eb15",
              b: "-e4437ed6010e88286f547fa90abfe4c3"
            }, {
              a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
              b: "3086d221a7d46bcde86c90e49284eb15"
            }],
            gRed: !1,
            g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", n]
          });
        },
        "./node_modules/elliptic/lib/elliptic/ec/index.js":
        /*!********************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/ec/index.js ***!
          \********************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticEcIndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              i = r(
          /*! hmac-drbg */
          "./node_modules/hmac-drbg/lib/hmac-drbg.js"),
              o = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              a = r(
          /*! ../curves */
          "./node_modules/elliptic/lib/elliptic/curves.js"),
              s = r(
          /*! brorand */
          "./node_modules/brorand/index.js"),
              f = o.assert,
              c = r(
          /*! ./key */
          "./node_modules/elliptic/lib/elliptic/ec/key.js"),
              u = r(
          /*! ./signature */
          "./node_modules/elliptic/lib/elliptic/ec/signature.js");

          function d(e) {
            if (!(this instanceof d)) return new d(e);
            "string" == typeof e && (f(a.hasOwnProperty(e), "Unknown curve " + e), e = a[e]), e instanceof a.PresetCurve && (e = {
              curve: e
            }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
          }

          e.exports = d, d.prototype.keyPair = function (e) {
            return new c(this, e);
          }, d.prototype.keyFromPrivate = function (e, t) {
            return c.fromPrivate(this, e, t);
          }, d.prototype.keyFromPublic = function (e, t) {
            return c.fromPublic(this, e, t);
          }, d.prototype.genKeyPair = function (e) {
            e || (e = {});

            for (var t = new i({
              hash: this.hash,
              pers: e.pers,
              persEnc: e.persEnc || "utf8",
              entropy: e.entropy || s(this.hash.hmacStrength),
              entropyEnc: e.entropy && e.entropyEnc || "utf8",
              nonce: this.n.toArray()
            }), r = this.n.byteLength(), o = this.n.sub(new n(2));;) {
              var a = new n(t.generate(r));
              if (!(a.cmp(o) > 0)) return a.iaddn(1), this.keyFromPrivate(a);
            }
          }, d.prototype._truncateToN = function (e, t) {
            var r = 8 * e.byteLength() - this.n.bitLength();
            return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
          }, d.prototype.sign = function (e, t, r, o) {
            "object" == typeof r && (o = r, r = null), o || (o = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));

            for (var a = this.n.byteLength(), s = t.getPrivate().toArray("be", a), f = e.toArray("be", a), c = new i({
              hash: this.hash,
              entropy: s,
              nonce: f,
              pers: o.pers,
              persEnc: o.persEnc || "utf8"
            }), d = this.n.sub(new n(1)), h = 0;; h++) {
              var l = o.k ? o.k(h) : new n(c.generate(this.n.byteLength()));

              if (!((l = this._truncateToN(l, !0)).cmpn(1) <= 0 || l.cmp(d) >= 0)) {
                var p = this.g.mul(l);

                if (!p.isInfinity()) {
                  var b = p.getX(),
                      m = b.umod(this.n);

                  if (0 !== m.cmpn(0)) {
                    var y = l.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));

                    if (0 !== (y = y.umod(this.n)).cmpn(0)) {
                      var v = (p.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(m) ? 2 : 0);
                      return o.canonical && y.cmp(this.nh) > 0 && (y = this.n.sub(y), v ^= 1), new u({
                        r: m,
                        s: y,
                        recoveryParam: v
                      });
                    }
                  }
                }
              }
            }
          }, d.prototype.verify = function (e, t, r, i) {
            e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
            var o = (t = new u(t, "hex")).r,
                a = t.s;
            if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
            if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
            var s,
                f = a.invm(this.n),
                c = f.mul(e).umod(this.n),
                d = f.mul(o).umod(this.n);
            return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(c, r.getPublic(), d)).isInfinity() && s.eqXToP(o) : !(s = this.g.mulAdd(c, r.getPublic(), d)).isInfinity() && 0 === s.getX().umod(this.n).cmp(o);
          }, d.prototype.recoverPubKey = function (e, t, r, i) {
            f((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
            var o = this.n,
                a = new n(e),
                s = t.r,
                c = t.s,
                d = 1 & r,
                h = r >> 1;
            if (s.cmp(this.curve.p.umod(this.curve.n)) >= 0 && h) throw new Error("Unable to find sencond key candinate");
            s = h ? this.curve.pointFromX(s.add(this.curve.n), d) : this.curve.pointFromX(s, d);
            var l = t.r.invm(o),
                p = o.sub(a).mul(l).umod(o),
                b = c.mul(l).umod(o);
            return this.g.mulAdd(p, s, b);
          }, d.prototype.getKeyRecoveryParam = function (e, t, r, n) {
            if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;

            for (var i = 0; i < 4; i++) {
              var o;

              try {
                o = this.recoverPubKey(e, t, i);
              } catch (e) {
                continue;
              }

              if (o.eq(r)) return i;
            }

            throw new Error("Unable to find valid recovery factor");
          };
        },
        "./node_modules/elliptic/lib/elliptic/ec/key.js":
        /*!******************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/ec/key.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticEcKeyJs(e, t, r) {
          "use strict";

          var n = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              i = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js").assert;

          function o(e, t) {
            this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
          }

          e.exports = o, o.fromPublic = function (e, t, r) {
            return t instanceof o ? t : new o(e, {
              pub: t,
              pubEnc: r
            });
          }, o.fromPrivate = function (e, t, r) {
            return t instanceof o ? t : new o(e, {
              priv: t,
              privEnc: r
            });
          }, o.prototype.validate = function () {
            var e = this.getPublic();
            return e.isInfinity() ? {
              result: !1,
              reason: "Invalid public key"
            } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
              result: !0,
              reason: null
            } : {
              result: !1,
              reason: "Public key * N != O"
            } : {
              result: !1,
              reason: "Public key is not a point"
            };
          }, o.prototype.getPublic = function (e, t) {
            return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
          }, o.prototype.getPrivate = function (e) {
            return "hex" === e ? this.priv.toString(16, 2) : this.priv;
          }, o.prototype._importPrivate = function (e, t) {
            this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
          }, o.prototype._importPublic = function (e, t) {
            if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
            this.pub = this.ec.curve.decodePoint(e, t);
          }, o.prototype.derive = function (e) {
            return e.mul(this.priv).getX();
          }, o.prototype.sign = function (e, t, r) {
            return this.ec.sign(e, this, t, r);
          }, o.prototype.verify = function (e, t) {
            return this.ec.verify(e, t, this);
          }, o.prototype.inspect = function () {
            return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
          };
        },
        "./node_modules/elliptic/lib/elliptic/ec/signature.js":
        /*!************************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/ec/signature.js ***!
          \************************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticEcSignatureJs(e, t, r) {
          "use strict";

          var n = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              i = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              o = i.assert;

          function a(e, t) {
            if (e instanceof a) return e;
            this._importDER(e, t) || (o(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
          }

          function s() {
            this.place = 0;
          }

          function f(e, t) {
            var r = e[t.place++];
            if (!(128 & r)) return r;

            for (var n = 15 & r, i = 0, o = 0, a = t.place; o < n; o++, a++) {
              i <<= 8, i |= e[a];
            }

            return t.place = a, i;
          }

          function c(e) {
            for (var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;) {
              t++;
            }

            return 0 === t ? e : e.slice(t);
          }

          function u(e, t) {
            if (t < 128) e.push(t);else {
              var r = 1 + (Math.log(t) / Math.LN2 >>> 3);

              for (e.push(128 | r); --r;) {
                e.push(t >>> (r << 3) & 255);
              }

              e.push(t);
            }
          }

          e.exports = a, a.prototype._importDER = function (e, t) {
            e = i.toArray(e, t);
            var r = new s();
            if (48 !== e[r.place++]) return !1;
            if (f(e, r) + r.place !== e.length) return !1;
            if (2 !== e[r.place++]) return !1;
            var o = f(e, r),
                a = e.slice(r.place, o + r.place);
            if (r.place += o, 2 !== e[r.place++]) return !1;
            var c = f(e, r);
            if (e.length !== c + r.place) return !1;
            var u = e.slice(r.place, c + r.place);
            return 0 === a[0] && 128 & a[1] && (a = a.slice(1)), 0 === u[0] && 128 & u[1] && (u = u.slice(1)), this.r = new n(a), this.s = new n(u), this.recoveryParam = null, !0;
          }, a.prototype.toDER = function (e) {
            var t = this.r.toArray(),
                r = this.s.toArray();

            for (128 & t[0] && (t = [0].concat(t)), 128 & r[0] && (r = [0].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);) {
              r = r.slice(1);
            }

            var n = [2];
            u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
            var o = n.concat(r),
                a = [48];
            return u(a, o.length), a = a.concat(o), i.encode(a, e);
          };
        },
        "./node_modules/elliptic/lib/elliptic/eddsa/index.js":
        /*!***********************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/eddsa/index.js ***!
          \***********************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticEddsaIndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! hash.js */
          "./node_modules/hash.js/lib/hash.js"),
              i = r(
          /*! ../curves */
          "./node_modules/elliptic/lib/elliptic/curves.js"),
              o = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              a = o.assert,
              s = o.parseBytes,
              f = r(
          /*! ./key */
          "./node_modules/elliptic/lib/elliptic/eddsa/key.js"),
              c = r(
          /*! ./signature */
          "./node_modules/elliptic/lib/elliptic/eddsa/signature.js");

          function u(e) {
            if (a("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
            e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
          }

          e.exports = u, u.prototype.sign = function (e, t) {
            e = s(e);
            var r = this.keyFromSecret(t),
                n = this.hashInt(r.messagePrefix(), e),
                i = this.g.mul(n),
                o = this.encodePoint(i),
                a = this.hashInt(o, r.pubBytes(), e).mul(r.priv()),
                f = n.add(a).umod(this.curve.n);
            return this.makeSignature({
              R: i,
              S: f,
              Rencoded: o
            });
          }, u.prototype.verify = function (e, t, r) {
            e = s(e), t = this.makeSignature(t);
            var n = this.keyFromPublic(r),
                i = this.hashInt(t.Rencoded(), n.pubBytes(), e),
                o = this.g.mul(t.S());
            return t.R().add(n.pub().mul(i)).eq(o);
          }, u.prototype.hashInt = function () {
            for (var e = this.hash(), t = 0; t < arguments.length; t++) {
              e.update(arguments[t]);
            }

            return o.intFromLE(e.digest()).umod(this.curve.n);
          }, u.prototype.keyFromPublic = function (e) {
            return f.fromPublic(this, e);
          }, u.prototype.keyFromSecret = function (e) {
            return f.fromSecret(this, e);
          }, u.prototype.makeSignature = function (e) {
            return e instanceof c ? e : new c(this, e);
          }, u.prototype.encodePoint = function (e) {
            var t = e.getY().toArray("le", this.encodingLength);
            return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
          }, u.prototype.decodePoint = function (e) {
            var t = (e = o.parseBytes(e)).length - 1,
                r = e.slice(0, t).concat(-129 & e[t]),
                n = 0 != (128 & e[t]),
                i = o.intFromLE(r);
            return this.curve.pointFromY(i, n);
          }, u.prototype.encodeInt = function (e) {
            return e.toArray("le", this.encodingLength);
          }, u.prototype.decodeInt = function (e) {
            return o.intFromLE(e);
          }, u.prototype.isPoint = function (e) {
            return e instanceof this.pointClass;
          };
        },
        "./node_modules/elliptic/lib/elliptic/eddsa/key.js":
        /*!*********************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/eddsa/key.js ***!
          \*********************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticEddsaKeyJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              i = n.assert,
              o = n.parseBytes,
              a = n.cachedProperty;

          function s(e, t) {
            this.eddsa = e, this._secret = o(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = o(t.pub);
          }

          s.fromPublic = function (e, t) {
            return t instanceof s ? t : new s(e, {
              pub: t
            });
          }, s.fromSecret = function (e, t) {
            return t instanceof s ? t : new s(e, {
              secret: t
            });
          }, s.prototype.secret = function () {
            return this._secret;
          }, a(s, "pubBytes", function () {
            return this.eddsa.encodePoint(this.pub());
          }), a(s, "pub", function () {
            return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
          }), a(s, "privBytes", function () {
            var e = this.eddsa,
                t = this.hash(),
                r = e.encodingLength - 1,
                n = t.slice(0, e.encodingLength);
            return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
          }), a(s, "priv", function () {
            return this.eddsa.decodeInt(this.privBytes());
          }), a(s, "hash", function () {
            return this.eddsa.hash().update(this.secret()).digest();
          }), a(s, "messagePrefix", function () {
            return this.hash().slice(this.eddsa.encodingLength);
          }), s.prototype.sign = function (e) {
            return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
          }, s.prototype.verify = function (e, t) {
            return this.eddsa.verify(e, t, this);
          }, s.prototype.getSecret = function (e) {
            return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
          }, s.prototype.getPublic = function (e) {
            return n.encode(this.pubBytes(), e);
          }, e.exports = s;
        },
        "./node_modules/elliptic/lib/elliptic/eddsa/signature.js":
        /*!***************************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/eddsa/signature.js ***!
          \***************************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticEddsaSignatureJs(e, t, r) {
          "use strict";

          var n = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              i = r(
          /*! ../utils */
          "./node_modules/elliptic/lib/elliptic/utils.js"),
              o = i.assert,
              a = i.cachedProperty,
              s = i.parseBytes;

          function f(e, t) {
            this.eddsa = e, "object" != typeof t && (t = s(t)), Array.isArray(t) && (t = {
              R: t.slice(0, e.encodingLength),
              S: t.slice(e.encodingLength)
            }), o(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
          }

          a(f, "S", function () {
            return this.eddsa.decodeInt(this.Sencoded());
          }), a(f, "R", function () {
            return this.eddsa.decodePoint(this.Rencoded());
          }), a(f, "Rencoded", function () {
            return this.eddsa.encodePoint(this.R());
          }), a(f, "Sencoded", function () {
            return this.eddsa.encodeInt(this.S());
          }), f.prototype.toBytes = function () {
            return this.Rencoded().concat(this.Sencoded());
          }, f.prototype.toHex = function () {
            return i.encode(this.toBytes(), "hex").toUpperCase();
          }, e.exports = f;
        },
        "./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js":
        /*!*********************************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js ***!
          \*********************************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticPrecomputedSecp256k1Js(e, t) {
          e.exports = {
            doubles: {
              step: 4,
              points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
            },
            naf: {
              wnd: 7,
              points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
            }
          };
        },
        "./node_modules/elliptic/lib/elliptic/utils.js":
        /*!*****************************************************!*\
          !*** ./node_modules/elliptic/lib/elliptic/utils.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesEllipticLibEllipticUtilsJs(e, t, r) {
          "use strict";

          var n = t,
              i = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              o = r(
          /*! minimalistic-assert */
          "./node_modules/minimalistic-assert/index.js"),
              a = r(
          /*! minimalistic-crypto-utils */
          "./node_modules/minimalistic-crypto-utils/lib/utils.js");
          n.assert = o, n.toArray = a.toArray, n.zero2 = a.zero2, n.toHex = a.toHex, n.encode = a.encode, n.getNAF = function (e, t, r) {
            var n = new Array(Math.max(e.bitLength(), r) + 1);
            n.fill(0);

            for (var i = 1 << t + 1, o = e.clone(), a = 0; a < n.length; a++) {
              var s,
                  f = o.andln(i - 1);
              o.isOdd() ? (s = f > (i >> 1) - 1 ? (i >> 1) - f : f, o.isubn(s)) : s = 0, n[a] = s, o.iushrn(1);
            }

            return n;
          }, n.getJSF = function (e, t) {
            var r = [[], []];
            e = e.clone(), t = t.clone();

            for (var n = 0, i = 0; e.cmpn(-n) > 0 || t.cmpn(-i) > 0;) {
              var o,
                  a,
                  s,
                  f = e.andln(3) + n & 3,
                  c = t.andln(3) + i & 3;
              3 === f && (f = -1), 3 === c && (c = -1), o = 0 == (1 & f) ? 0 : 3 != (s = e.andln(7) + n & 7) && 5 !== s || 2 !== c ? f : -f, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 != (s = t.andln(7) + i & 7) && 5 !== s || 2 !== f ? c : -c, r[1].push(a), 2 * n === o + 1 && (n = 1 - n), 2 * i === a + 1 && (i = 1 - i), e.iushrn(1), t.iushrn(1);
            }

            return r;
          }, n.cachedProperty = function (e, t, r) {
            var n = "_" + t;

            e.prototype[t] = function () {
              return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
            };
          }, n.parseBytes = function (e) {
            return "string" == typeof e ? n.toArray(e, "hex") : e;
          }, n.intFromLE = function (e) {
            return new i(e, "hex", "le");
          };
        },
        "./node_modules/elliptic/package.json":
        /*!********************************************!*\
          !*** ./node_modules/elliptic/package.json ***!
          \********************************************/

        /*! exports provided: _from, _id, _inBundle, _integrity, _location, _phantomChildren, _requested, _requiredBy, _resolved, _shasum, _spec, _where, author, bugs, bundleDependencies, dependencies, deprecated, description, devDependencies, files, homepage, keywords, license, main, name, repository, scripts, version, default */
        function node_modulesEllipticPackageJson(e) {
          e.exports = JSON.parse('{"_from":"elliptic@^6.0.0","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_shasum":"05c5678d7173c049d8ca433552224a495d0e3762","_spec":"elliptic@^6.0.0","_where":"/Users/thi/gh/Documents/GitHub/icetea-common/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}');
        },
        "./node_modules/event-lite/event-lite.js":
        /*!***********************************************!*\
          !*** ./node_modules/event-lite/event-lite.js ***!
          \***********************************************/

        /*! no static exports found */
        function node_modulesEventLiteEventLiteJs(e, t, r) {
          !function (t) {
            e.exports = t;
            var r = {
              on: function on(e, t) {
                return o(this, e).push(t), this;
              },
              once: function once(e, t) {
                var r = this;
                return n.originalListener = t, o(r, e).push(n), r;

                function n() {
                  i.call(r, e, n), t.apply(this, arguments);
                }
              },
              off: i,
              emit: function emit(e, t) {
                var r = this,
                    n = o(r, e, !0);
                if (!n) return !1;
                var i = arguments.length;
                if (1 === i) n.forEach(s);else if (2 === i) n.forEach(f);else {
                  var a = Array.prototype.slice.call(arguments, 1);
                  n.forEach(c);
                }
                return !!n.length;

                function s(e) {
                  e.call(r);
                }

                function f(e) {
                  e.call(r, t);
                }

                function c(e) {
                  e.apply(r, a);
                }
              }
            };

            function n(e) {
              for (var t in r) {
                e[t] = r[t];
              }

              return e;
            }

            function i(e, t) {
              var r,
                  n = this;

              if (arguments.length) {
                if (t) {
                  if (r = o(n, e, !0)) {
                    if (!(r = r.filter(a)).length) return i.call(n, e);
                    n.listeners[e] = r;
                  }
                } else if ((r = n.listeners) && (delete r[e], !Object.keys(r).length)) return i.call(n);
              } else delete n.listeners;

              return n;

              function a(e) {
                return e !== t && e.originalListener !== t;
              }
            }

            function o(e, t, r) {
              if (!r || e.listeners) {
                var n = e.listeners || (e.listeners = {});
                return n[t] || (n[t] = []);
              }
            }

            n(t.prototype), t.mixin = n;
          }(
          /**
           * event-lite.js - Light-weight EventEmitter (less than 1KB when gzipped)
           *
           * @copyright Yusuke Kawasaki
           * @license MIT
           * @constructor
           * @see https://github.com/kawanet/event-lite
           * @see http://kawanet.github.io/event-lite/EventLite.html
           * @example
           * var EventLite = require("event-lite");
           *
           * function MyClass() {...}             // your class
           *
           * EventLite.mixin(MyClass.prototype);  // import event methods
           *
           * var obj = new MyClass();
           * obj.on("foo", function() {...});     // add event listener
           * obj.once("bar", function() {...});   // add one-time event listener
           * obj.emit("foo");                     // dispatch event
           * obj.emit("bar");                     // dispatch another event
           * obj.off("foo");                      // remove event listener
           */
          function e() {
            if (!(this instanceof e)) return new e();
          });
        },
        "./node_modules/events/events.js":
        /*!***************************************!*\
          !*** ./node_modules/events/events.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesEventsEventsJs(e, t, r) {
          "use strict";

          var n,
              i = "object" == typeof Reflect ? Reflect : null,
              o = i && "function" == typeof i.apply ? i.apply : function (e, t, r) {
            return Function.prototype.apply.call(e, t, r);
          };
          n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (e) {
            return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
          } : function (e) {
            return Object.getOwnPropertyNames(e);
          };

          var a = Number.isNaN || function (e) {
            return e != e;
          };

          function s() {
            s.init.call(this);
          }

          e.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
          var f = 10;

          function c(e) {
            if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
          }

          function u(e) {
            return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners;
          }

          function d(e, t, r, n) {
            var i, o, a, s;
            if (c(r), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]), void 0 === a) a = o[t] = r, ++e._eventsCount;else if ("function" == typeof a ? a = o[t] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), (i = u(e)) > 0 && a.length > i && !a.warned) {
              a.warned = !0;
              var f = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
              f.name = "MaxListenersExceededWarning", f.emitter = e, f.type = t, f.count = a.length, s = f, console && console.warn && console.warn(s);
            }
            return e;
          }

          function h() {
            if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
          }

          function l(e, t, r) {
            var n = {
              fired: !1,
              wrapFn: void 0,
              target: e,
              type: t,
              listener: r
            },
                i = h.bind(n);
            return i.listener = r, n.wrapFn = i, i;
          }

          function p(e, t, r) {
            var n = e._events;
            if (void 0 === n) return [];
            var i = n[t];
            return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (e) {
              for (var t = new Array(e.length), r = 0; r < t.length; ++r) {
                t[r] = e[r].listener || e[r];
              }

              return t;
            }(i) : m(i, i.length);
          }

          function b(e) {
            var t = this._events;

            if (void 0 !== t) {
              var r = t[e];
              if ("function" == typeof r) return 1;
              if (void 0 !== r) return r.length;
            }

            return 0;
          }

          function m(e, t) {
            for (var r = new Array(t), n = 0; n < t; ++n) {
              r[n] = e[n];
            }

            return r;
          }

          Object.defineProperty(s, "defaultMaxListeners", {
            enumerable: !0,
            get: function get() {
              return f;
            },
            set: function set(e) {
              if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
              f = e;
            }
          }), s.init = function () {
            void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
          }, s.prototype.setMaxListeners = function (e) {
            if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
            return this._maxListeners = e, this;
          }, s.prototype.getMaxListeners = function () {
            return u(this);
          }, s.prototype.emit = function (e) {
            for (var t = [], r = 1; r < arguments.length; r++) {
              t.push(arguments[r]);
            }

            var n = "error" === e,
                i = this._events;
            if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

            if (n) {
              var a;
              if (t.length > 0 && (a = t[0]), a instanceof Error) throw a;
              var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
              throw s.context = a, s;
            }

            var f = i[e];
            if (void 0 === f) return !1;
            if ("function" == typeof f) o(f, this, t);else {
              var c = f.length,
                  u = m(f, c);

              for (r = 0; r < c; ++r) {
                o(u[r], this, t);
              }
            }
            return !0;
          }, s.prototype.addListener = function (e, t) {
            return d(this, e, t, !1);
          }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (e, t) {
            return d(this, e, t, !0);
          }, s.prototype.once = function (e, t) {
            return c(t), this.on(e, l(this, e, t)), this;
          }, s.prototype.prependOnceListener = function (e, t) {
            return c(t), this.prependListener(e, l(this, e, t)), this;
          }, s.prototype.removeListener = function (e, t) {
            var r, n, i, o, a;
            if (c(t), void 0 === (n = this._events)) return this;
            if (void 0 === (r = n[e])) return this;
            if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));else if ("function" != typeof r) {
              for (i = -1, o = r.length - 1; o >= 0; o--) {
                if (r[o] === t || r[o].listener === t) {
                  a = r[o].listener, i = o;
                  break;
                }
              }

              if (i < 0) return this;
              0 === i ? r.shift() : function (e, t) {
                for (; t + 1 < e.length; t++) {
                  e[t] = e[t + 1];
                }

                e.pop();
              }(r, i), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, a || t);
            }
            return this;
          }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (e) {
            var t, r, n;
            if (void 0 === (r = this._events)) return this;
            if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;

            if (0 === arguments.length) {
              var i,
                  o = Object.keys(r);

              for (n = 0; n < o.length; ++n) {
                "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
              }

              return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
            }

            if ("function" == typeof (t = r[e])) this.removeListener(e, t);else if (void 0 !== t) for (n = t.length - 1; n >= 0; n--) {
              this.removeListener(e, t[n]);
            }
            return this;
          }, s.prototype.listeners = function (e) {
            return p(this, e, !0);
          }, s.prototype.rawListeners = function (e) {
            return p(this, e, !1);
          }, s.listenerCount = function (e, t) {
            return "function" == typeof e.listenerCount ? e.listenerCount(t) : b.call(e, t);
          }, s.prototype.listenerCount = b, s.prototype.eventNames = function () {
            return this._eventsCount > 0 ? n(this._events) : [];
          };
        },
        "./node_modules/hash-base/index.js":
        /*!*****************************************!*\
          !*** ./node_modules/hash-base/index.js ***!
          \*****************************************/

        /*! no static exports found */
        function node_modulesHashBaseIndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              i = r(
          /*! stream */
          "./node_modules/stream-browserify/index.js").Transform;

          function o(e) {
            i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
          }

          r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js")(o, i), o.prototype._transform = function (e, t, r) {
            var n = null;

            try {
              this.update(e, t);
            } catch (e) {
              n = e;
            }

            r(n);
          }, o.prototype._flush = function (e) {
            var t = null;

            try {
              this.push(this.digest());
            } catch (e) {
              t = e;
            }

            e(t);
          }, o.prototype.update = function (e, t) {
            if (function (e, t) {
              if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
            }(e, "Data"), this._finalized) throw new Error("Digest already called");
            n.isBuffer(e) || (e = n.from(e, t));

            for (var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;) {
              for (var o = this._blockOffset; o < this._blockSize;) {
                r[o++] = e[i++];
              }

              this._update(), this._blockOffset = 0;
            }

            for (; i < e.length;) {
              r[this._blockOffset++] = e[i++];
            }

            for (var a = 0, s = 8 * e.length; s > 0; ++a) {
              this._length[a] += s, (s = this._length[a] / 4294967296 | 0) > 0 && (this._length[a] -= 4294967296 * s);
            }

            return this;
          }, o.prototype._update = function () {
            throw new Error("_update is not implemented");
          }, o.prototype.digest = function (e) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = !0;

            var t = this._digest();

            void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;

            for (var r = 0; r < 4; ++r) {
              this._length[r] = 0;
            }

            return t;
          }, o.prototype._digest = function () {
            throw new Error("_digest is not implemented");
          }, e.exports = o;
        },
        "./node_modules/hash.js/lib/hash.js":
        /*!******************************************!*\
          !*** ./node_modules/hash.js/lib/hash.js ***!
          \******************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashJs(e, t, r) {
          var n = t;
          n.utils = r(
          /*! ./hash/utils */
          "./node_modules/hash.js/lib/hash/utils.js"), n.common = r(
          /*! ./hash/common */
          "./node_modules/hash.js/lib/hash/common.js"), n.sha = r(
          /*! ./hash/sha */
          "./node_modules/hash.js/lib/hash/sha.js"), n.ripemd = r(
          /*! ./hash/ripemd */
          "./node_modules/hash.js/lib/hash/ripemd.js"), n.hmac = r(
          /*! ./hash/hmac */
          "./node_modules/hash.js/lib/hash/hmac.js"), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
        },
        "./node_modules/hash.js/lib/hash/common.js":
        /*!*************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/common.js ***!
          \*************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashCommonJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ./utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! minimalistic-assert */
          "./node_modules/minimalistic-assert/index.js");

          function o() {
            this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
          }

          t.BlockHash = o, o.prototype.update = function (e, t) {
            if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
              var r = (e = this.pending).length % this._delta8;
              this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);

              for (var i = 0; i < e.length; i += this._delta32) {
                this._update(e, i, i + this._delta32);
              }
            }

            return this;
          }, o.prototype.digest = function (e) {
            return this.update(this._pad()), i(null === this.pending), this._digest(e);
          }, o.prototype._pad = function () {
            var e = this.pendingTotal,
                t = this._delta8,
                r = t - (e + this.padLength) % t,
                n = new Array(r + this.padLength);
            n[0] = 128;

            for (var i = 1; i < r; i++) {
              n[i] = 0;
            }

            if (e <<= 3, "big" === this.endian) {
              for (var o = 8; o < this.padLength; o++) {
                n[i++] = 0;
              }

              n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
            } else for (n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++) {
              n[i++] = 0;
            }

            return n;
          };
        },
        "./node_modules/hash.js/lib/hash/hmac.js":
        /*!***********************************************!*\
          !*** ./node_modules/hash.js/lib/hash/hmac.js ***!
          \***********************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashHmacJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ./utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! minimalistic-assert */
          "./node_modules/minimalistic-assert/index.js");

          function o(e, t, r) {
            if (!(this instanceof o)) return new o(e, t, r);
            this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
          }

          e.exports = o, o.prototype._init = function (e) {
            e.length > this.blockSize && (e = new this.Hash().update(e).digest()), i(e.length <= this.blockSize);

            for (var t = e.length; t < this.blockSize; t++) {
              e.push(0);
            }

            for (t = 0; t < e.length; t++) {
              e[t] ^= 54;
            }

            for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
              e[t] ^= 106;
            }

            this.outer = new this.Hash().update(e);
          }, o.prototype.update = function (e, t) {
            return this.inner.update(e, t), this;
          }, o.prototype.digest = function (e) {
            return this.outer.update(this.inner.digest()), this.outer.digest(e);
          };
        },
        "./node_modules/hash.js/lib/hash/ripemd.js":
        /*!*************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/ripemd.js ***!
          \*************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashRipemdJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ./utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! ./common */
          "./node_modules/hash.js/lib/hash/common.js"),
              o = n.rotl32,
              a = n.sum32,
              s = n.sum32_3,
              f = n.sum32_4,
              c = i.BlockHash;

          function u() {
            if (!(this instanceof u)) return new u();
            c.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
          }

          function d(e, t, r, n) {
            return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
          }

          function h(e) {
            return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
          }

          function l(e) {
            return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
          }

          n.inherits(u, c), t.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function (e, t) {
            for (var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], v = r, g = n, _ = i, w = c, k = u, E = 0; E < 80; E++) {
              var A = a(o(f(r, d(E, n, i, c), e[p[E] + t], h(E)), m[E]), u);
              r = u, u = c, c = o(i, 10), i = n, n = A, A = a(o(f(v, d(79 - E, g, _, w), e[b[E] + t], l(E)), y[E]), k), v = k, k = w, w = o(_, 10), _ = g, g = A;
            }

            A = s(this.h[1], i, w), this.h[1] = s(this.h[2], c, k), this.h[2] = s(this.h[3], u, v), this.h[3] = s(this.h[4], r, g), this.h[4] = s(this.h[0], n, _), this.h[0] = A;
          }, u.prototype._digest = function (e) {
            return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
          };
          var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
              b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
              m = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
              y = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
        },
        "./node_modules/hash.js/lib/hash/sha.js":
        /*!**********************************************!*\
          !*** ./node_modules/hash.js/lib/hash/sha.js ***!
          \**********************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashShaJs(e, t, r) {
          "use strict";

          t.sha1 = r(
          /*! ./sha/1 */
          "./node_modules/hash.js/lib/hash/sha/1.js"), t.sha224 = r(
          /*! ./sha/224 */
          "./node_modules/hash.js/lib/hash/sha/224.js"), t.sha256 = r(
          /*! ./sha/256 */
          "./node_modules/hash.js/lib/hash/sha/256.js"), t.sha384 = r(
          /*! ./sha/384 */
          "./node_modules/hash.js/lib/hash/sha/384.js"), t.sha512 = r(
          /*! ./sha/512 */
          "./node_modules/hash.js/lib/hash/sha/512.js");
        },
        "./node_modules/hash.js/lib/hash/sha/1.js":
        /*!************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/sha/1.js ***!
          \************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashSha1Js(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! ../common */
          "./node_modules/hash.js/lib/hash/common.js"),
              o = r(
          /*! ./common */
          "./node_modules/hash.js/lib/hash/sha/common.js"),
              a = n.rotl32,
              s = n.sum32,
              f = n.sum32_5,
              c = o.ft_1,
              u = i.BlockHash,
              d = [1518500249, 1859775393, 2400959708, 3395469782];

          function h() {
            if (!(this instanceof h)) return new h();
            u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
          }

          n.inherits(h, u), e.exports = h, h.blockSize = 512, h.outSize = 160, h.hmacStrength = 80, h.padLength = 64, h.prototype._update = function (e, t) {
            for (var r = this.W, n = 0; n < 16; n++) {
              r[n] = e[t + n];
            }

            for (; n < r.length; n++) {
              r[n] = a(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
            }

            var i = this.h[0],
                o = this.h[1],
                u = this.h[2],
                h = this.h[3],
                l = this.h[4];

            for (n = 0; n < r.length; n++) {
              var p = ~~(n / 20),
                  b = f(a(i, 5), c(p, o, u, h), l, r[n], d[p]);
              l = h, h = u, u = a(o, 30), o = i, i = b;
            }

            this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], u), this.h[3] = s(this.h[3], h), this.h[4] = s(this.h[4], l);
          }, h.prototype._digest = function (e) {
            return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
          };
        },
        "./node_modules/hash.js/lib/hash/sha/224.js":
        /*!**************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/sha/224.js ***!
          \**************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashSha224Js(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! ./256 */
          "./node_modules/hash.js/lib/hash/sha/256.js");

          function o() {
            if (!(this instanceof o)) return new o();
            i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
          }

          n.inherits(o, i), e.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function (e) {
            return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
          };
        },
        "./node_modules/hash.js/lib/hash/sha/256.js":
        /*!**************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/sha/256.js ***!
          \**************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashSha256Js(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! ../common */
          "./node_modules/hash.js/lib/hash/common.js"),
              o = r(
          /*! ./common */
          "./node_modules/hash.js/lib/hash/sha/common.js"),
              a = r(
          /*! minimalistic-assert */
          "./node_modules/minimalistic-assert/index.js"),
              s = n.sum32,
              f = n.sum32_4,
              c = n.sum32_5,
              u = o.ch32,
              d = o.maj32,
              h = o.s0_256,
              l = o.s1_256,
              p = o.g0_256,
              b = o.g1_256,
              m = i.BlockHash,
              y = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

          function v() {
            if (!(this instanceof v)) return new v();
            m.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = y, this.W = new Array(64);
          }

          n.inherits(v, m), e.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
            for (var r = this.W, n = 0; n < 16; n++) {
              r[n] = e[t + n];
            }

            for (; n < r.length; n++) {
              r[n] = f(b(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
            }

            var i = this.h[0],
                o = this.h[1],
                m = this.h[2],
                y = this.h[3],
                v = this.h[4],
                g = this.h[5],
                _ = this.h[6],
                w = this.h[7];

            for (a(this.k.length === r.length), n = 0; n < r.length; n++) {
              var k = c(w, l(v), u(v, g, _), this.k[n], r[n]),
                  E = s(h(i), d(i, o, m));
              w = _, _ = g, g = v, v = s(y, k), y = m, m = o, o = i, i = s(k, E);
            }

            this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], m), this.h[3] = s(this.h[3], y), this.h[4] = s(this.h[4], v), this.h[5] = s(this.h[5], g), this.h[6] = s(this.h[6], _), this.h[7] = s(this.h[7], w);
          }, v.prototype._digest = function (e) {
            return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
          };
        },
        "./node_modules/hash.js/lib/hash/sha/384.js":
        /*!**************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/sha/384.js ***!
          \**************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashSha384Js(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! ./512 */
          "./node_modules/hash.js/lib/hash/sha/512.js");

          function o() {
            if (!(this instanceof o)) return new o();
            i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
          }

          n.inherits(o, i), e.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function (e) {
            return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
          };
        },
        "./node_modules/hash.js/lib/hash/sha/512.js":
        /*!**************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/sha/512.js ***!
          \**************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashSha512Js(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/hash.js/lib/hash/utils.js"),
              i = r(
          /*! ../common */
          "./node_modules/hash.js/lib/hash/common.js"),
              o = r(
          /*! minimalistic-assert */
          "./node_modules/minimalistic-assert/index.js"),
              a = n.rotr64_hi,
              s = n.rotr64_lo,
              f = n.shr64_hi,
              c = n.shr64_lo,
              u = n.sum64,
              d = n.sum64_hi,
              h = n.sum64_lo,
              l = n.sum64_4_hi,
              p = n.sum64_4_lo,
              b = n.sum64_5_hi,
              m = n.sum64_5_lo,
              y = i.BlockHash,
              v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

          function g() {
            if (!(this instanceof g)) return new g();
            y.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
          }

          function _(e, t, r, n, i) {
            var o = e & r ^ ~e & i;
            return o < 0 && (o += 4294967296), o;
          }

          function w(e, t, r, n, i, o) {
            var a = t & n ^ ~t & o;
            return a < 0 && (a += 4294967296), a;
          }

          function k(e, t, r, n, i) {
            var o = e & r ^ e & i ^ r & i;
            return o < 0 && (o += 4294967296), o;
          }

          function E(e, t, r, n, i, o) {
            var a = t & n ^ t & o ^ n & o;
            return a < 0 && (a += 4294967296), a;
          }

          function A(e, t) {
            var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
            return r < 0 && (r += 4294967296), r;
          }

          function S(e, t) {
            var r = s(e, t, 28) ^ s(t, e, 2) ^ s(t, e, 7);
            return r < 0 && (r += 4294967296), r;
          }

          function M(e, t) {
            var r = s(e, t, 14) ^ s(e, t, 18) ^ s(t, e, 9);
            return r < 0 && (r += 4294967296), r;
          }

          function x(e, t) {
            var r = a(e, t, 1) ^ a(e, t, 8) ^ f(e, t, 7);
            return r < 0 && (r += 4294967296), r;
          }

          function I(e, t) {
            var r = s(e, t, 1) ^ s(e, t, 8) ^ c(e, t, 7);
            return r < 0 && (r += 4294967296), r;
          }

          function j(e, t) {
            var r = s(e, t, 19) ^ s(t, e, 29) ^ c(e, t, 6);
            return r < 0 && (r += 4294967296), r;
          }

          n.inherits(g, y), e.exports = g, g.blockSize = 1024, g.outSize = 512, g.hmacStrength = 192, g.padLength = 128, g.prototype._prepareBlock = function (e, t) {
            for (var r = this.W, n = 0; n < 32; n++) {
              r[n] = e[t + n];
            }

            for (; n < r.length; n += 2) {
              var i = (m = r[n - 4], y = r[n - 3], v = void 0, (v = a(m, y, 19) ^ a(y, m, 29) ^ f(m, y, 6)) < 0 && (v += 4294967296), v),
                  o = j(r[n - 4], r[n - 3]),
                  s = r[n - 14],
                  c = r[n - 13],
                  u = x(r[n - 30], r[n - 29]),
                  d = I(r[n - 30], r[n - 29]),
                  h = r[n - 32],
                  b = r[n - 31];
              r[n] = l(i, o, s, c, u, d, h, b), r[n + 1] = p(i, o, s, c, u, d, h, b);
            }

            var m, y, v;
          }, g.prototype._update = function (e, t) {
            this._prepareBlock(e, t);

            var r,
                n,
                i,
                s = this.W,
                f = this.h[0],
                c = this.h[1],
                l = this.h[2],
                p = this.h[3],
                y = this.h[4],
                v = this.h[5],
                g = this.h[6],
                x = this.h[7],
                I = this.h[8],
                j = this.h[9],
                B = this.h[10],
                R = this.h[11],
                P = this.h[12],
                T = this.h[13],
                L = this.h[14],
                C = this.h[15];
            o(this.k.length === s.length);

            for (var O = 0; O < s.length; O += 2) {
              var N = L,
                  U = C,
                  D = (i = void 0, (i = a(r = I, n = j, 14) ^ a(r, n, 18) ^ a(n, r, 9)) < 0 && (i += 4294967296), i),
                  q = M(I, j),
                  z = _(I, 0, B, 0, P),
                  F = w(0, j, 0, R, 0, T),
                  Y = this.k[O],
                  K = this.k[O + 1],
                  V = s[O],
                  H = s[O + 1],
                  W = b(N, U, D, q, z, F, Y, K, V, H),
                  G = m(N, U, D, q, z, F, Y, K, V, H);

              N = A(f, c), U = S(f, c), D = k(f, 0, l, 0, y), q = E(0, c, 0, p, 0, v);
              var X = d(N, U, D, q),
                  Z = h(N, U, D, q);
              L = P, C = T, P = B, T = R, B = I, R = j, I = d(g, x, W, G), j = h(x, x, W, G), g = y, x = v, y = l, v = p, l = f, p = c, f = d(W, G, X, Z), c = h(W, G, X, Z);
            }

            u(this.h, 0, f, c), u(this.h, 2, l, p), u(this.h, 4, y, v), u(this.h, 6, g, x), u(this.h, 8, I, j), u(this.h, 10, B, R), u(this.h, 12, P, T), u(this.h, 14, L, C);
          }, g.prototype._digest = function (e) {
            return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
          };
        },
        "./node_modules/hash.js/lib/hash/sha/common.js":
        /*!*****************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/sha/common.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashShaCommonJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ../utils */
          "./node_modules/hash.js/lib/hash/utils.js").rotr32;

          function i(e, t, r) {
            return e & t ^ ~e & r;
          }

          function o(e, t, r) {
            return e & t ^ e & r ^ t & r;
          }

          function a(e, t, r) {
            return e ^ t ^ r;
          }

          t.ft_1 = function (e, t, r, n) {
            return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? a(t, r, n) : 2 === e ? o(t, r, n) : void 0;
          }, t.ch32 = i, t.maj32 = o, t.p32 = a, t.s0_256 = function (e) {
            return n(e, 2) ^ n(e, 13) ^ n(e, 22);
          }, t.s1_256 = function (e) {
            return n(e, 6) ^ n(e, 11) ^ n(e, 25);
          }, t.g0_256 = function (e) {
            return n(e, 7) ^ n(e, 18) ^ e >>> 3;
          }, t.g1_256 = function (e) {
            return n(e, 17) ^ n(e, 19) ^ e >>> 10;
          };
        },
        "./node_modules/hash.js/lib/hash/utils.js":
        /*!************************************************!*\
          !*** ./node_modules/hash.js/lib/hash/utils.js ***!
          \************************************************/

        /*! no static exports found */
        function node_modulesHashJsLibHashUtilsJs(e, t, r) {
          "use strict";

          var n = r(
          /*! minimalistic-assert */
          "./node_modules/minimalistic-assert/index.js"),
              i = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js");

          function o(e, t) {
            return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
          }

          function a(e) {
            return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
          }

          function s(e) {
            return 1 === e.length ? "0" + e : e;
          }

          function f(e) {
            return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
          }

          t.inherits = i, t.toArray = function (e, t) {
            if (Array.isArray(e)) return e.slice();
            if (!e) return [];
            var r = [];
            if ("string" == typeof e) {
              if (t) {
                if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2) {
                  r.push(parseInt(e[i] + e[i + 1], 16));
                }
              } else for (var n = 0, i = 0; i < e.length; i++) {
                var a = e.charCodeAt(i);
                a < 128 ? r[n++] = a : a < 2048 ? (r[n++] = a >> 6 | 192, r[n++] = 63 & a | 128) : o(e, i) ? (a = 65536 + ((1023 & a) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = a >> 18 | 240, r[n++] = a >> 12 & 63 | 128, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128) : (r[n++] = a >> 12 | 224, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128);
              }
            } else for (i = 0; i < e.length; i++) {
              r[i] = 0 | e[i];
            }
            return r;
          }, t.toHex = function (e) {
            for (var t = "", r = 0; r < e.length; r++) {
              t += s(e[r].toString(16));
            }

            return t;
          }, t.htonl = a, t.toHex32 = function (e, t) {
            for (var r = "", n = 0; n < e.length; n++) {
              var i = e[n];
              "little" === t && (i = a(i)), r += f(i.toString(16));
            }

            return r;
          }, t.zero2 = s, t.zero8 = f, t.join32 = function (e, t, r, i) {
            var o = r - t;
            n(o % 4 == 0);

            for (var a = new Array(o / 4), s = 0, f = t; s < a.length; s++, f += 4) {
              var c;
              c = "big" === i ? e[f] << 24 | e[f + 1] << 16 | e[f + 2] << 8 | e[f + 3] : e[f + 3] << 24 | e[f + 2] << 16 | e[f + 1] << 8 | e[f], a[s] = c >>> 0;
            }

            return a;
          }, t.split32 = function (e, t) {
            for (var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4) {
              var o = e[n];
              "big" === t ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
            }

            return r;
          }, t.rotr32 = function (e, t) {
            return e >>> t | e << 32 - t;
          }, t.rotl32 = function (e, t) {
            return e << t | e >>> 32 - t;
          }, t.sum32 = function (e, t) {
            return e + t >>> 0;
          }, t.sum32_3 = function (e, t, r) {
            return e + t + r >>> 0;
          }, t.sum32_4 = function (e, t, r, n) {
            return e + t + r + n >>> 0;
          }, t.sum32_5 = function (e, t, r, n, i) {
            return e + t + r + n + i >>> 0;
          }, t.sum64 = function (e, t, r, n) {
            var i = e[t],
                o = n + e[t + 1] >>> 0,
                a = (o < n ? 1 : 0) + r + i;
            e[t] = a >>> 0, e[t + 1] = o;
          }, t.sum64_hi = function (e, t, r, n) {
            return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
          }, t.sum64_lo = function (e, t, r, n) {
            return t + n >>> 0;
          }, t.sum64_4_hi = function (e, t, r, n, i, o, a, s) {
            var f = 0,
                c = t;
            return f += (c = c + n >>> 0) < t ? 1 : 0, f += (c = c + o >>> 0) < o ? 1 : 0, e + r + i + a + (f += (c = c + s >>> 0) < s ? 1 : 0) >>> 0;
          }, t.sum64_4_lo = function (e, t, r, n, i, o, a, s) {
            return t + n + o + s >>> 0;
          }, t.sum64_5_hi = function (e, t, r, n, i, o, a, s, f, c) {
            var u = 0,
                d = t;
            return u += (d = d + n >>> 0) < t ? 1 : 0, u += (d = d + o >>> 0) < o ? 1 : 0, u += (d = d + s >>> 0) < s ? 1 : 0, e + r + i + a + f + (u += (d = d + c >>> 0) < c ? 1 : 0) >>> 0;
          }, t.sum64_5_lo = function (e, t, r, n, i, o, a, s, f, c) {
            return t + n + o + s + c >>> 0;
          }, t.rotr64_hi = function (e, t, r) {
            return (t << 32 - r | e >>> r) >>> 0;
          }, t.rotr64_lo = function (e, t, r) {
            return (e << 32 - r | t >>> r) >>> 0;
          }, t.shr64_hi = function (e, t, r) {
            return e >>> r;
          }, t.shr64_lo = function (e, t, r) {
            return (e << 32 - r | t >>> r) >>> 0;
          };
        },
        "./node_modules/hmac-drbg/lib/hmac-drbg.js":
        /*!*************************************************!*\
          !*** ./node_modules/hmac-drbg/lib/hmac-drbg.js ***!
          \*************************************************/

        /*! no static exports found */
        function node_modulesHmacDrbgLibHmacDrbgJs(e, t, r) {
          "use strict";

          var n = r(
          /*! hash.js */
          "./node_modules/hash.js/lib/hash.js"),
              i = r(
          /*! minimalistic-crypto-utils */
          "./node_modules/minimalistic-crypto-utils/lib/utils.js"),
              o = r(
          /*! minimalistic-assert */
          "./node_modules/minimalistic-assert/index.js");

          function a(e) {
            if (!(this instanceof a)) return new a(e);
            this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
            var t = i.toArray(e.entropy, e.entropyEnc || "hex"),
                r = i.toArray(e.nonce, e.nonceEnc || "hex"),
                n = i.toArray(e.pers, e.persEnc || "hex");
            o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
          }

          e.exports = a, a.prototype._init = function (e, t, r) {
            var n = e.concat(t).concat(r);
            this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

            for (var i = 0; i < this.V.length; i++) {
              this.K[i] = 0, this.V[i] = 1;
            }

            this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
          }, a.prototype._hmac = function () {
            return new n.hmac(this.hash, this.K);
          }, a.prototype._update = function (e) {
            var t = this._hmac().update(this.V).update([0]);

            e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
          }, a.prototype.reseed = function (e, t, r, n) {
            "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
          }, a.prototype.generate = function (e, t, r, n) {
            if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
            "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));

            for (var o = []; o.length < e;) {
              this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
            }

            var a = o.slice(0, e);
            return this._update(r), this._reseed++, i.encode(a, t);
          };
        },
        "./node_modules/ieee754/index.js":
        /*!***************************************!*\
          !*** ./node_modules/ieee754/index.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesIeee754IndexJs(e, t) {
          t.read = function (e, t, r, n, i) {
            var o,
                a,
                s = 8 * i - n - 1,
                f = (1 << s) - 1,
                c = f >> 1,
                u = -7,
                d = r ? i - 1 : 0,
                h = r ? -1 : 1,
                l = e[t + d];

            for (d += h, o = l & (1 << -u) - 1, l >>= -u, u += s; u > 0; o = 256 * o + e[t + d], d += h, u -= 8) {
              ;
            }

            for (a = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; a = 256 * a + e[t + d], d += h, u -= 8) {
              ;
            }

            if (0 === o) o = 1 - c;else {
              if (o === f) return a ? NaN : 1 / 0 * (l ? -1 : 1);
              a += Math.pow(2, n), o -= c;
            }
            return (l ? -1 : 1) * a * Math.pow(2, o - n);
          }, t.write = function (e, t, r, n, i, o) {
            var a,
                s,
                f,
                c = 8 * o - i - 1,
                u = (1 << c) - 1,
                d = u >> 1,
                h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                l = n ? 0 : o - 1,
                p = n ? 1 : -1,
                b = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

            for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = u) : (a = Math.floor(Math.log(t) / Math.LN2), t * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (t += a + d >= 1 ? h / f : h * Math.pow(2, 1 - d)) * f >= 2 && (a++, f /= 2), a + d >= u ? (s = 0, a = u) : a + d >= 1 ? (s = (t * f - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[r + l] = 255 & s, l += p, s /= 256, i -= 8) {
              ;
            }

            for (a = a << i | s, c += i; c > 0; e[r + l] = 255 & a, l += p, a /= 256, c -= 8) {
              ;
            }

            e[r + l - p] |= 128 * b;
          };
        },
        "./node_modules/inherits/inherits_browser.js":
        /*!***************************************************!*\
          !*** ./node_modules/inherits/inherits_browser.js ***!
          \***************************************************/

        /*! no static exports found */
        function node_modulesInheritsInherits_browserJs(e, t) {
          "function" == typeof Object.create ? e.exports = function (e, t) {
            e.super_ = t, e.prototype = Object.create(t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            });
          } : e.exports = function (e, t) {
            e.super_ = t;

            var r = function r() {};

            r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
          };
        },
        "./node_modules/int64-buffer/int64-buffer.js":
        /*!***************************************************!*\
          !*** ./node_modules/int64-buffer/int64-buffer.js ***!
          \***************************************************/

        /*! no static exports found */
        function node_modulesInt64BufferInt64BufferJs(e, t, r) {
          (function (e) {
            !function (t) {
              var r,
                  n = void 0 !== e && e,
                  i = "undefined" != typeof Uint8Array && Uint8Array,
                  o = "undefined" != typeof ArrayBuffer && ArrayBuffer,
                  a = [0, 0, 0, 0, 0, 0, 0, 0],
                  s = Array.isArray || function (e) {
                return !!e && "[object Array]" == Object.prototype.toString.call(e);
              },
                  f = 4294967296;

              function c(e, s, c) {
                var _ = s ? 0 : 4,
                    w = s ? 4 : 0,
                    k = s ? 0 : 3,
                    E = s ? 1 : 2,
                    A = s ? 2 : 1,
                    S = s ? 3 : 0,
                    M = s ? m : v,
                    x = s ? y : g,
                    I = R.prototype,
                    j = "is" + e,
                    B = "_" + j;

                return I.buffer = void 0, I.offset = 0, I[B] = !0, I.toNumber = P, I.toString = function (e) {
                  var t = this.buffer,
                      r = this.offset,
                      n = L(t, r + _),
                      i = L(t, r + w),
                      o = "",
                      a = !c && 2147483648 & n;

                  for (a && (n = ~n, i = f - i), e = e || 10;;) {
                    var s = n % e * f + i;
                    if (n = Math.floor(n / e), i = Math.floor(s / e), o = (s % e).toString(e) + o, !n && !i) break;
                  }

                  return a && (o = "-" + o), o;
                }, I.toJSON = P, I.toArray = u, n && (I.toBuffer = d), i && (I.toArrayBuffer = h), R[j] = function (e) {
                  return !(!e || !e[B]);
                }, t[e] = R, R;

                function R(e, t, n, s) {
                  return this instanceof R ? function (e, t, n, s, c) {
                    i && o && (t instanceof o && (t = new i(t)), s instanceof o && (s = new i(s))), t || n || s || r ? (l(t, n) || (c = n, s = t, n = 0, t = new (r || Array)(8)), e.buffer = t, e.offset = n |= 0, void 0 !== s && ("string" == typeof s ? function (e, t, r, n) {
                      var i = 0,
                          o = r.length,
                          a = 0,
                          s = 0;
                      "-" === r[0] && i++;

                      for (var c = i; i < o;) {
                        var u = parseInt(r[i++], n);
                        if (!(u >= 0)) break;
                        s = s * n + u, a = a * n + Math.floor(s / f), s %= f;
                      }

                      c && (a = ~a, s ? s = f - s : a++), T(e, t + _, a), T(e, t + w, s);
                    }(t, n, s, c || 10) : l(s, c) ? p(t, n, s, c) : "number" == typeof c ? (T(t, n + _, s), T(t, n + w, c)) : s > 0 ? M(t, n, s) : s < 0 ? x(t, n, s) : p(t, n, a, 0))) : e.buffer = b(a, 0);
                  }(this, e, t, n, s) : new R(e, t, n, s);
                }

                function P() {
                  var e = this.buffer,
                      t = this.offset,
                      r = L(e, t + _),
                      n = L(e, t + w);
                  return c || (r |= 0), r ? r * f + n : n;
                }

                function T(e, t, r) {
                  e[t + S] = 255 & r, r >>= 8, e[t + A] = 255 & r, r >>= 8, e[t + E] = 255 & r, r >>= 8, e[t + k] = 255 & r;
                }

                function L(e, t) {
                  return 16777216 * e[t + k] + (e[t + E] << 16) + (e[t + A] << 8) + e[t + S];
                }
              }

              function u(e) {
                var t = this.buffer,
                    n = this.offset;
                return r = null, !1 !== e && 0 === n && 8 === t.length && s(t) ? t : b(t, n);
              }

              function d(t) {
                var i = this.buffer,
                    o = this.offset;
                if (r = n, !1 !== t && 0 === o && 8 === i.length && e.isBuffer(i)) return i;
                var a = new n(8);
                return p(a, 0, i, o), a;
              }

              function h(e) {
                var t = this.buffer,
                    n = this.offset,
                    a = t.buffer;
                if (r = i, !1 !== e && 0 === n && a instanceof o && 8 === a.byteLength) return a;
                var s = new i(8);
                return p(s, 0, t, n), s.buffer;
              }

              function l(e, t) {
                var r = e && e.length;
                return t |= 0, r && t + 8 <= r && "string" != typeof e[t];
              }

              function p(e, t, r, n) {
                t |= 0, n |= 0;

                for (var i = 0; i < 8; i++) {
                  e[t++] = 255 & r[n++];
                }
              }

              function b(e, t) {
                return Array.prototype.slice.call(e, t, t + 8);
              }

              function m(e, t, r) {
                for (var n = t + 8; n > t;) {
                  e[--n] = 255 & r, r /= 256;
                }
              }

              function y(e, t, r) {
                var n = t + 8;

                for (r++; n > t;) {
                  e[--n] = 255 & -r ^ 255, r /= 256;
                }
              }

              function v(e, t, r) {
                for (var n = t + 8; t < n;) {
                  e[t++] = 255 & r, r /= 256;
                }
              }

              function g(e, t, r) {
                var n = t + 8;

                for (r++; t < n;) {
                  e[t++] = 255 & -r ^ 255, r /= 256;
                }
              }

              c("Uint64BE", !0, !0), c("Int64BE", !0, !1), c("Uint64LE", !1, !0), c("Int64LE", !1, !1);
            }("string" != typeof t.nodeName ? t : this || {});
          }).call(this, r(
          /*! ./../buffer/index.js */
          "./node_modules/buffer/index.js").Buffer);
        },
        "./node_modules/isarray/index.js":
        /*!***************************************!*\
          !*** ./node_modules/isarray/index.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesIsarrayIndexJs(e, t) {
          var r = {}.toString;

          e.exports = Array.isArray || function (e) {
            return "[object Array]" == r.call(e);
          };
        },
        "./node_modules/json-stable-stringify/index.js":
        /*!*****************************************************!*\
          !*** ./node_modules/json-stable-stringify/index.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesJsonStableStringifyIndexJs(e, t, r) {
          var n = "undefined" != typeof JSON ? JSON : r(
          /*! jsonify */
          "./node_modules/jsonify/index.js");

          e.exports = function (e, t) {
            t || (t = {}), "function" == typeof t && (t = {
              cmp: t
            });
            var r = t.space || "";
            "number" == typeof r && (r = Array(r + 1).join(" "));

            var a,
                s = "boolean" == typeof t.cycles && t.cycles,
                f = t.replacer || function (e, t) {
              return t;
            },
                c = t.cmp && (a = t.cmp, function (e) {
              return function (t, r) {
                var n = {
                  key: t,
                  value: e[t]
                },
                    i = {
                  key: r,
                  value: e[r]
                };
                return a(n, i);
              };
            }),
                u = [];

            return function e(t, a, d, h) {
              var l = r ? "\n" + new Array(h + 1).join(r) : "",
                  p = r ? ": " : ":";

              if (d && d.toJSON && "function" == typeof d.toJSON && (d = d.toJSON()), void 0 !== (d = f.call(t, a, d))) {
                if ("object" != typeof d || null === d) return n.stringify(d);

                if (i(d)) {
                  for (var b = [], m = 0; m < d.length; m++) {
                    var y = e(d, m, d[m], h + 1) || n.stringify(null);
                    b.push(l + r + y);
                  }

                  return "[" + b.join(",") + l + "]";
                }

                if (-1 !== u.indexOf(d)) {
                  if (s) return n.stringify("__cycle__");
                  throw new TypeError("Converting circular structure to JSON");
                }

                u.push(d);
                var v = o(d).sort(c && c(d));

                for (b = [], m = 0; m < v.length; m++) {
                  var g = e(d, a = v[m], d[a], h + 1);

                  if (g) {
                    var _ = n.stringify(a) + p + g;

                    b.push(l + r + _);
                  }
                }

                return u.splice(u.indexOf(d), 1), "{" + b.join(",") + l + "}";
              }
            }({
              "": e
            }, "", e, 0);
          };

          var i = Array.isArray || function (e) {
            return "[object Array]" === {}.toString.call(e);
          },
              o = Object.keys || function (e) {
            var t = Object.prototype.hasOwnProperty || function () {
              return !0;
            },
                r = [];

            for (var n in e) {
              t.call(e, n) && r.push(n);
            }

            return r;
          };
        },
        "./node_modules/jsonify/index.js":
        /*!***************************************!*\
          !*** ./node_modules/jsonify/index.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesJsonifyIndexJs(e, t, r) {
          t.parse = r(
          /*! ./lib/parse */
          "./node_modules/jsonify/lib/parse.js"), t.stringify = r(
          /*! ./lib/stringify */
          "./node_modules/jsonify/lib/stringify.js");
        },
        "./node_modules/jsonify/lib/parse.js":
        /*!*******************************************!*\
          !*** ./node_modules/jsonify/lib/parse.js ***!
          \*******************************************/

        /*! no static exports found */
        function node_modulesJsonifyLibParseJs(e, t) {
          var r,
              n,
              i,
              _o,
              a = {
            '"': '"',
            "\\": "\\",
            "/": "/",
            b: "\b",
            f: "\f",
            n: "\n",
            r: "\r",
            t: "\t"
          },
              s = function s(e) {
            throw {
              name: "SyntaxError",
              message: e,
              at: r,
              text: i
            };
          },
              f = function f(e) {
            return e && e !== n && s("Expected '" + e + "' instead of '" + n + "'"), n = i.charAt(r), r += 1, n;
          },
              c = function c() {
            var e,
                t = "";

            for ("-" === n && (t = "-", f("-")); n >= "0" && n <= "9";) {
              t += n, f();
            }

            if ("." === n) for (t += "."; f() && n >= "0" && n <= "9";) {
              t += n;
            }
            if ("e" === n || "E" === n) for (t += n, f(), "-" !== n && "+" !== n || (t += n, f()); n >= "0" && n <= "9";) {
              t += n, f();
            }
            if (e = +t, isFinite(e)) return e;
            s("Bad number");
          },
              u = function u() {
            var e,
                t,
                r,
                i = "";
            if ('"' === n) for (; f();) {
              if ('"' === n) return f(), i;
              if ("\\" === n) {
                if (f(), "u" === n) {
                  for (r = 0, t = 0; t < 4 && (e = parseInt(f(), 16), isFinite(e)); t += 1) {
                    r = 16 * r + e;
                  }

                  i += String.fromCharCode(r);
                } else {
                  if ("string" != typeof a[n]) break;
                  i += a[n];
                }
              } else i += n;
            }
            s("Bad string");
          },
              d = function d() {
            for (; n && n <= " ";) {
              f();
            }
          };

          _o = function o() {
            switch (d(), n) {
              case "{":
                return function () {
                  var e,
                      t = {};

                  if ("{" === n) {
                    if (f("{"), d(), "}" === n) return f("}"), t;

                    for (; n;) {
                      if (e = u(), d(), f(":"), Object.hasOwnProperty.call(t, e) && s('Duplicate key "' + e + '"'), t[e] = _o(), d(), "}" === n) return f("}"), t;
                      f(","), d();
                    }
                  }

                  s("Bad object");
                }();

              case "[":
                return function () {
                  var e = [];

                  if ("[" === n) {
                    if (f("["), d(), "]" === n) return f("]"), e;

                    for (; n;) {
                      if (e.push(_o()), d(), "]" === n) return f("]"), e;
                      f(","), d();
                    }
                  }

                  s("Bad array");
                }();

              case '"':
                return u();

              case "-":
                return c();

              default:
                return n >= "0" && n <= "9" ? c() : function () {
                  switch (n) {
                    case "t":
                      return f("t"), f("r"), f("u"), f("e"), !0;

                    case "f":
                      return f("f"), f("a"), f("l"), f("s"), f("e"), !1;

                    case "n":
                      return f("n"), f("u"), f("l"), f("l"), null;
                  }

                  s("Unexpected '" + n + "'");
                }();
            }
          }, e.exports = function (e, t) {
            var a;
            return i = e, r = 0, n = " ", a = _o(), d(), n && s("Syntax error"), "function" == typeof t ? function e(r, n) {
              var i,
                  o,
                  a = r[n];
              if (a && "object" == typeof a) for (i in a) {
                Object.prototype.hasOwnProperty.call(a, i) && (void 0 !== (o = e(a, i)) ? a[i] = o : delete a[i]);
              }
              return t.call(r, n, a);
            }({
              "": a
            }, "") : a;
          };
        },
        "./node_modules/jsonify/lib/stringify.js":
        /*!***********************************************!*\
          !*** ./node_modules/jsonify/lib/stringify.js ***!
          \***********************************************/

        /*! no static exports found */
        function node_modulesJsonifyLibStringifyJs(e, t) {
          var r,
              n,
              i,
              o = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
              a = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
          };

          function s(e) {
            return o.lastIndex = 0, o.test(e) ? '"' + e.replace(o, function (e) {
              var t = a[e];
              return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + e + '"';
          }

          e.exports = function (e, t, o) {
            var a;
            if (r = "", n = "", "number" == typeof o) for (a = 0; a < o; a += 1) {
              n += " ";
            } else "string" == typeof o && (n = o);
            if (i = t, t && "function" != typeof t && ("object" != typeof t || "number" != typeof t.length)) throw new Error("JSON.stringify");
            return function e(t, o) {
              var a,
                  f,
                  c,
                  u,
                  d,
                  h = r,
                  l = o[t];

              switch (l && "object" == typeof l && "function" == typeof l.toJSON && (l = l.toJSON(t)), "function" == typeof i && (l = i.call(o, t, l)), typeof l) {
                case "string":
                  return s(l);

                case "number":
                  return isFinite(l) ? String(l) : "null";

                case "boolean":
                case "null":
                  return String(l);

                case "object":
                  if (!l) return "null";

                  if (r += n, d = [], "[object Array]" === Object.prototype.toString.apply(l)) {
                    for (u = l.length, a = 0; a < u; a += 1) {
                      d[a] = e(a, l) || "null";
                    }

                    return c = 0 === d.length ? "[]" : r ? "[\n" + r + d.join(",\n" + r) + "\n" + h + "]" : "[" + d.join(",") + "]", r = h, c;
                  }

                  if (i && "object" == typeof i) for (u = i.length, a = 0; a < u; a += 1) {
                    "string" == typeof (f = i[a]) && (c = e(f, l)) && d.push(s(f) + (r ? ": " : ":") + c);
                  } else for (f in l) {
                    Object.prototype.hasOwnProperty.call(l, f) && (c = e(f, l)) && d.push(s(f) + (r ? ": " : ":") + c);
                  }
                  return c = 0 === d.length ? "{}" : r ? "{\n" + r + d.join(",\n" + r) + "\n" + h + "}" : "{" + d.join(",") + "}", r = h, c;
              }
            }("", {
              "": e
            });
          };
        },
        "./node_modules/md5.js/index.js":
        /*!**************************************!*\
          !*** ./node_modules/md5.js/index.js ***!
          \**************************************/

        /*! no static exports found */
        function node_modulesMd5JsIndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! hash-base */
          "./node_modules/hash-base/index.js"),
              o = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              a = new Array(16);

          function s() {
            i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
          }

          function f(e, t) {
            return e << t | e >>> 32 - t;
          }

          function c(e, t, r, n, i, o, a) {
            return f(e + (t & r | ~t & n) + i + o | 0, a) + t | 0;
          }

          function u(e, t, r, n, i, o, a) {
            return f(e + (t & n | r & ~n) + i + o | 0, a) + t | 0;
          }

          function d(e, t, r, n, i, o, a) {
            return f(e + (t ^ r ^ n) + i + o | 0, a) + t | 0;
          }

          function h(e, t, r, n, i, o, a) {
            return f(e + (r ^ (t | ~n)) + i + o | 0, a) + t | 0;
          }

          n(s, i), s.prototype._update = function () {
            for (var e = a, t = 0; t < 16; ++t) {
              e[t] = this._block.readInt32LE(4 * t);
            }

            var r = this._a,
                n = this._b,
                i = this._c,
                o = this._d;
            r = c(r, n, i, o, e[0], 3614090360, 7), o = c(o, r, n, i, e[1], 3905402710, 12), i = c(i, o, r, n, e[2], 606105819, 17), n = c(n, i, o, r, e[3], 3250441966, 22), r = c(r, n, i, o, e[4], 4118548399, 7), o = c(o, r, n, i, e[5], 1200080426, 12), i = c(i, o, r, n, e[6], 2821735955, 17), n = c(n, i, o, r, e[7], 4249261313, 22), r = c(r, n, i, o, e[8], 1770035416, 7), o = c(o, r, n, i, e[9], 2336552879, 12), i = c(i, o, r, n, e[10], 4294925233, 17), n = c(n, i, o, r, e[11], 2304563134, 22), r = c(r, n, i, o, e[12], 1804603682, 7), o = c(o, r, n, i, e[13], 4254626195, 12), i = c(i, o, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, o, r, e[15], 1236535329, 22), i, o, e[1], 4129170786, 5), o = u(o, r, n, i, e[6], 3225465664, 9), i = u(i, o, r, n, e[11], 643717713, 14), n = u(n, i, o, r, e[0], 3921069994, 20), r = u(r, n, i, o, e[5], 3593408605, 5), o = u(o, r, n, i, e[10], 38016083, 9), i = u(i, o, r, n, e[15], 3634488961, 14), n = u(n, i, o, r, e[4], 3889429448, 20), r = u(r, n, i, o, e[9], 568446438, 5), o = u(o, r, n, i, e[14], 3275163606, 9), i = u(i, o, r, n, e[3], 4107603335, 14), n = u(n, i, o, r, e[8], 1163531501, 20), r = u(r, n, i, o, e[13], 2850285829, 5), o = u(o, r, n, i, e[2], 4243563512, 9), i = u(i, o, r, n, e[7], 1735328473, 14), r = d(r, n = u(n, i, o, r, e[12], 2368359562, 20), i, o, e[5], 4294588738, 4), o = d(o, r, n, i, e[8], 2272392833, 11), i = d(i, o, r, n, e[11], 1839030562, 16), n = d(n, i, o, r, e[14], 4259657740, 23), r = d(r, n, i, o, e[1], 2763975236, 4), o = d(o, r, n, i, e[4], 1272893353, 11), i = d(i, o, r, n, e[7], 4139469664, 16), n = d(n, i, o, r, e[10], 3200236656, 23), r = d(r, n, i, o, e[13], 681279174, 4), o = d(o, r, n, i, e[0], 3936430074, 11), i = d(i, o, r, n, e[3], 3572445317, 16), n = d(n, i, o, r, e[6], 76029189, 23), r = d(r, n, i, o, e[9], 3654602809, 4), o = d(o, r, n, i, e[12], 3873151461, 11), i = d(i, o, r, n, e[15], 530742520, 16), r = h(r, n = d(n, i, o, r, e[2], 3299628645, 23), i, o, e[0], 4096336452, 6), o = h(o, r, n, i, e[7], 1126891415, 10), i = h(i, o, r, n, e[14], 2878612391, 15), n = h(n, i, o, r, e[5], 4237533241, 21), r = h(r, n, i, o, e[12], 1700485571, 6), o = h(o, r, n, i, e[3], 2399980690, 10), i = h(i, o, r, n, e[10], 4293915773, 15), n = h(n, i, o, r, e[1], 2240044497, 21), r = h(r, n, i, o, e[8], 1873313359, 6), o = h(o, r, n, i, e[15], 4264355552, 10), i = h(i, o, r, n, e[6], 2734768916, 15), n = h(n, i, o, r, e[13], 1309151649, 21), r = h(r, n, i, o, e[4], 4149444226, 6), o = h(o, r, n, i, e[11], 3174756917, 10), i = h(i, o, r, n, e[2], 718787259, 15), n = h(n, i, o, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
          }, s.prototype._digest = function () {
            this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
            var e = o.allocUnsafe(16);
            return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
          }, e.exports = s;
        },
        "./node_modules/minimalistic-assert/index.js":
        /*!***************************************************!*\
          !*** ./node_modules/minimalistic-assert/index.js ***!
          \***************************************************/

        /*! no static exports found */
        function node_modulesMinimalisticAssertIndexJs(e, t) {
          function r(e, t) {
            if (!e) throw new Error(t || "Assertion failed");
          }

          e.exports = r, r.equal = function (e, t, r) {
            if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
          };
        },
        "./node_modules/minimalistic-crypto-utils/lib/utils.js":
        /*!*************************************************************!*\
          !*** ./node_modules/minimalistic-crypto-utils/lib/utils.js ***!
          \*************************************************************/

        /*! no static exports found */
        function node_modulesMinimalisticCryptoUtilsLibUtilsJs(e, t, r) {
          "use strict";

          var n = t;

          function i(e) {
            return 1 === e.length ? "0" + e : e;
          }

          function o(e) {
            for (var t = "", r = 0; r < e.length; r++) {
              t += i(e[r].toString(16));
            }

            return t;
          }

          n.toArray = function (e, t) {
            if (Array.isArray(e)) return e.slice();
            if (!e) return [];
            var r = [];

            if ("string" != typeof e) {
              for (var n = 0; n < e.length; n++) {
                r[n] = 0 | e[n];
              }

              return r;
            }

            if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2) {
              r.push(parseInt(e[n] + e[n + 1], 16));
            } else for (n = 0; n < e.length; n++) {
              var i = e.charCodeAt(n),
                  o = i >> 8,
                  a = 255 & i;
              o ? r.push(o, a) : r.push(a);
            }
            return r;
          }, n.zero2 = i, n.toHex = o, n.encode = function (e, t) {
            return "hex" === t ? o(e) : e;
          };
        },
        "./node_modules/msgpack-lite/lib/browser.js":
        /*!**************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/browser.js ***!
          \**************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBrowserJs(e, t, r) {
          t.encode = r(
          /*! ./encode */
          "./node_modules/msgpack-lite/lib/encode.js").encode, t.decode = r(
          /*! ./decode */
          "./node_modules/msgpack-lite/lib/decode.js").decode, t.Encoder = r(
          /*! ./encoder */
          "./node_modules/msgpack-lite/lib/encoder.js").Encoder, t.Decoder = r(
          /*! ./decoder */
          "./node_modules/msgpack-lite/lib/decoder.js").Decoder, t.createCodec = r(
          /*! ./ext */
          "./node_modules/msgpack-lite/lib/ext.js").createCodec, t.codec = r(
          /*! ./codec */
          "./node_modules/msgpack-lite/lib/codec.js").codec;
        },
        "./node_modules/msgpack-lite/lib/buffer-global.js":
        /*!********************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/buffer-global.js ***!
          \********************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBufferGlobalJs(e, t, r) {
          (function (t) {
            function r(e) {
              return e && e.isBuffer && e;
            }

            e.exports = r(void 0 !== t && t) || r(this.Buffer) || r("undefined" != typeof window && window.Buffer) || this.Buffer;
          }).call(this, r(
          /*! ./../../buffer/index.js */
          "./node_modules/buffer/index.js").Buffer);
        },
        "./node_modules/msgpack-lite/lib/buffer-lite.js":
        /*!******************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/buffer-lite.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBufferLiteJs(e, t) {
          t.copy = function (e, t, r, n) {
            var i;
            r || (r = 0), n || 0 === n || (n = this.length), t || (t = 0);
            var o = n - r;
            if (e === this && r < t && t < n) for (i = o - 1; i >= 0; i--) {
              e[i + t] = this[i + r];
            } else for (i = 0; i < o; i++) {
              e[i + t] = this[i + r];
            }
            return o;
          }, t.toString = function (e, t, r) {
            var n = 0 | t;
            r || (r = this.length);

            for (var i = "", o = 0; n < r;) {
              (o = this[n++]) < 128 ? i += String.fromCharCode(o) : (192 == (224 & o) ? o = (31 & o) << 6 | 63 & this[n++] : 224 == (240 & o) ? o = (15 & o) << 12 | (63 & this[n++]) << 6 | 63 & this[n++] : 240 == (248 & o) && (o = (7 & o) << 18 | (63 & this[n++]) << 12 | (63 & this[n++]) << 6 | 63 & this[n++]), o >= 65536 ? (o -= 65536, i += String.fromCharCode(55296 + (o >>> 10), 56320 + (1023 & o))) : i += String.fromCharCode(o));
            }

            return i;
          }, t.write = function (e, t) {
            for (var r = t || (t |= 0), n = e.length, i = 0, o = 0; o < n;) {
              (i = e.charCodeAt(o++)) < 128 ? this[r++] = i : i < 2048 ? (this[r++] = 192 | i >>> 6, this[r++] = 128 | 63 & i) : i < 55296 || i > 57343 ? (this[r++] = 224 | i >>> 12, this[r++] = 128 | i >>> 6 & 63, this[r++] = 128 | 63 & i) : (i = 65536 + (i - 55296 << 10 | e.charCodeAt(o++) - 56320), this[r++] = 240 | i >>> 18, this[r++] = 128 | i >>> 12 & 63, this[r++] = 128 | i >>> 6 & 63, this[r++] = 128 | 63 & i);
            }

            return r - t;
          };
        },
        "./node_modules/msgpack-lite/lib/bufferish-array.js":
        /*!**********************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/bufferish-array.js ***!
          \**********************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBufferishArrayJs(e, t, r) {
          var n = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js");

          function i(e) {
            return new Array(e);
          }

          (t = e.exports = i(0)).alloc = i, t.concat = n.concat, t.from = function (e) {
            if (!n.isBuffer(e) && n.isView(e)) e = n.Uint8Array.from(e);else if (n.isArrayBuffer(e)) e = new Uint8Array(e);else {
              if ("string" == typeof e) return n.from.call(t, e);
              if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
            }
            return Array.prototype.slice.call(e);
          };
        },
        "./node_modules/msgpack-lite/lib/bufferish-buffer.js":
        /*!***********************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/bufferish-buffer.js ***!
          \***********************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBufferishBufferJs(e, t, r) {
          var n = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js"),
              i = n.global;
          (t = e.exports = n.hasBuffer ? i.alloc(0) : []).alloc = n.hasBuffer && i.alloc, t.concat = n.concat, t.from = function (e) {
            if (!n.isBuffer(e) && n.isView(e)) e = n.Uint8Array.from(e);else if (n.isArrayBuffer(e)) e = new Uint8Array(e);else {
              if ("string" == typeof e) return n.from.call(t, e);
              if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
            }
            return i.from(e);
          };
        },
        "./node_modules/msgpack-lite/lib/bufferish-proto.js":
        /*!**********************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/bufferish-proto.js ***!
          \**********************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBufferishProtoJs(e, t, r) {
          var n,
              i = r(
          /*! ./buffer-lite */
          "./node_modules/msgpack-lite/lib/buffer-lite.js");
          t.copy = c, t.slice = u, t.toString = function (e, t, r) {
            var n = !s && o.isBuffer(this) ? this.toString : i.toString;
            return n.apply(this, arguments);
          }, t.write = (n = "write", function () {
            var e = this[n] || i[n];
            return e.apply(this, arguments);
          });
          var o = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js"),
              a = o.global,
              s = o.hasBuffer && "TYPED_ARRAY_SUPPORT" in a,
              f = s && !a.TYPED_ARRAY_SUPPORT;

          function c(e, t, r, n) {
            var a = o.isBuffer(this),
                s = o.isBuffer(e);
            if (a && s) return this.copy(e, t, r, n);
            if (f || a || s || !o.isView(this) || !o.isView(e)) return i.copy.call(this, e, t, r, n);
            var c = r || null != n ? u.call(this, r, n) : this;
            return e.set(c, t), c.length;
          }

          function u(e, t) {
            var r = this.slice || !f && this.subarray;
            if (r) return r.call(this, e, t);
            var n = o.alloc.call(this, t - e);
            return c.call(this, n, 0, e, t), n;
          }
        },
        "./node_modules/msgpack-lite/lib/bufferish-uint8array.js":
        /*!***************************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/bufferish-uint8array.js ***!
          \***************************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBufferishUint8arrayJs(e, t, r) {
          var n = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js");

          function i(e) {
            return new Uint8Array(e);
          }

          (t = e.exports = n.hasArrayBuffer ? i(0) : []).alloc = i, t.concat = n.concat, t.from = function (e) {
            if (n.isView(e)) {
              var r = e.byteOffset,
                  i = e.byteLength;
              (e = e.buffer).byteLength !== i && (e.slice ? e = e.slice(r, r + i) : (e = new Uint8Array(e)).byteLength !== i && (e = Array.prototype.slice.call(e, r, r + i)));
            } else {
              if ("string" == typeof e) return n.from.call(t, e);
              if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
            }

            return new Uint8Array(e);
          };
        },
        "./node_modules/msgpack-lite/lib/bufferish.js":
        /*!****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/bufferish.js ***!
          \****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibBufferishJs(e, t, r) {
          var n = t.global = r(
          /*! ./buffer-global */
          "./node_modules/msgpack-lite/lib/buffer-global.js"),
              i = t.hasBuffer = n && !!n.isBuffer,
              o = t.hasArrayBuffer = "undefined" != typeof ArrayBuffer,
              a = t.isArray = r(
          /*! isarray */
          "./node_modules/isarray/index.js");
          t.isArrayBuffer = o ? function (e) {
            return e instanceof ArrayBuffer || p(e);
          } : y;
          var s = t.isBuffer = i ? n.isBuffer : y,
              f = t.isView = o ? ArrayBuffer.isView || v("ArrayBuffer", "buffer") : y;
          t.alloc = l, t.concat = function (e, r) {
            r || (r = 0, Array.prototype.forEach.call(e, function (e) {
              r += e.length;
            }));
            var n = this !== t && this || e[0],
                i = l.call(n, r),
                o = 0;
            return Array.prototype.forEach.call(e, function (e) {
              o += h.copy.call(e, i, o);
            }), i;
          }, t.from = function (e) {
            return "string" == typeof e ? b.call(this, e) : m(this).from(e);
          };
          var c = t.Array = r(
          /*! ./bufferish-array */
          "./node_modules/msgpack-lite/lib/bufferish-array.js"),
              u = t.Buffer = r(
          /*! ./bufferish-buffer */
          "./node_modules/msgpack-lite/lib/bufferish-buffer.js"),
              d = t.Uint8Array = r(
          /*! ./bufferish-uint8array */
          "./node_modules/msgpack-lite/lib/bufferish-uint8array.js"),
              h = t.prototype = r(
          /*! ./bufferish-proto */
          "./node_modules/msgpack-lite/lib/bufferish-proto.js");

          function l(e) {
            return m(this).alloc(e);
          }

          var p = v("ArrayBuffer");

          function b(e) {
            var t = 3 * e.length,
                r = l.call(this, t),
                n = h.write.call(r, e);
            return t !== n && (r = h.slice.call(r, 0, n)), r;
          }

          function m(e) {
            return s(e) ? u : f(e) ? d : a(e) ? c : i ? u : o ? d : c;
          }

          function y() {
            return !1;
          }

          function v(e, t) {
            return e = "[object " + e + "]", function (r) {
              return null != r && {}.toString.call(t ? r[t] : r) === e;
            };
          }
        },
        "./node_modules/msgpack-lite/lib/codec-base.js":
        /*!*****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/codec-base.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibCodecBaseJs(e, t, r) {
          var n = r(
          /*! isarray */
          "./node_modules/isarray/index.js");
          t.createCodec = s, t.install = function (e) {
            for (var t in e) {
              o.prototype[t] = a(o.prototype[t], e[t]);
            }
          }, t.filter = function (e) {
            return n(e) ? function (e) {
              return e = e.slice(), function (r) {
                return e.reduce(t, r);
              };

              function t(e, t) {
                return t(e);
              }
            }(e) : e;
          };
          var i = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js");

          function o(e) {
            if (!(this instanceof o)) return new o(e);
            this.options = e, this.init();
          }

          function a(e, t) {
            return e && t ? function () {
              return e.apply(this, arguments), t.apply(this, arguments);
            } : e || t;
          }

          function s(e) {
            return new o(e);
          }

          o.prototype.init = function () {
            var e = this.options;
            return e && e.uint8array && (this.bufferish = i.Uint8Array), this;
          }, t.preset = s({
            preset: !0
          });
        },
        "./node_modules/msgpack-lite/lib/codec.js":
        /*!************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/codec.js ***!
          \************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibCodecJs(e, t, r) {
          r(
          /*! ./read-core */
          "./node_modules/msgpack-lite/lib/read-core.js"), r(
          /*! ./write-core */
          "./node_modules/msgpack-lite/lib/write-core.js"), t.codec = {
            preset: r(
            /*! ./codec-base */
            "./node_modules/msgpack-lite/lib/codec-base.js").preset
          };
        },
        "./node_modules/msgpack-lite/lib/decode-buffer.js":
        /*!********************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/decode-buffer.js ***!
          \********************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibDecodeBufferJs(e, t, r) {
          t.DecodeBuffer = i;
          var n = r(
          /*! ./read-core */
          "./node_modules/msgpack-lite/lib/read-core.js").preset;

          function i(e) {
            if (!(this instanceof i)) return new i(e);

            if (e && (this.options = e, e.codec)) {
              var t = this.codec = e.codec;
              t.bufferish && (this.bufferish = t.bufferish);
            }
          }

          r(
          /*! ./flex-buffer */
          "./node_modules/msgpack-lite/lib/flex-buffer.js").FlexDecoder.mixin(i.prototype), i.prototype.codec = n, i.prototype.fetch = function () {
            return this.codec.decode(this);
          };
        },
        "./node_modules/msgpack-lite/lib/decode.js":
        /*!*************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/decode.js ***!
          \*************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibDecodeJs(e, t, r) {
          t.decode = function (e, t) {
            var r = new n(t);
            return r.write(e), r.read();
          };

          var n = r(
          /*! ./decode-buffer */
          "./node_modules/msgpack-lite/lib/decode-buffer.js").DecodeBuffer;
        },
        "./node_modules/msgpack-lite/lib/decoder.js":
        /*!**************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/decoder.js ***!
          \**************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibDecoderJs(e, t, r) {
          t.Decoder = o;
          var n = r(
          /*! event-lite */
          "./node_modules/event-lite/event-lite.js"),
              i = r(
          /*! ./decode-buffer */
          "./node_modules/msgpack-lite/lib/decode-buffer.js").DecodeBuffer;

          function o(e) {
            if (!(this instanceof o)) return new o(e);
            i.call(this, e);
          }

          o.prototype = new i(), n.mixin(o.prototype), o.prototype.decode = function (e) {
            arguments.length && this.write(e), this.flush();
          }, o.prototype.push = function (e) {
            this.emit("data", e);
          }, o.prototype.end = function (e) {
            this.decode(e), this.emit("end");
          };
        },
        "./node_modules/msgpack-lite/lib/encode-buffer.js":
        /*!********************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/encode-buffer.js ***!
          \********************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibEncodeBufferJs(e, t, r) {
          t.EncodeBuffer = i;
          var n = r(
          /*! ./write-core */
          "./node_modules/msgpack-lite/lib/write-core.js").preset;

          function i(e) {
            if (!(this instanceof i)) return new i(e);

            if (e && (this.options = e, e.codec)) {
              var t = this.codec = e.codec;
              t.bufferish && (this.bufferish = t.bufferish);
            }
          }

          r(
          /*! ./flex-buffer */
          "./node_modules/msgpack-lite/lib/flex-buffer.js").FlexEncoder.mixin(i.prototype), i.prototype.codec = n, i.prototype.write = function (e) {
            this.codec.encode(this, e);
          };
        },
        "./node_modules/msgpack-lite/lib/encode.js":
        /*!*************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/encode.js ***!
          \*************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibEncodeJs(e, t, r) {
          t.encode = function (e, t) {
            var r = new n(t);
            return r.write(e), r.read();
          };

          var n = r(
          /*! ./encode-buffer */
          "./node_modules/msgpack-lite/lib/encode-buffer.js").EncodeBuffer;
        },
        "./node_modules/msgpack-lite/lib/encoder.js":
        /*!**************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/encoder.js ***!
          \**************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibEncoderJs(e, t, r) {
          t.Encoder = o;
          var n = r(
          /*! event-lite */
          "./node_modules/event-lite/event-lite.js"),
              i = r(
          /*! ./encode-buffer */
          "./node_modules/msgpack-lite/lib/encode-buffer.js").EncodeBuffer;

          function o(e) {
            if (!(this instanceof o)) return new o(e);
            i.call(this, e);
          }

          o.prototype = new i(), n.mixin(o.prototype), o.prototype.encode = function (e) {
            this.write(e), this.emit("data", this.read());
          }, o.prototype.end = function (e) {
            arguments.length && this.encode(e), this.flush(), this.emit("end");
          };
        },
        "./node_modules/msgpack-lite/lib/ext-buffer.js":
        /*!*****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/ext-buffer.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibExtBufferJs(e, t, r) {
          t.ExtBuffer = function e(t, r) {
            if (!(this instanceof e)) return new e(t, r);
            this.buffer = n.from(t), this.type = r;
          };

          var n = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js");
        },
        "./node_modules/msgpack-lite/lib/ext-packer.js":
        /*!*****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/ext-packer.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibExtPackerJs(e, t, r) {
          t.setExtPackers = function (e) {
            e.addExtPacker(14, Error, [l, f]), e.addExtPacker(1, EvalError, [l, f]), e.addExtPacker(2, RangeError, [l, f]), e.addExtPacker(3, ReferenceError, [l, f]), e.addExtPacker(4, SyntaxError, [l, f]), e.addExtPacker(5, TypeError, [l, f]), e.addExtPacker(6, URIError, [l, f]), e.addExtPacker(10, RegExp, [h, f]), e.addExtPacker(11, Boolean, [d, f]), e.addExtPacker(12, String, [d, f]), e.addExtPacker(13, Date, [Number, f]), e.addExtPacker(15, Number, [d, f]), "undefined" != typeof Uint8Array && (e.addExtPacker(17, Int8Array, a), e.addExtPacker(18, Uint8Array, a), e.addExtPacker(19, Int16Array, a), e.addExtPacker(20, Uint16Array, a), e.addExtPacker(21, Int32Array, a), e.addExtPacker(22, Uint32Array, a), e.addExtPacker(23, Float32Array, a), "undefined" != typeof Float64Array && e.addExtPacker(24, Float64Array, a), "undefined" != typeof Uint8ClampedArray && e.addExtPacker(25, Uint8ClampedArray, a), e.addExtPacker(26, ArrayBuffer, a), e.addExtPacker(29, DataView, a)), i.hasBuffer && e.addExtPacker(27, o, i.from), e.addExtPacker(30, void 0, [c, f]), "undefined" != typeof BigInt && e.addExtPacker(31, BigInt, [u, f]);
          };

          var n,
              i = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js"),
              o = i.global,
              a = i.Uint8Array.from,
              s = {
            name: 1,
            message: 1,
            stack: 1,
            columnNumber: 1,
            fileName: 1,
            lineNumber: 1
          };

          function f(e) {
            return n || (n = r(
            /*! ./encode */
            "./node_modules/msgpack-lite/lib/encode.js").encode), n(e);
          }

          function c() {
            return 0;
          }

          function u(e) {
            return e.toString();
          }

          function d(e) {
            return e.valueOf();
          }

          function h(e) {
            (e = RegExp.prototype.toString.call(e).split("/")).shift();
            var t = [e.pop()];
            return t.unshift(e.join("/")), t;
          }

          function l(e) {
            var t = {};

            for (var r in s) {
              t[r] = e[r];
            }

            return t;
          }
        },
        "./node_modules/msgpack-lite/lib/ext-unpacker.js":
        /*!*******************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/ext-unpacker.js ***!
          \*******************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibExtUnpackerJs(e, t, r) {
          t.setExtUnpackers = function (e) {
            e.addExtUnpacker(14, [s, c(Error)]), e.addExtUnpacker(1, [s, c(EvalError)]), e.addExtUnpacker(2, [s, c(RangeError)]), e.addExtUnpacker(3, [s, c(ReferenceError)]), e.addExtUnpacker(4, [s, c(SyntaxError)]), e.addExtUnpacker(5, [s, c(TypeError)]), e.addExtUnpacker(6, [s, c(URIError)]), e.addExtUnpacker(10, [s, f]), e.addExtUnpacker(11, [s, h(Boolean)]), e.addExtUnpacker(12, [s, h(String)]), e.addExtUnpacker(13, [s, h(Date)]), e.addExtUnpacker(15, [s, h(Number)]), "undefined" != typeof Uint8Array && (e.addExtUnpacker(17, h(Int8Array)), e.addExtUnpacker(18, h(Uint8Array)), e.addExtUnpacker(19, [l, h(Int16Array)]), e.addExtUnpacker(20, [l, h(Uint16Array)]), e.addExtUnpacker(21, [l, h(Int32Array)]), e.addExtUnpacker(22, [l, h(Uint32Array)]), e.addExtUnpacker(23, [l, h(Float32Array)]), "undefined" != typeof Float64Array && e.addExtUnpacker(24, [l, h(Float64Array)]), "undefined" != typeof Uint8ClampedArray && e.addExtUnpacker(25, h(Uint8ClampedArray)), e.addExtUnpacker(26, l), e.addExtUnpacker(29, [l, h(DataView)])), i.hasBuffer && e.addExtUnpacker(27, h(o)), e.addExtUnpacker(30, u), e.addExtUnpacker(31, [s, d]);
          };

          var n,
              i = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js"),
              o = i.global,
              a = {
            name: 1,
            message: 1,
            stack: 1,
            columnNumber: 1,
            fileName: 1,
            lineNumber: 1
          };

          function s(e) {
            return n || (n = r(
            /*! ./decode */
            "./node_modules/msgpack-lite/lib/decode.js").decode), n(e);
          }

          function f(e) {
            return RegExp.apply(null, e);
          }

          function c(e) {
            return function (t) {
              var r = new e();

              for (var n in a) {
                r[n] = t[n];
              }

              return r;
            };
          }

          function u() {}

          function d(e) {
            return "undefined" != typeof BigInt ? BigInt(e) : e;
          }

          function h(e) {
            return function (t) {
              return new e(t);
            };
          }

          function l(e) {
            return new Uint8Array(e).buffer;
          }
        },
        "./node_modules/msgpack-lite/lib/ext.js":
        /*!**********************************************!*\
          !*** ./node_modules/msgpack-lite/lib/ext.js ***!
          \**********************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibExtJs(e, t, r) {
          r(
          /*! ./read-core */
          "./node_modules/msgpack-lite/lib/read-core.js"), r(
          /*! ./write-core */
          "./node_modules/msgpack-lite/lib/write-core.js"), t.createCodec = r(
          /*! ./codec-base */
          "./node_modules/msgpack-lite/lib/codec-base.js").createCodec;
        },
        "./node_modules/msgpack-lite/lib/flex-buffer.js":
        /*!******************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/flex-buffer.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibFlexBufferJs(e, t, r) {
          t.FlexDecoder = i, t.FlexEncoder = o;
          var n = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js");

          function i() {
            if (!(this instanceof i)) return new i();
          }

          function o() {
            if (!(this instanceof o)) return new o();
          }

          function a() {
            throw new Error("method not implemented: write()");
          }

          function s() {
            throw new Error("method not implemented: fetch()");
          }

          function f() {
            return this.buffers && this.buffers.length ? (this.flush(), this.pull()) : this.fetch();
          }

          function c(e) {
            (this.buffers || (this.buffers = [])).push(e);
          }

          function u() {
            return (this.buffers || (this.buffers = [])).shift();
          }

          function d(e) {
            return function (t) {
              for (var r in e) {
                t[r] = e[r];
              }

              return t;
            };
          }

          i.mixin = d({
            bufferish: n,
            write: function write(e) {
              var t = this.offset ? n.prototype.slice.call(this.buffer, this.offset) : this.buffer;
              this.buffer = t ? e ? this.bufferish.concat([t, e]) : t : e, this.offset = 0;
            },
            fetch: s,
            flush: function flush() {
              for (; this.offset < this.buffer.length;) {
                var e,
                    t = this.offset;

                try {
                  e = this.fetch();
                } catch (e) {
                  if (e && "BUFFER_SHORTAGE" != e.message) throw e;
                  this.offset = t;
                  break;
                }

                this.push(e);
              }
            },
            push: c,
            pull: u,
            read: f,
            reserve: function reserve(e) {
              var t = this.offset,
                  r = t + e;
              if (r > this.buffer.length) throw new Error("BUFFER_SHORTAGE");
              return this.offset = r, t;
            },
            offset: 0
          }), i.mixin(i.prototype), o.mixin = d({
            bufferish: n,
            write: a,
            fetch: function fetch() {
              var e = this.start;

              if (e < this.offset) {
                var t = this.start = this.offset;
                return n.prototype.slice.call(this.buffer, e, t);
              }
            },
            flush: function flush() {
              for (; this.start < this.offset;) {
                var e = this.fetch();
                e && this.push(e);
              }
            },
            push: c,
            pull: function pull() {
              var e = this.buffers || (this.buffers = []),
                  t = e.length > 1 ? this.bufferish.concat(e) : e[0];
              return e.length = 0, t;
            },
            read: f,
            reserve: function reserve(e) {
              var t = 0 | e;

              if (this.buffer) {
                var r = this.buffer.length,
                    n = 0 | this.offset,
                    i = n + t;
                if (i < r) return this.offset = i, n;
                this.flush(), e = Math.max(e, Math.min(2 * r, this.maxBufferSize));
              }

              return e = Math.max(e, this.minBufferSize), this.buffer = this.bufferish.alloc(e), this.start = 0, this.offset = t, 0;
            },
            send: function send(e) {
              var t = e.length;
              if (t > this.minBufferSize) this.flush(), this.push(e);else {
                var r = this.reserve(t);
                n.prototype.copy.call(e, this.buffer, r);
              }
            },
            maxBufferSize: 65536,
            minBufferSize: 2048,
            offset: 0,
            start: 0
          }), o.mixin(o.prototype);
        },
        "./node_modules/msgpack-lite/lib/read-core.js":
        /*!****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/read-core.js ***!
          \****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibReadCoreJs(e, t, r) {
          var n = r(
          /*! ./ext-buffer */
          "./node_modules/msgpack-lite/lib/ext-buffer.js").ExtBuffer,
              i = r(
          /*! ./ext-unpacker */
          "./node_modules/msgpack-lite/lib/ext-unpacker.js"),
              o = r(
          /*! ./read-format */
          "./node_modules/msgpack-lite/lib/read-format.js").readUint8,
              a = r(
          /*! ./read-token */
          "./node_modules/msgpack-lite/lib/read-token.js"),
              s = r(
          /*! ./codec-base */
          "./node_modules/msgpack-lite/lib/codec-base.js");

          function f() {
            var e = this.options;
            return this.decode = function (e) {
              var t = a.getReadToken(e);
              return function (e) {
                var r = o(e),
                    n = t[r];
                if (!n) throw new Error("Invalid type: " + (r ? "0x" + r.toString(16) : r));
                return n(e);
              };
            }(e), e && e.preset && i.setExtUnpackers(this), this;
          }

          s.install({
            addExtUnpacker: function addExtUnpacker(e, t) {
              (this.extUnpackers || (this.extUnpackers = []))[e] = s.filter(t);
            },
            getExtUnpacker: function getExtUnpacker(e) {
              return (this.extUnpackers || (this.extUnpackers = []))[e] || function (t) {
                return new n(t, e);
              };
            },
            init: f
          }), t.preset = f.call(s.preset);
        },
        "./node_modules/msgpack-lite/lib/read-format.js":
        /*!******************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/read-format.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibReadFormatJs(e, t, r) {
          var n = r(
          /*! ieee754 */
          "./node_modules/ieee754/index.js"),
              i = r(
          /*! int64-buffer */
          "./node_modules/int64-buffer/int64-buffer.js"),
              o = i.Uint64BE,
              a = i.Int64BE;
          t.getReadFormat = function (e) {
            var t = s.hasArrayBuffer && e && e.binarraybuffer,
                r = e && e.int64;
            return {
              map: c && e && e.usemap ? d : u,
              array: h,
              str: l,
              bin: t ? b : p,
              ext: m,
              uint8: y,
              uint16: g,
              uint32: w,
              uint64: E(8, r ? M : A),
              int8: v,
              int16: _,
              int32: k,
              int64: E(8, r ? x : S),
              float32: E(4, I),
              float64: E(8, j)
            };
          }, t.readUint8 = y;
          var s = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js"),
              f = r(
          /*! ./bufferish-proto */
          "./node_modules/msgpack-lite/lib/bufferish-proto.js"),
              c = "undefined" != typeof Map;

          function u(e, t) {
            var r,
                n = {},
                i = new Array(t),
                o = new Array(t),
                a = e.codec.decode;

            for (r = 0; r < t; r++) {
              i[r] = a(e), o[r] = a(e);
            }

            for (r = 0; r < t; r++) {
              n[i[r]] = o[r];
            }

            return n;
          }

          function d(e, t) {
            var r,
                n = new Map(),
                i = new Array(t),
                o = new Array(t),
                a = e.codec.decode;

            for (r = 0; r < t; r++) {
              i[r] = a(e), o[r] = a(e);
            }

            for (r = 0; r < t; r++) {
              n.set(i[r], o[r]);
            }

            return n;
          }

          function h(e, t) {
            for (var r = new Array(t), n = e.codec.decode, i = 0; i < t; i++) {
              r[i] = n(e);
            }

            return r;
          }

          function l(e, t) {
            var r = e.reserve(t),
                n = r + t;
            return f.toString.call(e.buffer, "utf-8", r, n);
          }

          function p(e, t) {
            var r = e.reserve(t),
                n = r + t,
                i = f.slice.call(e.buffer, r, n);
            return s.from(i);
          }

          function b(e, t) {
            var r = e.reserve(t),
                n = r + t,
                i = f.slice.call(e.buffer, r, n);
            return s.Uint8Array.from(i).buffer;
          }

          function m(e, t) {
            var r = e.reserve(t + 1),
                n = e.buffer[r++],
                i = r + t,
                o = e.codec.getExtUnpacker(n);
            if (!o) throw new Error("Invalid ext type: " + (n ? "0x" + n.toString(16) : n));
            return o(f.slice.call(e.buffer, r, i));
          }

          function y(e) {
            var t = e.reserve(1);
            return e.buffer[t];
          }

          function v(e) {
            var t = e.reserve(1),
                r = e.buffer[t];
            return 128 & r ? r - 256 : r;
          }

          function g(e) {
            var t = e.reserve(2),
                r = e.buffer;
            return r[t++] << 8 | r[t];
          }

          function _(e) {
            var t = e.reserve(2),
                r = e.buffer,
                n = r[t++] << 8 | r[t];
            return 32768 & n ? n - 65536 : n;
          }

          function w(e) {
            var t = e.reserve(4),
                r = e.buffer;
            return 16777216 * r[t++] + (r[t++] << 16) + (r[t++] << 8) + r[t];
          }

          function k(e) {
            var t = e.reserve(4),
                r = e.buffer;
            return r[t++] << 24 | r[t++] << 16 | r[t++] << 8 | r[t];
          }

          function E(e, t) {
            return function (r) {
              var n = r.reserve(e);
              return t.call(r.buffer, n, !0);
            };
          }

          function A(e) {
            return new o(this, e).toNumber();
          }

          function S(e) {
            return new a(this, e).toNumber();
          }

          function M(e) {
            return new o(this, e);
          }

          function x(e) {
            return new a(this, e);
          }

          function I(e) {
            return n.read(this, e, !1, 23, 4);
          }

          function j(e) {
            return n.read(this, e, !1, 52, 8);
          }
        },
        "./node_modules/msgpack-lite/lib/read-token.js":
        /*!*****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/read-token.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibReadTokenJs(e, t, r) {
          var n = r(
          /*! ./read-format */
          "./node_modules/msgpack-lite/lib/read-format.js");

          function i(e) {
            var t,
                r = new Array(256);

            for (t = 0; t <= 127; t++) {
              r[t] = o(t);
            }

            for (t = 128; t <= 143; t++) {
              r[t] = s(t - 128, e.map);
            }

            for (t = 144; t <= 159; t++) {
              r[t] = s(t - 144, e.array);
            }

            for (t = 160; t <= 191; t++) {
              r[t] = s(t - 160, e.str);
            }

            for (r[192] = o(null), r[193] = null, r[194] = o(!1), r[195] = o(!0), r[196] = a(e.uint8, e.bin), r[197] = a(e.uint16, e.bin), r[198] = a(e.uint32, e.bin), r[199] = a(e.uint8, e.ext), r[200] = a(e.uint16, e.ext), r[201] = a(e.uint32, e.ext), r[202] = e.float32, r[203] = e.float64, r[204] = e.uint8, r[205] = e.uint16, r[206] = e.uint32, r[207] = e.uint64, r[208] = e.int8, r[209] = e.int16, r[210] = e.int32, r[211] = e.int64, r[212] = s(1, e.ext), r[213] = s(2, e.ext), r[214] = s(4, e.ext), r[215] = s(8, e.ext), r[216] = s(16, e.ext), r[217] = a(e.uint8, e.str), r[218] = a(e.uint16, e.str), r[219] = a(e.uint32, e.str), r[220] = a(e.uint16, e.array), r[221] = a(e.uint32, e.array), r[222] = a(e.uint16, e.map), r[223] = a(e.uint32, e.map), t = 224; t <= 255; t++) {
              r[t] = o(t - 256);
            }

            return r;
          }

          function o(e) {
            return function () {
              return e;
            };
          }

          function a(e, t) {
            return function (r) {
              var n = e(r);
              return t(r, n);
            };
          }

          function s(e, t) {
            return function (r) {
              return t(r, e);
            };
          }

          t.getReadToken = function (e) {
            var t = n.getReadFormat(e);
            return e && e.useraw ? function (e) {
              var t,
                  r = i(e).slice();

              for (r[217] = r[196], r[218] = r[197], r[219] = r[198], t = 160; t <= 191; t++) {
                r[t] = s(t - 160, e.bin);
              }

              return r;
            }(t) : i(t);
          };
        },
        "./node_modules/msgpack-lite/lib/write-core.js":
        /*!*****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/write-core.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibWriteCoreJs(e, t, r) {
          var n = r(
          /*! ./ext-buffer */
          "./node_modules/msgpack-lite/lib/ext-buffer.js").ExtBuffer,
              i = r(
          /*! ./ext-packer */
          "./node_modules/msgpack-lite/lib/ext-packer.js"),
              o = r(
          /*! ./write-type */
          "./node_modules/msgpack-lite/lib/write-type.js"),
              a = r(
          /*! ./codec-base */
          "./node_modules/msgpack-lite/lib/codec-base.js");

          function s() {
            var e = this.options;
            return this.encode = function (e) {
              var t = o.getWriteType(e);
              return function (e, r) {
                var n = t[typeof r];
                if (!n) throw new Error('Unsupported type "' + typeof r + '": ' + r);
                n(e, r);
              };
            }(e), e && e.preset && i.setExtPackers(this), this;
          }

          a.install({
            addExtPacker: function addExtPacker(e, t, r) {
              r = a.filter(r);
              var i = void 0 === t ? "undefined" : t.name;

              function o(t) {
                return r && (t = r(t)), new n(t, e);
              }

              i && "Object" !== i ? (this.extPackers || (this.extPackers = {}))[i] = o : (this.extEncoderList || (this.extEncoderList = [])).unshift([t, o]);
            },
            getExtPacker: function getExtPacker(e) {
              var t = this.extPackers || (this.extPackers = {}),
                  r = void 0 === e,
                  n = r ? void 0 : e.constructor,
                  i = r ? t.undefined : n && n.name && t[n.name];
              if (i) return i;

              for (var o = this.extEncoderList || (this.extEncoderList = []), a = o.length, s = 0; s < a; s++) {
                var f = o[s];
                if (n === f[0]) return f[1];
              }
            },
            init: s
          }), t.preset = s.call(a.preset);
        },
        "./node_modules/msgpack-lite/lib/write-token.js":
        /*!******************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/write-token.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibWriteTokenJs(e, t, r) {
          var n = r(
          /*! ieee754 */
          "./node_modules/ieee754/index.js"),
              i = r(
          /*! int64-buffer */
          "./node_modules/int64-buffer/int64-buffer.js"),
              o = i.Uint64BE,
              a = i.Int64BE,
              s = r(
          /*! ./write-uint8 */
          "./node_modules/msgpack-lite/lib/write-uint8.js").uint8,
              f = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js"),
              c = f.global,
              u = f.hasBuffer && "TYPED_ARRAY_SUPPORT" in c && !c.TYPED_ARRAY_SUPPORT,
              d = f.hasBuffer && c.prototype || {};

          function h() {
            var e = s.slice();
            return e[196] = l(196), e[197] = p(197), e[198] = b(198), e[199] = l(199), e[200] = p(200), e[201] = b(201), e[202] = m(202, 4, d.writeFloatBE || g, !0), e[203] = m(203, 8, d.writeDoubleBE || _, !0), e[204] = l(204), e[205] = p(205), e[206] = b(206), e[207] = m(207, 8, y), e[208] = l(208), e[209] = p(209), e[210] = b(210), e[211] = m(211, 8, v), e[217] = l(217), e[218] = p(218), e[219] = b(219), e[220] = p(220), e[221] = b(221), e[222] = p(222), e[223] = b(223), e;
          }

          function l(e) {
            return function (t, r) {
              var n = t.reserve(2),
                  i = t.buffer;
              i[n++] = e, i[n] = r;
            };
          }

          function p(e) {
            return function (t, r) {
              var n = t.reserve(3),
                  i = t.buffer;
              i[n++] = e, i[n++] = r >>> 8, i[n] = r;
            };
          }

          function b(e) {
            return function (t, r) {
              var n = t.reserve(5),
                  i = t.buffer;
              i[n++] = e, i[n++] = r >>> 24, i[n++] = r >>> 16, i[n++] = r >>> 8, i[n] = r;
            };
          }

          function m(e, t, r, n) {
            return function (i, o) {
              var a = i.reserve(t + 1);
              i.buffer[a++] = e, r.call(i.buffer, o, a, n);
            };
          }

          function y(e, t) {
            new o(this, t, e);
          }

          function v(e, t) {
            new a(this, t, e);
          }

          function g(e, t) {
            n.write(this, e, t, !1, 23, 4);
          }

          function _(e, t) {
            n.write(this, e, t, !1, 52, 8);
          }

          t.getWriteToken = function (e) {
            return e && e.uint8array ? ((t = h())[202] = m(202, 4, g), t[203] = m(203, 8, _), t) : u || f.hasBuffer && e && e.safe ? function () {
              var e = s.slice();
              return e[196] = m(196, 1, c.prototype.writeUInt8), e[197] = m(197, 2, c.prototype.writeUInt16BE), e[198] = m(198, 4, c.prototype.writeUInt32BE), e[199] = m(199, 1, c.prototype.writeUInt8), e[200] = m(200, 2, c.prototype.writeUInt16BE), e[201] = m(201, 4, c.prototype.writeUInt32BE), e[202] = m(202, 4, c.prototype.writeFloatBE), e[203] = m(203, 8, c.prototype.writeDoubleBE), e[204] = m(204, 1, c.prototype.writeUInt8), e[205] = m(205, 2, c.prototype.writeUInt16BE), e[206] = m(206, 4, c.prototype.writeUInt32BE), e[207] = m(207, 8, y), e[208] = m(208, 1, c.prototype.writeInt8), e[209] = m(209, 2, c.prototype.writeInt16BE), e[210] = m(210, 4, c.prototype.writeInt32BE), e[211] = m(211, 8, v), e[217] = m(217, 1, c.prototype.writeUInt8), e[218] = m(218, 2, c.prototype.writeUInt16BE), e[219] = m(219, 4, c.prototype.writeUInt32BE), e[220] = m(220, 2, c.prototype.writeUInt16BE), e[221] = m(221, 4, c.prototype.writeUInt32BE), e[222] = m(222, 2, c.prototype.writeUInt16BE), e[223] = m(223, 4, c.prototype.writeUInt32BE), e;
            }() : h();
            var t;
          };
        },
        "./node_modules/msgpack-lite/lib/write-type.js":
        /*!*****************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/write-type.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibWriteTypeJs(e, t, r) {
          var n = r(
          /*! isarray */
          "./node_modules/isarray/index.js"),
              i = r(
          /*! int64-buffer */
          "./node_modules/int64-buffer/int64-buffer.js"),
              o = i.Uint64BE,
              a = i.Int64BE,
              s = r(
          /*! ./bufferish */
          "./node_modules/msgpack-lite/lib/bufferish.js"),
              f = r(
          /*! ./bufferish-proto */
          "./node_modules/msgpack-lite/lib/bufferish-proto.js"),
              c = r(
          /*! ./write-token */
          "./node_modules/msgpack-lite/lib/write-token.js"),
              u = r(
          /*! ./write-uint8 */
          "./node_modules/msgpack-lite/lib/write-uint8.js").uint8,
              d = r(
          /*! ./ext-buffer */
          "./node_modules/msgpack-lite/lib/ext-buffer.js").ExtBuffer,
              h = "undefined" != typeof Uint8Array,
              l = "undefined" != typeof Map,
              p = [];
          p[1] = 212, p[2] = 213, p[4] = 214, p[8] = 215, p[16] = 216, t.getWriteType = function (e) {
            var t,
                r = c.getWriteToken(e),
                i = e && e.useraw,
                b = h && e && e.binarraybuffer,
                m = b ? s.isArrayBuffer : s.isBuffer,
                y = b ? function (e, t) {
              w(e, new Uint8Array(t));
            } : w,
                v = l && e && e.usemap ? function (e, t) {
              if (!(t instanceof Map)) return E(e, t);
              var n = t.size;
              r[n < 16 ? 128 + n : n <= 65535 ? 222 : 223](e, n);
              var i = e.codec.encode;
              t.forEach(function (t, r, n) {
                i(e, r), i(e, t);
              });
            } : E;
            return {
              boolean: function boolean(e, t) {
                r[t ? 195 : 194](e, t);
              },
              number: function number(e, t) {
                var n = 0 | t;
                t === n ? r[-32 <= n && n <= 127 ? 255 & n : 0 <= n ? n <= 255 ? 204 : n <= 65535 ? 205 : 206 : -128 <= n ? 208 : -32768 <= n ? 209 : 210](e, n) : r[203](e, t);
              },
              object: i ? function (e, t) {
                if (m(t)) return function (e, t) {
                  var n = t.length;
                  r[n < 32 ? 160 + n : n <= 65535 ? 218 : 219](e, n), e.send(t);
                }(e, t);
                g(e, t);
              } : g,
              string: (t = i ? function (e) {
                return e < 32 ? 1 : e <= 65535 ? 3 : 5;
              } : function (e) {
                return e < 32 ? 1 : e <= 255 ? 2 : e <= 65535 ? 3 : 5;
              }, function (e, n) {
                var i = n.length,
                    o = 5 + 3 * i;
                e.offset = e.reserve(o);
                var a = e.buffer,
                    s = t(i),
                    c = e.offset + s;
                i = f.write.call(a, n, c);
                var u = t(i);

                if (s !== u) {
                  var d = c + u - s,
                      h = c + i;
                  f.copy.call(a, a, d, c, h);
                }

                r[1 === u ? 160 + i : u <= 3 ? 215 + u : 219](e, i), e.offset += i;
              }),
              undefined: _,
              bigint: _
            };

            function g(e, t) {
              if (null === t) return function (e, t) {
                r[192](e, t);
              }(e, t);
              if (m(t)) return y(e, t);
              if (n(t)) return function (e, t) {
                var n = t.length;
                r[n < 16 ? 144 + n : n <= 65535 ? 220 : 221](e, n);

                for (var i = e.codec.encode, o = 0; o < n; o++) {
                  i(e, t[o]);
                }
              }(e, t);
              if (o.isUint64BE(t)) return function (e, t) {
                r[207](e, t.toArray());
              }(e, t);
              if (a.isInt64BE(t)) return function (e, t) {
                r[211](e, t.toArray());
              }(e, t);
              var i = e.codec.getExtPacker(t);
              if (i && (t = i(t)), t instanceof d) return k(e, t);
              v(e, t);
            }

            function _(e, t) {
              var r = e.codec.getExtPacker(t);
              return k(e, r(t));
            }

            function w(e, t) {
              var n = t.length;
              r[n < 255 ? 196 : n <= 65535 ? 197 : 198](e, n), e.send(t);
            }

            function k(e, t) {
              var n = t.buffer,
                  i = n.length,
                  o = p[i] || (i < 255 ? 199 : i <= 65535 ? 200 : 201);
              r[o](e, i), u[t.type](e), e.send(n);
            }

            function E(e, t) {
              var n = Object.keys(t),
                  i = n.length;
              r[i < 16 ? 128 + i : i <= 65535 ? 222 : 223](e, i);
              var o = e.codec.encode;
              n.forEach(function (r) {
                o(e, r), o(e, t[r]);
              });
            }
          };
        },
        "./node_modules/msgpack-lite/lib/write-uint8.js":
        /*!******************************************************!*\
          !*** ./node_modules/msgpack-lite/lib/write-uint8.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesMsgpackLiteLibWriteUint8Js(e, t) {
          for (var r = t.uint8 = new Array(256), n = 0; n <= 255; n++) {
            r[n] = i(n);
          }

          function i(e) {
            return function (t) {
              var r = t.reserve(1);
              t.buffer[r] = e;
            };
          }
        },
        "./node_modules/process-nextick-args/index.js":
        /*!****************************************************!*\
          !*** ./node_modules/process-nextick-args/index.js ***!
          \****************************************************/

        /*! no static exports found */
        function node_modulesProcessNextickArgsIndexJs(e, t, r) {
          "use strict";

          (function (t) {
            !t.version || 0 === t.version.indexOf("v0.") || 0 === t.version.indexOf("v1.") && 0 !== t.version.indexOf("v1.8.") ? e.exports = {
              nextTick: function nextTick(e, r, n, i) {
                if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
                var o,
                    a,
                    s = arguments.length;

                switch (s) {
                  case 0:
                  case 1:
                    return t.nextTick(e);

                  case 2:
                    return t.nextTick(function () {
                      e.call(null, r);
                    });

                  case 3:
                    return t.nextTick(function () {
                      e.call(null, r, n);
                    });

                  case 4:
                    return t.nextTick(function () {
                      e.call(null, r, n, i);
                    });

                  default:
                    for (o = new Array(s - 1), a = 0; a < o.length;) {
                      o[a++] = arguments[a];
                    }

                    return t.nextTick(function () {
                      e.apply(null, o);
                    });
                }
              }
            } : e.exports = t;
          }).call(this, r(
          /*! ./../process/browser.js */
          "./node_modules/process/browser.js"));
        },
        "./node_modules/process/browser.js":
        /*!*****************************************!*\
          !*** ./node_modules/process/browser.js ***!
          \*****************************************/

        /*! no static exports found */
        function node_modulesProcessBrowserJs(e, t) {
          var r,
              n,
              i = e.exports = {};

          function o() {
            throw new Error("setTimeout has not been defined");
          }

          function a() {
            throw new Error("clearTimeout has not been defined");
          }

          function s(e) {
            if (r === setTimeout) return setTimeout(e, 0);
            if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

            try {
              return r(e, 0);
            } catch (t) {
              try {
                return r.call(null, e, 0);
              } catch (t) {
                return r.call(this, e, 0);
              }
            }
          }

          !function () {
            try {
              r = "function" == typeof setTimeout ? setTimeout : o;
            } catch (e) {
              r = o;
            }

            try {
              n = "function" == typeof clearTimeout ? clearTimeout : a;
            } catch (e) {
              n = a;
            }
          }();
          var f,
              c = [],
              u = !1,
              d = -1;

          function h() {
            u && f && (u = !1, f.length ? c = f.concat(c) : d = -1, c.length && l());
          }

          function l() {
            if (!u) {
              var e = s(h);
              u = !0;

              for (var t = c.length; t;) {
                for (f = c, c = []; ++d < t;) {
                  f && f[d].run();
                }

                d = -1, t = c.length;
              }

              f = null, u = !1, function (e) {
                if (n === clearTimeout) return clearTimeout(e);
                if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);

                try {
                  n(e);
                } catch (t) {
                  try {
                    return n.call(null, e);
                  } catch (t) {
                    return n.call(this, e);
                  }
                }
              }(e);
            }
          }

          function p(e, t) {
            this.fun = e, this.array = t;
          }

          function b() {}

          i.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
              t[r - 1] = arguments[r];
            }
            c.push(new p(e, t)), 1 !== c.length || u || s(l);
          }, p.prototype.run = function () {
            this.fun.apply(null, this.array);
          }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = b, i.addListener = b, i.once = b, i.off = b, i.removeListener = b, i.removeAllListeners = b, i.emit = b, i.prependListener = b, i.prependOnceListener = b, i.listeners = function (e) {
            return [];
          }, i.binding = function (e) {
            throw new Error("process.binding is not supported");
          }, i.cwd = function () {
            return "/";
          }, i.chdir = function (e) {
            throw new Error("process.chdir is not supported");
          }, i.umask = function () {
            return 0;
          };
        },
        "./node_modules/randombytes/browser.js":
        /*!*********************************************!*\
          !*** ./node_modules/randombytes/browser.js ***!
          \*********************************************/

        /*! no static exports found */
        function node_modulesRandombytesBrowserJs(e, t, r) {
          "use strict";

          (function (t, n) {
            var i = r(
            /*! safe-buffer */
            "./node_modules/safe-buffer/index.js").Buffer,
                o = t.crypto || t.msCrypto;
            o && o.getRandomValues ? e.exports = function (e, t) {
              if (e > 4294967295) throw new RangeError("requested too many random bytes");
              var r = i.allocUnsafe(e);
              if (e > 0) if (e > 65536) for (var a = 0; a < e; a += 65536) {
                o.getRandomValues(r.slice(a, a + 65536));
              } else o.getRandomValues(r);
              return "function" == typeof t ? n.nextTick(function () {
                t(null, r);
              }) : r;
            } : e.exports = function () {
              throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
            };
          }).call(this, r(
          /*! ./../webpack/buildin/global.js */
          "./node_modules/webpack/buildin/global.js"), r(
          /*! ./../process/browser.js */
          "./node_modules/process/browser.js"));
        },
        "./node_modules/readable-stream/duplex-browser.js":
        /*!********************************************************!*\
          !*** ./node_modules/readable-stream/duplex-browser.js ***!
          \********************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamDuplexBrowserJs(e, t, r) {
          e.exports = r(
          /*! ./lib/_stream_duplex.js */
          "./node_modules/readable-stream/lib/_stream_duplex.js");
        },
        "./node_modules/readable-stream/lib/_stream_duplex.js":
        /*!************************************************************!*\
          !*** ./node_modules/readable-stream/lib/_stream_duplex.js ***!
          \************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLib_stream_duplexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! process-nextick-args */
          "./node_modules/process-nextick-args/index.js"),
              i = Object.keys || function (e) {
            var t = [];

            for (var r in e) {
              t.push(r);
            }

            return t;
          };

          e.exports = d;
          var o = r(
          /*! core-util-is */
          "./node_modules/core-util-is/lib/util.js");
          o.inherits = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js");
          var a = r(
          /*! ./_stream_readable */
          "./node_modules/readable-stream/lib/_stream_readable.js"),
              s = r(
          /*! ./_stream_writable */
          "./node_modules/readable-stream/lib/_stream_writable.js");
          o.inherits(d, a);

          for (var f = i(s.prototype), c = 0; c < f.length; c++) {
            var u = f[c];
            d.prototype[u] || (d.prototype[u] = s.prototype[u]);
          }

          function d(e) {
            if (!(this instanceof d)) return new d(e);
            a.call(this, e), s.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", h);
          }

          function h() {
            this.allowHalfOpen || this._writableState.ended || n.nextTick(l, this);
          }

          function l(e) {
            e.end();
          }

          Object.defineProperty(d.prototype, "writableHighWaterMark", {
            enumerable: !1,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          }), Object.defineProperty(d.prototype, "destroyed", {
            get: function get() {
              return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
            },
            set: function set(e) {
              void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
            }
          }), d.prototype._destroy = function (e, t) {
            this.push(null), this.end(), n.nextTick(t, e);
          };
        },
        "./node_modules/readable-stream/lib/_stream_passthrough.js":
        /*!*****************************************************************!*\
          !*** ./node_modules/readable-stream/lib/_stream_passthrough.js ***!
          \*****************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLib_stream_passthroughJs(e, t, r) {
          "use strict";

          e.exports = o;
          var n = r(
          /*! ./_stream_transform */
          "./node_modules/readable-stream/lib/_stream_transform.js"),
              i = r(
          /*! core-util-is */
          "./node_modules/core-util-is/lib/util.js");

          function o(e) {
            if (!(this instanceof o)) return new o(e);
            n.call(this, e);
          }

          i.inherits = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"), i.inherits(o, n), o.prototype._transform = function (e, t, r) {
            r(null, e);
          };
        },
        "./node_modules/readable-stream/lib/_stream_readable.js":
        /*!**************************************************************!*\
          !*** ./node_modules/readable-stream/lib/_stream_readable.js ***!
          \**************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLib_stream_readableJs(e, t, r) {
          "use strict";

          (function (t, n) {
            var i = r(
            /*! process-nextick-args */
            "./node_modules/process-nextick-args/index.js");
            e.exports = g;
            var o,
                a = r(
            /*! isarray */
            "./node_modules/isarray/index.js");
            g.ReadableState = v, r(
            /*! events */
            "./node_modules/events/events.js").EventEmitter;

            var s = function s(e, t) {
              return e.listeners(t).length;
            },
                f = r(
            /*! ./internal/streams/stream */
            "./node_modules/readable-stream/lib/internal/streams/stream-browser.js"),
                c = r(
            /*! safe-buffer */
            "./node_modules/safe-buffer/index.js").Buffer,
                u = t.Uint8Array || function () {},
                d = r(
            /*! core-util-is */
            "./node_modules/core-util-is/lib/util.js");

            d.inherits = r(
            /*! inherits */
            "./node_modules/inherits/inherits_browser.js");
            var h = r(
            /*! util */
            0),
                l = void 0;
            l = h && h.debuglog ? h.debuglog("stream") : function () {};
            var p,
                b = r(
            /*! ./internal/streams/BufferList */
            "./node_modules/readable-stream/lib/internal/streams/BufferList.js"),
                m = r(
            /*! ./internal/streams/destroy */
            "./node_modules/readable-stream/lib/internal/streams/destroy.js");
            d.inherits(g, f);
            var y = ["error", "close", "destroy", "pause", "resume"];

            function v(e, t) {
              e = e || {};
              var n = t instanceof (o = o || r(
              /*! ./_stream_duplex */
              "./node_modules/readable-stream/lib/_stream_duplex.js"));
              this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.readableObjectMode);
              var i = e.highWaterMark,
                  a = e.readableHighWaterMark,
                  s = this.objectMode ? 16 : 16384;
              this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new b(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (p || (p = r(
              /*! string_decoder/ */
              "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder), this.decoder = new p(e.encoding), this.encoding = e.encoding);
            }

            function g(e) {
              if (o = o || r(
              /*! ./_stream_duplex */
              "./node_modules/readable-stream/lib/_stream_duplex.js"), !(this instanceof g)) return new g(e);
              this._readableState = new v(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), f.call(this);
            }

            function _(e, t, r, n, i) {
              var o,
                  a = e._readableState;
              return null === t ? (a.reading = !1, function (e, t) {
                if (!t.ended) {
                  if (t.decoder) {
                    var r = t.decoder.end();
                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                  }

                  t.ended = !0, E(e);
                }
              }(e, a)) : (i || (o = function (e, t) {
                var r, n;
                return n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk")), r;
              }(a, t)), o ? e.emit("error", o) : a.objectMode || t && t.length > 0 ? ("string" == typeof t || a.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function (e) {
                return c.from(e);
              }(t)), n ? a.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : w(e, a, t, !0) : a.ended ? e.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !r ? (t = a.decoder.write(t), a.objectMode || 0 !== t.length ? w(e, a, t, !1) : S(e, a)) : w(e, a, t, !1))) : n || (a.reading = !1)), function (e) {
                return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
              }(a);
            }

            function w(e, t, r, n) {
              t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && E(e)), S(e, t);
            }

            function k(e, t) {
              return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
                return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
              }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
            }

            function E(e) {
              var t = e._readableState;
              t.needReadable = !1, t.emittedReadable || (l("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(A, e) : A(e));
            }

            function A(e) {
              l("emit readable"), e.emit("readable"), j(e);
            }

            function S(e, t) {
              t.readingMore || (t.readingMore = !0, i.nextTick(M, e, t));
            }

            function M(e, t) {
              for (var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (l("maybeReadMore read 0"), e.read(0), r !== t.length);) {
                r = t.length;
              }

              t.readingMore = !1;
            }

            function x(e) {
              l("readable nexttick read 0"), e.read(0);
            }

            function I(e, t) {
              t.reading || (l("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), j(e), t.flowing && !t.reading && e.read(0);
            }

            function j(e) {
              var t = e._readableState;

              for (l("flow", t.flowing); t.flowing && null !== e.read();) {
                ;
              }
            }

            function B(e, t) {
              return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function (e, t, r) {
                var n;
                return e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function (e, t) {
                  var r = t.head,
                      n = 1,
                      i = r.data;

                  for (e -= i.length; r = r.next;) {
                    var o = r.data,
                        a = e > o.length ? o.length : e;

                    if (a === o.length ? i += o : i += o.slice(0, e), 0 == (e -= a)) {
                      a === o.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = o.slice(a));
                      break;
                    }

                    ++n;
                  }

                  return t.length -= n, i;
                }(e, t) : function (e, t) {
                  var r = c.allocUnsafe(e),
                      n = t.head,
                      i = 1;

                  for (n.data.copy(r), e -= n.data.length; n = n.next;) {
                    var o = n.data,
                        a = e > o.length ? o.length : e;

                    if (o.copy(r, r.length - e, 0, a), 0 == (e -= a)) {
                      a === o.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = o.slice(a));
                      break;
                    }

                    ++i;
                  }

                  return t.length -= i, r;
                }(e, t), n;
              }(e, t.buffer, t.decoder), r);
              var r;
            }

            function R(e) {
              var t = e._readableState;
              if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
              t.endEmitted || (t.ended = !0, i.nextTick(P, t, e));
            }

            function P(e, t) {
              e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
            }

            function T(e, t) {
              for (var r = 0, n = e.length; r < n; r++) {
                if (e[r] === t) return r;
              }

              return -1;
            }

            Object.defineProperty(g.prototype, "destroyed", {
              get: function get() {
                return void 0 !== this._readableState && this._readableState.destroyed;
              },
              set: function set(e) {
                this._readableState && (this._readableState.destroyed = e);
              }
            }), g.prototype.destroy = m.destroy, g.prototype._undestroy = m.undestroy, g.prototype._destroy = function (e, t) {
              this.push(null), t(e);
            }, g.prototype.push = function (e, t) {
              var r,
                  n = this._readableState;
              return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), _(this, e, t, !1, r);
            }, g.prototype.unshift = function (e) {
              return _(this, e, null, !0, !1);
            }, g.prototype.isPaused = function () {
              return !1 === this._readableState.flowing;
            }, g.prototype.setEncoding = function (e) {
              return p || (p = r(
              /*! string_decoder/ */
              "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder), this._readableState.decoder = new p(e), this._readableState.encoding = e, this;
            }, g.prototype.read = function (e) {
              l("read", e), e = parseInt(e, 10);
              var t = this._readableState,
                  r = e;
              if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return l("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? R(this) : E(this), null;
              if (0 === (e = k(e, t)) && t.ended) return 0 === t.length && R(this), null;
              var n,
                  i = t.needReadable;
              return l("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && l("length less than watermark", i = !0), t.ended || t.reading ? l("reading or ended", i = !1) : i && (l("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = k(r, t))), null === (n = e > 0 ? B(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && R(this)), null !== n && this.emit("data", n), n;
            }, g.prototype._read = function (e) {
              this.emit("error", new Error("_read() is not implemented"));
            }, g.prototype.pipe = function (e, t) {
              var r = this,
                  o = this._readableState;

              switch (o.pipesCount) {
                case 0:
                  o.pipes = e;
                  break;

                case 1:
                  o.pipes = [o.pipes, e];
                  break;

                default:
                  o.pipes.push(e);
              }

              o.pipesCount += 1, l("pipe count=%d opts=%j", o.pipesCount, t);
              var f = t && !1 === t.end || e === n.stdout || e === n.stderr ? g : u;

              function c(t, n) {
                l("onunpipe"), t === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, l("cleanup"), e.removeListener("close", y), e.removeListener("finish", v), e.removeListener("drain", d), e.removeListener("error", m), e.removeListener("unpipe", c), r.removeListener("end", u), r.removeListener("end", g), r.removeListener("data", b), h = !0, !o.awaitDrain || e._writableState && !e._writableState.needDrain || d());
              }

              function u() {
                l("onend"), e.end();
              }

              o.endEmitted ? i.nextTick(f) : r.once("end", f), e.on("unpipe", c);

              var d = function (e) {
                return function () {
                  var t = e._readableState;
                  l("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, j(e));
                };
              }(r);

              e.on("drain", d);
              var h = !1,
                  p = !1;

              function b(t) {
                l("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === o.pipesCount && o.pipes === e || o.pipesCount > 1 && -1 !== T(o.pipes, e)) && !h && (l("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, p = !0), r.pause());
              }

              function m(t) {
                l("onerror", t), g(), e.removeListener("error", m), 0 === s(e, "error") && e.emit("error", t);
              }

              function y() {
                e.removeListener("finish", v), g();
              }

              function v() {
                l("onfinish"), e.removeListener("close", y), g();
              }

              function g() {
                l("unpipe"), r.unpipe(e);
              }

              return r.on("data", b), function (e, t, r) {
                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                e._events && e._events[t] ? a(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [r, e._events[t]] : e.on(t, r);
              }(e, "error", m), e.once("close", y), e.once("finish", v), e.emit("pipe", r), o.flowing || (l("pipe resume"), r.resume()), e;
            }, g.prototype.unpipe = function (e) {
              var t = this._readableState,
                  r = {
                hasUnpiped: !1
              };
              if (0 === t.pipesCount) return this;
              if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;

              if (!e) {
                var n = t.pipes,
                    i = t.pipesCount;
                t.pipes = null, t.pipesCount = 0, t.flowing = !1;

                for (var o = 0; o < i; o++) {
                  n[o].emit("unpipe", this, r);
                }

                return this;
              }

              var a = T(t.pipes, e);
              return -1 === a || (t.pipes.splice(a, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
            }, g.prototype.on = function (e, t) {
              var r = f.prototype.on.call(this, e, t);
              if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
                var n = this._readableState;
                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && E(this) : i.nextTick(x, this));
              }
              return r;
            }, g.prototype.addListener = g.prototype.on, g.prototype.resume = function () {
              var e = this._readableState;
              return e.flowing || (l("resume"), e.flowing = !0, function (e, t) {
                t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(I, e, t));
              }(this, e)), this;
            }, g.prototype.pause = function () {
              return l("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (l("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
            }, g.prototype.wrap = function (e) {
              var t = this,
                  r = this._readableState,
                  n = !1;

              for (var i in e.on("end", function () {
                if (l("wrapped end"), r.decoder && !r.ended) {
                  var e = r.decoder.end();
                  e && e.length && t.push(e);
                }

                t.push(null);
              }), e.on("data", function (i) {
                l("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
              }), e) {
                void 0 === this[i] && "function" == typeof e[i] && (this[i] = function (t) {
                  return function () {
                    return e[t].apply(e, arguments);
                  };
                }(i));
              }

              for (var o = 0; o < y.length; o++) {
                e.on(y[o], this.emit.bind(this, y[o]));
              }

              return this._read = function (t) {
                l("wrapped _read", t), n && (n = !1, e.resume());
              }, this;
            }, Object.defineProperty(g.prototype, "readableHighWaterMark", {
              enumerable: !1,
              get: function get() {
                return this._readableState.highWaterMark;
              }
            }), g._fromList = B;
          }).call(this, r(
          /*! ./../../webpack/buildin/global.js */
          "./node_modules/webpack/buildin/global.js"), r(
          /*! ./../../process/browser.js */
          "./node_modules/process/browser.js"));
        },
        "./node_modules/readable-stream/lib/_stream_transform.js":
        /*!***************************************************************!*\
          !*** ./node_modules/readable-stream/lib/_stream_transform.js ***!
          \***************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLib_stream_transformJs(e, t, r) {
          "use strict";

          e.exports = a;
          var n = r(
          /*! ./_stream_duplex */
          "./node_modules/readable-stream/lib/_stream_duplex.js"),
              i = r(
          /*! core-util-is */
          "./node_modules/core-util-is/lib/util.js");

          function o(e, t) {
            var r = this._transformState;
            r.transforming = !1;
            var n = r.writecb;
            if (!n) return this.emit("error", new Error("write callback called multiple times"));
            r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
            var i = this._readableState;
            i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
          }

          function a(e) {
            if (!(this instanceof a)) return new a(e);
            n.call(this, e), this._transformState = {
              afterTransform: o.bind(this),
              needTransform: !1,
              transforming: !1,
              writecb: null,
              writechunk: null,
              writeencoding: null
            }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", s);
          }

          function s() {
            var e = this;
            "function" == typeof this._flush ? this._flush(function (t, r) {
              f(e, t, r);
            }) : f(this, null, null);
          }

          function f(e, t, r) {
            if (t) return e.emit("error", t);
            if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
            if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
            return e.push(null);
          }

          i.inherits = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"), i.inherits(a, n), a.prototype.push = function (e, t) {
            return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
          }, a.prototype._transform = function (e, t, r) {
            throw new Error("_transform() is not implemented");
          }, a.prototype._write = function (e, t, r) {
            var n = this._transformState;

            if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
              var i = this._readableState;
              (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
            }
          }, a.prototype._read = function (e) {
            var t = this._transformState;
            null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
          }, a.prototype._destroy = function (e, t) {
            var r = this;

            n.prototype._destroy.call(this, e, function (e) {
              t(e), r.emit("close");
            });
          };
        },
        "./node_modules/readable-stream/lib/_stream_writable.js":
        /*!**************************************************************!*\
          !*** ./node_modules/readable-stream/lib/_stream_writable.js ***!
          \**************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLib_stream_writableJs(e, t, r) {
          "use strict";

          (function (t, n, i) {
            var o = r(
            /*! process-nextick-args */
            "./node_modules/process-nextick-args/index.js");

            function a(e) {
              var t = this;
              this.next = null, this.entry = null, this.finish = function () {
                !function (e, t, r) {
                  var n = e.entry;

                  for (e.entry = null; n;) {
                    var i = n.callback;
                    t.pendingcb--, i(r), n = n.next;
                  }

                  t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
                }(t, e);
              };
            }

            e.exports = v;
            var s,
                f = !t.browser && ["v0.10", "v0.9."].indexOf(t.version.slice(0, 5)) > -1 ? n : o.nextTick;
            v.WritableState = y;
            var c = r(
            /*! core-util-is */
            "./node_modules/core-util-is/lib/util.js");
            c.inherits = r(
            /*! inherits */
            "./node_modules/inherits/inherits_browser.js");

            var u,
                d = {
              deprecate: r(
              /*! util-deprecate */
              "./node_modules/util-deprecate/browser.js")
            },
                h = r(
            /*! ./internal/streams/stream */
            "./node_modules/readable-stream/lib/internal/streams/stream-browser.js"),
                l = r(
            /*! safe-buffer */
            "./node_modules/safe-buffer/index.js").Buffer,
                p = i.Uint8Array || function () {},
                b = r(
            /*! ./internal/streams/destroy */
            "./node_modules/readable-stream/lib/internal/streams/destroy.js");

            function m() {}

            function y(e, t) {
              s = s || r(
              /*! ./_stream_duplex */
              "./node_modules/readable-stream/lib/_stream_duplex.js"), e = e || {};
              var n = t instanceof s;
              this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.writableObjectMode);
              var i = e.highWaterMark,
                  c = e.writableHighWaterMark,
                  u = this.objectMode ? 16 : 16384;
              this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
              var d = !1 === e.decodeStrings;
              this.decodeStrings = !d, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
                !function (e, t) {
                  var r = e._writableState,
                      n = r.sync,
                      i = r.writecb;
                  if (function (e) {
                    e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                  }(r), t) !function (e, t, r, n, i) {
                    --t.pendingcb, r ? (o.nextTick(i, n), o.nextTick(A, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), A(e, t));
                  }(e, r, n, t, i);else {
                    var a = k(r);
                    a || r.corked || r.bufferProcessing || !r.bufferedRequest || w(e, r), n ? f(_, e, r, a, i) : _(e, r, a, i);
                  }
                }(t, e);
              }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
            }

            function v(e) {
              if (s = s || r(
              /*! ./_stream_duplex */
              "./node_modules/readable-stream/lib/_stream_duplex.js"), !(u.call(v, this) || this instanceof s)) return new v(e);
              this._writableState = new y(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), h.call(this);
            }

            function g(e, t, r, n, i, o, a) {
              t.writelen = n, t.writecb = a, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, o, t.onwrite), t.sync = !1;
            }

            function _(e, t, r, n) {
              r || function (e, t) {
                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
              }(e, t), t.pendingcb--, n(), A(e, t);
            }

            function w(e, t) {
              t.bufferProcessing = !0;
              var r = t.bufferedRequest;

              if (e._writev && r && r.next) {
                var n = t.bufferedRequestCount,
                    i = new Array(n),
                    o = t.corkedRequestsFree;
                o.entry = r;

                for (var s = 0, f = !0; r;) {
                  i[s] = r, r.isBuf || (f = !1), r = r.next, s += 1;
                }

                i.allBuffers = f, g(e, t, !0, t.length, i, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new a(t), t.bufferedRequestCount = 0;
              } else {
                for (; r;) {
                  var c = r.chunk,
                      u = r.encoding,
                      d = r.callback;
                  if (g(e, t, !1, t.objectMode ? 1 : c.length, c, u, d), r = r.next, t.bufferedRequestCount--, t.writing) break;
                }

                null === r && (t.lastBufferedRequest = null);
              }

              t.bufferedRequest = r, t.bufferProcessing = !1;
            }

            function k(e) {
              return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
            }

            function E(e, t) {
              e._final(function (r) {
                t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), A(e, t);
              });
            }

            function A(e, t) {
              var r = k(t);
              return r && (function (e, t) {
                t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, o.nextTick(E, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
              }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
            }

            c.inherits(v, h), y.prototype.getBuffer = function () {
              for (var e = this.bufferedRequest, t = []; e;) {
                t.push(e), e = e.next;
              }

              return t;
            }, function () {
              try {
                Object.defineProperty(y.prototype, "buffer", {
                  get: d.deprecate(function () {
                    return this.getBuffer();
                  }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                });
              } catch (e) {}
            }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
              value: function value(e) {
                return !!u.call(this, e) || this === v && e && e._writableState instanceof y;
              }
            })) : u = function u(e) {
              return e instanceof this;
            }, v.prototype.pipe = function () {
              this.emit("error", new Error("Cannot pipe, not readable"));
            }, v.prototype.write = function (e, t, r) {
              var n,
                  i = this._writableState,
                  a = !1,
                  s = !i.objectMode && (n = e, l.isBuffer(n) || n instanceof p);
              return s && !l.isBuffer(e) && (e = function (e) {
                return l.from(e);
              }(e)), "function" == typeof t && (r = t, t = null), s ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = m), i.ended ? function (e, t) {
                var r = new Error("write after end");
                e.emit("error", r), o.nextTick(t, r);
              }(this, r) : (s || function (e, t, r, n) {
                var i = !0,
                    a = !1;
                return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (e.emit("error", a), o.nextTick(n, a), i = !1), i;
              }(this, i, e, r)) && (i.pendingcb++, a = function (e, t, r, n, i, o) {
                if (!r) {
                  var a = function (e, t, r) {
                    return e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, r)), t;
                  }(t, n, i);

                  n !== a && (r = !0, i = "buffer", n = a);
                }

                var s = t.objectMode ? 1 : n.length;
                t.length += s;
                var f = t.length < t.highWaterMark;

                if (f || (t.needDrain = !0), t.writing || t.corked) {
                  var c = t.lastBufferedRequest;
                  t.lastBufferedRequest = {
                    chunk: n,
                    encoding: i,
                    isBuf: r,
                    callback: o,
                    next: null
                  }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                } else g(e, t, !1, s, n, i, o);

                return f;
              }(this, i, s, e, t, r)), a;
            }, v.prototype.cork = function () {
              this._writableState.corked++;
            }, v.prototype.uncork = function () {
              var e = this._writableState;
              e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || w(this, e));
            }, v.prototype.setDefaultEncoding = function (e) {
              if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
              return this._writableState.defaultEncoding = e, this;
            }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
              enumerable: !1,
              get: function get() {
                return this._writableState.highWaterMark;
              }
            }), v.prototype._write = function (e, t, r) {
              r(new Error("_write() is not implemented"));
            }, v.prototype._writev = null, v.prototype.end = function (e, t, r) {
              var n = this._writableState;
              "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (e, t, r) {
                t.ending = !0, A(e, t), r && (t.finished ? o.nextTick(r) : e.once("finish", r)), t.ended = !0, e.writable = !1;
              }(this, n, r);
            }, Object.defineProperty(v.prototype, "destroyed", {
              get: function get() {
                return void 0 !== this._writableState && this._writableState.destroyed;
              },
              set: function set(e) {
                this._writableState && (this._writableState.destroyed = e);
              }
            }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function (e, t) {
              this.end(), t(e);
            };
          }).call(this, r(
          /*! ./../../process/browser.js */
          "./node_modules/process/browser.js"), r(
          /*! ./../../timers-browserify/main.js */
          "./node_modules/timers-browserify/main.js").setImmediate, r(
          /*! ./../../webpack/buildin/global.js */
          "./node_modules/webpack/buildin/global.js"));
        },
        "./node_modules/readable-stream/lib/internal/streams/BufferList.js":
        /*!*************************************************************************!*\
          !*** ./node_modules/readable-stream/lib/internal/streams/BufferList.js ***!
          \*************************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLibInternalStreamsBufferListJs(e, t, r) {
          "use strict";

          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              i = r(
          /*! util */
          1);
          e.exports = function () {
            function e() {
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.head = null, this.tail = null, this.length = 0;
            }

            return e.prototype.push = function (e) {
              var t = {
                data: e,
                next: null
              };
              this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
            }, e.prototype.unshift = function (e) {
              var t = {
                data: e,
                next: this.head
              };
              0 === this.length && (this.tail = t), this.head = t, ++this.length;
            }, e.prototype.shift = function () {
              if (0 !== this.length) {
                var e = this.head.data;
                return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
              }
            }, e.prototype.clear = function () {
              this.head = this.tail = null, this.length = 0;
            }, e.prototype.join = function (e) {
              if (0 === this.length) return "";

              for (var t = this.head, r = "" + t.data; t = t.next;) {
                r += e + t.data;
              }

              return r;
            }, e.prototype.concat = function (e) {
              if (0 === this.length) return n.alloc(0);
              if (1 === this.length) return this.head.data;

              for (var t, r, i, o = n.allocUnsafe(e >>> 0), a = this.head, s = 0; a;) {
                t = a.data, r = o, i = s, t.copy(r, i), s += a.data.length, a = a.next;
              }

              return o;
            }, e;
          }(), i && i.inspect && i.inspect.custom && (e.exports.prototype[i.inspect.custom] = function () {
            var e = i.inspect({
              length: this.length
            });
            return this.constructor.name + " " + e;
          });
        },
        "./node_modules/readable-stream/lib/internal/streams/destroy.js":
        /*!**********************************************************************!*\
          !*** ./node_modules/readable-stream/lib/internal/streams/destroy.js ***!
          \**********************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLibInternalStreamsDestroyJs(e, t, r) {
          "use strict";

          var n = r(
          /*! process-nextick-args */
          "./node_modules/process-nextick-args/index.js");

          function i(e, t) {
            e.emit("error", t);
          }

          e.exports = {
            destroy: function destroy(e, t) {
              var r = this,
                  o = this._readableState && this._readableState.destroyed,
                  a = this._writableState && this._writableState.destroyed;
              return o || a ? (t ? t(e) : !e || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, e), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
                !t && e ? (n.nextTick(i, r, e), r._writableState && (r._writableState.errorEmitted = !0)) : t && t(e);
              }), this);
            },
            undestroy: function undestroy() {
              this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            }
          };
        },
        "./node_modules/readable-stream/lib/internal/streams/stream-browser.js":
        /*!*****************************************************************************!*\
          !*** ./node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
          \*****************************************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamLibInternalStreamsStreamBrowserJs(e, t, r) {
          e.exports = r(
          /*! events */
          "./node_modules/events/events.js").EventEmitter;
        },
        "./node_modules/readable-stream/passthrough.js":
        /*!*****************************************************!*\
          !*** ./node_modules/readable-stream/passthrough.js ***!
          \*****************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamPassthroughJs(e, t, r) {
          e.exports = r(
          /*! ./readable */
          "./node_modules/readable-stream/readable-browser.js").PassThrough;
        },
        "./node_modules/readable-stream/readable-browser.js":
        /*!**********************************************************!*\
          !*** ./node_modules/readable-stream/readable-browser.js ***!
          \**********************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamReadableBrowserJs(e, t, r) {
          (t = e.exports = r(
          /*! ./lib/_stream_readable.js */
          "./node_modules/readable-stream/lib/_stream_readable.js")).Stream = t, t.Readable = t, t.Writable = r(
          /*! ./lib/_stream_writable.js */
          "./node_modules/readable-stream/lib/_stream_writable.js"), t.Duplex = r(
          /*! ./lib/_stream_duplex.js */
          "./node_modules/readable-stream/lib/_stream_duplex.js"), t.Transform = r(
          /*! ./lib/_stream_transform.js */
          "./node_modules/readable-stream/lib/_stream_transform.js"), t.PassThrough = r(
          /*! ./lib/_stream_passthrough.js */
          "./node_modules/readable-stream/lib/_stream_passthrough.js");
        },
        "./node_modules/readable-stream/transform.js":
        /*!***************************************************!*\
          !*** ./node_modules/readable-stream/transform.js ***!
          \***************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamTransformJs(e, t, r) {
          e.exports = r(
          /*! ./readable */
          "./node_modules/readable-stream/readable-browser.js").Transform;
        },
        "./node_modules/readable-stream/writable-browser.js":
        /*!**********************************************************!*\
          !*** ./node_modules/readable-stream/writable-browser.js ***!
          \**********************************************************/

        /*! no static exports found */
        function node_modulesReadableStreamWritableBrowserJs(e, t, r) {
          e.exports = r(
          /*! ./lib/_stream_writable.js */
          "./node_modules/readable-stream/lib/_stream_writable.js");
        },
        "./node_modules/ripemd160/index.js":
        /*!*****************************************!*\
          !*** ./node_modules/ripemd160/index.js ***!
          \*****************************************/

        /*! no static exports found */
        function node_modulesRipemd160IndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! buffer */
          "./node_modules/buffer/index.js").Buffer,
              i = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              o = r(
          /*! hash-base */
          "./node_modules/hash-base/index.js"),
              a = new Array(16),
              s = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
              f = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
              c = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
              u = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
              d = [0, 1518500249, 1859775393, 2400959708, 2840853838],
              h = [1352829926, 1548603684, 1836072691, 2053994217, 0];

          function l() {
            o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
          }

          function p(e, t) {
            return e << t | e >>> 32 - t;
          }

          function b(e, t, r, n, i, o, a, s) {
            return p(e + (t ^ r ^ n) + o + a | 0, s) + i | 0;
          }

          function m(e, t, r, n, i, o, a, s) {
            return p(e + (t & r | ~t & n) + o + a | 0, s) + i | 0;
          }

          function y(e, t, r, n, i, o, a, s) {
            return p(e + ((t | ~r) ^ n) + o + a | 0, s) + i | 0;
          }

          function v(e, t, r, n, i, o, a, s) {
            return p(e + (t & n | r & ~n) + o + a | 0, s) + i | 0;
          }

          function g(e, t, r, n, i, o, a, s) {
            return p(e + (t ^ (r | ~n)) + o + a | 0, s) + i | 0;
          }

          i(l, o), l.prototype._update = function () {
            for (var e = a, t = 0; t < 16; ++t) {
              e[t] = this._block.readInt32LE(4 * t);
            }

            for (var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, o = 0 | this._d, l = 0 | this._e, _ = 0 | this._a, w = 0 | this._b, k = 0 | this._c, E = 0 | this._d, A = 0 | this._e, S = 0; S < 80; S += 1) {
              var M, x;
              S < 16 ? (M = b(r, n, i, o, l, e[s[S]], d[0], c[S]), x = g(_, w, k, E, A, e[f[S]], h[0], u[S])) : S < 32 ? (M = m(r, n, i, o, l, e[s[S]], d[1], c[S]), x = v(_, w, k, E, A, e[f[S]], h[1], u[S])) : S < 48 ? (M = y(r, n, i, o, l, e[s[S]], d[2], c[S]), x = y(_, w, k, E, A, e[f[S]], h[2], u[S])) : S < 64 ? (M = v(r, n, i, o, l, e[s[S]], d[3], c[S]), x = m(_, w, k, E, A, e[f[S]], h[3], u[S])) : (M = g(r, n, i, o, l, e[s[S]], d[4], c[S]), x = b(_, w, k, E, A, e[f[S]], h[4], u[S])), r = l, l = o, o = p(i, 10), i = n, n = M, _ = A, A = E, E = p(k, 10), k = w, w = x;
            }

            var I = this._b + i + E | 0;
            this._b = this._c + o + A | 0, this._c = this._d + l + _ | 0, this._d = this._e + r + w | 0, this._e = this._a + n + k | 0, this._a = I;
          }, l.prototype._digest = function () {
            this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
            var e = n.alloc ? n.alloc(20) : new n(20);
            return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
          }, e.exports = l;
        },
        "./node_modules/safe-buffer/index.js":
        /*!*******************************************!*\
          !*** ./node_modules/safe-buffer/index.js ***!
          \*******************************************/

        /*! no static exports found */
        function node_modulesSafeBufferIndexJs(e, t, r) {
          var n = r(
          /*! buffer */
          "./node_modules/buffer/index.js"),
              i = n.Buffer;

          function o(e, t) {
            for (var r in e) {
              t[r] = e[r];
            }
          }

          function a(e, t, r) {
            return i(e, t, r);
          }

          i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = n : (o(n, t), t.Buffer = a), o(i, a), a.from = function (e, t, r) {
            if ("number" == typeof e) throw new TypeError("Argument must not be a number");
            return i(e, t, r);
          }, a.alloc = function (e, t, r) {
            if ("number" != typeof e) throw new TypeError("Argument must be a number");
            var n = i(e);
            return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
          }, a.allocUnsafe = function (e) {
            if ("number" != typeof e) throw new TypeError("Argument must be a number");
            return i(e);
          }, a.allocUnsafeSlow = function (e) {
            if ("number" != typeof e) throw new TypeError("Argument must be a number");
            return n.SlowBuffer(e);
          };
        },
        "./node_modules/secp256k1/elliptic.js":
        /*!********************************************!*\
          !*** ./node_modules/secp256k1/elliptic.js ***!
          \********************************************/

        /*! no static exports found */
        function node_modulesSecp256k1EllipticJs(e, t, r) {
          "use strict";

          e.exports = r(
          /*! ./lib */
          "./node_modules/secp256k1/lib/index.js")(r(
          /*! ./lib/elliptic */
          "./node_modules/secp256k1/lib/elliptic/index.js"));
        },
        "./node_modules/secp256k1/lib/assert.js":
        /*!**********************************************!*\
          !*** ./node_modules/secp256k1/lib/assert.js ***!
          \**********************************************/

        /*! no static exports found */
        function node_modulesSecp256k1LibAssertJs(e, t, r) {
          "use strict";

          (function (e) {
            var r = Object.prototype.toString;
            t.isArray = function (e, t) {
              if (!Array.isArray(e)) throw TypeError(t);
            }, t.isBoolean = function (e, t) {
              if ("[object Boolean]" !== r.call(e)) throw TypeError(t);
            }, t.isBuffer = function (t, r) {
              if (!e.isBuffer(t)) throw TypeError(r);
            }, t.isFunction = function (e, t) {
              if ("[object Function]" !== r.call(e)) throw TypeError(t);
            }, t.isNumber = function (e, t) {
              if ("[object Number]" !== r.call(e)) throw TypeError(t);
            }, t.isObject = function (e, t) {
              if ("[object Object]" !== r.call(e)) throw TypeError(t);
            }, t.isBufferLength = function (e, t, r) {
              if (e.length !== t) throw RangeError(r);
            }, t.isBufferLength2 = function (e, t, r, n) {
              if (e.length !== t && e.length !== r) throw RangeError(n);
            }, t.isLengthGTZero = function (e, t) {
              if (0 === e.length) throw RangeError(t);
            }, t.isNumberInInterval = function (e, t, r, n) {
              if (e <= t || e >= r) throw RangeError(n);
            };
          }).call(this, r(
          /*! ./../../buffer/index.js */
          "./node_modules/buffer/index.js").Buffer);
        },
        "./node_modules/secp256k1/lib/der.js":
        /*!*******************************************!*\
          !*** ./node_modules/secp256k1/lib/der.js ***!
          \*******************************************/

        /*! no static exports found */
        function node_modulesSecp256k1LibDerJs(e, t, r) {
          "use strict";

          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              i = r(
          /*! bip66 */
          "./node_modules/bip66/index.js"),
              o = n.from([48, 129, 211, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 133, 48, 129, 130, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 33, 2, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 36, 3, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
              a = n.from([48, 130, 1, 19, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 165, 48, 129, 162, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 65, 4, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 72, 58, 218, 119, 38, 163, 196, 101, 93, 164, 251, 252, 14, 17, 8, 168, 253, 23, 180, 72, 166, 133, 84, 25, 156, 71, 208, 143, 251, 16, 212, 184, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 68, 3, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
          t.privateKeyExport = function (e, t, r) {
            var i = n.from(r ? o : a);
            return e.copy(i, r ? 8 : 9), t.copy(i, r ? 181 : 214), i;
          }, t.privateKeyImport = function (e) {
            var t = e.length,
                r = 0;

            if (!(t < r + 1 || 48 !== e[r]) && !(t < (r += 1) + 1) && 128 & e[r]) {
              var n = 127 & e[r];

              if (r += 1, !(n < 1 || n > 2 || t < r + n)) {
                var i = e[r + n - 1] | (n > 1 ? e[r + n - 2] << 8 : 0);
                if (!(t < (r += n) + i || t < r + 3 || 2 !== e[r] || 1 !== e[r + 1] || 1 !== e[r + 2] || t < (r += 3) + 2 || 4 !== e[r] || e[r + 1] > 32 || t < r + 2 + e[r + 1])) return e.slice(r + 2, r + 2 + e[r + 1]);
              }
            }
          }, t.signatureExport = function (e) {
            for (var t = n.concat([n.from([0]), e.r]), r = 33, o = 0; r > 1 && 0 === t[o] && !(128 & t[o + 1]); --r, ++o) {
              ;
            }

            for (var a = n.concat([n.from([0]), e.s]), s = 33, f = 0; s > 1 && 0 === a[f] && !(128 & a[f + 1]); --s, ++f) {
              ;
            }

            return i.encode(t.slice(o), a.slice(f));
          }, t.signatureImport = function (e) {
            var t = n.alloc(32, 0),
                r = n.alloc(32, 0);

            try {
              var o = i.decode(e);
              if (33 === o.r.length && 0 === o.r[0] && (o.r = o.r.slice(1)), o.r.length > 32) throw new Error("R length is too long");
              if (33 === o.s.length && 0 === o.s[0] && (o.s = o.s.slice(1)), o.s.length > 32) throw new Error("S length is too long");
            } catch (e) {
              return;
            }

            return o.r.copy(t, 32 - o.r.length), o.s.copy(r, 32 - o.s.length), {
              r: t,
              s: r
            };
          }, t.signatureImportLax = function (e) {
            var t = n.alloc(32, 0),
                r = n.alloc(32, 0),
                i = e.length,
                o = 0;

            if (48 === e[o++]) {
              var a = e[o++];

              if (!(128 & a && (o += a - 128) > i) && 2 === e[o++]) {
                var s = e[o++];

                if (128 & s) {
                  if (o + (a = s - 128) > i) return;

                  for (; a > 0 && 0 === e[o]; o += 1, a -= 1) {
                    ;
                  }

                  for (s = 0; a > 0; o += 1, a -= 1) {
                    s = (s << 8) + e[o];
                  }
                }

                if (!(s > i - o)) {
                  var f = o;

                  if (o += s, 2 === e[o++]) {
                    var c = e[o++];

                    if (128 & c) {
                      if (o + (a = c - 128) > i) return;

                      for (; a > 0 && 0 === e[o]; o += 1, a -= 1) {
                        ;
                      }

                      for (c = 0; a > 0; o += 1, a -= 1) {
                        c = (c << 8) + e[o];
                      }
                    }

                    if (!(c > i - o)) {
                      var u = o;

                      for (o += c; s > 0 && 0 === e[f]; s -= 1, f += 1) {
                        ;
                      }

                      if (!(s > 32)) {
                        var d = e.slice(f, f + s);

                        for (d.copy(t, 32 - d.length); c > 0 && 0 === e[u]; c -= 1, u += 1) {
                          ;
                        }

                        if (!(c > 32)) {
                          var h = e.slice(u, u + c);
                          return h.copy(r, 32 - h.length), {
                            r: t,
                            s: r
                          };
                        }
                      }
                    }
                  }
                }
              }
            }
          };
        },
        "./node_modules/secp256k1/lib/elliptic/index.js":
        /*!******************************************************!*\
          !*** ./node_modules/secp256k1/lib/elliptic/index.js ***!
          \******************************************************/

        /*! no static exports found */
        function node_modulesSecp256k1LibEllipticIndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              i = r(
          /*! create-hash */
          "./node_modules/create-hash/browser.js"),
              o = r(
          /*! bn.js */
          "./node_modules/bn.js/lib/bn.js"),
              a = r(
          /*! elliptic */
          "./node_modules/elliptic/lib/elliptic.js").ec,
              s = r(
          /*! ../messages.json */
          "./node_modules/secp256k1/lib/messages.json"),
              f = new a("secp256k1"),
              c = f.curve;

          function u(e) {
            var t = e[0];

            switch (t) {
              case 2:
              case 3:
                return 33 !== e.length ? null : function (e, t) {
                  var r = new o(t);
                  if (r.cmp(c.p) >= 0) return null;
                  var n = (r = r.toRed(c.red)).redSqr().redIMul(r).redIAdd(c.b).redSqrt();
                  return 3 === e !== n.isOdd() && (n = n.redNeg()), f.keyPair({
                    pub: {
                      x: r,
                      y: n
                    }
                  });
                }(t, e.slice(1, 33));

              case 4:
              case 6:
              case 7:
                return 65 !== e.length ? null : function (e, t, r) {
                  var n = new o(t),
                      i = new o(r);
                  if (n.cmp(c.p) >= 0 || i.cmp(c.p) >= 0) return null;
                  if (n = n.toRed(c.red), i = i.toRed(c.red), (6 === e || 7 === e) && i.isOdd() !== (7 === e)) return null;
                  var a = n.redSqr().redIMul(n);
                  return i.redSqr().redISub(a.redIAdd(c.b)).isZero() ? f.keyPair({
                    pub: {
                      x: n,
                      y: i
                    }
                  }) : null;
                }(t, e.slice(1, 33), e.slice(33, 65));

              default:
                return null;
            }
          }

          t.privateKeyVerify = function (e) {
            var t = new o(e);
            return t.cmp(c.n) < 0 && !t.isZero();
          }, t.privateKeyExport = function (e, t) {
            var r = new o(e);
            if (r.cmp(c.n) >= 0 || r.isZero()) throw new Error(s.EC_PRIVATE_KEY_EXPORT_DER_FAIL);
            return n.from(f.keyFromPrivate(e).getPublic(t, !0));
          }, t.privateKeyNegate = function (e) {
            var t = new o(e);
            return t.isZero() ? n.alloc(32) : c.n.sub(t).umod(c.n).toArrayLike(n, "be", 32);
          }, t.privateKeyModInverse = function (e) {
            var t = new o(e);
            if (t.cmp(c.n) >= 0 || t.isZero()) throw new Error(s.EC_PRIVATE_KEY_RANGE_INVALID);
            return t.invm(c.n).toArrayLike(n, "be", 32);
          }, t.privateKeyTweakAdd = function (e, t) {
            var r = new o(t);
            if (r.cmp(c.n) >= 0) throw new Error(s.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
            if (r.iadd(new o(e)), r.cmp(c.n) >= 0 && r.isub(c.n), r.isZero()) throw new Error(s.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
            return r.toArrayLike(n, "be", 32);
          }, t.privateKeyTweakMul = function (e, t) {
            var r = new o(t);
            if (r.cmp(c.n) >= 0 || r.isZero()) throw new Error(s.EC_PRIVATE_KEY_TWEAK_MUL_FAIL);
            return r.imul(new o(e)), r.cmp(c.n) && (r = r.umod(c.n)), r.toArrayLike(n, "be", 32);
          }, t.publicKeyCreate = function (e, t) {
            var r = new o(e);
            if (r.cmp(c.n) >= 0 || r.isZero()) throw new Error(s.EC_PUBLIC_KEY_CREATE_FAIL);
            return n.from(f.keyFromPrivate(e).getPublic(t, !0));
          }, t.publicKeyConvert = function (e, t) {
            var r = u(e);
            if (null === r) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
            return n.from(r.getPublic(t, !0));
          }, t.publicKeyVerify = function (e) {
            return null !== u(e);
          }, t.publicKeyTweakAdd = function (e, t, r) {
            var i = u(e);
            if (null === i) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
            if ((t = new o(t)).cmp(c.n) >= 0) throw new Error(s.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
            var a = c.g.mul(t).add(i.pub);
            if (a.isInfinity()) throw new Error(s.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
            return n.from(a.encode(!0, r));
          }, t.publicKeyTweakMul = function (e, t, r) {
            var i = u(e);
            if (null === i) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
            if ((t = new o(t)).cmp(c.n) >= 0 || t.isZero()) throw new Error(s.EC_PUBLIC_KEY_TWEAK_MUL_FAIL);
            return n.from(i.pub.mul(t).encode(!0, r));
          }, t.publicKeyCombine = function (e, t) {
            for (var r = new Array(e.length), i = 0; i < e.length; ++i) {
              if (r[i] = u(e[i]), null === r[i]) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
            }

            for (var o = r[0].pub, a = 1; a < r.length; ++a) {
              o = o.add(r[a].pub);
            }

            if (o.isInfinity()) throw new Error(s.EC_PUBLIC_KEY_COMBINE_FAIL);
            return n.from(o.encode(!0, t));
          }, t.signatureNormalize = function (e) {
            var t = new o(e.slice(0, 32)),
                r = new o(e.slice(32, 64));
            if (t.cmp(c.n) >= 0 || r.cmp(c.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);
            var i = n.from(e);
            return 1 === r.cmp(f.nh) && c.n.sub(r).toArrayLike(n, "be", 32).copy(i, 32), i;
          }, t.signatureExport = function (e) {
            var t = e.slice(0, 32),
                r = e.slice(32, 64);
            if (new o(t).cmp(c.n) >= 0 || new o(r).cmp(c.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);
            return {
              r: t,
              s: r
            };
          }, t.signatureImport = function (e) {
            var t = new o(e.r);
            t.cmp(c.n) >= 0 && (t = new o(0));
            var r = new o(e.s);
            return r.cmp(c.n) >= 0 && (r = new o(0)), n.concat([t.toArrayLike(n, "be", 32), r.toArrayLike(n, "be", 32)]);
          }, t.sign = function (e, t, r, i) {
            if ("function" == typeof r) {
              var a = r;

              r = function r(_r2) {
                var f = a(e, t, null, i, _r2);
                if (!n.isBuffer(f) || 32 !== f.length) throw new Error(s.ECDSA_SIGN_FAIL);
                return new o(f);
              };
            }

            var u = new o(t);
            if (u.cmp(c.n) >= 0 || u.isZero()) throw new Error(s.ECDSA_SIGN_FAIL);
            var d = f.sign(e, t, {
              canonical: !0,
              k: r,
              pers: i
            });
            return {
              signature: n.concat([d.r.toArrayLike(n, "be", 32), d.s.toArrayLike(n, "be", 32)]),
              recovery: d.recoveryParam
            };
          }, t.verify = function (e, t, r) {
            var n = {
              r: t.slice(0, 32),
              s: t.slice(32, 64)
            },
                i = new o(n.r),
                a = new o(n.s);
            if (i.cmp(c.n) >= 0 || a.cmp(c.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);
            if (1 === a.cmp(f.nh) || i.isZero() || a.isZero()) return !1;
            var d = u(r);
            if (null === d) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
            return f.verify(e, n, {
              x: d.pub.x,
              y: d.pub.y
            });
          }, t.recover = function (e, t, r, i) {
            var a = {
              r: t.slice(0, 32),
              s: t.slice(32, 64)
            },
                u = new o(a.r),
                d = new o(a.s);
            if (u.cmp(c.n) >= 0 || d.cmp(c.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);

            try {
              if (u.isZero() || d.isZero()) throw new Error();
              var h = f.recoverPubKey(e, a, r);
              return n.from(h.encode(!0, i));
            } catch (e) {
              throw new Error(s.ECDSA_RECOVER_FAIL);
            }
          }, t.ecdh = function (e, r) {
            var n = t.ecdhUnsafe(e, r, !0);
            return i("sha256").update(n).digest();
          }, t.ecdhUnsafe = function (e, t, r) {
            var i = u(e);
            if (null === i) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
            var a = new o(t);
            if (a.cmp(c.n) >= 0 || a.isZero()) throw new Error(s.ECDH_FAIL);
            return n.from(i.pub.mul(a).encode(!0, r));
          };
        },
        "./node_modules/secp256k1/lib/index.js":
        /*!*********************************************!*\
          !*** ./node_modules/secp256k1/lib/index.js ***!
          \*********************************************/

        /*! no static exports found */
        function node_modulesSecp256k1LibIndexJs(e, t, r) {
          "use strict";

          var n = r(
          /*! ./assert */
          "./node_modules/secp256k1/lib/assert.js"),
              i = r(
          /*! ./der */
          "./node_modules/secp256k1/lib/der.js"),
              o = r(
          /*! ./messages.json */
          "./node_modules/secp256k1/lib/messages.json");

          function a(e, t) {
            return void 0 === e ? t : (n.isBoolean(e, o.COMPRESSED_TYPE_INVALID), e);
          }

          e.exports = function (e) {
            return {
              privateKeyVerify: function privateKeyVerify(t) {
                return n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), 32 === t.length && e.privateKeyVerify(t);
              },
              privateKeyExport: function privateKeyExport(t, r) {
                n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(t, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), r = a(r, !0);
                var s = e.privateKeyExport(t, r);
                return i.privateKeyExport(t, s, r);
              },
              privateKeyImport: function privateKeyImport(t) {
                if (n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), (t = i.privateKeyImport(t)) && 32 === t.length && e.privateKeyVerify(t)) return t;
                throw new Error(o.EC_PRIVATE_KEY_IMPORT_DER_FAIL);
              },
              privateKeyNegate: function privateKeyNegate(t) {
                return n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(t, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), e.privateKeyNegate(t);
              },
              privateKeyModInverse: function privateKeyModInverse(t) {
                return n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(t, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), e.privateKeyModInverse(t);
              },
              privateKeyTweakAdd: function privateKeyTweakAdd(t, r) {
                return n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(t, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), e.privateKeyTweakAdd(t, r);
              },
              privateKeyTweakMul: function privateKeyTweakMul(t, r) {
                return n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(t, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), e.privateKeyTweakMul(t, r);
              },
              publicKeyCreate: function publicKeyCreate(t, r) {
                return n.isBuffer(t, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(t, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), r = a(r, !0), e.publicKeyCreate(t, r);
              },
              publicKeyConvert: function publicKeyConvert(t, r) {
                return n.isBuffer(t, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(t, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), r = a(r, !0), e.publicKeyConvert(t, r);
              },
              publicKeyVerify: function publicKeyVerify(t) {
                return n.isBuffer(t, o.EC_PUBLIC_KEY_TYPE_INVALID), e.publicKeyVerify(t);
              },
              publicKeyTweakAdd: function publicKeyTweakAdd(t, r, i) {
                return n.isBuffer(t, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(t, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), i = a(i, !0), e.publicKeyTweakAdd(t, r, i);
              },
              publicKeyTweakMul: function publicKeyTweakMul(t, r, i) {
                return n.isBuffer(t, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(t, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), i = a(i, !0), e.publicKeyTweakMul(t, r, i);
              },
              publicKeyCombine: function publicKeyCombine(t, r) {
                n.isArray(t, o.EC_PUBLIC_KEYS_TYPE_INVALID), n.isLengthGTZero(t, o.EC_PUBLIC_KEYS_LENGTH_INVALID);

                for (var i = 0; i < t.length; ++i) {
                  n.isBuffer(t[i], o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(t[i], 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID);
                }

                return r = a(r, !0), e.publicKeyCombine(t, r);
              },
              signatureNormalize: function signatureNormalize(t) {
                return n.isBuffer(t, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(t, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), e.signatureNormalize(t);
              },
              signatureExport: function signatureExport(t) {
                n.isBuffer(t, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(t, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID);
                var r = e.signatureExport(t);
                return i.signatureExport(r);
              },
              signatureImport: function signatureImport(t) {
                n.isBuffer(t, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isLengthGTZero(t, o.ECDSA_SIGNATURE_LENGTH_INVALID);
                var r = i.signatureImport(t);
                if (r) return e.signatureImport(r);
                throw new Error(o.ECDSA_SIGNATURE_PARSE_DER_FAIL);
              },
              signatureImportLax: function signatureImportLax(t) {
                n.isBuffer(t, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isLengthGTZero(t, o.ECDSA_SIGNATURE_LENGTH_INVALID);
                var r = i.signatureImportLax(t);
                if (r) return e.signatureImport(r);
                throw new Error(o.ECDSA_SIGNATURE_PARSE_DER_FAIL);
              },
              sign: function sign(t, r, i) {
                n.isBuffer(t, o.MSG32_TYPE_INVALID), n.isBufferLength(t, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID);
                var a = null,
                    s = null;
                return void 0 !== i && (n.isObject(i, o.OPTIONS_TYPE_INVALID), void 0 !== i.data && (n.isBuffer(i.data, o.OPTIONS_DATA_TYPE_INVALID), n.isBufferLength(i.data, 32, o.OPTIONS_DATA_LENGTH_INVALID), a = i.data), void 0 !== i.noncefn && (n.isFunction(i.noncefn, o.OPTIONS_NONCEFN_TYPE_INVALID), s = i.noncefn)), e.sign(t, r, s, a);
              },
              verify: function verify(t, r, i) {
                return n.isBuffer(t, o.MSG32_TYPE_INVALID), n.isBufferLength(t, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(r, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), n.isBuffer(i, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(i, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), e.verify(t, r, i);
              },
              recover: function recover(t, r, i, s) {
                return n.isBuffer(t, o.MSG32_TYPE_INVALID), n.isBufferLength(t, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(r, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), n.isNumber(i, o.RECOVERY_ID_TYPE_INVALID), n.isNumberInInterval(i, -1, 4, o.RECOVERY_ID_VALUE_INVALID), s = a(s, !0), e.recover(t, r, i, s);
              },
              ecdh: function ecdh(t, r) {
                return n.isBuffer(t, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(t, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), e.ecdh(t, r);
              },
              ecdhUnsafe: function ecdhUnsafe(t, r, i) {
                return n.isBuffer(t, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(t, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), i = a(i, !0), e.ecdhUnsafe(t, r, i);
              }
            };
          };
        },
        "./node_modules/secp256k1/lib/messages.json":
        /*!**************************************************!*\
          !*** ./node_modules/secp256k1/lib/messages.json ***!
          \**************************************************/

        /*! exports provided: COMPRESSED_TYPE_INVALID, EC_PRIVATE_KEY_TYPE_INVALID, EC_PRIVATE_KEY_LENGTH_INVALID, EC_PRIVATE_KEY_RANGE_INVALID, EC_PRIVATE_KEY_TWEAK_ADD_FAIL, EC_PRIVATE_KEY_TWEAK_MUL_FAIL, EC_PRIVATE_KEY_EXPORT_DER_FAIL, EC_PRIVATE_KEY_IMPORT_DER_FAIL, EC_PUBLIC_KEYS_TYPE_INVALID, EC_PUBLIC_KEYS_LENGTH_INVALID, EC_PUBLIC_KEY_TYPE_INVALID, EC_PUBLIC_KEY_LENGTH_INVALID, EC_PUBLIC_KEY_PARSE_FAIL, EC_PUBLIC_KEY_CREATE_FAIL, EC_PUBLIC_KEY_TWEAK_ADD_FAIL, EC_PUBLIC_KEY_TWEAK_MUL_FAIL, EC_PUBLIC_KEY_COMBINE_FAIL, ECDH_FAIL, ECDSA_SIGNATURE_TYPE_INVALID, ECDSA_SIGNATURE_LENGTH_INVALID, ECDSA_SIGNATURE_PARSE_FAIL, ECDSA_SIGNATURE_PARSE_DER_FAIL, ECDSA_SIGNATURE_SERIALIZE_DER_FAIL, ECDSA_SIGN_FAIL, ECDSA_RECOVER_FAIL, MSG32_TYPE_INVALID, MSG32_LENGTH_INVALID, OPTIONS_TYPE_INVALID, OPTIONS_DATA_TYPE_INVALID, OPTIONS_DATA_LENGTH_INVALID, OPTIONS_NONCEFN_TYPE_INVALID, RECOVERY_ID_TYPE_INVALID, RECOVERY_ID_VALUE_INVALID, TWEAK_TYPE_INVALID, TWEAK_LENGTH_INVALID, default */
        function node_modulesSecp256k1LibMessagesJson(e) {
          e.exports = JSON.parse('{"COMPRESSED_TYPE_INVALID":"compressed should be a boolean","EC_PRIVATE_KEY_TYPE_INVALID":"private key should be a Buffer","EC_PRIVATE_KEY_LENGTH_INVALID":"private key length is invalid","EC_PRIVATE_KEY_RANGE_INVALID":"private key range is invalid","EC_PRIVATE_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting private key is invalid","EC_PRIVATE_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PRIVATE_KEY_EXPORT_DER_FAIL":"couldn\'t export to DER format","EC_PRIVATE_KEY_IMPORT_DER_FAIL":"couldn\'t import from DER format","EC_PUBLIC_KEYS_TYPE_INVALID":"public keys should be an Array","EC_PUBLIC_KEYS_LENGTH_INVALID":"public keys Array should have at least 1 element","EC_PUBLIC_KEY_TYPE_INVALID":"public key should be a Buffer","EC_PUBLIC_KEY_LENGTH_INVALID":"public key length is invalid","EC_PUBLIC_KEY_PARSE_FAIL":"the public key could not be parsed or is invalid","EC_PUBLIC_KEY_CREATE_FAIL":"private was invalid, try again","EC_PUBLIC_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting public key is invalid","EC_PUBLIC_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PUBLIC_KEY_COMBINE_FAIL":"the sum of the public keys is not valid","ECDH_FAIL":"scalar was invalid (zero or overflow)","ECDSA_SIGNATURE_TYPE_INVALID":"signature should be a Buffer","ECDSA_SIGNATURE_LENGTH_INVALID":"signature length is invalid","ECDSA_SIGNATURE_PARSE_FAIL":"couldn\'t parse signature","ECDSA_SIGNATURE_PARSE_DER_FAIL":"couldn\'t parse DER signature","ECDSA_SIGNATURE_SERIALIZE_DER_FAIL":"couldn\'t serialize signature to DER format","ECDSA_SIGN_FAIL":"nonce generation function failed or private key is invalid","ECDSA_RECOVER_FAIL":"couldn\'t recover public key from signature","MSG32_TYPE_INVALID":"message should be a Buffer","MSG32_LENGTH_INVALID":"message length is invalid","OPTIONS_TYPE_INVALID":"options should be an Object","OPTIONS_DATA_TYPE_INVALID":"options.data should be a Buffer","OPTIONS_DATA_LENGTH_INVALID":"options.data length is invalid","OPTIONS_NONCEFN_TYPE_INVALID":"options.noncefn should be a Function","RECOVERY_ID_TYPE_INVALID":"recovery should be a Number","RECOVERY_ID_VALUE_INVALID":"recovery should have value between -1 and 4","TWEAK_TYPE_INVALID":"tweak should be a Buffer","TWEAK_LENGTH_INVALID":"tweak length is invalid"}');
        },
        "./node_modules/setimmediate/setImmediate.js":
        /*!***************************************************!*\
          !*** ./node_modules/setimmediate/setImmediate.js ***!
          \***************************************************/

        /*! no static exports found */
        function node_modulesSetimmediateSetImmediateJs(e, t, r) {
          (function (e, t) {
            !function (e, r) {
              "use strict";

              if (!e.setImmediate) {
                var n,
                    i,
                    o,
                    a,
                    s,
                    f = 1,
                    c = {},
                    u = !1,
                    d = e.document,
                    h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                h = h && h.setTimeout ? h : e, "[object process]" === {}.toString.call(e.process) ? n = function n(e) {
                  t.nextTick(function () {
                    p(e);
                  });
                } : function () {
                  if (e.postMessage && !e.importScripts) {
                    var t = !0,
                        r = e.onmessage;
                    return e.onmessage = function () {
                      t = !1;
                    }, e.postMessage("", "*"), e.onmessage = r, t;
                  }
                }() ? (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
                  t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && p(+t.data.slice(a.length));
                }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), n = function n(t) {
                  e.postMessage(a + t, "*");
                }) : e.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (e) {
                  p(e.data);
                }, n = function n(e) {
                  o.port2.postMessage(e);
                }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, n = function n(e) {
                  var t = d.createElement("script");
                  t.onreadystatechange = function () {
                    p(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                  }, i.appendChild(t);
                }) : n = function n(e) {
                  setTimeout(p, 0, e);
                }, h.setImmediate = function (e) {
                  "function" != typeof e && (e = new Function("" + e));

                  for (var t = new Array(arguments.length - 1), r = 0; r < t.length; r++) {
                    t[r] = arguments[r + 1];
                  }

                  var i = {
                    callback: e,
                    args: t
                  };
                  return c[f] = i, n(f), f++;
                }, h.clearImmediate = l;
              }

              function l(e) {
                delete c[e];
              }

              function p(e) {
                if (u) setTimeout(p, 0, e);else {
                  var t = c[e];

                  if (t) {
                    u = !0;

                    try {
                      !function (e) {
                        var t = e.callback,
                            r = e.args;

                        switch (r.length) {
                          case 0:
                            t();
                            break;

                          case 1:
                            t(r[0]);
                            break;

                          case 2:
                            t(r[0], r[1]);
                            break;

                          case 3:
                            t(r[0], r[1], r[2]);
                            break;

                          default:
                            t.apply(void 0, r);
                        }
                      }(t);
                    } finally {
                      l(e), u = !1;
                    }
                  }
                }
              }
            }("undefined" == typeof self ? void 0 === e ? this : e : self);
          }).call(this, r(
          /*! ./../webpack/buildin/global.js */
          "./node_modules/webpack/buildin/global.js"), r(
          /*! ./../process/browser.js */
          "./node_modules/process/browser.js"));
        },
        "./node_modules/sha.js/hash.js":
        /*!*************************************!*\
          !*** ./node_modules/sha.js/hash.js ***!
          \*************************************/

        /*! no static exports found */
        function node_modulesShaJsHashJs(e, t, r) {
          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer;

          function i(e, t) {
            this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
          }

          i.prototype.update = function (e, t) {
            "string" == typeof e && (t = t || "utf8", e = n.from(e, t));

            for (var r = this._block, i = this._blockSize, o = e.length, a = this._len, s = 0; s < o;) {
              for (var f = a % i, c = Math.min(o - s, i - f), u = 0; u < c; u++) {
                r[f + u] = e[s + u];
              }

              s += c, (a += c) % i == 0 && this._update(r);
            }

            return this._len += o, this;
          }, i.prototype.digest = function (e) {
            var t = this._len % this._blockSize;
            this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
            var r = 8 * this._len;
            if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);else {
              var n = (4294967295 & r) >>> 0,
                  i = (r - n) / 4294967296;
              this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
            }

            this._update(this._block);

            var o = this._hash();

            return e ? o.toString(e) : o;
          }, i.prototype._update = function () {
            throw new Error("_update must be implemented by subclass");
          }, e.exports = i;
        },
        "./node_modules/sha.js/index.js":
        /*!**************************************!*\
          !*** ./node_modules/sha.js/index.js ***!
          \**************************************/

        /*! no static exports found */
        function node_modulesShaJsIndexJs(e, t, r) {
          (t = e.exports = function (e) {
            e = e.toLowerCase();
            var r = t[e];
            if (!r) throw new Error(e + " is not supported (we accept pull requests)");
            return new r();
          }).sha = r(
          /*! ./sha */
          "./node_modules/sha.js/sha.js"), t.sha1 = r(
          /*! ./sha1 */
          "./node_modules/sha.js/sha1.js"), t.sha224 = r(
          /*! ./sha224 */
          "./node_modules/sha.js/sha224.js"), t.sha256 = r(
          /*! ./sha256 */
          "./node_modules/sha.js/sha256.js"), t.sha384 = r(
          /*! ./sha384 */
          "./node_modules/sha.js/sha384.js"), t.sha512 = r(
          /*! ./sha512 */
          "./node_modules/sha.js/sha512.js");
        },
        "./node_modules/sha.js/sha.js":
        /*!************************************!*\
          !*** ./node_modules/sha.js/sha.js ***!
          \************************************/

        /*! no static exports found */
        function node_modulesShaJsShaJs(e, t, r) {
          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! ./hash */
          "./node_modules/sha.js/hash.js"),
              o = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              a = [1518500249, 1859775393, -1894007588, -899497514],
              s = new Array(80);

          function f() {
            this.init(), this._w = s, i.call(this, 64, 56);
          }

          function c(e) {
            return e << 30 | e >>> 2;
          }

          function u(e, t, r, n) {
            return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
          }

          n(f, i), f.prototype.init = function () {
            return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
          }, f.prototype._update = function (e) {
            for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, d = 0; d < 16; ++d) {
              r[d] = e.readInt32BE(4 * d);
            }

            for (; d < 80; ++d) {
              r[d] = r[d - 3] ^ r[d - 8] ^ r[d - 14] ^ r[d - 16];
            }

            for (var h = 0; h < 80; ++h) {
              var l = ~~(h / 20),
                  p = 0 | ((t = n) << 5 | t >>> 27) + u(l, i, o, s) + f + r[h] + a[l];
              f = s, s = o, o = c(i), i = n, n = p;
            }

            this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0;
          }, f.prototype._hash = function () {
            var e = o.allocUnsafe(20);
            return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
          }, e.exports = f;
        },
        "./node_modules/sha.js/sha1.js":
        /*!*************************************!*\
          !*** ./node_modules/sha.js/sha1.js ***!
          \*************************************/

        /*! no static exports found */
        function node_modulesShaJsSha1Js(e, t, r) {
          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! ./hash */
          "./node_modules/sha.js/hash.js"),
              o = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              a = [1518500249, 1859775393, -1894007588, -899497514],
              s = new Array(80);

          function f() {
            this.init(), this._w = s, i.call(this, 64, 56);
          }

          function c(e) {
            return e << 5 | e >>> 27;
          }

          function u(e) {
            return e << 30 | e >>> 2;
          }

          function d(e, t, r, n) {
            return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
          }

          n(f, i), f.prototype.init = function () {
            return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
          }, f.prototype._update = function (e) {
            for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, h = 0; h < 16; ++h) {
              r[h] = e.readInt32BE(4 * h);
            }

            for (; h < 80; ++h) {
              r[h] = (t = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16]) << 1 | t >>> 31;
            }

            for (var l = 0; l < 80; ++l) {
              var p = ~~(l / 20),
                  b = c(n) + d(p, i, o, s) + f + r[l] + a[p] | 0;
              f = s, s = o, o = u(i), i = n, n = b;
            }

            this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0;
          }, f.prototype._hash = function () {
            var e = o.allocUnsafe(20);
            return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
          }, e.exports = f;
        },
        "./node_modules/sha.js/sha224.js":
        /*!***************************************!*\
          !*** ./node_modules/sha.js/sha224.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesShaJsSha224Js(e, t, r) {
          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! ./sha256 */
          "./node_modules/sha.js/sha256.js"),
              o = r(
          /*! ./hash */
          "./node_modules/sha.js/hash.js"),
              a = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              s = new Array(64);

          function f() {
            this.init(), this._w = s, o.call(this, 64, 56);
          }

          n(f, i), f.prototype.init = function () {
            return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
          }, f.prototype._hash = function () {
            var e = a.allocUnsafe(28);
            return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
          }, e.exports = f;
        },
        "./node_modules/sha.js/sha256.js":
        /*!***************************************!*\
          !*** ./node_modules/sha.js/sha256.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesShaJsSha256Js(e, t, r) {
          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! ./hash */
          "./node_modules/sha.js/hash.js"),
              o = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              a = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
              s = new Array(64);

          function f() {
            this.init(), this._w = s, i.call(this, 64, 56);
          }

          function c(e, t, r) {
            return r ^ e & (t ^ r);
          }

          function u(e, t, r) {
            return e & t | r & (e | t);
          }

          function d(e) {
            return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
          }

          function h(e) {
            return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
          }

          function l(e) {
            return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
          }

          n(f, i), f.prototype.init = function () {
            return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
          }, f.prototype._update = function (e) {
            for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, p = 0 | this._f, b = 0 | this._g, m = 0 | this._h, y = 0; y < 16; ++y) {
              r[y] = e.readInt32BE(4 * y);
            }

            for (; y < 64; ++y) {
              r[y] = 0 | (((t = r[y - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[y - 7] + l(r[y - 15]) + r[y - 16];
            }

            for (var v = 0; v < 64; ++v) {
              var g = m + h(f) + c(f, p, b) + a[v] + r[v] | 0,
                  _ = d(n) + u(n, i, o) | 0;

              m = b, b = p, p = f, f = s + g | 0, s = o, o = i, i = n, n = g + _ | 0;
            }

            this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0, this._f = p + this._f | 0, this._g = b + this._g | 0, this._h = m + this._h | 0;
          }, f.prototype._hash = function () {
            var e = o.allocUnsafe(32);
            return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
          }, e.exports = f;
        },
        "./node_modules/sha.js/sha384.js":
        /*!***************************************!*\
          !*** ./node_modules/sha.js/sha384.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesShaJsSha384Js(e, t, r) {
          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! ./sha512 */
          "./node_modules/sha.js/sha512.js"),
              o = r(
          /*! ./hash */
          "./node_modules/sha.js/hash.js"),
              a = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              s = new Array(160);

          function f() {
            this.init(), this._w = s, o.call(this, 128, 112);
          }

          n(f, i), f.prototype.init = function () {
            return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
          }, f.prototype._hash = function () {
            var e = a.allocUnsafe(48);

            function t(t, r, n) {
              e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
            }

            return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
          }, e.exports = f;
        },
        "./node_modules/sha.js/sha512.js":
        /*!***************************************!*\
          !*** ./node_modules/sha.js/sha512.js ***!
          \***************************************/

        /*! no static exports found */
        function node_modulesShaJsSha512Js(e, t, r) {
          var n = r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js"),
              i = r(
          /*! ./hash */
          "./node_modules/sha.js/hash.js"),
              o = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              a = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
              s = new Array(160);

          function f() {
            this.init(), this._w = s, i.call(this, 128, 112);
          }

          function c(e, t, r) {
            return r ^ e & (t ^ r);
          }

          function u(e, t, r) {
            return e & t | r & (e | t);
          }

          function d(e, t) {
            return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
          }

          function h(e, t) {
            return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
          }

          function l(e, t) {
            return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
          }

          function p(e, t) {
            return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
          }

          function b(e, t) {
            return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
          }

          function m(e, t) {
            return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
          }

          function y(e, t) {
            return e >>> 0 < t >>> 0 ? 1 : 0;
          }

          n(f, i), f.prototype.init = function () {
            return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
          }, f.prototype._update = function (e) {
            for (var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, o = 0 | this._dh, s = 0 | this._eh, f = 0 | this._fh, v = 0 | this._gh, g = 0 | this._hh, _ = 0 | this._al, w = 0 | this._bl, k = 0 | this._cl, E = 0 | this._dl, A = 0 | this._el, S = 0 | this._fl, M = 0 | this._gl, x = 0 | this._hl, I = 0; I < 32; I += 2) {
              t[I] = e.readInt32BE(4 * I), t[I + 1] = e.readInt32BE(4 * I + 4);
            }

            for (; I < 160; I += 2) {
              var j = t[I - 30],
                  B = t[I - 30 + 1],
                  R = l(j, B),
                  P = p(B, j),
                  T = b(j = t[I - 4], B = t[I - 4 + 1]),
                  L = m(B, j),
                  C = t[I - 14],
                  O = t[I - 14 + 1],
                  N = t[I - 32],
                  U = t[I - 32 + 1],
                  D = P + O | 0,
                  q = R + C + y(D, P) | 0;
              q = (q = q + T + y(D = D + L | 0, L) | 0) + N + y(D = D + U | 0, U) | 0, t[I] = q, t[I + 1] = D;
            }

            for (var z = 0; z < 160; z += 2) {
              q = t[z], D = t[z + 1];
              var F = u(r, n, i),
                  Y = u(_, w, k),
                  K = d(r, _),
                  V = d(_, r),
                  H = h(s, A),
                  W = h(A, s),
                  G = a[z],
                  X = a[z + 1],
                  Z = c(s, f, v),
                  J = c(A, S, M),
                  $ = x + W | 0,
                  Q = g + H + y($, x) | 0;
              Q = (Q = (Q = Q + Z + y($ = $ + J | 0, J) | 0) + G + y($ = $ + X | 0, X) | 0) + q + y($ = $ + D | 0, D) | 0;
              var ee = V + Y | 0,
                  te = K + F + y(ee, V) | 0;
              g = v, x = M, v = f, M = S, f = s, S = A, s = o + Q + y(A = E + $ | 0, E) | 0, o = i, E = k, i = n, k = w, n = r, w = _, r = Q + te + y(_ = $ + ee | 0, $) | 0;
            }

            this._al = this._al + _ | 0, this._bl = this._bl + w | 0, this._cl = this._cl + k | 0, this._dl = this._dl + E | 0, this._el = this._el + A | 0, this._fl = this._fl + S | 0, this._gl = this._gl + M | 0, this._hl = this._hl + x | 0, this._ah = this._ah + r + y(this._al, _) | 0, this._bh = this._bh + n + y(this._bl, w) | 0, this._ch = this._ch + i + y(this._cl, k) | 0, this._dh = this._dh + o + y(this._dl, E) | 0, this._eh = this._eh + s + y(this._el, A) | 0, this._fh = this._fh + f + y(this._fl, S) | 0, this._gh = this._gh + v + y(this._gl, M) | 0, this._hh = this._hh + g + y(this._hl, x) | 0;
          }, f.prototype._hash = function () {
            var e = o.allocUnsafe(64);

            function t(t, r, n) {
              e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
            }

            return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
          }, e.exports = f;
        },
        "./node_modules/stream-browserify/index.js":
        /*!*************************************************!*\
          !*** ./node_modules/stream-browserify/index.js ***!
          \*************************************************/

        /*! no static exports found */
        function node_modulesStreamBrowserifyIndexJs(e, t, r) {
          e.exports = i;
          var n = r(
          /*! events */
          "./node_modules/events/events.js").EventEmitter;

          function i() {
            n.call(this);
          }

          r(
          /*! inherits */
          "./node_modules/inherits/inherits_browser.js")(i, n), i.Readable = r(
          /*! readable-stream/readable.js */
          "./node_modules/readable-stream/readable-browser.js"), i.Writable = r(
          /*! readable-stream/writable.js */
          "./node_modules/readable-stream/writable-browser.js"), i.Duplex = r(
          /*! readable-stream/duplex.js */
          "./node_modules/readable-stream/duplex-browser.js"), i.Transform = r(
          /*! readable-stream/transform.js */
          "./node_modules/readable-stream/transform.js"), i.PassThrough = r(
          /*! readable-stream/passthrough.js */
          "./node_modules/readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function (e, t) {
            var r = this;

            function i(t) {
              e.writable && !1 === e.write(t) && r.pause && r.pause();
            }

            function o() {
              r.readable && r.resume && r.resume();
            }

            r.on("data", i), e.on("drain", o), e._isStdio || t && !1 === t.end || (r.on("end", s), r.on("close", f));
            var a = !1;

            function s() {
              a || (a = !0, e.end());
            }

            function f() {
              a || (a = !0, "function" == typeof e.destroy && e.destroy());
            }

            function c(e) {
              if (u(), 0 === n.listenerCount(this, "error")) throw e;
            }

            function u() {
              r.removeListener("data", i), e.removeListener("drain", o), r.removeListener("end", s), r.removeListener("close", f), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
            }

            return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
          };
        },
        "./node_modules/string_decoder/lib/string_decoder.js":
        /*!***********************************************************!*\
          !*** ./node_modules/string_decoder/lib/string_decoder.js ***!
          \***********************************************************/

        /*! no static exports found */
        function node_modulesString_decoderLibString_decoderJs(e, t, r) {
          "use strict";

          var n = r(
          /*! safe-buffer */
          "./node_modules/safe-buffer/index.js").Buffer,
              i = n.isEncoding || function (e) {
            switch ((e = "" + e) && e.toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
              case "raw":
                return !0;

              default:
                return !1;
            }
          };

          function o(e) {
            var t;

            switch (this.encoding = function (e) {
              var t = function (e) {
                if (!e) return "utf8";

                for (var t;;) {
                  switch (e) {
                    case "utf8":
                    case "utf-8":
                      return "utf8";

                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return "utf16le";

                    case "latin1":
                    case "binary":
                      return "latin1";

                    case "base64":
                    case "ascii":
                    case "hex":
                      return e;

                    default:
                      if (t) return;
                      e = ("" + e).toLowerCase(), t = !0;
                  }
                }
              }(e);

              if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
              return t || e;
            }(e), this.encoding) {
              case "utf16le":
                this.text = f, this.end = c, t = 4;
                break;

              case "utf8":
                this.fillLast = s, t = 4;
                break;

              case "base64":
                this.text = u, this.end = d, t = 3;
                break;

              default:
                return this.write = h, void (this.end = l);
            }

            this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
          }

          function a(e) {
            return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
          }

          function s(e) {
            var t = this.lastTotal - this.lastNeed,
                r = function (e, t, r) {
              if (128 != (192 & t[0])) return e.lastNeed = 0, "�";

              if (e.lastNeed > 1 && t.length > 1) {
                if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
                if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
              }
            }(this, e);

            return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
          }

          function f(e, t) {
            if ((e.length - t) % 2 == 0) {
              var r = e.toString("utf16le", t);

              if (r) {
                var n = r.charCodeAt(r.length - 1);
                if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
              }

              return r;
            }

            return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
          }

          function c(e) {
            var t = e && e.length ? this.write(e) : "";

            if (this.lastNeed) {
              var r = this.lastTotal - this.lastNeed;
              return t + this.lastChar.toString("utf16le", 0, r);
            }

            return t;
          }

          function u(e, t) {
            var r = (e.length - t) % 3;
            return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
          }

          function d(e) {
            var t = e && e.length ? this.write(e) : "";
            return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
          }

          function h(e) {
            return e.toString(this.encoding);
          }

          function l(e) {
            return e && e.length ? this.write(e) : "";
          }

          t.StringDecoder = o, o.prototype.write = function (e) {
            if (0 === e.length) return "";
            var t, r;

            if (this.lastNeed) {
              if (void 0 === (t = this.fillLast(e))) return "";
              r = this.lastNeed, this.lastNeed = 0;
            } else r = 0;

            return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
          }, o.prototype.end = function (e) {
            var t = e && e.length ? this.write(e) : "";
            return this.lastNeed ? t + "�" : t;
          }, o.prototype.text = function (e, t) {
            var r = function (e, t, r) {
              var n = t.length - 1;
              if (n < r) return 0;
              var i = a(t[n]);
              return i >= 0 ? (i > 0 && (e.lastNeed = i - 1), i) : --n < r || -2 === i ? 0 : (i = a(t[n])) >= 0 ? (i > 0 && (e.lastNeed = i - 2), i) : --n < r || -2 === i ? 0 : (i = a(t[n])) >= 0 ? (i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i) : 0;
            }(this, e, t);

            if (!this.lastNeed) return e.toString("utf8", t);
            this.lastTotal = r;
            var n = e.length - (r - this.lastNeed);
            return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
          }, o.prototype.fillLast = function (e) {
            if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
            e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
          };
        },
        "./node_modules/timers-browserify/main.js":
        /*!************************************************!*\
          !*** ./node_modules/timers-browserify/main.js ***!
          \************************************************/

        /*! no static exports found */
        function node_modulesTimersBrowserifyMainJs(e, t, r) {
          (function (e) {
            var n = void 0 !== e && e || "undefined" != typeof self && self || window,
                i = Function.prototype.apply;

            function o(e, t) {
              this._id = e, this._clearFn = t;
            }

            t.setTimeout = function () {
              return new o(i.call(setTimeout, n, arguments), clearTimeout);
            }, t.setInterval = function () {
              return new o(i.call(setInterval, n, arguments), clearInterval);
            }, t.clearTimeout = t.clearInterval = function (e) {
              e && e.close();
            }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
              this._clearFn.call(n, this._id);
            }, t.enroll = function (e, t) {
              clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
            }, t.unenroll = function (e) {
              clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
            }, t._unrefActive = t.active = function (e) {
              clearTimeout(e._idleTimeoutId);
              var t = e._idleTimeout;
              t >= 0 && (e._idleTimeoutId = setTimeout(function () {
                e._onTimeout && e._onTimeout();
              }, t));
            }, r(
            /*! setimmediate */
            "./node_modules/setimmediate/setImmediate.js"), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
          }).call(this, r(
          /*! ./../webpack/buildin/global.js */
          "./node_modules/webpack/buildin/global.js"));
        },
        "./node_modules/util-deprecate/browser.js":
        /*!************************************************!*\
          !*** ./node_modules/util-deprecate/browser.js ***!
          \************************************************/

        /*! no static exports found */
        function node_modulesUtilDeprecateBrowserJs(e, t, r) {
          (function (t) {
            function r(e) {
              try {
                if (!t.localStorage) return !1;
              } catch (e) {
                return !1;
              }

              var r = t.localStorage[e];
              return null != r && "true" === String(r).toLowerCase();
            }

            e.exports = function (e, t) {
              if (r("noDeprecation")) return e;
              var n = !1;
              return function () {
                if (!n) {
                  if (r("throwDeprecation")) throw new Error(t);
                  r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
                }

                return e.apply(this, arguments);
              };
            };
          }).call(this, r(
          /*! ./../webpack/buildin/global.js */
          "./node_modules/webpack/buildin/global.js"));
        },
        "./node_modules/webpack/buildin/global.js":
        /*!***********************************!*\
          !*** (webpack)/buildin/global.js ***!
          \***********************************/

        /*! no static exports found */
        function node_modulesWebpackBuildinGlobalJs(e, t) {
          var r;

          r = function () {
            return this;
          }();

          try {
            r = r || new Function("return this")();
          } catch (e) {
            "object" == typeof window && (r = window);
          }

          e.exports = r;
        },
        "./node_modules/webpack/buildin/module.js":
        /*!***********************************!*\
          !*** (webpack)/buildin/module.js ***!
          \***********************************/

        /*! no static exports found */
        function node_modulesWebpackBuildinModuleJs(e, t) {
          e.exports = function (e) {
            return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
              enumerable: !0,
              get: function get() {
                return e.l;
              }
            }), Object.defineProperty(e, "id", {
              enumerable: !0,
              get: function get() {
                return e.i;
              }
            }), e.webpackPolyfill = 1), e;
          };
        },
        "./src/Tx.js":
        /*!*******************!*\
          !*** ./src/Tx.js ***!
          \*******************/

        /*! no static exports found */
        function srcTxJs(e, t, r) {
          function n(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
          }

          var i = r(
          /*! ./enum */
          "./src/enum.js"),
              o = i.TxOp,
              a = i.ContractMode,
              s = r(
          /*! ./ecc */
          "./src/ecc.js").stableHashObject;

          e.exports = function () {
            function e(t) {
              var r = t.from,
                  n = t.to,
                  i = t.payer,
                  o = t.value,
                  f = t.fee,
                  c = t.data,
                  u = t.nonce;

              if (function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.from = r || "", this.to = n || "", this.payer = i || "", this.value = String(o || ""), this.fee = String(f || ""), this.data = c || {}, this.nonce = u || Date.now() + Math.random(), this.isContractCreation()) {
                if (void 0 !== this.data.mode && this.data.mode !== a.JS_RAW && this.data.mode !== a.WASM) throw new Error("Invalid contract source mode: " + this.data.mode);
                if (!this.data.src) throw new Error("You must provide contract source to deploy contract.");
              }

              var d = {
                from: this.from,
                to: this.to,
                payer: this.payer,
                value: this.value,
                fee: this.fee,
                data: this.data,
                nonce: this.nonce
              };
              this.sigHash = s(d);
            }

            var t, r, i;
            return t = e, (r = [{
              key: "setEvidence",
              value: function value(e) {
                return this.evidence = e, this;
              }
            }, {
              key: "messageName",
              value: function value() {
                return null == this.data ? void 0 : this.data.name;
              }
            }, {
              key: "messageParams",
              value: function value() {
                return null == this.data ? void 0 : this.data.params || [];
              }
            }, {
              key: "isSimpleTransfer",
              value: function value() {
                return null == this.data || null == this.data.op;
              }
            }, {
              key: "isContractCreation",
              value: function value() {
                return this.data && this.data.op === o.DEPLOY_CONTRACT;
              }
            }, {
              key: "isContractCall",
              value: function value() {
                return this.data && this.data.op === o.CALL_CONTRACT;
              }
            }]) && n(t.prototype, r), i && n(t, i), e;
          }();
        },
        "./src/bech32.js":
        /*!***********************!*\
          !*** ./src/bech32.js ***!
          \***********************/

        /*! no static exports found */
        function srcBech32Js(e, t) {
          var r = "qpzry9x8gf2tvdw0s3jn54khce6mua7l",
              n = [996825010, 642813549, 513874426, 1027748829, 705979059];

          function i(e) {
            for (var t = 1, r = 0; r < e.length; ++r) {
              var i = t >> 25;
              t = (33554431 & t) << 5 ^ e[r];

              for (var o = 0; o < 5; ++o) {
                i >> o & 1 && (t ^= n[o]);
              }
            }

            return t;
          }

          function o(e) {
            var t,
                r = [];

            for (t = 0; t < e.length; ++t) {
              r.push(e.charCodeAt(t) >> 5);
            }

            for (r.push(0), t = 0; t < e.length; ++t) {
              r.push(31 & e.charCodeAt(t));
            }

            return r;
          }

          e.exports = {
            decode: function decode(e) {
              var t,
                  n = !1,
                  a = !1;

              for (t = 0; t < e.length; ++t) {
                if (e.charCodeAt(t) < 33 || e.charCodeAt(t) > 126) return null;
                e.charCodeAt(t) >= 97 && e.charCodeAt(t) <= 122 && (n = !0), e.charCodeAt(t) >= 65 && e.charCodeAt(t) <= 90 && (a = !0);
              }

              if (n && a) return null;
              if (11 > (e = e.toLowerCase()).length || e.length > 90) return null;
              var s = e.substring(0, 4),
                  f = [];

              for (t = 5; t < e.length; ++t) {
                var c = r.indexOf(e.charAt(t));
                if (-1 === c) return null;
                f.push(c);
              }

              var u = e.charAt(4);
              return u !== String(f[0] % 2) ? null : function (e, t) {
                return 1 === i(o(e).concat(t));
              }(s, f) ? {
                hrp: s,
                type: u,
                data: f.slice(0, f.length - 6)
              } : null;
            },
            encode: function encode(e, t) {
              for (var n = t.concat(function (e, t) {
                for (var r = 1 ^ i(o(e).concat(t).concat([0, 0, 0, 0, 0, 0])), n = [], a = 0; a < 6; ++a) {
                  n.push(r >> 5 * (5 - a) & 31);
                }

                return n;
              }(e, t)), a = e + String(t[0] % 2), s = 0; s < n.length; ++s) {
                a += r.charAt(n[s]);
              }

              return a;
            }
          };
        },
        "./src/codec.js":
        /*!**********************!*\
          !*** ./src/codec.js ***!
          \**********************/

        /*! no static exports found */
        function srcCodecJs(e, t, r) {
          (function (e) {
            var n = r(
            /*! msgpack-lite */
            "./node_modules/msgpack-lite/lib/browser.js"),
                i = r(
            /*! json-stable-stringify */
            "./node_modules/json-stable-stringify/index.js"),
                o = r(
            /*! base-x */
            "./node_modules/base-x/src/index.js")("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"),
                a = r(
            /*! ./bech32 */
            "./src/bech32.js"),
                s = r(
            /*! ./enum */
            "./src/enum.js").AccountType,
                f = s.REGULAR_ACCOUNT,
                c = s.BANK_ACCOUNT,
                u = function u(t) {
              var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "base58";
              if (e.isBuffer(t)) return t;
              if ("string" != typeof t) throw new Error("Text must be a string.");
              return "base58" === r ? o.decode(t) : e.from(t, r);
            },
                d = function d(t) {
              var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "base58";
              if ("string" == typeof t) return t;
              if (!e.isBuffer(t)) throw new Error("Buf must be a buffer.");
              return "base58" === r ? o.encode(t) : t.toString(r);
            },
                h = function h(e, t) {
              return e.charAt(4) === String(t);
            },
                l = function l(e) {
              for (var t = e.byteLength, r = new Uint8Array(e), n = 0, i = 0, o = [], a = 0; a < t; a++) {
                for (i = i << 8 | r[a], n += 8; n >= 5;) {
                  o.push(i >>> n - 5 & 31), n -= 5;
                }
              }

              return n > 0 && o.push(i << 5 - n & 31), o;
            };

            t.TX_ENCODING = "msgpack", t.encode = n.encode, t.decode = n.decode, t.KEY_ENCODING = "base58", t.toKeyBuffer = function (e) {
              return u(e, "base58");
            }, t.toKeyString = function (e) {
              return d(e, "base58");
            }, t.toAddressString = function (e, t) {
              return a.encode(t, l(e));
            }, t.decodeAddress = a.decode, t.isAddressType = h, t.isBankAddress = function (e) {
              return h(e, c);
            }, t.isRegularAddress = function (e) {
              return h(e, f);
            }, t.isAddressBufferType = function (e, t) {
              return function (e, t) {
                return String(e[0] % 2) === String(t);
              }(l(e), t);
            }, t.DATA_ENCODING = "base64", t.toDataBuffer = function (e) {
              return u(e, "base64");
            }, t.toDataString = function (e) {
              return d(e, "base64");
            }, t.stableStringify = i, t.toBuffer = u, t.toString = d;
          }).call(this, r(
          /*! ./../node_modules/buffer/index.js */
          "./node_modules/buffer/index.js").Buffer);
        },
        "./src/ecc.js":
        /*!********************!*\
          !*** ./src/ecc.js ***!
          \********************/

        /*! no static exports found */
        function srcEccJs(e, t, r) {
          var n = r(
          /*! randombytes */
          "./node_modules/randombytes/browser.js"),
              i = r(
          /*! create-hash */
          "./node_modules/create-hash/browser.js"),
              o = r(
          /*! secp256k1 */
          "./node_modules/secp256k1/elliptic.js"),
              a = r(
          /*! ./codec */
          "./src/codec.js"),
              s = a.toKeyBuffer,
              f = a.toKeyString,
              c = a.toAddressString,
              u = a.decodeAddress,
              d = a.toDataBuffer,
              h = a.stableStringify,
              l = a.DATA_ENCODING,
              p = a.isAddressType,
              b = a.isAddressBufferType,
              m = r(
          /*! ./enum */
          "./src/enum.js").AccountType,
              y = m.REGULAR_ACCOUNT,
              v = m.BANK_ACCOUNT;

          function g() {
            var e;

            do {
              e = n(32);
            } while (!o.privateKeyVerify(e));

            return e;
          }

          var _ = {
            validateAddress: function validateAddress(e) {
              var t;

              try {
                var r = (t = u(e)).hrp;
                if ("team" !== r && "teat" !== r) throw new Error("Invalid address prefix.");
                var n = t.type;
                if (n !== y && n !== v) throw new Error("Invalid account type.");
              } catch (e) {
                throw e.message = "Invalid address: " + e.message, e;
              }

              if (32 !== t.data.length) throw new Error("Invalid address length.");
              return t;
            },
            toPublicKeyBuffer: function toPublicKeyBuffer(e) {
              return o.publicKeyCreate(s(e));
            },
            toPublicKey: function toPublicKey(e) {
              return f(_.toPublicKeyBuffer(e));
            },
            toAddress: function toAddress(e) {
              var t = i("sha256").update(s(e)).digest(),
                  r = i("ripemd160").update(t).digest();
              return c(r, "teat");
            },
            toContractAddress: function toContractAddress(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v;
              if (t = String(t), ![v, y].includes(t)) throw new Error("Invalid account type: ".concat(t));
              var r = i("sha256").update(e).digest();

              do {
                r = i("ripemd160").update(r).digest();
              } while (!b(r, t));

              return c(r, "teat");
            },
            toPubKeyAndAddressBuffer: function toPubKeyAndAddressBuffer(e) {
              var t = _.toPublicKeyBuffer(e);

              return {
                publicKey: t,
                address: _.toAddress(t)
              };
            },
            toPubKeyAndAddress: function toPubKeyAndAddress(e) {
              var t = _.toPubKeyAndAddressBuffer(e),
                  r = t.publicKey,
                  n = t.address;

              return {
                publicKey: f(r),
                address: n
              };
            },
            newKeyBuffers: function newKeyBuffers() {
              var e,
                  t,
                  r,
                  n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : y;

              do {
                e = g(), t = _.toPublicKeyBuffer(e), r = _.toAddress(t);
              } while (!p(r, n));

              return {
                publicKey: t,
                privateKey: e,
                address: r
              };
            },
            newBankKeyBuffers: function newBankKeyBuffers() {
              return _.newKeyBuffers(v);
            },
            newKeys: function newKeys() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : y,
                  t = _.newKeyBuffers(e);

              return t.privateKey = f(t.privateKey), t.publicKey = f(t.publicKey), t;
            },
            newBankKeys: function newBankKeys() {
              return _.newKeys(v);
            },
            verify: function verify(e, t, r) {
              return o.verify(d(e), d(t), s(r));
            },
            sign: function sign(e, t) {
              return o.sign(d(e), s(t));
            },
            stableHashObject: function stableHashObject(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l;
              "string" != typeof e && (e = h(e));
              var r = i("sha256").update(e);
              return t ? r.digest(t) : r.digest();
            }
          };
          e.exports = _;
        },
        "./src/enum.js":
        /*!*********************!*\
          !*** ./src/enum.js ***!
          \*********************/

        /*! no static exports found */
        function srcEnumJs(e, t) {
          t.ContractMode = Object.freeze({
            JS_RAW: 0,
            JS_DECORATED: 1,
            WASM: 100
          }), t.TxOp = Object.freeze({
            DEPLOY_CONTRACT: 0,
            CALL_CONTRACT: 1
          }), t.AccountType = Object.freeze({
            REGULAR_ACCOUNT: "0",
            BANK_ACCOUNT: "1"
          });
        },
        "./src/index.js":
        /*!**********************!*\
          !*** ./src/index.js ***!
          \**********************/

        /*! no static exports found */
        function srcIndexJs(e, t, r) {
          var n = r(
          /*! ./codec */
          "./src/codec.js"),
              i = r(
          /*! ./ecc */
          "./src/ecc.js"),
              o = r(
          /*! ./Tx */
          "./src/Tx.js"),
              a = r(
          /*! ./enum */
          "./src/enum.js"),
              s = a.ContractMode,
              f = a.TxOp,
              c = a.AccountType,
              u = r(
          /*! ./utils */
          "./src/utils.js");
          t.codec = n, t.ecc = i, t.Tx = o, t.ContractMode = s, t.TxOp = f, t.AccountType = c, t.utils = u;
        },
        "./src/utils.js":
        /*!**********************!*\
          !*** ./src/utils.js ***!
          \**********************/

        /*! no static exports found */
        function srcUtilsJs(e, t, r) {
          (function (t) {
            var n = r(
            /*! ./ecc */
            "./src/ecc.js"),
                i = r(
            /*! ./Tx */
            "./src/Tx.js"),
                o = r(
            /*! ./codec */
            "./src/codec.js"),
                a = o.toKeyBuffer,
                s = o.toDataString,
                f = r(
            /*! ./enum */
            "./src/enum.js").AccountType;

            function c(e) {
              return u(n.newKeyBuffers(e));
            }

            function u(e) {
              if (!e) throw new Error("Private key is required.");
              var r, i;
              if (e.privateKey && (r = e.publicKey, i = e.address, e = e.privateKey), "string" != typeof e && !t.isBuffer(e)) throw new Error("Invalid private key. Private key must be a Buffer or a string.");
              if (32 !== (e = a(e)).length) throw new Error("Invalid private key length.");

              if (!r || !i) {
                var o = n.toPubKeyAndAddressBuffer(e);
                r = o.publicKey, i = o.address;
              }

              return {
                address: i,
                publicKey: r,
                privateKey: e,
                sign: function sign(t) {
                  return n.sign(t, e);
                },
                signTransaction: function signTransaction(t) {
                  return d(t, e);
                }
              };
            }

            function d(e, t) {
              t = a(t), e.evidence = e.evidence || [];
              var r = {};
              r.pubkey = n.toPublicKey(t);
              var o = new i(e);
              return r.signature = s(n.sign(o.sigHash, t).signature), e.evidence.push(r), e.nonce || (e.nonce = o.nonce), e;
            }

            e.exports = {
              signTransaction: d,
              verifyTxSignature: function verifyTxSignature(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                    r = e.evidence;
                Array.isArray(r) || (r = [r]);
                var i = [];
                r.forEach(function (r) {
                  if (!n.verify(e.sigHash, r.signature, r.pubkey)) throw new Error("Invalid signature.");
                  t && i.push(n.toAddress(r.pubkey));
                }), t && (e.signers = i);
              },
              newAccount: c,
              newRegularAccount: function newRegularAccount() {
                return c(f.REGULAR_ACCOUNT);
              },
              newBankAccount: function newBankAccount() {
                return c(f.BANK_ACCOUNT);
              },
              getAccount: u
            };
          }).call(this, r(
          /*! ./../node_modules/buffer/index.js */
          "./node_modules/buffer/index.js").Buffer);
        },
        0:
        /*!**********************!*\
          !*** util (ignored) ***!
          \**********************/

        /*! no static exports found */
        function _(e, t) {},
        1:
        /*!**********************!*\
          !*** util (ignored) ***!
          \**********************/

        /*! no static exports found */
        function _(e, t) {},
        2:
        /*!************************!*\
          !*** buffer (ignored) ***!
          \************************/

        /*! no static exports found */
        function _(e, t) {},
        3:
        /*!************************!*\
          !*** crypto (ignored) ***!
          \************************/

        /*! no static exports found */
        function _(e, t) {}
      });
    }, e.exports = n();
  }, function (e, t, r) {
    "use strict";

    var n = r(21),
        i = Object.keys || function (e) {
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t;
    };

    e.exports = d;
    var o = Object.create(r(15));
    o.inherits = r(0);
    var a = r(48),
        s = r(31);
    o.inherits(d, a);

    for (var f = i(s.prototype), c = 0; c < f.length; c++) {
      var u = f[c];
      d.prototype[u] || (d.prototype[u] = s.prototype[u]);
    }

    function d(e) {
      if (!(this instanceof d)) return new d(e);
      a.call(this, e), s.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", h);
    }

    function h() {
      this.allowHalfOpen || this._writableState.ended || n.nextTick(l, this);
    }

    function l(e) {
      e.end();
    }

    Object.defineProperty(d.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(d.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(e) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
      }
    }), d.prototype._destroy = function (e, t) {
      this.push(null), this.end(), n.nextTick(t, e);
    };
  }, function (e, t, r) {
    "use strict";

    (function (t, n) {
      var i = r(1).Buffer,
          o = t.crypto || t.msCrypto;
      o && o.getRandomValues ? e.exports = function (e, t) {
        if (e > 4294967295) throw new RangeError("requested too many random bytes");
        var r = i.allocUnsafe(e);
        if (e > 0) if (e > 65536) for (var a = 0; a < e; a += 65536) {
          o.getRandomValues(r.slice(a, a + 65536));
        } else o.getRandomValues(r);
        if ("function" == typeof t) return n.nextTick(function () {
          t(null, r);
        });
        return r;
      } : e.exports = function () {
        throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
      };
    }).call(this, r(6), r(7));
  }, function (e, t, r) {
    var n = r(1).Buffer;

    function i(e, t) {
      this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
    }

    i.prototype.update = function (e, t) {
      "string" == typeof e && (t = t || "utf8", e = n.from(e, t));

      for (var r = this._block, i = this._blockSize, o = e.length, a = this._len, s = 0; s < o;) {
        for (var f = a % i, c = Math.min(o - s, i - f), u = 0; u < c; u++) {
          r[f + u] = e[s + u];
        }

        s += c, (a += c) % i == 0 && this._update(r);
      }

      return this._len += o, this;
    }, i.prototype.digest = function (e) {
      var t = this._len % this._blockSize;
      this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
      var r = 8 * this._len;
      if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);else {
        var n = (4294967295 & r) >>> 0,
            i = (r - n) / 4294967296;
        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
      }

      this._update(this._block);

      var o = this._hash();

      return e ? o.toString(e) : o;
    }, i.prototype._update = function () {
      throw new Error("_update must be implemented by subclass");
    }, e.exports = i;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        i = r(27),
        o = r(33),
        a = r(34),
        s = r(9);

    function f(e) {
      s.call(this, "digest"), this._hash = e;
    }

    n(f, s), f.prototype._update = function (e) {
      this._hash.update(e);
    }, f.prototype._final = function () {
      return this._hash.digest();
    }, e.exports = function (e) {
      return "md5" === (e = e.toLowerCase()) ? new i() : "rmd160" === e || "ripemd160" === e ? new o() : new f(a(e));
    };
  }, function (e, t, r) {
    (function (e) {
      function r(e) {
        return Object.prototype.toString.call(e);
      }

      t.isArray = function (e) {
        return Array.isArray ? Array.isArray(e) : "[object Array]" === r(e);
      }, t.isBoolean = function (e) {
        return "boolean" == typeof e;
      }, t.isNull = function (e) {
        return null === e;
      }, t.isNullOrUndefined = function (e) {
        return null == e;
      }, t.isNumber = function (e) {
        return "number" == typeof e;
      }, t.isString = function (e) {
        return "string" == typeof e;
      }, t.isSymbol = function (e) {
        return "symbol" == typeof e;
      }, t.isUndefined = function (e) {
        return void 0 === e;
      }, t.isRegExp = function (e) {
        return "[object RegExp]" === r(e);
      }, t.isObject = function (e) {
        return "object" == typeof e && null !== e;
      }, t.isDate = function (e) {
        return "[object Date]" === r(e);
      }, t.isError = function (e) {
        return "[object Error]" === r(e) || e instanceof Error;
      }, t.isFunction = function (e) {
        return "function" == typeof e;
      }, t.isPrimitive = function (e) {
        return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
      }, t.isBuffer = e.isBuffer;
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    (function (t) {
      e.exports = function (e, r) {
        for (var n = Math.min(e.length, r.length), i = new t(n), o = 0; o < n; ++o) {
          i[o] = e[o] ^ r[o];
        }

        return i;
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(4);

    function o() {
      this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
    }

    t.BlockHash = o, o.prototype.update = function (e, t) {
      if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
        var r = (e = this.pending).length % this._delta8;
        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);

        for (var i = 0; i < e.length; i += this._delta32) {
          this._update(e, i, i + this._delta32);
        }
      }

      return this;
    }, o.prototype.digest = function (e) {
      return this.update(this._pad()), i(null === this.pending), this._digest(e);
    }, o.prototype._pad = function () {
      var e = this.pendingTotal,
          t = this._delta8,
          r = t - (e + this.padLength) % t,
          n = new Array(r + this.padLength);
      n[0] = 128;

      for (var i = 1; i < r; i++) {
        n[i] = 0;
      }

      if (e <<= 3, "big" === this.endian) {
        for (var o = 8; o < this.padLength; o++) {
          n[i++] = 0;
        }

        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
      } else for (n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++) {
        n[i++] = 0;
      }

      return n;
    };
  }, function (e, t, r) {
    var n = t;
    n.bignum = r(3), n.define = r(158).define, n.base = r(19), n.constants = r(77), n.decoders = r(163), n.encoders = r(165);
  }, function (e, t, r) {
    var n = t;
    n.Reporter = r(160).Reporter, n.DecoderBuffer = r(76).DecoderBuffer, n.EncoderBuffer = r(76).EncoderBuffer, n.Node = r(161);
  }, function (e, t, r) {
    "use strict";

    t.randomBytes = t.rng = t.pseudoRandomBytes = t.prng = r(12), t.createHash = t.Hash = r(14), t.createHmac = t.Hmac = r(54);
    var n = r(115),
        i = Object.keys(n),
        o = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(i);

    t.getHashes = function () {
      return o;
    };

    var a = r(57);
    t.pbkdf2 = a.pbkdf2, t.pbkdf2Sync = a.pbkdf2Sync;
    var s = r(117);
    t.Cipher = s.Cipher, t.createCipher = s.createCipher, t.Cipheriv = s.Cipheriv, t.createCipheriv = s.createCipheriv, t.Decipher = s.Decipher, t.createDecipher = s.createDecipher, t.Decipheriv = s.Decipheriv, t.createDecipheriv = s.createDecipheriv, t.getCiphers = s.getCiphers, t.listCiphers = s.listCiphers;
    var f = r(132);
    t.DiffieHellmanGroup = f.DiffieHellmanGroup, t.createDiffieHellmanGroup = f.createDiffieHellmanGroup, t.getDiffieHellman = f.getDiffieHellman, t.createDiffieHellman = f.createDiffieHellman, t.DiffieHellman = f.DiffieHellman;
    var c = r(137);
    t.createSign = c.createSign, t.Sign = c.Sign, t.createVerify = c.createVerify, t.Verify = c.Verify, t.createECDH = r(171);
    var u = r(172);
    t.publicEncrypt = u.publicEncrypt, t.privateEncrypt = u.privateEncrypt, t.publicDecrypt = u.publicDecrypt, t.privateDecrypt = u.privateDecrypt;
    var d = r(175);
    t.randomFill = d.randomFill, t.randomFillSync = d.randomFillSync, t.createCredentials = function () {
      throw new Error(["sorry, createCredentials is not implemented yet", "we accept pull requests", "https://github.com/crypto-browserify/crypto-browserify"].join("\n"));
    }, t.constants = {
      DH_CHECK_P_NOT_SAFE_PRIME: 2,
      DH_CHECK_P_NOT_PRIME: 1,
      DH_UNABLE_TO_CHECK_GENERATOR: 4,
      DH_NOT_SUITABLE_GENERATOR: 8,
      NPN_ENABLED: 1,
      ALPN_ENABLED: 1,
      RSA_PKCS1_PADDING: 1,
      RSA_SSLV23_PADDING: 2,
      RSA_NO_PADDING: 3,
      RSA_PKCS1_OAEP_PADDING: 4,
      RSA_X931_PADDING: 5,
      RSA_PKCS1_PSS_PADDING: 6,
      POINT_CONVERSION_COMPRESSED: 2,
      POINT_CONVERSION_UNCOMPRESSED: 4,
      POINT_CONVERSION_HYBRID: 6
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      void 0 === t || !t.version || 0 === t.version.indexOf("v0.") || 0 === t.version.indexOf("v1.") && 0 !== t.version.indexOf("v1.8.") ? e.exports = {
        nextTick: function nextTick(e, r, n, i) {
          if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
          var o,
              a,
              s = arguments.length;

          switch (s) {
            case 0:
            case 1:
              return t.nextTick(e);

            case 2:
              return t.nextTick(function () {
                e.call(null, r);
              });

            case 3:
              return t.nextTick(function () {
                e.call(null, r, n);
              });

            case 4:
              return t.nextTick(function () {
                e.call(null, r, n, i);
              });

            default:
              for (o = new Array(s - 1), a = 0; a < o.length;) {
                o[a++] = arguments[a];
              }

              return t.nextTick(function () {
                e.apply(null, o);
              });
          }
        }
      } : e.exports = t;
    }).call(this, r(7));
  }, function (e, t, r) {
    var n = r(1).Buffer;

    function i(e) {
      n.isBuffer(e) || (e = n.from(e));

      for (var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++) {
        r[i] = e.readUInt32BE(4 * i);
      }

      return r;
    }

    function o(e) {
      for (; 0 < e.length; e++) {
        e[0] = 0;
      }
    }

    function a(e, t, r, n, i) {
      for (var o, a, s, f, c = r[0], u = r[1], d = r[2], h = r[3], l = e[0] ^ t[0], p = e[1] ^ t[1], b = e[2] ^ t[2], m = e[3] ^ t[3], y = 4, v = 1; v < i; v++) {
        o = c[l >>> 24] ^ u[p >>> 16 & 255] ^ d[b >>> 8 & 255] ^ h[255 & m] ^ t[y++], a = c[p >>> 24] ^ u[b >>> 16 & 255] ^ d[m >>> 8 & 255] ^ h[255 & l] ^ t[y++], s = c[b >>> 24] ^ u[m >>> 16 & 255] ^ d[l >>> 8 & 255] ^ h[255 & p] ^ t[y++], f = c[m >>> 24] ^ u[l >>> 16 & 255] ^ d[p >>> 8 & 255] ^ h[255 & b] ^ t[y++], l = o, p = a, b = s, m = f;
      }

      return o = (n[l >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & m]) ^ t[y++], a = (n[p >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[m >>> 8 & 255] << 8 | n[255 & l]) ^ t[y++], s = (n[b >>> 24] << 24 | n[m >>> 16 & 255] << 16 | n[l >>> 8 & 255] << 8 | n[255 & p]) ^ t[y++], f = (n[m >>> 24] << 24 | n[l >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & b]) ^ t[y++], [o >>>= 0, a >>>= 0, s >>>= 0, f >>>= 0];
    }

    var s = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
        f = function () {
      for (var e = new Array(256), t = 0; t < 256; t++) {
        e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
      }

      for (var r = [], n = [], i = [[], [], [], []], o = [[], [], [], []], a = 0, s = 0, f = 0; f < 256; ++f) {
        var c = s ^ s << 1 ^ s << 2 ^ s << 3 ^ s << 4;
        c = c >>> 8 ^ 255 & c ^ 99, r[a] = c, n[c] = a;
        var u = e[a],
            d = e[u],
            h = e[d],
            l = 257 * e[c] ^ 16843008 * c;
        i[0][a] = l << 24 | l >>> 8, i[1][a] = l << 16 | l >>> 16, i[2][a] = l << 8 | l >>> 24, i[3][a] = l, l = 16843009 * h ^ 65537 * d ^ 257 * u ^ 16843008 * a, o[0][c] = l << 24 | l >>> 8, o[1][c] = l << 16 | l >>> 16, o[2][c] = l << 8 | l >>> 24, o[3][c] = l, 0 === a ? a = s = 1 : (a = u ^ e[e[e[h ^ u]]], s ^= e[e[s]]);
      }

      return {
        SBOX: r,
        INV_SBOX: n,
        SUB_MIX: i,
        INV_SUB_MIX: o
      };
    }();

    function c(e) {
      this._key = i(e), this._reset();
    }

    c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function () {
      for (var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], o = 0; o < t; o++) {
        i[o] = e[o];
      }

      for (o = t; o < n; o++) {
        var a = i[o - 1];
        o % t == 0 ? (a = a << 8 | a >>> 24, a = f.SBOX[a >>> 24] << 24 | f.SBOX[a >>> 16 & 255] << 16 | f.SBOX[a >>> 8 & 255] << 8 | f.SBOX[255 & a], a ^= s[o / t | 0] << 24) : t > 6 && o % t == 4 && (a = f.SBOX[a >>> 24] << 24 | f.SBOX[a >>> 16 & 255] << 16 | f.SBOX[a >>> 8 & 255] << 8 | f.SBOX[255 & a]), i[o] = i[o - t] ^ a;
      }

      for (var c = [], u = 0; u < n; u++) {
        var d = n - u,
            h = i[d - (u % 4 ? 0 : 4)];
        c[u] = u < 4 || d <= 4 ? h : f.INV_SUB_MIX[0][f.SBOX[h >>> 24]] ^ f.INV_SUB_MIX[1][f.SBOX[h >>> 16 & 255]] ^ f.INV_SUB_MIX[2][f.SBOX[h >>> 8 & 255]] ^ f.INV_SUB_MIX[3][f.SBOX[255 & h]];
      }

      this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
    }, c.prototype.encryptBlockRaw = function (e) {
      return a(e = i(e), this._keySchedule, f.SUB_MIX, f.SBOX, this._nRounds);
    }, c.prototype.encryptBlock = function (e) {
      var t = this.encryptBlockRaw(e),
          r = n.allocUnsafe(16);
      return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
    }, c.prototype.decryptBlock = function (e) {
      var t = (e = i(e))[1];
      e[1] = e[3], e[3] = t;
      var r = a(e, this._invKeySchedule, f.INV_SUB_MIX, f.INV_SBOX, this._nRounds),
          o = n.allocUnsafe(16);
      return o.writeUInt32BE(r[0], 0), o.writeUInt32BE(r[3], 4), o.writeUInt32BE(r[2], 8), o.writeUInt32BE(r[1], 12), o;
    }, c.prototype.scrub = function () {
      o(this._keySchedule), o(this._invKeySchedule), o(this._key);
    }, e.exports.AES = c;
  }, function (e, t, r) {
    var n = r(1).Buffer,
        i = r(27);

    e.exports = function (e, t, r, o) {
      if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");

      for (var a = r / 8, s = n.alloc(a), f = n.alloc(o || 0), c = n.alloc(0); a > 0 || o > 0;) {
        var u = new i();
        u.update(c), u.update(e), t && u.update(t), c = u.digest();
        var d = 0;

        if (a > 0) {
          var h = s.length - a;
          d = Math.min(a, c.length), c.copy(s, h, 0, d), a -= d;
        }

        if (d < c.length && o > 0) {
          var l = f.length - o,
              p = Math.min(o, c.length - d);
          c.copy(f, l, d, d + p), o -= p;
        }
      }

      return c.fill(0), {
        key: s,
        iv: f
      };
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(3),
        i = r(5),
        o = i.getNAF,
        a = i.getJSF,
        s = i.assert;

    function f(e, t) {
      this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
      var r = this.n && this.p.div(this.n);
      !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
    }

    function c(e, t) {
      this.curve = e, this.type = t, this.precomputed = null;
    }

    e.exports = f, f.prototype.point = function () {
      throw new Error("Not implemented");
    }, f.prototype.validate = function () {
      throw new Error("Not implemented");
    }, f.prototype._fixedNafMul = function (e, t) {
      s(e.precomputed);

      var r = e._getDoubles(),
          n = o(t, 1, this._bitLength),
          i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);

      i /= 3;

      for (var a = [], f = 0; f < n.length; f += r.step) {
        var c = 0;

        for (t = f + r.step - 1; t >= f; t--) {
          c = (c << 1) + n[t];
        }

        a.push(c);
      }

      for (var u = this.jpoint(null, null, null), d = this.jpoint(null, null, null), h = i; h > 0; h--) {
        for (f = 0; f < a.length; f++) {
          (c = a[f]) === h ? d = d.mixedAdd(r.points[f]) : c === -h && (d = d.mixedAdd(r.points[f].neg()));
        }

        u = u.add(d);
      }

      return u.toP();
    }, f.prototype._wnafMul = function (e, t) {
      var r = 4,
          n = e._getNAFPoints(r);

      r = n.wnd;

      for (var i = n.points, a = o(t, r, this._bitLength), f = this.jpoint(null, null, null), c = a.length - 1; c >= 0; c--) {
        for (t = 0; c >= 0 && 0 === a[c]; c--) {
          t++;
        }

        if (c >= 0 && t++, f = f.dblp(t), c < 0) break;
        var u = a[c];
        s(0 !== u), f = "affine" === e.type ? u > 0 ? f.mixedAdd(i[u - 1 >> 1]) : f.mixedAdd(i[-u - 1 >> 1].neg()) : u > 0 ? f.add(i[u - 1 >> 1]) : f.add(i[-u - 1 >> 1].neg());
      }

      return "affine" === e.type ? f.toP() : f;
    }, f.prototype._wnafMulAdd = function (e, t, r, n, i) {
      for (var s = this._wnafT1, f = this._wnafT2, c = this._wnafT3, u = 0, d = 0; d < n; d++) {
        var h = (S = t[d])._getNAFPoints(e);

        s[d] = h.wnd, f[d] = h.points;
      }

      for (d = n - 1; d >= 1; d -= 2) {
        var l = d - 1,
            p = d;

        if (1 === s[l] && 1 === s[p]) {
          var b = [t[l], null, null, t[p]];
          0 === t[l].y.cmp(t[p].y) ? (b[1] = t[l].add(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg())) : 0 === t[l].y.cmp(t[p].y.redNeg()) ? (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].add(t[p].neg())) : (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg()));
          var m = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
              y = a(r[l], r[p]);
          u = Math.max(y[0].length, u), c[l] = new Array(u), c[p] = new Array(u);

          for (var v = 0; v < u; v++) {
            var g = 0 | y[0][v],
                _ = 0 | y[1][v];

            c[l][v] = m[3 * (g + 1) + (_ + 1)], c[p][v] = 0, f[l] = b;
          }
        } else c[l] = o(r[l], s[l], this._bitLength), c[p] = o(r[p], s[p], this._bitLength), u = Math.max(c[l].length, u), u = Math.max(c[p].length, u);
      }

      var w = this.jpoint(null, null, null),
          k = this._wnafT4;

      for (d = u; d >= 0; d--) {
        for (var E = 0; d >= 0;) {
          var A = !0;

          for (v = 0; v < n; v++) {
            k[v] = 0 | c[v][d], 0 !== k[v] && (A = !1);
          }

          if (!A) break;
          E++, d--;
        }

        if (d >= 0 && E++, w = w.dblp(E), d < 0) break;

        for (v = 0; v < n; v++) {
          var S,
              M = k[v];
          0 !== M && (M > 0 ? S = f[v][M - 1 >> 1] : M < 0 && (S = f[v][-M - 1 >> 1].neg()), w = "affine" === S.type ? w.mixedAdd(S) : w.add(S));
        }
      }

      for (d = 0; d < n; d++) {
        f[d] = null;
      }

      return i ? w : w.toP();
    }, f.BasePoint = c, c.prototype.eq = function () {
      throw new Error("Not implemented");
    }, c.prototype.validate = function () {
      return this.curve.validate(this);
    }, f.prototype.decodePoint = function (e, t) {
      e = i.toArray(e, t);
      var r = this.p.byteLength();
      if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? s(e[e.length - 1] % 2 == 0) : 7 === e[0] && s(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
      if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
      throw new Error("Unknown point format");
    }, c.prototype.encodeCompressed = function (e) {
      return this.encode(e, !0);
    }, c.prototype._encode = function (e) {
      var t = this.curve.p.byteLength(),
          r = this.getX().toArray("be", t);
      return e ? [this.getY().isEven() ? 2 : 3].concat(r) : [4].concat(r, this.getY().toArray("be", t));
    }, c.prototype.encode = function (e, t) {
      return i.encode(this._encode(t), e);
    }, c.prototype.precompute = function (e) {
      if (this.precomputed) return this;
      var t = {
        doubles: null,
        naf: null,
        beta: null
      };
      return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
    }, c.prototype._hasDoubles = function (e) {
      if (!this.precomputed) return !1;
      var t = this.precomputed.doubles;
      return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
    }, c.prototype._getDoubles = function (e, t) {
      if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

      for (var r = [this], n = this, i = 0; i < t; i += e) {
        for (var o = 0; o < e; o++) {
          n = n.dbl();
        }

        r.push(n);
      }

      return {
        step: e,
        points: r
      };
    }, c.prototype._getNAFPoints = function (e) {
      if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

      for (var t = [this], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++) {
        t[i] = t[i - 1].add(n);
      }

      return {
        wnd: e,
        points: t
      };
    }, c.prototype._getBeta = function () {
      return null;
    }, c.prototype.dblp = function (e) {
      for (var t = this, r = 0; r < e; r++) {
        t = t.dbl();
      }

      return t;
    };
  }, function (e, t, r) {
    var n = r(157),
        i = r(168),
        o = r(169),
        a = r(36),
        s = r(57),
        f = r(1).Buffer;

    function c(e) {
      var t;
      "object" != typeof e || f.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = f.from(e));
      var r,
          c,
          u = o(e, t),
          d = u.tag,
          h = u.data;

      switch (d) {
        case "CERTIFICATE":
          c = n.certificate.decode(h, "der").tbsCertificate.subjectPublicKeyInfo;

        case "PUBLIC KEY":
          switch (c || (c = n.PublicKey.decode(h, "der")), r = c.algorithm.algorithm.join(".")) {
            case "1.2.840.113549.1.1.1":
              return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");

            case "1.2.840.10045.2.1":
              return c.subjectPrivateKey = c.subjectPublicKey, {
                type: "ec",
                data: c
              };

            case "1.2.840.10040.4.1":
              return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                type: "dsa",
                data: c.algorithm.params
              };

            default:
              throw new Error("unknown key id " + r);
          }

          throw new Error("unknown key type " + d);

        case "ENCRYPTED PRIVATE KEY":
          h = function (e, t) {
            var r = e.algorithm.decrypt.kde.kdeparams.salt,
                n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10),
                o = i[e.algorithm.decrypt.cipher.algo.join(".")],
                c = e.algorithm.decrypt.cipher.iv,
                u = e.subjectPrivateKey,
                d = parseInt(o.split("-")[1], 10) / 8,
                h = s.pbkdf2Sync(t, r, n, d, "sha1"),
                l = a.createDecipheriv(o, h, c),
                p = [];
            return p.push(l.update(u)), p.push(l.final()), f.concat(p);
          }(h = n.EncryptedPrivateKey.decode(h, "der"), t);

        case "PRIVATE KEY":
          switch (r = (c = n.PrivateKey.decode(h, "der")).algorithm.algorithm.join(".")) {
            case "1.2.840.113549.1.1.1":
              return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");

            case "1.2.840.10045.2.1":
              return {
                curve: c.algorithm.curve,
                privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
              };

            case "1.2.840.10040.4.1":
              return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                type: "dsa",
                params: c.algorithm.params
              };

            default:
              throw new Error("unknown key id " + r);
          }

          throw new Error("unknown key type " + d);

        case "RSA PUBLIC KEY":
          return n.RSAPublicKey.decode(h, "der");

        case "RSA PRIVATE KEY":
          return n.RSAPrivateKey.decode(h, "der");

        case "DSA PRIVATE KEY":
          return {
            type: "dsa",
            params: n.DSAPrivateKey.decode(h, "der")
          };

        case "EC PRIVATE KEY":
          return {
            curve: (h = n.ECPrivateKey.decode(h, "der")).parameters.value,
            privateKey: h.privateKey
          };

        default:
          throw new Error("unknown key type " + d);
      }
    }

    e.exports = c, c.signature = n.signature;
  }, function (e, t, r) {
    (function (e) {
      var n = this,
          i = r(10).codec;
      t.tryParseJson = function (e) {
        try {
          return JSON.parse(e);
        } catch (t) {
          return e;
        }
      }, t.tryJsonStringify = function (e) {
        if ("string" == typeof e) return e;

        try {
          return JSON.stringify(e);
        } catch (t) {
          return String(e);
        }
      }, t.isRegularAccount = i.isRegularAddress, t.isBankAccount = i.isBankAddress, t.encodeTX = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "base64";
        return i.encode(e).toString(t);
      }, t.decodeTxContent = function (t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "base64";
        return i.decode(e.from(t, r));
      }, t.ensureBuffer = function (t, r) {
        return e.isBuffer(t) ? t : e.from(t, r);
      }, t.switchEncoding = function (e, r, n) {
        return t.ensureBuffer(e, r).toString(n);
      }, t.decodeTxEvents = function (e) {
        var t = o(e, "events") || e;
        return t.length ? t.map(function (e) {
          return {
            type: e.type,
            attributes: e.attributes.reduce(function (e, t) {
              var r = t.key,
                  i = t.value;
              return r = n.switchEncoding(r, "base64", "utf8"), i = n.switchEncoding(i, "base64", "utf8"), e[r] = n.tryParseJson(i), e;
            }, {})
          };
        }).map(function (e) {
          var t = e.type,
              r = e.attributes,
              n = r._ev;
          return n && delete r._ev, {
            emitter: t,
            eventName: n,
            eventData: r
          };
        }) : [];
      }, t.decodeTxResult = function (e) {
        var t = Object.assign({}, e);
        return t.returnValue = n.decodeTxReturnValue(t), t.tx && (t.tx = n.decodeTxContent(t.tx)), t.events = n.decodeTxEvents(t), t;
      }, t.decodeTxReturnValue = function (t) {
        var r = o(t, "data");
        return r && (r = i.decode(e.from(r, "base64"))), r;
      }, t.removeItem = function (e, t) {
        var r = e.indexOf(t);
        return r >= 0 ? e.splice(r, 1) : e;
      }, t.escapeQueryValue = function (e) {
        return "number" == typeof e ? e : "'" + String(e).replace(/'/g, "\\'") + "'";
      };

      var o = function o(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ["tx_result", "deliver_tx"],
            n = r.find(function (t) {
          return t in e;
        });
        return n ? e[n][t] : void 0;
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        i = r(47),
        o = r(1).Buffer,
        a = new Array(16);

    function s() {
      i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
    }

    function f(e, t) {
      return e << t | e >>> 32 - t;
    }

    function c(e, t, r, n, i, o, a) {
      return f(e + (t & r | ~t & n) + i + o | 0, a) + t | 0;
    }

    function u(e, t, r, n, i, o, a) {
      return f(e + (t & n | r & ~n) + i + o | 0, a) + t | 0;
    }

    function d(e, t, r, n, i, o, a) {
      return f(e + (t ^ r ^ n) + i + o | 0, a) + t | 0;
    }

    function h(e, t, r, n, i, o, a) {
      return f(e + (r ^ (t | ~n)) + i + o | 0, a) + t | 0;
    }

    n(s, i), s.prototype._update = function () {
      for (var e = a, t = 0; t < 16; ++t) {
        e[t] = this._block.readInt32LE(4 * t);
      }

      var r = this._a,
          n = this._b,
          i = this._c,
          o = this._d;
      r = c(r, n, i, o, e[0], 3614090360, 7), o = c(o, r, n, i, e[1], 3905402710, 12), i = c(i, o, r, n, e[2], 606105819, 17), n = c(n, i, o, r, e[3], 3250441966, 22), r = c(r, n, i, o, e[4], 4118548399, 7), o = c(o, r, n, i, e[5], 1200080426, 12), i = c(i, o, r, n, e[6], 2821735955, 17), n = c(n, i, o, r, e[7], 4249261313, 22), r = c(r, n, i, o, e[8], 1770035416, 7), o = c(o, r, n, i, e[9], 2336552879, 12), i = c(i, o, r, n, e[10], 4294925233, 17), n = c(n, i, o, r, e[11], 2304563134, 22), r = c(r, n, i, o, e[12], 1804603682, 7), o = c(o, r, n, i, e[13], 4254626195, 12), i = c(i, o, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, o, r, e[15], 1236535329, 22), i, o, e[1], 4129170786, 5), o = u(o, r, n, i, e[6], 3225465664, 9), i = u(i, o, r, n, e[11], 643717713, 14), n = u(n, i, o, r, e[0], 3921069994, 20), r = u(r, n, i, o, e[5], 3593408605, 5), o = u(o, r, n, i, e[10], 38016083, 9), i = u(i, o, r, n, e[15], 3634488961, 14), n = u(n, i, o, r, e[4], 3889429448, 20), r = u(r, n, i, o, e[9], 568446438, 5), o = u(o, r, n, i, e[14], 3275163606, 9), i = u(i, o, r, n, e[3], 4107603335, 14), n = u(n, i, o, r, e[8], 1163531501, 20), r = u(r, n, i, o, e[13], 2850285829, 5), o = u(o, r, n, i, e[2], 4243563512, 9), i = u(i, o, r, n, e[7], 1735328473, 14), r = d(r, n = u(n, i, o, r, e[12], 2368359562, 20), i, o, e[5], 4294588738, 4), o = d(o, r, n, i, e[8], 2272392833, 11), i = d(i, o, r, n, e[11], 1839030562, 16), n = d(n, i, o, r, e[14], 4259657740, 23), r = d(r, n, i, o, e[1], 2763975236, 4), o = d(o, r, n, i, e[4], 1272893353, 11), i = d(i, o, r, n, e[7], 4139469664, 16), n = d(n, i, o, r, e[10], 3200236656, 23), r = d(r, n, i, o, e[13], 681279174, 4), o = d(o, r, n, i, e[0], 3936430074, 11), i = d(i, o, r, n, e[3], 3572445317, 16), n = d(n, i, o, r, e[6], 76029189, 23), r = d(r, n, i, o, e[9], 3654602809, 4), o = d(o, r, n, i, e[12], 3873151461, 11), i = d(i, o, r, n, e[15], 530742520, 16), r = h(r, n = d(n, i, o, r, e[2], 3299628645, 23), i, o, e[0], 4096336452, 6), o = h(o, r, n, i, e[7], 1126891415, 10), i = h(i, o, r, n, e[14], 2878612391, 15), n = h(n, i, o, r, e[5], 4237533241, 21), r = h(r, n, i, o, e[12], 1700485571, 6), o = h(o, r, n, i, e[3], 2399980690, 10), i = h(i, o, r, n, e[10], 4293915773, 15), n = h(n, i, o, r, e[1], 2240044497, 21), r = h(r, n, i, o, e[8], 1873313359, 6), o = h(o, r, n, i, e[15], 4264355552, 10), i = h(i, o, r, n, e[6], 2734768916, 15), n = h(n, i, o, r, e[13], 1309151649, 21), r = h(r, n, i, o, e[4], 4149444226, 6), o = h(o, r, n, i, e[11], 3174756917, 10), i = h(i, o, r, n, e[2], 718787259, 15), n = h(n, i, o, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
    }, s.prototype._digest = function () {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var e = o.allocUnsafe(16);
      return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
    }, e.exports = s;
  }, function (e, t, r) {
    e.exports = i;
    var n = r(29).EventEmitter;

    function i() {
      n.call(this);
    }

    r(0)(i, n), i.Readable = r(30), i.Writable = r(106), i.Duplex = r(107), i.Transform = r(108), i.PassThrough = r(109), i.Stream = i, i.prototype.pipe = function (e, t) {
      var r = this;

      function i(t) {
        e.writable && !1 === e.write(t) && r.pause && r.pause();
      }

      function o() {
        r.readable && r.resume && r.resume();
      }

      r.on("data", i), e.on("drain", o), e._isStdio || t && !1 === t.end || (r.on("end", s), r.on("close", f));
      var a = !1;

      function s() {
        a || (a = !0, e.end());
      }

      function f() {
        a || (a = !0, "function" == typeof e.destroy && e.destroy());
      }

      function c(e) {
        if (u(), 0 === n.listenerCount(this, "error")) throw e;
      }

      function u() {
        r.removeListener("data", i), e.removeListener("drain", o), r.removeListener("end", s), r.removeListener("close", f), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
      }

      return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
    };
  }, function (e, t, r) {
    "use strict";

    var n,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (e, t, r) {
      return Function.prototype.apply.call(e, t, r);
    };
    n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (e) {
      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
    } : function (e) {
      return Object.getOwnPropertyNames(e);
    };

    var a = Number.isNaN || function (e) {
      return e != e;
    };

    function s() {
      s.init.call(this);
    }

    e.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var f = 10;

    function c(e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
    }

    function u(e) {
      return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners;
    }

    function d(e, t, r, n) {
      var i, o, a, s;
      if (c(r), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]), void 0 === a) a = o[t] = r, ++e._eventsCount;else if ("function" == typeof a ? a = o[t] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), (i = u(e)) > 0 && a.length > i && !a.warned) {
        a.warned = !0;
        var f = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        f.name = "MaxListenersExceededWarning", f.emitter = e, f.type = t, f.count = a.length, s = f, console && console.warn && console.warn(s);
      }
      return e;
    }

    function h() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }

    function l(e, t, r) {
      var n = {
        fired: !1,
        wrapFn: void 0,
        target: e,
        type: t,
        listener: r
      },
          i = h.bind(n);
      return i.listener = r, n.wrapFn = i, i;
    }

    function p(e, t, r) {
      var n = e._events;
      if (void 0 === n) return [];
      var i = n[t];
      return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (e) {
        for (var t = new Array(e.length), r = 0; r < t.length; ++r) {
          t[r] = e[r].listener || e[r];
        }

        return t;
      }(i) : m(i, i.length);
    }

    function b(e) {
      var t = this._events;

      if (void 0 !== t) {
        var r = t[e];
        if ("function" == typeof r) return 1;
        if (void 0 !== r) return r.length;
      }

      return 0;
    }

    function m(e, t) {
      for (var r = new Array(t), n = 0; n < t; ++n) {
        r[n] = e[n];
      }

      return r;
    }

    Object.defineProperty(s, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return f;
      },
      set: function set(e) {
        if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
        f = e;
      }
    }), s.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, s.prototype.setMaxListeners = function (e) {
      if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
      return this._maxListeners = e, this;
    }, s.prototype.getMaxListeners = function () {
      return u(this);
    }, s.prototype.emit = function (e) {
      for (var t = [], r = 1; r < arguments.length; r++) {
        t.push(arguments[r]);
      }

      var n = "error" === e,
          i = this._events;
      if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

      if (n) {
        var a;
        if (t.length > 0 && (a = t[0]), a instanceof Error) throw a;
        var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw s.context = a, s;
      }

      var f = i[e];
      if (void 0 === f) return !1;
      if ("function" == typeof f) o(f, this, t);else {
        var c = f.length,
            u = m(f, c);

        for (r = 0; r < c; ++r) {
          o(u[r], this, t);
        }
      }
      return !0;
    }, s.prototype.addListener = function (e, t) {
      return d(this, e, t, !1);
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (e, t) {
      return d(this, e, t, !0);
    }, s.prototype.once = function (e, t) {
      return c(t), this.on(e, l(this, e, t)), this;
    }, s.prototype.prependOnceListener = function (e, t) {
      return c(t), this.prependListener(e, l(this, e, t)), this;
    }, s.prototype.removeListener = function (e, t) {
      var r, n, i, o, a;
      if (c(t), void 0 === (n = this._events)) return this;
      if (void 0 === (r = n[e])) return this;
      if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));else if ("function" != typeof r) {
        for (i = -1, o = r.length - 1; o >= 0; o--) {
          if (r[o] === t || r[o].listener === t) {
            a = r[o].listener, i = o;
            break;
          }
        }

        if (i < 0) return this;
        0 === i ? r.shift() : function (e, t) {
          for (; t + 1 < e.length; t++) {
            e[t] = e[t + 1];
          }

          e.pop();
        }(r, i), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, a || t);
      }
      return this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (e) {
      var t, r, n;
      if (void 0 === (r = this._events)) return this;
      if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;

      if (0 === arguments.length) {
        var i,
            o = Object.keys(r);

        for (n = 0; n < o.length; ++n) {
          "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (t = r[e])) this.removeListener(e, t);else if (void 0 !== t) for (n = t.length - 1; n >= 0; n--) {
        this.removeListener(e, t[n]);
      }
      return this;
    }, s.prototype.listeners = function (e) {
      return p(this, e, !0);
    }, s.prototype.rawListeners = function (e) {
      return p(this, e, !1);
    }, s.listenerCount = function (e, t) {
      return "function" == typeof e.listenerCount ? e.listenerCount(t) : b.call(e, t);
    }, s.prototype.listenerCount = b, s.prototype.eventNames = function () {
      return this._eventsCount > 0 ? n(this._events) : [];
    };
  }, function (e, t, r) {
    (t = e.exports = r(48)).Stream = t, t.Readable = t, t.Writable = r(31), t.Duplex = r(11), t.Transform = r(51), t.PassThrough = r(105);
  }, function (e, t, r) {
    "use strict";

    (function (t, n, i) {
      var o = r(21);

      function a(e) {
        var t = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (e, t, r) {
            var n = e.entry;
            e.entry = null;

            for (; n;) {
              var i = n.callback;
              t.pendingcb--, i(r), n = n.next;
            }

            t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
          }(t, e);
        };
      }

      e.exports = v;
      var s,
          f = !t.browser && ["v0.10", "v0.9."].indexOf(t.version.slice(0, 5)) > -1 ? n : o.nextTick;
      v.WritableState = y;
      var c = Object.create(r(15));
      c.inherits = r(0);

      var u = {
        deprecate: r(104)
      },
          d = r(49),
          h = r(1).Buffer,
          l = i.Uint8Array || function () {};

      var p,
          b = r(50);

      function m() {}

      function y(e, t) {
        s = s || r(11), e = e || {};
        var n = t instanceof s;
        this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.writableObjectMode);
        var i = e.highWaterMark,
            c = e.writableHighWaterMark,
            u = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var d = !1 === e.decodeStrings;
        this.decodeStrings = !d, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
          !function (e, t) {
            var r = e._writableState,
                n = r.sync,
                i = r.writecb;
            if (function (e) {
              e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
            }(r), t) !function (e, t, r, n, i) {
              --t.pendingcb, r ? (o.nextTick(i, n), o.nextTick(A, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), A(e, t));
            }(e, r, n, t, i);else {
              var a = k(r);
              a || r.corked || r.bufferProcessing || !r.bufferedRequest || w(e, r), n ? f(_, e, r, a, i) : _(e, r, a, i);
            }
          }(t, e);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
      }

      function v(e) {
        if (s = s || r(11), !(p.call(v, this) || this instanceof s)) return new v(e);
        this._writableState = new y(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), d.call(this);
      }

      function g(e, t, r, n, i, o, a) {
        t.writelen = n, t.writecb = a, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, o, t.onwrite), t.sync = !1;
      }

      function _(e, t, r, n) {
        r || function (e, t) {
          0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
        }(e, t), t.pendingcb--, n(), A(e, t);
      }

      function w(e, t) {
        t.bufferProcessing = !0;
        var r = t.bufferedRequest;

        if (e._writev && r && r.next) {
          var n = t.bufferedRequestCount,
              i = new Array(n),
              o = t.corkedRequestsFree;
          o.entry = r;

          for (var s = 0, f = !0; r;) {
            i[s] = r, r.isBuf || (f = !1), r = r.next, s += 1;
          }

          i.allBuffers = f, g(e, t, !0, t.length, i, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new a(t), t.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var c = r.chunk,
                u = r.encoding,
                d = r.callback;
            if (g(e, t, !1, t.objectMode ? 1 : c.length, c, u, d), r = r.next, t.bufferedRequestCount--, t.writing) break;
          }

          null === r && (t.lastBufferedRequest = null);
        }

        t.bufferedRequest = r, t.bufferProcessing = !1;
      }

      function k(e) {
        return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
      }

      function E(e, t) {
        e._final(function (r) {
          t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), A(e, t);
        });
      }

      function A(e, t) {
        var r = k(t);
        return r && (!function (e, t) {
          t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, o.nextTick(E, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
        }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
      }

      c.inherits(v, d), y.prototype.getBuffer = function () {
        for (var e = this.bufferedRequest, t = []; e;) {
          t.push(e), e = e.next;
        }

        return t;
      }, function () {
        try {
          Object.defineProperty(y.prototype, "buffer", {
            get: u.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (e) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
        value: function value(e) {
          return !!p.call(this, e) || this === v && e && e._writableState instanceof y;
        }
      })) : p = function p(e) {
        return e instanceof this;
      }, v.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, v.prototype.write = function (e, t, r) {
        var n,
            i = this._writableState,
            a = !1,
            s = !i.objectMode && (n = e, h.isBuffer(n) || n instanceof l);
        return s && !h.isBuffer(e) && (e = function (e) {
          return h.from(e);
        }(e)), "function" == typeof t && (r = t, t = null), s ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = m), i.ended ? function (e, t) {
          var r = new Error("write after end");
          e.emit("error", r), o.nextTick(t, r);
        }(this, r) : (s || function (e, t, r, n) {
          var i = !0,
              a = !1;
          return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (e.emit("error", a), o.nextTick(n, a), i = !1), i;
        }(this, i, e, r)) && (i.pendingcb++, a = function (e, t, r, n, i, o) {
          if (!r) {
            var a = function (e, t, r) {
              e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = h.from(t, r));
              return t;
            }(t, n, i);

            n !== a && (r = !0, i = "buffer", n = a);
          }

          var s = t.objectMode ? 1 : n.length;
          t.length += s;
          var f = t.length < t.highWaterMark;
          f || (t.needDrain = !0);

          if (t.writing || t.corked) {
            var c = t.lastBufferedRequest;
            t.lastBufferedRequest = {
              chunk: n,
              encoding: i,
              isBuf: r,
              callback: o,
              next: null
            }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
          } else g(e, t, !1, s, n, i, o);

          return f;
        }(this, i, s, e, t, r)), a;
      }, v.prototype.cork = function () {
        this._writableState.corked++;
      }, v.prototype.uncork = function () {
        var e = this._writableState;
        e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || w(this, e));
      }, v.prototype.setDefaultEncoding = function (e) {
        if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
        return this._writableState.defaultEncoding = e, this;
      }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), v.prototype._write = function (e, t, r) {
        r(new Error("_write() is not implemented"));
      }, v.prototype._writev = null, v.prototype.end = function (e, t, r) {
        var n = this._writableState;
        "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (e, t, r) {
          t.ending = !0, A(e, t), r && (t.finished ? o.nextTick(r) : e.once("finish", r));
          t.ended = !0, e.writable = !1;
        }(this, n, r);
      }, Object.defineProperty(v.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(e) {
          this._writableState && (this._writableState.destroyed = e);
        }
      }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function (e, t) {
        this.end(), t(e);
      };
    }).call(this, r(7), r(102).setImmediate, r(6));
  }, function (e, t, r) {
    "use strict";

    var n = r(1).Buffer,
        i = n.isEncoding || function (e) {
      switch ((e = "" + e) && e.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    function o(e) {
      var t;

      switch (this.encoding = function (e) {
        var t = function (e) {
          if (!e) return "utf8";

          for (var t;;) {
            switch (e) {
              case "utf8":
              case "utf-8":
                return "utf8";

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";

              case "latin1":
              case "binary":
                return "latin1";

              case "base64":
              case "ascii":
              case "hex":
                return e;

              default:
                if (t) return;
                e = ("" + e).toLowerCase(), t = !0;
            }
          }
        }(e);

        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
        return t || e;
      }(e), this.encoding) {
        case "utf16le":
          this.text = f, this.end = c, t = 4;
          break;

        case "utf8":
          this.fillLast = s, t = 4;
          break;

        case "base64":
          this.text = u, this.end = d, t = 3;
          break;

        default:
          return this.write = h, void (this.end = l);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
    }

    function a(e) {
      return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
    }

    function s(e) {
      var t = this.lastTotal - this.lastNeed,
          r = function (e, t, r) {
        if (128 != (192 & t[0])) return e.lastNeed = 0, "�";

        if (e.lastNeed > 1 && t.length > 1) {
          if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
          if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
        }
      }(this, e);

      return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
    }

    function f(e, t) {
      if ((e.length - t) % 2 == 0) {
        var r = e.toString("utf16le", t);

        if (r) {
          var n = r.charCodeAt(r.length - 1);
          if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
        }

        return r;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
    }

    function c(e) {
      var t = e && e.length ? this.write(e) : "";

      if (this.lastNeed) {
        var r = this.lastTotal - this.lastNeed;
        return t + this.lastChar.toString("utf16le", 0, r);
      }

      return t;
    }

    function u(e, t) {
      var r = (e.length - t) % 3;
      return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
    }

    function d(e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
    }

    function h(e) {
      return e.toString(this.encoding);
    }

    function l(e) {
      return e && e.length ? this.write(e) : "";
    }

    t.StringDecoder = o, o.prototype.write = function (e) {
      if (0 === e.length) return "";
      var t, r;

      if (this.lastNeed) {
        if (void 0 === (t = this.fillLast(e))) return "";
        r = this.lastNeed, this.lastNeed = 0;
      } else r = 0;

      return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
    }, o.prototype.end = function (e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + "�" : t;
    }, o.prototype.text = function (e, t) {
      var r = function (e, t, r) {
        var n = t.length - 1;
        if (n < r) return 0;
        var i = a(t[n]);
        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
        if (--n < r || -2 === i) return 0;
        if ((i = a(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
        if (--n < r || -2 === i) return 0;
        if ((i = a(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
        return 0;
      }(this, e, t);

      if (!this.lastNeed) return e.toString("utf8", t);
      this.lastTotal = r;
      var n = e.length - (r - this.lastNeed);
      return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
    }, o.prototype.fillLast = function (e) {
      if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(2).Buffer,
        i = r(0),
        o = r(47),
        a = new Array(16),
        s = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        f = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        c = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        u = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
        d = [0, 1518500249, 1859775393, 2400959708, 2840853838],
        h = [1352829926, 1548603684, 1836072691, 2053994217, 0];

    function l() {
      o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
    }

    function p(e, t) {
      return e << t | e >>> 32 - t;
    }

    function b(e, t, r, n, i, o, a, s) {
      return p(e + (t ^ r ^ n) + o + a | 0, s) + i | 0;
    }

    function m(e, t, r, n, i, o, a, s) {
      return p(e + (t & r | ~t & n) + o + a | 0, s) + i | 0;
    }

    function y(e, t, r, n, i, o, a, s) {
      return p(e + ((t | ~r) ^ n) + o + a | 0, s) + i | 0;
    }

    function v(e, t, r, n, i, o, a, s) {
      return p(e + (t & n | r & ~n) + o + a | 0, s) + i | 0;
    }

    function g(e, t, r, n, i, o, a, s) {
      return p(e + (t ^ (r | ~n)) + o + a | 0, s) + i | 0;
    }

    i(l, o), l.prototype._update = function () {
      for (var e = a, t = 0; t < 16; ++t) {
        e[t] = this._block.readInt32LE(4 * t);
      }

      for (var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, o = 0 | this._d, l = 0 | this._e, _ = 0 | this._a, w = 0 | this._b, k = 0 | this._c, E = 0 | this._d, A = 0 | this._e, S = 0; S < 80; S += 1) {
        var M, x;
        S < 16 ? (M = b(r, n, i, o, l, e[s[S]], d[0], c[S]), x = g(_, w, k, E, A, e[f[S]], h[0], u[S])) : S < 32 ? (M = m(r, n, i, o, l, e[s[S]], d[1], c[S]), x = v(_, w, k, E, A, e[f[S]], h[1], u[S])) : S < 48 ? (M = y(r, n, i, o, l, e[s[S]], d[2], c[S]), x = y(_, w, k, E, A, e[f[S]], h[2], u[S])) : S < 64 ? (M = v(r, n, i, o, l, e[s[S]], d[3], c[S]), x = m(_, w, k, E, A, e[f[S]], h[3], u[S])) : (M = g(r, n, i, o, l, e[s[S]], d[4], c[S]), x = b(_, w, k, E, A, e[f[S]], h[4], u[S])), r = l, l = o, o = p(i, 10), i = n, n = M, _ = A, A = E, E = p(k, 10), k = w, w = x;
      }

      var I = this._b + i + E | 0;
      this._b = this._c + o + A | 0, this._c = this._d + l + _ | 0, this._d = this._e + r + w | 0, this._e = this._a + n + k | 0, this._a = I;
    }, l.prototype._digest = function () {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var e = n.alloc ? n.alloc(20) : new n(20);
      return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
    }, e.exports = l;
  }, function (e, t, r) {
    (t = e.exports = function (e) {
      e = e.toLowerCase();
      var r = t[e];
      if (!r) throw new Error(e + " is not supported (we accept pull requests)");
      return new r();
    }).sha = r(110), t.sha1 = r(111), t.sha224 = r(112), t.sha256 = r(52), t.sha384 = r(113), t.sha512 = r(53);
  }, function (e, t, r) {
    "use strict";

    var n = r(4);

    function i(e) {
      this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0;
    }

    e.exports = i, i.prototype._init = function () {}, i.prototype.update = function (e) {
      return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
    }, i.prototype._buffer = function (e, t) {
      for (var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++) {
        this.buffer[this.bufferOff + n] = e[t + n];
      }

      return this.bufferOff += r, r;
    }, i.prototype._flushBuffer = function (e, t) {
      return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
    }, i.prototype._updateEncrypt = function (e) {
      var t = 0,
          r = 0,
          n = (this.bufferOff + e.length) / this.blockSize | 0,
          i = new Array(n * this.blockSize);
      0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));

      for (var o = e.length - (e.length - t) % this.blockSize; t < o; t += this.blockSize) {
        this._update(e, t, i, r), r += this.blockSize;
      }

      for (; t < e.length; t++, this.bufferOff++) {
        this.buffer[this.bufferOff] = e[t];
      }

      return i;
    }, i.prototype._updateDecrypt = function (e) {
      for (var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--) {
        t += this._buffer(e, t), r += this._flushBuffer(i, r);
      }

      return t += this._buffer(e, t), i;
    }, i.prototype.final = function (e) {
      var t, r;
      return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
    }, i.prototype._pad = function (e, t) {
      if (0 === t) return !1;

      for (; t < e.length;) {
        e[t++] = 0;
      }

      return !0;
    }, i.prototype._finalEncrypt = function () {
      if (!this._pad(this.buffer, this.bufferOff)) return [];
      var e = new Array(this.blockSize);
      return this._update(this.buffer, 0, e, 0), e;
    }, i.prototype._unpad = function (e) {
      return e;
    }, i.prototype._finalDecrypt = function () {
      n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
      var e = new Array(this.blockSize);
      return this._flushBuffer(e, 0), this._unpad(e);
    };
  }, function (e, t, r) {
    var n = r(122),
        i = r(130),
        o = r(65);
    t.createCipher = t.Cipher = n.createCipher, t.createCipheriv = t.Cipheriv = n.createCipheriv, t.createDecipher = t.Decipher = i.createDecipher, t.createDecipheriv = t.Decipheriv = i.createDecipheriv, t.listCiphers = t.getCiphers = function () {
      return Object.keys(o);
    };
  }, function (e, t, r) {
    var n = {
      ECB: r(123),
      CBC: r(124),
      CFB: r(125),
      CFB8: r(126),
      CFB1: r(127),
      OFB: r(128),
      CTR: r(63),
      GCM: r(63)
    },
        i = r(65);

    for (var o in i) {
      i[o].module = n[i[o].mode];
    }

    e.exports = i;
  }, function (e, t, r) {
    var n;

    function i(e) {
      this.rand = e;
    }

    if (e.exports = function (e) {
      return n || (n = new i(null)), n.generate(e);
    }, e.exports.Rand = i, i.prototype.generate = function (e) {
      return this._rand(e);
    }, i.prototype._rand = function (e) {
      if (this.rand.getBytes) return this.rand.getBytes(e);

      for (var t = new Uint8Array(e), r = 0; r < t.length; r++) {
        t[r] = this.rand.getByte();
      }

      return t;
    }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (e) {
      var t = new Uint8Array(e);
      return self.crypto.getRandomValues(t), t;
    } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (e) {
      var t = new Uint8Array(e);
      return self.msCrypto.getRandomValues(t), t;
    } : "object" == typeof window && (i.prototype._rand = function () {
      throw new Error("Not implemented yet");
    });else try {
      var o = r(134);
      if ("function" != typeof o.randomBytes) throw new Error("Not supported");

      i.prototype._rand = function (e) {
        return o.randomBytes(e);
      };
    } catch (e) {}
  }, function (e, t, r) {
    (function (t) {
      var n = r(3),
          i = r(12);

      function o(e, r) {
        var i = function (e) {
          var t = a(e);
          return {
            blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
            unblinder: t.invm(e.modulus)
          };
        }(r),
            o = r.modulus.byteLength(),
            s = (n.mont(r.modulus), new n(e).mul(i.blinder).umod(r.modulus)),
            f = s.toRed(n.mont(r.prime1)),
            c = s.toRed(n.mont(r.prime2)),
            u = r.coefficient,
            d = r.prime1,
            h = r.prime2,
            l = f.redPow(r.exponent1),
            p = c.redPow(r.exponent2);

        l = l.fromRed(), p = p.fromRed();
        var b = l.isub(p).imul(u).umod(d);
        return b.imul(h), p.iadd(b), new t(p.imul(i.unblinder).umod(r.modulus).toArray(!1, o));
      }

      function a(e) {
        for (var t = e.modulus.byteLength(), r = new n(i(t)); r.cmp(e.modulus) >= 0 || !r.umod(e.prime1) || !r.umod(e.prime2);) {
          r = new n(i(t));
        }

        return r;
      }

      e.exports = o, o.getr = a;
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = t;
    n.version = r(139).version, n.utils = r(5), n.rand = r(38), n.curve = r(72), n.curves = r(41), n.ec = r(150), n.eddsa = r(154);
  }, function (e, t, r) {
    "use strict";

    var n,
        i = t,
        o = r(42),
        a = r(72),
        s = r(5).assert;

    function f(e) {
      "short" === e.type ? this.curve = new a.short(e) : "edwards" === e.type ? this.curve = new a.edwards(e) : this.curve = new a.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, s(this.g.validate(), "Invalid curve"), s(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }

    function c(e, t) {
      Object.defineProperty(i, e, {
        configurable: !0,
        enumerable: !0,
        get: function get() {
          var r = new f(t);
          return Object.defineProperty(i, e, {
            configurable: !0,
            enumerable: !0,
            value: r
          }), r;
        }
      });
    }

    i.PresetCurve = f, c("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: o.sha256,
      gRed: !1,
      g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
    }), c("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: o.sha256,
      gRed: !1,
      g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
    }), c("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: o.sha256,
      gRed: !1,
      g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
    }), c("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: o.sha384,
      gRed: !1,
      g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
    }), c("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: o.sha512,
      gRed: !1,
      g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
    }), c("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: ["9"]
    }), c("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
    });

    try {
      n = r(149);
    } catch (e) {
      n = void 0;
    }

    c("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: o.sha256,
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [{
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      }, {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }],
      gRed: !1,
      g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", n]
    });
  }, function (e, t, r) {
    var n = t;
    n.utils = r(8), n.common = r(17), n.sha = r(143), n.ripemd = r(147), n.hmac = r(148), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
  }, function (e, t) {}, function (e, t, r) {
    (function (e) {
      function r(e, t) {
        for (var r = 0, n = e.length - 1; n >= 0; n--) {
          var i = e[n];
          "." === i ? e.splice(n, 1) : ".." === i ? (e.splice(n, 1), r++) : r && (e.splice(n, 1), r--);
        }

        if (t) for (; r--; r) {
          e.unshift("..");
        }
        return e;
      }

      function n(e, t) {
        if (e.filter) return e.filter(t);

        for (var r = [], n = 0; n < e.length; n++) {
          t(e[n], n, e) && r.push(e[n]);
        }

        return r;
      }

      t.resolve = function () {
        for (var t = "", i = !1, o = arguments.length - 1; o >= -1 && !i; o--) {
          var a = o >= 0 ? arguments[o] : e.cwd();
          if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
          a && (t = a + "/" + t, i = "/" === a.charAt(0));
        }

        return (i ? "/" : "") + (t = r(n(t.split("/"), function (e) {
          return !!e;
        }), !i).join("/")) || ".";
      }, t.normalize = function (e) {
        var o = t.isAbsolute(e),
            a = "/" === i(e, -1);
        return (e = r(n(e.split("/"), function (e) {
          return !!e;
        }), !o).join("/")) || o || (e = "."), e && a && (e += "/"), (o ? "/" : "") + e;
      }, t.isAbsolute = function (e) {
        return "/" === e.charAt(0);
      }, t.join = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return t.normalize(n(e, function (e, t) {
          if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
          return e;
        }).join("/"));
      }, t.relative = function (e, r) {
        function n(e) {
          for (var t = 0; t < e.length && "" === e[t]; t++) {
            ;
          }

          for (var r = e.length - 1; r >= 0 && "" === e[r]; r--) {
            ;
          }

          return t > r ? [] : e.slice(t, r - t + 1);
        }

        e = t.resolve(e).substr(1), r = t.resolve(r).substr(1);

        for (var i = n(e.split("/")), o = n(r.split("/")), a = Math.min(i.length, o.length), s = a, f = 0; f < a; f++) {
          if (i[f] !== o[f]) {
            s = f;
            break;
          }
        }

        var c = [];

        for (f = s; f < i.length; f++) {
          c.push("..");
        }

        return (c = c.concat(o.slice(s))).join("/");
      }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
        if ("string" != typeof e && (e += ""), 0 === e.length) return ".";

        for (var t = e.charCodeAt(0), r = 47 === t, n = -1, i = !0, o = e.length - 1; o >= 1; --o) {
          if (47 === (t = e.charCodeAt(o))) {
            if (!i) {
              n = o;
              break;
            }
          } else i = !1;
        }

        return -1 === n ? r ? "/" : "." : r && 1 === n ? "/" : e.slice(0, n);
      }, t.basename = function (e, t) {
        var r = function (e) {
          "string" != typeof e && (e += "");
          var t,
              r = 0,
              n = -1,
              i = !0;

          for (t = e.length - 1; t >= 0; --t) {
            if (47 === e.charCodeAt(t)) {
              if (!i) {
                r = t + 1;
                break;
              }
            } else -1 === n && (i = !1, n = t + 1);
          }

          return -1 === n ? "" : e.slice(r, n);
        }(e);

        return t && r.substr(-1 * t.length) === t && (r = r.substr(0, r.length - t.length)), r;
      }, t.extname = function (e) {
        "string" != typeof e && (e += "");

        for (var t = -1, r = 0, n = -1, i = !0, o = 0, a = e.length - 1; a >= 0; --a) {
          var s = e.charCodeAt(a);
          if (47 !== s) -1 === n && (i = !1, n = a + 1), 46 === s ? -1 === t ? t = a : 1 !== o && (o = 1) : -1 !== t && (o = -1);else if (!i) {
            r = a + 1;
            break;
          }
        }

        return -1 === t || -1 === n || 0 === o || 1 === o && t === n - 1 && t === r + 1 ? "" : e.slice(t, n);
      };
      var i = "b" === "ab".substr(-1) ? function (e, t, r) {
        return e.substr(t, r);
      } : function (e, t, r) {
        return t < 0 && (t = e.length + t), e.substr(t, r);
      };
    }).call(this, r(7));
  }, function (e, t, r) {
    "use strict";

    e.exports = function () {
      if ("function" != typeof Promise) throw new TypeError("`Promise.prototype.finally` requires a global `Promise` be available.");
    };
  }, function (e, t) {
    var r = {}.toString;

    e.exports = Array.isArray || function (e) {
      return "[object Array]" == r.call(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(28).Transform;

    function o(e) {
      i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
    }

    r(0)(o, i), o.prototype._transform = function (e, t, r) {
      var n = null;

      try {
        this.update(e, t);
      } catch (e) {
        n = e;
      }

      r(n);
    }, o.prototype._flush = function (e) {
      var t = null;

      try {
        this.push(this.digest());
      } catch (e) {
        t = e;
      }

      e(t);
    }, o.prototype.update = function (e, t) {
      if (function (e, t) {
        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
      }(e, "Data"), this._finalized) throw new Error("Digest already called");
      n.isBuffer(e) || (e = n.from(e, t));

      for (var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;) {
        for (var o = this._blockOffset; o < this._blockSize;) {
          r[o++] = e[i++];
        }

        this._update(), this._blockOffset = 0;
      }

      for (; i < e.length;) {
        r[this._blockOffset++] = e[i++];
      }

      for (var a = 0, s = 8 * e.length; s > 0; ++a) {
        this._length[a] += s, (s = this._length[a] / 4294967296 | 0) > 0 && (this._length[a] -= 4294967296 * s);
      }

      return this;
    }, o.prototype._update = function () {
      throw new Error("_update is not implemented");
    }, o.prototype.digest = function (e) {
      if (this._finalized) throw new Error("Digest already called");
      this._finalized = !0;

      var t = this._digest();

      void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;

      for (var r = 0; r < 4; ++r) {
        this._length[r] = 0;
      }

      return t;
    }, o.prototype._digest = function () {
      throw new Error("_digest is not implemented");
    }, e.exports = o;
  }, function (e, t, r) {
    "use strict";

    (function (t, n) {
      var i = r(21);
      e.exports = g;
      var o,
          a = r(46);
      g.ReadableState = v;
      r(29).EventEmitter;

      var s = function s(e, t) {
        return e.listeners(t).length;
      },
          f = r(49),
          c = r(1).Buffer,
          u = t.Uint8Array || function () {};

      var d = Object.create(r(15));
      d.inherits = r(0);
      var h = r(99),
          l = void 0;
      l = h && h.debuglog ? h.debuglog("stream") : function () {};
      var p,
          b = r(100),
          m = r(50);
      d.inherits(g, f);
      var y = ["error", "close", "destroy", "pause", "resume"];

      function v(e, t) {
        e = e || {};
        var n = t instanceof (o = o || r(11));
        this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.readableObjectMode);
        var i = e.highWaterMark,
            a = e.readableHighWaterMark,
            s = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new b(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (p || (p = r(32).StringDecoder), this.decoder = new p(e.encoding), this.encoding = e.encoding);
      }

      function g(e) {
        if (o = o || r(11), !(this instanceof g)) return new g(e);
        this._readableState = new v(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), f.call(this);
      }

      function _(e, t, r, n, i) {
        var o,
            a = e._readableState;
        null === t ? (a.reading = !1, function (e, t) {
          if (t.ended) return;

          if (t.decoder) {
            var r = t.decoder.end();
            r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
          }

          t.ended = !0, E(e);
        }(e, a)) : (i || (o = function (e, t) {
          var r;
          n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
          var n;
          return r;
        }(a, t)), o ? e.emit("error", o) : a.objectMode || t && t.length > 0 ? ("string" == typeof t || a.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function (e) {
          return c.from(e);
        }(t)), n ? a.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : w(e, a, t, !0) : a.ended ? e.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !r ? (t = a.decoder.write(t), a.objectMode || 0 !== t.length ? w(e, a, t, !1) : S(e, a)) : w(e, a, t, !1))) : n || (a.reading = !1));
        return function (e) {
          return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
        }(a);
      }

      function w(e, t, r, n) {
        t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && E(e)), S(e, t);
      }

      Object.defineProperty(g.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(e) {
          this._readableState && (this._readableState.destroyed = e);
        }
      }), g.prototype.destroy = m.destroy, g.prototype._undestroy = m.undestroy, g.prototype._destroy = function (e, t) {
        this.push(null), t(e);
      }, g.prototype.push = function (e, t) {
        var r,
            n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), _(this, e, t, !1, r);
      }, g.prototype.unshift = function (e) {
        return _(this, e, null, !0, !1);
      }, g.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, g.prototype.setEncoding = function (e) {
        return p || (p = r(32).StringDecoder), this._readableState.decoder = new p(e), this._readableState.encoding = e, this;
      };

      function k(e, t) {
        return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
          return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
        }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
      }

      function E(e) {
        var t = e._readableState;
        t.needReadable = !1, t.emittedReadable || (l("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(A, e) : A(e));
      }

      function A(e) {
        l("emit readable"), e.emit("readable"), j(e);
      }

      function S(e, t) {
        t.readingMore || (t.readingMore = !0, i.nextTick(M, e, t));
      }

      function M(e, t) {
        for (var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (l("maybeReadMore read 0"), e.read(0), r !== t.length);) {
          r = t.length;
        }

        t.readingMore = !1;
      }

      function x(e) {
        l("readable nexttick read 0"), e.read(0);
      }

      function I(e, t) {
        t.reading || (l("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), j(e), t.flowing && !t.reading && e.read(0);
      }

      function j(e) {
        var t = e._readableState;

        for (l("flow", t.flowing); t.flowing && null !== e.read();) {
          ;
        }
      }

      function B(e, t) {
        return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function (e, t, r) {
          var n;
          e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function (e, t) {
            var r = t.head,
                n = 1,
                i = r.data;
            e -= i.length;

            for (; r = r.next;) {
              var o = r.data,
                  a = e > o.length ? o.length : e;

              if (a === o.length ? i += o : i += o.slice(0, e), 0 === (e -= a)) {
                a === o.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = o.slice(a));
                break;
              }

              ++n;
            }

            return t.length -= n, i;
          }(e, t) : function (e, t) {
            var r = c.allocUnsafe(e),
                n = t.head,
                i = 1;
            n.data.copy(r), e -= n.data.length;

            for (; n = n.next;) {
              var o = n.data,
                  a = e > o.length ? o.length : e;

              if (o.copy(r, r.length - e, 0, a), 0 === (e -= a)) {
                a === o.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = o.slice(a));
                break;
              }

              ++i;
            }

            return t.length -= i, r;
          }(e, t);
          return n;
        }(e, t.buffer, t.decoder), r);
        var r;
      }

      function R(e) {
        var t = e._readableState;
        if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        t.endEmitted || (t.ended = !0, i.nextTick(P, t, e));
      }

      function P(e, t) {
        e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
      }

      function T(e, t) {
        for (var r = 0, n = e.length; r < n; r++) {
          if (e[r] === t) return r;
        }

        return -1;
      }

      g.prototype.read = function (e) {
        l("read", e), e = parseInt(e, 10);
        var t = this._readableState,
            r = e;
        if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return l("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? R(this) : E(this), null;
        if (0 === (e = k(e, t)) && t.ended) return 0 === t.length && R(this), null;
        var n,
            i = t.needReadable;
        return l("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && l("length less than watermark", i = !0), t.ended || t.reading ? l("reading or ended", i = !1) : i && (l("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = k(r, t))), null === (n = e > 0 ? B(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && R(this)), null !== n && this.emit("data", n), n;
      }, g.prototype._read = function (e) {
        this.emit("error", new Error("_read() is not implemented"));
      }, g.prototype.pipe = function (e, t) {
        var r = this,
            o = this._readableState;

        switch (o.pipesCount) {
          case 0:
            o.pipes = e;
            break;

          case 1:
            o.pipes = [o.pipes, e];
            break;

          default:
            o.pipes.push(e);
        }

        o.pipesCount += 1, l("pipe count=%d opts=%j", o.pipesCount, t);
        var f = (!t || !1 !== t.end) && e !== n.stdout && e !== n.stderr ? u : g;

        function c(t, n) {
          l("onunpipe"), t === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, l("cleanup"), e.removeListener("close", y), e.removeListener("finish", v), e.removeListener("drain", d), e.removeListener("error", m), e.removeListener("unpipe", c), r.removeListener("end", u), r.removeListener("end", g), r.removeListener("data", b), h = !0, !o.awaitDrain || e._writableState && !e._writableState.needDrain || d());
        }

        function u() {
          l("onend"), e.end();
        }

        o.endEmitted ? i.nextTick(f) : r.once("end", f), e.on("unpipe", c);

        var d = function (e) {
          return function () {
            var t = e._readableState;
            l("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, j(e));
          };
        }(r);

        e.on("drain", d);
        var h = !1;
        var p = !1;

        function b(t) {
          l("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === o.pipesCount && o.pipes === e || o.pipesCount > 1 && -1 !== T(o.pipes, e)) && !h && (l("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, p = !0), r.pause());
        }

        function m(t) {
          l("onerror", t), g(), e.removeListener("error", m), 0 === s(e, "error") && e.emit("error", t);
        }

        function y() {
          e.removeListener("finish", v), g();
        }

        function v() {
          l("onfinish"), e.removeListener("close", y), g();
        }

        function g() {
          l("unpipe"), r.unpipe(e);
        }

        return r.on("data", b), function (e, t, r) {
          if ("function" == typeof e.prependListener) return e.prependListener(t, r);
          e._events && e._events[t] ? a(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [r, e._events[t]] : e.on(t, r);
        }(e, "error", m), e.once("close", y), e.once("finish", v), e.emit("pipe", r), o.flowing || (l("pipe resume"), r.resume()), e;
      }, g.prototype.unpipe = function (e) {
        var t = this._readableState,
            r = {
          hasUnpiped: !1
        };
        if (0 === t.pipesCount) return this;
        if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;

        if (!e) {
          var n = t.pipes,
              i = t.pipesCount;
          t.pipes = null, t.pipesCount = 0, t.flowing = !1;

          for (var o = 0; o < i; o++) {
            n[o].emit("unpipe", this, r);
          }

          return this;
        }

        var a = T(t.pipes, e);
        return -1 === a || (t.pipes.splice(a, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
      }, g.prototype.on = function (e, t) {
        var r = f.prototype.on.call(this, e, t);
        if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
          var n = this._readableState;
          n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && E(this) : i.nextTick(x, this));
        }
        return r;
      }, g.prototype.addListener = g.prototype.on, g.prototype.resume = function () {
        var e = this._readableState;
        return e.flowing || (l("resume"), e.flowing = !0, function (e, t) {
          t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(I, e, t));
        }(this, e)), this;
      }, g.prototype.pause = function () {
        return l("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (l("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, g.prototype.wrap = function (e) {
        var t = this,
            r = this._readableState,
            n = !1;

        for (var i in e.on("end", function () {
          if (l("wrapped end"), r.decoder && !r.ended) {
            var e = r.decoder.end();
            e && e.length && t.push(e);
          }

          t.push(null);
        }), e.on("data", function (i) {
          (l("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
        }), e) {
          void 0 === this[i] && "function" == typeof e[i] && (this[i] = function (t) {
            return function () {
              return e[t].apply(e, arguments);
            };
          }(i));
        }

        for (var o = 0; o < y.length; o++) {
          e.on(y[o], this.emit.bind(this, y[o]));
        }

        return this._read = function (t) {
          l("wrapped _read", t), n && (n = !1, e.resume());
        }, this;
      }, Object.defineProperty(g.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), g._fromList = B;
    }).call(this, r(6), r(7));
  }, function (e, t, r) {
    e.exports = r(29).EventEmitter;
  }, function (e, t, r) {
    "use strict";

    var n = r(21);

    function i(e, t) {
      e.emit("error", t);
    }

    e.exports = {
      destroy: function destroy(e, t) {
        var r = this,
            o = this._readableState && this._readableState.destroyed,
            a = this._writableState && this._writableState.destroyed;
        return o || a ? (t ? t(e) : !e || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, e), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
          !t && e ? (n.nextTick(i, r, e), r._writableState && (r._writableState.errorEmitted = !0)) : t && t(e);
        }), this);
      },
      undestroy: function undestroy() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = a;
    var n = r(11),
        i = Object.create(r(15));

    function o(e, t) {
      var r = this._transformState;
      r.transforming = !1;
      var n = r.writecb;
      if (!n) return this.emit("error", new Error("write callback called multiple times"));
      r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }

    function a(e) {
      if (!(this instanceof a)) return new a(e);
      n.call(this, e), this._transformState = {
        afterTransform: o.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", s);
    }

    function s() {
      var e = this;
      "function" == typeof this._flush ? this._flush(function (t, r) {
        f(e, t, r);
      }) : f(this, null, null);
    }

    function f(e, t, r) {
      if (t) return e.emit("error", t);
      if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return e.push(null);
    }

    i.inherits = r(0), i.inherits(a, n), a.prototype.push = function (e, t) {
      return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
    }, a.prototype._transform = function (e, t, r) {
      throw new Error("_transform() is not implemented");
    }, a.prototype._write = function (e, t, r) {
      var n = this._transformState;

      if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
        var i = this._readableState;
        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, a.prototype._read = function (e) {
      var t = this._transformState;
      null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
    }, a.prototype._destroy = function (e, t) {
      var r = this;

      n.prototype._destroy.call(this, e, function (e) {
        t(e), r.emit("close");
      });
    };
  }, function (e, t, r) {
    var n = r(0),
        i = r(13),
        o = r(1).Buffer,
        a = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
        s = new Array(64);

    function f() {
      this.init(), this._w = s, i.call(this, 64, 56);
    }

    function c(e, t, r) {
      return r ^ e & (t ^ r);
    }

    function u(e, t, r) {
      return e & t | r & (e | t);
    }

    function d(e) {
      return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
    }

    function h(e) {
      return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
    }

    function l(e) {
      return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
    }, f.prototype._update = function (e) {
      for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, p = 0 | this._f, b = 0 | this._g, m = 0 | this._h, y = 0; y < 16; ++y) {
        r[y] = e.readInt32BE(4 * y);
      }

      for (; y < 64; ++y) {
        r[y] = 0 | (((t = r[y - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[y - 7] + l(r[y - 15]) + r[y - 16];
      }

      for (var v = 0; v < 64; ++v) {
        var g = m + h(f) + c(f, p, b) + a[v] + r[v] | 0,
            _ = d(n) + u(n, i, o) | 0;

        m = b, b = p, p = f, f = s + g | 0, s = o, o = i, i = n, n = g + _ | 0;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0, this._f = p + this._f | 0, this._g = b + this._g | 0, this._h = m + this._h | 0;
    }, f.prototype._hash = function () {
      var e = o.allocUnsafe(32);
      return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(0),
        i = r(13),
        o = r(1).Buffer,
        a = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
        s = new Array(160);

    function f() {
      this.init(), this._w = s, i.call(this, 128, 112);
    }

    function c(e, t, r) {
      return r ^ e & (t ^ r);
    }

    function u(e, t, r) {
      return e & t | r & (e | t);
    }

    function d(e, t) {
      return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
    }

    function h(e, t) {
      return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
    }

    function l(e, t) {
      return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
    }

    function p(e, t) {
      return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
    }

    function b(e, t) {
      return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
    }

    function m(e, t) {
      return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
    }

    function y(e, t) {
      return e >>> 0 < t >>> 0 ? 1 : 0;
    }

    n(f, i), f.prototype.init = function () {
      return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
    }, f.prototype._update = function (e) {
      for (var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, o = 0 | this._dh, s = 0 | this._eh, f = 0 | this._fh, v = 0 | this._gh, g = 0 | this._hh, _ = 0 | this._al, w = 0 | this._bl, k = 0 | this._cl, E = 0 | this._dl, A = 0 | this._el, S = 0 | this._fl, M = 0 | this._gl, x = 0 | this._hl, I = 0; I < 32; I += 2) {
        t[I] = e.readInt32BE(4 * I), t[I + 1] = e.readInt32BE(4 * I + 4);
      }

      for (; I < 160; I += 2) {
        var j = t[I - 30],
            B = t[I - 30 + 1],
            R = l(j, B),
            P = p(B, j),
            T = b(j = t[I - 4], B = t[I - 4 + 1]),
            L = m(B, j),
            C = t[I - 14],
            O = t[I - 14 + 1],
            N = t[I - 32],
            U = t[I - 32 + 1],
            D = P + O | 0,
            q = R + C + y(D, P) | 0;
        q = (q = q + T + y(D = D + L | 0, L) | 0) + N + y(D = D + U | 0, U) | 0, t[I] = q, t[I + 1] = D;
      }

      for (var z = 0; z < 160; z += 2) {
        q = t[z], D = t[z + 1];
        var F = u(r, n, i),
            Y = u(_, w, k),
            K = d(r, _),
            V = d(_, r),
            H = h(s, A),
            W = h(A, s),
            G = a[z],
            X = a[z + 1],
            Z = c(s, f, v),
            J = c(A, S, M),
            $ = x + W | 0,
            Q = g + H + y($, x) | 0;
        Q = (Q = (Q = Q + Z + y($ = $ + J | 0, J) | 0) + G + y($ = $ + X | 0, X) | 0) + q + y($ = $ + D | 0, D) | 0;
        var ee = V + Y | 0,
            te = K + F + y(ee, V) | 0;
        g = v, x = M, v = f, M = S, f = s, S = A, s = o + Q + y(A = E + $ | 0, E) | 0, o = i, E = k, i = n, k = w, n = r, w = _, r = Q + te + y(_ = $ + ee | 0, $) | 0;
      }

      this._al = this._al + _ | 0, this._bl = this._bl + w | 0, this._cl = this._cl + k | 0, this._dl = this._dl + E | 0, this._el = this._el + A | 0, this._fl = this._fl + S | 0, this._gl = this._gl + M | 0, this._hl = this._hl + x | 0, this._ah = this._ah + r + y(this._al, _) | 0, this._bh = this._bh + n + y(this._bl, w) | 0, this._ch = this._ch + i + y(this._cl, k) | 0, this._dh = this._dh + o + y(this._dl, E) | 0, this._eh = this._eh + s + y(this._el, A) | 0, this._fh = this._fh + f + y(this._fl, S) | 0, this._gh = this._gh + v + y(this._gl, M) | 0, this._hh = this._hh + g + y(this._hl, x) | 0;
    }, f.prototype._hash = function () {
      var e = o.allocUnsafe(64);

      function t(t, r, n) {
        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
      }

      return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
    }, e.exports = f;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        i = r(114),
        o = r(9),
        a = r(1).Buffer,
        s = r(55),
        f = r(33),
        c = r(34),
        u = a.alloc(128);

    function d(e, t) {
      o.call(this, "digest"), "string" == typeof t && (t = a.from(t));
      var r = "sha512" === e || "sha384" === e ? 128 : 64;
      (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new f() : c(e)).update(t).digest() : t.length < r && (t = a.concat([t, u], r));

      for (var n = this._ipad = a.allocUnsafe(r), i = this._opad = a.allocUnsafe(r), s = 0; s < r; s++) {
        n[s] = 54 ^ t[s], i[s] = 92 ^ t[s];
      }

      this._hash = "rmd160" === e ? new f() : c(e), this._hash.update(n);
    }

    n(d, o), d.prototype._update = function (e) {
      this._hash.update(e);
    }, d.prototype._final = function () {
      var e = this._hash.digest();

      return ("rmd160" === this._alg ? new f() : c(this._alg)).update(this._opad).update(e).digest();
    }, e.exports = function (e, t) {
      return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new d("rmd160", t) : "md5" === e ? new i(s, t) : new d(e, t);
    };
  }, function (e, t, r) {
    var n = r(27);

    e.exports = function (e) {
      return new n().update(e).digest();
    };
  }, function (e) {
    e.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');
  }, function (e, t, r) {
    t.pbkdf2 = r(116), t.pbkdf2Sync = r(60);
  }, function (e, t, r) {
    (function (t) {
      var r = Math.pow(2, 30) - 1;

      function n(e, r) {
        if ("string" != typeof e && !t.isBuffer(e)) throw new TypeError(r + " must be a buffer or string");
      }

      e.exports = function (e, t, i, o) {
        if (n(e, "Password"), n(t, "Salt"), "number" != typeof i) throw new TypeError("Iterations not a number");
        if (i < 0) throw new TypeError("Bad iterations");
        if ("number" != typeof o) throw new TypeError("Key length not a number");
        if (o < 0 || o > r || o != o) throw new TypeError("Bad key length");
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var r;
      t.browser ? r = "utf-8" : r = parseInt(t.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
      e.exports = r;
    }).call(this, r(7));
  }, function (e, t, r) {
    var n = r(55),
        i = r(33),
        o = r(34),
        a = r(58),
        s = r(59),
        f = r(1).Buffer,
        c = f.alloc(128),
        u = {
      md5: 16,
      sha1: 20,
      sha224: 28,
      sha256: 32,
      sha384: 48,
      sha512: 64,
      rmd160: 20,
      ripemd160: 20
    };

    function d(e, t, r) {
      var a = function (e) {
        function t(t) {
          return o(e).update(t).digest();
        }

        return "rmd160" === e || "ripemd160" === e ? function (e) {
          return new i().update(e).digest();
        } : "md5" === e ? n : t;
      }(e),
          s = "sha512" === e || "sha384" === e ? 128 : 64;

      t.length > s ? t = a(t) : t.length < s && (t = f.concat([t, c], s));

      for (var d = f.allocUnsafe(s + u[e]), h = f.allocUnsafe(s + u[e]), l = 0; l < s; l++) {
        d[l] = 54 ^ t[l], h[l] = 92 ^ t[l];
      }

      var p = f.allocUnsafe(s + r + 4);
      d.copy(p, 0, 0, s), this.ipad1 = p, this.ipad2 = d, this.opad = h, this.alg = e, this.blocksize = s, this.hash = a, this.size = u[e];
    }

    d.prototype.run = function (e, t) {
      return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
    }, e.exports = function (e, t, r, n, i) {
      a(e, t, r, n), f.isBuffer(e) || (e = f.from(e, s)), f.isBuffer(t) || (t = f.from(t, s));
      var o = new d(i = i || "sha1", e, t.length),
          c = f.allocUnsafe(n),
          h = f.allocUnsafe(t.length + 4);
      t.copy(h, 0, 0, t.length);

      for (var l = 0, p = u[i], b = Math.ceil(n / p), m = 1; m <= b; m++) {
        h.writeUInt32BE(m, t.length);

        for (var y = o.run(h, o.ipad1), v = y, g = 1; g < r; g++) {
          v = o.run(v, o.ipad2);

          for (var _ = 0; _ < p; _++) {
            y[_] ^= v[_];
          }
        }

        y.copy(c, l), l += p;
      }

      return c;
    };
  }, function (e, t, r) {
    "use strict";

    t.readUInt32BE = function (e, t) {
      return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
    }, t.writeUInt32BE = function (e, t, r) {
      e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
    }, t.ip = function (e, t, r, n) {
      for (var i = 0, o = 0, a = 6; a >= 0; a -= 2) {
        for (var s = 0; s <= 24; s += 8) {
          i <<= 1, i |= t >>> s + a & 1;
        }

        for (s = 0; s <= 24; s += 8) {
          i <<= 1, i |= e >>> s + a & 1;
        }
      }

      for (a = 6; a >= 0; a -= 2) {
        for (s = 1; s <= 25; s += 8) {
          o <<= 1, o |= t >>> s + a & 1;
        }

        for (s = 1; s <= 25; s += 8) {
          o <<= 1, o |= e >>> s + a & 1;
        }
      }

      r[n + 0] = i >>> 0, r[n + 1] = o >>> 0;
    }, t.rip = function (e, t, r, n) {
      for (var i = 0, o = 0, a = 0; a < 4; a++) {
        for (var s = 24; s >= 0; s -= 8) {
          i <<= 1, i |= t >>> s + a & 1, i <<= 1, i |= e >>> s + a & 1;
        }
      }

      for (a = 4; a < 8; a++) {
        for (s = 24; s >= 0; s -= 8) {
          o <<= 1, o |= t >>> s + a & 1, o <<= 1, o |= e >>> s + a & 1;
        }
      }

      r[n + 0] = i >>> 0, r[n + 1] = o >>> 0;
    }, t.pc1 = function (e, t, r, n) {
      for (var i = 0, o = 0, a = 7; a >= 5; a--) {
        for (var s = 0; s <= 24; s += 8) {
          i <<= 1, i |= t >> s + a & 1;
        }

        for (s = 0; s <= 24; s += 8) {
          i <<= 1, i |= e >> s + a & 1;
        }
      }

      for (s = 0; s <= 24; s += 8) {
        i <<= 1, i |= t >> s + a & 1;
      }

      for (a = 1; a <= 3; a++) {
        for (s = 0; s <= 24; s += 8) {
          o <<= 1, o |= t >> s + a & 1;
        }

        for (s = 0; s <= 24; s += 8) {
          o <<= 1, o |= e >> s + a & 1;
        }
      }

      for (s = 0; s <= 24; s += 8) {
        o <<= 1, o |= e >> s + a & 1;
      }

      r[n + 0] = i >>> 0, r[n + 1] = o >>> 0;
    }, t.r28shl = function (e, t) {
      return e << t & 268435455 | e >>> 28 - t;
    };
    var n = [14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26, 15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24];
    t.pc2 = function (e, t, r, i) {
      for (var o = 0, a = 0, s = n.length >>> 1, f = 0; f < s; f++) {
        o <<= 1, o |= e >>> n[f] & 1;
      }

      for (f = s; f < n.length; f++) {
        a <<= 1, a |= t >>> n[f] & 1;
      }

      r[i + 0] = o >>> 0, r[i + 1] = a >>> 0;
    }, t.expand = function (e, t, r) {
      var n = 0,
          i = 0;
      n = (1 & e) << 5 | e >>> 27;

      for (var o = 23; o >= 15; o -= 4) {
        n <<= 6, n |= e >>> o & 63;
      }

      for (o = 11; o >= 3; o -= 4) {
        i |= e >>> o & 63, i <<= 6;
      }

      i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
    };
    var i = [14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11];

    t.substitute = function (e, t) {
      for (var r = 0, n = 0; n < 4; n++) {
        r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
      }

      for (n = 0; n < 4; n++) {
        r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
      }

      return r >>> 0;
    };

    var o = [16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7];
    t.permute = function (e) {
      for (var t = 0, r = 0; r < o.length; r++) {
        t <<= 1, t |= e >>> o[r] & 1;
      }

      return t >>> 0;
    }, t.padSplit = function (e, t, r) {
      for (var n = e.toString(2); n.length < t;) {
        n = "0" + n;
      }

      for (var i = [], o = 0; o < t; o += r) {
        i.push(n.slice(o, o + r));
      }

      return i.join(" ");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        i = r(0),
        o = r(61),
        a = r(35);

    function s() {
      this.tmp = new Array(2), this.keys = null;
    }

    function f(e) {
      a.call(this, e);
      var t = new s();
      this._desState = t, this.deriveKeys(t, e.key);
    }

    i(f, a), e.exports = f, f.create = function (e) {
      return new f(e);
    };
    var c = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
    f.prototype.deriveKeys = function (e, t) {
      e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
      var r = o.readUInt32BE(t, 0),
          i = o.readUInt32BE(t, 4);
      o.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];

      for (var a = 0; a < e.keys.length; a += 2) {
        var s = c[a >>> 1];
        r = o.r28shl(r, s), i = o.r28shl(i, s), o.pc2(r, i, e.keys, a);
      }
    }, f.prototype._update = function (e, t, r, n) {
      var i = this._desState,
          a = o.readUInt32BE(e, t),
          s = o.readUInt32BE(e, t + 4);
      o.ip(a, s, i.tmp, 0), a = i.tmp[0], s = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, a, s, i.tmp, 0) : this._decrypt(i, a, s, i.tmp, 0), a = i.tmp[0], s = i.tmp[1], o.writeUInt32BE(r, a, n), o.writeUInt32BE(r, s, n + 4);
    }, f.prototype._pad = function (e, t) {
      for (var r = e.length - t, n = t; n < e.length; n++) {
        e[n] = r;
      }

      return !0;
    }, f.prototype._unpad = function (e) {
      for (var t = e[e.length - 1], r = e.length - t; r < e.length; r++) {
        n.equal(e[r], t);
      }

      return e.slice(0, e.length - t);
    }, f.prototype._encrypt = function (e, t, r, n, i) {
      for (var a = t, s = r, f = 0; f < e.keys.length; f += 2) {
        var c = e.keys[f],
            u = e.keys[f + 1];
        o.expand(s, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
        var d = o.substitute(c, u),
            h = s;
        s = (a ^ o.permute(d)) >>> 0, a = h;
      }

      o.rip(s, a, n, i);
    }, f.prototype._decrypt = function (e, t, r, n, i) {
      for (var a = r, s = t, f = e.keys.length - 2; f >= 0; f -= 2) {
        var c = e.keys[f],
            u = e.keys[f + 1];
        o.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
        var d = o.substitute(c, u),
            h = a;
        a = (s ^ o.permute(d)) >>> 0, s = h;
      }

      o.rip(a, s, n, i);
    };
  }, function (e, t, r) {
    var n = r(16),
        i = r(1).Buffer,
        o = r(64);

    function a(e) {
      var t = e._cipher.encryptBlockRaw(e._prev);

      return o(e._prev), t;
    }

    t.encrypt = function (e, t) {
      var r = Math.ceil(t.length / 16),
          o = e._cache.length;
      e._cache = i.concat([e._cache, i.allocUnsafe(16 * r)]);

      for (var s = 0; s < r; s++) {
        var f = a(e),
            c = o + 16 * s;
        e._cache.writeUInt32BE(f[0], c + 0), e._cache.writeUInt32BE(f[1], c + 4), e._cache.writeUInt32BE(f[2], c + 8), e._cache.writeUInt32BE(f[3], c + 12);
      }

      var u = e._cache.slice(0, t.length);

      return e._cache = e._cache.slice(t.length), n(t, u);
    };
  }, function (e, t) {
    e.exports = function (e) {
      for (var t, r = e.length; r--;) {
        if (255 !== (t = e.readUInt8(r))) {
          t++, e.writeUInt8(t, r);
          break;
        }

        e.writeUInt8(0, r);
      }
    };
  }, function (e) {
    e.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');
  }, function (e, t, r) {
    var n = r(22),
        i = r(1).Buffer,
        o = r(9),
        a = r(0),
        s = r(129),
        f = r(16),
        c = r(64);

    function u(e, t, r, a) {
      o.call(this);
      var f = i.alloc(4, 0);
      this._cipher = new n.AES(t);

      var u = this._cipher.encryptBlock(f);

      this._ghash = new s(u), r = function (e, t, r) {
        if (12 === t.length) return e._finID = i.concat([t, i.from([0, 0, 0, 1])]), i.concat([t, i.from([0, 0, 0, 2])]);
        var n = new s(r),
            o = t.length,
            a = o % 16;
        n.update(t), a && (a = 16 - a, n.update(i.alloc(a, 0))), n.update(i.alloc(8, 0));
        var f = 8 * o,
            u = i.alloc(8);
        u.writeUIntBE(f, 0, 8), n.update(u), e._finID = n.state;
        var d = i.from(e._finID);
        return c(d), d;
      }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
    }

    a(u, o), u.prototype._update = function (e) {
      if (!this._called && this._alen) {
        var t = 16 - this._alen % 16;
        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
      }

      this._called = !0;

      var r = this._mode.encrypt(this, e);

      return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
    }, u.prototype._final = function () {
      if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
      var e = f(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
      if (this._decrypt && function (e, t) {
        var r = 0;
        e.length !== t.length && r++;

        for (var n = Math.min(e.length, t.length), i = 0; i < n; ++i) {
          r += e[i] ^ t[i];
        }

        return r;
      }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
      this._authTag = e, this._cipher.scrub();
    }, u.prototype.getAuthTag = function () {
      if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
      return this._authTag;
    }, u.prototype.setAuthTag = function (e) {
      if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
      this._authTag = e;
    }, u.prototype.setAAD = function (e) {
      if (this._called) throw new Error("Attempting to set AAD in unsupported state");
      this._ghash.update(e), this._alen += e.length;
    }, e.exports = u;
  }, function (e, t, r) {
    var n = r(22),
        i = r(1).Buffer,
        o = r(9);

    function a(e, t, r, a) {
      o.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._mode = e;
    }

    r(0)(a, o), a.prototype._update = function (e) {
      return this._mode.encrypt(this, e, this._decrypt);
    }, a.prototype._final = function () {
      this._cipher.scrub();
    }, e.exports = a;
  }, function (e, t, r) {
    var n = r(12);
    e.exports = v, v.simpleSieve = m, v.fermatTest = y;
    var i = r(3),
        o = new i(24),
        a = new (r(70))(),
        s = new i(1),
        f = new i(2),
        c = new i(5),
        u = (new i(16), new i(8), new i(10)),
        d = new i(3),
        h = (new i(7), new i(11)),
        l = new i(4),
        p = (new i(12), null);

    function b() {
      if (null !== p) return p;
      var e = [];
      e[0] = 2;

      for (var t = 1, r = 3; r < 1048576; r += 2) {
        for (var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++) {
          ;
        }

        t !== i && e[i] <= n || (e[t++] = r);
      }

      return p = e, e;
    }

    function m(e) {
      for (var t = b(), r = 0; r < t.length; r++) {
        if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
      }

      return !0;
    }

    function y(e) {
      var t = i.mont(e);
      return 0 === f.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
    }

    function v(e, t) {
      if (e < 16) return new i(2 === t || 5 === t ? [140, 123] : [140, 39]);
      var r, p;

      for (t = new i(t);;) {
        for (r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;) {
          r.ishrn(1);
        }

        if (r.isEven() && r.iadd(s), r.testn(1) || r.iadd(f), t.cmp(f)) {
          if (!t.cmp(c)) for (; r.mod(u).cmp(d);) {
            r.iadd(l);
          }
        } else for (; r.mod(o).cmp(h);) {
          r.iadd(l);
        }

        if (m(p = r.shrn(1)) && m(r) && y(p) && y(r) && a.test(p) && a.test(r)) return r;
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, r) {
    var n = r(3),
        i = r(38);

    function o(e) {
      this.rand = e || new i.Rand();
    }

    e.exports = o, o.create = function (e) {
      return new o(e);
    }, o.prototype._randbelow = function (e) {
      var t = e.bitLength(),
          r = Math.ceil(t / 8);

      do {
        var i = new n(this.rand.generate(r));
      } while (i.cmp(e) >= 0);

      return i;
    }, o.prototype._randrange = function (e, t) {
      var r = t.sub(e);
      return e.add(this._randbelow(r));
    }, o.prototype.test = function (e, t, r) {
      var i = e.bitLength(),
          o = n.mont(e),
          a = new n(1).toRed(o);
      t || (t = Math.max(1, i / 48 | 0));

      for (var s = e.subn(1), f = 0; !s.testn(f); f++) {
        ;
      }

      for (var c = e.shrn(f), u = s.toRed(o); t > 0; t--) {
        var d = this._randrange(new n(2), s);

        r && r(d);
        var h = d.toRed(o).redPow(c);

        if (0 !== h.cmp(a) && 0 !== h.cmp(u)) {
          for (var l = 1; l < f; l++) {
            if (0 === (h = h.redSqr()).cmp(a)) return !1;
            if (0 === h.cmp(u)) break;
          }

          if (l === f) return !1;
        }
      }

      return !0;
    }, o.prototype.getDivisor = function (e, t) {
      var r = e.bitLength(),
          i = n.mont(e),
          o = new n(1).toRed(i);
      t || (t = Math.max(1, r / 48 | 0));

      for (var a = e.subn(1), s = 0; !a.testn(s); s++) {
        ;
      }

      for (var f = e.shrn(s), c = a.toRed(i); t > 0; t--) {
        var u = this._randrange(new n(2), a),
            d = e.gcd(u);

        if (0 !== d.cmpn(1)) return d;
        var h = u.toRed(i).redPow(f);

        if (0 !== h.cmp(o) && 0 !== h.cmp(c)) {
          for (var l = 1; l < s; l++) {
            if (0 === (h = h.redSqr()).cmp(o)) return h.fromRed().subn(1).gcd(e);
            if (0 === h.cmp(c)) break;
          }

          if (l === s) return (h = h.redSqr()).fromRed().subn(1).gcd(e);
        }
      }

      return !1;
    };
  }, function (e, t, r) {
    "use strict";

    var n = t;

    function i(e) {
      return 1 === e.length ? "0" + e : e;
    }

    function o(e) {
      for (var t = "", r = 0; r < e.length; r++) {
        t += i(e[r].toString(16));
      }

      return t;
    }

    n.toArray = function (e, t) {
      if (Array.isArray(e)) return e.slice();
      if (!e) return [];
      var r = [];

      if ("string" != typeof e) {
        for (var n = 0; n < e.length; n++) {
          r[n] = 0 | e[n];
        }

        return r;
      }

      if ("hex" === t) {
        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);

        for (n = 0; n < e.length; n += 2) {
          r.push(parseInt(e[n] + e[n + 1], 16));
        }
      } else for (n = 0; n < e.length; n++) {
        var i = e.charCodeAt(n),
            o = i >> 8,
            a = 255 & i;
        o ? r.push(o, a) : r.push(a);
      }

      return r;
    }, n.zero2 = i, n.toHex = o, n.encode = function (e, t) {
      return "hex" === t ? o(e) : e;
    };
  }, function (e, t, r) {
    "use strict";

    var n = t;
    n.base = r(24), n.short = r(140), n.mont = r(141), n.edwards = r(142);
  }, function (e, t, r) {
    "use strict";

    var n = r(8).rotr32;

    function i(e, t, r) {
      return e & t ^ ~e & r;
    }

    function o(e, t, r) {
      return e & t ^ e & r ^ t & r;
    }

    function a(e, t, r) {
      return e ^ t ^ r;
    }

    t.ft_1 = function (e, t, r, n) {
      return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? a(t, r, n) : 2 === e ? o(t, r, n) : void 0;
    }, t.ch32 = i, t.maj32 = o, t.p32 = a, t.s0_256 = function (e) {
      return n(e, 2) ^ n(e, 13) ^ n(e, 22);
    }, t.s1_256 = function (e) {
      return n(e, 6) ^ n(e, 11) ^ n(e, 25);
    }, t.g0_256 = function (e) {
      return n(e, 7) ^ n(e, 18) ^ e >>> 3;
    }, t.g1_256 = function (e) {
      return n(e, 17) ^ n(e, 19) ^ e >>> 10;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(17),
        o = r(73),
        a = r(4),
        s = n.sum32,
        f = n.sum32_4,
        c = n.sum32_5,
        u = o.ch32,
        d = o.maj32,
        h = o.s0_256,
        l = o.s1_256,
        p = o.g0_256,
        b = o.g1_256,
        m = i.BlockHash,
        y = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

    function v() {
      if (!(this instanceof v)) return new v();
      m.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = y, this.W = new Array(64);
    }

    n.inherits(v, m), e.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = e[t + n];
      }

      for (; n < r.length; n++) {
        r[n] = f(b(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
      }

      var i = this.h[0],
          o = this.h[1],
          m = this.h[2],
          y = this.h[3],
          v = this.h[4],
          g = this.h[5],
          _ = this.h[6],
          w = this.h[7];

      for (a(this.k.length === r.length), n = 0; n < r.length; n++) {
        var k = c(w, l(v), u(v, g, _), this.k[n], r[n]),
            E = s(h(i), d(i, o, m));
        w = _, _ = g, g = v, v = s(y, k), y = m, m = o, o = i, i = s(k, E);
      }

      this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], m), this.h[3] = s(this.h[3], y), this.h[4] = s(this.h[4], v), this.h[5] = s(this.h[5], g), this.h[6] = s(this.h[6], _), this.h[7] = s(this.h[7], w);
    }, v.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(17),
        o = r(4),
        a = n.rotr64_hi,
        s = n.rotr64_lo,
        f = n.shr64_hi,
        c = n.shr64_lo,
        u = n.sum64,
        d = n.sum64_hi,
        h = n.sum64_lo,
        l = n.sum64_4_hi,
        p = n.sum64_4_lo,
        b = n.sum64_5_hi,
        m = n.sum64_5_lo,
        y = i.BlockHash,
        v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

    function g() {
      if (!(this instanceof g)) return new g();
      y.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
    }

    function _(e, t, r, n, i) {
      var o = e & r ^ ~e & i;
      return o < 0 && (o += 4294967296), o;
    }

    function w(e, t, r, n, i, o) {
      var a = t & n ^ ~t & o;
      return a < 0 && (a += 4294967296), a;
    }

    function k(e, t, r, n, i) {
      var o = e & r ^ e & i ^ r & i;
      return o < 0 && (o += 4294967296), o;
    }

    function E(e, t, r, n, i, o) {
      var a = t & n ^ t & o ^ n & o;
      return a < 0 && (a += 4294967296), a;
    }

    function A(e, t) {
      var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function S(e, t) {
      var r = s(e, t, 28) ^ s(t, e, 2) ^ s(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function M(e, t) {
      var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function x(e, t) {
      var r = s(e, t, 14) ^ s(e, t, 18) ^ s(t, e, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function I(e, t) {
      var r = a(e, t, 1) ^ a(e, t, 8) ^ f(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function j(e, t) {
      var r = s(e, t, 1) ^ s(e, t, 8) ^ c(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function B(e, t) {
      var r = a(e, t, 19) ^ a(t, e, 29) ^ f(e, t, 6);
      return r < 0 && (r += 4294967296), r;
    }

    function R(e, t) {
      var r = s(e, t, 19) ^ s(t, e, 29) ^ c(e, t, 6);
      return r < 0 && (r += 4294967296), r;
    }

    n.inherits(g, y), e.exports = g, g.blockSize = 1024, g.outSize = 512, g.hmacStrength = 192, g.padLength = 128, g.prototype._prepareBlock = function (e, t) {
      for (var r = this.W, n = 0; n < 32; n++) {
        r[n] = e[t + n];
      }

      for (; n < r.length; n += 2) {
        var i = B(r[n - 4], r[n - 3]),
            o = R(r[n - 4], r[n - 3]),
            a = r[n - 14],
            s = r[n - 13],
            f = I(r[n - 30], r[n - 29]),
            c = j(r[n - 30], r[n - 29]),
            u = r[n - 32],
            d = r[n - 31];
        r[n] = l(i, o, a, s, f, c, u, d), r[n + 1] = p(i, o, a, s, f, c, u, d);
      }
    }, g.prototype._update = function (e, t) {
      this._prepareBlock(e, t);

      var r = this.W,
          n = this.h[0],
          i = this.h[1],
          a = this.h[2],
          s = this.h[3],
          f = this.h[4],
          c = this.h[5],
          l = this.h[6],
          p = this.h[7],
          y = this.h[8],
          v = this.h[9],
          g = this.h[10],
          I = this.h[11],
          j = this.h[12],
          B = this.h[13],
          R = this.h[14],
          P = this.h[15];
      o(this.k.length === r.length);

      for (var T = 0; T < r.length; T += 2) {
        var L = R,
            C = P,
            O = M(y, v),
            N = x(y, v),
            U = _(y, v, g, I, j),
            D = w(y, v, g, I, j, B),
            q = this.k[T],
            z = this.k[T + 1],
            F = r[T],
            Y = r[T + 1],
            K = b(L, C, O, N, U, D, q, z, F, Y),
            V = m(L, C, O, N, U, D, q, z, F, Y);

        L = A(n, i), C = S(n, i), O = k(n, i, a, s, f), N = E(n, i, a, s, f, c);
        var H = d(L, C, O, N),
            W = h(L, C, O, N);
        R = j, P = B, j = g, B = I, g = y, I = v, y = d(l, p, K, V), v = h(p, p, K, V), l = f, p = c, f = a, c = s, a = n, s = i, n = d(K, V, H, W), i = h(K, V, H, W);
      }

      u(this.h, 0, n, i), u(this.h, 2, a, s), u(this.h, 4, f, c), u(this.h, 6, l, p), u(this.h, 8, y, v), u(this.h, 10, g, I), u(this.h, 12, j, B), u(this.h, 14, R, P);
    }, g.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (e, t, r) {
    var n = r(0),
        i = r(19).Reporter,
        o = r(2).Buffer;

    function a(e, t) {
      i.call(this, t), o.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
    }

    function s(e, t) {
      if (Array.isArray(e)) this.length = 0, this.value = e.map(function (e) {
        return e instanceof s || (e = new s(e, t)), this.length += e.length, e;
      }, this);else if ("number" == typeof e) {
        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
        this.value = e, this.length = 1;
      } else if ("string" == typeof e) this.value = e, this.length = o.byteLength(e);else {
        if (!o.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
        this.value = e, this.length = e.length;
      }
    }

    n(a, i), t.DecoderBuffer = a, a.prototype.save = function () {
      return {
        offset: this.offset,
        reporter: i.prototype.save.call(this)
      };
    }, a.prototype.restore = function (e) {
      var t = new a(this.base);
      return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
    }, a.prototype.isEmpty = function () {
      return this.offset === this.length;
    }, a.prototype.readUInt8 = function (e) {
      return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
    }, a.prototype.skip = function (e, t) {
      if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
      var r = new a(this.base);
      return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
    }, a.prototype.raw = function (e) {
      return this.base.slice(e ? e.offset : this.offset, this.length);
    }, t.EncoderBuffer = s, s.prototype.join = function (e, t) {
      return e || (e = new o(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function (r) {
        r.join(e, t), t += r.length;
      }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : o.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
    };
  }, function (e, t, r) {
    var n = t;
    n._reverse = function (e) {
      var t = {};
      return Object.keys(e).forEach(function (r) {
        (0 | r) == r && (r |= 0);
        var n = e[r];
        t[n] = r;
      }), t;
    }, n.der = r(162);
  }, function (e, t, r) {
    var n = r(0),
        i = r(18),
        o = i.base,
        a = i.bignum,
        s = i.constants.der;

    function f(e) {
      this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c(), this.tree._init(e.body);
    }

    function c(e) {
      o.Node.call(this, "der", e);
    }

    function u(e, t) {
      var r = e.readUInt8(t);
      if (e.isError(r)) return r;
      var n = s.tagClass[r >> 6],
          i = 0 == (32 & r);

      if (31 == (31 & r)) {
        var o = r;

        for (r = 0; 128 == (128 & o);) {
          if (o = e.readUInt8(t), e.isError(o)) return o;
          r <<= 7, r |= 127 & o;
        }
      } else r &= 31;

      return {
        cls: n,
        primitive: i,
        tag: r,
        tagStr: s.tag[r]
      };
    }

    function d(e, t, r) {
      var n = e.readUInt8(r);
      if (e.isError(n)) return n;
      if (!t && 128 === n) return null;
      if (0 == (128 & n)) return n;
      var i = 127 & n;
      if (i > 4) return e.error("length octect is too long");
      n = 0;

      for (var o = 0; o < i; o++) {
        n <<= 8;
        var a = e.readUInt8(r);
        if (e.isError(a)) return a;
        n |= a;
      }

      return n;
    }

    e.exports = f, f.prototype.decode = function (e, t) {
      return e instanceof o.DecoderBuffer || (e = new o.DecoderBuffer(e, t)), this.tree._decode(e, t);
    }, n(c, o.Node), c.prototype._peekTag = function (e, t, r) {
      if (e.isEmpty()) return !1;
      var n = e.save(),
          i = u(e, 'Failed to peek tag: "' + t + '"');
      return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
    }, c.prototype._decodeTag = function (e, t, r) {
      var n = u(e, 'Failed to decode tag of "' + t + '"');
      if (e.isError(n)) return n;
      var i = d(e, n.primitive, 'Failed to get length of "' + t + '"');
      if (e.isError(i)) return i;
      if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
      if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');

      var o = e.save(),
          a = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');

      return e.isError(a) ? a : (i = e.offset - o.offset, e.restore(o), e.skip(i, 'Failed to match body of: "' + t + '"'));
    }, c.prototype._skipUntilEnd = function (e, t) {
      for (;;) {
        var r = u(e, t);
        if (e.isError(r)) return r;
        var n,
            i = d(e, r.primitive, t);
        if (e.isError(i)) return i;
        if (n = r.primitive || null !== i ? e.skip(i) : this._skipUntilEnd(e, t), e.isError(n)) return n;
        if ("end" === r.tagStr) break;
      }
    }, c.prototype._decodeList = function (e, t, r, n) {
      for (var i = []; !e.isEmpty();) {
        var o = this._peekTag(e, "end");

        if (e.isError(o)) return o;
        var a = r.decode(e, "der", n);
        if (e.isError(a) && o) break;
        i.push(a);
      }

      return i;
    }, c.prototype._decodeStr = function (e, t) {
      if ("bitstr" === t) {
        var r = e.readUInt8();
        return e.isError(r) ? r : {
          unused: r,
          data: e.raw()
        };
      }

      if ("bmpstr" === t) {
        var n = e.raw();
        if (n.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");

        for (var i = "", o = 0; o < n.length / 2; o++) {
          i += String.fromCharCode(n.readUInt16BE(2 * o));
        }

        return i;
      }

      if ("numstr" === t) {
        var a = e.raw().toString("ascii");
        return this._isNumstr(a) ? a : e.error("Decoding of string type: numstr unsupported characters");
      }

      if ("octstr" === t) return e.raw();
      if ("objDesc" === t) return e.raw();

      if ("printstr" === t) {
        var s = e.raw().toString("ascii");
        return this._isPrintstr(s) ? s : e.error("Decoding of string type: printstr unsupported characters");
      }

      return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
    }, c.prototype._decodeObjid = function (e, t, r) {
      for (var n, i = [], o = 0; !e.isEmpty();) {
        var a = e.readUInt8();
        o <<= 7, o |= 127 & a, 0 == (128 & a) && (i.push(o), o = 0);
      }

      128 & a && i.push(o);
      var s = i[0] / 40 | 0,
          f = i[0] % 40;

      if (n = r ? i : [s, f].concat(i.slice(1)), t) {
        var c = t[n.join(" ")];
        void 0 === c && (c = t[n.join(".")]), void 0 !== c && (n = c);
      }

      return n;
    }, c.prototype._decodeTime = function (e, t) {
      var r = e.raw().toString();
      if ("gentime" === t) var n = 0 | r.slice(0, 4),
          i = 0 | r.slice(4, 6),
          o = 0 | r.slice(6, 8),
          a = 0 | r.slice(8, 10),
          s = 0 | r.slice(10, 12),
          f = 0 | r.slice(12, 14);else {
        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), o = 0 | r.slice(4, 6), a = 0 | r.slice(6, 8), s = 0 | r.slice(8, 10), f = 0 | r.slice(10, 12);
        n = n < 70 ? 2e3 + n : 1900 + n;
      }
      return Date.UTC(n, i - 1, o, a, s, f, 0);
    }, c.prototype._decodeNull = function (e) {
      return null;
    }, c.prototype._decodeBool = function (e) {
      var t = e.readUInt8();
      return e.isError(t) ? t : 0 !== t;
    }, c.prototype._decodeInt = function (e, t) {
      var r = e.raw(),
          n = new a(r);
      return t && (n = t[n.toString(10)] || n), n;
    }, c.prototype._use = function (e, t) {
      return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
    };
  }, function (e, t, r) {
    var n = r(0),
        i = r(2).Buffer,
        o = r(18),
        a = o.base,
        s = o.constants.der;

    function f(e) {
      this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c(), this.tree._init(e.body);
    }

    function c(e) {
      a.Node.call(this, "der", e);
    }

    function u(e) {
      return e < 10 ? "0" + e : e;
    }

    e.exports = f, f.prototype.encode = function (e, t) {
      return this.tree._encode(e, t).join();
    }, n(c, a.Node), c.prototype._encodeComposite = function (e, t, r, n) {
      var o,
          a = function (e, t, r, n) {
        var i;
        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
        if (s.tagByName.hasOwnProperty(e)) i = s.tagByName[e];else {
          if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
          i = e;
        }
        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
        t || (i |= 32);
        return i |= s.tagClassByName[r || "universal"] << 6;
      }(e, t, r, this.reporter);

      if (n.length < 128) return (o = new i(2))[0] = a, o[1] = n.length, this._createEncoderBuffer([o, n]);

      for (var f = 1, c = n.length; c >= 256; c >>= 8) {
        f++;
      }

      (o = new i(2 + f))[0] = a, o[1] = 128 | f;
      c = 1 + f;

      for (var u = n.length; u > 0; c--, u >>= 8) {
        o[c] = 255 & u;
      }

      return this._createEncoderBuffer([o, n]);
    }, c.prototype._encodeStr = function (e, t) {
      if ("bitstr" === t) return this._createEncoderBuffer([0 | e.unused, e.data]);

      if ("bmpstr" === t) {
        for (var r = new i(2 * e.length), n = 0; n < e.length; n++) {
          r.writeUInt16BE(e.charCodeAt(n), 2 * n);
        }

        return this._createEncoderBuffer(r);
      }

      return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
    }, c.prototype._encodeObjid = function (e, t, r) {
      if ("string" == typeof e) {
        if (!t) return this.reporter.error("string objid given, but no values map found");
        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
        e = t[e].split(/[\s\.]+/g);

        for (var n = 0; n < e.length; n++) {
          e[n] |= 0;
        }
      } else if (Array.isArray(e)) {
        e = e.slice();

        for (n = 0; n < e.length; n++) {
          e[n] |= 0;
        }
      }

      if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));

      if (!r) {
        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        e.splice(0, 2, 40 * e[0] + e[1]);
      }

      var o = 0;

      for (n = 0; n < e.length; n++) {
        var a = e[n];

        for (o++; a >= 128; a >>= 7) {
          o++;
        }
      }

      var s = new i(o),
          f = s.length - 1;

      for (n = e.length - 1; n >= 0; n--) {
        a = e[n];

        for (s[f--] = 127 & a; (a >>= 7) > 0;) {
          s[f--] = 128 | 127 & a;
        }
      }

      return this._createEncoderBuffer(s);
    }, c.prototype._encodeTime = function (e, t) {
      var r,
          n = new Date(e);
      return "gentime" === t ? r = [u(n.getFullYear()), u(n.getUTCMonth() + 1), u(n.getUTCDate()), u(n.getUTCHours()), u(n.getUTCMinutes()), u(n.getUTCSeconds()), "Z"].join("") : "utctime" === t ? r = [u(n.getFullYear() % 100), u(n.getUTCMonth() + 1), u(n.getUTCDate()), u(n.getUTCHours()), u(n.getUTCMinutes()), u(n.getUTCSeconds()), "Z"].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
    }, c.prototype._encodeNull = function () {
      return this._createEncoderBuffer("");
    }, c.prototype._encodeInt = function (e, t) {
      if ("string" == typeof e) {
        if (!t) return this.reporter.error("String int or enum given, but no values map");
        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
        e = t[e];
      }

      if ("number" != typeof e && !i.isBuffer(e)) {
        var r = e.toArray();
        !e.sign && 128 & r[0] && r.unshift(0), e = new i(r);
      }

      if (i.isBuffer(e)) {
        var n = e.length;
        0 === e.length && n++;
        var o = new i(n);
        return e.copy(o), 0 === e.length && (o[0] = 0), this._createEncoderBuffer(o);
      }

      if (e < 128) return this._createEncoderBuffer(e);
      if (e < 256) return this._createEncoderBuffer([0, e]);
      n = 1;

      for (var a = e; a >= 256; a >>= 8) {
        n++;
      }

      for (a = (o = new Array(n)).length - 1; a >= 0; a--) {
        o[a] = 255 & e, e >>= 8;
      }

      return 128 & o[0] && o.unshift(0), this._createEncoderBuffer(new i(o));
    }, c.prototype._encodeBool = function (e) {
      return this._createEncoderBuffer(e ? 255 : 0);
    }, c.prototype._use = function (e, t) {
      return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
    }, c.prototype._skipDefault = function (e, t, r) {
      var n,
          i = this._baseState;
      if (null === i.default) return !1;
      var o = e.join();
      if (void 0 === i.defaultBuffer && (i.defaultBuffer = this._encodeValue(i.default, t, r).join()), o.length !== i.defaultBuffer.length) return !1;

      for (n = 0; n < o.length; n++) {
        if (o[n] !== i.defaultBuffer[n]) return !1;
      }

      return !0;
    };
  }, function (e) {
    e.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');
  }, function (e, t, r) {
    var n = r(14),
        i = r(1).Buffer;

    function o(e) {
      var t = i.allocUnsafe(4);
      return t.writeUInt32BE(e, 0), t;
    }

    e.exports = function (e, t) {
      for (var r, a = i.alloc(0), s = 0; a.length < t;) {
        r = o(s++), a = i.concat([a, n("sha1").update(e).update(r).digest()]);
      }

      return a.slice(0, t);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = e.length, n = -1; ++n < r;) {
        e[n] ^= t[n];
      }

      return e;
    };
  }, function (e, t, r) {
    var n = r(3),
        i = r(1).Buffer;

    e.exports = function (e, t) {
      return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
    };
  }, function (e, t, r) {
    (function (t) {
      function n(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function i(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      function o(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var a = r(26),
          s = a.encodeTX,
          f = a.tryJsonStringify,
          c = r(10).codec,
          u = function () {
        function e(t, r, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.endpoint = t, this.options = Object.assign({}, n || {}, r || {});
        }

        var r, a, u;
        return r = e, (a = [{
          key: "sanitizeParams",
          value: function value(e) {
            return e = e || {}, Object.keys(e).forEach(function (t) {
              var r = e[t];
              "number" == typeof r && (e[t] = String(r));
            }), e;
          }
        }, {
          key: "_call",
          value: function value(e, t) {
            throw new Error("BaseProvider._call is not implemented.");
          }
        }, {
          key: "call",
          value: function value(e, t) {
            return this._call(e, t).then(function (e) {
              if (e.error) {
                var t = new Error(e.error.data || e.error.message);
                throw t.error = e.error, t;
              }

              return e.id && (e.result.id = e.id), e.result;
            });
          }
        }, {
          key: "query",
          value: function value(e, r, o) {
            var a = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? n(Object(r), !0).forEach(function (t) {
                  i(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }

              return e;
            }({
              path: e
            }, o);

            return r && (a.data = s(r, "hex")), this.call("abci_query", a).then(function (e) {
              var n = e.response;

              if (n.code) {
                var i = new Error(f(n.info && n.info.message || n.info || n.log || r));
                throw i.code = n.code, i.info = n.info, i.log = n.log, i;
              }

              return c.decode(t.from(n.value, "base64"));
            });
          }
        }, {
          key: "send",
          value: function value(e, t) {
            return this.call(e, {
              tx: s(t, "base64")
            }).then(function (e) {
              if (e.code || e.check_tx && e.check_tx.code || e.deliver_tx && e.deliver_tx.code) {
                var t = e.log || e.check_tx && e.check_tx.log || e.deliver_tx && e.deliver_tx.log;
                throw Object.assign(new Error(t), e);
              }

              return e;
            });
          }
        }]) && o(r.prototype, a), u && o(r, u), e;
      }();

      e.exports = u;
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    var n = r(184),
        _r3 = r(185),
        i = _r3.isPromise,
        o = _r3.createErrorType,
        a = _r3.tryCall;

    var s =
    /*#__PURE__*/
    function () {
      "use strict";

      function s(e) {
        _classCallCheck(this, s);

        this._options = Object.assign({}, n, e), this._resolve = null, this._reject = null, this._isPending = !1, this._isFulfilled = !1, this._isRejected = !1, this._value = void 0, this._promise = null, this._timer = null;
      }

      _createClass(s, [{
        key: "call",
        value: function call(e) {
          return this._isPending || (this.reset(), this._createPromise(), this._createTimer(), this._callFn(e)), this._promise;
        }
      }, {
        key: "resolve",
        value: function resolve(e) {
          this._isPending && (i(e) ? this._tryAttachToPromise(e) : (this._settle(e), this._isFulfilled = !0, this._resolve(e)));
        }
      }, {
        key: "reject",
        value: function reject(e) {
          this._isPending && (this._settle(e), this._isRejected = !0, this._reject(e));
        }
      }, {
        key: "reset",
        value: function reset() {
          if (this._isPending) {
            var _e2 = a(this._options.resetReason),
                _t2 = new s.ResetError(_e2);

            this.reject(_t2);
          }

          this._promise = null, this._isPending = !1, this._isFulfilled = !1, this._isRejected = !1, this._value = void 0, this._clearTimer();
        }
      }, {
        key: "configure",
        value: function configure(e) {
          Object.assign(this._options, e);
        }
      }, {
        key: "_createPromise",
        value: function _createPromise() {
          var _this = this;

          this._promise = new Promise(function (e, t) {
            _this._isPending = !0, _this._resolve = e, _this._reject = t;
          });
        }
      }, {
        key: "_handleTimeout",
        value: function _handleTimeout() {
          var e = a(this._options.timeoutReason),
              t = "string" == typeof e ? e.replace("{timeout}", this._options.timeout) : "",
              r = new s.TimeoutError(t);
          this.reject(r);
        }
      }, {
        key: "_createTimer",
        value: function _createTimer() {
          var _this2 = this;

          this._options.timeout && (this._timer = setTimeout(function () {
            return _this2._handleTimeout();
          }, this._options.timeout));
        }
      }, {
        key: "_clearTimer",
        value: function _clearTimer() {
          this._timer && (clearTimeout(this._timer), this._timer = null);
        }
      }, {
        key: "_settle",
        value: function _settle(e) {
          this._isPending = !1, this._value = e, this._clearTimer();
        }
      }, {
        key: "_callFn",
        value: function _callFn(e) {
          if ("function" == typeof e) try {
            var _t3 = e();

            this._tryAttachToPromise(_t3);
          } catch (e) {
            this.reject(e);
          }
        }
      }, {
        key: "_tryAttachToPromise",
        value: function _tryAttachToPromise(e) {
          var _this3 = this;

          i(e) && e.then(function (e) {
            return _this3.resolve(e);
          }, function (e) {
            return _this3.reject(e);
          });
        }
      }, {
        key: "promise",
        get: function get() {
          return this._promise;
        }
      }, {
        key: "value",
        get: function get() {
          return this._value;
        }
      }, {
        key: "isPending",
        get: function get() {
          return this._isPending;
        }
      }, {
        key: "isFulfilled",
        get: function get() {
          return this._isFulfilled;
        }
      }, {
        key: "isRejected",
        get: function get() {
          return this._isRejected;
        }
      }, {
        key: "isSettled",
        get: function get() {
          return this._isFulfilled || this._isRejected;
        }
      }]);

      return s;
    }();

    s.TimeoutError = o("TimeoutError"), s.ResetError = o("ResetError"), e.exports = s;
  }, function (e, t, r) {
    "use strict";

    var n = r(188);
    e.exports = Function.prototype.bind || n;
  }, function (e, t, r) {
    "use strict";

    var n = r(189),
        i = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
        o = Object.prototype.toString,
        a = Array.prototype.concat,
        s = Object.defineProperty,
        f = s && function () {
      var e = {};

      try {
        for (var t in s(e, "x", {
          enumerable: !1,
          value: e
        }), e) {
          return !1;
        }

        return e.x === e;
      } catch (e) {
        return !1;
      }
    }(),
        c = function c(e, t, r, n) {
      var i;
      t in e && ("function" != typeof (i = n) || "[object Function]" !== o.call(i) || !n()) || (f ? s(e, t, {
        configurable: !0,
        enumerable: !1,
        value: r,
        writable: !0
      }) : e[t] = r);
    },
        u = function u(e, t) {
      var r = arguments.length > 2 ? arguments[2] : {},
          o = n(t);
      i && (o = a.call(o, Object.getOwnPropertySymbols(t)));

      for (var s = 0; s < o.length; s += 1) {
        c(e, o[s], t[o[s]], r[o[s]]);
      }
    };

    u.supportsDescriptors = !!f, e.exports = u;
  }, function (e, t, r) {
    "use strict";

    var n = Object.prototype.toString;

    e.exports = function (e) {
      var t = n.call(e),
          r = "[object Arguments]" === t;
      return r || (r = "[object Array]" !== t && null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Function]" === n.call(e.callee)), r;
    };
  }, function (e, t, r) {
    "use strict";

    r(45)();

    var n = r(191),
        i = r(193),
        o = r(90),
        a = function a(e, t) {
      return new e(function (e) {
        e(t);
      });
    },
        s = Promise,
        f = function f(e) {
      if ("Object" !== o(this)) throw new TypeError("receiver is not an Object");
      var t = i(this, s),
          r = e,
          f = e;
      return n(e) && (r = function (e, t) {
        return function (r) {
          var n = t();
          return a(e, n).then(function () {
            return r;
          });
        };
      }(t, e), f = function (e, t) {
        return function (r) {
          var n = t();
          return a(e, n).then(function () {
            throw r;
          });
        };
      }(t, e)), this.then(r, f);
    };

    if (Object.getOwnPropertyDescriptor) {
      var c = Object.getOwnPropertyDescriptor(f, "name");
      c && c.configurable && Object.defineProperty(f, "name", {
        configurable: !0,
        value: "finally"
      });
    }

    e.exports = f;
  }, function (e, t, r) {
    "use strict";

    var n = r(198);

    e.exports = function (e) {
      return "symbol" == typeof e ? "Symbol" : n(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(45),
        i = r(89);

    e.exports = function () {
      return n(), "function" == typeof Promise.prototype.finally ? Promise.prototype.finally : i;
    };
  }, function (e, t, r) {
    (function (e) {
      function n() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }

      function i(e, t, r) {
        return (i = n() ? Reflect.construct : function (e, t, r) {
          var n = [null];
          n.push.apply(n, t);
          var i = new (Function.bind.apply(e, n))();
          return r && o(i, r.prototype), i;
        }).apply(null, arguments);
      }

      function o(e, t) {
        return (o = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function a(e) {
        return function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, r = new Array(e.length); t < e.length; t++) {
              r[t] = e[t];
            }

            return r;
          }
        }(e) || function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }

      function s(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function f(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? s(Object(r), !0).forEach(function (t) {
            c(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      function c(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      function u(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var d = r(10),
          h = d.utils,
          l = d.TxOp,
          p = d.ContractMode,
          b = r(26),
          m = b.switchEncoding,
          y = b.decodeTxContent,
          v = b.decodeTxEvents,
          g = b.decodeTxResult,
          _ = b.decodeTxReturnValue,
          w = b.removeItem,
          k = b.escapeQueryValue,
          E = b.isRegularAccount,
          A = b.isBankAccount,
          S = r(95),
          M = r(96),
          x = r(179),
          I = r(181),
          j = h.signTransaction;

      function B(_x, _x2, _x3) {
        return _B.apply(this, arguments);
      }

      function _B() {
        _B = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6(e, t, r) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!(!t.evidence || !t.evidence.length)) {
                    _context6.next = 2;
                    break;
                  }

                  throw new Error("Transaction was not signed yet.");

                case 2:
                  return _context6.abrupt("return", e.send(r, t).then(g));

                case 3:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));
        return _B.apply(this, arguments);
      }

      function R(e, t, r) {
        return r = function (e, t) {
          if (!t) return e.from;
          if ("string" == typeof t || Array.isArray(t)) return t;
          return t.signers || t.from || e.from;
        }(e, r), Array.isArray(r) || (r = [r]), r.forEach(function (r) {
          var n = t.getPrivateKeyByAddress(r);
          if (!n) throw new Error("Not found private key to sign for signer: " + r);
          e = j(e, n);
        }), e;
      }

      t.utils = {
        decodeTxContent: y,
        decodeTxReturnValue: _,
        decodeTxEvents: v,
        decodeTxResult: g,
        isRegularAccount: E,
        isBankAccount: A
      }, t.IceteaWeb3 = function () {
        function r(e, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), this.isWebSocket = !(!e.startsWith("ws://") && !e.startsWith("wss://")), this.isWebSocket ? this.rpc = new I(e, n) : this.rpc = new x(e, n), this._wssub = {}, this.wallet = new M(), this.utils = t.utils;
        }

        var n, o, s;
        return n = r, (o = [{
          key: "close",
          value: function value() {
            this.isWebSocket && this.rpc.close();
          }
        }, {
          key: "rpcCall",
          value: function value(e, t) {
            return this.rpc.call(e, t);
          }
        }, {
          key: "getBlockHeaders",
          value: function value(e) {
            return this.rpc.call("blockchain", e);
          }
        }, {
          key: "getBlockchainStatus",
          value: function value() {
            return this.rpc.call("status");
          }
        }, {
          key: "countUnconfirmedTxs",
          value: function value() {
            return this.rpc.call("num_unconfirmed_txs");
          }
        }, {
          key: "getUnconfimedTxs",
          value: function value() {
            return this.rpc.call("unconfirmed_txs");
          }
        }, {
          key: "getValidators",
          value: function value(e) {
            return this.rpc.query("validators", void 0, e);
          }
        }, {
          key: "getBalance",
          value: function value(e) {
            return this.rpc.query("balance", e);
          }
        }, {
          key: "getBlock",
          value: function value(e) {
            return this.rpc.call("block", e);
          }
        }, {
          key: "getBlocks",
          value: function value(e) {
            return this.rpc.call("blockchain", e);
          }
        }, {
          key: "getTransaction",
          value: function () {
            var _value = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(e, t) {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (e) {
                        _context.next = 2;
                        break;
                      }

                      throw new Error("hash is required");

                    case 2:
                      return _context.abrupt("return", this.rpc.call("tx", f({
                        hash: m(e, "hex", "base64")
                      }, t)).then(g));

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

            function value(_x4, _x5) {
              return _value.apply(this, arguments);
            }

            return value;
          }()
        }, {
          key: "searchTransactions",
          value: function () {
            var _value2 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2(e, t, r) {
              var n;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (e) {
                        _context2.next = 2;
                        break;
                      }

                      throw new Error('query is required, example "tx.height>0"');

                    case 2:
                      n = this.rpc.call("tx_search", f({
                        query: e
                      }, t));
                      return _context2.abrupt("return", r ? n : n.then(function (e) {
                        return e.txs = e.txs.map(g), e;
                      }));

                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));

            function value(_x6, _x7, _x8) {
              return _value2.apply(this, arguments);
            }

            return value;
          }()
        }, {
          key: "getContractEvents",
          value: function () {
            var _value3 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee3(e, t, r, n) {
              var i, o, a, s, f, c;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!(r = r || {}, !e)) {
                        _context3.next = 2;
                        break;
                      }

                      throw new Error("getPastEvents: contract address is required");

                    case 2:
                      if (t) {
                        _context3.next = 4;
                        break;
                      }

                      throw new Error("getPastEvents: eventName is required");

                    case 4:
                      i = "".concat(e, ".").concat("_ev"), o = ["*", "allEvents"].includes(t), a = o ? ["".concat(i, " CONTAINS ''")] : ["".concat(i, "=").concat(k(t))];
                      r.fromBlock && a.push("tx.height>".concat(+r.fromBlock - 1)), r.toBlock && a.push("tx.height<".concat(+r.toBlock + 1)), r.atBlock && a.push("tx.height=".concat(r.atBlock));
                      s = r.filter || {};
                      Object.keys(s).forEach(function (t) {
                        var r = k(s[t]);
                        a.push("".concat(e, ".").concat(t, "=").concat(r));
                      });
                      f = r.rawFilter;
                      f && (f.forEach ? f.forEach(function (t) {
                        t.startsWith(e + ".") || (t = e + "." + t), a.push(t);
                      }) : a.push(f));
                      c = a.join(" AND ");
                      return _context3.abrupt("return", this.searchTransactions(c, n, !1).then(function (r) {
                        return r.txs.reduce(function (r, n) {
                          var i = n.events.filter(function (r) {
                            return r.emitter === e && (o || r.eventName === t);
                          }).map(function (e) {
                            return e.tx = n, e;
                          });
                          return r.concat(i);
                        }, []);
                      }));

                    case 12:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));

            function value(_x9, _x10, _x11, _x12) {
              return _value3.apply(this, arguments);
            }

            return value;
          }()
        }, {
          key: "getContracts",
          value: function value(e) {
            return this.rpc.query("contracts", e);
          }
        }, {
          key: "getMetadata",
          value: function value(e) {
            return this.rpc.query("metadata", e);
          }
        }, {
          key: "getAccountInfo",
          value: function value(e) {
            return this.rpc.query("account_info", e);
          }
        }, {
          key: "getContractSource",
          value: function value(e) {
            return this.rpc.query("contract_src", e);
          }
        }, {
          key: "getDebugState",
          value: function value() {
            return this.rpc.query("state");
          }
        }, {
          key: "sendTransaction",
          value: function value(e, t, r) {
            return r = r || t && t.sendMode || "commit", function (e, t, r, n, i) {
              return B(e, R(t, n, i), r);
            }(this.rpc, e, "broadcast_tx_" + r, this.wallet, t);
          }
        }, {
          key: "sendTransactionAsync",
          value: function value(e, t) {
            return this.sendTransaction(e, t, "async");
          }
        }, {
          key: "sendTransactionSync",
          value: function value(e, t) {
            return this.sendTransaction(e, t, "sync");
          }
        }, {
          key: "sendTransactionCommit",
          value: function value(e, t) {
            return this.sendTransaction(e, t, "commit");
          }
        }, {
          key: "signTransaction",
          value: function value(e, t) {
            return R(e, this.wallet, t);
          }
        }, {
          key: "sendRawTransaction",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "commit";
            return B(this.rpc, e, "broadcast_tx_" + t);
          }
        }, {
          key: "callReadonlyContractMethod",
          value: function value(e, t) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
                n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            return this.rpc.query("invokeView", {
              address: e,
              name: t,
              params: r,
              options: n
            });
          }
        }, {
          key: "callPureContractMethod",
          value: function value(e, t) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
                n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            return this.rpc.query("invokePure", {
              address: e,
              name: t,
              params: r,
              options: n
            });
          }
        }, {
          key: "ensureAddress",
          value: function value(e) {
            return this.callReadonlyContractMethod("system.alias", "resolve", [e]).then(function (t) {
              return t || e;
            });
          }
        }, {
          key: "subscribe",
          value: function () {
            var _value4 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee5(e) {
              var t,
                  r,
                  n,
                  i,
                  o,
                  s,
                  f,
                  c,
                  u,
                  _args5 = arguments;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      t = this, r = _args5.length > 1 && void 0 !== _args5[1] ? _args5[1] : {}, n = _args5.length > 2 ? _args5[2] : void 0;

                      if (this.isWebSocket) {
                        _context5.next = 3;
                        break;
                      }

                      throw new Error("subscribe: supports WebSocketProvider only.");

                    case 3:
                      i = ["NewBlock", "NewBlockHeader", "Tx", "RoundState", "NewRound", "CompleteProposal", "Vote", "ValidatorSetUpdates", "ProposalString"];
                      e && !i.includes(e) && console.warn("Event ".concat(e, " is not one of known supported events: ").concat(i, "."));
                      o = "";
                      if ("string" == typeof r) o = r;else {
                        "function" == typeof r && void 0 === n && (n = r, r = {});
                        s = ["tm.event=".concat(k(e))];
                        r.fromBlock && s.push("tx.height>".concat(+r.fromBlock - 1)), r.toBlock && s.push("tx.height<".concat(+r.toBlock + 1)), r.atBlock && s.push("tx.height=".concat(r.atBlock));
                        f = r.filter || {};
                        Object.keys(f).forEach(function (e) {
                          var t = k(f[e]);
                          s.push("".concat(e, "=").concat(t));
                        });
                        c = "string" == typeof r.rawFilter ? [r.rawFilter] : r.rawFilter;
                        c && s.push.apply(s, a(c)), o = s.join(" AND ");
                      }

                      u =
                      /*#__PURE__*/
                      function () {
                        var _ref = _asyncToGenerator(
                        /*#__PURE__*/
                        _regeneratorRuntime.mark(function _callee4() {
                          var e;
                          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  e = t._wssub[o];

                                  if (!(e && (w(e.callbacks, n), !(e.callbacks.length > 0)))) {
                                    _context4.next = 3;
                                    break;
                                  }

                                  return _context4.abrupt("return", t.rpc.call("unsubscribe", {
                                    query: o
                                  }).then(function (e) {
                                    return delete t._wssub[o], e;
                                  }));

                                case 3:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4);
                        }));

                        return function u() {
                          return _ref.apply(this, arguments);
                        };
                      }();

                      return _context5.abrupt("return", this._wssub[o] ? (this._wssub[o].callbacks.push(n), {
                        unsubscribe: u
                      }) : this.rpc.call("subscribe", {
                        query: o
                      }).then(function (e) {
                        return t._wssub[o] = {
                          id: e.id,
                          query: o,
                          callbacks: [n]
                        }, t._wshandler = t._wshandler || {}, t._wshandler.onmessage || (t._wshandler.onmessage = function (e) {
                          Object.values(t._wssub).forEach(function (t) {
                            var r = t.id,
                                n = t.callbacks;

                            if (e.id === r) {
                              var i = e.error,
                                  o = e.result;

                              if (o && o.data && "tendermint/event/Tx" === o.data.type) {
                                var a = o.data.value.TxResult;
                                !a.tx_result && a.result && (a.tx_result = a.result), o.data.value.TxResult = g(a);
                              }

                              n.forEach(function (e) {
                                return e(i, o);
                              });
                            }
                          });
                        }, t.rpc.registerEventListener("onResponse", t._wshandler.onmessage)), {
                          unsubscribe: u
                        };
                      }).catch(n));

                    case 9:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, this);
            }));

            function value(_x13) {
              return _value4.apply(this, arguments);
            }

            return value;
          }()
        }, {
          key: "unsubscribeAll",
          value: function value() {
            return this.rpc.call("/unsubscribe_all");
          }
        }, {
          key: "clearSubscriptions",
          value: function value() {
            return this.unsubscribeAll();
          }
        }, {
          key: "registerEventListener",
          value: function value(e, t) {
            if (!this.isWebSocket) throw new Error("registerEventListener is for WebSocketProvider only.");
            this.rpc.registerEventListener(e, t);
          }
        }, {
          key: "onError",
          value: function value(e) {
            if (!this.isWebSocket) throw new Error("onError is for WebSocketProvider only");
            this.rpc.registerEventListener("onError", e);
          }
        }, {
          key: "onClose",
          value: function value(e) {
            if (!this.isWebSocket) throw new Error("onClose is for WebSocketProvider only");
            this.rpc.registerEventListener("onClose", e);
          }
        }, {
          key: "contract",
          value: function value() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return i(S, [this].concat(t));
          }
        }, {
          key: "deploy",
          value: function value(t, r) {
            var n = this;
            "string" == typeof t && (t = {
              data: t
            });

            var i = function (t, r) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
                  i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                  o = {};
              null == t || "js" === t ? t = p.JS_RAW : "wasm" === t && (t = p.WASM);
              var a = {
                op: l.DEPLOY_CONTRACT,
                mode: t,
                params: n
              };
              if (t === p.JS_DECORATED || t === p.JS_RAW) a.src = m(r, "utf8", "base64");else {
                if (e.isBuffer(r)) r = e.toString("base64");else if ("string" != typeof r) throw Error("Wasm binary must be in form of Buffer or base64-encoded string.");
                a.src = r;
              }
              return o.from = i.from, o.payer = i.payer, o.value = i.value || 0, o.fee = i.fee || 0, o.data = a, o;
            }(t.mode, t.data, t.arguments, r);

            return this.sendTransaction(i, r).then(function (e) {
              return n.contract(e);
            });
          }
        }, {
          key: "transfer",
          value: function value(e, t, r) {
            var n = {
              from: (r = r || {}).from,
              to: e,
              value: t,
              fee: r.fee,
              payer: r.payer
            };
            return r.params && (n.data = {
              params: r.params
            }), this.sendTransaction(n, r);
          }
        }]) && u(n.prototype, o), s && u(n, s), r;
      }(), t.IceteaWeb3.utils = t.utils;
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    "use strict";

    t.byteLength = function (e) {
      var t = c(e),
          r = t[0],
          n = t[1];
      return 3 * (r + n) / 4 - n;
    }, t.toByteArray = function (e) {
      var t,
          r,
          n = c(e),
          a = n[0],
          s = n[1],
          f = new o(function (e, t, r) {
        return 3 * (t + r) / 4 - r;
      }(0, a, s)),
          u = 0,
          d = s > 0 ? a - 4 : a;

      for (r = 0; r < d; r += 4) {
        t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], f[u++] = t >> 16 & 255, f[u++] = t >> 8 & 255, f[u++] = 255 & t;
      }

      2 === s && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, f[u++] = 255 & t);
      1 === s && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, f[u++] = t >> 8 & 255, f[u++] = 255 & t);
      return f;
    }, t.fromByteArray = function (e) {
      for (var t, r = e.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
        o.push(u(e, a, a + 16383 > s ? s : a + 16383));
      }

      1 === i ? (t = e[r - 1], o.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], o.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
      return o.join("");
    };

    for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) {
      n[s] = a[s], i[a.charCodeAt(s)] = s;
    }

    function c(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = e.indexOf("=");
      return -1 === r && (r = t), [r, r === t ? 0 : 4 - r % 4];
    }

    function u(e, t, r) {
      for (var i, o, a = [], s = t; s < r; s += 3) {
        i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
      }

      return a.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (e, t) {
    t.read = function (e, t, r, n, i) {
      var o,
          a,
          s = 8 * i - n - 1,
          f = (1 << s) - 1,
          c = f >> 1,
          u = -7,
          d = r ? i - 1 : 0,
          h = r ? -1 : 1,
          l = e[t + d];

      for (d += h, o = l & (1 << -u) - 1, l >>= -u, u += s; u > 0; o = 256 * o + e[t + d], d += h, u -= 8) {
        ;
      }

      for (a = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; a = 256 * a + e[t + d], d += h, u -= 8) {
        ;
      }

      if (0 === o) o = 1 - c;else {
        if (o === f) return a ? NaN : 1 / 0 * (l ? -1 : 1);
        a += Math.pow(2, n), o -= c;
      }
      return (l ? -1 : 1) * a * Math.pow(2, o - n);
    }, t.write = function (e, t, r, n, i, o) {
      var a,
          s,
          f,
          c = 8 * o - i - 1,
          u = (1 << c) - 1,
          d = u >> 1,
          h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          l = n ? 0 : o - 1,
          p = n ? 1 : -1,
          b = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = u) : (a = Math.floor(Math.log(t) / Math.LN2), t * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (t += a + d >= 1 ? h / f : h * Math.pow(2, 1 - d)) * f >= 2 && (a++, f /= 2), a + d >= u ? (s = 0, a = u) : a + d >= 1 ? (s = (t * f - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[r + l] = 255 & s, l += p, s /= 256, i -= 8) {
        ;
      }

      for (a = a << i | s, c += i; c > 0; e[r + l] = 255 & a, l += p, a /= 256, c -= 8) {
        ;
      }

      e[r + l - p] |= 128 * b;
    };
  }, function (e, t, r) {
    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    var i = r(10),
        o = i.TxOp,
        a = i.ecc,
        s = r(26).escapeQueryValue;

    function f(e, t, r, n) {
      var i = n.contractAddr,
          a = n.method,
          s = n.params,
          f = Object.assign({}, e.options, t || {}),
          c = function (e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
            n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            i = {},
            a = {
          op: o.CALL_CONTRACT,
          name: t,
          params: r
        };
        return i.from = n.from || "", i.payer = n.payer || "", i.to = e, i.value = n.value || 0, i.fee = n.fee || 0, i.data = a, i;
      }(i, a, s, f);

      return e.web3.sendTransaction(c, f, r);
    }

    function c(_x14, _x15, _x16, _x17, _x18, _x19) {
      return _c.apply(this, arguments);
    }

    function _c() {
      _c = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(e, t, r, n, i, o) {
        var a, f, c, u, d;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (t.indexOf(".") >= 0 && 0 !== t.indexOf("system.")) {
                  _context7.next = 6;
                  break;
                }

                "function" == typeof n && void 0 === i ? i = n : a = Object.assign({}, n), (a = a || {}).rawFilter = "string" == typeof a.rawFilter ? [a.rawFilter] : a.rawFilter || [], a.rawFilter.map(function (e) {
                  var r = t + ".";
                  return e.startsWith(r) ? e : r + e;
                });
                f = ["allEvents", "*"].includes(r);
                f ? a.rawFilter.push("".concat(t, "._ev EXISTS")) : a.rawFilter.push("".concat(t, "._ev=").concat(s(r)));
                u = a.filter || {};
                return _context7.abrupt("return", (delete a.filter, Object.keys(u).forEach(function (e) {
                  var r = s(u[e]);
                  a.rawFilter.push("".concat(t, ".").concat(e, "=").concat(r));
                }), e.subscribe("Tx", a, function (e, n) {
                  if (e) return i(e), void (o && c && c.off && c.off());
                  var a = n.data.value.TxResult,
                      s = a.events,
                      u = !1;
                  s.forEach(function (e) {
                    if (e.emitter === t && (f || e.eventName === r)) {
                      if (o && u) return;
                      u = !0, i(void 0, e, a);
                    }
                  }), o && c && c.off && c.off();
                }).then(function (e) {
                  return c = {
                    off: e.unsubscribe
                  };
                })));

              case 6:
                d = new Error("To subscribe to event, you must resolve contract alias first.");
                i(d);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _c.apply(this, arguments);
    }

    e.exports = function e(t, r) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (n(this, e), !r) throw new Error("Contract address is required.");
      var o = this;
      this.web3 = t, this.options = i, "string" == typeof r ? this.address = r : (this.address = r.address || r.returnValue, this.hash = r.hash, this.height = r.height, this.deployTxResult = r), "system" !== this.address && this.address.indexOf(".") < 0 && a.validateAddress(this.address);
      var s = this.address;
      this.getBalance = function () {
        return t.getBalance(s);
      }, this.getMetadata = function (e) {
        return t.getMetadata(e);
      }, this.prepareMethod = function (e) {
        for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
          n[i - 1] = arguments[i];
        }

        return {
          call: function call() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return t.callReadonlyContractMethod(s, e, n, Object.assign({}, this.options, r));
          },
          callPure: function callPure() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return t.callPureContractMethod(s, e, n, Object.assign({}, this.options, r));
          },
          getMetadata: function getMetadata() {
            return t.getMetadata(n);
          },
          sendAsync: function sendAsync() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return f(o, t, "async", {
              contractAddr: s,
              method: e,
              params: n
            });
          },
          sendSync: function sendSync() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return f(o, t, "sync", {
              contractAddr: s,
              method: e,
              params: n
            });
          },
          sendCommit: function sendCommit() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return f(o, t, "commit", {
              contractAddr: s,
              method: e,
              params: n
            });
          },
          send: function send() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return f(o, t, void 0, {
              contractAddr: s,
              method: e,
              params: n
            });
          }
        };
      }, this.methods = new Proxy({}, {
        get: function get(e, t) {
          return function () {
            for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
              r[n] = arguments[n];
            }

            return o.prepareMethod.apply(o, [t].concat(r));
          };
        }
      }), this.on = function (e, r, n) {
        return c(t, s, e, r, n);
      }, this.once = function (e, r, n) {
        return c(t, s, e, r, n, !0);
      }, this.events = new Proxy({}, {
        get: function get(e, r) {
          return function (e, n) {
            return c(t, s, r, e, n);
          };
        }
      }), this.getPastEvents = function (e, r, n) {
        return t.getContractEvents(s, e, r, n);
      };
    };
  }, function (e, t, r) {
    (function (t) {
      function n(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var i = r(10).utils,
          o = i.newAccount,
          a = i.newBankAccount,
          s = i.newRegularAccount,
          f = i.getAccount,
          c = r(10).codec,
          u = r(97),
          d = {
        defaultAccount: "",
        accounts: []
      },
          h = {
        set wallet(e) {
          d = e;
        },

        get wallet() {
          return d;
        },

        set defaultAccount(e) {
          if (0 === !h.wallet.accounts.length) throw new Error("Please import account before set defaultAccount.");

          for (var t = !1, r = 0; r < h.wallet.accounts.length; r++) {
            if (h.wallet.accounts[r].address === e) {
              t = !0;
              break;
            }
          }

          if (!t) throw new Error("Address " + e + " doesn't exist in wallet.");
          h.wallet.defaultAccount = e;
        },

        get defaultAccount() {
          return h.wallet.defaultAccount ? h.wallet.defaultAccount : h.wallet.accounts.length > 0 ? (h.wallet.defaultAccount = h.wallet.accounts[0].address, h.wallet.defaultAccount) : void 0;
        },

        addAccount: function addAccount(e) {
          for (var t = !1, r = 0; r < h.wallet.accounts.length; r++) {
            var n = h.wallet.accounts[r].privateKey;

            if (n === e.privateKey || "function" == typeof n.equals && n.equals(e.privateKey)) {
              t = !0;
              break;
            }
          }

          t || h.wallet.accounts.push(e);
        },
        getAccounts: function getAccounts() {
          return h.wallet.accounts;
        }
      };

      var l = "undefined" != typeof localStorage ? localStorage : {
        _data: {},
        setItem: function setItem(e, t) {
          return this._data[e] = t;
        },
        getItem: function getItem(e) {
          return this._data[e];
        },
        removeItem: function removeItem(e) {
          return delete this._data[e];
        },
        clear: function clear() {
          return this._data = {};
        }
      },
          p = function p(e) {
        return Promise.resolve(l.setItem("_icetea_accounts", JSON.stringify(e)));
      },
          b = function b() {
        return Promise.resolve(l.getItem("_icetea_accounts")).then(function (e) {
          return e ? JSON.parse(e) : {
            defaultAccount: "",
            accounts: []
          };
        });
      },
          m = function m(e) {
        var t = {},
            r = u.create(),
            n = {
          defaultAccount: "",
          accounts: []
        };
        return h.wallet.accounts.forEach(function (i) {
          if (i.privateKey) {
            var o = c.toBuffer(i.privateKey),
                a = u.dump(e, o, r.salt, r.iv, t);
            n.accounts.push(a);
          }
        }), n.defaultAccount = h.wallet.defaultAccount, n;
      },
          y = function y(e, t, r) {
        r && !Array.isArray(r) && (r = [r]);
        var n = {
          defaultAccount: "",
          accounts: []
        };
        return n.defaultAccount = t.defaultAccount, t.accounts.forEach(function (t) {
          if (!r || r.includes(t.address)) {
            var i = t.privateKey || u.recover(e, t),
                o = t.signTransaction ? t : f(i);
            n.accounts.push(o);
          } else n.accounts.push(t);
        }), n;
      },
          v = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        var r, i, c;
        return r = e, (i = [{
          key: "createAccount",
          value: function value(e) {
            var t = o(e);
            return h.addAccount(t), t;
          }
        }, {
          key: "createBankAccount",
          value: function value() {
            var e = a();
            return h.addAccount(e), e;
          }
        }, {
          key: "createRegularAccount",
          value: function value() {
            var e = s();
            return h.addAccount(e), e;
          }
        }, {
          key: "importAccount",
          value: function value(e) {
            var r;
            if ("string" == typeof e || t.isBuffer(e)) r = f(e);else {
              if (!e || !e.privateKey || !t.isBuffer(e.privateKey)) throw new Error("Invalid account object. Account must have a privateKey buffer.");
              r = e;
            }
            return h.addAccount(r), r;
          }
        }, {
          key: "getAccountByPrivateKey",
          value: function value(e) {
            return f(e);
          }
        }, {
          key: "getPrivateKeyByAddress",
          value: function value(e) {
            e || (e = this.defaultAccount);
            var t = this.getAccountByAddress(e);
            if (t) return t.privateKey;
          }
        }, {
          key: "getAccountByAddress",
          value: function value(e) {
            for (var t = this.accounts, r = 0; r < t.length; r++) {
              if (t[r].address === e || t[r].publicKey === e) return t[r];
            }
          }
        }, {
          key: "saveToStorage",
          value: function value(e) {
            if (!e) throw Error("Password is required.");
            var t = m(e);
            return p(t), t.accounts.length;
          }
        }, {
          key: "loadFromStorage",
          value: function value(e, t, r) {
            return Promise.resolve(t || b()).then(function (t) {
              if (t && t.accounts.length > 0) {
                if (!e) throw Error("Password is required.");
                var n = y(e, t, r);
                h.wallet = n;
              }

              return h.wallet.accounts.length;
            });
          }
        }, {
          key: "setStorate",
          value: function value(e) {
            if (!e || "function" != typeof e.getItem || "function" != typeof e.setItem) throw new Error("Storage must be an object with getItem and setItem functions.");
            l = e;
          }
        }, {
          key: "defaultAccount",
          set: function set(e) {
            h.defaultAccount = e;
          },
          get: function get() {
            return h.defaultAccount;
          }
        }, {
          key: "accounts",
          get: function get() {
            return h.getAccounts();
          }
        }]) && n(r.prototype, i), c && n(r, c), e;
      }();

      e.exports = v;
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    "use strict";

    (function (t, n) {
      var i = void 0 === t || !t.nextTick || Boolean(t.browser),
          o = r(98),
          a = r(176),
          s = r(10).ecc;

      function f(e) {
        return "function" == typeof e;
      }

      e.exports = {
        browser: i,
        scrypt: null,
        crypto: r(20),
        constants: {
          cipher: "aes-128-ctr",
          ivBytes: 16,
          keyBytes: 32,
          pbkdf2: {
            c: 16384,
            dklen: 32,
            hash: "sha256",
            prf: "hmac-sha256"
          },
          scrypt: {
            memory: 28e7,
            dklen: 32,
            n: 16384,
            r: 8,
            p: 1
          }
        },
        isHex: function isHex(e) {
          return !(e.length % 2 != 0 || !e.match(/^[0-9a-f]+$/i));
        },
        isBase64: function isBase64(e) {
          var t;
          return !(e.length % 4 > 0 || e.match(/[^0-9a-z+\/=]/i)) && !(-1 !== (t = e.indexOf("=")) && !e.slice(t).match(/={1,2}/));
        },
        str2buf: function str2buf(e, t) {
          return e && e.constructor === String ? (!t && this.isHex(e) && (t = "hex"), !t && this.isBase64(e) && (t = "base64"), n.from(e, t)) : e;
        },
        isCipherAvailable: function isCipherAvailable(e) {
          return this.crypto.getCiphers().some(function (t) {
            return t === e;
          });
        },
        encrypt: function encrypt(e, t, r, i) {
          var o, a;
          if (i = i || this.constants.cipher, !this.isCipherAvailable(i)) throw new Error(i + " is not available");
          return a = (o = this.crypto.createCipheriv(i, this.str2buf(t), this.str2buf(r))).update(this.str2buf(e)), n.concat([a, o.final()]);
        },
        decrypt: function decrypt(e, t, r, i) {
          var o, a;
          if (i = i || this.constants.cipher, !this.isCipherAvailable(i)) throw new Error(i + " is not available");
          return a = (o = this.crypto.createDecipheriv(i, this.str2buf(t), this.str2buf(r))).update(this.str2buf(e)), n.concat([a, o.final()]);
        },
        privateKeyToAddress: function privateKeyToAddress(e) {
          return s.toPubKeyAndAddress(e).address;
        },
        getMAC: function getMAC(e, t) {
          if (null != e && null != t) return (r = this.crypto, i = n.concat([this.str2buf(e).slice(16, 32), this.str2buf(t)]), r.createHash("sha256").update(i).digest()).toString("hex");
          var r, i;
        },
        deriveKeyUsingScryptInNode: function deriveKeyUsingScryptInNode(e, t, n, i) {
          if (!f(i)) return this.deriveKeyUsingScryptInBrowser(e, t, n);
          var o = {
            N: n.kdfparams.n || this.constants.scrypt.n,
            r: n.kdfparams.r || this.constants.scrypt.r,
            p: n.kdfparams.p || this.constants.scrypt.p,
            maxmem: n.kdfparams.memory || this.constants.scrypt.memory
          };
          r(20).scrypt(e, t, n.kdfparams.dklen || this.constants.scrypt.dklen, o, function (e, t) {
            i(e || t);
          });
        },
        deriveKeyUsingScryptInBrowser: function deriveKeyUsingScryptInBrowser(e, t, i, o) {
          var a = this;
          if (null === this.scrypt && (this.scrypt = r(178)), f(this.scrypt) && (this.scrypt = this.scrypt(i.kdfparams.memory || this.constants.scrypt.memory)), !f(o)) return n.from(this.scrypt.to_hex(this.scrypt.crypto_scrypt(e, t, i.kdfparams.n || this.constants.scrypt.n, i.kdfparams.r || this.constants.scrypt.r, i.kdfparams.p || this.constants.scrypt.p, i.kdfparams.dklen || this.constants.scrypt.dklen)), "hex");
          setTimeout(function () {
            o(n.from(a.scrypt.to_hex(a.scrypt.crypto_scrypt(e, t, i.kdfparams.n || a.constants.scrypt.n, i.kdfparams.r || a.constants.scrypt.r, i.kdfparams.p || a.constants.scrypt.p, i.kdfparams.dklen || a.constants.scrypt.dklen)), "hex"));
          }, 0);
        },
        deriveKey: function deriveKey(e, t, r, i) {
          var a,
              s = this;
          if (null == e || !t) throw new Error("Must provide password and salt to derive a key");
          return (r = r || {}).kdfparams = r.kdfparams || {}, e = this.str2buf(e, "utf8"), t = this.str2buf(t), "scrypt" === r.kdf ? this.browser ? this.deriveKeyUsingScryptInBrowser(e, t, r, i) : this.deriveKeyUsingScryptInNode(e, t, r, i) : ("hmac-sha256" === (a = r.kdfparams.prf || this.constants.pbkdf2.prf) && (a = "sha256"), f(i) ? void (this.crypto.pbkdf2 ? this.crypto.pbkdf2(e, t, r.kdfparams.c || this.constants.pbkdf2.c, r.kdfparams.dklen || this.constants.pbkdf2.dklen, a, function (e, t) {
            if (e) return i(e);
            i(t);
          }) : setTimeout(function () {
            i(n.from(o.codec.hex.fromBits(o.misc.pbkdf2(e.toString("utf8"), o.codec.hex.toBits(t.toString("hex")), r.kdfparams.c || s.constants.pbkdf2.c, 8 * (r.kdfparams.dklen || s.constants.pbkdf2.dklen))), "hex"));
          }, 0)) : this.crypto.pbkdf2Sync ? this.crypto.pbkdf2Sync(e, t, r.kdfparams.c || this.constants.pbkdf2.c, r.kdfparams.dklen || this.constants.pbkdf2.dklen, a) : n.from(o.codec.hex.fromBits(o.misc.pbkdf2(e.toString("utf8"), o.codec.hex.toBits(t.toString("hex")), r.kdfparams.c || s.constants.pbkdf2.c, 8 * (r.kdfparams.dklen || s.constants.pbkdf2.dklen))), "hex"));
        },
        create: function create(e, t) {
          var r, n;

          function i(e) {
            return {
              iv: e.slice(0, n),
              salt: e.slice(n)
            };
          }

          if (r = (e = e || {}).keyBytes || this.constants.keyBytes, n = e.ivBytes || this.constants.ivBytes, !f(t)) return i(this.crypto.randomBytes(n + r));
          this.crypto.randomBytes(n + r, function (e, r) {
            if (e) return t(e);
            t(i(r));
          });
        },
        marshal: function marshal(e, t, r, n, i) {
          var o, s, f;
          return (i = i || {}).kdfparams = i.kdfparams || {}, f = i.cipher || this.constants.cipher, o = this.encrypt(t, e.slice(0, 16), n, f).toString("hex"), s = {
            address: i.noAddress ? "no address" : this.privateKeyToAddress(t),
            crypto: {
              cipher: i.cipher || this.constants.cipher,
              ciphertext: o,
              cipherparams: {
                iv: n.toString("hex")
              },
              mac: this.getMAC(e, o)
            },
            id: a.v4(),
            version: 1
          }, "scrypt" === i.kdf ? (s.crypto.kdf = "scrypt", s.crypto.kdfparams = {
            dklen: i.kdfparams.dklen || this.constants.scrypt.dklen,
            n: i.kdfparams.n || this.constants.scrypt.n,
            r: i.kdfparams.r || this.constants.scrypt.r,
            p: i.kdfparams.p || this.constants.scrypt.p,
            salt: r.toString("hex")
          }) : (s.crypto.kdf = "pbkdf2", s.crypto.kdfparams = {
            c: i.kdfparams.c || this.constants.pbkdf2.c,
            dklen: i.kdfparams.dklen || this.constants.pbkdf2.dklen,
            prf: i.kdfparams.prf || this.constants.pbkdf2.prf,
            salt: r.toString("hex")
          }), s;
        },
        dump: function dump(e, t, r, n, i, o) {
          if (i = i || {}, n = this.str2buf(n), t = this.str2buf(t), !f(o)) return this.marshal(this.deriveKey(e, r, i), t, r, n, i);
          this.deriveKey(e, r, i, function (e) {
            o(this.marshal(e, t, r, n, i));
          }.bind(this));
        },
        recover: function recover(e, t, r) {
          var n,
              i,
              o,
              a,
              s,
              c = this;

          function u(e, t, r, i, o) {
            var a;
            if (c.getMAC(e, i) !== n.mac) throw new Error("message authentication code mismatch");
            return a = e.slice(0, 16), c.decrypt(i, a, r, o);
          }

          if (n = t.Crypto || t.crypto, i = this.str2buf(n.cipherparams.iv), o = this.str2buf(n.kdfparams.salt), a = this.str2buf(n.ciphertext), s = n.cipher, "pbkdf2" === n.kdf && "hmac-sha256" !== n.kdfparams.prf) throw new Error("PBKDF2 only supported with HMAC-SHA256");
          if (!f(r)) return u(this.deriveKey(e, o, n), 0, i, a, s);
          this.deriveKey(e, o, n, function (e) {
            try {
              r(u(e, 0, i, a, s));
            } catch (e) {
              r(e);
            }
          });
        },
        generateKeystoreFilename: function generateKeystoreFilename(e) {
          var r = "UTC--" + new Date().toISOString() + "--" + e;
          return "win32" === t.platform && (r = r.split(":").join("-")), r;
        },
        exportToFile: function exportToFile(e, t, n) {
          var i, o, a, s;
          return t = t || "keystore", i = this.generateKeystoreFilename(e.address), a = JSON.stringify(e), this.browser ? f(n) ? n(a) : a : (o = r(44).join(t, i), s = r(43), f(n) ? void s.writeFile(o, a, function (e) {
            if (e) return n(e);
            n(o);
          }) : (s.writeFileSync(o, a), o));
        },
        importFromFile: function importFromFile(e, n, i) {
          var o, a, s, c;
          if (this.browser) throw new Error("method only available in Node.js");

          function u(e, t, r) {
            var n,
                i,
                o = null;

            for (n = 0, i = r.length; n < i; ++n) {
              if (r[n].indexOf(t) > -1) {
                o = s.join(e, r[n]), c.lstatSync(o).isDirectory() && (o = s.join(o, r[n]));
                break;
              }
            }

            return o;
          }

          if (s = r(44), c = r(43), e = e.toLowerCase(), n = n || s.join(t.env.HOME, ".ethereum"), o = s.join(n, "keystore"), !f(i)) {
            if (!(a = u(o, e, c.readdirSync(o)))) throw new Error("could not find key file for address " + e);
            return JSON.parse(c.readFileSync(a));
          }

          c.readdir(o, function (t, r) {
            var n;
            return t ? i(t) : (n = u(o, e, r), i(n ? JSON.parse(c.readFileSync(n)) : new Error("could not find key file for address " + e)));
          });
        }
      };
    }).call(this, r(7), r(2).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n,
        i = {
      cipher: {},
      hash: {},
      keyexchange: {},
      mode: {},
      misc: {},
      codec: {},
      exception: {
        corrupt: function corrupt(e) {
          this.toString = function () {
            return "CORRUPT: " + this.message;
          }, this.message = e;
        },
        invalid: function invalid(e) {
          this.toString = function () {
            return "INVALID: " + this.message;
          }, this.message = e;
        },
        bug: function bug(e) {
          this.toString = function () {
            return "BUG: " + this.message;
          }, this.message = e;
        },
        notReady: function notReady(e) {
          this.toString = function () {
            return "NOT READY: " + this.message;
          }, this.message = e;
        }
      }
    };

    function o(e, t, r) {
      if (4 !== t.length) throw new i.exception.invalid("invalid aes block size");
      var n = e.b[r],
          o = t[0] ^ n[0],
          a = t[r ? 3 : 1] ^ n[1],
          s = t[2] ^ n[2];
      t = t[r ? 1 : 3] ^ n[3];
      var f,
          c,
          u,
          d,
          h = n.length / 4 - 2,
          l = 4,
          p = [0, 0, 0, 0];
      e = (f = e.s[r])[0];
      var b = f[1],
          m = f[2],
          y = f[3],
          v = f[4];

      for (d = 0; d < h; d++) {
        f = e[o >>> 24] ^ b[a >> 16 & 255] ^ m[s >> 8 & 255] ^ y[255 & t] ^ n[l], c = e[a >>> 24] ^ b[s >> 16 & 255] ^ m[t >> 8 & 255] ^ y[255 & o] ^ n[l + 1], u = e[s >>> 24] ^ b[t >> 16 & 255] ^ m[o >> 8 & 255] ^ y[255 & a] ^ n[l + 2], t = e[t >>> 24] ^ b[o >> 16 & 255] ^ m[a >> 8 & 255] ^ y[255 & s] ^ n[l + 3], l += 4, o = f, a = c, s = u;
      }

      for (d = 0; 4 > d; d++) {
        p[r ? 3 & -d : d] = v[o >>> 24] << 24 ^ v[a >> 16 & 255] << 16 ^ v[s >> 8 & 255] << 8 ^ v[255 & t] ^ n[l++], f = o, o = a, a = s, s = t, t = f;
      }

      return p;
    }

    function a(e, t) {
      var r,
          n,
          i,
          o = e.F,
          a = e.b,
          s = o[0],
          f = o[1],
          c = o[2],
          u = o[3],
          d = o[4],
          h = o[5],
          l = o[6],
          p = o[7];

      for (r = 0; 64 > r; r++) {
        16 > r ? n = t[r] : (n = t[r + 1 & 15], i = t[r + 14 & 15], n = t[15 & r] = (n >>> 7 ^ n >>> 18 ^ n >>> 3 ^ n << 25 ^ n << 14) + (i >>> 17 ^ i >>> 19 ^ i >>> 10 ^ i << 15 ^ i << 13) + t[15 & r] + t[r + 9 & 15] | 0), n = n + p + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (l ^ d & (h ^ l)) + a[r], p = l, l = h, h = d, d = u + n | 0, u = c, c = f, s = n + ((f = s) & c ^ u & (f ^ c)) + (f >>> 2 ^ f >>> 13 ^ f >>> 22 ^ f << 30 ^ f << 19 ^ f << 10) | 0;
      }

      o[0] = o[0] + s | 0, o[1] = o[1] + f | 0, o[2] = o[2] + c | 0, o[3] = o[3] + u | 0, o[4] = o[4] + d | 0, o[5] = o[5] + h | 0, o[6] = o[6] + l | 0, o[7] = o[7] + p | 0;
    }

    function s(e, t) {
      var r,
          n = i.random.K[e],
          o = [];

      for (r in n) {
        n.hasOwnProperty(r) && o.push(n[r]);
      }

      for (r = 0; r < o.length; r++) {
        o[r](t);
      }
    }

    function f(e, t) {
      "undefined" != typeof window && window.performance && "function" == typeof window.performance.now ? e.addEntropy(window.performance.now(), t, "loadtime") : e.addEntropy(new Date().valueOf(), t, "loadtime");
    }

    function c(e) {
      e.b = u(e).concat(u(e)), e.L = new i.cipher.aes(e.b);
    }

    function u(e) {
      for (var t = 0; 4 > t && (e.h[t] = e.h[t] + 1 | 0, !e.h[t]); t++) {
        ;
      }

      return e.L.encrypt(e.h);
    }

    function d(e, t) {
      return function () {
        t.apply(e, arguments);
      };
    }

    i.cipher.aes = function (e) {
      this.s[0][0][0] || this.O();
      var t,
          r,
          n,
          o,
          a = this.s[0][4],
          s = this.s[1],
          f = 1;
      if (4 !== (t = e.length) && 6 !== t && 8 !== t) throw new i.exception.invalid("invalid aes key size");

      for (this.b = [n = e.slice(0), o = []], e = t; e < 4 * t + 28; e++) {
        r = n[e - 1], (0 == e % t || 8 === t && 4 == e % t) && (r = a[r >>> 24] << 24 ^ a[r >> 16 & 255] << 16 ^ a[r >> 8 & 255] << 8 ^ a[255 & r], 0 == e % t && (r = r << 8 ^ r >>> 24 ^ f << 24, f = f << 1 ^ 283 * (f >> 7))), n[e] = n[e - t] ^ r;
      }

      for (t = 0; e; t++, e--) {
        r = n[3 & t ? e : e - 4], o[t] = 4 >= e || 4 > t ? r : s[0][a[r >>> 24]] ^ s[1][a[r >> 16 & 255]] ^ s[2][a[r >> 8 & 255]] ^ s[3][a[255 & r]];
      }
    }, i.cipher.aes.prototype = {
      encrypt: function encrypt(e) {
        return o(this, e, 0);
      },
      decrypt: function decrypt(e) {
        return o(this, e, 1);
      },
      s: [[[], [], [], [], []], [[], [], [], [], []]],
      O: function O() {
        var e,
            t,
            r,
            n,
            i,
            o,
            a,
            s = this.s[0],
            f = this.s[1],
            c = s[4],
            u = f[4],
            d = [],
            h = [];

        for (e = 0; 256 > e; e++) {
          h[(d[e] = e << 1 ^ 283 * (e >> 7)) ^ e] = e;
        }

        for (t = r = 0; !c[t]; t ^= n || 1, r = h[r] || 1) {
          for (o = (o = r ^ r << 1 ^ r << 2 ^ r << 3 ^ r << 4) >> 8 ^ 255 & o ^ 99, c[t] = o, u[o] = t, a = 16843009 * (i = d[e = d[n = d[t]]]) ^ 65537 * e ^ 257 * n ^ 16843008 * t, i = 257 * d[o] ^ 16843008 * o, e = 0; 4 > e; e++) {
            s[e][t] = i = i << 24 ^ i >>> 8, f[e][o] = a = a << 24 ^ a >>> 8;
          }
        }

        for (e = 0; 5 > e; e++) {
          s[e] = s[e].slice(0), f[e] = f[e].slice(0);
        }
      }
    }, i.bitArray = {
      bitSlice: function bitSlice(e, t, r) {
        return e = i.bitArray.$(e.slice(t / 32), 32 - (31 & t)).slice(1), void 0 === r ? e : i.bitArray.clamp(e, r - t);
      },
      extract: function extract(e, t, r) {
        var n = Math.floor(-t - r & 31);
        return (-32 & (t + r - 1 ^ t) ? e[t / 32 | 0] << 32 - n ^ e[t / 32 + 1 | 0] >>> n : e[t / 32 | 0] >>> n) & (1 << r) - 1;
      },
      concat: function concat(e, t) {
        if (0 === e.length || 0 === t.length) return e.concat(t);
        var r = e[e.length - 1],
            n = i.bitArray.getPartial(r);
        return 32 === n ? e.concat(t) : i.bitArray.$(t, n, 0 | r, e.slice(0, e.length - 1));
      },
      bitLength: function bitLength(e) {
        var t = e.length;
        return 0 === t ? 0 : 32 * (t - 1) + i.bitArray.getPartial(e[t - 1]);
      },
      clamp: function clamp(e, t) {
        if (32 * e.length < t) return e;
        var r = (e = e.slice(0, Math.ceil(t / 32))).length;
        return t &= 31, 0 < r && t && (e[r - 1] = i.bitArray.partial(t, e[r - 1] & 2147483648 >> t - 1, 1)), e;
      },
      partial: function partial(e, t, r) {
        return 32 === e ? t : (r ? 0 | t : t << 32 - e) + 1099511627776 * e;
      },
      getPartial: function getPartial(e) {
        return Math.round(e / 1099511627776) || 32;
      },
      equal: function equal(e, t) {
        if (i.bitArray.bitLength(e) !== i.bitArray.bitLength(t)) return !1;
        var r,
            n = 0;

        for (r = 0; r < e.length; r++) {
          n |= e[r] ^ t[r];
        }

        return 0 === n;
      },
      $: function $(e, t, r, n) {
        var o;

        for (o = 0, void 0 === n && (n = []); 32 <= t; t -= 32) {
          n.push(r), r = 0;
        }

        if (0 === t) return n.concat(e);

        for (o = 0; o < e.length; o++) {
          n.push(r | e[o] >>> t), r = e[o] << 32 - t;
        }

        return o = e.length ? e[e.length - 1] : 0, e = i.bitArray.getPartial(o), n.push(i.bitArray.partial(t + e & 31, 32 < t + e ? r : n.pop(), 1)), n;
      },
      i: function i(e, t) {
        return [e[0] ^ t[0], e[1] ^ t[1], e[2] ^ t[2], e[3] ^ t[3]];
      },
      byteswapM: function byteswapM(e) {
        var t, r;

        for (t = 0; t < e.length; ++t) {
          r = e[t], e[t] = r >>> 24 | r >>> 8 & 65280 | (65280 & r) << 8 | r << 24;
        }

        return e;
      }
    }, i.codec.utf8String = {
      fromBits: function fromBits(e) {
        var t,
            r,
            n = "",
            o = i.bitArray.bitLength(e);

        for (t = 0; t < o / 8; t++) {
          0 == (3 & t) && (r = e[t / 4]), n += String.fromCharCode(r >>> 24), r <<= 8;
        }

        return decodeURIComponent(escape(n));
      },
      toBits: function toBits(e) {
        e = unescape(encodeURIComponent(e));
        var t,
            r = [],
            n = 0;

        for (t = 0; t < e.length; t++) {
          n = n << 8 | e.charCodeAt(t), 3 == (3 & t) && (r.push(n), n = 0);
        }

        return 3 & t && r.push(i.bitArray.partial(8 * (3 & t), n)), r;
      }
    }, i.codec.hex = {
      fromBits: function fromBits(e) {
        var t,
            r = "";

        for (t = 0; t < e.length; t++) {
          r += (0xf00000000000 + (0 | e[t])).toString(16).substr(4);
        }

        return r.substr(0, i.bitArray.bitLength(e) / 4);
      },
      toBits: function toBits(e) {
        var t,
            r,
            n = [];

        for (r = (e = e.replace(/\s|0x/g, "")).length, e += "00000000", t = 0; t < e.length; t += 8) {
          n.push(0 ^ parseInt(e.substr(t, 8), 16));
        }

        return i.bitArray.clamp(n, 4 * r);
      }
    }, i.codec.base32 = {
      B: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
      X: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
      BITS: 32,
      BASE: 5,
      REMAINING: 27,
      fromBits: function fromBits(e, t, r) {
        var n = i.codec.base32.BASE,
            o = i.codec.base32.REMAINING,
            a = "",
            s = 0,
            f = i.codec.base32.B,
            c = 0,
            u = i.bitArray.bitLength(e);

        for (r && (f = i.codec.base32.X), r = 0; a.length * n < u;) {
          a += f.charAt((c ^ e[r] >>> s) >>> o), s < n ? (c = e[r] << n - s, s += o, r++) : (c <<= n, s -= n);
        }

        for (; 7 & a.length && !t;) {
          a += "=";
        }

        return a;
      },
      toBits: function toBits(e, t) {
        e = e.replace(/\s|=/g, "").toUpperCase();
        var r,
            n,
            o = i.codec.base32.BITS,
            a = i.codec.base32.BASE,
            s = i.codec.base32.REMAINING,
            f = [],
            c = 0,
            u = i.codec.base32.B,
            d = 0,
            h = "base32";

        for (t && (u = i.codec.base32.X, h = "base32hex"), r = 0; r < e.length; r++) {
          if (0 > (n = u.indexOf(e.charAt(r)))) {
            if (!t) try {
              return i.codec.base32hex.toBits(e);
            } catch (e) {}
            throw new i.exception.invalid("this isn't " + h + "!");
          }

          c > s ? (c -= s, f.push(d ^ n >>> c), d = n << o - c) : d ^= n << o - (c += a);
        }

        return 56 & c && f.push(i.bitArray.partial(56 & c, d, 1)), f;
      }
    }, i.codec.base32hex = {
      fromBits: function fromBits(e, t) {
        return i.codec.base32.fromBits(e, t, 1);
      },
      toBits: function toBits(e) {
        return i.codec.base32.toBits(e, 1);
      }
    }, i.codec.base64 = {
      B: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
      fromBits: function fromBits(e, t, r) {
        var n = "",
            o = 0,
            a = i.codec.base64.B,
            s = 0,
            f = i.bitArray.bitLength(e);

        for (r && (a = a.substr(0, 62) + "-_"), r = 0; 6 * n.length < f;) {
          n += a.charAt((s ^ e[r] >>> o) >>> 26), 6 > o ? (s = e[r] << 6 - o, o += 26, r++) : (s <<= 6, o -= 6);
        }

        for (; 3 & n.length && !t;) {
          n += "=";
        }

        return n;
      },
      toBits: function toBits(e, t) {
        e = e.replace(/\s|=/g, "");
        var r,
            n,
            o = [],
            a = 0,
            s = i.codec.base64.B,
            f = 0;

        for (t && (s = s.substr(0, 62) + "-_"), r = 0; r < e.length; r++) {
          if (0 > (n = s.indexOf(e.charAt(r)))) throw new i.exception.invalid("this isn't base64!");
          26 < a ? (a -= 26, o.push(f ^ n >>> a), f = n << 32 - a) : f ^= n << 32 - (a += 6);
        }

        return 56 & a && o.push(i.bitArray.partial(56 & a, f, 1)), o;
      }
    }, i.codec.base64url = {
      fromBits: function fromBits(e) {
        return i.codec.base64.fromBits(e, 1, 1);
      },
      toBits: function toBits(e) {
        return i.codec.base64.toBits(e, 1);
      }
    }, i.hash.sha256 = function (e) {
      this.b[0] || this.O(), e ? (this.F = e.F.slice(0), this.A = e.A.slice(0), this.l = e.l) : this.reset();
    }, i.hash.sha256.hash = function (e) {
      return new i.hash.sha256().update(e).finalize();
    }, i.hash.sha256.prototype = {
      blockSize: 512,
      reset: function reset() {
        return this.F = this.Y.slice(0), this.A = [], this.l = 0, this;
      },
      update: function update(e) {
        "string" == typeof e && (e = i.codec.utf8String.toBits(e));
        var t,
            r = this.A = i.bitArray.concat(this.A, e);
        if (t = this.l, 9007199254740991 < (e = this.l = t + i.bitArray.bitLength(e))) throw new i.exception.invalid("Cannot hash more than 2^53 - 1 bits");

        if ("undefined" != typeof Uint32Array) {
          var n = new Uint32Array(r),
              o = 0;

          for (t = 512 + t - (512 + t & 511); t <= e; t += 512) {
            a(this, n.subarray(16 * o, 16 * (o + 1))), o += 1;
          }

          r.splice(0, 16 * o);
        } else for (t = 512 + t - (512 + t & 511); t <= e; t += 512) {
          a(this, r.splice(0, 16));
        }

        return this;
      },
      finalize: function finalize() {
        var e,
            t = this.A,
            r = this.F;

        for (e = (t = i.bitArray.concat(t, [i.bitArray.partial(1, 1)])).length + 2; 15 & e; e++) {
          t.push(0);
        }

        for (t.push(Math.floor(this.l / 4294967296)), t.push(0 | this.l); t.length;) {
          a(this, t.splice(0, 16));
        }

        return this.reset(), r;
      },
      Y: [],
      b: [],
      O: function O() {
        function e(e) {
          return 4294967296 * (e - Math.floor(e)) | 0;
        }

        for (var t, r, n = 0, i = 2; 64 > n; i++) {
          for (r = !0, t = 2; t * t <= i; t++) {
            if (0 == i % t) {
              r = !1;
              break;
            }
          }

          r && (8 > n && (this.Y[n] = e(Math.pow(i, .5))), this.b[n] = e(Math.pow(i, 1 / 3)), n++);
        }
      }
    }, i.mode.ccm = {
      name: "ccm",
      G: [],
      listenProgress: function listenProgress(e) {
        i.mode.ccm.G.push(e);
      },
      unListenProgress: function unListenProgress(e) {
        -1 < (e = i.mode.ccm.G.indexOf(e)) && i.mode.ccm.G.splice(e, 1);
      },
      fa: function fa(e) {
        var t,
            r = i.mode.ccm.G.slice();

        for (t = 0; t < r.length; t += 1) {
          r[t](e);
        }
      },
      encrypt: function encrypt(e, t, r, n, o) {
        var a,
            s = t.slice(0),
            f = i.bitArray,
            c = f.bitLength(r) / 8,
            u = f.bitLength(s) / 8;
        if (o = o || 64, n = n || [], 7 > c) throw new i.exception.invalid("ccm: iv must be at least 7 bytes");

        for (a = 2; 4 > a && u >>> 8 * a; a++) {
          ;
        }

        return a < 15 - c && (a = 15 - c), r = f.clamp(r, 8 * (15 - a)), t = i.mode.ccm.V(e, t, r, n, o, a), s = i.mode.ccm.C(e, s, r, t, o, a), f.concat(s.data, s.tag);
      },
      decrypt: function decrypt(e, t, r, n, o) {
        o = o || 64, n = n || [];
        var a = i.bitArray,
            s = a.bitLength(r) / 8,
            f = a.bitLength(t),
            c = a.clamp(t, f - o),
            u = a.bitSlice(t, f - o);
        f = (f - o) / 8;
        if (7 > s) throw new i.exception.invalid("ccm: iv must be at least 7 bytes");

        for (t = 2; 4 > t && f >>> 8 * t; t++) {
          ;
        }

        if (t < 15 - s && (t = 15 - s), r = a.clamp(r, 8 * (15 - t)), c = i.mode.ccm.C(e, c, r, u, o, t), e = i.mode.ccm.V(e, c.data, r, n, o, t), !a.equal(c.tag, e)) throw new i.exception.corrupt("ccm: tag doesn't match");
        return c.data;
      },
      na: function na(e, t, r, n, o, a) {
        var s = [],
            f = i.bitArray,
            c = f.i;
        if (n = [f.partial(8, (t.length ? 64 : 0) | n - 2 << 2 | a - 1)], (n = f.concat(n, r))[3] |= o, n = e.encrypt(n), t.length) for (65279 >= (r = f.bitLength(t) / 8) ? s = [f.partial(16, r)] : 4294967295 >= r && (s = f.concat([f.partial(16, 65534)], [r])), s = f.concat(s, t), t = 0; t < s.length; t += 4) {
          n = e.encrypt(c(n, s.slice(t, t + 4).concat([0, 0, 0])));
        }
        return n;
      },
      V: function V(e, t, r, n, o, a) {
        var s = i.bitArray,
            f = s.i;
        if ((o /= 8) % 2 || 4 > o || 16 < o) throw new i.exception.invalid("ccm: invalid tag length");
        if (4294967295 < n.length || 4294967295 < t.length) throw new i.exception.bug("ccm: can't deal with 4GiB or more data");

        for (r = i.mode.ccm.na(e, n, r, o, s.bitLength(t) / 8, a), n = 0; n < t.length; n += 4) {
          r = e.encrypt(f(r, t.slice(n, n + 4).concat([0, 0, 0])));
        }

        return s.clamp(r, 8 * o);
      },
      C: function C(e, t, r, n, o, a) {
        var s,
            f = i.bitArray;
        s = f.i;
        var c = t.length,
            u = f.bitLength(t),
            d = c / 50,
            h = d;
        if (r = f.concat([f.partial(8, a - 1)], r).concat([0, 0, 0]).slice(0, 4), n = f.bitSlice(s(n, e.encrypt(r)), 0, o), !c) return {
          tag: n,
          data: []
        };

        for (s = 0; s < c; s += 4) {
          s > d && (i.mode.ccm.fa(s / c), d += h), r[3]++, o = e.encrypt(r), t[s] ^= o[0], t[s + 1] ^= o[1], t[s + 2] ^= o[2], t[s + 3] ^= o[3];
        }

        return {
          tag: n,
          data: f.clamp(t, u)
        };
      }
    }, i.mode.ocb2 = {
      name: "ocb2",
      encrypt: function encrypt(e, t, r, n, o, a) {
        if (128 !== i.bitArray.bitLength(r)) throw new i.exception.invalid("ocb iv must be 128 bits");
        var s,
            f = i.mode.ocb2.S,
            c = i.bitArray,
            u = c.i,
            d = [0, 0, 0, 0];
        r = f(e.encrypt(r));
        var h,
            l = [];

        for (n = n || [], o = o || 64, s = 0; s + 4 < t.length; s += 4) {
          d = u(d, h = t.slice(s, s + 4)), l = l.concat(u(r, e.encrypt(u(r, h)))), r = f(r);
        }

        return h = t.slice(s), t = c.bitLength(h), s = e.encrypt(u(r, [0, 0, 0, t])), h = c.clamp(u(h.concat([0, 0, 0]), s), t), d = u(d, u(h.concat([0, 0, 0]), s)), d = e.encrypt(u(d, u(r, f(r)))), n.length && (d = u(d, a ? n : i.mode.ocb2.pmac(e, n))), l.concat(c.concat(h, c.clamp(d, o)));
      },
      decrypt: function decrypt(e, t, r, n, o, a) {
        if (128 !== i.bitArray.bitLength(r)) throw new i.exception.invalid("ocb iv must be 128 bits");
        o = o || 64;
        var s,
            f,
            c = i.mode.ocb2.S,
            u = i.bitArray,
            d = u.i,
            h = [0, 0, 0, 0],
            l = c(e.encrypt(r)),
            p = i.bitArray.bitLength(t) - o,
            b = [];

        for (n = n || [], r = 0; r + 4 < p / 32; r += 4) {
          s = d(l, e.decrypt(d(l, t.slice(r, r + 4)))), h = d(h, s), b = b.concat(s), l = c(l);
        }

        if (f = p - 32 * r, s = e.encrypt(d(l, [0, 0, 0, f])), s = d(s, u.clamp(t.slice(r), f).concat([0, 0, 0])), h = d(h, s), h = e.encrypt(d(h, d(l, c(l)))), n.length && (h = d(h, a ? n : i.mode.ocb2.pmac(e, n))), !u.equal(u.clamp(h, o), u.bitSlice(t, p))) throw new i.exception.corrupt("ocb: tag doesn't match");
        return b.concat(u.clamp(s, f));
      },
      pmac: function pmac(e, t) {
        var r,
            n = i.mode.ocb2.S,
            o = i.bitArray,
            a = o.i,
            s = [0, 0, 0, 0],
            f = a(f = e.encrypt([0, 0, 0, 0]), n(n(f)));

        for (r = 0; r + 4 < t.length; r += 4) {
          f = n(f), s = a(s, e.encrypt(a(f, t.slice(r, r + 4))));
        }

        return r = t.slice(r), 128 > o.bitLength(r) && (f = a(f, n(f)), r = o.concat(r, [-2147483648, 0, 0, 0])), s = a(s, r), e.encrypt(a(n(a(f, n(f))), s));
      },
      S: function S(e) {
        return [e[0] << 1 ^ e[1] >>> 31, e[1] << 1 ^ e[2] >>> 31, e[2] << 1 ^ e[3] >>> 31, e[3] << 1 ^ 135 * (e[0] >>> 31)];
      }
    }, i.mode.gcm = {
      name: "gcm",
      encrypt: function encrypt(e, t, r, n, o) {
        var a = t.slice(0);
        return t = i.bitArray, n = n || [], e = i.mode.gcm.C(!0, e, a, n, r, o || 128), t.concat(e.data, e.tag);
      },
      decrypt: function decrypt(e, t, r, n, o) {
        var a = t.slice(0),
            s = i.bitArray,
            f = s.bitLength(a);
        if (n = n || [], (o = o || 128) <= f ? (t = s.bitSlice(a, f - o), a = s.bitSlice(a, 0, f - o)) : (t = a, a = []), e = i.mode.gcm.C(!1, e, a, n, r, o), !s.equal(e.tag, t)) throw new i.exception.corrupt("gcm: tag doesn't match");
        return e.data;
      },
      ka: function ka(e, t) {
        var r,
            n,
            o,
            a,
            s,
            f = i.bitArray.i;

        for (o = [0, 0, 0, 0], a = t.slice(0), r = 0; 128 > r; r++) {
          for ((n = 0 != (e[Math.floor(r / 32)] & 1 << 31 - r % 32)) && (o = f(o, a)), s = 0 != (1 & a[3]), n = 3; 0 < n; n--) {
            a[n] = a[n] >>> 1 | (1 & a[n - 1]) << 31;
          }

          a[0] >>>= 1, s && (a[0] ^= -520093696);
        }

        return o;
      },
      j: function j(e, t, r) {
        var n,
            o = r.length;

        for (t = t.slice(0), n = 0; n < o; n += 4) {
          t[0] ^= 4294967295 & r[n], t[1] ^= 4294967295 & r[n + 1], t[2] ^= 4294967295 & r[n + 2], t[3] ^= 4294967295 & r[n + 3], t = i.mode.gcm.ka(t, e);
        }

        return t;
      },
      C: function C(e, t, r, n, o, a) {
        var s,
            f,
            c,
            u,
            d,
            h,
            l,
            p,
            b = i.bitArray;

        for (h = r.length, l = b.bitLength(r), p = b.bitLength(n), f = b.bitLength(o), s = t.encrypt([0, 0, 0, 0]), 96 === f ? (o = o.slice(0), o = b.concat(o, [1])) : (o = i.mode.gcm.j(s, [0, 0, 0, 0], o), o = i.mode.gcm.j(s, o, [0, 0, Math.floor(f / 4294967296), 4294967295 & f])), f = i.mode.gcm.j(s, [0, 0, 0, 0], n), d = o.slice(0), n = f.slice(0), e || (n = i.mode.gcm.j(s, f, r)), u = 0; u < h; u += 4) {
          d[3]++, c = t.encrypt(d), r[u] ^= c[0], r[u + 1] ^= c[1], r[u + 2] ^= c[2], r[u + 3] ^= c[3];
        }

        return r = b.clamp(r, l), e && (n = i.mode.gcm.j(s, f, r)), e = [Math.floor(p / 4294967296), 4294967295 & p, Math.floor(l / 4294967296), 4294967295 & l], n = i.mode.gcm.j(s, n, e), c = t.encrypt(o), n[0] ^= c[0], n[1] ^= c[1], n[2] ^= c[2], n[3] ^= c[3], {
          tag: b.bitSlice(n, 0, a),
          data: r
        };
      }
    }, i.misc.hmac = function (e, t) {
      this.W = t = t || i.hash.sha256;
      var r,
          n = [[], []],
          o = t.prototype.blockSize / 32;

      for (this.w = [new t(), new t()], e.length > o && (e = t.hash(e)), r = 0; r < o; r++) {
        n[0][r] = 909522486 ^ e[r], n[1][r] = 1549556828 ^ e[r];
      }

      this.w[0].update(n[0]), this.w[1].update(n[1]), this.R = new t(this.w[0]);
    }, i.misc.hmac.prototype.encrypt = i.misc.hmac.prototype.mac = function (e) {
      if (this.aa) throw new i.exception.invalid("encrypt on already updated hmac called!");
      return this.update(e), this.digest(e);
    }, i.misc.hmac.prototype.reset = function () {
      this.R = new this.W(this.w[0]), this.aa = !1;
    }, i.misc.hmac.prototype.update = function (e) {
      this.aa = !0, this.R.update(e);
    }, i.misc.hmac.prototype.digest = function () {
      var e = this.R.finalize();
      e = new this.W(this.w[1]).update(e).finalize();
      return this.reset(), e;
    }, i.misc.pbkdf2 = function (e, t, r, n, o) {
      if (r = r || 1e4, 0 > n || 0 > r) throw new i.exception.invalid("invalid params to pbkdf2");
      "string" == typeof e && (e = i.codec.utf8String.toBits(e)), "string" == typeof t && (t = i.codec.utf8String.toBits(t)), e = new (o = o || i.misc.hmac)(e);
      var a,
          s,
          f,
          c,
          u = [],
          d = i.bitArray;

      for (c = 1; 32 * u.length < (n || 1); c++) {
        for (o = a = e.encrypt(d.concat(t, [c])), s = 1; s < r; s++) {
          for (a = e.encrypt(a), f = 0; f < a.length; f++) {
            o[f] ^= a[f];
          }
        }

        u = u.concat(o);
      }

      return n && (u = d.clamp(u, n)), u;
    }, i.prng = function (e) {
      this.c = [new i.hash.sha256()], this.m = [0], this.P = 0, this.H = {}, this.N = 0, this.U = {}, this.Z = this.f = this.o = this.ha = 0, this.b = [0, 0, 0, 0, 0, 0, 0, 0], this.h = [0, 0, 0, 0], this.L = void 0, this.M = e, this.D = !1, this.K = {
        progress: {},
        seeded: {}
      }, this.u = this.ga = 0, this.I = 1, this.J = 2, this.ca = 65536, this.T = [0, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024], this.da = 3e4, this.ba = 80;
    }, i.prng.prototype = {
      randomWords: function randomWords(e, t) {
        var r,
            n,
            o = [];
        if ((r = this.isReady(t)) === this.u) throw new i.exception.notReady("generator isn't seeded");

        if (r & this.J) {
          r = !(r & this.I), n = [];
          var a,
              s = 0;

          for (this.Z = n[0] = new Date().valueOf() + this.da, a = 0; 16 > a; a++) {
            n.push(4294967296 * Math.random() | 0);
          }

          for (a = 0; a < this.c.length && (n = n.concat(this.c[a].finalize()), s += this.m[a], this.m[a] = 0, r || !(this.P & 1 << a)); a++) {
            ;
          }

          for (this.P >= 1 << this.c.length && (this.c.push(new i.hash.sha256()), this.m.push(0)), this.f -= s, s > this.o && (this.o = s), this.P++, this.b = i.hash.sha256.hash(this.b.concat(n)), this.L = new i.cipher.aes(this.b), r = 0; 4 > r && (this.h[r] = this.h[r] + 1 | 0, !this.h[r]); r++) {
            ;
          }
        }

        for (r = 0; r < e; r += 4) {
          0 == (r + 1) % this.ca && c(this), n = u(this), o.push(n[0], n[1], n[2], n[3]);
        }

        return c(this), o.slice(0, e);
      },
      setDefaultParanoia: function setDefaultParanoia(e, t) {
        if (0 === e && "Setting paranoia=0 will ruin your security; use it only for testing" !== t) throw new i.exception.invalid("Setting paranoia=0 will ruin your security; use it only for testing");
        this.M = e;
      },
      addEntropy: function addEntropy(e, t, r) {
        r = r || "user";
        var n,
            o,
            a = new Date().valueOf(),
            f = this.H[r],
            c = this.isReady(),
            u = 0;

        switch (void 0 === (n = this.U[r]) && (n = this.U[r] = this.ha++), void 0 === f && (f = this.H[r] = 0), this.H[r] = (this.H[r] + 1) % this.c.length, typeof e) {
          case "number":
            void 0 === t && (t = 1), this.c[f].update([n, this.N++, 1, t, a, 1, 0 | e]);
            break;

          case "object":
            if ("[object Uint32Array]" === (r = Object.prototype.toString.call(e))) {
              for (o = [], r = 0; r < e.length; r++) {
                o.push(e[r]);
              }

              e = o;
            } else for ("[object Array]" !== r && (u = 1), r = 0; r < e.length && !u; r++) {
              "number" != typeof e[r] && (u = 1);
            }

            if (!u) {
              if (void 0 === t) for (r = t = 0; r < e.length; r++) {
                for (o = e[r]; 0 < o;) {
                  t++, o >>>= 1;
                }
              }
              this.c[f].update([n, this.N++, 2, t, a, e.length].concat(e));
            }

            break;

          case "string":
            void 0 === t && (t = e.length), this.c[f].update([n, this.N++, 3, t, a, e.length]), this.c[f].update(e);
            break;

          default:
            u = 1;
        }

        if (u) throw new i.exception.bug("random: addEntropy only supports number, array of numbers or string");
        this.m[f] += t, this.f += t, c === this.u && (this.isReady() !== this.u && s("seeded", Math.max(this.o, this.f)), s("progress", this.getProgress()));
      },
      isReady: function isReady(e) {
        return e = this.T[void 0 !== e ? e : this.M], this.o && this.o >= e ? this.m[0] > this.ba && new Date().valueOf() > this.Z ? this.J | this.I : this.I : this.f >= e ? this.J | this.u : this.u;
      },
      getProgress: function getProgress(e) {
        return e = this.T[e || this.M], this.o >= e || this.f > e ? 1 : this.f / e;
      },
      startCollectors: function startCollectors() {
        if (!this.D) {
          if (this.a = {
            loadTimeCollector: d(this, this.ma),
            mouseCollector: d(this, this.oa),
            keyboardCollector: d(this, this.la),
            accelerometerCollector: d(this, this.ea),
            touchCollector: d(this, this.qa)
          }, window.addEventListener) window.addEventListener("load", this.a.loadTimeCollector, !1), window.addEventListener("mousemove", this.a.mouseCollector, !1), window.addEventListener("keypress", this.a.keyboardCollector, !1), window.addEventListener("devicemotion", this.a.accelerometerCollector, !1), window.addEventListener("touchmove", this.a.touchCollector, !1);else {
            if (!document.attachEvent) throw new i.exception.bug("can't attach event");
            document.attachEvent("onload", this.a.loadTimeCollector), document.attachEvent("onmousemove", this.a.mouseCollector), document.attachEvent("keypress", this.a.keyboardCollector);
          }
          this.D = !0;
        }
      },
      stopCollectors: function stopCollectors() {
        this.D && (window.removeEventListener ? (window.removeEventListener("load", this.a.loadTimeCollector, !1), window.removeEventListener("mousemove", this.a.mouseCollector, !1), window.removeEventListener("keypress", this.a.keyboardCollector, !1), window.removeEventListener("devicemotion", this.a.accelerometerCollector, !1), window.removeEventListener("touchmove", this.a.touchCollector, !1)) : document.detachEvent && (document.detachEvent("onload", this.a.loadTimeCollector), document.detachEvent("onmousemove", this.a.mouseCollector), document.detachEvent("keypress", this.a.keyboardCollector)), this.D = !1);
      },
      addEventListener: function addEventListener(e, t) {
        this.K[e][this.ga++] = t;
      },
      removeEventListener: function removeEventListener(e, t) {
        var r,
            n,
            i = this.K[e],
            o = [];

        for (n in i) {
          i.hasOwnProperty(n) && i[n] === t && o.push(n);
        }

        for (r = 0; r < o.length; r++) {
          delete i[n = o[r]];
        }
      },
      la: function la() {
        f(this, 1);
      },
      oa: function oa(e) {
        var t, r;

        try {
          t = e.x || e.clientX || e.offsetX || 0, r = e.y || e.clientY || e.offsetY || 0;
        } catch (e) {
          r = t = 0;
        }

        0 != t && 0 != r && this.addEntropy([t, r], 2, "mouse"), f(this, 0);
      },
      qa: function qa(e) {
        e = e.touches[0] || e.changedTouches[0], this.addEntropy([e.pageX || e.clientX, e.pageY || e.clientY], 1, "touch"), f(this, 0);
      },
      ma: function ma() {
        f(this, 2);
      },
      ea: function ea(e) {
        if (e = e.accelerationIncludingGravity.x || e.accelerationIncludingGravity.y || e.accelerationIncludingGravity.z, window.orientation) {
          var t = window.orientation;
          "number" == typeof t && this.addEntropy(t, 1, "accelerometer");
        }

        e && this.addEntropy(e, 2, "accelerometer"), f(this, 0);
      }
    }, i.random = new i.prng(6);

    e: try {
      var h, l, p, b;

      if (b = e.exports) {
        var m;

        try {
          m = r(20);
        } catch (e) {
          m = null;
        }

        b = l = m;
      }

      if (b && l.randomBytes) h = l.randomBytes(128), h = new Uint32Array(new Uint8Array(h).buffer), i.random.addEntropy(h, 1024, "crypto['randomBytes']");else if ("undefined" != typeof window && "undefined" != typeof Uint32Array) {
        if (p = new Uint32Array(32), window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(p);else {
          if (!window.msCrypto || !window.msCrypto.getRandomValues) break e;
          window.msCrypto.getRandomValues(p);
        }
        i.random.addEntropy(p, 1024, "crypto['getRandomValues']");
      }
    } catch (e) {
      "undefined" != typeof window && window.console && (console.log("There was an error collecting entropy from the browser:"), console.log(e));
    }

    i.json = {
      defaults: {
        v: 1,
        iter: 1e4,
        ks: 128,
        ts: 64,
        mode: "ccm",
        adata: "",
        cipher: "aes"
      },
      ja: function ja(e, t, r, n) {
        r = r || {}, n = n || {};
        var o,
            a = i.json,
            s = a.g({
          iv: i.random.randomWords(4, 0)
        }, a.defaults);
        if (a.g(s, r), r = s.adata, "string" == typeof s.salt && (s.salt = i.codec.base64.toBits(s.salt)), "string" == typeof s.iv && (s.iv = i.codec.base64.toBits(s.iv)), !i.mode[s.mode] || !i.cipher[s.cipher] || "string" == typeof e && 100 >= s.iter || 64 !== s.ts && 96 !== s.ts && 128 !== s.ts || 128 !== s.ks && 192 !== s.ks && 256 !== s.ks || 2 > s.iv.length || 4 < s.iv.length) throw new i.exception.invalid("json encrypt: invalid parameters");
        return "string" == typeof e ? (e = (o = i.misc.cachedPbkdf2(e, s)).key.slice(0, s.ks / 32), s.salt = o.salt) : i.ecc && e instanceof i.ecc.elGamal.publicKey && (o = e.kem(), s.kemtag = o.tag, e = o.key.slice(0, s.ks / 32)), "string" == typeof t && (t = i.codec.utf8String.toBits(t)), "string" == typeof r && (s.adata = r = i.codec.utf8String.toBits(r)), o = new i.cipher[s.cipher](e), a.g(n, s), n.key = e, s.ct = "ccm" === s.mode && i.arrayBuffer && i.arrayBuffer.ccm && t instanceof ArrayBuffer ? i.arrayBuffer.ccm.encrypt(o, t, s.iv, r, s.ts) : i.mode[s.mode].encrypt(o, t, s.iv, r, s.ts), s;
      },
      encrypt: function encrypt(e, t, r, n) {
        var o = i.json,
            a = o.ja.apply(o, arguments);
        return o.encode(a);
      },
      ia: function ia(e, t, r, n) {
        r = r || {}, n = n || {};
        var o,
            a,
            s = i.json;
        if (o = (t = s.g(s.g(s.g({}, s.defaults), t), r, !0)).adata, "string" == typeof t.salt && (t.salt = i.codec.base64.toBits(t.salt)), "string" == typeof t.iv && (t.iv = i.codec.base64.toBits(t.iv)), !i.mode[t.mode] || !i.cipher[t.cipher] || "string" == typeof e && 100 >= t.iter || 64 !== t.ts && 96 !== t.ts && 128 !== t.ts || 128 !== t.ks && 192 !== t.ks && 256 !== t.ks || !t.iv || 2 > t.iv.length || 4 < t.iv.length) throw new i.exception.invalid("json decrypt: invalid parameters");
        return "string" == typeof e ? (e = (a = i.misc.cachedPbkdf2(e, t)).key.slice(0, t.ks / 32), t.salt = a.salt) : i.ecc && e instanceof i.ecc.elGamal.secretKey && (e = e.unkem(i.codec.base64.toBits(t.kemtag)).slice(0, t.ks / 32)), "string" == typeof o && (o = i.codec.utf8String.toBits(o)), a = new i.cipher[t.cipher](e), o = "ccm" === t.mode && i.arrayBuffer && i.arrayBuffer.ccm && t.ct instanceof ArrayBuffer ? i.arrayBuffer.ccm.decrypt(a, t.ct, t.iv, t.tag, o, t.ts) : i.mode[t.mode].decrypt(a, t.ct, t.iv, o, t.ts), s.g(n, t), n.key = e, 1 === r.raw ? o : i.codec.utf8String.fromBits(o);
      },
      decrypt: function decrypt(e, t, r, n) {
        var o = i.json;
        return o.ia(e, o.decode(t), r, n);
      },
      encode: function encode(e) {
        var t,
            r = "{",
            n = "";

        for (t in e) {
          if (e.hasOwnProperty(t)) {
            if (!t.match(/^[a-z0-9]+$/i)) throw new i.exception.invalid("json encode: invalid property name");

            switch (r += n + '"' + t + '":', n = ",", typeof e[t]) {
              case "number":
              case "boolean":
                r += e[t];
                break;

              case "string":
                r += '"' + escape(e[t]) + '"';
                break;

              case "object":
                r += '"' + i.codec.base64.fromBits(e[t], 0) + '"';
                break;

              default:
                throw new i.exception.bug("json encode: unsupported type");
            }
          }
        }

        return r + "}";
      },
      decode: function decode(e) {
        if (!(e = e.replace(/\s/g, "")).match(/^\{.*\}$/)) throw new i.exception.invalid("json decode: this isn't json!");
        e = e.replace(/^\{|\}$/g, "").split(/,/);
        var t,
            r,
            n = {};

        for (t = 0; t < e.length; t++) {
          if (!(r = e[t].match(/^\s*(?:(["']?)([a-z][a-z0-9]*)\1)\s*:\s*(?:(-?\d+)|"([a-z0-9+\/%*_.@=\-]*)"|(true|false))$/i))) throw new i.exception.invalid("json decode: this isn't json!");
          null != r[3] ? n[r[2]] = parseInt(r[3], 10) : null != r[4] ? n[r[2]] = r[2].match(/^(ct|adata|salt|iv)$/) ? i.codec.base64.toBits(r[4]) : unescape(r[4]) : null != r[5] && (n[r[2]] = "true" === r[5]);
        }

        return n;
      },
      g: function g(e, t, r) {
        if (void 0 === e && (e = {}), void 0 === t) return e;

        for (var n in t) {
          if (t.hasOwnProperty(n)) {
            if (r && void 0 !== e[n] && e[n] !== t[n]) throw new i.exception.invalid("required parameter overridden");
            e[n] = t[n];
          }
        }

        return e;
      },
      sa: function sa(e, t) {
        var r,
            n = {};

        for (r in e) {
          e.hasOwnProperty(r) && e[r] !== t[r] && (n[r] = e[r]);
        }

        return n;
      },
      ra: function ra(e, t) {
        var r,
            n = {};

        for (r = 0; r < t.length; r++) {
          void 0 !== e[t[r]] && (n[t[r]] = e[t[r]]);
        }

        return n;
      }
    }, i.encrypt = i.json.encrypt, i.decrypt = i.json.decrypt, i.misc.pa = {}, i.misc.cachedPbkdf2 = function (e, t) {
      var r,
          n = i.misc.pa;
      return r = (t = t || {}).iter || 1e3, (r = (n = n[e] = n[e] || {})[r] = n[r] || {
        firstSalt: t.salt && t.salt.length ? t.salt.slice(0) : i.random.randomWords(2, 0)
      })[n = void 0 === t.salt ? r.firstSalt : t.salt] = r[n] || i.misc.pbkdf2(e, n, t.iter), {
        key: r[n].slice(0),
        salt: n.slice(0)
      };
    }, e.exports && (e.exports = i), void 0 === (n = function () {
      return i;
    }.apply(t, [])) || (e.exports = n);
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(101);
    e.exports = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.head = null, this.tail = null, this.length = 0;
      }

      return e.prototype.push = function (e) {
        var t = {
          data: e,
          next: null
        };
        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
      }, e.prototype.unshift = function (e) {
        var t = {
          data: e,
          next: this.head
        };
        0 === this.length && (this.tail = t), this.head = t, ++this.length;
      }, e.prototype.shift = function () {
        if (0 !== this.length) {
          var e = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
        }
      }, e.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, e.prototype.join = function (e) {
        if (0 === this.length) return "";

        for (var t = this.head, r = "" + t.data; t = t.next;) {
          r += e + t.data;
        }

        return r;
      }, e.prototype.concat = function (e) {
        if (0 === this.length) return n.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var t, r, i, o = n.allocUnsafe(e >>> 0), a = this.head, s = 0; a;) {
          t = a.data, r = o, i = s, t.copy(r, i), s += a.data.length, a = a.next;
        }

        return o;
      }, e;
    }(), i && i.inspect && i.inspect.custom && (e.exports.prototype[i.inspect.custom] = function () {
      var e = i.inspect({
        length: this.length
      });
      return this.constructor.name + " " + e;
    });
  }, function (e, t) {}, function (e, t, r) {
    (function (e) {
      var n = void 0 !== e && e || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(e, t) {
        this._id = e, this._clearFn = t;
      }

      t.setTimeout = function () {
        return new o(i.call(setTimeout, n, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new o(i.call(setInterval, n, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(n, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, r(103), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(this, r(6));
  }, function (e, t, r) {
    (function (e, t) {
      !function (e, r) {
        "use strict";

        if (!e.setImmediate) {
          var n,
              i,
              o,
              a,
              s,
              f = 1,
              c = {},
              u = !1,
              d = e.document,
              h = Object.getPrototypeOf && Object.getPrototypeOf(e);
          h = h && h.setTimeout ? h : e, "[object process]" === {}.toString.call(e.process) ? n = function n(e) {
            t.nextTick(function () {
              p(e);
            });
          } : !function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                  r = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = r, t;
            }
          }() ? e.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (e) {
            p(e.data);
          }, n = function n(e) {
            o.port2.postMessage(e);
          }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, n = function n(e) {
            var t = d.createElement("script");
            t.onreadystatechange = function () {
              p(e), t.onreadystatechange = null, i.removeChild(t), t = null;
            }, i.appendChild(t);
          }) : n = function n(e) {
            setTimeout(p, 0, e);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && p(+t.data.slice(a.length));
          }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), n = function n(t) {
            e.postMessage(a + t, "*");
          }), h.setImmediate = function (e) {
            "function" != typeof e && (e = new Function("" + e));

            for (var t = new Array(arguments.length - 1), r = 0; r < t.length; r++) {
              t[r] = arguments[r + 1];
            }

            var i = {
              callback: e,
              args: t
            };
            return c[f] = i, n(f), f++;
          }, h.clearImmediate = l;
        }

        function l(e) {
          delete c[e];
        }

        function p(e) {
          if (u) setTimeout(p, 0, e);else {
            var t = c[e];

            if (t) {
              u = !0;

              try {
                !function (e) {
                  var t = e.callback,
                      r = e.args;

                  switch (r.length) {
                    case 0:
                      t();
                      break;

                    case 1:
                      t(r[0]);
                      break;

                    case 2:
                      t(r[0], r[1]);
                      break;

                    case 3:
                      t(r[0], r[1], r[2]);
                      break;

                    default:
                      t.apply(void 0, r);
                  }
                }(t);
              } finally {
                l(e), u = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(this, r(6), r(7));
  }, function (e, t, r) {
    (function (t) {
      function r(e) {
        try {
          if (!t.localStorage) return !1;
        } catch (e) {
          return !1;
        }

        var r = t.localStorage[e];
        return null != r && "true" === String(r).toLowerCase();
      }

      e.exports = function (e, t) {
        if (r("noDeprecation")) return e;
        var n = !1;
        return function () {
          if (!n) {
            if (r("throwDeprecation")) throw new Error(t);
            r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
          }

          return e.apply(this, arguments);
        };
      };
    }).call(this, r(6));
  }, function (e, t, r) {
    "use strict";

    e.exports = o;
    var n = r(51),
        i = Object.create(r(15));

    function o(e) {
      if (!(this instanceof o)) return new o(e);
      n.call(this, e);
    }

    i.inherits = r(0), i.inherits(o, n), o.prototype._transform = function (e, t, r) {
      r(null, e);
    };
  }, function (e, t, r) {
    e.exports = r(31);
  }, function (e, t, r) {
    e.exports = r(11);
  }, function (e, t, r) {
    e.exports = r(30).Transform;
  }, function (e, t, r) {
    e.exports = r(30).PassThrough;
  }, function (e, t, r) {
    var n = r(0),
        i = r(13),
        o = r(1).Buffer,
        a = [1518500249, 1859775393, -1894007588, -899497514],
        s = new Array(80);

    function f() {
      this.init(), this._w = s, i.call(this, 64, 56);
    }

    function c(e) {
      return e << 30 | e >>> 2;
    }

    function u(e, t, r, n) {
      return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, f.prototype._update = function (e) {
      for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, d = 0; d < 16; ++d) {
        r[d] = e.readInt32BE(4 * d);
      }

      for (; d < 80; ++d) {
        r[d] = r[d - 3] ^ r[d - 8] ^ r[d - 14] ^ r[d - 16];
      }

      for (var h = 0; h < 80; ++h) {
        var l = ~~(h / 20),
            p = 0 | ((t = n) << 5 | t >>> 27) + u(l, i, o, s) + f + r[h] + a[l];
        f = s, s = o, o = c(i), i = n, n = p;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0;
    }, f.prototype._hash = function () {
      var e = o.allocUnsafe(20);
      return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(0),
        i = r(13),
        o = r(1).Buffer,
        a = [1518500249, 1859775393, -1894007588, -899497514],
        s = new Array(80);

    function f() {
      this.init(), this._w = s, i.call(this, 64, 56);
    }

    function c(e) {
      return e << 5 | e >>> 27;
    }

    function u(e) {
      return e << 30 | e >>> 2;
    }

    function d(e, t, r, n) {
      return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, f.prototype._update = function (e) {
      for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, h = 0; h < 16; ++h) {
        r[h] = e.readInt32BE(4 * h);
      }

      for (; h < 80; ++h) {
        r[h] = (t = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16]) << 1 | t >>> 31;
      }

      for (var l = 0; l < 80; ++l) {
        var p = ~~(l / 20),
            b = c(n) + d(p, i, o, s) + f + r[l] + a[p] | 0;
        f = s, s = o, o = u(i), i = n, n = b;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0;
    }, f.prototype._hash = function () {
      var e = o.allocUnsafe(20);
      return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(0),
        i = r(52),
        o = r(13),
        a = r(1).Buffer,
        s = new Array(64);

    function f() {
      this.init(), this._w = s, o.call(this, 64, 56);
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
    }, f.prototype._hash = function () {
      var e = a.allocUnsafe(28);
      return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(0),
        i = r(53),
        o = r(13),
        a = r(1).Buffer,
        s = new Array(160);

    function f() {
      this.init(), this._w = s, o.call(this, 128, 112);
    }

    n(f, i), f.prototype.init = function () {
      return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
    }, f.prototype._hash = function () {
      var e = a.allocUnsafe(48);

      function t(t, r, n) {
        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
      }

      return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
    }, e.exports = f;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        i = r(1).Buffer,
        o = r(9),
        a = i.alloc(128);

    function s(e, t) {
      o.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([t, a], 64));

      for (var r = this._ipad = i.allocUnsafe(64), n = this._opad = i.allocUnsafe(64), s = 0; s < 64; s++) {
        r[s] = 54 ^ t[s], n[s] = 92 ^ t[s];
      }

      this._hash = [r];
    }

    n(s, o), s.prototype._update = function (e) {
      this._hash.push(e);
    }, s.prototype._final = function () {
      var e = this._alg(i.concat(this._hash));

      return this._alg(i.concat([this._opad, e]));
    }, e.exports = s;
  }, function (e, t, r) {
    e.exports = r(56);
  }, function (e, t, r) {
    (function (t, n) {
      var i,
          o = r(58),
          a = r(59),
          s = r(60),
          f = r(1).Buffer,
          c = t.crypto && t.crypto.subtle,
          u = {
        sha: "SHA-1",
        "sha-1": "SHA-1",
        sha1: "SHA-1",
        sha256: "SHA-256",
        "sha-256": "SHA-256",
        sha384: "SHA-384",
        "sha-384": "SHA-384",
        "sha-512": "SHA-512",
        sha512: "SHA-512"
      },
          d = [];

      function h(e, t, r, n, i) {
        return c.importKey("raw", e, {
          name: "PBKDF2"
        }, !1, ["deriveBits"]).then(function (e) {
          return c.deriveBits({
            name: "PBKDF2",
            salt: t,
            iterations: r,
            hash: {
              name: i
            }
          }, e, n << 3);
        }).then(function (e) {
          return f.from(e);
        });
      }

      e.exports = function (e, r, l, p, b, m) {
        "function" == typeof b && (m = b, b = void 0);
        var y = u[(b = b || "sha1").toLowerCase()];
        if (!y || "function" != typeof t.Promise) return n.nextTick(function () {
          var t;

          try {
            t = s(e, r, l, p, b);
          } catch (e) {
            return m(e);
          }

          m(null, t);
        });
        if (o(e, r, l, p), "function" != typeof m) throw new Error("No callback provided to pbkdf2");
        f.isBuffer(e) || (e = f.from(e, a)), f.isBuffer(r) || (r = f.from(r, a)), function (e, t) {
          e.then(function (e) {
            n.nextTick(function () {
              t(null, e);
            });
          }, function (e) {
            n.nextTick(function () {
              t(e);
            });
          });
        }(function (e) {
          if (t.process && !t.process.browser) return Promise.resolve(!1);
          if (!c || !c.importKey || !c.deriveBits) return Promise.resolve(!1);
          if (void 0 !== d[e]) return d[e];
          var r = h(i = i || f.alloc(8), i, 10, 128, e).then(function () {
            return !0;
          }).catch(function () {
            return !1;
          });
          return d[e] = r, r;
        }(y).then(function (t) {
          return t ? h(e, r, l, p, y) : s(e, r, l, p, b);
        }), m);
      };
    }).call(this, r(6), r(7));
  }, function (e, t, r) {
    var n = r(118),
        i = r(36),
        o = r(37),
        a = r(131),
        s = r(23);

    function f(e, t, r) {
      if (e = e.toLowerCase(), o[e]) return i.createCipheriv(e, t, r);
      if (a[e]) return new n({
        key: t,
        iv: r,
        mode: e
      });
      throw new TypeError("invalid suite type");
    }

    function c(e, t, r) {
      if (e = e.toLowerCase(), o[e]) return i.createDecipheriv(e, t, r);
      if (a[e]) return new n({
        key: t,
        iv: r,
        mode: e,
        decrypt: !0
      });
      throw new TypeError("invalid suite type");
    }

    t.createCipher = t.Cipher = function (e, t) {
      var r, n;
      if (e = e.toLowerCase(), o[e]) r = o[e].key, n = o[e].iv;else {
        if (!a[e]) throw new TypeError("invalid suite type");
        r = 8 * a[e].key, n = a[e].iv;
      }
      var i = s(t, !1, r, n);
      return f(e, i.key, i.iv);
    }, t.createCipheriv = t.Cipheriv = f, t.createDecipher = t.Decipher = function (e, t) {
      var r, n;
      if (e = e.toLowerCase(), o[e]) r = o[e].key, n = o[e].iv;else {
        if (!a[e]) throw new TypeError("invalid suite type");
        r = 8 * a[e].key, n = a[e].iv;
      }
      var i = s(t, !1, r, n);
      return c(e, i.key, i.iv);
    }, t.createDecipheriv = t.Decipheriv = c, t.listCiphers = t.getCiphers = function () {
      return Object.keys(a).concat(i.getCiphers());
    };
  }, function (e, t, r) {
    var n = r(9),
        i = r(119),
        o = r(0),
        a = r(1).Buffer,
        s = {
      "des-ede3-cbc": i.CBC.instantiate(i.EDE),
      "des-ede3": i.EDE,
      "des-ede-cbc": i.CBC.instantiate(i.EDE),
      "des-ede": i.EDE,
      "des-cbc": i.CBC.instantiate(i.DES),
      "des-ecb": i.DES
    };

    function f(e) {
      n.call(this);
      var t,
          r = e.mode.toLowerCase(),
          i = s[r];
      t = e.decrypt ? "decrypt" : "encrypt";
      var o = e.key;
      a.isBuffer(o) || (o = a.from(o)), "des-ede" !== r && "des-ede-cbc" !== r || (o = a.concat([o, o.slice(0, 8)]));
      var f = e.iv;
      a.isBuffer(f) || (f = a.from(f)), this._des = i.create({
        key: o,
        iv: f,
        type: t
      });
    }

    s.des = s["des-cbc"], s.des3 = s["des-ede3-cbc"], e.exports = f, o(f, n), f.prototype._update = function (e) {
      return a.from(this._des.update(e));
    }, f.prototype._final = function () {
      return a.from(this._des.final());
    };
  }, function (e, t, r) {
    "use strict";

    t.utils = r(61), t.Cipher = r(35), t.DES = r(62), t.CBC = r(120), t.EDE = r(121);
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        i = r(0),
        o = {};

    function a(e) {
      n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);

      for (var t = 0; t < this.iv.length; t++) {
        this.iv[t] = e[t];
      }
    }

    t.instantiate = function (e) {
      function t(t) {
        e.call(this, t), this._cbcInit();
      }

      i(t, e);

      for (var r = Object.keys(o), n = 0; n < r.length; n++) {
        var a = r[n];
        t.prototype[a] = o[a];
      }

      return t.create = function (e) {
        return new t(e);
      }, t;
    }, o._cbcInit = function () {
      var e = new a(this.options.iv);
      this._cbcState = e;
    }, o._update = function (e, t, r, n) {
      var i = this._cbcState,
          o = this.constructor.super_.prototype,
          a = i.iv;

      if ("encrypt" === this.type) {
        for (var s = 0; s < this.blockSize; s++) {
          a[s] ^= e[t + s];
        }

        o._update.call(this, a, 0, r, n);

        for (s = 0; s < this.blockSize; s++) {
          a[s] = r[n + s];
        }
      } else {
        o._update.call(this, e, t, r, n);

        for (s = 0; s < this.blockSize; s++) {
          r[n + s] ^= a[s];
        }

        for (s = 0; s < this.blockSize; s++) {
          a[s] = e[t + s];
        }
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        i = r(0),
        o = r(35),
        a = r(62);

    function s(e, t) {
      n.equal(t.length, 24, "Invalid key length");
      var r = t.slice(0, 8),
          i = t.slice(8, 16),
          o = t.slice(16, 24);
      this.ciphers = "encrypt" === e ? [a.create({
        type: "encrypt",
        key: r
      }), a.create({
        type: "decrypt",
        key: i
      }), a.create({
        type: "encrypt",
        key: o
      })] : [a.create({
        type: "decrypt",
        key: o
      }), a.create({
        type: "encrypt",
        key: i
      }), a.create({
        type: "decrypt",
        key: r
      })];
    }

    function f(e) {
      o.call(this, e);
      var t = new s(this.type, this.options.key);
      this._edeState = t;
    }

    i(f, o), e.exports = f, f.create = function (e) {
      return new f(e);
    }, f.prototype._update = function (e, t, r, n) {
      var i = this._edeState;
      i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
    }, f.prototype._pad = a.prototype._pad, f.prototype._unpad = a.prototype._unpad;
  }, function (e, t, r) {
    var n = r(37),
        i = r(66),
        o = r(1).Buffer,
        a = r(67),
        s = r(9),
        f = r(22),
        c = r(23);

    function u(e, t, r) {
      s.call(this), this._cache = new h(), this._cipher = new f.AES(t), this._prev = o.from(r), this._mode = e, this._autopadding = !0;
    }

    r(0)(u, s), u.prototype._update = function (e) {
      var t, r;

      this._cache.add(e);

      for (var n = []; t = this._cache.get();) {
        r = this._mode.encrypt(this, t), n.push(r);
      }

      return o.concat(n);
    };
    var d = o.alloc(16, 16);

    function h() {
      this.cache = o.allocUnsafe(0);
    }

    function l(e, t, r) {
      var s = n[e.toLowerCase()];
      if (!s) throw new TypeError("invalid suite type");
      if ("string" == typeof t && (t = o.from(t)), t.length !== s.key / 8) throw new TypeError("invalid key length " + t.length);
      if ("string" == typeof r && (r = o.from(r)), "GCM" !== s.mode && r.length !== s.iv) throw new TypeError("invalid iv length " + r.length);
      return "stream" === s.type ? new a(s.module, t, r) : "auth" === s.type ? new i(s.module, t, r) : new u(s.module, t, r);
    }

    u.prototype._final = function () {
      var e = this._cache.flush();

      if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
      if (!e.equals(d)) throw this._cipher.scrub(), new Error("data not multiple of block length");
    }, u.prototype.setAutoPadding = function (e) {
      return this._autopadding = !!e, this;
    }, h.prototype.add = function (e) {
      this.cache = o.concat([this.cache, e]);
    }, h.prototype.get = function () {
      if (this.cache.length > 15) {
        var e = this.cache.slice(0, 16);
        return this.cache = this.cache.slice(16), e;
      }

      return null;
    }, h.prototype.flush = function () {
      for (var e = 16 - this.cache.length, t = o.allocUnsafe(e), r = -1; ++r < e;) {
        t.writeUInt8(e, r);
      }

      return o.concat([this.cache, t]);
    }, t.createCipheriv = l, t.createCipher = function (e, t) {
      var r = n[e.toLowerCase()];
      if (!r) throw new TypeError("invalid suite type");
      var i = c(t, !1, r.key, r.iv);
      return l(e, i.key, i.iv);
    };
  }, function (e, t) {
    t.encrypt = function (e, t) {
      return e._cipher.encryptBlock(t);
    }, t.decrypt = function (e, t) {
      return e._cipher.decryptBlock(t);
    };
  }, function (e, t, r) {
    var n = r(16);
    t.encrypt = function (e, t) {
      var r = n(t, e._prev);
      return e._prev = e._cipher.encryptBlock(r), e._prev;
    }, t.decrypt = function (e, t) {
      var r = e._prev;
      e._prev = t;

      var i = e._cipher.decryptBlock(t);

      return n(i, r);
    };
  }, function (e, t, r) {
    var n = r(1).Buffer,
        i = r(16);

    function o(e, t, r) {
      var o = t.length,
          a = i(t, e._cache);
      return e._cache = e._cache.slice(o), e._prev = n.concat([e._prev, r ? t : a]), a;
    }

    t.encrypt = function (e, t, r) {
      for (var i, a = n.allocUnsafe(0); t.length;) {
        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
          a = n.concat([a, o(e, t, r)]);
          break;
        }

        i = e._cache.length, a = n.concat([a, o(e, t.slice(0, i), r)]), t = t.slice(i);
      }

      return a;
    };
  }, function (e, t, r) {
    var n = r(1).Buffer;

    function i(e, t, r) {
      var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
      return e._prev = n.concat([e._prev.slice(1), n.from([r ? t : i])]), i;
    }

    t.encrypt = function (e, t, r) {
      for (var o = t.length, a = n.allocUnsafe(o), s = -1; ++s < o;) {
        a[s] = i(e, t[s], r);
      }

      return a;
    };
  }, function (e, t, r) {
    var n = r(1).Buffer;

    function i(e, t, r) {
      for (var n, i, a = -1, s = 0; ++a < 8;) {
        n = t & 1 << 7 - a ? 128 : 0, s += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> a % 8, e._prev = o(e._prev, r ? n : i);
      }

      return s;
    }

    function o(e, t) {
      var r = e.length,
          i = -1,
          o = n.allocUnsafe(e.length);

      for (e = n.concat([e, n.from([t])]); ++i < r;) {
        o[i] = e[i] << 1 | e[i + 1] >> 7;
      }

      return o;
    }

    t.encrypt = function (e, t, r) {
      for (var o = t.length, a = n.allocUnsafe(o), s = -1; ++s < o;) {
        a[s] = i(e, t[s], r);
      }

      return a;
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(16);

      function i(e) {
        return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
      }

      t.encrypt = function (t, r) {
        for (; t._cache.length < r.length;) {
          t._cache = e.concat([t._cache, i(t)]);
        }

        var o = t._cache.slice(0, r.length);

        return t._cache = t._cache.slice(r.length), n(r, o);
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    var n = r(1).Buffer,
        i = n.alloc(16, 0);

    function o(e) {
      var t = n.allocUnsafe(16);
      return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
    }

    function a(e) {
      this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
    }

    a.prototype.ghash = function (e) {
      for (var t = -1; ++t < e.length;) {
        this.state[t] ^= e[t];
      }

      this._multiply();
    }, a.prototype._multiply = function () {
      for (var e, t, r, n = [(e = this.h).readUInt32BE(0), e.readUInt32BE(4), e.readUInt32BE(8), e.readUInt32BE(12)], i = [0, 0, 0, 0], a = -1; ++a < 128;) {
        for (0 != (this.state[~~(a / 8)] & 1 << 7 - a % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--) {
          n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
        }

        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ 225 << 24);
      }

      this.state = o(i);
    }, a.prototype.update = function (e) {
      var t;

      for (this.cache = n.concat([this.cache, e]); this.cache.length >= 16;) {
        t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
      }
    }, a.prototype.final = function (e, t) {
      return this.cache.length && this.ghash(n.concat([this.cache, i], 16)), this.ghash(o([0, e, 0, t])), this.state;
    }, e.exports = a;
  }, function (e, t, r) {
    var n = r(66),
        i = r(1).Buffer,
        o = r(37),
        a = r(67),
        s = r(9),
        f = r(22),
        c = r(23);

    function u(e, t, r) {
      s.call(this), this._cache = new d(), this._last = void 0, this._cipher = new f.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
    }

    function d() {
      this.cache = i.allocUnsafe(0);
    }

    function h(e, t, r) {
      var s = o[e.toLowerCase()];
      if (!s) throw new TypeError("invalid suite type");
      if ("string" == typeof r && (r = i.from(r)), "GCM" !== s.mode && r.length !== s.iv) throw new TypeError("invalid iv length " + r.length);
      if ("string" == typeof t && (t = i.from(t)), t.length !== s.key / 8) throw new TypeError("invalid key length " + t.length);
      return "stream" === s.type ? new a(s.module, t, r, !0) : "auth" === s.type ? new n(s.module, t, r, !0) : new u(s.module, t, r);
    }

    r(0)(u, s), u.prototype._update = function (e) {
      var t, r;

      this._cache.add(e);

      for (var n = []; t = this._cache.get(this._autopadding);) {
        r = this._mode.decrypt(this, t), n.push(r);
      }

      return i.concat(n);
    }, u.prototype._final = function () {
      var e = this._cache.flush();

      if (this._autopadding) return function (e) {
        var t = e[15];
        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
        var r = -1;

        for (; ++r < t;) {
          if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
        }

        if (16 === t) return;
        return e.slice(0, 16 - t);
      }(this._mode.decrypt(this, e));
      if (e) throw new Error("data not multiple of block length");
    }, u.prototype.setAutoPadding = function (e) {
      return this._autopadding = !!e, this;
    }, d.prototype.add = function (e) {
      this.cache = i.concat([this.cache, e]);
    }, d.prototype.get = function (e) {
      var t;

      if (e) {
        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
      } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;

      return null;
    }, d.prototype.flush = function () {
      if (this.cache.length) return this.cache;
    }, t.createDecipher = function (e, t) {
      var r = o[e.toLowerCase()];
      if (!r) throw new TypeError("invalid suite type");
      var n = c(t, !1, r.key, r.iv);
      return h(e, n.key, n.iv);
    }, t.createDecipheriv = h;
  }, function (e, t) {
    t["des-ecb"] = {
      key: 8,
      iv: 0
    }, t["des-cbc"] = t.des = {
      key: 8,
      iv: 8
    }, t["des-ede3-cbc"] = t.des3 = {
      key: 24,
      iv: 8
    }, t["des-ede3"] = {
      key: 24,
      iv: 0
    }, t["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, t["des-ede"] = {
      key: 16,
      iv: 0
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(68),
          i = r(135),
          o = r(136);
      var a = {
        binary: !0,
        hex: !0,
        base64: !0
      };
      t.DiffieHellmanGroup = t.createDiffieHellmanGroup = t.getDiffieHellman = function (t) {
        var r = new e(i[t].prime, "hex"),
            n = new e(i[t].gen, "hex");
        return new o(r, n);
      }, t.createDiffieHellman = t.DiffieHellman = function t(r, i, s, f) {
        return e.isBuffer(i) || void 0 === a[i] ? t(r, "binary", i, s) : (i = i || "binary", f = f || "binary", s = s || new e([2]), e.isBuffer(s) || (s = new e(s, f)), "number" == typeof r ? new o(n(r, s), s, !0) : (e.isBuffer(r) || (r = new e(r, i)), new o(r, s, !0)));
      };
    }).call(this, r(2).Buffer);
  }, function (e, t) {}, function (e, t) {}, function (e) {
    e.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"}}');
  }, function (e, t, r) {
    (function (t) {
      var n = r(3),
          i = new (r(70))(),
          o = new n(24),
          a = new n(11),
          s = new n(10),
          f = new n(3),
          c = new n(7),
          u = r(68),
          d = r(12);

      function h(e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this._pub = new n(e), this;
      }

      function l(e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this._priv = new n(e), this;
      }

      e.exports = b;
      var p = {};

      function b(e, t, r) {
        this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = h, this.setPrivateKey = l) : this._primeCode = 8;
      }

      function m(e, r) {
        var n = new t(e.toArray());
        return r ? n.toString(r) : n;
      }

      Object.defineProperty(b.prototype, "verifyError", {
        enumerable: !0,
        get: function get() {
          return "number" != typeof this._primeCode && (this._primeCode = function (e, t) {
            var r = t.toString("hex"),
                n = [r, e.toString(16)].join("_");
            if (n in p) return p[n];
            var d,
                h = 0;
            if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return h += 1, h += "02" === r || "05" === r ? 8 : 4, p[n] = h, h;

            switch (i.test(e.shrn(1)) || (h += 2), r) {
              case "02":
                e.mod(o).cmp(a) && (h += 8);
                break;

              case "05":
                (d = e.mod(s)).cmp(f) && d.cmp(c) && (h += 8);
                break;

              default:
                h += 4;
            }

            return p[n] = h, h;
          }(this.__prime, this.__gen)), this._primeCode;
        }
      }), b.prototype.generateKeys = function () {
        return this._priv || (this._priv = new n(d(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
      }, b.prototype.computeSecret = function (e) {
        var r = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(),
            i = new t(r.toArray()),
            o = this.getPrime();

        if (i.length < o.length) {
          var a = new t(o.length - i.length);
          a.fill(0), i = t.concat([a, i]);
        }

        return i;
      }, b.prototype.getPublicKey = function (e) {
        return m(this._pub, e);
      }, b.prototype.getPrivateKey = function (e) {
        return m(this._priv, e);
      }, b.prototype.getPrime = function (e) {
        return m(this.__prime, e);
      }, b.prototype.getGenerator = function (e) {
        return m(this._gen, e);
      }, b.prototype.setGenerator = function (e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this.__gen = e, this._gen = new n(e), this;
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = r(14),
          i = r(28),
          o = r(0),
          a = r(138),
          s = r(170),
          f = r(56);

      function c(e) {
        i.Writable.call(this);
        var t = f[e];
        if (!t) throw new Error("Unknown message digest");
        this._hashType = t.hash, this._hash = n(t.hash), this._tag = t.id, this._signType = t.sign;
      }

      function u(e) {
        i.Writable.call(this);
        var t = f[e];
        if (!t) throw new Error("Unknown message digest");
        this._hash = n(t.hash), this._tag = t.id, this._signType = t.sign;
      }

      function d(e) {
        return new c(e);
      }

      function h(e) {
        return new u(e);
      }

      Object.keys(f).forEach(function (e) {
        f[e].id = new t(f[e].id, "hex"), f[e.toLowerCase()] = f[e];
      }), o(c, i.Writable), c.prototype._write = function (e, t, r) {
        this._hash.update(e), r();
      }, c.prototype.update = function (e, r) {
        return "string" == typeof e && (e = new t(e, r)), this._hash.update(e), this;
      }, c.prototype.sign = function (e, t) {
        this.end();

        var r = this._hash.digest(),
            n = a(r, e, this._hashType, this._signType, this._tag);

        return t ? n.toString(t) : n;
      }, o(u, i.Writable), u.prototype._write = function (e, t, r) {
        this._hash.update(e), r();
      }, u.prototype.update = function (e, r) {
        return "string" == typeof e && (e = new t(e, r)), this._hash.update(e), this;
      }, u.prototype.verify = function (e, r, n) {
        "string" == typeof r && (r = new t(r, n)), this.end();

        var i = this._hash.digest();

        return s(r, i, e, this._signType, this._tag);
      }, e.exports = {
        Sign: d,
        Verify: h,
        createSign: d,
        createVerify: h
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = r(54),
          i = r(39),
          o = r(40).ec,
          a = r(3),
          s = r(25),
          f = r(80);

      function c(e, r, i, o) {
        if ((e = new t(e.toArray())).length < r.byteLength()) {
          var a = new t(r.byteLength() - e.length);
          a.fill(0), e = t.concat([a, e]);
        }

        var s = i.length,
            f = function (e, r) {
          e = (e = u(e, r)).mod(r);
          var n = new t(e.toArray());

          if (n.length < r.byteLength()) {
            var i = new t(r.byteLength() - n.length);
            i.fill(0), n = t.concat([i, n]);
          }

          return n;
        }(i, r),
            c = new t(s);

        c.fill(1);
        var d = new t(s);
        return d.fill(0), d = n(o, d).update(c).update(new t([0])).update(e).update(f).digest(), c = n(o, d).update(c).digest(), {
          k: d = n(o, d).update(c).update(new t([1])).update(e).update(f).digest(),
          v: c = n(o, d).update(c).digest()
        };
      }

      function u(e, t) {
        var r = new a(e),
            n = (e.length << 3) - t.bitLength();
        return n > 0 && r.ishrn(n), r;
      }

      function d(e, r, i) {
        var o, a;

        do {
          for (o = new t(0); 8 * o.length < e.bitLength();) {
            r.v = n(i, r.k).update(r.v).digest(), o = t.concat([o, r.v]);
          }

          a = u(o, e), r.k = n(i, r.k).update(r.v).update(new t([0])).digest(), r.v = n(i, r.k).update(r.v).digest();
        } while (-1 !== a.cmp(e));

        return a;
      }

      function h(e, t, r, n) {
        return e.toRed(a.mont(r)).redPow(t).fromRed().mod(n);
      }

      e.exports = function (e, r, n, l, p) {
        var b = s(r);

        if (b.curve) {
          if ("ecdsa" !== l && "ecdsa/rsa" !== l) throw new Error("wrong private key type");
          return function (e, r) {
            var n = f[r.curve.join(".")];
            if (!n) throw new Error("unknown curve " + r.curve.join("."));
            var i = new o(n).keyFromPrivate(r.privateKey).sign(e);
            return new t(i.toDER());
          }(e, b);
        }

        if ("dsa" === b.type) {
          if ("dsa" !== l) throw new Error("wrong private key type");
          return function (e, r, n) {
            var i,
                o = r.params.priv_key,
                s = r.params.p,
                f = r.params.q,
                l = r.params.g,
                p = new a(0),
                b = u(e, f).mod(f),
                m = !1,
                y = c(o, f, e, n);

            for (; !1 === m;) {
              i = d(f, y, n), p = h(l, i, s, f), 0 === (m = i.invm(f).imul(b.add(o.mul(p))).mod(f)).cmpn(0) && (m = !1, p = new a(0));
            }

            return function (e, r) {
              e = e.toArray(), r = r.toArray(), 128 & e[0] && (e = [0].concat(e));
              128 & r[0] && (r = [0].concat(r));
              var n = [48, e.length + r.length + 4, 2, e.length];
              return n = n.concat(e, [2, r.length], r), new t(n);
            }(p, m);
          }(e, b, n);
        }

        if ("rsa" !== l && "ecdsa/rsa" !== l) throw new Error("wrong private key type");
        e = t.concat([p, e]);

        for (var m = b.modulus.byteLength(), y = [0, 1]; e.length + y.length + 1 < m;) {
          y.push(255);
        }

        y.push(0);

        for (var v = -1; ++v < e.length;) {
          y.push(e[v]);
        }

        return i(y, b);
      }, e.exports.getKey = c, e.exports.makeKey = d;
    }).call(this, r(2).Buffer);
  }, function (e) {
    e.exports = JSON.parse('{"_from":"elliptic@^6.0.0","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_shasum":"05c5678d7173c049d8ca433552224a495d0e3762","_spec":"elliptic@^6.0.0","_where":"/Users/thi/gh/Documents/GitHub/iceteaweb3/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}');
  }, function (e, t, r) {
    "use strict";

    var n = r(5),
        i = r(3),
        o = r(0),
        a = r(24),
        s = n.assert;

    function f(e) {
      a.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
    }

    function c(e, t, r, n) {
      a.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
    }

    function u(e, t, r, n) {
      a.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
    }

    o(f, a), e.exports = f, f.prototype._getEndomorphism = function (e) {
      if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
        var t, r;
        if (e.beta) t = new i(e.beta, 16).toRed(this.red);else {
          var n = this._getEndoRoots(this.p);

          t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
        }
        if (e.lambda) r = new i(e.lambda, 16);else {
          var o = this._getEndoRoots(this.n);

          0 === this.g.mul(o[0]).x.cmp(this.g.x.redMul(t)) ? r = o[0] : (r = o[1], s(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
        }
        return {
          beta: t,
          lambda: r,
          basis: e.basis ? e.basis.map(function (e) {
            return {
              a: new i(e.a, 16),
              b: new i(e.b, 16)
            };
          }) : this._getEndoBasis(r)
        };
      }
    }, f.prototype._getEndoRoots = function (e) {
      var t = e === this.p ? this.red : i.mont(e),
          r = new i(2).toRed(t).redInvm(),
          n = r.redNeg(),
          o = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
      return [n.redAdd(o).fromRed(), n.redSub(o).fromRed()];
    }, f.prototype._getEndoBasis = function (e) {
      for (var t, r, n, o, a, s, f, c, u, d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), h = e, l = this.n.clone(), p = new i(1), b = new i(0), m = new i(0), y = new i(1), v = 0; 0 !== h.cmpn(0);) {
        var g = l.div(h);
        c = l.sub(g.mul(h)), u = m.sub(g.mul(p));

        var _ = y.sub(g.mul(b));

        if (!n && c.cmp(d) < 0) t = f.neg(), r = p, n = c.neg(), o = u;else if (n && 2 == ++v) break;
        f = c, l = h, h = c, m = p, p = u, y = b, b = _;
      }

      a = c.neg(), s = u;
      var w = n.sqr().add(o.sqr());
      return a.sqr().add(s.sqr()).cmp(w) >= 0 && (a = t, s = r), n.negative && (n = n.neg(), o = o.neg()), a.negative && (a = a.neg(), s = s.neg()), [{
        a: n,
        b: o
      }, {
        a: a,
        b: s
      }];
    }, f.prototype._endoSplit = function (e) {
      var t = this.endo.basis,
          r = t[0],
          n = t[1],
          i = n.b.mul(e).divRound(this.n),
          o = r.b.neg().mul(e).divRound(this.n),
          a = i.mul(r.a),
          s = o.mul(n.a),
          f = i.mul(r.b),
          c = o.mul(n.b);
      return {
        k1: e.sub(a).sub(s),
        k2: f.add(c).neg()
      };
    }, f.prototype.pointFromX = function (e, t) {
      (e = new i(e, 16)).red || (e = e.toRed(this.red));
      var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
          n = r.redSqrt();
      if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
      var o = n.fromRed().isOdd();
      return (t && !o || !t && o) && (n = n.redNeg()), this.point(e, n);
    }, f.prototype.validate = function (e) {
      if (e.inf) return !0;
      var t = e.x,
          r = e.y,
          n = this.a.redMul(t),
          i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
      return 0 === r.redSqr().redISub(i).cmpn(0);
    }, f.prototype._endoWnafMulAdd = function (e, t, r) {
      for (var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++) {
        var a = this._endoSplit(t[o]),
            s = e[o],
            f = s._getBeta();

        a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), f = f.neg(!0)), n[2 * o] = s, n[2 * o + 1] = f, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
      }

      for (var c = this._wnafMulAdd(1, n, i, 2 * o, r), u = 0; u < 2 * o; u++) {
        n[u] = null, i[u] = null;
      }

      return c;
    }, o(c, a.BasePoint), f.prototype.point = function (e, t, r) {
      return new c(this, e, t, r);
    }, f.prototype.pointFromJSON = function (e, t) {
      return c.fromJSON(this, e, t);
    }, c.prototype._getBeta = function () {
      if (this.curve.endo) {
        var e = this.precomputed;
        if (e && e.beta) return e.beta;
        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

        if (e) {
          var r = this.curve,
              n = function n(e) {
            return r.point(e.x.redMul(r.endo.beta), e.y);
          };

          e.beta = t, t.precomputed = {
            beta: null,
            naf: e.naf && {
              wnd: e.naf.wnd,
              points: e.naf.points.map(n)
            },
            doubles: e.doubles && {
              step: e.doubles.step,
              points: e.doubles.points.map(n)
            }
          };
        }

        return t;
      }
    }, c.prototype.toJSON = function () {
      return this.precomputed ? [this.x, this.y, this.precomputed && {
        doubles: this.precomputed.doubles && {
          step: this.precomputed.doubles.step,
          points: this.precomputed.doubles.points.slice(1)
        },
        naf: this.precomputed.naf && {
          wnd: this.precomputed.naf.wnd,
          points: this.precomputed.naf.points.slice(1)
        }
      }] : [this.x, this.y];
    }, c.fromJSON = function (e, t, r) {
      "string" == typeof t && (t = JSON.parse(t));
      var n = e.point(t[0], t[1], r);
      if (!t[2]) return n;

      function i(t) {
        return e.point(t[0], t[1], r);
      }

      var o = t[2];
      return n.precomputed = {
        beta: null,
        doubles: o.doubles && {
          step: o.doubles.step,
          points: [n].concat(o.doubles.points.map(i))
        },
        naf: o.naf && {
          wnd: o.naf.wnd,
          points: [n].concat(o.naf.points.map(i))
        }
      }, n;
    }, c.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
    }, c.prototype.isInfinity = function () {
      return this.inf;
    }, c.prototype.add = function (e) {
      if (this.inf) return e;
      if (e.inf) return this;
      if (this.eq(e)) return this.dbl();
      if (this.neg().eq(e)) return this.curve.point(null, null);
      if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
      var t = this.y.redSub(e.y);
      0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
      var r = t.redSqr().redISub(this.x).redISub(e.x),
          n = t.redMul(this.x.redSub(r)).redISub(this.y);
      return this.curve.point(r, n);
    }, c.prototype.dbl = function () {
      if (this.inf) return this;
      var e = this.y.redAdd(this.y);
      if (0 === e.cmpn(0)) return this.curve.point(null, null);
      var t = this.curve.a,
          r = this.x.redSqr(),
          n = e.redInvm(),
          i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n),
          o = i.redSqr().redISub(this.x.redAdd(this.x)),
          a = i.redMul(this.x.redSub(o)).redISub(this.y);
      return this.curve.point(o, a);
    }, c.prototype.getX = function () {
      return this.x.fromRed();
    }, c.prototype.getY = function () {
      return this.y.fromRed();
    }, c.prototype.mul = function (e) {
      return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
    }, c.prototype.mulAdd = function (e, t, r) {
      var n = [this, t],
          i = [e, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
    }, c.prototype.jmulAdd = function (e, t, r) {
      var n = [this, t],
          i = [e, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
    }, c.prototype.eq = function (e) {
      return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
    }, c.prototype.neg = function (e) {
      if (this.inf) return this;
      var t = this.curve.point(this.x, this.y.redNeg());

      if (e && this.precomputed) {
        var r = this.precomputed,
            n = function n(e) {
          return e.neg();
        };

        t.precomputed = {
          naf: r.naf && {
            wnd: r.naf.wnd,
            points: r.naf.points.map(n)
          },
          doubles: r.doubles && {
            step: r.doubles.step,
            points: r.doubles.points.map(n)
          }
        };
      }

      return t;
    }, c.prototype.toJ = function () {
      return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
    }, o(u, a.BasePoint), f.prototype.jpoint = function (e, t, r) {
      return new u(this, e, t, r);
    }, u.prototype.toP = function () {
      if (this.isInfinity()) return this.curve.point(null, null);
      var e = this.z.redInvm(),
          t = e.redSqr(),
          r = this.x.redMul(t),
          n = this.y.redMul(t).redMul(e);
      return this.curve.point(r, n);
    }, u.prototype.neg = function () {
      return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    }, u.prototype.add = function (e) {
      if (this.isInfinity()) return e;
      if (e.isInfinity()) return this;
      var t = e.z.redSqr(),
          r = this.z.redSqr(),
          n = this.x.redMul(t),
          i = e.x.redMul(r),
          o = this.y.redMul(t.redMul(e.z)),
          a = e.y.redMul(r.redMul(this.z)),
          s = n.redSub(i),
          f = o.redSub(a);
      if (0 === s.cmpn(0)) return 0 !== f.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var c = s.redSqr(),
          u = c.redMul(s),
          d = n.redMul(c),
          h = f.redSqr().redIAdd(u).redISub(d).redISub(d),
          l = f.redMul(d.redISub(h)).redISub(o.redMul(u)),
          p = this.z.redMul(e.z).redMul(s);
      return this.curve.jpoint(h, l, p);
    }, u.prototype.mixedAdd = function (e) {
      if (this.isInfinity()) return e.toJ();
      if (e.isInfinity()) return this;
      var t = this.z.redSqr(),
          r = this.x,
          n = e.x.redMul(t),
          i = this.y,
          o = e.y.redMul(t).redMul(this.z),
          a = r.redSub(n),
          s = i.redSub(o);
      if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var f = a.redSqr(),
          c = f.redMul(a),
          u = r.redMul(f),
          d = s.redSqr().redIAdd(c).redISub(u).redISub(u),
          h = s.redMul(u.redISub(d)).redISub(i.redMul(c)),
          l = this.z.redMul(a);
      return this.curve.jpoint(d, h, l);
    }, u.prototype.dblp = function (e) {
      if (0 === e) return this;
      if (this.isInfinity()) return this;
      if (!e) return this.dbl();

      if (this.curve.zeroA || this.curve.threeA) {
        for (var t = this, r = 0; r < e; r++) {
          t = t.dbl();
        }

        return t;
      }

      var n = this.curve.a,
          i = this.curve.tinv,
          o = this.x,
          a = this.y,
          s = this.z,
          f = s.redSqr().redSqr(),
          c = a.redAdd(a);

      for (r = 0; r < e; r++) {
        var u = o.redSqr(),
            d = c.redSqr(),
            h = d.redSqr(),
            l = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(f)),
            p = o.redMul(d),
            b = l.redSqr().redISub(p.redAdd(p)),
            m = p.redISub(b),
            y = l.redMul(m);
        y = y.redIAdd(y).redISub(h);
        var v = c.redMul(s);
        r + 1 < e && (f = f.redMul(h)), o = b, s = v, c = y;
      }

      return this.curve.jpoint(o, c.redMul(i), s);
    }, u.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
    }, u.prototype._zeroDbl = function () {
      var e, t, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
        a = a.redIAdd(a);
        var s = n.redAdd(n).redIAdd(n),
            f = s.redSqr().redISub(a).redISub(a),
            c = o.redIAdd(o);
        c = (c = c.redIAdd(c)).redIAdd(c), e = f, t = s.redMul(a.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
      } else {
        var u = this.x.redSqr(),
            d = this.y.redSqr(),
            h = d.redSqr(),
            l = this.x.redAdd(d).redSqr().redISub(u).redISub(h);
        l = l.redIAdd(l);
        var p = u.redAdd(u).redIAdd(u),
            b = p.redSqr(),
            m = h.redIAdd(h);
        m = (m = m.redIAdd(m)).redIAdd(m), e = b.redISub(l).redISub(l), t = p.redMul(l.redISub(e)).redISub(m), r = (r = this.y.redMul(this.z)).redIAdd(r);
      }

      return this.curve.jpoint(e, t, r);
    }, u.prototype._threeDbl = function () {
      var e, t, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
        a = a.redIAdd(a);
        var s = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a),
            f = s.redSqr().redISub(a).redISub(a);
        e = f;
        var c = o.redIAdd(o);
        c = (c = c.redIAdd(c)).redIAdd(c), t = s.redMul(a.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
      } else {
        var u = this.z.redSqr(),
            d = this.y.redSqr(),
            h = this.x.redMul(d),
            l = this.x.redSub(u).redMul(this.x.redAdd(u));
        l = l.redAdd(l).redIAdd(l);
        var p = h.redIAdd(h),
            b = (p = p.redIAdd(p)).redAdd(p);
        e = l.redSqr().redISub(b), r = this.y.redAdd(this.z).redSqr().redISub(d).redISub(u);
        var m = d.redSqr();
        m = (m = (m = m.redIAdd(m)).redIAdd(m)).redIAdd(m), t = l.redMul(p.redISub(e)).redISub(m);
      }

      return this.curve.jpoint(e, t, r);
    }, u.prototype._dbl = function () {
      var e = this.curve.a,
          t = this.x,
          r = this.y,
          n = this.z,
          i = n.redSqr().redSqr(),
          o = t.redSqr(),
          a = r.redSqr(),
          s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),
          f = t.redAdd(t),
          c = (f = f.redIAdd(f)).redMul(a),
          u = s.redSqr().redISub(c.redAdd(c)),
          d = c.redISub(u),
          h = a.redSqr();
      h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
      var l = s.redMul(d).redISub(h),
          p = r.redAdd(r).redMul(n);
      return this.curve.jpoint(u, l, p);
    }, u.prototype.trpl = function () {
      if (!this.curve.zeroA) return this.dbl().add(this);
      var e = this.x.redSqr(),
          t = this.y.redSqr(),
          r = this.z.redSqr(),
          n = t.redSqr(),
          i = e.redAdd(e).redIAdd(e),
          o = i.redSqr(),
          a = this.x.redAdd(t).redSqr().redISub(e).redISub(n),
          s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
          f = n.redIAdd(n);
      f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
      var c = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(f),
          u = t.redMul(c);
      u = (u = u.redIAdd(u)).redIAdd(u);
      var d = this.x.redMul(s).redISub(u);
      d = (d = d.redIAdd(d)).redIAdd(d);
      var h = this.y.redMul(c.redMul(f.redISub(c)).redISub(a.redMul(s)));
      h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
      var l = this.z.redAdd(a).redSqr().redISub(r).redISub(s);
      return this.curve.jpoint(d, h, l);
    }, u.prototype.mul = function (e, t) {
      return e = new i(e, t), this.curve._wnafMul(this, e);
    }, u.prototype.eq = function (e) {
      if ("affine" === e.type) return this.eq(e.toJ());
      if (this === e) return !0;
      var t = this.z.redSqr(),
          r = e.z.redSqr();
      if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
      var n = t.redMul(this.z),
          i = r.redMul(e.z);
      return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
    }, u.prototype.eqXToP = function (e) {
      var t = this.z.redSqr(),
          r = e.toRed(this.curve.red).redMul(t);
      if (0 === this.x.cmp(r)) return !0;

      for (var n = e.clone(), i = this.curve.redN.redMul(t);;) {
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
      }
    }, u.prototype.inspect = function () {
      return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
    }, u.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(3),
        i = r(0),
        o = r(24),
        a = r(5);

    function s(e) {
      o.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    }

    function f(e, t, r) {
      o.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
    }

    i(s, o), e.exports = s, s.prototype.validate = function (e) {
      var t = e.normalize().x,
          r = t.redSqr(),
          n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
      return 0 === n.redSqrt().redSqr().cmp(n);
    }, i(f, o.BasePoint), s.prototype.decodePoint = function (e, t) {
      return this.point(a.toArray(e, t), 1);
    }, s.prototype.point = function (e, t) {
      return new f(this, e, t);
    }, s.prototype.pointFromJSON = function (e) {
      return f.fromJSON(this, e);
    }, f.prototype.precompute = function () {}, f.prototype._encode = function () {
      return this.getX().toArray("be", this.curve.p.byteLength());
    }, f.fromJSON = function (e, t) {
      return new f(e, t[0], t[1] || e.one);
    }, f.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, f.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    }, f.prototype.dbl = function () {
      var e = this.x.redAdd(this.z).redSqr(),
          t = this.x.redSub(this.z).redSqr(),
          r = e.redSub(t),
          n = e.redMul(t),
          i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
      return this.curve.point(n, i);
    }, f.prototype.add = function () {
      throw new Error("Not supported on Montgomery curve");
    }, f.prototype.diffAdd = function (e, t) {
      var r = this.x.redAdd(this.z),
          n = this.x.redSub(this.z),
          i = e.x.redAdd(e.z),
          o = e.x.redSub(e.z).redMul(r),
          a = i.redMul(n),
          s = t.z.redMul(o.redAdd(a).redSqr()),
          f = t.x.redMul(o.redISub(a).redSqr());
      return this.curve.point(s, f);
    }, f.prototype.mul = function (e) {
      for (var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) {
        i.push(t.andln(1));
      }

      for (var o = i.length - 1; o >= 0; o--) {
        0 === i[o] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
      }

      return n;
    }, f.prototype.mulAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, f.prototype.jumlAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, f.prototype.eq = function (e) {
      return 0 === this.getX().cmp(e.getX());
    }, f.prototype.normalize = function () {
      return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
    }, f.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(5),
        i = r(3),
        o = r(0),
        a = r(24),
        s = n.assert;

    function f(e) {
      this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, a.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), s(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
    }

    function c(e, t, r, n, o) {
      a.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = o && new i(o, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
    }

    o(f, a), e.exports = f, f.prototype._mulA = function (e) {
      return this.mOneA ? e.redNeg() : this.a.redMul(e);
    }, f.prototype._mulC = function (e) {
      return this.oneC ? e : this.c.redMul(e);
    }, f.prototype.jpoint = function (e, t, r, n) {
      return this.point(e, t, r, n);
    }, f.prototype.pointFromX = function (e, t) {
      (e = new i(e, 16)).red || (e = e.toRed(this.red));
      var r = e.redSqr(),
          n = this.c2.redSub(this.a.redMul(r)),
          o = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
          a = n.redMul(o.redInvm()),
          s = a.redSqrt();
      if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
      var f = s.fromRed().isOdd();
      return (t && !f || !t && f) && (s = s.redNeg()), this.point(e, s);
    }, f.prototype.pointFromY = function (e, t) {
      (e = new i(e, 16)).red || (e = e.toRed(this.red));
      var r = e.redSqr(),
          n = r.redSub(this.c2),
          o = r.redMul(this.d).redMul(this.c2).redSub(this.a),
          a = n.redMul(o.redInvm());

      if (0 === a.cmp(this.zero)) {
        if (t) throw new Error("invalid point");
        return this.point(this.zero, e);
      }

      var s = a.redSqrt();
      if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
      return s.fromRed().isOdd() !== t && (s = s.redNeg()), this.point(s, e);
    }, f.prototype.validate = function (e) {
      if (e.isInfinity()) return !0;
      e.normalize();
      var t = e.x.redSqr(),
          r = e.y.redSqr(),
          n = t.redMul(this.a).redAdd(r),
          i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
      return 0 === n.cmp(i);
    }, o(c, a.BasePoint), f.prototype.pointFromJSON = function (e) {
      return c.fromJSON(this, e);
    }, f.prototype.point = function (e, t, r, n) {
      return new c(this, e, t, r, n);
    }, c.fromJSON = function (e, t) {
      return new c(e, t[0], t[1], t[2]);
    }, c.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, c.prototype.isInfinity = function () {
      return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
    }, c.prototype._extDbl = function () {
      var e = this.x.redSqr(),
          t = this.y.redSqr(),
          r = this.z.redSqr();
      r = r.redIAdd(r);

      var n = this.curve._mulA(e),
          i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
          o = n.redAdd(t),
          a = o.redSub(r),
          s = n.redSub(t),
          f = i.redMul(a),
          c = o.redMul(s),
          u = i.redMul(s),
          d = a.redMul(o);

      return this.curve.point(f, c, d, u);
    }, c.prototype._projDbl = function () {
      var e,
          t,
          r,
          n = this.x.redAdd(this.y).redSqr(),
          i = this.x.redSqr(),
          o = this.y.redSqr();

      if (this.curve.twisted) {
        var a = (c = this.curve._mulA(i)).redAdd(o);

        if (this.zOne) e = n.redSub(i).redSub(o).redMul(a.redSub(this.curve.two)), t = a.redMul(c.redSub(o)), r = a.redSqr().redSub(a).redSub(a);else {
          var s = this.z.redSqr(),
              f = a.redSub(s).redISub(s);
          e = n.redSub(i).redISub(o).redMul(f), t = a.redMul(c.redSub(o)), r = a.redMul(f);
        }
      } else {
        var c = i.redAdd(o);
        s = this.curve._mulC(this.z).redSqr(), f = c.redSub(s).redSub(s);
        e = this.curve._mulC(n.redISub(c)).redMul(f), t = this.curve._mulC(c).redMul(i.redISub(o)), r = c.redMul(f);
      }

      return this.curve.point(e, t, r);
    }, c.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
    }, c.prototype._extAdd = function (e) {
      var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
          r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
          n = this.t.redMul(this.curve.dd).redMul(e.t),
          i = this.z.redMul(e.z.redAdd(e.z)),
          o = r.redSub(t),
          a = i.redSub(n),
          s = i.redAdd(n),
          f = r.redAdd(t),
          c = o.redMul(a),
          u = s.redMul(f),
          d = o.redMul(f),
          h = a.redMul(s);
      return this.curve.point(c, u, h, d);
    }, c.prototype._projAdd = function (e) {
      var t,
          r,
          n = this.z.redMul(e.z),
          i = n.redSqr(),
          o = this.x.redMul(e.x),
          a = this.y.redMul(e.y),
          s = this.curve.d.redMul(o).redMul(a),
          f = i.redSub(s),
          c = i.redAdd(s),
          u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),
          d = n.redMul(f).redMul(u);
      return this.curve.twisted ? (t = n.redMul(c).redMul(a.redSub(this.curve._mulA(o))), r = f.redMul(c)) : (t = n.redMul(c).redMul(a.redSub(o)), r = this.curve._mulC(f).redMul(c)), this.curve.point(d, t, r);
    }, c.prototype.add = function (e) {
      return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
    }, c.prototype.mul = function (e) {
      return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
    }, c.prototype.mulAdd = function (e, t, r) {
      return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !1);
    }, c.prototype.jmulAdd = function (e, t, r) {
      return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !0);
    }, c.prototype.normalize = function () {
      if (this.zOne) return this;
      var e = this.z.redInvm();
      return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
    }, c.prototype.neg = function () {
      return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
    }, c.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    }, c.prototype.getY = function () {
      return this.normalize(), this.y.fromRed();
    }, c.prototype.eq = function (e) {
      return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
    }, c.prototype.eqXToP = function (e) {
      var t = e.toRed(this.curve.red).redMul(this.z);
      if (0 === this.x.cmp(t)) return !0;

      for (var r = e.clone(), n = this.curve.redN.redMul(this.z);;) {
        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
      }
    }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
  }, function (e, t, r) {
    "use strict";

    t.sha1 = r(144), t.sha224 = r(145), t.sha256 = r(74), t.sha384 = r(146), t.sha512 = r(75);
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(17),
        o = r(73),
        a = n.rotl32,
        s = n.sum32,
        f = n.sum32_5,
        c = o.ft_1,
        u = i.BlockHash,
        d = [1518500249, 1859775393, 2400959708, 3395469782];

    function h() {
      if (!(this instanceof h)) return new h();
      u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
    }

    n.inherits(h, u), e.exports = h, h.blockSize = 512, h.outSize = 160, h.hmacStrength = 80, h.padLength = 64, h.prototype._update = function (e, t) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = e[t + n];
      }

      for (; n < r.length; n++) {
        r[n] = a(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
      }

      var i = this.h[0],
          o = this.h[1],
          u = this.h[2],
          h = this.h[3],
          l = this.h[4];

      for (n = 0; n < r.length; n++) {
        var p = ~~(n / 20),
            b = f(a(i, 5), c(p, o, u, h), l, r[n], d[p]);
        l = h, h = u, u = a(o, 30), o = i, i = b;
      }

      this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], u), this.h[3] = s(this.h[3], h), this.h[4] = s(this.h[4], l);
    }, h.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(74);

    function o() {
      if (!(this instanceof o)) return new o();
      i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
    }

    n.inherits(o, i), e.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(75);

    function o() {
      if (!(this instanceof o)) return new o();
      i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
    }

    n.inherits(o, i), e.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(17),
        o = n.rotl32,
        a = n.sum32,
        s = n.sum32_3,
        f = n.sum32_4,
        c = i.BlockHash;

    function u() {
      if (!(this instanceof u)) return new u();
      c.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
    }

    function d(e, t, r, n) {
      return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
    }

    function h(e) {
      return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
    }

    function l(e) {
      return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
    }

    n.inherits(u, c), t.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function (e, t) {
      for (var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], v = r, g = n, _ = i, w = c, k = u, E = 0; E < 80; E++) {
        var A = a(o(f(r, d(E, n, i, c), e[p[E] + t], h(E)), m[E]), u);
        r = u, u = c, c = o(i, 10), i = n, n = A, A = a(o(f(v, d(79 - E, g, _, w), e[b[E] + t], l(E)), y[E]), k), v = k, k = w, w = o(_, 10), _ = g, g = A;
      }

      A = s(this.h[1], i, w), this.h[1] = s(this.h[2], c, k), this.h[2] = s(this.h[3], u, v), this.h[3] = s(this.h[4], r, g), this.h[4] = s(this.h[0], n, _), this.h[0] = A;
    }, u.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
    };
    var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        m = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        y = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(4);

    function o(e, t, r) {
      if (!(this instanceof o)) return new o(e, t, r);
      this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
    }

    e.exports = o, o.prototype._init = function (e) {
      e.length > this.blockSize && (e = new this.Hash().update(e).digest()), i(e.length <= this.blockSize);

      for (var t = e.length; t < this.blockSize; t++) {
        e.push(0);
      }

      for (t = 0; t < e.length; t++) {
        e[t] ^= 54;
      }

      for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
        e[t] ^= 106;
      }

      this.outer = new this.Hash().update(e);
    }, o.prototype.update = function (e, t) {
      return this.inner.update(e, t), this;
    }, o.prototype.digest = function (e) {
      return this.outer.update(this.inner.digest()), this.outer.digest(e);
    };
  }, function (e, t) {
    e.exports = {
      doubles: {
        step: 4,
        points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
      },
      naf: {
        wnd: 7,
        points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(3),
        i = r(151),
        o = r(5),
        a = r(41),
        s = r(38),
        f = o.assert,
        c = r(152),
        u = r(153);

    function d(e) {
      if (!(this instanceof d)) return new d(e);
      "string" == typeof e && (f(a.hasOwnProperty(e), "Unknown curve " + e), e = a[e]), e instanceof a.PresetCurve && (e = {
        curve: e
      }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
    }

    e.exports = d, d.prototype.keyPair = function (e) {
      return new c(this, e);
    }, d.prototype.keyFromPrivate = function (e, t) {
      return c.fromPrivate(this, e, t);
    }, d.prototype.keyFromPublic = function (e, t) {
      return c.fromPublic(this, e, t);
    }, d.prototype.genKeyPair = function (e) {
      e || (e = {});

      for (var t = new i({
        hash: this.hash,
        pers: e.pers,
        persEnc: e.persEnc || "utf8",
        entropy: e.entropy || s(this.hash.hmacStrength),
        entropyEnc: e.entropy && e.entropyEnc || "utf8",
        nonce: this.n.toArray()
      }), r = this.n.byteLength(), o = this.n.sub(new n(2));;) {
        var a = new n(t.generate(r));
        if (!(a.cmp(o) > 0)) return a.iaddn(1), this.keyFromPrivate(a);
      }
    }, d.prototype._truncateToN = function (e, t) {
      var r = 8 * e.byteLength() - this.n.bitLength();
      return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
    }, d.prototype.sign = function (e, t, r, o) {
      "object" == typeof r && (o = r, r = null), o || (o = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));

      for (var a = this.n.byteLength(), s = t.getPrivate().toArray("be", a), f = e.toArray("be", a), c = new i({
        hash: this.hash,
        entropy: s,
        nonce: f,
        pers: o.pers,
        persEnc: o.persEnc || "utf8"
      }), d = this.n.sub(new n(1)), h = 0;; h++) {
        var l = o.k ? o.k(h) : new n(c.generate(this.n.byteLength()));

        if (!((l = this._truncateToN(l, !0)).cmpn(1) <= 0 || l.cmp(d) >= 0)) {
          var p = this.g.mul(l);

          if (!p.isInfinity()) {
            var b = p.getX(),
                m = b.umod(this.n);

            if (0 !== m.cmpn(0)) {
              var y = l.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));

              if (0 !== (y = y.umod(this.n)).cmpn(0)) {
                var v = (p.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(m) ? 2 : 0);
                return o.canonical && y.cmp(this.nh) > 0 && (y = this.n.sub(y), v ^= 1), new u({
                  r: m,
                  s: y,
                  recoveryParam: v
                });
              }
            }
          }
        }
      }
    }, d.prototype.verify = function (e, t, r, i) {
      e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
      var o = (t = new u(t, "hex")).r,
          a = t.s;
      if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
      if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
      var s,
          f = a.invm(this.n),
          c = f.mul(e).umod(this.n),
          d = f.mul(o).umod(this.n);
      return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(c, r.getPublic(), d)).isInfinity() && s.eqXToP(o) : !(s = this.g.mulAdd(c, r.getPublic(), d)).isInfinity() && 0 === s.getX().umod(this.n).cmp(o);
    }, d.prototype.recoverPubKey = function (e, t, r, i) {
      f((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
      var o = this.n,
          a = new n(e),
          s = t.r,
          c = t.s,
          d = 1 & r,
          h = r >> 1;
      if (s.cmp(this.curve.p.umod(this.curve.n)) >= 0 && h) throw new Error("Unable to find sencond key candinate");
      s = h ? this.curve.pointFromX(s.add(this.curve.n), d) : this.curve.pointFromX(s, d);
      var l = t.r.invm(o),
          p = o.sub(a).mul(l).umod(o),
          b = c.mul(l).umod(o);
      return this.g.mulAdd(p, s, b);
    }, d.prototype.getKeyRecoveryParam = function (e, t, r, n) {
      if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;

      for (var i = 0; i < 4; i++) {
        var o;

        try {
          o = this.recoverPubKey(e, t, i);
        } catch (e) {
          continue;
        }

        if (o.eq(r)) return i;
      }

      throw new Error("Unable to find valid recovery factor");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(42),
        i = r(71),
        o = r(4);

    function a(e) {
      if (!(this instanceof a)) return new a(e);
      this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
      var t = i.toArray(e.entropy, e.entropyEnc || "hex"),
          r = i.toArray(e.nonce, e.nonceEnc || "hex"),
          n = i.toArray(e.pers, e.persEnc || "hex");
      o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
    }

    e.exports = a, a.prototype._init = function (e, t, r) {
      var n = e.concat(t).concat(r);
      this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

      for (var i = 0; i < this.V.length; i++) {
        this.K[i] = 0, this.V[i] = 1;
      }

      this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
    }, a.prototype._hmac = function () {
      return new n.hmac(this.hash, this.K);
    }, a.prototype._update = function (e) {
      var t = this._hmac().update(this.V).update([0]);

      e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
    }, a.prototype.reseed = function (e, t, r, n) {
      "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
    }, a.prototype.generate = function (e, t, r, n) {
      if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
      "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));

      for (var o = []; o.length < e;) {
        this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
      }

      var a = o.slice(0, e);
      return this._update(r), this._reseed++, i.encode(a, t);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(3),
        i = r(5).assert;

    function o(e, t) {
      this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
    }

    e.exports = o, o.fromPublic = function (e, t, r) {
      return t instanceof o ? t : new o(e, {
        pub: t,
        pubEnc: r
      });
    }, o.fromPrivate = function (e, t, r) {
      return t instanceof o ? t : new o(e, {
        priv: t,
        privEnc: r
      });
    }, o.prototype.validate = function () {
      var e = this.getPublic();
      return e.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
      } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
      } : {
        result: !1,
        reason: "Public key * N != O"
      } : {
        result: !1,
        reason: "Public key is not a point"
      };
    }, o.prototype.getPublic = function (e, t) {
      return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
    }, o.prototype.getPrivate = function (e) {
      return "hex" === e ? this.priv.toString(16, 2) : this.priv;
    }, o.prototype._importPrivate = function (e, t) {
      this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
    }, o.prototype._importPublic = function (e, t) {
      if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
      this.pub = this.ec.curve.decodePoint(e, t);
    }, o.prototype.derive = function (e) {
      return e.mul(this.priv).getX();
    }, o.prototype.sign = function (e, t, r) {
      return this.ec.sign(e, this, t, r);
    }, o.prototype.verify = function (e, t) {
      return this.ec.verify(e, t, this);
    }, o.prototype.inspect = function () {
      return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(3),
        i = r(5),
        o = i.assert;

    function a(e, t) {
      if (e instanceof a) return e;
      this._importDER(e, t) || (o(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
    }

    function s() {
      this.place = 0;
    }

    function f(e, t) {
      var r = e[t.place++];
      if (!(128 & r)) return r;

      for (var n = 15 & r, i = 0, o = 0, a = t.place; o < n; o++, a++) {
        i <<= 8, i |= e[a];
      }

      return t.place = a, i;
    }

    function c(e) {
      for (var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;) {
        t++;
      }

      return 0 === t ? e : e.slice(t);
    }

    function u(e, t) {
      if (t < 128) e.push(t);else {
        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);

        for (e.push(128 | r); --r;) {
          e.push(t >>> (r << 3) & 255);
        }

        e.push(t);
      }
    }

    e.exports = a, a.prototype._importDER = function (e, t) {
      e = i.toArray(e, t);
      var r = new s();
      if (48 !== e[r.place++]) return !1;
      if (f(e, r) + r.place !== e.length) return !1;
      if (2 !== e[r.place++]) return !1;
      var o = f(e, r),
          a = e.slice(r.place, o + r.place);
      if (r.place += o, 2 !== e[r.place++]) return !1;
      var c = f(e, r);
      if (e.length !== c + r.place) return !1;
      var u = e.slice(r.place, c + r.place);
      return 0 === a[0] && 128 & a[1] && (a = a.slice(1)), 0 === u[0] && 128 & u[1] && (u = u.slice(1)), this.r = new n(a), this.s = new n(u), this.recoveryParam = null, !0;
    }, a.prototype.toDER = function (e) {
      var t = this.r.toArray(),
          r = this.s.toArray();

      for (128 & t[0] && (t = [0].concat(t)), 128 & r[0] && (r = [0].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);) {
        r = r.slice(1);
      }

      var n = [2];
      u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
      var o = n.concat(r),
          a = [48];
      return u(a, o.length), a = a.concat(o), i.encode(a, e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(42),
        i = r(41),
        o = r(5),
        a = o.assert,
        s = o.parseBytes,
        f = r(155),
        c = r(156);

    function u(e) {
      if (a("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
      e = i[e].curve;
      this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
    }

    e.exports = u, u.prototype.sign = function (e, t) {
      e = s(e);
      var r = this.keyFromSecret(t),
          n = this.hashInt(r.messagePrefix(), e),
          i = this.g.mul(n),
          o = this.encodePoint(i),
          a = this.hashInt(o, r.pubBytes(), e).mul(r.priv()),
          f = n.add(a).umod(this.curve.n);
      return this.makeSignature({
        R: i,
        S: f,
        Rencoded: o
      });
    }, u.prototype.verify = function (e, t, r) {
      e = s(e), t = this.makeSignature(t);
      var n = this.keyFromPublic(r),
          i = this.hashInt(t.Rencoded(), n.pubBytes(), e),
          o = this.g.mul(t.S());
      return t.R().add(n.pub().mul(i)).eq(o);
    }, u.prototype.hashInt = function () {
      for (var e = this.hash(), t = 0; t < arguments.length; t++) {
        e.update(arguments[t]);
      }

      return o.intFromLE(e.digest()).umod(this.curve.n);
    }, u.prototype.keyFromPublic = function (e) {
      return f.fromPublic(this, e);
    }, u.prototype.keyFromSecret = function (e) {
      return f.fromSecret(this, e);
    }, u.prototype.makeSignature = function (e) {
      return e instanceof c ? e : new c(this, e);
    }, u.prototype.encodePoint = function (e) {
      var t = e.getY().toArray("le", this.encodingLength);
      return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
    }, u.prototype.decodePoint = function (e) {
      var t = (e = o.parseBytes(e)).length - 1,
          r = e.slice(0, t).concat(-129 & e[t]),
          n = 0 != (128 & e[t]),
          i = o.intFromLE(r);
      return this.curve.pointFromY(i, n);
    }, u.prototype.encodeInt = function (e) {
      return e.toArray("le", this.encodingLength);
    }, u.prototype.decodeInt = function (e) {
      return o.intFromLE(e);
    }, u.prototype.isPoint = function (e) {
      return e instanceof this.pointClass;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(5),
        i = n.assert,
        o = n.parseBytes,
        a = n.cachedProperty;

    function s(e, t) {
      this.eddsa = e, this._secret = o(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = o(t.pub);
    }

    s.fromPublic = function (e, t) {
      return t instanceof s ? t : new s(e, {
        pub: t
      });
    }, s.fromSecret = function (e, t) {
      return t instanceof s ? t : new s(e, {
        secret: t
      });
    }, s.prototype.secret = function () {
      return this._secret;
    }, a(s, "pubBytes", function () {
      return this.eddsa.encodePoint(this.pub());
    }), a(s, "pub", function () {
      return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
    }), a(s, "privBytes", function () {
      var e = this.eddsa,
          t = this.hash(),
          r = e.encodingLength - 1,
          n = t.slice(0, e.encodingLength);
      return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
    }), a(s, "priv", function () {
      return this.eddsa.decodeInt(this.privBytes());
    }), a(s, "hash", function () {
      return this.eddsa.hash().update(this.secret()).digest();
    }), a(s, "messagePrefix", function () {
      return this.hash().slice(this.eddsa.encodingLength);
    }), s.prototype.sign = function (e) {
      return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
    }, s.prototype.verify = function (e, t) {
      return this.eddsa.verify(e, t, this);
    }, s.prototype.getSecret = function (e) {
      return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
    }, s.prototype.getPublic = function (e) {
      return n.encode(this.pubBytes(), e);
    }, e.exports = s;
  }, function (e, t, r) {
    "use strict";

    var n = r(3),
        i = r(5),
        o = i.assert,
        a = i.cachedProperty,
        s = i.parseBytes;

    function f(e, t) {
      this.eddsa = e, "object" != typeof t && (t = s(t)), Array.isArray(t) && (t = {
        R: t.slice(0, e.encodingLength),
        S: t.slice(e.encodingLength)
      }), o(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
    }

    a(f, "S", function () {
      return this.eddsa.decodeInt(this.Sencoded());
    }), a(f, "R", function () {
      return this.eddsa.decodePoint(this.Rencoded());
    }), a(f, "Rencoded", function () {
      return this.eddsa.encodePoint(this.R());
    }), a(f, "Sencoded", function () {
      return this.eddsa.encodeInt(this.S());
    }), f.prototype.toBytes = function () {
      return this.Rencoded().concat(this.Sencoded());
    }, f.prototype.toHex = function () {
      return i.encode(this.toBytes(), "hex").toUpperCase();
    }, e.exports = f;
  }, function (e, t, r) {
    "use strict";

    var n = r(18);
    t.certificate = r(167);
    var i = n.define("RSAPrivateKey", function () {
      this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
    });
    t.RSAPrivateKey = i;
    var o = n.define("RSAPublicKey", function () {
      this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
    });
    t.RSAPublicKey = o;
    var a = n.define("SubjectPublicKeyInfo", function () {
      this.seq().obj(this.key("algorithm").use(s), this.key("subjectPublicKey").bitstr());
    });
    t.PublicKey = a;
    var s = n.define("AlgorithmIdentifier", function () {
      this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
    }),
        f = n.define("PrivateKeyInfo", function () {
      this.seq().obj(this.key("version").int(), this.key("algorithm").use(s), this.key("subjectPrivateKey").octstr());
    });
    t.PrivateKey = f;
    var c = n.define("EncryptedPrivateKeyInfo", function () {
      this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
    });
    t.EncryptedPrivateKey = c;
    var u = n.define("DSAPrivateKey", function () {
      this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
    });
    t.DSAPrivateKey = u, t.DSAparam = n.define("DSAparam", function () {
      this.int();
    });
    var d = n.define("ECPrivateKey", function () {
      this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(h), this.key("publicKey").optional().explicit(1).bitstr());
    });
    t.ECPrivateKey = d;
    var h = n.define("ECParameters", function () {
      this.choice({
        namedCurve: this.objid()
      });
    });
    t.signature = n.define("signature", function () {
      this.seq().obj(this.key("r").int(), this.key("s").int());
    });
  }, function (e, t, r) {
    var n = r(18),
        i = r(0);

    function o(e, t) {
      this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
    }

    t.define = function (e, t) {
      return new o(e, t);
    }, o.prototype._createNamed = function (e) {
      var t;

      try {
        t = r(159).runInThisContext("(function " + this.name + "(entity) {\n  this._initNamed(entity);\n})");
      } catch (e) {
        t = function t(e) {
          this._initNamed(e);
        };
      }

      return i(t, e), t.prototype._initNamed = function (t) {
        e.call(this, t);
      }, new t(this);
    }, o.prototype._getDecoder = function (e) {
      return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(n.decoders[e])), this.decoders[e];
    }, o.prototype.decode = function (e, t, r) {
      return this._getDecoder(t).decode(e, r);
    }, o.prototype._getEncoder = function (e) {
      return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n.encoders[e])), this.encoders[e];
    }, o.prototype.encode = function (e, t, r) {
      return this._getEncoder(t).encode(e, r);
    };
  }, function (module, exports) {
    var indexOf = function indexOf(e, t) {
      if (e.indexOf) return e.indexOf(t);

      for (var r = 0; r < e.length; r++) {
        if (e[r] === t) return r;
      }

      return -1;
    },
        Object_keys = function Object_keys(e) {
      if (Object.keys) return Object.keys(e);
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t;
    },
        forEach = function forEach(e, t) {
      if (e.forEach) return e.forEach(t);

      for (var r = 0; r < e.length; r++) {
        t(e[r], r, e);
      }
    },
        defineProp = function () {
      try {
        return Object.defineProperty({}, "_", {}), function (e, t, r) {
          Object.defineProperty(e, t, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: r
          });
        };
      } catch (e) {
        return function (e, t, r) {
          e[t] = r;
        };
      }
    }(),
        globals = ["Array", "Boolean", "Date", "Error", "EvalError", "Function", "Infinity", "JSON", "Math", "NaN", "Number", "Object", "RangeError", "ReferenceError", "RegExp", "String", "SyntaxError", "TypeError", "URIError", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "undefined", "unescape"];

    function Context() {}

    Context.prototype = {};

    var Script = exports.Script = function (e) {
      if (!(this instanceof Script)) return new Script(e);
      this.code = e;
    };

    Script.prototype.runInContext = function (e) {
      if (!(e instanceof Context)) throw new TypeError("needs a 'context' argument.");
      var t = document.createElement("iframe");
      t.style || (t.style = {}), t.style.display = "none", document.body.appendChild(t);
      var r = t.contentWindow,
          n = r.eval,
          i = r.execScript;
      !n && i && (i.call(r, "null"), n = r.eval), forEach(Object_keys(e), function (t) {
        r[t] = e[t];
      }), forEach(globals, function (t) {
        e[t] && (r[t] = e[t]);
      });
      var o = Object_keys(r),
          a = n.call(r, this.code);
      return forEach(Object_keys(r), function (t) {
        (t in e || -1 === indexOf(o, t)) && (e[t] = r[t]);
      }), forEach(globals, function (t) {
        t in e || defineProp(e, t, r[t]);
      }), document.body.removeChild(t), a;
    }, Script.prototype.runInThisContext = function () {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function (e) {
      var t = Script.createContext(e),
          r = this.runInContext(t);
      return e && forEach(Object_keys(t), function (r) {
        e[r] = t[r];
      }), r;
    }, forEach(Object_keys(Script.prototype), function (e) {
      exports[e] = Script[e] = function (t) {
        var r = Script(t);
        return r[e].apply(r, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function (e) {
      return e instanceof Context;
    }, exports.createScript = function (e) {
      return exports.Script(e);
    }, exports.createContext = Script.createContext = function (e) {
      var t = new Context();
      return "object" == typeof e && forEach(Object_keys(e), function (r) {
        t[r] = e[r];
      }), t;
    };
  }, function (e, t, r) {
    var n = r(0);

    function i(e) {
      this._reporterState = {
        obj: null,
        path: [],
        options: e || {},
        errors: []
      };
    }

    function o(e, t) {
      this.path = e, this.rethrow(t);
    }

    t.Reporter = i, i.prototype.isError = function (e) {
      return e instanceof o;
    }, i.prototype.save = function () {
      var e = this._reporterState;
      return {
        obj: e.obj,
        pathLen: e.path.length
      };
    }, i.prototype.restore = function (e) {
      var t = this._reporterState;
      t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
    }, i.prototype.enterKey = function (e) {
      return this._reporterState.path.push(e);
    }, i.prototype.exitKey = function (e) {
      var t = this._reporterState;
      t.path = t.path.slice(0, e - 1);
    }, i.prototype.leaveKey = function (e, t, r) {
      var n = this._reporterState;
      this.exitKey(e), null !== n.obj && (n.obj[t] = r);
    }, i.prototype.path = function () {
      return this._reporterState.path.join("/");
    }, i.prototype.enterObject = function () {
      var e = this._reporterState,
          t = e.obj;
      return e.obj = {}, t;
    }, i.prototype.leaveObject = function (e) {
      var t = this._reporterState,
          r = t.obj;
      return t.obj = e, r;
    }, i.prototype.error = function (e) {
      var t,
          r = this._reporterState,
          n = e instanceof o;
      if (t = n ? e : new o(r.path.map(function (e) {
        return "[" + JSON.stringify(e) + "]";
      }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
      return n || r.errors.push(t), t;
    }, i.prototype.wrapResult = function (e) {
      var t = this._reporterState;
      return t.options.partial ? {
        result: this.isError(e) ? null : e,
        errors: t.errors
      } : e;
    }, n(o, Error), o.prototype.rethrow = function (e) {
      if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, o), !this.stack) try {
        throw new Error(this.message);
      } catch (e) {
        this.stack = e.stack;
      }
      return this;
    };
  }, function (e, t, r) {
    var n = r(19).Reporter,
        i = r(19).EncoderBuffer,
        o = r(19).DecoderBuffer,
        a = r(4),
        s = ["seq", "seqof", "set", "setof", "objid", "bool", "gentime", "utctime", "null_", "enum", "int", "objDesc", "bitstr", "bmpstr", "charstr", "genstr", "graphstr", "ia5str", "iso646str", "numstr", "octstr", "printstr", "t61str", "unistr", "utf8str", "videostr"],
        f = ["key", "obj", "use", "optional", "explicit", "implicit", "def", "choice", "any", "contains"].concat(s);

    function c(e, t) {
      var r = {};
      this._baseState = r, r.enc = e, r.parent = t || null, r.children = null, r.tag = null, r.args = null, r.reverseArgs = null, r.choice = null, r.optional = !1, r.any = !1, r.obj = !1, r.use = null, r.useDecoder = null, r.key = null, r.default = null, r.explicit = null, r.implicit = null, r.contains = null, r.parent || (r.children = [], this._wrap());
    }

    e.exports = c;
    var u = ["enc", "parent", "children", "tag", "args", "reverseArgs", "choice", "optional", "any", "obj", "use", "alteredUse", "key", "default", "explicit", "implicit", "contains"];
    c.prototype.clone = function () {
      var e = this._baseState,
          t = {};
      u.forEach(function (r) {
        t[r] = e[r];
      });
      var r = new this.constructor(t.parent);
      return r._baseState = t, r;
    }, c.prototype._wrap = function () {
      var e = this._baseState;
      f.forEach(function (t) {
        this[t] = function () {
          var r = new this.constructor(this);
          return e.children.push(r), r[t].apply(r, arguments);
        };
      }, this);
    }, c.prototype._init = function (e) {
      var t = this._baseState;
      a(null === t.parent), e.call(this), t.children = t.children.filter(function (e) {
        return e._baseState.parent === this;
      }, this), a.equal(t.children.length, 1, "Root node can have only one child");
    }, c.prototype._useArgs = function (e) {
      var t = this._baseState,
          r = e.filter(function (e) {
        return e instanceof this.constructor;
      }, this);
      e = e.filter(function (e) {
        return !(e instanceof this.constructor);
      }, this), 0 !== r.length && (a(null === t.children), t.children = r, r.forEach(function (e) {
        e._baseState.parent = this;
      }, this)), 0 !== e.length && (a(null === t.args), t.args = e, t.reverseArgs = e.map(function (e) {
        if ("object" != typeof e || e.constructor !== Object) return e;
        var t = {};
        return Object.keys(e).forEach(function (r) {
          r == (0 | r) && (r |= 0);
          var n = e[r];
          t[n] = r;
        }), t;
      }));
    }, ["_peekTag", "_decodeTag", "_use", "_decodeStr", "_decodeObjid", "_decodeTime", "_decodeNull", "_decodeInt", "_decodeBool", "_decodeList", "_encodeComposite", "_encodeStr", "_encodeObjid", "_encodeTime", "_encodeNull", "_encodeInt", "_encodeBool"].forEach(function (e) {
      c.prototype[e] = function () {
        var t = this._baseState;
        throw new Error(e + " not implemented for encoding: " + t.enc);
      };
    }), s.forEach(function (e) {
      c.prototype[e] = function () {
        var t = this._baseState,
            r = Array.prototype.slice.call(arguments);
        return a(null === t.tag), t.tag = e, this._useArgs(r), this;
      };
    }), c.prototype.use = function (e) {
      a(e);
      var t = this._baseState;
      return a(null === t.use), t.use = e, this;
    }, c.prototype.optional = function () {
      return this._baseState.optional = !0, this;
    }, c.prototype.def = function (e) {
      var t = this._baseState;
      return a(null === t.default), t.default = e, t.optional = !0, this;
    }, c.prototype.explicit = function (e) {
      var t = this._baseState;
      return a(null === t.explicit && null === t.implicit), t.explicit = e, this;
    }, c.prototype.implicit = function (e) {
      var t = this._baseState;
      return a(null === t.explicit && null === t.implicit), t.implicit = e, this;
    }, c.prototype.obj = function () {
      var e = this._baseState,
          t = Array.prototype.slice.call(arguments);
      return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
    }, c.prototype.key = function (e) {
      var t = this._baseState;
      return a(null === t.key), t.key = e, this;
    }, c.prototype.any = function () {
      return this._baseState.any = !0, this;
    }, c.prototype.choice = function (e) {
      var t = this._baseState;
      return a(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function (t) {
        return e[t];
      })), this;
    }, c.prototype.contains = function (e) {
      var t = this._baseState;
      return a(null === t.use), t.contains = e, this;
    }, c.prototype._decode = function (e, t) {
      var r = this._baseState;
      if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
      var n,
          i = r.default,
          a = !0,
          s = null;

      if (null !== r.key && (s = e.enterKey(r.key)), r.optional) {
        var f = null;

        if (null !== r.explicit ? f = r.explicit : null !== r.implicit ? f = r.implicit : null !== r.tag && (f = r.tag), null !== f || r.any) {
          if (a = this._peekTag(e, f, r.any), e.isError(a)) return a;
        } else {
          var c = e.save();

          try {
            null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), a = !0;
          } catch (e) {
            a = !1;
          }

          e.restore(c);
        }
      }

      if (r.obj && a && (n = e.enterObject()), a) {
        if (null !== r.explicit) {
          var u = this._decodeTag(e, r.explicit);

          if (e.isError(u)) return u;
          e = u;
        }

        var d = e.offset;

        if (null === r.use && null === r.choice) {
          if (r.any) c = e.save();

          var h = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);

          if (e.isError(h)) return h;
          r.any ? i = e.raw(c) : e = h;
        }

        if (t && t.track && null !== r.tag && t.track(e.path(), d, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), i = r.any ? i : null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), e.isError(i)) return i;

        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function (r) {
          r._decode(e, t);
        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
          var l = new o(i);
          i = this._getUse(r.contains, e._reporterState.obj)._decode(l, t);
        }
      }

      return r.obj && a && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== a ? null !== s && e.exitKey(s) : e.leaveKey(s, r.key, i), i;
    }, c.prototype._decodeGeneric = function (e, t, r) {
      var n = this._baseState;
      return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
    }, c.prototype._getUse = function (e, t) {
      var r = this._baseState;
      return r.useDecoder = this._use(e, t), a(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
    }, c.prototype._decodeChoice = function (e, t) {
      var r = this._baseState,
          n = null,
          i = !1;
      return Object.keys(r.choice).some(function (o) {
        var a = e.save(),
            s = r.choice[o];

        try {
          var f = s._decode(e, t);

          if (e.isError(f)) return !1;
          n = {
            type: o,
            value: f
          }, i = !0;
        } catch (t) {
          return e.restore(a), !1;
        }

        return !0;
      }, this), i ? n : e.error("Choice not matched");
    }, c.prototype._createEncoderBuffer = function (e) {
      return new i(e, this.reporter);
    }, c.prototype._encode = function (e, t, r) {
      var n = this._baseState;

      if (null === n.default || n.default !== e) {
        var i = this._encodeValue(e, t, r);

        if (void 0 !== i && !this._skipDefault(i, t, r)) return i;
      }
    }, c.prototype._encodeValue = function (e, t, r) {
      var i = this._baseState;
      if (null === i.parent) return i.children[0]._encode(e, t || new n());
      var o = null;

      if (this.reporter = t, i.optional && void 0 === e) {
        if (null === i.default) return;
        e = i.default;
      }

      var a = null,
          s = !1;
      if (i.any) o = this._createEncoderBuffer(e);else if (i.choice) o = this._encodeChoice(e, t);else if (i.contains) a = this._getUse(i.contains, r)._encode(e, t), s = !0;else if (i.children) a = i.children.map(function (r) {
        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
        if (null === r._baseState.key) return t.error("Child should have a key");
        var n = t.enterKey(r._baseState.key);
        if ("object" != typeof e) return t.error("Child expected, but input is not object");

        var i = r._encode(e[r._baseState.key], t, e);

        return t.leaveKey(n), i;
      }, this).filter(function (e) {
        return e;
      }), a = this._createEncoderBuffer(a);else if ("seqof" === i.tag || "setof" === i.tag) {
        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
        var f = this.clone();
        f._baseState.implicit = null, a = this._createEncoderBuffer(e.map(function (r) {
          var n = this._baseState;
          return this._getUse(n.args[0], e)._encode(r, t);
        }, f));
      } else null !== i.use ? o = this._getUse(i.use, r)._encode(e, t) : (a = this._encodePrimitive(i.tag, e), s = !0);

      if (!i.any && null === i.choice) {
        var c = null !== i.implicit ? i.implicit : i.tag,
            u = null === i.implicit ? "universal" : "context";
        null === c ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (o = this._encodeComposite(c, s, u, a));
      }

      return null !== i.explicit && (o = this._encodeComposite(i.explicit, !1, "context", o)), o;
    }, c.prototype._encodeChoice = function (e, t) {
      var r = this._baseState,
          n = r.choice[e.type];
      return n || a(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
    }, c.prototype._encodePrimitive = function (e, t) {
      var r = this._baseState;
      if (/str$/.test(e)) return this._encodeStr(t, e);
      if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
      if ("objid" === e) return this._encodeObjid(t, null, null);
      if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
      if ("null_" === e) return this._encodeNull();
      if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
      if ("bool" === e) return this._encodeBool(t);
      if ("objDesc" === e) return this._encodeStr(t, e);
      throw new Error("Unsupported tag: " + e);
    }, c.prototype._isNumstr = function (e) {
      return /^[0-9 ]*$/.test(e);
    }, c.prototype._isPrintstr = function (e) {
      return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e);
    };
  }, function (e, t, r) {
    var n = r(77);
    t.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, t.tagClassByName = n._reverse(t.tagClass), t.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, t.tagByName = n._reverse(t.tag);
  }, function (e, t, r) {
    var n = t;
    n.der = r(78), n.pem = r(164);
  }, function (e, t, r) {
    var n = r(0),
        i = r(2).Buffer,
        o = r(78);

    function a(e) {
      o.call(this, e), this.enc = "pem";
    }

    n(a, o), e.exports = a, a.prototype.decode = function (e, t) {
      for (var r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), a = /^-----(BEGIN|END) ([^-]+)-----$/, s = -1, f = -1, c = 0; c < r.length; c++) {
        var u = r[c].match(a);

        if (null !== u && u[2] === n) {
          if (-1 !== s) {
            if ("END" !== u[1]) break;
            f = c;
            break;
          }

          if ("BEGIN" !== u[1]) break;
          s = c;
        }
      }

      if (-1 === s || -1 === f) throw new Error("PEM section not found for: " + n);
      var d = r.slice(s + 1, f).join("");
      d.replace(/[^a-z0-9\+\/=]+/gi, "");
      var h = new i(d, "base64");
      return o.prototype.decode.call(this, h, t);
    };
  }, function (e, t, r) {
    var n = t;
    n.der = r(79), n.pem = r(166);
  }, function (e, t, r) {
    var n = r(0),
        i = r(79);

    function o(e) {
      i.call(this, e), this.enc = "pem";
    }

    n(o, i), e.exports = o, o.prototype.encode = function (e, t) {
      for (var r = i.prototype.encode.call(this, e).toString("base64"), n = ["-----BEGIN " + t.label + "-----"], o = 0; o < r.length; o += 64) {
        n.push(r.slice(o, o + 64));
      }

      return n.push("-----END " + t.label + "-----"), n.join("\n");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(18),
        i = n.define("Time", function () {
      this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
      });
    }),
        o = n.define("AttributeTypeValue", function () {
      this.seq().obj(this.key("type").objid(), this.key("value").any());
    }),
        a = n.define("AlgorithmIdentifier", function () {
      this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
    }),
        s = n.define("SubjectPublicKeyInfo", function () {
      this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
    }),
        f = n.define("RelativeDistinguishedName", function () {
      this.setof(o);
    }),
        c = n.define("RDNSequence", function () {
      this.seqof(f);
    }),
        u = n.define("Name", function () {
      this.choice({
        rdnSequence: this.use(c)
      });
    }),
        d = n.define("Validity", function () {
      this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
    }),
        h = n.define("Extension", function () {
      this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
    }),
        l = n.define("TBSCertificate", function () {
      this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(a), this.key("issuer").use(u), this.key("validity").use(d), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(s), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(h).optional());
    }),
        p = n.define("X509Certificate", function () {
      this.seq().obj(this.key("tbsCertificate").use(l), this.key("signatureAlgorithm").use(a), this.key("signatureValue").bitstr());
    });
    e.exports = p;
  }, function (e) {
    e.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');
  }, function (e, t, r) {
    var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m,
        i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,
        o = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m,
        a = r(23),
        s = r(36),
        f = r(1).Buffer;

    e.exports = function (e, t) {
      var r,
          c = e.toString(),
          u = c.match(n);

      if (u) {
        var d = "aes" + u[1],
            h = f.from(u[2], "hex"),
            l = f.from(u[3].replace(/[\r\n]/g, ""), "base64"),
            p = a(t, h.slice(0, 8), parseInt(u[1], 10)).key,
            b = [],
            m = s.createDecipheriv(d, p, h);
        b.push(m.update(l)), b.push(m.final()), r = f.concat(b);
      } else {
        var y = c.match(o);
        r = new f(y[2].replace(/[\r\n]/g, ""), "base64");
      }

      return {
        tag: c.match(i)[1],
        data: r
      };
    };
  }, function (e, t, r) {
    (function (t) {
      var n = r(3),
          i = r(40).ec,
          o = r(25),
          a = r(80);

      function s(e, t) {
        if (e.cmpn(0) <= 0) throw new Error("invalid sig");
        if (e.cmp(t) >= t) throw new Error("invalid sig");
      }

      e.exports = function (e, r, f, c, u) {
        var d = o(f);

        if ("ec" === d.type) {
          if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
          return function (e, t, r) {
            var n = a[r.data.algorithm.curve.join(".")];
            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
            var o = new i(n),
                s = r.data.subjectPrivateKey.data;
            return o.verify(t, e, s);
          }(e, r, d);
        }

        if ("dsa" === d.type) {
          if ("dsa" !== c) throw new Error("wrong public key type");
          return function (e, t, r) {
            var i = r.data.p,
                a = r.data.q,
                f = r.data.g,
                c = r.data.pub_key,
                u = o.signature.decode(e, "der"),
                d = u.s,
                h = u.r;
            s(d, a), s(h, a);
            var l = n.mont(i),
                p = d.invm(a);
            return 0 === f.toRed(l).redPow(new n(t).mul(p).mod(a)).fromRed().mul(c.toRed(l).redPow(h.mul(p).mod(a)).fromRed()).mod(i).mod(a).cmp(h);
          }(e, r, d);
        }

        if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
        r = t.concat([u, r]);

        for (var h = d.modulus.byteLength(), l = [1], p = 0; r.length + l.length + 2 < h;) {
          l.push(255), p++;
        }

        l.push(0);

        for (var b = -1; ++b < r.length;) {
          l.push(r[b]);
        }

        l = new t(l);
        var m = n.mont(d.modulus);
        e = (e = new n(e).toRed(m)).redPow(new n(d.publicExponent)), e = new t(e.fromRed().toArray());
        var y = p < 8 ? 1 : 0;

        for (h = Math.min(e.length, l.length), e.length !== l.length && (y = 1), b = -1; ++b < h;) {
          y |= e[b] ^ l[b];
        }

        return 0 === y;
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = r(40),
          i = r(3);

      e.exports = function (e) {
        return new a(e);
      };

      var o = {
        secp256k1: {
          name: "secp256k1",
          byteLength: 32
        },
        secp224r1: {
          name: "p224",
          byteLength: 28
        },
        prime256v1: {
          name: "p256",
          byteLength: 32
        },
        prime192v1: {
          name: "p192",
          byteLength: 24
        },
        ed25519: {
          name: "ed25519",
          byteLength: 32
        },
        secp384r1: {
          name: "p384",
          byteLength: 48
        },
        secp521r1: {
          name: "p521",
          byteLength: 66
        }
      };

      function a(e) {
        this.curveType = o[e], this.curveType || (this.curveType = {
          name: e
        }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
      }

      function s(e, r, n) {
        Array.isArray(e) || (e = e.toArray());
        var i = new t(e);

        if (n && i.length < n) {
          var o = new t(n - i.length);
          o.fill(0), i = t.concat([o, i]);
        }

        return r ? i.toString(r) : i;
      }

      o.p224 = o.secp224r1, o.p256 = o.secp256r1 = o.prime256v1, o.p192 = o.secp192r1 = o.prime192v1, o.p384 = o.secp384r1, o.p521 = o.secp521r1, a.prototype.generateKeys = function (e, t) {
        return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
      }, a.prototype.computeSecret = function (e, r, n) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), s(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
      }, a.prototype.getPublicKey = function (e, t) {
        var r = this.keys.getPublic("compressed" === t, !0);
        return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), s(r, e);
      }, a.prototype.getPrivateKey = function (e) {
        return s(this.keys.getPrivate(), e);
      }, a.prototype.setPublicKey = function (e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this.keys._importPublic(e), this;
      }, a.prototype.setPrivateKey = function (e, r) {
        r = r || "utf8", t.isBuffer(e) || (e = new t(e, r));
        var n = new i(e);
        return n = n.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(n), this;
      };
    }).call(this, r(2).Buffer);
  }, function (e, t, r) {
    t.publicEncrypt = r(173), t.privateDecrypt = r(174), t.privateEncrypt = function (e, r) {
      return t.publicEncrypt(e, r, !0);
    }, t.publicDecrypt = function (e, r) {
      return t.privateDecrypt(e, r, !0);
    };
  }, function (e, t, r) {
    var n = r(25),
        i = r(12),
        o = r(14),
        a = r(81),
        s = r(82),
        f = r(3),
        c = r(83),
        u = r(39),
        d = r(1).Buffer;

    e.exports = function (e, t, r) {
      var h;
      h = e.padding ? e.padding : r ? 1 : 4;
      var l,
          p = n(e);
      if (4 === h) l = function (e, t) {
        var r = e.modulus.byteLength(),
            n = t.length,
            c = o("sha1").update(d.alloc(0)).digest(),
            u = c.length,
            h = 2 * u;
        if (n > r - h - 2) throw new Error("message too long");
        var l = d.alloc(r - n - h - 2),
            p = r - u - 1,
            b = i(u),
            m = s(d.concat([c, l, d.alloc(1, 1), t], p), a(b, p)),
            y = s(b, a(m, u));
        return new f(d.concat([d.alloc(1), y, m], r));
      }(p, t);else if (1 === h) l = function (e, t, r) {
        var n,
            o = t.length,
            a = e.modulus.byteLength();
        if (o > a - 11) throw new Error("message too long");
        n = r ? d.alloc(a - o - 3, 255) : function (e) {
          var t,
              r = d.allocUnsafe(e),
              n = 0,
              o = i(2 * e),
              a = 0;

          for (; n < e;) {
            a === o.length && (o = i(2 * e), a = 0), (t = o[a++]) && (r[n++] = t);
          }

          return r;
        }(a - o - 3);
        return new f(d.concat([d.from([0, r ? 1 : 2]), n, d.alloc(1), t], a));
      }(p, t, r);else {
        if (3 !== h) throw new Error("unknown padding");
        if ((l = new f(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
      }
      return r ? u(l, p) : c(l, p);
    };
  }, function (e, t, r) {
    var n = r(25),
        i = r(81),
        o = r(82),
        a = r(3),
        s = r(39),
        f = r(14),
        c = r(83),
        u = r(1).Buffer;

    e.exports = function (e, t, r) {
      var d;
      d = e.padding ? e.padding : r ? 1 : 4;
      var h,
          l = n(e),
          p = l.modulus.byteLength();
      if (t.length > p || new a(t).cmp(l.modulus) >= 0) throw new Error("decryption error");
      h = r ? c(new a(t), l) : s(t, l);
      var b = u.alloc(p - h.length);
      if (h = u.concat([b, h], p), 4 === d) return function (e, t) {
        var r = e.modulus.byteLength(),
            n = f("sha1").update(u.alloc(0)).digest(),
            a = n.length;
        if (0 !== t[0]) throw new Error("decryption error");
        var s = t.slice(1, a + 1),
            c = t.slice(a + 1),
            d = o(s, i(c, a)),
            h = o(c, i(d, r - a - 1));
        if (function (e, t) {
          e = u.from(e), t = u.from(t);
          var r = 0,
              n = e.length;
          e.length !== t.length && (r++, n = Math.min(e.length, t.length));
          var i = -1;

          for (; ++i < n;) {
            r += e[i] ^ t[i];
          }

          return r;
        }(n, h.slice(0, a))) throw new Error("decryption error");
        var l = a;

        for (; 0 === h[l];) {
          l++;
        }

        if (1 !== h[l++]) throw new Error("decryption error");
        return h.slice(l);
      }(l, h);
      if (1 === d) return function (e, t, r) {
        var n = t.slice(0, 2),
            i = 2,
            o = 0;

        for (; 0 !== t[i++];) {
          if (i >= t.length) {
            o++;
            break;
          }
        }

        var a = t.slice(2, i - 1);
        ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && o++;
        a.length < 8 && o++;
        if (o) throw new Error("decryption error");
        return t.slice(i);
      }(0, h, r);
      if (3 === d) return h;
      throw new Error("unknown padding");
    };
  }, function (e, t, r) {
    "use strict";

    (function (e, n) {
      function i() {
        throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
      }

      var o = r(1),
          a = r(12),
          s = o.Buffer,
          f = o.kMaxLength,
          c = e.crypto || e.msCrypto,
          u = Math.pow(2, 32) - 1;

      function d(e, t) {
        if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
        if (e > u || e < 0) throw new TypeError("offset must be a uint32");
        if (e > f || e > t) throw new RangeError("offset out of range");
      }

      function h(e, t, r) {
        if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
        if (e > u || e < 0) throw new TypeError("size must be a uint32");
        if (e + t > r || e > f) throw new RangeError("buffer too small");
      }

      function l(e, t, r, i) {
        if (n.browser) {
          var o = e.buffer,
              s = new Uint8Array(o, t, r);
          return c.getRandomValues(s), i ? void n.nextTick(function () {
            i(null, e);
          }) : e;
        }

        if (!i) return a(r).copy(e, t), e;
        a(r, function (r, n) {
          if (r) return i(r);
          n.copy(e, t), i(null, e);
        });
      }

      c && c.getRandomValues || !n.browser ? (t.randomFill = function (t, r, n, i) {
        if (!(s.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        if ("function" == typeof r) i = r, r = 0, n = t.length;else if ("function" == typeof n) i = n, n = t.length - r;else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
        return d(r, t.length), h(n, r, t.length), l(t, r, n, i);
      }, t.randomFillSync = function (t, r, n) {
        void 0 === r && (r = 0);
        if (!(s.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        d(r, t.length), void 0 === n && (n = t.length - r);
        return h(n, r, t.length), l(t, r, n);
      }) : (t.randomFill = i, t.randomFillSync = i);
    }).call(this, r(6), r(7));
  }, function (e, t, r) {
    for (var n = r(177), i = [], o = {}, a = 0; a < 256; ++a) {
      i[a] = (a + 256).toString(16).substr(1), o[i[a]] = a;
    }

    function s(e, t) {
      var r = t || 0,
          n = i;
      return n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]];
    }

    var f = n(),
        c = [1 | f[0], f[1], f[2], f[3], f[4], f[5]],
        u = 16383 & (f[6] << 8 | f[7]),
        d = 0,
        h = 0;

    function l(e, t, r) {
      var i = t && r || 0;
      "string" == typeof e && (t = "binary" == e ? new Array(16) : null, e = null);
      var o = (e = e || {}).random || (e.rng || n)();
      if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) for (var a = 0; a < 16; ++a) {
        t[i + a] = o[a];
      }
      return t || s(o);
    }

    var p = l;
    p.v1 = function (e, t, r) {
      var n = t && r || 0,
          i = t || [],
          o = void 0 !== (e = e || {}).clockseq ? e.clockseq : u,
          a = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
          f = void 0 !== e.nsecs ? e.nsecs : h + 1,
          l = a - d + (f - h) / 1e4;
      if (l < 0 && void 0 === e.clockseq && (o = o + 1 & 16383), (l < 0 || a > d) && void 0 === e.nsecs && (f = 0), f >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      d = a, h = f, u = o;
      var p = (1e4 * (268435455 & (a += 122192928e5)) + f) % 4294967296;
      i[n++] = p >>> 24 & 255, i[n++] = p >>> 16 & 255, i[n++] = p >>> 8 & 255, i[n++] = 255 & p;
      var b = a / 4294967296 * 1e4 & 268435455;
      i[n++] = b >>> 8 & 255, i[n++] = 255 & b, i[n++] = b >>> 24 & 15 | 16, i[n++] = b >>> 16 & 255, i[n++] = o >>> 8 | 128, i[n++] = 255 & o;

      for (var m = e.node || c, y = 0; y < 6; ++y) {
        i[n + y] = m[y];
      }

      return t || s(i);
    }, p.v4 = l, e.exports = p;
  }, function (e, t, r) {
    (function (t) {
      var r,
          n = t.crypto || t.msCrypto;

      if (n && n.getRandomValues) {
        var i = new Uint8Array(16);

        r = function r() {
          return n.getRandomValues(i), i;
        };
      }

      if (!r) {
        var o = new Array(16);

        r = function r() {
          for (var e, t = 0; t < 16; t++) {
            0 == (3 & t) && (e = 4294967296 * Math.random()), o[t] = e >>> ((3 & t) << 3) & 255;
          }

          return o;
        };
      }

      e.exports = r;
    }).call(this, r(6));
  }, function (module, exports, __webpack_require__) {
    (function (process, __dirname, module) {
      module.exports = function (requested_total_memory) {
        var Module = {
          TOTAL_MEMORY: requested_total_memory || 33554432
        },
            scrypt_raw = Module;

        function g(e) {
          throw e;
        }

        var k = void 0,
            l = !0,
            m = null,
            p = !1,
            q,
            s;

        function aa() {
          return function () {};
        }

        s || (s = eval("(function() { try { return Module || {} } catch(e) { return {} } })()"));
        var ba = {},
            t;

        for (t in s) {
          s.hasOwnProperty(t) && (ba[t] = s[t]);
        }

        var ca = "object" == typeof process && !0,
            da = "object" == typeof window,
            ea = "function" == typeof importScripts,
            fa = !da && !ca && !ea,
            oa;

        if (ca) {
          s.print = function (e) {
            process.stdout.write(e + "\n");
          }, s.printErr = function (e) {
            process.stderr.write(e + "\n");
          };

          var ga = __webpack_require__(43),
              ha = __webpack_require__(44);

          s.read = function (e, t) {
            e = ha.normalize(e);
            var r = ga.readFileSync(e);
            return !r && e != ha.resolve(e) && (e = path.join(__dirname, "..", "src", e), r = ga.readFileSync(e)), r && !t && (r = r.toString()), r;
          }, s.readBinary = function (e) {
            return s.read(e, l);
          }, s.load = function (e) {
            ia(read(e));
          }, s.arguments = process.argv.slice(2), module.ee = s;
        } else fa ? (s.print = print, "undefined" != typeof printErr && (s.printErr = printErr), s.read = read, s.readBinary = function (e) {
          return read(e, "binary");
        }, "undefined" != typeof scriptArgs ? s.arguments = scriptArgs : void 0 !== arguments && (s.arguments = arguments), this.Module = s) : da || ea ? (s.read = function (e) {
          var t = new XMLHttpRequest();
          return t.open("GET", e, p), t.send(m), t.responseText;
        }, void 0 !== arguments && (s.arguments = arguments), da ? (s.print = function (e) {
          console.log(e);
        }, s.printErr = function (e) {
          console.log(e);
        }, this.Module = s) : ea && (s.print = aa(), s.load = importScripts)) : g("Unknown runtime environment. Where are we?");

        function ia(e) {
          eval.call(m, e);
        }

        for (t in "undefined" == !s.load && s.read && (s.load = function (e) {
          ia(s.read(e));
        }), s.print || (s.print = aa()), s.printErr || (s.printErr = s.print), s.arguments || (s.arguments = []), s.print = s.print, s.P = s.printErr, s.preRun = [], s.postRun = [], ba) {
          ba.hasOwnProperty(t) && (s[t] = ba[t]);
        }

        function ja() {
          return u;
        }

        function ka(e) {
          u = e;
        }

        function la(e) {
          if (1 == ma) return 1;
          var t = {
            "%i1": 1,
            "%i8": 1,
            "%i16": 2,
            "%i32": 4,
            "%i64": 8,
            "%float": 4,
            "%double": 8
          }["%" + e];
          return t || ("*" == e.charAt(e.length - 1) ? t = ma : "i" == e[0] && (w(0 == (e = parseInt(e.substr(1))) % 8), t = e / 8)), t;
        }

        function na(e, t, r) {
          r && r.length ? (r.splice || (r = Array.prototype.slice.call(r)), r.splice(0, 0, t), s["dynCall_" + e].apply(m, r)) : s["dynCall_" + e].call(m, t);
        }

        function pa() {
          var e = [],
              t = 0;
          this.oa = function (r) {
            if (r &= 255, t && (e.push(r), t--), 0 == e.length) return 128 > r ? String.fromCharCode(r) : (e.push(r), t = 191 < r && 224 > r ? 1 : 2, "");
            if (0 < t) return "";
            r = e[0];
            var n = e[1],
                i = e[2];
            r = 191 < r && 224 > r ? String.fromCharCode((31 & r) << 6 | 63 & n) : String.fromCharCode((15 & r) << 12 | (63 & n) << 6 | 63 & i);
            return e.length = 0, r;
          }, this.yb = function (e) {
            e = unescape(encodeURIComponent(e));

            for (var t = [], r = 0; r < e.length; r++) {
              t.push(e.charCodeAt(r));
            }

            return t;
          };
        }

        function qa(e) {
          var t = u;
          return u = (u = u + e | 0) + 7 >> 3 << 3, t;
        }

        function ra(e) {
          var t = sa;
          return sa = (sa = sa + e | 0) + 7 >> 3 << 3, t;
        }

        function ua(e) {
          var t = z;
          return (z = (z = z + e | 0) + 7 >> 3 << 3) >= va && wa("Cannot enlarge memory arrays in asm.js. Either (1) compile with -s TOTAL_MEMORY=X with X higher than the current value, or (2) set Module.TOTAL_MEMORY before the program runs."), t;
        }

        function xa(e, t) {
          return Math.ceil(e / (t || 8)) * (t || 8);
        }

        var ma = 4,
            ya = {},
            za = p,
            Aa;

        function w(e, t) {
          e || wa("Assertion failed: " + t);
        }

        function Ca(a) {
          try {
            var b = s["_" + a];
            b || (b = eval("_" + a));
          } catch (e) {}

          return w(b, "Cannot call unknown function " + a + " (perhaps LLVM optimizations or closure removed it?)"), b;
        }

        function Ba(e, t, r, n) {
          var i = 0,
              o = 0;
          n = n ? n.map(function (e) {
            return function (e, t) {
              if ("string" == t) {
                if (e === m || e === k || 0 === e) return 0;
                i || (i = ja());
                var r = qa(e.length + 1);
                return Da(e, r), r;
              }

              return "array" == t ? (i || (i = ja()), Ea(e, r = qa(e.length)), r) : e;
            }(e, r[o++]);
          }) : [];
          return e = e.apply(m, n), "string" == t ? t = Fa(e) : (w("array" != t), t = e), i && ka(i), t;
        }

        function Ga(e, t, r) {
          switch ("*" === (r = r || "i8").charAt(r.length - 1) && (r = "i32"), r) {
            case "i1":
            case "i8":
              A[e] = t;
              break;

            case "i16":
              Ha[e >> 1] = t;
              break;

            case "i32":
              B[e >> 2] = t;
              break;

            case "i64":
              Aa = [t >>> 0, (0 | Math.min(+Math.floor(t / 4294967296), 4294967295)) >>> 0], B[e >> 2] = Aa[0], B[e + 4 >> 2] = Aa[1];
              break;

            case "float":
              Ia[e >> 2] = t;
              break;

            case "double":
              Ja[e >> 3] = t;
              break;

            default:
              wa("invalid type for setValue: " + r);
          }
        }

        s.ccall = function (e, t, r, n) {
          return Ba(Ca(e), t, r, n);
        }, s.cwrap = function (e, t, r) {
          var n = Ca(e);
          return function () {
            return Ba(n, t, r, Array.prototype.slice.call(arguments));
          };
        }, s.setValue = Ga, s.getValue = function (e, t) {
          switch ("*" === (t = t || "i8").charAt(t.length - 1) && (t = "i32"), t) {
            case "i1":
            case "i8":
              return A[e];

            case "i16":
              return Ha[e >> 1];

            case "i32":
            case "i64":
              return B[e >> 2];

            case "float":
              return Ia[e >> 2];

            case "double":
              return Ja[e >> 3];

            default:
              wa("invalid type for setValue: " + t);
          }

          return m;
        };
        var Ka = 0,
            La = 1,
            E = 2,
            Na = 4;

        function F(e, t, r, n) {
          var i, o;
          "number" == typeof e ? (i = l, o = e) : (i = p, o = e.length);
          var a = "string" == typeof t ? t : m;
          r = r == Na ? n : [Oa, qa, ra, ua][r === k ? E : r](Math.max(o, a ? 1 : t.length));

          if (i) {
            for (n = r, w(0 == (3 & r)), e = r + (-4 & o); n < e; n += 4) {
              B[n >> 2] = 0;
            }

            for (e = r + o; n < e;) {
              A[0 | n++] = 0;
            }

            return r;
          }

          if ("i8" === a) return e.subarray || e.slice ? G.set(e, r) : G.set(new Uint8Array(e), r), r;
          var s, f;

          for (n = 0; n < o;) {
            var c = e[n];
            "function" == typeof c && (c = ya.fe(c)), 0 === (i = a || t[n]) ? n++ : ("i64" == i && (i = "i32"), Ga(r + n, c, i), f !== i && (s = la(i), f = i), n += s);
          }

          return r;
        }

        function Fa(e, t) {
          for (var r, n = p, i = 0;;) {
            if (128 <= (r = G[e + i | 0])) n = l;else if (0 == r && !t) break;
            if (i++, t && i == t) break;
          }

          t || (t = i);
          var o = "";

          if (!n) {
            for (; 0 < t;) {
              r = String.fromCharCode.apply(String, G.subarray(e, e + Math.min(t, 1024))), o = o ? o + r : r, e += 1024, t -= 1024;
            }

            return o;
          }

          for (n = new pa(), i = 0; i < t; i++) {
            r = G[e + i | 0], o += n.oa(r);
          }

          return o;
        }

        s.ALLOC_NORMAL = Ka, s.ALLOC_STACK = La, s.ALLOC_STATIC = E, s.ALLOC_DYNAMIC = 3, s.ALLOC_NONE = Na, s.allocate = F, s.Pointer_stringify = Fa;
        var A,
            G,
            Ha,
            Pa,
            B,
            Qa,
            Ia,
            Ja,
            Ra = 0,
            sa = 0,
            Sa = 0,
            u = 0,
            Ta = 0,
            Ua = 0,
            z = 0,
            va = s.TOTAL_MEMORY || 33554432;
        w(!!(Int32Array && Float64Array && new Int32Array(1).subarray && new Int32Array(1).set), "Cannot fallback to non-typed array case: Code is too specialized");
        var I = new ArrayBuffer(va);

        function Va(e) {
          for (; 0 < e.length;) {
            var t = e.shift();
            if ("function" == typeof t) t();else {
              var r = t.V;
              "number" == typeof r ? t.ha === k ? na("v", r) : na("vi", r, [t.ha]) : r(t.ha === k ? m : t.ha);
            }
          }
        }

        A = new Int8Array(I), Ha = new Int16Array(I), B = new Int32Array(I), G = new Uint8Array(I), Pa = new Uint16Array(I), Qa = new Uint32Array(I), Ia = new Float32Array(I), Ja = new Float64Array(I), B[0] = 255, w(255 === G[0] && 0 === G[3], "Typed arrays 2 must be run on a little-endian system"), s.HEAP = k, s.HEAP8 = A, s.HEAP16 = Ha, s.HEAP32 = B, s.HEAPU8 = G, s.HEAPU16 = Pa, s.HEAPU32 = Qa, s.HEAPF32 = Ia, s.HEAPF64 = Ja;
        var Wa = [],
            Xa = [],
            Ya = [],
            Za = [],
            $a = [],
            ab = p;

        function bb(e) {
          Wa.unshift(e);
        }

        function cb(e) {
          $a.unshift(e);
        }

        function J(e, t, r) {
          return e = new pa().yb(e), r && (e.length = r), t || e.push(0), e;
        }

        function Da(e, t, r) {
          for (e = J(e, r), r = 0; r < e.length;) {
            A[t + r | 0] = e[r], r += 1;
          }
        }

        function Ea(e, t) {
          for (var r = 0; r < e.length; r++) {
            A[t + r | 0] = e[r];
          }
        }

        function db(e, t) {
          return 0 <= e ? e : 32 >= t ? 2 * Math.abs(1 << t - 1) + e : Math.pow(2, t) + e;
        }

        function eb(e, t) {
          if (0 >= e) return e;
          var r = 32 >= t ? Math.abs(1 << t - 1) : Math.pow(2, t - 1);
          return e >= r && (32 >= t || e > r) && (e = -2 * r + e), e;
        }

        s.addOnPreRun = s.Vd = bb, s.addOnInit = s.Sd = function (e) {
          Xa.unshift(e);
        }, s.addOnPreMain = s.Ud = function (e) {
          Ya.unshift(e);
        }, s.addOnExit = s.Rd = function (e) {
          Za.unshift(e);
        }, s.addOnPostRun = s.Td = cb, s.intArrayFromString = J, s.intArrayToString = function (e) {
          for (var t = [], r = 0; r < e.length; r++) {
            var n = e[r];
            255 < n && (n &= 255), t.push(String.fromCharCode(n));
          }

          return t.join("");
        }, s.writeStringToMemory = Da, s.writeArrayToMemory = Ea, Math.imul || (Math.imul = function (e, t) {
          var r = 65535 & e,
              n = 65535 & t;
          return r * n + ((e >>> 16) * n + r * (t >>> 16) << 16) | 0;
        }), Math.ie = Math.imul;
        var L = 0,
            fb = {},
            gb = p,
            hb = m,
            nb,
            ob,
            pb;

        function ib(e) {
          L++, s.monitorRunDependencies && s.monitorRunDependencies(L), e ? (w(!fb[e]), fb[e] = 1) : s.P("warning: run dependency added without ID");
        }

        function jb(e) {
          L--, s.monitorRunDependencies && s.monitorRunDependencies(L), e ? (w(fb[e]), delete fb[e]) : s.P("warning: run dependency removed without ID"), 0 == L && (hb !== m && (clearInterval(hb), hb = m), !gb && kb && lb());
        }

        s.addRunDependency = ib, s.removeRunDependency = jb, s.preloadedImages = {}, s.preloadedAudios = {}, Ra = 8, sa = Ra + 1312, Xa.push({
          V: function V() {
            mb();
          }
        }), nb = nb = F([0, 0, 0, 0, 0, 0, 0, 0], "i8", E), ob = ob = F([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "i8", E), pb = pb = F([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "i8", E), F([111, 112, 116, 105, 111, 110, 32, 114, 101, 113, 117, 105, 114, 101, 115, 32, 97, 110, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 45, 45, 32, 37, 115, 0, 0, 0, 0, 0, 0, 0, 111, 112, 116, 105, 111, 110, 32, 114, 101, 113, 117, 105, 114, 101, 115, 32, 97, 110, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 45, 45, 32, 37, 99, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 36, 64, 0, 0, 0, 0, 0, 0, 89, 64, 0, 0, 0, 0, 0, 136, 195, 64, 0, 0, 0, 0, 132, 215, 151, 65, 0, 128, 224, 55, 121, 195, 65, 67, 23, 110, 5, 181, 181, 184, 147, 70, 245, 249, 63, 233, 3, 79, 56, 77, 50, 29, 48, 249, 72, 119, 130, 90, 60, 191, 115, 127, 221, 79, 21, 117, 56, 3, 0, 0, 0, 0, 0, 0, 63, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255, 0, 0, 0, 0, 255, 255, 255, 255, 0, 0, 0, 0, 111, 112, 116, 105, 111, 110, 32, 100, 111, 101, 115, 110, 39, 116, 32, 116, 97, 107, 101, 32, 97, 110, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 45, 45, 32, 37, 46, 42, 115, 0, 117, 110, 107, 110, 111, 119, 110, 32, 111, 112, 116, 105, 111, 110, 32, 45, 45, 32, 37, 115, 0, 0, 0, 0, 117, 110, 107, 110, 111, 119, 110, 32, 111, 112, 116, 105, 111, 110, 32, 45, 45, 32, 37, 99, 0, 0, 0, 0, 255, 255, 255, 255, 0, 0, 0, 0, 97, 109, 98, 105, 103, 117, 111, 117, 115, 32, 111, 112, 116, 105, 111, 110, 32, 45, 45, 32, 37, 46, 42, 115, 0, 0, 0, 0, 0, 0, 0, 0, 37, 115, 58, 32, 0, 0, 0, 0, 80, 79, 83, 73, 88, 76, 89, 95, 67, 79, 82, 82, 69, 67, 84, 0, 115, 116, 100, 58, 58, 98, 97, 100, 95, 97, 108, 108, 111, 99, 0, 0, 37, 115, 58, 32, 0, 0, 0, 0, 37, 115, 10, 0, 0, 0, 0, 0, 37, 115, 10, 0, 0, 0, 0, 0, 105, 110, 32, 117, 115, 101, 32, 98, 121, 116, 101, 115, 32, 32, 32, 32, 32, 61, 32, 37, 49, 48, 108, 117, 10, 0, 0, 0, 0, 0, 0, 0, 37, 115, 58, 32, 0, 0, 0, 0, 37, 115, 58, 32, 0, 0, 0, 0, 98, 97, 100, 95, 97, 114, 114, 97, 121, 95, 110, 101, 119, 95, 108, 101, 110, 103, 116, 104, 0, 0, 0, 0, 58, 32, 0, 0, 0, 0, 0, 0, 58, 32, 0, 0, 0, 0, 0, 0, 115, 121, 115, 116, 101, 109, 32, 98, 121, 116, 101, 115, 32, 32, 32, 32, 32, 61, 32, 37, 49, 48, 108, 117, 10, 0, 0, 0, 0, 0, 0, 0, 109, 97, 120, 32, 115, 121, 115, 116, 101, 109, 32, 98, 121, 116, 101, 115, 32, 61, 32, 37, 49, 48, 108, 117, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 176, 2, 0, 0, 6, 0, 0, 0, 10, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 2, 0, 0, 6, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 116, 57, 101, 120, 99, 101, 112, 116, 105, 111, 110, 0, 0, 0, 0, 83, 116, 57, 98, 97, 100, 95, 97, 108, 108, 111, 99, 0, 0, 0, 0, 83, 116, 50, 48, 98, 97, 100, 95, 97, 114, 114, 97, 121, 95, 110, 101, 119, 95, 108, 101, 110, 103, 116, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 104, 2, 0, 0, 0, 0, 0, 0, 120, 2, 0, 0, 168, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 136, 2, 0, 0, 176, 2, 0, 0, 0, 0, 0, 0, 128, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "i8", Na, 8);
        var qb = xa(F(12, "i8", E), 8);
        w(0 == qb % 8);
        var rb = 0;

        function M(e) {
          return B[rb >> 2] = e;
        }

        s._memcpy = sb, s._memset = tb;
        var N = {
          L: 1,
          ca: 2,
          Bd: 3,
          sc: 4,
          I: 5,
          za: 6,
          Jb: 7,
          Sc: 8,
          $: 9,
          Zb: 10,
          ua: 11,
          Ld: 11,
          $a: 12,
          Ya: 13,
          kc: 14,
          ed: 15,
          Wb: 16,
          va: 17,
          Md: 18,
          wa: 19,
          gd: 20,
          aa: 21,
          A: 22,
          Mc: 23,
          Za: 24,
          ld: 25,
          Id: 26,
          lc: 27,
          ad: 28,
          da: 29,
          yd: 30,
          Fc: 31,
          rd: 32,
          hc: 33,
          ab: 34,
          Wc: 35,
          pc: 36,
          $b: 37,
          vc: 38,
          wc: 39,
          xc: 40,
          Ec: 41,
          Jd: 42,
          Qc: 43,
          uc: 44,
          ec: 45,
          Tc: 46,
          Pb: 50,
          Sb: 51,
          Nd: 52,
          Oc: 53,
          Tb: 54,
          Ub: 55,
          fc: 56,
          Vb: 57,
          cd: 60,
          Rc: 61,
          Fd: 62,
          bd: 63,
          Xc: 64,
          Yc: 65,
          xd: 66,
          Uc: 67,
          Mb: 68,
          Cd: 69,
          ac: 70,
          td: 71,
          Hc: 74,
          yc: 75,
          ic: 76,
          Rb: 77,
          mc: 79,
          md: 80,
          Qb: 81,
          wd: 82,
          zc: 83,
          Ac: 84,
          Dc: 85,
          Cc: 86,
          Bc: 87,
          dd: 88,
          Nc: 89,
          ya: 90,
          Ic: 91,
          ba: 92,
          nd: 95,
          qd: 96,
          dc: 104,
          Pc: 105,
          Nb: 106,
          vd: 107,
          jd: 108,
          Zc: 109,
          zd: 110,
          cc: 111,
          Kb: 112,
          bc: 113,
          Lc: 114,
          Jc: 115,
          Gd: 116,
          nc: 117,
          oc: 118,
          rc: 119,
          Ob: 120,
          gc: 121,
          Gc: 122,
          ud: 123,
          Ad: 124,
          Lb: 125,
          Kc: 126,
          tc: 127,
          fd: 128,
          Hd: 129,
          sd: 130,
          Kd: 131,
          jc: 132,
          Dd: 133,
          kd: 134,
          Vc: 135,
          $c: 136,
          Yb: 137,
          qc: 138,
          od: 139,
          Xb: 140,
          hd: 141,
          pd: 142,
          Ed: 143
        },
            ub = {
          0: "Success",
          1: "Not super-user",
          2: "No such file or directory",
          3: "No such process",
          4: "Interrupted system call",
          5: "I/O error",
          6: "No such device or address",
          7: "Arg list too long",
          8: "Exec format error",
          9: "Bad file number",
          10: "No children",
          11: "No more processes",
          12: "Not enough core",
          13: "Permission denied",
          14: "Bad address",
          15: "Block device required",
          16: "Mount device busy",
          17: "File exists",
          18: "Cross-device link",
          19: "No such device",
          20: "Not a directory",
          21: "Is a directory",
          22: "Invalid argument",
          23: "Too many open files in system",
          24: "Too many open files",
          25: "Not a typewriter",
          26: "Text file busy",
          27: "File too large",
          28: "No space left on device",
          29: "Illegal seek",
          30: "Read only file system",
          31: "Too many links",
          32: "Broken pipe",
          33: "Math arg out of domain of func",
          34: "Math result not representable",
          35: "No message of desired type",
          36: "Identifier removed",
          37: "Channel number out of range",
          38: "Level 2 not synchronized",
          39: "Level 3 halted",
          40: "Level 3 reset",
          41: "Link number out of range",
          42: "Protocol driver not attached",
          43: "No CSI structure available",
          44: "Level 2 halted",
          45: "Deadlock condition",
          46: "No record locks available",
          50: "Invalid exchange",
          51: "Invalid request descriptor",
          52: "Exchange full",
          53: "No anode",
          54: "Invalid request code",
          55: "Invalid slot",
          56: "File locking deadlock error",
          57: "Bad font file fmt",
          60: "Device not a stream",
          61: "No data (for no delay io)",
          62: "Timer expired",
          63: "Out of streams resources",
          64: "Machine is not on the network",
          65: "Package not installed",
          66: "The object is remote",
          67: "The link has been severed",
          68: "Advertise error",
          69: "Srmount error",
          70: "Communication error on send",
          71: "Protocol error",
          74: "Multihop attempted",
          75: "Inode is remote (not really error)",
          76: "Cross mount point (not really error)",
          77: "Trying to read unreadable message",
          79: "Inappropriate file type or format",
          80: "Given log. name not unique",
          81: "f.d. invalid for this operation",
          82: "Remote address changed",
          83: "Can\t access a needed shared lib",
          84: "Accessing a corrupted shared lib",
          85: ".lib section in a.out corrupted",
          86: "Attempting to link in too many libs",
          87: "Attempting to exec a shared library",
          88: "Function not implemented",
          89: "No more files",
          90: "Directory not empty",
          91: "File or path name too long",
          92: "Too many symbolic links",
          95: "Operation not supported on transport endpoint",
          96: "Protocol family not supported",
          104: "Connection reset by peer",
          105: "No buffer space available",
          106: "Address family not supported by protocol family",
          107: "Protocol wrong type for socket",
          108: "Socket operation on non-socket",
          109: "Protocol not available",
          110: "Can't send after socket shutdown",
          111: "Connection refused",
          112: "Address already in use",
          113: "Connection aborted",
          114: "Network is unreachable",
          115: "Network interface is not configured",
          116: "Connection timed out",
          117: "Host is down",
          118: "Host is unreachable",
          119: "Connection already in progress",
          120: "Socket already connected",
          121: "Destination address required",
          122: "Message too long",
          123: "Unknown protocol",
          124: "Socket type not supported",
          125: "Address not available",
          126: "ENETRESET",
          127: "Socket is already connected",
          128: "Socket is not connected",
          129: "TOOMANYREFS",
          130: "EPROCLIM",
          131: "EUSERS",
          132: "EDQUOT",
          133: "ESTALE",
          134: "Not supported",
          135: "No medium (in tape drive)",
          136: "No such host or network path",
          137: "Filename exists with different case",
          138: "EILSEQ",
          139: "Value too large for defined data type",
          140: "Operation canceled",
          141: "State not recoverable",
          142: "Previous owner died",
          143: "Streams pipe error"
        };

        function vb(e, t, r) {
          var n = O(e, {
            parent: l
          }).d,
              i = xb(n, e = "/" === e ? "/" : wb(e)[2]);
          return i && g(new _Q(i)), n.l.Ta || g(new _Q(N.L)), n.l.Ta(n, e, t, r);
        }

        function yb(e, t) {
          return vb(e, t = 4095 & t | 32768, 0);
        }

        function zb(e, t) {
          return vb(e, t = 1023 & t | 16384, 0);
        }

        function Ab(e, t, r) {
          return vb(e, 8192 | t, r);
        }

        function Bb(e, t) {
          var r = O(t, {
            parent: l
          }).d,
              n = "/" === t ? "/" : wb(t)[2],
              i = xb(r, n);
          return i && g(new _Q(i)), r.l.Wa || g(new _Q(N.L)), r.l.Wa(r, n, e);
        }

        function Cb(e, t) {
          var r;
          (r = "string" == typeof e ? O(e, {
            N: l
          }).d : e).l.Y || g(new _Q(N.L)), r.l.Y(r, {
            mode: 4095 & t | -4096 & r.mode,
            timestamp: Date.now()
          });
        }

        function Db(e, t) {
          var r, n, i;
          e = Eb(e);
          "string" == typeof t ? void 0 === (n = Fb[t]) && g(Error("Unknown file open mode: " + t)) : n = t, r = 512 & (t = n) ? 4095 & r | 32768 : 0;

          try {
            var o = O(e, {
              N: !(65536 & t)
            });
            i = o.d, e = o.path;
          } catch (e) {}

          512 & t && (i ? 2048 & t && g(new _Q(N.va)) : i = vb(e, r, 0)), i || g(new _Q(N.ca)), 8192 == (61440 & i.mode) && (t &= -1025), i ? 40960 == (61440 & i.mode) ? r = N.ba : 16384 == (61440 & i.mode) && (0 != (3 & t) || 1024 & t) ? r = N.aa : (r = ["r", "w", "rw"][3 & t], 1024 & t && (r += "w"), r = Gb(i, r)) : r = N.ca, r && g(new _Q(r)), 1024 & t && ((r = "string" == typeof (r = i) ? O(r, {
            N: l
          }).d : r).l.Y || g(new _Q(N.L)), 16384 == (61440 & r.mode) && g(new _Q(N.aa)), 32768 != (61440 & r.mode) && g(new _Q(N.A)), (o = Gb(r, "w")) && g(new _Q(o)), r.l.Y(r, {
            size: 0,
            timestamp: Date.now()
          }));
          var a,
              s = {
            path: e,
            d: i,
            M: t,
            seekable: l,
            position: 0,
            e: i.e,
            Gb: [],
            error: p
          };

          e: {
            for (i = k || 4096, r = k || 1; r <= i; r++) {
              if (!R[r]) {
                a = r;
                break e;
              }
            }

            g(new _Q(N.Za));
          }

          return s.s = a, Object.defineProperty(s, "object", {
            get: function get() {
              return s.d;
            },
            set: function set(e) {
              s.d = e;
            }
          }), Object.defineProperty(s, "isRead", {
            get: function get() {
              return 1 != (3 & s.M);
            }
          }), Object.defineProperty(s, "isWrite", {
            get: function get() {
              return 0 != (3 & s.M);
            }
          }), Object.defineProperty(s, "isAppend", {
            get: function get() {
              return 8 & s.M;
            }
          }), R[a] = s, s.e.open && s.e.open(s), s;
        }

        function Hb(e) {
          try {
            e.e.close && e.e.close(e);
          } catch (e) {
            g(e);
          } finally {
            R[e.s] = m;
          }
        }

        function Ib(e, t, r, n, i) {
          (0 > n || 0 > i) && g(new _Q(N.A)), 0 == (3 & e.M) && g(new _Q(N.$)), 16384 == (61440 & e.d.mode) && g(new _Q(N.aa)), e.e.write || g(new _Q(N.A));
          var o = l;
          return void 0 === i ? (i = e.position, o = p) : e.seekable || g(new _Q(N.da)), 8 & e.M && ((!e.seekable || !e.e.na) && g(new _Q(N.da)), e.e.na(e, 0, 2)), t = e.e.write(e, t, r, n, i), o || (e.position += t), t;
        }

        function wb(e) {
          return /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(e).slice(1);
        }

        function Jb(e, t) {
          for (var r = 0, n = e.length - 1; 0 <= n; n--) {
            var i = e[n];
            "." === i ? e.splice(n, 1) : ".." === i ? (e.splice(n, 1), r++) : r && (e.splice(n, 1), r--);
          }

          if (t) for (; r--; r) {
            e.unshift("..");
          }
          return e;
        }

        function Eb(e) {
          var t = "/" === e.charAt(0),
              r = "/" === e.substr(-1);
          return !(e = Jb(e.split("/").filter(function (e) {
            return !!e;
          }), !t).join("/")) && !t && (e = "."), e && r && (e += "/"), (t ? "/" : "") + e;
        }

        function S() {
          var e = Array.prototype.slice.call(arguments, 0);
          return Eb(e.filter(function (e) {
            return "string" != typeof e && g(new TypeError("Arguments to path.join must be strings")), e;
          }).join("/"));
        }

        function Kb() {
          for (var e = "", t = p, r = arguments.length - 1; -1 <= r && !t; r--) {
            var n = 0 <= r ? arguments[r] : "/";
            "string" != typeof n && g(new TypeError("Arguments to path.resolve must be strings")), n && (e = n + "/" + e, t = "/" === n.charAt(0));
          }

          return (t ? "/" : "") + (e = Jb(e.split("/").filter(function (e) {
            return !!e;
          }), !t).join("/")) || ".";
        }

        var Lb = [];

        function Mb(e, t) {
          Lb[e] = {
            input: [],
            H: [],
            O: t
          }, Nb[e] = {
            e: Ob
          };
        }

        var Ob = {
          open: function open(e) {
            Pb || (Pb = new pa());
            var t = Lb[e.d.X];
            t || g(new _Q(N.wa)), e.q = t, e.seekable = p;
          },
          close: function close(e) {
            e.q.H.length && e.q.O.W(e.q, 10);
          },
          Q: function Q(e, t, r, n) {
            (!e.q || !e.q.O.Na) && g(new _Q(N.za));

            for (var i = 0, o = 0; o < n; o++) {
              var a;

              try {
                a = e.q.O.Na(e.q);
              } catch (e) {
                g(new _Q(N.I));
              }

              if (a === k && 0 === i && g(new _Q(N.ua)), a === m || a === k) break;
              i++, t[r + o] = a;
            }

            return i && (e.d.timestamp = Date.now()), i;
          },
          write: function write(e, t, r, n) {
            (!e.q || !e.q.O.W) && g(new _Q(N.za));

            for (var i = 0; i < n; i++) {
              try {
                e.q.O.W(e.q, t[r + i]);
              } catch (e) {
                g(new _Q(N.I));
              }
            }

            return n && (e.d.timestamp = Date.now()), i;
          }
        },
            Pb,
            T = {
          z: function z() {
            return T.ka(m, "/", 16895, 0);
          },
          ka: function ka(e, t, r, n) {
            return (24576 == (61440 & r) || 4096 == (61440 & r)) && g(new _Q(N.L)), (r = Qb(e, t, r, n)).l = T.l, 16384 == (61440 & r.mode) ? (r.e = T.e, r.g = {}) : 32768 == (61440 & r.mode) ? (r.e = T.e, r.g = []) : 40960 == (61440 & r.mode) ? r.e = T.e : 8192 == (61440 & r.mode) && (r.e = Rb), r.timestamp = Date.now(), e && (e.g[t] = r), r;
          },
          l: {
            ge: function ge(e) {
              var t = {};
              return t.ce = 8192 == (61440 & e.mode) ? e.id : 1, t.je = e.id, t.mode = e.mode, t.pe = 1, t.uid = 0, t.he = 0, t.X = e.X, t.size = 16384 == (61440 & e.mode) ? 4096 : 32768 == (61440 & e.mode) ? e.g.length : 40960 == (61440 & e.mode) ? e.link.length : 0, t.Yd = new Date(e.timestamp), t.oe = new Date(e.timestamp), t.ae = new Date(e.timestamp), t.ib = 4096, t.Zd = Math.ceil(t.size / t.ib), t;
            },
            Y: function Y(e, t) {
              if (t.mode !== k && (e.mode = t.mode), t.timestamp !== k && (e.timestamp = t.timestamp), t.size !== k) {
                var r = e.g;
                if (t.size < r.length) r.length = t.size;else for (; t.size > r.length;) {
                  r.push(0);
                }
              }
            },
            tb: function tb() {
              g(new _Q(N.ca));
            },
            Ta: function Ta(e, t, r, n) {
              return T.ka(e, t, r, n);
            },
            rename: function rename(e, t, r) {
              if (16384 == (61440 & e.mode)) {
                var n;

                try {
                  n = Sb(t, r);
                } catch (e) {}

                if (n) for (var i in n.g) {
                  g(new _Q(N.ya));
                }
              }

              delete e.parent.g[e.name], e.name = r, t.g[r] = e;
            },
            ze: function ze(e, t) {
              delete e.g[t];
            },
            ve: function ve(e, t) {
              var r,
                  n = Sb(e, t);

              for (r in n.g) {
                g(new _Q(N.ya));
              }

              delete e.g[t];
            },
            Wa: function Wa(e, t, r) {
              return (e = T.ka(e, t, 41471, 0)).link = r, e;
            },
            Va: function Va(e) {
              return 40960 != (61440 & e.mode) && g(new _Q(N.A)), e.link;
            }
          },
          e: {
            open: function open(e) {
              if (16384 == (61440 & e.d.mode)) {
                var t,
                    r = [".", ".."];

                for (t in e.d.g) {
                  e.d.g.hasOwnProperty(t) && r.push(t);
                }

                e.lb = r;
              }
            },
            Q: function Q(e, t, r, n, i) {
              if (e = e.d.g, n = Math.min(e.length - i, n), e.subarray) t.set(e.subarray(i, i + n), r);else for (var o = 0; o < n; o++) {
                t[r + o] = e[i + o];
              }
              return n;
            },
            write: function write(e, t, r, n, i) {
              for (var o = e.d.g; o.length < i;) {
                o.push(0);
              }

              for (var a = 0; a < n; a++) {
                o[i + a] = t[r + a];
              }

              return e.d.timestamp = Date.now(), n;
            },
            na: function na(e, t, r) {
              return 1 === r ? t += e.position : 2 === r && 32768 == (61440 & e.d.mode) && (t += e.d.g.length), 0 > t && g(new _Q(N.A)), e.Gb = [], e.position = t;
            },
            ue: function ue(e) {
              return e.lb;
            },
            Wd: function Wd(e, t, r) {
              for (e = e.d.g, t += r; t > e.length;) {
                e.push(0);
              }
            },
            ne: function ne(e, t, r, n, i, o, a) {
              return 32768 != (61440 & e.d.mode) && g(new _Q(N.wa)), e = e.d.g, 2 & a ? ((0 < i || i + n < e.length) && (e = e.subarray ? e.subarray(i, i + n) : Array.prototype.slice.call(e, i, i + n)), i = l, (n = Oa(n)) || g(new _Q(N.$a)), t.set(e, n)) : (w(e.buffer === t || e.buffer === t.buffer), i = p, n = e.byteOffset), {
                te: n,
                Xd: i
              };
            }
          }
        },
            Tb = F(1, "i32*", E),
            Ub = F(1, "i32*", E);
        nb = F(1, "i32*", E);
        var Vb = m,
            Nb = [m],
            R = [m],
            Wb = 1,
            Xb = [,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,],
            Yb = l;

        function _Q(e) {
          for (var t in this.mb = e, N) {
            if (N[t] === e) {
              this.code = t;
              break;
            }
          }

          this.message = ub[e];
        }

        function Zb(e) {
          e instanceof _Q || g(e + " : " + Error().stack), M(e.mb);
        }

        function $b(e, t) {
          for (var r = 0, n = 0; n < t.length; n++) {
            r = (r << 5) - r + t.charCodeAt(n) | 0;
          }

          return (e + r) % Xb.length;
        }

        function Sb(e, t) {
          var r = Gb(e, "x");

          for (r && g(new _Q(r)), r = Xb[$b(e.id, t)]; r; r = r.wb) {
            if (r.parent.id === e.id && r.name === t) return r;
          }

          return e.l.tb(e, t);
        }

        function Qb(e, t, r, n) {
          var i = {
            id: Wb++,
            name: t,
            mode: r,
            l: {},
            e: {},
            X: n,
            parent: m,
            z: m
          };
          return e || (e = i), i.parent = e, i.z = e.z, Object.defineProperty(i, "read", {
            get: function get() {
              return 365 == (365 & i.mode);
            },
            set: function set(e) {
              e ? i.mode |= 365 : i.mode &= -366;
            }
          }), Object.defineProperty(i, "write", {
            get: function get() {
              return 146 == (146 & i.mode);
            },
            set: function set(e) {
              e ? i.mode |= 146 : i.mode &= -147;
            }
          }), e = $b(i.parent.id, i.name), i.wb = Xb[e], Xb[e] = i;
        }

        function O(e, t) {
          e = Kb("/", e), 8 < (t = t || {
            pa: 0
          }).pa && g(new _Q(N.ba));

          for (var r = Jb(e.split("/").filter(function (e) {
            return !!e;
          }), p), n = Vb, i = "/", o = 0; o < r.length; o++) {
            var a = o === r.length - 1;
            if (a && t.parent) break;
            if (n = Sb(n, r[o]), i = S(i, r[o]), n.ub && (n = n.z.root), !a || t.N) for (a = 0; 40960 == (61440 & n.mode);) {
              (n = O(i, {
                N: p
              }).d).l.Va || g(new _Q(N.A));
              n = n.l.Va(n);
              var s = Kb,
                  f = (i = (f = wb(i))[0], f[1]);
              i || f ? (f && (f = f.substr(0, f.length - 1)), i += f) : i = ".", n = O(i = s(i, n), {
                pa: t.pa
              }).d, 40 < a++ && g(new _Q(N.ba));
            }
          }

          return {
            path: i,
            d: n
          };
        }

        function ac(e) {
          for (var t;;) {
            if (e === e.parent) return t ? S(e.z.Ua, t) : e.z.Ua;
            t = t ? S(e.name, t) : e.name, e = e.parent;
          }
        }

        var Fb = {
          r: 0,
          rs: 8192,
          "r+": 2,
          w: 1537,
          wx: 3585,
          xw: 3585,
          "w+": 1538,
          "wx+": 3586,
          "xw+": 3586,
          a: 521,
          ax: 2569,
          xa: 2569,
          "a+": 522,
          "ax+": 2570,
          "xa+": 2570
        };

        function Gb(e, t) {
          return Yb || (-1 === t.indexOf("r") || 292 & e.mode) && (-1 === t.indexOf("w") || 146 & e.mode) && (-1 === t.indexOf("x") || 73 & e.mode) ? 0 : N.Ya;
        }

        function xb(e, t) {
          try {
            return Sb(e, t), N.va;
          } catch (e) {}

          return Gb(e, "wx");
        }

        var Rb = {
          open: function open(e) {
            e.e = Nb[e.d.X].e, e.e.open && e.e.open(e);
          },
          na: function na() {
            g(new _Q(N.da));
          }
        },
            bc;

        function cc(e, t) {
          var r = 0;
          return e && (r |= 365), t && (r |= 146), r;
        }

        function dc(e, t, r, n, i) {
          if (i = yb(e = S("string" == typeof e ? e : ac(e), t), n = cc(n, i)), r) {
            if ("string" == typeof r) {
              t = Array(r.length);

              for (var o = 0, a = r.length; o < a; ++o) {
                t[o] = r.charCodeAt(o);
              }

              r = t;
            }

            Cb(e, 146 | n), Ib(t = Db(e, "w"), r, 0, r.length, 0), Hb(t), Cb(e, n);
          }

          return i;
        }

        function ec(e, t, r, n) {
          return e = S("string" == typeof e ? e : ac(e), t), ec.Sa || (ec.Sa = 64), t = ec.Sa++ << 8 | 0, Nb[t] = {
            e: {
              open: function open(e) {
                e.seekable = p;
              },
              close: function close() {
                n && n.buffer && n.buffer.length && n(10);
              },
              Q: function Q(e, t, n, i) {
                for (var o = 0, a = 0; a < i; a++) {
                  var s;

                  try {
                    s = r();
                  } catch (e) {
                    g(new _Q(N.I));
                  }

                  if (s === k && 0 === o && g(new _Q(N.ua)), s === m || s === k) break;
                  o++, t[n + a] = s;
                }

                return o && (e.d.timestamp = Date.now()), o;
              },
              write: function write(e, t, r, i) {
                for (var o = 0; o < i; o++) {
                  try {
                    n(t[r + o]);
                  } catch (e) {
                    g(new _Q(N.I));
                  }
                }

                return i && (e.d.timestamp = Date.now()), o;
              }
            }
          }, Ab(e, r && n ? 511 : r ? 219 : 365, t);
        }

        function fc(e, t, r) {
          return (e = R[e]) ? (e.sender(G.subarray(t, t + r)), r) : -1;
        }

        function gc(e, t, r) {
          var n = R[e];
          if (!n) return M(N.$), -1;
          if (n && "socket" in n) return fc(e, t, r);

          try {
            return Ib(n, A, t, r);
          } catch (e) {
            return Zb(e), -1;
          }
        }

        function hc(e, t, r, n) {
          return 0 == (r *= t) ? 0 : -1 == (e = gc(n, e, r)) ? ((t = R[n]) && (t.error = l), 0) : Math.floor(e / t);
        }

        function jc(e) {
          return 0 > e || 0 === e && -1 / 0 == 1 / e;
        }

        function kc(e, t) {
          function r(e) {
            var r;
            return "double" === e ? r = Ja[t + a >> 3] : "i64" == e ? (r = [B[t + a >> 2], B[t + (a + 8) >> 2]], a += 8) : (e = "i32", r = B[t + a >> 2]), a += Math.max(Math.max(la(e), ma), 8), r;
          }

          for (var n, i, o = e, a = 0, s = [];;) {
            var f = o;
            if (0 === (n = A[o])) break;

            if (i = A[o + 1 | 0], 37 == n) {
              var c = p,
                  u = p,
                  d = p,
                  h = p;

              e: for (;;) {
                switch (i) {
                  case 43:
                    c = l;
                    break;

                  case 45:
                    u = l;
                    break;

                  case 35:
                    d = l;
                    break;

                  case 48:
                    if (h) break e;
                    h = l;
                    break;

                  default:
                    break e;
                }

                o++, i = A[o + 1 | 0];
              }

              var b = 0;
              if (42 == i) b = r("i32"), o++, i = A[o + 1 | 0];else for (; 48 <= i && 57 >= i;) {
                b = 10 * b + (i - 48), o++, i = A[o + 1 | 0];
              }
              var y,
                  v = p;

              if (46 == i) {
                var g = 0;
                v = l;
                if (o++, 42 == (i = A[o + 1 | 0])) g = r("i32"), o++;else for (; !(48 > (i = A[o + 1 | 0]) || 57 < i);) {
                  g = 10 * g + (i - 48), o++;
                }
                i = A[o + 1 | 0];
              } else g = 6;

              switch (String.fromCharCode(i)) {
                case "h":
                  104 == (i = A[o + 2 | 0]) ? (o++, y = 1) : y = 2;
                  break;

                case "l":
                  108 == (i = A[o + 2 | 0]) ? (o++, y = 8) : y = 4;
                  break;

                case "L":
                case "q":
                case "j":
                  y = 8;
                  break;

                case "z":
                case "t":
                case "I":
                  y = 4;
                  break;

                default:
                  y = m;
              }

              switch (y && o++, i = A[o + 1 | 0], String.fromCharCode(i)) {
                case "d":
                case "i":
                case "u":
                case "o":
                case "x":
                case "X":
                case "p":
                  f = 100 == i || 105 == i;

                  var _,
                      w = n = r("i" + 8 * (y = y || 4));

                  8 == y && (n = 117 == i ? +(n[0] >>> 0) + 4294967296 * +(n[1] >>> 0) : +(n[0] >>> 0) + 4294967296 * +(0 | n[1])), 4 >= y && (n = (f ? eb : db)(n & Math.pow(256, y) - 1, 8 * y));
                  var k = Math.abs(n);
                  f = "";
                  if (100 == i || 105 == i) _ = 8 == y && lc ? lc.stringify(w[0], w[1], m) : eb(n, 8 * y).toString(10);else if (117 == i) _ = 8 == y && lc ? lc.stringify(w[0], w[1], l) : db(n, 8 * y).toString(10), n = Math.abs(n);else if (111 == i) _ = (d ? "0" : "") + k.toString(8);else if (120 == i || 88 == i) {
                    if (f = d && 0 != n ? "0x" : "", 8 == y && lc) {
                      if (w[1]) {
                        for (_ = (w[1] >>> 0).toString(16), d = (w[0] >>> 0).toString(16); 8 > d.length;) {
                          d = "0" + d;
                        }

                        _ += d;
                      } else _ = (w[0] >>> 0).toString(16);
                    } else if (0 > n) {
                      for (n = -n, _ = (k - 1).toString(16), w = [], d = 0; d < _.length; d++) {
                        w.push((15 - parseInt(_[d], 16)).toString(16));
                      }

                      for (_ = w.join(""); _.length < 2 * y;) {
                        _ = "f" + _;
                      }
                    } else _ = k.toString(16);
                    88 == i && (f = f.toUpperCase(), _ = _.toUpperCase());
                  } else 112 == i && (0 === k ? _ = "(nil)" : (f = "0x", _ = k.toString(16)));
                  if (v) for (; _.length < g;) {
                    _ = "0" + _;
                  }

                  for (c && (f = 0 > n ? "-" + f : "+" + f); f.length + _.length < b;) {
                    u ? _ += " " : h ? _ = "0" + _ : f = " " + f;
                  }

                  (_ = f + _).split("").forEach(function (e) {
                    s.push(e.charCodeAt(0));
                  });

                  break;

                case "f":
                case "F":
                case "e":
                case "E":
                case "g":
                case "G":
                  if (n = r("double"), isNaN(n)) _ = "nan", h = p;else if (isFinite(n)) {
                    if (v = p, y = Math.min(g, 20), 103 != i && 71 != i || (v = l, (g = g || 1) > (y = parseInt(n.toExponential(y).split("e")[1], 10)) && -4 <= y ? (i = (103 == i ? "f" : "F").charCodeAt(0), g -= y + 1) : (i = (103 == i ? "e" : "E").charCodeAt(0), g--), y = Math.min(g, 20)), 101 == i || 69 == i ? (_ = n.toExponential(y), /[eE][-+]\d$/.test(_) && (_ = _.slice(0, -1) + "0" + _.slice(-1))) : 102 != i && 70 != i || (_ = n.toFixed(y), 0 === n && jc(n) && (_ = "-" + _)), f = _.split("e"), v && !d) for (; 1 < f[0].length && -1 != f[0].indexOf(".") && ("0" == f[0].slice(-1) || "." == f[0].slice(-1));) {
                      f[0] = f[0].slice(0, -1);
                    } else for (d && -1 == _.indexOf(".") && (f[0] += "."); g > y++;) {
                      f[0] += "0";
                    }
                    _ = f[0] + (1 < f.length ? "e" + f[1] : ""), 69 == i && (_ = _.toUpperCase()), c && 0 <= n && (_ = "+" + _);
                  } else _ = (0 > n ? "-" : "") + "inf", h = p;

                  for (; _.length < b;) {
                    _ = u ? _ + " " : !h || "-" != _[0] && "+" != _[0] ? (h ? "0" : " ") + _ : _[0] + "0" + _.slice(1);
                  }

                  97 > i && (_ = _.toUpperCase()), _.split("").forEach(function (e) {
                    s.push(e.charCodeAt(0));
                  });
                  break;

                case "s":
                  if (h = (c = r("i8*")) ? ic(c) : 6, v && (h = Math.min(h, g)), !u) for (; h < b--;) {
                    s.push(32);
                  }
                  if (c) for (d = 0; d < h; d++) {
                    s.push(G[0 | c++]);
                  } else s = s.concat(J("(null)".substr(0, h), l));
                  if (u) for (; h < b--;) {
                    s.push(32);
                  }
                  break;

                case "c":
                  for (u && s.push(r("i8")); 0 < --b;) {
                    s.push(32);
                  }

                  u || s.push(r("i8"));
                  break;

                case "n":
                  u = r("i32*"), B[u >> 2] = s.length;
                  break;

                case "%":
                  s.push(n);
                  break;

                default:
                  for (d = f; d < o + 2; d++) {
                    s.push(A[d]);
                  }

              }

              o += 2;
            } else s.push(n), o += 1;
          }

          return s;
        }

        function mc(e, t, r) {
          return r = kc(t, r), t = ja(), e = hc(F(r, "i8", La), 1, r.length, e), ka(t), e;
        }

        function nc(e) {
          nc.ia || (z = z + 4095 >> 12 << 12, nc.ia = l, w(ua), nc.hb = ua, ua = function ua() {
            wa("cannot dynamically allocate, sbrk now has control");
          });
          var t = z;
          return 0 != e && nc.hb(e), t;
        }

        function U() {
          return B[U.m >> 2];
        }

        function oc() {
          return !!oc.ta;
        }

        function pc(e) {
          var t = p;

          try {
            e == __ZTIi && (t = l);
          } catch (e) {}

          try {
            e == __ZTIj && (t = l);
          } catch (e) {}

          try {
            e == __ZTIl && (t = l);
          } catch (e) {}

          try {
            e == __ZTIm && (t = l);
          } catch (e) {}

          try {
            e == __ZTIx && (t = l);
          } catch (e) {}

          try {
            e == __ZTIy && (t = l);
          } catch (e) {}

          try {
            e == __ZTIf && (t = l);
          } catch (e) {}

          try {
            e == __ZTId && (t = l);
          } catch (e) {}

          try {
            e == __ZTIe && (t = l);
          } catch (e) {}

          try {
            e == __ZTIc && (t = l);
          } catch (e) {}

          try {
            e == __ZTIa && (t = l);
          } catch (e) {}

          try {
            e == __ZTIh && (t = l);
          } catch (e) {}

          try {
            e == __ZTIs && (t = l);
          } catch (e) {}

          try {
            e == __ZTIt && (t = l);
          } catch (e) {}

          return t;
        }

        function qc(e, t, r) {
          if (0 == r) return p;
          if (0 == t || t == e) return l;

          switch (pc(t) ? t : B[B[t >> 2] - 8 >> 2]) {
            case 0:
              return 0 == B[B[e >> 2] - 8 >> 2] ? qc(B[e + 8 >> 2], B[t + 8 >> 2], r) : p;

            case 1:
              return p;

            case 2:
              return qc(e, B[t + 8 >> 2], r);

            default:
              return p;
          }
        }

        function rc(e, t, r) {
          if (!rc.sb) {
            try {
              B[__ZTVN10__cxxabiv119__pointer_type_infoE >> 2] = 0;
            } catch (e) {}

            try {
              B[pb >> 2] = 1;
            } catch (e) {}

            try {
              B[ob >> 2] = 2;
            } catch (e) {}

            rc.sb = l;
          }

          B[U.m >> 2] = e, B[U.m + 4 >> 2] = t, B[U.m + 8 >> 2] = r, "uncaught_exception" in oc ? oc.ta++ : oc.ta = 1, g(e + " - Exception catching is disabled, this exception cannot be caught. Compile with -s DISABLE_EXCEPTION_CATCHING=0 or DISABLE_EXCEPTION_CATCHING=2 to catch.");
        }

        function sc(e) {
          try {
            return tc(e);
          } catch (e) {}
        }

        function uc() {
          if (uc.Bb) uc.Bb = p;else {
            V.setThrew(0), B[U.m + 4 >> 2] = 0;
            var e = B[U.m >> 2],
                t = B[U.m + 8 >> 2];
            t && (na("vi", t, [e]), B[U.m + 8 >> 2] = 0), e && (sc(e), B[U.m >> 2] = 0);
          }
        }

        s._strlen = ic;
        var vc = F(1, "i32*", E);

        function wc(e) {
          var t, r;
          wc.ia ? (r = B[vc >> 2], t = B[r >> 2]) : (wc.ia = l, W.USER = "root", W.PATH = "/", W.PWD = "/", W.HOME = "/home/emscripten", W.LANG = "en_US.UTF-8", W._ = "./this.program", t = F(1024, "i8", E), r = F(256, "i8*", E), B[r >> 2] = t, B[vc >> 2] = r);
          var n,
              i = [],
              o = 0;

          for (n in e) {
            if ("string" == typeof e[n]) {
              var a = n + "=" + e[n];
              i.push(a), o += a.length;
            }
          }

          for (1024 < o && g(Error("Environment size exceeded TOTAL_ENV_SIZE!")), e = 0; e < i.length; e++) {
            for (a = i[e], o = 0; o < a.length; o++) {
              A[t + o | 0] = a.charCodeAt(o);
            }

            A[t + o | 0] = 0, B[r + 4 * e >> 2] = t, t += a.length + 1;
          }

          B[r + 4 * i.length >> 2] = 0;
        }

        var W = {};

        function xc(e) {
          return 0 === e ? 0 : (e = Fa(e), W.hasOwnProperty(e) ? (xc.J && tc(xc.J), xc.J = F(J(W[e]), "i8", Ka), xc.J) : 0);
        }

        function yc(e, t, r) {
          if (e in ub) {
            if (ub[e].length > r - 1) return M(N.ab);

            for (e = ub[e], r = 0; r < e.length; r++) {
              A[t + r | 0] = e.charCodeAt(r);
            }

            return A[t + r | 0] = 0;
          }

          return M(N.A);
        }

        function zc(e) {
          return zc.buffer || (zc.buffer = Oa(256)), yc(e, zc.buffer, 256), zc.buffer;
        }

        function Ac(e) {
          s.exit(e);
        }

        function Bc(e, t) {
          var r = db(255 & e);
          return A[0 | Bc.J] = r, -1 == gc(t, Bc.J, 1) ? ((r = R[t]) && (r.error = l), -1) : r;
        }

        var Cc = p,
            Dc = p,
            Ec = p,
            Fc = p,
            Gc = k,
            Hc = k;

        function Ic(e) {
          return {
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            png: "image/png",
            bmp: "image/bmp",
            ogg: "audio/ogg",
            wav: "audio/wav",
            mp3: "audio/mpeg"
          }[e.substr(e.lastIndexOf(".") + 1)];
        }

        var Jc = [];

        function Kc() {
          var e = s.canvas;
          Jc.forEach(function (t) {
            t(e.width, e.height);
          });
        }

        function Lc() {
          var e = s.canvas;
          this.Ib = e.width, this.Hb = e.height, e.width = screen.width, e.height = screen.height, "undefined" != typeof SDL && (e = Qa[SDL.screen + 0 * ma >> 2], B[SDL.screen + 0 * ma >> 2] = 8388608 | e), Kc();
        }

        function Mc() {
          var e = s.canvas;
          e.width = this.Ib, e.height = this.Hb, "undefined" != typeof SDL && (e = Qa[SDL.screen + 0 * ma >> 2], B[SDL.screen + 0 * ma >> 2] = -8388609 & e), Kc();
        }

        var Nc,
            Oc,
            Pc,
            Qc,
            rb = ra(4);
        B[rb >> 2] = 0;
        var Vb = Qb(m, "/", 16895, 0),
            Rc = T,
            Sc = {
          type: Rc,
          se: {},
          Ua: "/",
          root: m
        },
            Tc;
        Tc = O("/", {
          N: p
        });
        var Uc = Rc.z(Sc);
        Uc.z = Sc, Sc.root = Uc, Tc && (Tc.d.z = Sc, Tc.d.ub = l, Vb = Sc.root), zb("/tmp", 511), zb("/dev", 511), Nb[259] = {
          e: {
            Q: function Q() {
              return 0;
            },
            write: function write() {
              return 0;
            }
          }
        }, Ab("/dev/null", 438, 259), Mb(1280, {
          Na: function Na(e) {
            if (!e.input.length) {
              var t = m;

              if (ca) {
                if (process.Eb.be) return;
                t = process.Eb.Q();
              } else "undefined" != typeof window && "function" == typeof window.prompt ? (t = window.prompt("Input: ")) !== m && (t += "\n") : "function" == typeof readline && (t = readline()) !== m && (t += "\n");

              if (!t) return m;
              e.input = J(t, l);
            }

            return e.input.shift();
          },
          W: function W(e, t) {
            t === m || 10 === t ? (s.print(e.H.join("")), e.H = []) : e.H.push(Pb.oa(t));
          }
        }), Mb(1536, {
          W: function W(e, t) {
            t === m || 10 === t ? (s.printErr(e.H.join("")), e.H = []) : e.H.push(Pb.oa(t));
          }
        }), Ab("/dev/tty", 438, 1280), Ab("/dev/tty1", 438, 1536), zb("/dev/shm", 511), zb("/dev/shm/tmp", 511), Xa.unshift({
          V: function V() {
            if (!s.noFSInit && !bc) {
              w(!bc, "FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)"), bc = l, s.stdin = s.stdin, s.stdout = s.stdout, s.stderr = s.stderr, s.stdin ? ec("/dev", "stdin", s.stdin) : Bb("/dev/tty", "/dev/stdin"), s.stdout ? ec("/dev", "stdout", m, s.stdout) : Bb("/dev/tty", "/dev/stdout"), s.stderr ? ec("/dev", "stderr", m, s.stderr) : Bb("/dev/tty1", "/dev/stderr");
              var e = Db("/dev/stdin", "r");
              B[Tb >> 2] = e.s, w(1 === e.s, "invalid handle for stdin (" + e.s + ")"), e = Db("/dev/stdout", "w"), B[Ub >> 2] = e.s, w(2 === e.s, "invalid handle for stdout (" + e.s + ")"), e = Db("/dev/stderr", "w"), B[nb >> 2] = e.s, w(3 === e.s, "invalid handle for stderr (" + e.s + ")");
            }
          }
        }), Ya.push({
          V: function V() {
            Yb = p;
          }
        }), Za.push({
          V: function V() {
            bc = p;

            for (var e = 0; e < R.length; e++) {
              var t = R[e];
              t && Hb(t);
            }
          }
        }), s.FS_createFolder = function (e, t, r, n) {
          return zb(e = S("string" == typeof e ? e : ac(e), t), cc(r, n));
        }, s.FS_createPath = function (e, t) {
          e = "string" == typeof e ? e : ac(e);

          for (var r = t.split("/").reverse(); r.length;) {
            var n = r.pop();

            if (n) {
              var i = S(e, n);

              try {
                zb(i, 511);
              } catch (e) {}

              e = i;
            }
          }

          return i;
        }, s.FS_createDataFile = dc, s.FS_createPreloadedFile = function (e, t, r, n, i, o, a, f) {
          function c() {
            Ec = document.pointerLockElement === d || document.mozPointerLockElement === d || document.webkitPointerLockElement === d;
          }

          function u(r) {
            function c(r) {
              f || dc(e, t, r, n, i), o && o(), jb("cp " + h);
            }

            var u = p;
            s.preloadPlugins.forEach(function (e) {
              !u && e.canHandle(h) && (e.handle(r, h, c, function () {
                a && a(), jb("cp " + h);
              }), u = l);
            }), u || c(r);
          }

          if (s.preloadPlugins || (s.preloadPlugins = []), !Nc && !ea) {
            Nc = l;

            try {
              new Blob(), Oc = l;
            } catch (e) {
              Oc = p, console.log("warning: no blob constructor, cannot create blobs with mimetypes");
            }

            Pc = "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : "undefined" != typeof WebKitBlobBuilder ? WebKitBlobBuilder : Oc ? m : console.log("warning: no BlobBuilder"), Qc = "undefined" != typeof window ? window.URL ? window.URL : window.webkitURL : console.log("warning: cannot create object URLs"), s.preloadPlugins.push({
              canHandle: function canHandle(e) {
                return !s.re && /\.(jpg|jpeg|png|bmp)$/i.test(e);
              },
              handle: function handle(e, t, r, n) {
                var i = m;
                if (Oc) try {
                  (i = new Blob([e], {
                    type: Ic(t)
                  })).size !== e.length && (i = new Blob([new Uint8Array(e).buffer], {
                    type: Ic(t)
                  }));
                } catch (e) {
                  var o = "Blob constructor present but fails: " + e + "; falling back to blob builder";
                  oa || (oa = {}), oa[o] || (oa[o] = 1, s.P(o));
                }
                i || ((i = new Pc()).append(new Uint8Array(e).buffer), i = i.getBlob());
                var a = Qc.createObjectURL(i),
                    f = new Image();
                f.onload = function () {
                  w(f.complete, "Image " + t + " could not be decoded");
                  var n = document.createElement("canvas");
                  n.width = f.width, n.height = f.height, n.getContext("2d").drawImage(f, 0, 0), s.preloadedImages[t] = n, Qc.revokeObjectURL(a), r && r(e);
                }, f.onerror = function () {
                  console.log("Image " + a + " could not be decoded"), n && n();
                }, f.src = a;
              }
            }), s.preloadPlugins.push({
              canHandle: function canHandle(e) {
                return !s.qe && e.substr(-4) in {
                  ".ogg": 1,
                  ".wav": 1,
                  ".mp3": 1
                };
              },
              handle: function handle(e, t, r, n) {
                function i(n) {
                  a || (a = l, s.preloadedAudios[t] = n, r && r(e));
                }

                function o() {
                  a || (a = l, s.preloadedAudios[t] = new Audio(), n && n());
                }

                var a = p;
                if (!Oc) return o();

                try {
                  var f = new Blob([e], {
                    type: Ic(t)
                  });
                } catch (e) {
                  return o();
                }

                f = Qc.createObjectURL(f);
                var c = new Audio();
                c.addEventListener("canplaythrough", function () {
                  i(c);
                }, p), c.onerror = function () {
                  if (!a) {
                    console.log("warning: browser could not fully decode audio " + t + ", trying slower base64 approach");

                    for (var r = "", n = 0, o = 0, s = 0; s < e.length; s++) {
                      for (n = n << 8 | e[s], o += 8; 6 <= o;) {
                        var f = n >> o - 6 & 63;
                        o = o - 6, r = r + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[f];
                      }
                    }

                    2 == o ? (r += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(3 & n) << 4], r += "==") : 4 == o && (r += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(15 & n) << 2], r += "="), c.src = "data:audio/x-" + t.substr(-3) + ";base64," + r, i(c);
                  }
                }, c.src = f, setTimeout(function () {
                  za || i(c);
                }, 1e4);
              }
            });
            var d = s.canvas;
            d.qa = d.requestPointerLock || d.mozRequestPointerLock || d.webkitRequestPointerLock, d.La = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock || aa(), d.La = d.La.bind(document), document.addEventListener("pointerlockchange", c, p), document.addEventListener("mozpointerlockchange", c, p), document.addEventListener("webkitpointerlockchange", c, p), s.elementPointerLock && d.addEventListener("click", function (e) {
              !Ec && d.qa && (d.qa(), e.preventDefault());
            }, p);
          }

          var h,
              b = S.apply(m, [e, t]);

          if ("/" == b[0] && (b = b.substr(1)), ib("cp " + (h = b)), "string" == typeof r) {
            var y = a,
                v = function v() {
              y ? y() : g('Loading data file "' + r + '" failed.');
            },
                _ = new XMLHttpRequest();

            _.open("GET", r, l), _.responseType = "arraybuffer", _.onload = function () {
              if (200 == _.status || 0 == _.status && _.response) {
                var e = _.response;
                w(e, 'Loading data file "' + r + '" failed (no arrayBuffer).'), u(e = new Uint8Array(e)), jb("al " + r);
              } else v();
            }, _.onerror = v, _.send(m), ib("al " + r);
          } else u(r);
        }, s.FS_createLazyFile = function (e, t, r, n, i) {
          var o, a;
          "undefined" != typeof XMLHttpRequest ? (ea || g("Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc"), (o = function o() {
            this.ma = p, this.T = [];
          }).prototype.get = function (e) {
            if (!(e > this.length - 1 || 0 > e)) {
              var t = e % this.S;
              return this.pb(Math.floor(e / this.S))[t];
            }
          }, o.prototype.Cb = function (e) {
            this.pb = e;
          }, o.prototype.Fa = function () {
            var e = new XMLHttpRequest();
            e.open("HEAD", r, p), e.send(m), 200 <= e.status && 300 > e.status || 304 === e.status || g(Error("Couldn't load " + r + ". Status: " + e.status));
            var t,
                n = Number(e.getResponseHeader("Content-length")),
                i = 1048576;
            (t = e.getResponseHeader("Accept-Ranges")) && "bytes" === t || (i = n);
            var o = this;
            o.Cb(function (e) {
              var t = e * i,
                  a = (e + 1) * i - 1;
              a = Math.min(a, n - 1);

              if (void 0 === o.T[e]) {
                var s = o.T;
                t > a && g(Error("invalid range (" + t + ", " + a + ") or no bytes requested!")), a > n - 1 && g(Error("only " + n + " bytes available! programmer error!"));
                var f = new XMLHttpRequest();
                f.open("GET", r, p), n !== i && f.setRequestHeader("Range", "bytes=" + t + "-" + a), "undefined" != typeof Uint8Array && (f.responseType = "arraybuffer"), f.overrideMimeType && f.overrideMimeType("text/plain; charset=x-user-defined"), f.send(m), 200 <= f.status && 300 > f.status || 304 === f.status || g(Error("Couldn't load " + r + ". Status: " + f.status)), t = f.response !== k ? new Uint8Array(f.response || []) : J(f.responseText || "", l), s[e] = t;
              }

              return void 0 === o.T[e] && g(Error("doXHR failed!")), o.T[e];
            }), this.gb = n, this.fb = i, this.ma = l;
          }, o = new o(), Object.defineProperty(o, "length", {
            get: function get() {
              return this.ma || this.Fa(), this.gb;
            }
          }), Object.defineProperty(o, "chunkSize", {
            get: function get() {
              return this.ma || this.Fa(), this.fb;
            }
          }), a = k) : (a = r, o = k);
          var f;
          e = S("string" == typeof e ? e : ac(e), t);
          f = yb(e, cc(n, i)), o ? f.g = o : a && (f.g = m, f.url = a);
          var c = {};
          return Object.keys(f.e).forEach(function (e) {
            var t = f.e[e];

            c[e] = function () {
              var e;
              if (f.ke || f.le || f.link || f.g) e = l;else {
                if (e = l, "undefined" != typeof XMLHttpRequest && g(Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.")), s.read) try {
                  f.g = J(s.read(f.url), l);
                } catch (t) {
                  e = p;
                } else g(Error("Cannot load without read() or XMLHttpRequest."));
                e || M(N.I);
              }
              return e || g(new _Q(N.I)), t.apply(m, arguments);
            };
          }), c.Q = function (e, t, r, n, i) {
            if (e = e.d.g, n = Math.min(e.length - i, n), e.slice) for (var o = 0; o < n; o++) {
              t[r + o] = e[i + o];
            } else for (o = 0; o < n; o++) {
              t[r + o] = e.get(i + o);
            }
            return n;
          }, f.e = c, f;
        }, s.FS_createLink = function (e, t, r) {
          return Bb(r, e = S("string" == typeof e ? e : ac(e), t));
        }, s.FS_createDevice = ec, U.m = F(12, "void*", E), wc(W), Bc.J = F([0], "i8", E), s.requestFullScreen = function (e, t) {
          function r() {
            Dc = p, (document.webkitFullScreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.mozFullscreenElement || document.fullScreenElement || document.fullscreenElement) === n ? (n.Ga = document.cancelFullScreen || document.mozCancelFullScreen || document.webkitCancelFullScreen, n.Ga = n.Ga.bind(document), Gc && n.qa(), Dc = l, Hc && Lc()) : Hc && Mc(), s.onFullScreen && s.onFullScreen(Dc);
          }

          void 0 === (Gc = e) && (Gc = l), void 0 === (Hc = t) && (Hc = p);
          var n = s.canvas;
          Fc || (Fc = l, document.addEventListener("fullscreenchange", r, p), document.addEventListener("mozfullscreenchange", r, p), document.addEventListener("webkitfullscreenchange", r, p)), n.Ab = n.requestFullScreen || n.mozRequestFullScreen || (n.webkitRequestFullScreen ? function () {
            n.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
          } : m), n.Ab();
        }, s.requestAnimationFrame = function (e) {
          window.requestAnimationFrame || (window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || window.setTimeout), window.requestAnimationFrame(e);
        }, s.pauseMainLoop = aa(), s.resumeMainLoop = function () {
          Cc && (Cc = p, m());
        }, s.getUserMedia = function () {
          window.Ma || (window.Ma = navigator.getUserMedia || navigator.mozGetUserMedia), window.Ma(k);
        }, Sa = u = xa(sa), Ta = Sa + 5242880, Ua = z = xa(Ta), w(Ua < va);

        var Vc = F([8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "i8", 3),
            Wc = F([8, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 6, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 7, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 6, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0], "i8", 3),
            Xc = Math.min,
            V = function (e, t, r) {
          "use asm";

          var n = new e.Int8Array(r);
          var i = new e.Int16Array(r);
          var o = new e.Int32Array(r);
          var a = new e.Uint8Array(r);
          var s = new e.Uint16Array(r);
          var f = new e.Uint32Array(r);
          var c = new e.Float32Array(r);
          var u = new e.Float64Array(r);
          var d = t.STACKTOP | 0;
          var h = t.STACK_MAX | 0;
          var l = t.tempDoublePtr | 0;
          var p = t.ABORT | 0;
          var b = t.cttz_i8 | 0;
          var m = t.ctlz_i8 | 0;
          var y = t._stderr | 0;
          var v = t.__ZTVN10__cxxabiv120__si_class_type_infoE | 0;
          var g = t.__ZTVN10__cxxabiv117__class_type_infoE | 0;

          var _ = t.___progname | 0;

          var w = +t.NaN;
          var k = +t.Infinity;
          var E = 0;
          var A = 0;
          var S = 0;
          var M = 0;
          var x = 0,
              I = 0,
              j = 0,
              B = 0,
              R = 0.0,
              P = 0,
              T = 0,
              L = 0,
              C = 0.0;
          var O = 0;
          var N = 0;
          var U = 0;
          var D = 0;
          var q = 0;
          var z = 0;
          var F = 0;
          var Y = 0;
          var K = 0;
          var V = 0;
          var H = e.Math.floor;
          var W = e.Math.abs;
          var G = e.Math.sqrt;
          var X = e.Math.pow;
          var Z = e.Math.cos;
          var J = e.Math.sin;
          var $ = e.Math.tan;
          var Q = e.Math.acos;
          var ee = e.Math.asin;
          var te = e.Math.atan;
          var re = e.Math.atan2;
          var ne = e.Math.exp;
          var ie = e.Math.log;
          var oe = e.Math.ceil;
          var ae = e.Math.imul;
          var se = t.abort;
          var fe = t.assert;
          var ce = t.asmPrintInt;
          var ue = t.asmPrintFloat;
          var de = t.min;
          var he = t.invoke_vi;
          var le = t.invoke_vii;
          var pe = t.invoke_ii;
          var be = t.invoke_viii;
          var me = t.invoke_v;
          var ye = t.invoke_iii;
          var ve = t._strncmp;
          var ge = t._llvm_va_end;
          var _e = t._sysconf;
          var we = t.___cxa_throw;
          var ke = t._strerror;
          var Ee = t._abort;
          var Ae = t._fprintf;
          var Se = t._llvm_eh_exception;
          var Me = t.___cxa_free_exception;
          var xe = t._fflush;
          var Ie = t.___buildEnvironment;
          var je = t.__reallyNegative;
          var Be = t._strchr;
          var Re = t._fputc;
          var Pe = t.___setErrNo;
          var Te = t._fwrite;
          var Le = t._send;
          var Ce = t._write;
          var Oe = t._exit;
          var Ne = t.___cxa_find_matching_catch;
          var Ue = t.___cxa_allocate_exception;
          var De = t._isspace;
          var qe = t.__formatString;
          var ze = t.___resumeException;
          var Fe = t._llvm_uadd_with_overflow_i32;
          var Ye = t.___cxa_does_inherit;
          var Ke = t._getenv;
          var Ve = t._vfprintf;
          var He = t.___cxa_begin_catch;
          var We = t.__ZSt18uncaught_exceptionv;
          var Ge = t._pwrite;
          var Xe = t.___cxa_call_unexpected;
          var Ze = t._sbrk;
          var Je = t._strerror_r;
          var $e = t.___errno_location;
          var Qe = t.___gxx_personality_v0;
          var et = t.___cxa_is_number_type;
          var tt = t._time;
          var rt = t.__exit;
          var nt = t.___cxa_end_catch;

          function it(e) {
            e = e | 0;
            var t = 0;
            t = d;
            d = d + e | 0;
            d = d + 7 >> 3 << 3;
            return t | 0;
          }

          function ot() {
            return d | 0;
          }

          function at(e) {
            e = e | 0;
            d = e;
          }

          function st(e, t) {
            e = e | 0;
            t = t | 0;

            if ((E | 0) == 0) {
              E = e;
              A = t;
            }
          }

          function ft(e) {
            e = e | 0;
            n[l] = n[e];
            n[l + 1 | 0] = n[e + 1 | 0];
            n[l + 2 | 0] = n[e + 2 | 0];
            n[l + 3 | 0] = n[e + 3 | 0];
          }

          function ct(e) {
            e = e | 0;
            n[l] = n[e];
            n[l + 1 | 0] = n[e + 1 | 0];
            n[l + 2 | 0] = n[e + 2 | 0];
            n[l + 3 | 0] = n[e + 3 | 0];
            n[l + 4 | 0] = n[e + 4 | 0];
            n[l + 5 | 0] = n[e + 5 | 0];
            n[l + 6 | 0] = n[e + 6 | 0];
            n[l + 7 | 0] = n[e + 7 | 0];
          }

          function ut(e) {
            e = e | 0;
            O = e;
          }

          function dt(e) {
            e = e | 0;
            N = e;
          }

          function ht(e) {
            e = e | 0;
            U = e;
          }

          function lt(e) {
            e = e | 0;
            D = e;
          }

          function pt(e) {
            e = e | 0;
            q = e;
          }

          function bt(e) {
            e = e | 0;
            z = e;
          }

          function mt(e) {
            e = e | 0;
            F = e;
          }

          function yt(e) {
            e = e | 0;
            Y = e;
          }

          function vt(e) {
            e = e | 0;
            K = e;
          }

          function gt(e) {
            e = e | 0;
            V = e;
          }

          function _t() {
            o[170] = g + 8;
            o[172] = v + 8;
            o[176] = v + 8;
          }

          function wt(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var i = 0;

            if ((r | 0) == 0) {
              return;
            } else {
              i = 0;
            }

            do {
              n[e + i | 0] = n[t + i | 0] | 0;
              i = i + 1 | 0;
            } while (i >>> 0 < r >>> 0);

            return;
          }

          function kt(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var i = 0,
                o = 0;

            if ((r | 0) == 0) {
              return;
            } else {
              i = 0;
            }

            do {
              o = e + i | 0;
              n[o] = n[o] ^ n[t + i | 0];
              i = i + 1 | 0;
            } while (i >>> 0 < r >>> 0);

            return;
          }

          function Et(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0,
                i = 0;
            t = a[e + 1 | 0] | 0;
            r = a[e + 2 | 0] | 0;
            n = a[e + 3 | 0] | 0;
            i = rn(t << 8 | 0 >>> 24 | (a[e] | 0) | (r << 16 | 0 >>> 16) | (n << 24 | 0 >>> 8) | (0 << 8 | 0 >>> 24), 0 << 8 | t >>> 24 | (0 << 16 | r >>> 16) | (0 << 24 | n >>> 8) | (a[e + 4 | 0] | 0) | ((a[e + 5 | 0] | 0) << 8 | 0 >>> 24), 0 << 16 | 0 >>> 16, (a[e + 6 | 0] | 0) << 16 | 0 >>> 16) | 0;
            n = rn(i, O, 0 << 24 | 0 >>> 8, (a[e + 7 | 0] | 0) << 24 | 0 >>> 8) | 0;
            return (O = O, n) | 0;
          }

          function At(e) {
            e = e | 0;
            return (a[e + 1 | 0] | 0) << 8 | (a[e] | 0) | (a[e + 2 | 0] | 0) << 16 | (a[e + 3 | 0] | 0) << 24 | 0;
          }

          function St(e, t) {
            e = e | 0;
            t = t | 0;
            n[e] = t & 255;
            n[e + 1 | 0] = t >>> 8 & 255;
            n[e + 2 | 0] = t >>> 16 & 255;
            n[e + 3 | 0] = t >>> 24 & 255;
            return;
          }

          function Mt(e) {
            e = e | 0;
            o[e + 36 >> 2] = 0;
            o[e + 32 >> 2] = 0;
            o[e >> 2] = 1779033703;
            o[e + 4 >> 2] = -1150833019;
            o[e + 8 >> 2] = 1013904242;
            o[e + 12 >> 2] = -1521486534;
            o[e + 16 >> 2] = 1359893119;
            o[e + 20 >> 2] = -1694144372;
            o[e + 24 >> 2] = 528734635;
            o[e + 28 >> 2] = 1541459225;
            return;
          }

          function xt(e, t, r, n, i, a, s, f, c, u) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            i = i | 0;
            a = a | 0;
            s = s | 0;
            f = f | 0;
            c = c | 0;
            u = u | 0;
            var d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0;
            d = ln(f, 0, s, 0) | 0;
            h = O;
            l = 0;

            if (h >>> 0 > l >>> 0 | h >>> 0 == l >>> 0 & d >>> 0 > 1073741823 >>> 0) {
              o[($e() | 0) >> 2] = 27;
              p = -1;
              return p | 0;
            }

            d = rn(i, a, -1, -1) | 0;

            if ((d & i | 0) != 0 | (O & a | 0) != 0 | (i | 0) == 0 & (a | 0) == 0) {
              o[($e() | 0) >> 2] = 22;
              p = -1;
              return p | 0;
            }

            do {
              if (!((33554431 / (f >>> 0) | 0) >>> 0 < s >>> 0 | s >>> 0 > 16777215)) {
                d = 0;

                if (d >>> 0 < a >>> 0 | d >>> 0 == a >>> 0 & (33554431 / (s >>> 0) | 0) >>> 0 < i >>> 0) {
                  break;
                }

                d = s << 7;
                l = Kt(ae(d, f) | 0) | 0;

                if ((l | 0) == 0) {
                  p = -1;
                  return p | 0;
                }

                h = Kt(s << 8) | 0;

                do {
                  if ((h | 0) != 0) {
                    b = ln(d, 0, i, a) | 0;
                    m = Kt(b) | 0;

                    if ((m | 0) == 0) {
                      Vt(h);
                      break;
                    }

                    b = ae(f << 7, s) | 0;
                    Ft(e, t, r, n, 1, 0, l, b);

                    if ((f | 0) != 0) {
                      y = s << 7;
                      v = 0;

                      do {
                        It(l + (ae(y, v) | 0) | 0, s, i, a, m, h);
                        v = v + 1 | 0;
                      } while (v >>> 0 < f >>> 0);
                    }

                    Ft(e, t, l, b, 1, 0, c, u);
                    Vt(m);
                    Vt(h);
                    Vt(l);
                    p = 0;
                    return p | 0;
                  }
                } while (0);

                Vt(l);
                p = -1;
                return p | 0;
              }
            } while (0);

            o[($e() | 0) >> 2] = 12;
            p = -1;
            return p | 0;
          }

          function It(e, t, r, n, i, o) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            i = i | 0;
            o = o | 0;
            var a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0;
            a = t << 7;
            s = o + a | 0;
            wt(o, e, a);

            if ((r | 0) == 0 & (n | 0) == 0) {
              wt(e, o, a);
              return;
            }

            f = a;
            c = 0;
            u = 0;
            d = 0;

            do {
              h = ln(d, u, f, c) | 0;
              wt(i + h | 0, o, a);
              jt(o, s, t);
              d = rn(d, u, 1, 0) | 0;
              u = O;
            } while (u >>> 0 < n >>> 0 | u >>> 0 == n >>> 0 & d >>> 0 < r >>> 0);

            if ((r | 0) == 0 & (n | 0) == 0) {
              wt(e, o, a);
              return;
            }

            d = rn(r, n, -1, -1) | 0;
            u = O;
            c = a;
            f = 0;
            h = 0;
            l = 0;

            do {
              p = Bt(o, t) | 0;
              b = ln(p & d, O & u, c, f) | 0;
              kt(o, i + b | 0, a);
              jt(o, s, t);
              l = rn(l, h, 1, 0) | 0;
              h = O;
            } while (h >>> 0 < n >>> 0 | h >>> 0 == n >>> 0 & l >>> 0 < r >>> 0);

            wt(e, o, a);
            return;
          }

          function jt(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0,
                o = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0;
            n = d;
            d = d + 64 | 0;
            i = n | 0;
            o = r << 1;
            wt(i, e + ((r << 7) - 64) | 0, 64);

            if ((o | 0) != 0) {
              a = 0;

              do {
                s = a << 6;
                kt(i, e + s | 0, 64);
                Rt(i);
                wt(t + s | 0, i, 64);
                a = a + 1 | 0;
              } while (a >>> 0 < o >>> 0);
            }

            if ((r | 0) == 0) {
              d = n;
              return;
            } else {
              f = 0;
            }

            do {
              wt(e + (f << 6) | 0, t + (f << 7) | 0, 64);
              f = f + 1 | 0;
            } while (f >>> 0 < r >>> 0);

            if ((r | 0) == 0) {
              d = n;
              return;
            } else {
              c = 0;
            }

            do {
              wt(e + (c + r << 6) | 0, t + (c << 7 | 64) | 0, 64);
              c = c + 1 | 0;
            } while (c >>> 0 < r >>> 0);

            d = n;
            return;
          }

          function Bt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0;
            r = Et(e + ((t << 7) - 64) | 0) | 0;
            return (O = O, r) | 0;
          }

          function Rt(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0,
                x = 0,
                I = 0,
                j = 0,
                B = 0,
                R = 0,
                P = 0,
                T = 0,
                L = 0,
                C = 0,
                O = 0,
                N = 0,
                U = 0,
                D = 0,
                q = 0,
                z = 0,
                F = 0,
                Y = 0,
                K = 0,
                V = 0,
                H = 0,
                W = 0,
                G = 0,
                X = 0,
                Z = 0,
                J = 0,
                $ = 0,
                Q = 0,
                ee = 0,
                te = 0;
            t = d;
            d = d + 128 | 0;
            r = t | 0;
            n = t + 64 | 0;
            i = 0;

            do {
              o[r + (i << 2) >> 2] = At(e + (i << 2) | 0) | 0;
              i = i + 1 | 0;
            } while (i >>> 0 < 16);

            i = r;
            a = n;
            Qr(a | 0, i | 0, 64) | 0;
            i = n | 0;
            a = n + 48 | 0;
            s = n + 16 | 0;
            f = n + 32 | 0;
            c = n + 20 | 0;
            u = n + 4 | 0;
            h = n + 36 | 0;
            l = n + 52 | 0;
            p = n + 40 | 0;
            b = n + 24 | 0;
            m = n + 56 | 0;
            y = n + 8 | 0;
            v = n + 60 | 0;
            g = n + 44 | 0;
            _ = n + 12 | 0;
            w = n + 28 | 0;
            k = 0;
            E = o[i >> 2] | 0;
            A = o[a >> 2] | 0;
            S = o[s >> 2] | 0;
            M = o[f >> 2] | 0;
            x = o[c >> 2] | 0;
            I = o[u >> 2] | 0;
            j = o[h >> 2] | 0;
            B = o[l >> 2] | 0;
            R = o[p >> 2] | 0;
            P = o[b >> 2] | 0;
            T = o[m >> 2] | 0;
            L = o[y >> 2] | 0;
            C = o[v >> 2] | 0;
            O = o[g >> 2] | 0;
            N = o[_ >> 2] | 0;
            U = o[w >> 2] | 0;

            do {
              D = A + E | 0;
              q = (D << 7 | D >>> 25) ^ S;
              D = q + E | 0;
              z = (D << 9 | D >>> 23) ^ M;
              D = z + q | 0;
              F = (D << 13 | D >>> 19) ^ A;
              D = F + z | 0;
              Y = (D << 18 | D >>> 14) ^ E;
              D = I + x | 0;
              K = (D << 7 | D >>> 25) ^ j;
              D = K + x | 0;
              V = (D << 9 | D >>> 23) ^ B;
              D = V + K | 0;
              H = (D << 13 | D >>> 19) ^ I;
              D = H + V | 0;
              W = (D << 18 | D >>> 14) ^ x;
              D = P + R | 0;
              G = (D << 7 | D >>> 25) ^ T;
              D = G + R | 0;
              X = (D << 9 | D >>> 23) ^ L;
              D = X + G | 0;
              Z = (D << 13 | D >>> 19) ^ P;
              D = Z + X | 0;
              J = (D << 18 | D >>> 14) ^ R;
              D = O + C | 0;
              $ = (D << 7 | D >>> 25) ^ N;
              D = $ + C | 0;
              Q = (D << 9 | D >>> 23) ^ U;
              D = Q + $ | 0;
              ee = (D << 13 | D >>> 19) ^ O;
              D = ee + Q | 0;
              te = (D << 18 | D >>> 14) ^ C;
              D = $ + Y | 0;
              I = (D << 7 | D >>> 25) ^ H;
              H = I + Y | 0;
              L = (H << 9 | H >>> 23) ^ X;
              X = L + I | 0;
              N = (X << 13 | X >>> 19) ^ $;
              $ = N + L | 0;
              E = ($ << 18 | $ >>> 14) ^ Y;
              Y = q + W | 0;
              P = (Y << 7 | Y >>> 25) ^ Z;
              Z = P + W | 0;
              U = (Z << 9 | Z >>> 23) ^ Q;
              Q = U + P | 0;
              S = (Q << 13 | Q >>> 19) ^ q;
              q = S + U | 0;
              x = (q << 18 | q >>> 14) ^ W;
              W = K + J | 0;
              O = (W << 7 | W >>> 25) ^ ee;
              ee = O + J | 0;
              M = (ee << 9 | ee >>> 23) ^ z;
              z = M + O | 0;
              j = (z << 13 | z >>> 19) ^ K;
              K = j + M | 0;
              R = (K << 18 | K >>> 14) ^ J;
              J = G + te | 0;
              A = (J << 7 | J >>> 25) ^ F;
              F = A + te | 0;
              B = (F << 9 | F >>> 23) ^ V;
              V = B + A | 0;
              T = (V << 13 | V >>> 19) ^ G;
              G = T + B | 0;
              C = (G << 18 | G >>> 14) ^ te;
              k = k + 2 | 0;
            } while (k >>> 0 < 8);

            o[i >> 2] = E;
            o[a >> 2] = A;
            o[s >> 2] = S;
            o[f >> 2] = M;
            o[c >> 2] = x;
            o[u >> 2] = I;
            o[h >> 2] = j;
            o[l >> 2] = B;
            o[p >> 2] = R;
            o[b >> 2] = P;
            o[m >> 2] = T;
            o[y >> 2] = L;
            o[v >> 2] = C;
            o[g >> 2] = O;
            o[_ >> 2] = N;
            o[w >> 2] = U;
            U = r | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n >> 2] | 0);
            U = r + 4 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 4 >> 2] | 0);
            U = r + 8 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 8 >> 2] | 0);
            U = r + 12 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 12 >> 2] | 0);
            U = r + 16 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 16 >> 2] | 0);
            U = r + 20 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 20 >> 2] | 0);
            U = r + 24 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 24 >> 2] | 0);
            U = r + 28 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 28 >> 2] | 0);
            U = r + 32 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 32 >> 2] | 0);
            U = r + 36 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 36 >> 2] | 0);
            U = r + 40 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 40 >> 2] | 0);
            U = r + 44 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 44 >> 2] | 0);
            U = r + 48 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 48 >> 2] | 0);
            U = r + 52 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 52 >> 2] | 0);
            U = r + 56 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 56 >> 2] | 0);
            U = r + 60 | 0;
            o[U >> 2] = (o[U >> 2] | 0) + (o[n + 60 >> 2] | 0);
            n = 0;

            do {
              St(e + (n << 2) | 0, o[r + (n << 2) >> 2] | 0);
              n = n + 1 | 0;
            } while (n >>> 0 < 16);

            d = t;
            return;
          }

          function Pt(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0;
            n = e + 32 | 0;
            i = e + 36 | 0;
            a = o[i >> 2] | 0;
            s = a >>> 3 & 63;
            f = Fe(a | 0, r << 3 | 0) | 0;
            o[i >> 2] = f;

            if (O) {
              f = n | 0;
              o[f >> 2] = (o[f >> 2] | 0) + 1;
            }

            f = n | 0;
            o[f >> 2] = (o[f >> 2] | 0) + (r >>> 29);
            f = 64 - s | 0;
            n = e + 40 + s | 0;

            if (f >>> 0 > r >>> 0) {
              Qr(n | 0, t | 0, r) | 0;
              return;
            }

            Qr(n | 0, t | 0, f) | 0;
            n = e | 0;
            s = e + 40 | 0;
            Tt(n, s);
            e = t + f | 0;
            t = r - f | 0;

            if (t >>> 0 > 63) {
              f = t;
              r = e;

              while (1) {
                Tt(n, r);
                i = r + 64 | 0;
                a = f - 64 | 0;

                if (a >>> 0 > 63) {
                  f = a;
                  r = i;
                } else {
                  c = a;
                  u = i;
                  break;
                }
              }
            } else {
              c = t;
              u = e;
            }

            Qr(s | 0, u | 0, c) | 0;
            return;
          }

          function Tt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0;
            r = d;
            d = d + 288 | 0;
            n = r | 0;
            i = r + 256 | 0;
            a = n | 0;
            Yt(a, t);
            t = 16;

            do {
              s = o[n + (t - 2 << 2) >> 2] | 0;
              f = o[n + (t - 15 << 2) >> 2] | 0;
              o[n + (t << 2) >> 2] = (o[n + (t - 16 << 2) >> 2] | 0) + (o[n + (t - 7 << 2) >> 2] | 0) + ((s >>> 19 | s << 13) ^ s >>> 10 ^ (s >>> 17 | s << 15)) + ((f >>> 18 | f << 14) ^ f >>> 3 ^ (f >>> 7 | f << 25));
              t = t + 1 | 0;
            } while ((t | 0) < 64);

            t = i;
            f = e;
            Qr(t | 0, f | 0, 32) | 0;
            f = i + 28 | 0;
            t = i + 16 | 0;
            s = o[t >> 2] | 0;
            c = i + 20 | 0;
            u = i + 24 | 0;
            h = o[u >> 2] | 0;
            l = (o[f >> 2] | 0) + 1116352408 + (o[a >> 2] | 0) + ((s >>> 6 | s << 26) ^ (s >>> 11 | s << 21) ^ (s >>> 25 | s << 7)) + ((h ^ o[c >> 2]) & s ^ h) | 0;
            h = i | 0;
            s = o[h >> 2] | 0;
            a = i + 4 | 0;
            p = o[a >> 2] | 0;
            b = i + 8 | 0;
            m = o[b >> 2] | 0;
            y = i + 12 | 0;
            o[y >> 2] = (o[y >> 2] | 0) + l;
            v = ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + l + ((m | p) & s | m & p) | 0;
            o[f >> 2] = v;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            s = (o[u >> 2] | 0) + 1899447441 + (o[n + 4 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[u >> 2] = l;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            v = (o[c >> 2] | 0) - 1245643825 + (o[n + 8 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[c >> 2] = s;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            l = (o[t >> 2] | 0) - 373957723 + (o[n + 12 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[t >> 2] = v;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            s = (o[y >> 2] | 0) + 961987163 + (o[n + 16 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[y >> 2] = l;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            v = (o[b >> 2] | 0) + 1508970993 + (o[n + 20 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[b >> 2] = s;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            l = (o[a >> 2] | 0) - 1841331548 + (o[n + 24 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[a >> 2] = v;
            p = o[c >> 2] | 0;
            m = o[f >> 2] | 0;
            s = (o[h >> 2] | 0) - 1424204075 + (o[n + 28 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[u >> 2]) & p ^ m) | 0;
            m = o[b >> 2] | 0;
            p = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[h >> 2] = l;
            m = o[t >> 2] | 0;
            p = o[u >> 2] | 0;
            v = (o[f >> 2] | 0) - 670586216 + (o[n + 32 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[c >> 2]) & m ^ p) | 0;
            p = o[a >> 2] | 0;
            m = o[b >> 2] | 0;
            o[y >> 2] = (o[y >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[f >> 2] = s;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            l = (o[u >> 2] | 0) + 310598401 + (o[n + 36 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[u >> 2] = v;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            s = (o[c >> 2] | 0) + 607225278 + (o[n + 40 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[c >> 2] = l;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            v = (o[t >> 2] | 0) + 1426881987 + (o[n + 44 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[t >> 2] = s;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            l = (o[y >> 2] | 0) + 1925078388 + (o[n + 48 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[y >> 2] = v;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            s = (o[b >> 2] | 0) - 2132889090 + (o[n + 52 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[b >> 2] = l;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            v = (o[a >> 2] | 0) - 1680079193 + (o[n + 56 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[a >> 2] = s;
            p = o[c >> 2] | 0;
            m = o[f >> 2] | 0;
            l = (o[h >> 2] | 0) - 1046744716 + (o[n + 60 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[u >> 2]) & p ^ m) | 0;
            m = o[b >> 2] | 0;
            p = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[h >> 2] = v;
            m = o[t >> 2] | 0;
            p = o[u >> 2] | 0;
            s = (o[f >> 2] | 0) - 459576895 + (o[n + 64 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[c >> 2]) & m ^ p) | 0;
            p = o[a >> 2] | 0;
            m = o[b >> 2] | 0;
            o[y >> 2] = (o[y >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[f >> 2] = l;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            v = (o[u >> 2] | 0) - 272742522 + (o[n + 68 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[u >> 2] = s;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            l = (o[c >> 2] | 0) + 264347078 + (o[n + 72 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[c >> 2] = v;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            s = (o[t >> 2] | 0) + 604807628 + (o[n + 76 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[t >> 2] = l;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            v = (o[y >> 2] | 0) + 770255983 + (o[n + 80 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[y >> 2] = s;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            l = (o[b >> 2] | 0) + 1249150122 + (o[n + 84 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[b >> 2] = v;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            s = (o[a >> 2] | 0) + 1555081692 + (o[n + 88 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[a >> 2] = l;
            p = o[c >> 2] | 0;
            m = o[f >> 2] | 0;
            v = (o[h >> 2] | 0) + 1996064986 + (o[n + 92 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[u >> 2]) & p ^ m) | 0;
            m = o[b >> 2] | 0;
            p = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[h >> 2] = s;
            m = o[t >> 2] | 0;
            p = o[u >> 2] | 0;
            l = (o[f >> 2] | 0) - 1740746414 + (o[n + 96 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[c >> 2]) & m ^ p) | 0;
            p = o[a >> 2] | 0;
            m = o[b >> 2] | 0;
            o[y >> 2] = (o[y >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[f >> 2] = v;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            s = (o[u >> 2] | 0) - 1473132947 + (o[n + 100 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[u >> 2] = l;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            v = (o[c >> 2] | 0) - 1341970488 + (o[n + 104 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[c >> 2] = s;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            l = (o[t >> 2] | 0) - 1084653625 + (o[n + 108 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[t >> 2] = v;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            s = (o[y >> 2] | 0) - 958395405 + (o[n + 112 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[y >> 2] = l;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            v = (o[b >> 2] | 0) - 710438585 + (o[n + 116 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[b >> 2] = s;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            l = (o[a >> 2] | 0) + 113926993 + (o[n + 120 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[a >> 2] = v;
            p = o[c >> 2] | 0;
            m = o[f >> 2] | 0;
            s = (o[h >> 2] | 0) + 338241895 + (o[n + 124 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[u >> 2]) & p ^ m) | 0;
            m = o[b >> 2] | 0;
            p = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[h >> 2] = l;
            m = o[t >> 2] | 0;
            p = o[u >> 2] | 0;
            v = (o[f >> 2] | 0) + 666307205 + (o[n + 128 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[c >> 2]) & m ^ p) | 0;
            p = o[a >> 2] | 0;
            m = o[b >> 2] | 0;
            o[y >> 2] = (o[y >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[f >> 2] = s;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            l = (o[u >> 2] | 0) + 773529912 + (o[n + 132 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[u >> 2] = v;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            s = (o[c >> 2] | 0) + 1294757372 + (o[n + 136 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[c >> 2] = l;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            v = (o[t >> 2] | 0) + 1396182291 + (o[n + 140 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[t >> 2] = s;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            l = (o[y >> 2] | 0) + 1695183700 + (o[n + 144 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[y >> 2] = v;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            s = (o[b >> 2] | 0) + 1986661051 + (o[n + 148 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[b >> 2] = l;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            v = (o[a >> 2] | 0) - 2117940946 + (o[n + 152 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[a >> 2] = s;
            p = o[c >> 2] | 0;
            m = o[f >> 2] | 0;
            l = (o[h >> 2] | 0) - 1838011259 + (o[n + 156 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[u >> 2]) & p ^ m) | 0;
            m = o[b >> 2] | 0;
            p = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[h >> 2] = v;
            m = o[t >> 2] | 0;
            p = o[u >> 2] | 0;
            s = (o[f >> 2] | 0) - 1564481375 + (o[n + 160 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[c >> 2]) & m ^ p) | 0;
            p = o[a >> 2] | 0;
            m = o[b >> 2] | 0;
            o[y >> 2] = (o[y >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[f >> 2] = l;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            v = (o[u >> 2] | 0) - 1474664885 + (o[n + 164 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[u >> 2] = s;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            l = (o[c >> 2] | 0) - 1035236496 + (o[n + 168 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[c >> 2] = v;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            s = (o[t >> 2] | 0) - 949202525 + (o[n + 172 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[t >> 2] = l;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            v = (o[y >> 2] | 0) - 778901479 + (o[n + 176 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[y >> 2] = s;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            l = (o[b >> 2] | 0) - 694614492 + (o[n + 180 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[b >> 2] = v;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            s = (o[a >> 2] | 0) - 200395387 + (o[n + 184 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[a >> 2] = l;
            p = o[c >> 2] | 0;
            m = o[f >> 2] | 0;
            v = (o[h >> 2] | 0) + 275423344 + (o[n + 188 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[u >> 2]) & p ^ m) | 0;
            m = o[b >> 2] | 0;
            p = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[h >> 2] = s;
            m = o[t >> 2] | 0;
            p = o[u >> 2] | 0;
            l = (o[f >> 2] | 0) + 430227734 + (o[n + 192 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[c >> 2]) & m ^ p) | 0;
            p = o[a >> 2] | 0;
            m = o[b >> 2] | 0;
            o[y >> 2] = (o[y >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[f >> 2] = v;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            s = (o[u >> 2] | 0) + 506948616 + (o[n + 196 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[u >> 2] = l;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            v = (o[c >> 2] | 0) + 659060556 + (o[n + 200 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[c >> 2] = s;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            l = (o[t >> 2] | 0) + 883997877 + (o[n + 204 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[t >> 2] = v;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            s = (o[y >> 2] | 0) + 958139571 + (o[n + 208 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[y >> 2] = l;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            v = (o[b >> 2] | 0) + 1322822218 + (o[n + 212 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[b >> 2] = s;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            l = (o[a >> 2] | 0) + 1537002063 + (o[n + 216 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[a >> 2] = v;
            p = o[c >> 2] | 0;
            m = o[f >> 2] | 0;
            s = (o[h >> 2] | 0) + 1747873779 + (o[n + 220 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[u >> 2]) & p ^ m) | 0;
            m = o[b >> 2] | 0;
            p = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[h >> 2] = l;
            m = o[t >> 2] | 0;
            p = o[u >> 2] | 0;
            v = (o[f >> 2] | 0) + 1955562222 + (o[n + 224 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[c >> 2]) & m ^ p) | 0;
            p = o[a >> 2] | 0;
            m = o[b >> 2] | 0;
            o[y >> 2] = (o[y >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[f >> 2] = s;
            p = o[y >> 2] | 0;
            m = o[c >> 2] | 0;
            l = (o[u >> 2] | 0) + 2024104815 + (o[n + 228 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[t >> 2]) & p ^ m) | 0;
            m = o[h >> 2] | 0;
            p = o[a >> 2] | 0;
            o[b >> 2] = (o[b >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((p | m) & s | p & m) | 0;
            o[u >> 2] = v;
            m = o[b >> 2] | 0;
            p = o[t >> 2] | 0;
            s = (o[c >> 2] | 0) - 2067236844 + (o[n + 232 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[y >> 2]) & m ^ p) | 0;
            p = o[f >> 2] | 0;
            m = o[h >> 2] | 0;
            o[a >> 2] = (o[a >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((m | p) & v | m & p) | 0;
            o[c >> 2] = l;
            p = o[a >> 2] | 0;
            m = o[y >> 2] | 0;
            v = (o[t >> 2] | 0) - 1933114872 + (o[n + 236 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[b >> 2]) & p ^ m) | 0;
            m = o[u >> 2] | 0;
            p = o[f >> 2] | 0;
            o[h >> 2] = (o[h >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((p | m) & l | p & m) | 0;
            o[t >> 2] = s;
            m = o[h >> 2] | 0;
            p = o[b >> 2] | 0;
            l = (o[y >> 2] | 0) - 1866530822 + (o[n + 240 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[a >> 2]) & m ^ p) | 0;
            p = o[c >> 2] | 0;
            m = o[u >> 2] | 0;
            o[f >> 2] = (o[f >> 2] | 0) + l;
            v = l + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((m | p) & s | m & p) | 0;
            o[y >> 2] = v;
            p = o[f >> 2] | 0;
            m = o[a >> 2] | 0;
            s = (o[b >> 2] | 0) - 1538233109 + (o[n + 244 >> 2] | 0) + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + ((m ^ o[h >> 2]) & p ^ m) | 0;
            m = o[t >> 2] | 0;
            p = o[c >> 2] | 0;
            o[u >> 2] = (o[u >> 2] | 0) + s;
            l = s + ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + ((p | m) & v | p & m) | 0;
            o[b >> 2] = l;
            m = o[u >> 2] | 0;
            p = o[h >> 2] | 0;
            v = (o[a >> 2] | 0) - 1090935817 + (o[n + 248 >> 2] | 0) + ((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + ((p ^ o[f >> 2]) & m ^ p) | 0;
            p = o[y >> 2] | 0;
            m = o[t >> 2] | 0;
            o[c >> 2] = (o[c >> 2] | 0) + v;
            s = v + ((l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10)) + ((m | p) & l | m & p) | 0;
            o[a >> 2] = s;
            a = o[c >> 2] | 0;
            c = o[f >> 2] | 0;
            f = (o[h >> 2] | 0) - 965641998 + (o[n + 252 >> 2] | 0) + ((a >>> 6 | a << 26) ^ (a >>> 11 | a << 21) ^ (a >>> 25 | a << 7)) + ((c ^ o[u >> 2]) & a ^ c) | 0;
            c = o[b >> 2] | 0;
            b = o[y >> 2] | 0;
            o[t >> 2] = (o[t >> 2] | 0) + f;
            t = f + ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + ((b | c) & s | b & c) | 0;
            o[h >> 2] = t;
            o[e >> 2] = (o[e >> 2] | 0) + t;
            t = e + 4 | 0;
            o[t >> 2] = (o[t >> 2] | 0) + (o[i + 4 >> 2] | 0);
            t = e + 8 | 0;
            o[t >> 2] = (o[t >> 2] | 0) + (o[i + 8 >> 2] | 0);
            t = e + 12 | 0;
            o[t >> 2] = (o[t >> 2] | 0) + (o[i + 12 >> 2] | 0);
            t = e + 16 | 0;
            o[t >> 2] = (o[t >> 2] | 0) + (o[i + 16 >> 2] | 0);
            t = e + 20 | 0;
            o[t >> 2] = (o[t >> 2] | 0) + (o[i + 20 >> 2] | 0);
            t = e + 24 | 0;
            o[t >> 2] = (o[t >> 2] | 0) + (o[i + 24 >> 2] | 0);
            t = e + 28 | 0;
            o[t >> 2] = (o[t >> 2] | 0) + (o[i + 28 >> 2] | 0);
            d = r;
            return;
          }

          function Lt(e, t) {
            e = e | 0;
            t = t | 0;
            n[e + 3 | 0] = t & 255;
            n[e + 2 | 0] = t >>> 8 & 255;
            n[e + 1 | 0] = t >>> 16 & 255;
            n[e] = t >>> 24 & 255;
            return;
          }

          function Ct(e) {
            e = e | 0;
            return (a[e + 2 | 0] | 0) << 8 | (a[e + 3 | 0] | 0) | (a[e + 1 | 0] | 0) << 16 | (a[e] | 0) << 24 | 0;
          }

          function Ot(e, t) {
            e = e | 0;
            t = t | 0;
            Nt(t);
            Ut(e, t | 0, 32);
            en(t | 0, 0, 104);
            return;
          }

          function Nt(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0;
            t = d;
            d = d + 8 | 0;
            r = t | 0;
            Ut(r, e + 32 | 0, 8);
            n = (o[e + 36 >> 2] | 0) >>> 3 & 63;
            Pt(e, 720, (n >>> 0 < 56 ? 56 : 120) - n | 0);
            Pt(e, r, 8);
            d = t;
            return;
          }

          function Ut(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0;
            n = r >>> 2;

            if ((n | 0) == 0) {
              return;
            } else {
              i = 0;
            }

            do {
              Lt(e + (i << 2) | 0, o[t + (i << 2) >> 2] | 0);
              i = i + 1 | 0;
            } while (i >>> 0 < n >>> 0);

            return;
          }

          function Dt(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var i = 0,
                o = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0;
            i = d;
            d = d + 96 | 0;
            o = i | 0;

            if (r >>> 0 > 64) {
              a = e | 0;
              Mt(a);
              Pt(a, t, r);
              s = i + 64 | 0;
              Ot(s, a);
              f = s;
              c = 32;
            } else {
              f = t;
              c = r;
            }

            r = e | 0;
            Mt(r);
            t = o | 0;
            en(t | 0, 54, 64);

            if ((c | 0) != 0) {
              s = 0;

              do {
                a = o + s | 0;
                n[a] = n[a] ^ n[f + s | 0];
                s = s + 1 | 0;
              } while (s >>> 0 < c >>> 0);
            }

            Pt(r, t, 64);
            r = e + 104 | 0;
            Mt(r);
            en(t | 0, 92, 64);

            if ((c | 0) == 0) {
              Pt(r, t, 64);
              d = i;
              return;
            } else {
              u = 0;
            }

            do {
              e = o + u | 0;
              n[e] = n[e] ^ n[f + u | 0];
              u = u + 1 | 0;
            } while (u >>> 0 < c >>> 0);

            Pt(r, t, 64);
            d = i;
            return;
          }

          function qt(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            Pt(e | 0, t, r);
            return;
          }

          function zt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0;
            r = d;
            d = d + 32 | 0;
            n = r | 0;
            Ot(n, t | 0);
            i = t + 104 | 0;
            Pt(i, n, 32);
            Ot(e, i);
            d = r;
            return;
          }

          function Ft(e, t, r, i, o, a, s, f) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            i = i | 0;
            o = o | 0;
            a = a | 0;
            s = s | 0;
            f = f | 0;
            var c = 0,
                u = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0;
            c = d;
            d = d + 488 | 0;
            u = c | 0;
            h = c + 208 | 0;
            l = c + 424 | 0;
            p = c + 456 | 0;
            Dt(u, e, t);
            qt(u, r, i);

            if ((f | 0) == 0) {
              d = c;
              return;
            }

            i = c + 416 | 0;
            r = h;
            b = u;
            u = l | 0;
            m = p | 0;
            y = 0;
            v = a >>> 0 < y >>> 0 | a >>> 0 == y >>> 0 & o >>> 0 < 2 >>> 0;
            y = 0;
            g = 0;

            do {
              y = y + 1 | 0;
              Lt(i, y);
              Qr(r | 0, b | 0, 208) | 0;
              qt(h, i, 4);
              zt(u, h);
              Qr(m | 0, u | 0, 32) | 0;

              if (!v) {
                _ = 0;
                w = 2;

                do {
                  Dt(h, e, t);
                  qt(h, u, 32);
                  zt(u, h);
                  k = 0;

                  do {
                    E = p + k | 0;
                    n[E] = n[E] ^ n[l + k | 0];
                    k = k + 1 | 0;
                  } while ((k | 0) < 32);

                  w = rn(w, _, 1, 0) | 0;
                  _ = O;
                } while (!(_ >>> 0 > a >>> 0 | _ >>> 0 == a >>> 0 & w >>> 0 > o >>> 0));
              }

              w = f - g | 0;
              _ = w >>> 0 > 32 ? 32 : w;
              w = s + g | 0;
              Qr(w | 0, m | 0, _) | 0;
              g = y << 5;
            } while (g >>> 0 < f >>> 0);

            d = c;
            return;
          }

          function Yt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0;
            r = 0;

            do {
              o[e + (r << 2) >> 2] = Ct(t + (r << 2) | 0) | 0;
              r = r + 1 | 0;
            } while (r >>> 0 < 16);

            return;
          }

          function Kt(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0,
                x = 0,
                I = 0,
                j = 0,
                B = 0,
                R = 0,
                P = 0,
                T = 0,
                L = 0,
                C = 0,
                O = 0,
                N = 0,
                U = 0,
                D = 0,
                q = 0,
                z = 0,
                F = 0,
                Y = 0,
                K = 0,
                V = 0,
                H = 0,
                W = 0,
                G = 0,
                X = 0,
                Z = 0,
                J = 0,
                $ = 0,
                Q = 0,
                ee = 0,
                te = 0,
                re = 0,
                ne = 0,
                ie = 0,
                oe = 0,
                ae = 0,
                se = 0,
                fe = 0,
                ce = 0,
                ue = 0,
                de = 0,
                he = 0,
                le = 0,
                pe = 0,
                be = 0,
                me = 0,
                ye = 0,
                ve = 0,
                ge = 0,
                we = 0,
                ke = 0,
                Ae = 0,
                Se = 0,
                Me = 0,
                xe = 0,
                Ie = 0,
                je = 0,
                Be = 0,
                Re = 0,
                Pe = 0,
                Te = 0,
                Le = 0;

            do {
              if (e >>> 0 < 245) {
                if (e >>> 0 < 11) {
                  t = 16;
                } else {
                  t = e + 11 & -8;
                }

                r = t >>> 3;
                n = o[208] | 0;
                i = n >>> (r >>> 0);

                if ((i & 3 | 0) != 0) {
                  a = (i & 1 ^ 1) + r | 0;
                  s = a << 1;
                  f = 872 + (s << 2) | 0;
                  c = 872 + (s + 2 << 2) | 0;
                  s = o[c >> 2] | 0;
                  u = s + 8 | 0;
                  d = o[u >> 2] | 0;

                  do {
                    if ((f | 0) == (d | 0)) {
                      o[208] = n & ~(1 << a);
                    } else {
                      if (d >>> 0 < (o[212] | 0) >>> 0) {
                        Ee();
                        return 0;
                      }

                      h = d + 12 | 0;

                      if ((o[h >> 2] | 0) == (s | 0)) {
                        o[h >> 2] = f;
                        o[c >> 2] = d;
                        break;
                      } else {
                        Ee();
                        return 0;
                      }
                    }
                  } while (0);

                  d = a << 3;
                  o[s + 4 >> 2] = d | 3;
                  c = s + (d | 4) | 0;
                  o[c >> 2] = o[c >> 2] | 1;
                  l = u;
                  return l | 0;
                }

                if (t >>> 0 <= (o[210] | 0) >>> 0) {
                  p = t;
                  break;
                }

                if ((i | 0) != 0) {
                  c = 2 << r;
                  d = i << r & (c | -c);
                  c = (d & -d) - 1 | 0;
                  d = c >>> 12 & 16;
                  f = c >>> (d >>> 0);
                  c = f >>> 5 & 8;
                  h = f >>> (c >>> 0);
                  f = h >>> 2 & 4;
                  b = h >>> (f >>> 0);
                  h = b >>> 1 & 2;
                  m = b >>> (h >>> 0);
                  b = m >>> 1 & 1;
                  y = (c | d | f | h | b) + (m >>> (b >>> 0)) | 0;
                  b = y << 1;
                  m = 872 + (b << 2) | 0;
                  h = 872 + (b + 2 << 2) | 0;
                  b = o[h >> 2] | 0;
                  f = b + 8 | 0;
                  d = o[f >> 2] | 0;

                  do {
                    if ((m | 0) == (d | 0)) {
                      o[208] = n & ~(1 << y);
                    } else {
                      if (d >>> 0 < (o[212] | 0) >>> 0) {
                        Ee();
                        return 0;
                      }

                      c = d + 12 | 0;

                      if ((o[c >> 2] | 0) == (b | 0)) {
                        o[c >> 2] = m;
                        o[h >> 2] = d;
                        break;
                      } else {
                        Ee();
                        return 0;
                      }
                    }
                  } while (0);

                  d = y << 3;
                  h = d - t | 0;
                  o[b + 4 >> 2] = t | 3;
                  m = b;
                  n = m + t | 0;
                  o[m + (t | 4) >> 2] = h | 1;
                  o[m + d >> 2] = h;
                  d = o[210] | 0;

                  if ((d | 0) != 0) {
                    m = o[213] | 0;
                    r = d >>> 3;
                    d = r << 1;
                    i = 872 + (d << 2) | 0;
                    u = o[208] | 0;
                    s = 1 << r;

                    do {
                      if ((u & s | 0) == 0) {
                        o[208] = u | s;
                        v = i;
                        g = 872 + (d + 2 << 2) | 0;
                      } else {
                        r = 872 + (d + 2 << 2) | 0;
                        a = o[r >> 2] | 0;

                        if (a >>> 0 >= (o[212] | 0) >>> 0) {
                          v = a;
                          g = r;
                          break;
                        }

                        Ee();
                        return 0;
                      }
                    } while (0);

                    o[g >> 2] = m;
                    o[v + 12 >> 2] = m;
                    o[m + 8 >> 2] = v;
                    o[m + 12 >> 2] = i;
                  }

                  o[210] = h;
                  o[213] = n;
                  l = f;
                  return l | 0;
                }

                d = o[209] | 0;

                if ((d | 0) == 0) {
                  p = t;
                  break;
                }

                s = (d & -d) - 1 | 0;
                d = s >>> 12 & 16;
                u = s >>> (d >>> 0);
                s = u >>> 5 & 8;
                b = u >>> (s >>> 0);
                u = b >>> 2 & 4;
                y = b >>> (u >>> 0);
                b = y >>> 1 & 2;
                r = y >>> (b >>> 0);
                y = r >>> 1 & 1;
                a = o[1136 + ((s | d | u | b | y) + (r >>> (y >>> 0)) << 2) >> 2] | 0;
                y = a;
                r = a;
                b = (o[a + 4 >> 2] & -8) - t | 0;

                while (1) {
                  a = o[y + 16 >> 2] | 0;

                  if ((a | 0) == 0) {
                    u = o[y + 20 >> 2] | 0;

                    if ((u | 0) == 0) {
                      break;
                    } else {
                      _ = u;
                    }
                  } else {
                    _ = a;
                  }

                  a = (o[_ + 4 >> 2] & -8) - t | 0;
                  u = a >>> 0 < b >>> 0;
                  y = _;
                  r = u ? _ : r;
                  b = u ? a : b;
                }

                y = r;
                f = o[212] | 0;

                if (y >>> 0 < f >>> 0) {
                  Ee();
                  return 0;
                }

                n = y + t | 0;
                h = n;

                if (y >>> 0 >= n >>> 0) {
                  Ee();
                  return 0;
                }

                n = o[r + 24 >> 2] | 0;
                i = o[r + 12 >> 2] | 0;

                do {
                  if ((i | 0) == (r | 0)) {
                    m = r + 20 | 0;
                    a = o[m >> 2] | 0;

                    if ((a | 0) == 0) {
                      u = r + 16 | 0;
                      d = o[u >> 2] | 0;

                      if ((d | 0) == 0) {
                        w = 0;
                        break;
                      } else {
                        k = d;
                        E = u;
                      }
                    } else {
                      k = a;
                      E = m;
                    }

                    while (1) {
                      m = k + 20 | 0;
                      a = o[m >> 2] | 0;

                      if ((a | 0) != 0) {
                        k = a;
                        E = m;
                        continue;
                      }

                      m = k + 16 | 0;
                      a = o[m >> 2] | 0;

                      if ((a | 0) == 0) {
                        break;
                      } else {
                        k = a;
                        E = m;
                      }
                    }

                    if (E >>> 0 < f >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[E >> 2] = 0;
                      w = k;
                      break;
                    }
                  } else {
                    m = o[r + 8 >> 2] | 0;

                    if (m >>> 0 < f >>> 0) {
                      Ee();
                      return 0;
                    }

                    a = m + 12 | 0;

                    if ((o[a >> 2] | 0) != (r | 0)) {
                      Ee();
                      return 0;
                    }

                    u = i + 8 | 0;

                    if ((o[u >> 2] | 0) == (r | 0)) {
                      o[a >> 2] = i;
                      o[u >> 2] = m;
                      w = i;
                      break;
                    } else {
                      Ee();
                      return 0;
                    }
                  }
                } while (0);

                e: do {
                  if ((n | 0) != 0) {
                    i = r + 28 | 0;
                    f = 1136 + (o[i >> 2] << 2) | 0;

                    do {
                      if ((r | 0) == (o[f >> 2] | 0)) {
                        o[f >> 2] = w;

                        if ((w | 0) != 0) {
                          break;
                        }

                        o[209] = o[209] & ~(1 << o[i >> 2]);
                        break e;
                      } else {
                        if (n >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                          return 0;
                        }

                        m = n + 16 | 0;

                        if ((o[m >> 2] | 0) == (r | 0)) {
                          o[m >> 2] = w;
                        } else {
                          o[n + 20 >> 2] = w;
                        }

                        if ((w | 0) == 0) {
                          break e;
                        }
                      }
                    } while (0);

                    if (w >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                      return 0;
                    }

                    o[w + 24 >> 2] = n;
                    i = o[r + 16 >> 2] | 0;

                    do {
                      if ((i | 0) != 0) {
                        if (i >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                          return 0;
                        } else {
                          o[w + 16 >> 2] = i;
                          o[i + 24 >> 2] = w;
                          break;
                        }
                      }
                    } while (0);

                    i = o[r + 20 >> 2] | 0;

                    if ((i | 0) == 0) {
                      break;
                    }

                    if (i >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[w + 20 >> 2] = i;
                      o[i + 24 >> 2] = w;
                      break;
                    }
                  }
                } while (0);

                if (b >>> 0 < 16) {
                  n = b + t | 0;
                  o[r + 4 >> 2] = n | 3;
                  i = y + (n + 4) | 0;
                  o[i >> 2] = o[i >> 2] | 1;
                } else {
                  o[r + 4 >> 2] = t | 3;
                  o[y + (t | 4) >> 2] = b | 1;
                  o[y + (b + t) >> 2] = b;
                  i = o[210] | 0;

                  if ((i | 0) != 0) {
                    n = o[213] | 0;
                    f = i >>> 3;
                    i = f << 1;
                    m = 872 + (i << 2) | 0;
                    u = o[208] | 0;
                    a = 1 << f;

                    do {
                      if ((u & a | 0) == 0) {
                        o[208] = u | a;
                        A = m;
                        S = 872 + (i + 2 << 2) | 0;
                      } else {
                        f = 872 + (i + 2 << 2) | 0;
                        d = o[f >> 2] | 0;

                        if (d >>> 0 >= (o[212] | 0) >>> 0) {
                          A = d;
                          S = f;
                          break;
                        }

                        Ee();
                        return 0;
                      }
                    } while (0);

                    o[S >> 2] = n;
                    o[A + 12 >> 2] = n;
                    o[n + 8 >> 2] = A;
                    o[n + 12 >> 2] = m;
                  }

                  o[210] = b;
                  o[213] = h;
                }

                i = r + 8 | 0;

                if ((i | 0) == 0) {
                  p = t;
                  break;
                } else {
                  l = i;
                }

                return l | 0;
              } else {
                if (e >>> 0 > 4294967231) {
                  p = -1;
                  break;
                }

                i = e + 11 | 0;
                a = i & -8;
                u = o[209] | 0;

                if ((u | 0) == 0) {
                  p = a;
                  break;
                }

                y = -a | 0;
                f = i >>> 8;

                do {
                  if ((f | 0) == 0) {
                    M = 0;
                  } else {
                    if (a >>> 0 > 16777215) {
                      M = 31;
                      break;
                    }

                    i = (f + 1048320 | 0) >>> 16 & 8;
                    d = f << i;
                    s = (d + 520192 | 0) >>> 16 & 4;
                    c = d << s;
                    d = (c + 245760 | 0) >>> 16 & 2;
                    x = 14 - (s | i | d) + (c << d >>> 15) | 0;
                    M = a >>> ((x + 7 | 0) >>> 0) & 1 | x << 1;
                  }
                } while (0);

                f = o[1136 + (M << 2) >> 2] | 0;

                e: do {
                  if ((f | 0) == 0) {
                    I = 0;
                    j = y;
                    B = 0;
                  } else {
                    if ((M | 0) == 31) {
                      R = 0;
                    } else {
                      R = 25 - (M >>> 1) | 0;
                    }

                    r = 0;
                    h = y;
                    b = f;
                    m = a << R;
                    n = 0;

                    while (1) {
                      x = o[b + 4 >> 2] & -8;
                      d = x - a | 0;

                      if (d >>> 0 < h >>> 0) {
                        if ((x | 0) == (a | 0)) {
                          I = b;
                          j = d;
                          B = b;
                          break e;
                        } else {
                          P = b;
                          T = d;
                        }
                      } else {
                        P = r;
                        T = h;
                      }

                      d = o[b + 20 >> 2] | 0;
                      x = o[b + 16 + (m >>> 31 << 2) >> 2] | 0;
                      c = (d | 0) == 0 | (d | 0) == (x | 0) ? n : d;

                      if ((x | 0) == 0) {
                        I = P;
                        j = T;
                        B = c;
                        break;
                      } else {
                        r = P;
                        h = T;
                        b = x;
                        m = m << 1;
                        n = c;
                      }
                    }
                  }
                } while (0);

                if ((B | 0) == 0 & (I | 0) == 0) {
                  f = 2 << M;
                  y = u & (f | -f);

                  if ((y | 0) == 0) {
                    p = a;
                    break;
                  }

                  f = (y & -y) - 1 | 0;
                  y = f >>> 12 & 16;
                  n = f >>> (y >>> 0);
                  f = n >>> 5 & 8;
                  m = n >>> (f >>> 0);
                  n = m >>> 2 & 4;
                  b = m >>> (n >>> 0);
                  m = b >>> 1 & 2;
                  h = b >>> (m >>> 0);
                  b = h >>> 1 & 1;
                  L = o[1136 + ((f | y | n | m | b) + (h >>> (b >>> 0)) << 2) >> 2] | 0;
                } else {
                  L = B;
                }

                if ((L | 0) == 0) {
                  C = j;
                  O = I;
                } else {
                  b = L;
                  h = j;
                  m = I;

                  while (1) {
                    n = (o[b + 4 >> 2] & -8) - a | 0;
                    y = n >>> 0 < h >>> 0;
                    f = y ? n : h;
                    n = y ? b : m;
                    y = o[b + 16 >> 2] | 0;

                    if ((y | 0) != 0) {
                      b = y;
                      h = f;
                      m = n;
                      continue;
                    }

                    y = o[b + 20 >> 2] | 0;

                    if ((y | 0) == 0) {
                      C = f;
                      O = n;
                      break;
                    } else {
                      b = y;
                      h = f;
                      m = n;
                    }
                  }
                }

                if ((O | 0) == 0) {
                  p = a;
                  break;
                }

                if (C >>> 0 >= ((o[210] | 0) - a | 0) >>> 0) {
                  p = a;
                  break;
                }

                m = O;
                h = o[212] | 0;

                if (m >>> 0 < h >>> 0) {
                  Ee();
                  return 0;
                }

                b = m + a | 0;
                u = b;

                if (m >>> 0 >= b >>> 0) {
                  Ee();
                  return 0;
                }

                n = o[O + 24 >> 2] | 0;
                f = o[O + 12 >> 2] | 0;

                do {
                  if ((f | 0) == (O | 0)) {
                    y = O + 20 | 0;
                    r = o[y >> 2] | 0;

                    if ((r | 0) == 0) {
                      c = O + 16 | 0;
                      x = o[c >> 2] | 0;

                      if ((x | 0) == 0) {
                        N = 0;
                        break;
                      } else {
                        U = x;
                        D = c;
                      }
                    } else {
                      U = r;
                      D = y;
                    }

                    while (1) {
                      y = U + 20 | 0;
                      r = o[y >> 2] | 0;

                      if ((r | 0) != 0) {
                        U = r;
                        D = y;
                        continue;
                      }

                      y = U + 16 | 0;
                      r = o[y >> 2] | 0;

                      if ((r | 0) == 0) {
                        break;
                      } else {
                        U = r;
                        D = y;
                      }
                    }

                    if (D >>> 0 < h >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[D >> 2] = 0;
                      N = U;
                      break;
                    }
                  } else {
                    y = o[O + 8 >> 2] | 0;

                    if (y >>> 0 < h >>> 0) {
                      Ee();
                      return 0;
                    }

                    r = y + 12 | 0;

                    if ((o[r >> 2] | 0) != (O | 0)) {
                      Ee();
                      return 0;
                    }

                    c = f + 8 | 0;

                    if ((o[c >> 2] | 0) == (O | 0)) {
                      o[r >> 2] = f;
                      o[c >> 2] = y;
                      N = f;
                      break;
                    } else {
                      Ee();
                      return 0;
                    }
                  }
                } while (0);

                e: do {
                  if ((n | 0) != 0) {
                    f = O + 28 | 0;
                    h = 1136 + (o[f >> 2] << 2) | 0;

                    do {
                      if ((O | 0) == (o[h >> 2] | 0)) {
                        o[h >> 2] = N;

                        if ((N | 0) != 0) {
                          break;
                        }

                        o[209] = o[209] & ~(1 << o[f >> 2]);
                        break e;
                      } else {
                        if (n >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                          return 0;
                        }

                        y = n + 16 | 0;

                        if ((o[y >> 2] | 0) == (O | 0)) {
                          o[y >> 2] = N;
                        } else {
                          o[n + 20 >> 2] = N;
                        }

                        if ((N | 0) == 0) {
                          break e;
                        }
                      }
                    } while (0);

                    if (N >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                      return 0;
                    }

                    o[N + 24 >> 2] = n;
                    f = o[O + 16 >> 2] | 0;

                    do {
                      if ((f | 0) != 0) {
                        if (f >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                          return 0;
                        } else {
                          o[N + 16 >> 2] = f;
                          o[f + 24 >> 2] = N;
                          break;
                        }
                      }
                    } while (0);

                    f = o[O + 20 >> 2] | 0;

                    if ((f | 0) == 0) {
                      break;
                    }

                    if (f >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[N + 20 >> 2] = f;
                      o[f + 24 >> 2] = N;
                      break;
                    }
                  }
                } while (0);

                do {
                  if (C >>> 0 < 16) {
                    n = C + a | 0;
                    o[O + 4 >> 2] = n | 3;
                    f = m + (n + 4) | 0;
                    o[f >> 2] = o[f >> 2] | 1;
                  } else {
                    o[O + 4 >> 2] = a | 3;
                    o[m + (a | 4) >> 2] = C | 1;
                    o[m + (C + a) >> 2] = C;
                    f = C >>> 3;

                    if (C >>> 0 < 256) {
                      n = f << 1;
                      h = 872 + (n << 2) | 0;
                      y = o[208] | 0;
                      c = 1 << f;

                      do {
                        if ((y & c | 0) == 0) {
                          o[208] = y | c;
                          q = h;
                          z = 872 + (n + 2 << 2) | 0;
                        } else {
                          f = 872 + (n + 2 << 2) | 0;
                          r = o[f >> 2] | 0;

                          if (r >>> 0 >= (o[212] | 0) >>> 0) {
                            q = r;
                            z = f;
                            break;
                          }

                          Ee();
                          return 0;
                        }
                      } while (0);

                      o[z >> 2] = u;
                      o[q + 12 >> 2] = u;
                      o[m + (a + 8) >> 2] = q;
                      o[m + (a + 12) >> 2] = h;
                      break;
                    }

                    n = b;
                    c = C >>> 8;

                    do {
                      if ((c | 0) == 0) {
                        F = 0;
                      } else {
                        if (C >>> 0 > 16777215) {
                          F = 31;
                          break;
                        }

                        y = (c + 1048320 | 0) >>> 16 & 8;
                        f = c << y;
                        r = (f + 520192 | 0) >>> 16 & 4;
                        x = f << r;
                        f = (x + 245760 | 0) >>> 16 & 2;
                        d = 14 - (r | y | f) + (x << f >>> 15) | 0;
                        F = C >>> ((d + 7 | 0) >>> 0) & 1 | d << 1;
                      }
                    } while (0);

                    c = 1136 + (F << 2) | 0;
                    o[m + (a + 28) >> 2] = F;
                    o[m + (a + 20) >> 2] = 0;
                    o[m + (a + 16) >> 2] = 0;
                    h = o[209] | 0;
                    d = 1 << F;

                    if ((h & d | 0) == 0) {
                      o[209] = h | d;
                      o[c >> 2] = n;
                      o[m + (a + 24) >> 2] = c;
                      o[m + (a + 12) >> 2] = n;
                      o[m + (a + 8) >> 2] = n;
                      break;
                    }

                    if ((F | 0) == 31) {
                      Y = 0;
                    } else {
                      Y = 25 - (F >>> 1) | 0;
                    }

                    d = C << Y;
                    h = o[c >> 2] | 0;

                    while (1) {
                      if ((o[h + 4 >> 2] & -8 | 0) == (C | 0)) {
                        break;
                      }

                      K = h + 16 + (d >>> 31 << 2) | 0;
                      c = o[K >> 2] | 0;

                      if ((c | 0) == 0) {
                        V = 262;
                        break;
                      } else {
                        d = d << 1;
                        h = c;
                      }
                    }

                    if ((V | 0) == 262) {
                      if (K >>> 0 < (o[212] | 0) >>> 0) {
                        Ee();
                        return 0;
                      } else {
                        o[K >> 2] = n;
                        o[m + (a + 24) >> 2] = h;
                        o[m + (a + 12) >> 2] = n;
                        o[m + (a + 8) >> 2] = n;
                        break;
                      }
                    }

                    d = h + 8 | 0;
                    c = o[d >> 2] | 0;
                    f = o[212] | 0;

                    if (h >>> 0 < f >>> 0) {
                      Ee();
                      return 0;
                    }

                    if (c >>> 0 < f >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[c + 12 >> 2] = n;
                      o[d >> 2] = n;
                      o[m + (a + 8) >> 2] = c;
                      o[m + (a + 12) >> 2] = h;
                      o[m + (a + 24) >> 2] = 0;
                      break;
                    }
                  }
                } while (0);

                m = O + 8 | 0;

                if ((m | 0) == 0) {
                  p = a;
                  break;
                } else {
                  l = m;
                }

                return l | 0;
              }
            } while (0);

            O = o[210] | 0;

            if (p >>> 0 <= O >>> 0) {
              K = O - p | 0;
              C = o[213] | 0;

              if (K >>> 0 > 15) {
                Y = C;
                o[213] = Y + p;
                o[210] = K;
                o[Y + (p + 4) >> 2] = K | 1;
                o[Y + O >> 2] = K;
                o[C + 4 >> 2] = p | 3;
              } else {
                o[210] = 0;
                o[213] = 0;
                o[C + 4 >> 2] = O | 3;
                K = C + (O + 4) | 0;
                o[K >> 2] = o[K >> 2] | 1;
              }

              l = C + 8 | 0;
              return l | 0;
            }

            C = o[211] | 0;

            if (p >>> 0 < C >>> 0) {
              K = C - p | 0;
              o[211] = K;
              C = o[214] | 0;
              O = C;
              o[214] = O + p;
              o[O + (p + 4) >> 2] = K | 1;
              o[C + 4 >> 2] = p | 3;
              l = C + 8 | 0;
              return l | 0;
            }

            do {
              if ((o[200] | 0) == 0) {
                C = _e(8) | 0;

                if ((C - 1 & C | 0) == 0) {
                  o[202] = C;
                  o[201] = C;
                  o[203] = -1;
                  o[204] = 2097152;
                  o[205] = 0;
                  o[319] = 0;
                  o[200] = (tt(0) | 0) & -16 ^ 1431655768;
                  break;
                } else {
                  Ee();
                  return 0;
                }
              }
            } while (0);

            C = p + 48 | 0;
            K = o[202] | 0;
            O = p + 47 | 0;
            Y = K + O | 0;
            F = -K | 0;
            K = Y & F;

            if (K >>> 0 <= p >>> 0) {
              l = 0;
              return l | 0;
            }

            q = o[318] | 0;

            do {
              if ((q | 0) != 0) {
                z = o[316] | 0;
                N = z + K | 0;

                if (N >>> 0 <= z >>> 0 | N >>> 0 > q >>> 0) {
                  l = 0;
                } else {
                  break;
                }

                return l | 0;
              }
            } while (0);

            e: do {
              if ((o[319] & 4 | 0) == 0) {
                q = o[214] | 0;

                t: do {
                  if ((q | 0) == 0) {
                    V = 292;
                  } else {
                    N = q;
                    z = 1280;

                    while (1) {
                      H = z | 0;
                      U = o[H >> 2] | 0;

                      if (U >>> 0 <= N >>> 0) {
                        W = z + 4 | 0;

                        if ((U + (o[W >> 2] | 0) | 0) >>> 0 > N >>> 0) {
                          break;
                        }
                      }

                      U = o[z + 8 >> 2] | 0;

                      if ((U | 0) == 0) {
                        V = 292;
                        break t;
                      } else {
                        z = U;
                      }
                    }

                    if ((z | 0) == 0) {
                      V = 292;
                      break;
                    }

                    N = Y - (o[211] | 0) & F;

                    if (N >>> 0 >= 2147483647) {
                      G = 0;
                      break;
                    }

                    h = Ze(N | 0) | 0;
                    n = (h | 0) == ((o[H >> 2] | 0) + (o[W >> 2] | 0) | 0);
                    X = n ? h : -1;
                    Z = n ? N : 0;
                    J = h;
                    $ = N;
                    V = 301;
                  }
                } while (0);

                do {
                  if ((V | 0) == 292) {
                    q = Ze(0) | 0;

                    if ((q | 0) == -1) {
                      G = 0;
                      break;
                    }

                    a = q;
                    N = o[201] | 0;
                    h = N - 1 | 0;

                    if ((h & a | 0) == 0) {
                      Q = K;
                    } else {
                      Q = K - a + (h + a & -N) | 0;
                    }

                    N = o[316] | 0;
                    a = N + Q | 0;

                    if (!(Q >>> 0 > p >>> 0 & Q >>> 0 < 2147483647)) {
                      G = 0;
                      break;
                    }

                    h = o[318] | 0;

                    if ((h | 0) != 0) {
                      if (a >>> 0 <= N >>> 0 | a >>> 0 > h >>> 0) {
                        G = 0;
                        break;
                      }
                    }

                    h = Ze(Q | 0) | 0;
                    a = (h | 0) == (q | 0);
                    X = a ? q : -1;
                    Z = a ? Q : 0;
                    J = h;
                    $ = Q;
                    V = 301;
                  }
                } while (0);

                t: do {
                  if ((V | 0) == 301) {
                    h = -$ | 0;

                    if ((X | 0) != -1) {
                      ee = Z;
                      te = X;
                      V = 312;
                      break e;
                    }

                    do {
                      if ((J | 0) != -1 & $ >>> 0 < 2147483647 & $ >>> 0 < C >>> 0) {
                        a = o[202] | 0;
                        q = O - $ + a & -a;

                        if (q >>> 0 >= 2147483647) {
                          re = $;
                          break;
                        }

                        if ((Ze(q | 0) | 0) == -1) {
                          Ze(h | 0) | 0;
                          G = Z;
                          break t;
                        } else {
                          re = q + $ | 0;
                          break;
                        }
                      } else {
                        re = $;
                      }
                    } while (0);

                    if ((J | 0) == -1) {
                      G = Z;
                    } else {
                      ee = re;
                      te = J;
                      V = 312;
                      break e;
                    }
                  }
                } while (0);

                o[319] = o[319] | 4;
                ne = G;
                V = 309;
              } else {
                ne = 0;
                V = 309;
              }
            } while (0);

            do {
              if ((V | 0) == 309) {
                if (K >>> 0 >= 2147483647) {
                  break;
                }

                G = Ze(K | 0) | 0;
                J = Ze(0) | 0;

                if (!((J | 0) != -1 & (G | 0) != -1 & G >>> 0 < J >>> 0)) {
                  break;
                }

                re = J - G | 0;
                J = re >>> 0 > (p + 40 | 0) >>> 0;
                Z = J ? G : -1;

                if ((Z | 0) != -1) {
                  ee = J ? re : ne;
                  te = Z;
                  V = 312;
                }
              }
            } while (0);

            do {
              if ((V | 0) == 312) {
                ne = (o[316] | 0) + ee | 0;
                o[316] = ne;

                if (ne >>> 0 > (o[317] | 0) >>> 0) {
                  o[317] = ne;
                }

                ne = o[214] | 0;

                e: do {
                  if ((ne | 0) == 0) {
                    K = o[212] | 0;

                    if ((K | 0) == 0 | te >>> 0 < K >>> 0) {
                      o[212] = te;
                    }

                    o[320] = te;
                    o[321] = ee;
                    o[323] = 0;
                    o[217] = o[200];
                    o[216] = -1;
                    K = 0;

                    do {
                      Z = K << 1;
                      re = 872 + (Z << 2) | 0;
                      o[872 + (Z + 3 << 2) >> 2] = re;
                      o[872 + (Z + 2 << 2) >> 2] = re;
                      K = K + 1 | 0;
                    } while (K >>> 0 < 32);

                    K = te + 8 | 0;

                    if ((K & 7 | 0) == 0) {
                      ie = 0;
                    } else {
                      ie = -K & 7;
                    }

                    K = ee - 40 - ie | 0;
                    o[214] = te + ie;
                    o[211] = K;
                    o[te + (ie + 4) >> 2] = K | 1;
                    o[te + (ee - 36) >> 2] = 40;
                    o[215] = o[204];
                  } else {
                    K = 1280;

                    while (1) {
                      oe = o[K >> 2] | 0;
                      ae = K + 4 | 0;
                      se = o[ae >> 2] | 0;

                      if ((te | 0) == (oe + se | 0)) {
                        V = 324;
                        break;
                      }

                      re = o[K + 8 >> 2] | 0;

                      if ((re | 0) == 0) {
                        break;
                      } else {
                        K = re;
                      }
                    }

                    do {
                      if ((V | 0) == 324) {
                        if ((o[K + 12 >> 2] & 8 | 0) != 0) {
                          break;
                        }

                        re = ne;

                        if (!(re >>> 0 >= oe >>> 0 & re >>> 0 < te >>> 0)) {
                          break;
                        }

                        o[ae >> 2] = se + ee;
                        re = o[214] | 0;
                        Z = (o[211] | 0) + ee | 0;
                        J = re;
                        G = re + 8 | 0;

                        if ((G & 7 | 0) == 0) {
                          fe = 0;
                        } else {
                          fe = -G & 7;
                        }

                        G = Z - fe | 0;
                        o[214] = J + fe;
                        o[211] = G;
                        o[J + (fe + 4) >> 2] = G | 1;
                        o[J + (Z + 4) >> 2] = 40;
                        o[215] = o[204];
                        break e;
                      }
                    } while (0);

                    if (te >>> 0 < (o[212] | 0) >>> 0) {
                      o[212] = te;
                    }

                    K = te + ee | 0;
                    Z = 1280;

                    while (1) {
                      ce = Z | 0;

                      if ((o[ce >> 2] | 0) == (K | 0)) {
                        V = 334;
                        break;
                      }

                      J = o[Z + 8 >> 2] | 0;

                      if ((J | 0) == 0) {
                        break;
                      } else {
                        Z = J;
                      }
                    }

                    do {
                      if ((V | 0) == 334) {
                        if ((o[Z + 12 >> 2] & 8 | 0) != 0) {
                          break;
                        }

                        o[ce >> 2] = te;
                        K = Z + 4 | 0;
                        o[K >> 2] = (o[K >> 2] | 0) + ee;
                        K = te + 8 | 0;

                        if ((K & 7 | 0) == 0) {
                          ue = 0;
                        } else {
                          ue = -K & 7;
                        }

                        K = te + (ee + 8) | 0;

                        if ((K & 7 | 0) == 0) {
                          de = 0;
                        } else {
                          de = -K & 7;
                        }

                        K = te + (de + ee) | 0;
                        J = K;
                        G = ue + p | 0;
                        re = te + G | 0;
                        $ = re;
                        O = K - (te + ue) - p | 0;
                        o[te + (ue + 4) >> 2] = p | 3;

                        do {
                          if ((J | 0) == (o[214] | 0)) {
                            C = (o[211] | 0) + O | 0;
                            o[211] = C;
                            o[214] = $;
                            o[te + (G + 4) >> 2] = C | 1;
                          } else {
                            if ((J | 0) == (o[213] | 0)) {
                              C = (o[210] | 0) + O | 0;
                              o[210] = C;
                              o[213] = $;
                              o[te + (G + 4) >> 2] = C | 1;
                              o[te + (C + G) >> 2] = C;
                              break;
                            }

                            C = ee + 4 | 0;
                            X = o[te + (C + de) >> 2] | 0;

                            if ((X & 3 | 0) == 1) {
                              Q = X & -8;
                              W = X >>> 3;

                              t: do {
                                if (X >>> 0 < 256) {
                                  H = o[te + ((de | 8) + ee) >> 2] | 0;
                                  F = o[te + (ee + 12 + de) >> 2] | 0;
                                  Y = 872 + (W << 1 << 2) | 0;

                                  do {
                                    if ((H | 0) != (Y | 0)) {
                                      if (H >>> 0 < (o[212] | 0) >>> 0) {
                                        Ee();
                                        return 0;
                                      }

                                      if ((o[H + 12 >> 2] | 0) == (J | 0)) {
                                        break;
                                      }

                                      Ee();
                                      return 0;
                                    }
                                  } while (0);

                                  if ((F | 0) == (H | 0)) {
                                    o[208] = o[208] & ~(1 << W);
                                    break;
                                  }

                                  do {
                                    if ((F | 0) == (Y | 0)) {
                                      he = F + 8 | 0;
                                    } else {
                                      if (F >>> 0 < (o[212] | 0) >>> 0) {
                                        Ee();
                                        return 0;
                                      }

                                      h = F + 8 | 0;

                                      if ((o[h >> 2] | 0) == (J | 0)) {
                                        he = h;
                                        break;
                                      }

                                      Ee();
                                      return 0;
                                    }
                                  } while (0);

                                  o[H + 12 >> 2] = F;
                                  o[he >> 2] = H;
                                } else {
                                  Y = K;
                                  h = o[te + ((de | 24) + ee) >> 2] | 0;
                                  z = o[te + (ee + 12 + de) >> 2] | 0;

                                  do {
                                    if ((z | 0) == (Y | 0)) {
                                      q = de | 16;
                                      a = te + (C + q) | 0;
                                      N = o[a >> 2] | 0;

                                      if ((N | 0) == 0) {
                                        n = te + (q + ee) | 0;
                                        q = o[n >> 2] | 0;

                                        if ((q | 0) == 0) {
                                          le = 0;
                                          break;
                                        } else {
                                          pe = q;
                                          be = n;
                                        }
                                      } else {
                                        pe = N;
                                        be = a;
                                      }

                                      while (1) {
                                        a = pe + 20 | 0;
                                        N = o[a >> 2] | 0;

                                        if ((N | 0) != 0) {
                                          pe = N;
                                          be = a;
                                          continue;
                                        }

                                        a = pe + 16 | 0;
                                        N = o[a >> 2] | 0;

                                        if ((N | 0) == 0) {
                                          break;
                                        } else {
                                          pe = N;
                                          be = a;
                                        }
                                      }

                                      if (be >>> 0 < (o[212] | 0) >>> 0) {
                                        Ee();
                                        return 0;
                                      } else {
                                        o[be >> 2] = 0;
                                        le = pe;
                                        break;
                                      }
                                    } else {
                                      a = o[te + ((de | 8) + ee) >> 2] | 0;

                                      if (a >>> 0 < (o[212] | 0) >>> 0) {
                                        Ee();
                                        return 0;
                                      }

                                      N = a + 12 | 0;

                                      if ((o[N >> 2] | 0) != (Y | 0)) {
                                        Ee();
                                        return 0;
                                      }

                                      n = z + 8 | 0;

                                      if ((o[n >> 2] | 0) == (Y | 0)) {
                                        o[N >> 2] = z;
                                        o[n >> 2] = a;
                                        le = z;
                                        break;
                                      } else {
                                        Ee();
                                        return 0;
                                      }
                                    }
                                  } while (0);

                                  if ((h | 0) == 0) {
                                    break;
                                  }

                                  z = te + (ee + 28 + de) | 0;
                                  H = 1136 + (o[z >> 2] << 2) | 0;

                                  do {
                                    if ((Y | 0) == (o[H >> 2] | 0)) {
                                      o[H >> 2] = le;

                                      if ((le | 0) != 0) {
                                        break;
                                      }

                                      o[209] = o[209] & ~(1 << o[z >> 2]);
                                      break t;
                                    } else {
                                      if (h >>> 0 < (o[212] | 0) >>> 0) {
                                        Ee();
                                        return 0;
                                      }

                                      F = h + 16 | 0;

                                      if ((o[F >> 2] | 0) == (Y | 0)) {
                                        o[F >> 2] = le;
                                      } else {
                                        o[h + 20 >> 2] = le;
                                      }

                                      if ((le | 0) == 0) {
                                        break t;
                                      }
                                    }
                                  } while (0);

                                  if (le >>> 0 < (o[212] | 0) >>> 0) {
                                    Ee();
                                    return 0;
                                  }

                                  o[le + 24 >> 2] = h;
                                  Y = de | 16;
                                  z = o[te + (Y + ee) >> 2] | 0;

                                  do {
                                    if ((z | 0) != 0) {
                                      if (z >>> 0 < (o[212] | 0) >>> 0) {
                                        Ee();
                                        return 0;
                                      } else {
                                        o[le + 16 >> 2] = z;
                                        o[z + 24 >> 2] = le;
                                        break;
                                      }
                                    }
                                  } while (0);

                                  z = o[te + (C + Y) >> 2] | 0;

                                  if ((z | 0) == 0) {
                                    break;
                                  }

                                  if (z >>> 0 < (o[212] | 0) >>> 0) {
                                    Ee();
                                    return 0;
                                  } else {
                                    o[le + 20 >> 2] = z;
                                    o[z + 24 >> 2] = le;
                                    break;
                                  }
                                }
                              } while (0);

                              me = te + ((Q | de) + ee) | 0;
                              ye = Q + O | 0;
                            } else {
                              me = J;
                              ye = O;
                            }

                            C = me + 4 | 0;
                            o[C >> 2] = o[C >> 2] & -2;
                            o[te + (G + 4) >> 2] = ye | 1;
                            o[te + (ye + G) >> 2] = ye;
                            C = ye >>> 3;

                            if (ye >>> 0 < 256) {
                              W = C << 1;
                              X = 872 + (W << 2) | 0;
                              z = o[208] | 0;
                              h = 1 << C;

                              do {
                                if ((z & h | 0) == 0) {
                                  o[208] = z | h;
                                  ve = X;
                                  ge = 872 + (W + 2 << 2) | 0;
                                } else {
                                  C = 872 + (W + 2 << 2) | 0;
                                  H = o[C >> 2] | 0;

                                  if (H >>> 0 >= (o[212] | 0) >>> 0) {
                                    ve = H;
                                    ge = C;
                                    break;
                                  }

                                  Ee();
                                  return 0;
                                }
                              } while (0);

                              o[ge >> 2] = $;
                              o[ve + 12 >> 2] = $;
                              o[te + (G + 8) >> 2] = ve;
                              o[te + (G + 12) >> 2] = X;
                              break;
                            }

                            W = re;
                            h = ye >>> 8;

                            do {
                              if ((h | 0) == 0) {
                                we = 0;
                              } else {
                                if (ye >>> 0 > 16777215) {
                                  we = 31;
                                  break;
                                }

                                z = (h + 1048320 | 0) >>> 16 & 8;
                                Q = h << z;
                                C = (Q + 520192 | 0) >>> 16 & 4;
                                H = Q << C;
                                Q = (H + 245760 | 0) >>> 16 & 2;
                                F = 14 - (C | z | Q) + (H << Q >>> 15) | 0;
                                we = ye >>> ((F + 7 | 0) >>> 0) & 1 | F << 1;
                              }
                            } while (0);

                            h = 1136 + (we << 2) | 0;
                            o[te + (G + 28) >> 2] = we;
                            o[te + (G + 20) >> 2] = 0;
                            o[te + (G + 16) >> 2] = 0;
                            X = o[209] | 0;
                            F = 1 << we;

                            if ((X & F | 0) == 0) {
                              o[209] = X | F;
                              o[h >> 2] = W;
                              o[te + (G + 24) >> 2] = h;
                              o[te + (G + 12) >> 2] = W;
                              o[te + (G + 8) >> 2] = W;
                              break;
                            }

                            if ((we | 0) == 31) {
                              ke = 0;
                            } else {
                              ke = 25 - (we >>> 1) | 0;
                            }

                            F = ye << ke;
                            X = o[h >> 2] | 0;

                            while (1) {
                              if ((o[X + 4 >> 2] & -8 | 0) == (ye | 0)) {
                                break;
                              }

                              Ae = X + 16 + (F >>> 31 << 2) | 0;
                              h = o[Ae >> 2] | 0;

                              if ((h | 0) == 0) {
                                V = 407;
                                break;
                              } else {
                                F = F << 1;
                                X = h;
                              }
                            }

                            if ((V | 0) == 407) {
                              if (Ae >>> 0 < (o[212] | 0) >>> 0) {
                                Ee();
                                return 0;
                              } else {
                                o[Ae >> 2] = W;
                                o[te + (G + 24) >> 2] = X;
                                o[te + (G + 12) >> 2] = W;
                                o[te + (G + 8) >> 2] = W;
                                break;
                              }
                            }

                            F = X + 8 | 0;
                            h = o[F >> 2] | 0;
                            Q = o[212] | 0;

                            if (X >>> 0 < Q >>> 0) {
                              Ee();
                              return 0;
                            }

                            if (h >>> 0 < Q >>> 0) {
                              Ee();
                              return 0;
                            } else {
                              o[h + 12 >> 2] = W;
                              o[F >> 2] = W;
                              o[te + (G + 8) >> 2] = h;
                              o[te + (G + 12) >> 2] = X;
                              o[te + (G + 24) >> 2] = 0;
                              break;
                            }
                          }
                        } while (0);

                        l = te + (ue | 8) | 0;
                        return l | 0;
                      }
                    } while (0);

                    Z = ne;
                    G = 1280;

                    while (1) {
                      Se = o[G >> 2] | 0;

                      if (Se >>> 0 <= Z >>> 0) {
                        Me = o[G + 4 >> 2] | 0;
                        xe = Se + Me | 0;

                        if (xe >>> 0 > Z >>> 0) {
                          break;
                        }
                      }

                      G = o[G + 8 >> 2] | 0;
                    }

                    G = Se + (Me - 39) | 0;

                    if ((G & 7 | 0) == 0) {
                      Ie = 0;
                    } else {
                      Ie = -G & 7;
                    }

                    G = Se + (Me - 47 + Ie) | 0;
                    re = G >>> 0 < (ne + 16 | 0) >>> 0 ? Z : G;
                    G = re + 8 | 0;
                    $ = te + 8 | 0;

                    if (($ & 7 | 0) == 0) {
                      je = 0;
                    } else {
                      je = -$ & 7;
                    }

                    $ = ee - 40 - je | 0;
                    o[214] = te + je;
                    o[211] = $;
                    o[te + (je + 4) >> 2] = $ | 1;
                    o[te + (ee - 36) >> 2] = 40;
                    o[215] = o[204];
                    o[re + 4 >> 2] = 27;
                    o[G >> 2] = o[320];
                    o[G + 4 >> 2] = o[1284 >> 2];
                    o[G + 8 >> 2] = o[1288 >> 2];
                    o[G + 12 >> 2] = o[1292 >> 2];
                    o[320] = te;
                    o[321] = ee;
                    o[323] = 0;
                    o[322] = G;
                    G = re + 28 | 0;
                    o[G >> 2] = 7;

                    if ((re + 32 | 0) >>> 0 < xe >>> 0) {
                      $ = G;

                      while (1) {
                        G = $ + 4 | 0;
                        o[G >> 2] = 7;

                        if (($ + 8 | 0) >>> 0 < xe >>> 0) {
                          $ = G;
                        } else {
                          break;
                        }
                      }
                    }

                    if ((re | 0) == (Z | 0)) {
                      break;
                    }

                    $ = re - ne | 0;
                    G = Z + ($ + 4) | 0;
                    o[G >> 2] = o[G >> 2] & -2;
                    o[ne + 4 >> 2] = $ | 1;
                    o[Z + $ >> 2] = $;
                    G = $ >>> 3;

                    if ($ >>> 0 < 256) {
                      O = G << 1;
                      J = 872 + (O << 2) | 0;
                      K = o[208] | 0;
                      h = 1 << G;

                      do {
                        if ((K & h | 0) == 0) {
                          o[208] = K | h;
                          Be = J;
                          Re = 872 + (O + 2 << 2) | 0;
                        } else {
                          G = 872 + (O + 2 << 2) | 0;
                          F = o[G >> 2] | 0;

                          if (F >>> 0 >= (o[212] | 0) >>> 0) {
                            Be = F;
                            Re = G;
                            break;
                          }

                          Ee();
                          return 0;
                        }
                      } while (0);

                      o[Re >> 2] = ne;
                      o[Be + 12 >> 2] = ne;
                      o[ne + 8 >> 2] = Be;
                      o[ne + 12 >> 2] = J;
                      break;
                    }

                    O = ne;
                    h = $ >>> 8;

                    do {
                      if ((h | 0) == 0) {
                        Pe = 0;
                      } else {
                        if ($ >>> 0 > 16777215) {
                          Pe = 31;
                          break;
                        }

                        K = (h + 1048320 | 0) >>> 16 & 8;
                        Z = h << K;
                        re = (Z + 520192 | 0) >>> 16 & 4;
                        G = Z << re;
                        Z = (G + 245760 | 0) >>> 16 & 2;
                        F = 14 - (re | K | Z) + (G << Z >>> 15) | 0;
                        Pe = $ >>> ((F + 7 | 0) >>> 0) & 1 | F << 1;
                      }
                    } while (0);

                    h = 1136 + (Pe << 2) | 0;
                    o[ne + 28 >> 2] = Pe;
                    o[ne + 20 >> 2] = 0;
                    o[ne + 16 >> 2] = 0;
                    J = o[209] | 0;
                    F = 1 << Pe;

                    if ((J & F | 0) == 0) {
                      o[209] = J | F;
                      o[h >> 2] = O;
                      o[ne + 24 >> 2] = h;
                      o[ne + 12 >> 2] = ne;
                      o[ne + 8 >> 2] = ne;
                      break;
                    }

                    if ((Pe | 0) == 31) {
                      Te = 0;
                    } else {
                      Te = 25 - (Pe >>> 1) | 0;
                    }

                    F = $ << Te;
                    J = o[h >> 2] | 0;

                    while (1) {
                      if ((o[J + 4 >> 2] & -8 | 0) == ($ | 0)) {
                        break;
                      }

                      Le = J + 16 + (F >>> 31 << 2) | 0;
                      h = o[Le >> 2] | 0;

                      if ((h | 0) == 0) {
                        V = 442;
                        break;
                      } else {
                        F = F << 1;
                        J = h;
                      }
                    }

                    if ((V | 0) == 442) {
                      if (Le >>> 0 < (o[212] | 0) >>> 0) {
                        Ee();
                        return 0;
                      } else {
                        o[Le >> 2] = O;
                        o[ne + 24 >> 2] = J;
                        o[ne + 12 >> 2] = ne;
                        o[ne + 8 >> 2] = ne;
                        break;
                      }
                    }

                    F = J + 8 | 0;
                    $ = o[F >> 2] | 0;
                    h = o[212] | 0;

                    if (J >>> 0 < h >>> 0) {
                      Ee();
                      return 0;
                    }

                    if ($ >>> 0 < h >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[$ + 12 >> 2] = O;
                      o[F >> 2] = O;
                      o[ne + 8 >> 2] = $;
                      o[ne + 12 >> 2] = J;
                      o[ne + 24 >> 2] = 0;
                      break;
                    }
                  }
                } while (0);

                ne = o[211] | 0;

                if (ne >>> 0 <= p >>> 0) {
                  break;
                }

                $ = ne - p | 0;
                o[211] = $;
                ne = o[214] | 0;
                F = ne;
                o[214] = F + p;
                o[F + (p + 4) >> 2] = $ | 1;
                o[ne + 4 >> 2] = p | 3;
                l = ne + 8 | 0;
                return l | 0;
              }
            } while (0);

            o[($e() | 0) >> 2] = 12;
            l = 0;
            return l | 0;
          }

          function Vt(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0,
                x = 0,
                I = 0,
                j = 0,
                B = 0,
                R = 0,
                P = 0,
                T = 0,
                L = 0,
                C = 0,
                O = 0,
                N = 0,
                U = 0,
                D = 0,
                q = 0;

            if ((e | 0) == 0) {
              return;
            }

            t = e - 8 | 0;
            r = t;
            n = o[212] | 0;

            if (t >>> 0 < n >>> 0) {
              Ee();
            }

            i = o[e - 4 >> 2] | 0;
            a = i & 3;

            if ((a | 0) == 1) {
              Ee();
            }

            s = i & -8;
            f = e + (s - 8) | 0;
            c = f;

            e: do {
              if ((i & 1 | 0) == 0) {
                u = o[t >> 2] | 0;

                if ((a | 0) == 0) {
                  return;
                }

                d = -8 - u | 0;
                h = e + d | 0;
                l = h;
                p = u + s | 0;

                if (h >>> 0 < n >>> 0) {
                  Ee();
                }

                if ((l | 0) == (o[213] | 0)) {
                  b = e + (s - 4) | 0;

                  if ((o[b >> 2] & 3 | 0) != 3) {
                    m = l;
                    y = p;
                    break;
                  }

                  o[210] = p;
                  o[b >> 2] = o[b >> 2] & -2;
                  o[e + (d + 4) >> 2] = p | 1;
                  o[f >> 2] = p;
                  return;
                }

                b = u >>> 3;

                if (u >>> 0 < 256) {
                  u = o[e + (d + 8) >> 2] | 0;
                  v = o[e + (d + 12) >> 2] | 0;
                  g = 872 + (b << 1 << 2) | 0;

                  do {
                    if ((u | 0) != (g | 0)) {
                      if (u >>> 0 < n >>> 0) {
                        Ee();
                      }

                      if ((o[u + 12 >> 2] | 0) == (l | 0)) {
                        break;
                      }

                      Ee();
                    }
                  } while (0);

                  if ((v | 0) == (u | 0)) {
                    o[208] = o[208] & ~(1 << b);
                    m = l;
                    y = p;
                    break;
                  }

                  do {
                    if ((v | 0) == (g | 0)) {
                      _ = v + 8 | 0;
                    } else {
                      if (v >>> 0 < n >>> 0) {
                        Ee();
                      }

                      w = v + 8 | 0;

                      if ((o[w >> 2] | 0) == (l | 0)) {
                        _ = w;
                        break;
                      }

                      Ee();
                    }
                  } while (0);

                  o[u + 12 >> 2] = v;
                  o[_ >> 2] = u;
                  m = l;
                  y = p;
                  break;
                }

                g = h;
                b = o[e + (d + 24) >> 2] | 0;
                w = o[e + (d + 12) >> 2] | 0;

                do {
                  if ((w | 0) == (g | 0)) {
                    k = e + (d + 20) | 0;
                    E = o[k >> 2] | 0;

                    if ((E | 0) == 0) {
                      A = e + (d + 16) | 0;
                      S = o[A >> 2] | 0;

                      if ((S | 0) == 0) {
                        M = 0;
                        break;
                      } else {
                        x = S;
                        I = A;
                      }
                    } else {
                      x = E;
                      I = k;
                    }

                    while (1) {
                      k = x + 20 | 0;
                      E = o[k >> 2] | 0;

                      if ((E | 0) != 0) {
                        x = E;
                        I = k;
                        continue;
                      }

                      k = x + 16 | 0;
                      E = o[k >> 2] | 0;

                      if ((E | 0) == 0) {
                        break;
                      } else {
                        x = E;
                        I = k;
                      }
                    }

                    if (I >>> 0 < n >>> 0) {
                      Ee();
                    } else {
                      o[I >> 2] = 0;
                      M = x;
                      break;
                    }
                  } else {
                    k = o[e + (d + 8) >> 2] | 0;

                    if (k >>> 0 < n >>> 0) {
                      Ee();
                    }

                    E = k + 12 | 0;

                    if ((o[E >> 2] | 0) != (g | 0)) {
                      Ee();
                    }

                    A = w + 8 | 0;

                    if ((o[A >> 2] | 0) == (g | 0)) {
                      o[E >> 2] = w;
                      o[A >> 2] = k;
                      M = w;
                      break;
                    } else {
                      Ee();
                    }
                  }
                } while (0);

                if ((b | 0) == 0) {
                  m = l;
                  y = p;
                  break;
                }

                w = e + (d + 28) | 0;
                h = 1136 + (o[w >> 2] << 2) | 0;

                do {
                  if ((g | 0) == (o[h >> 2] | 0)) {
                    o[h >> 2] = M;

                    if ((M | 0) != 0) {
                      break;
                    }

                    o[209] = o[209] & ~(1 << o[w >> 2]);
                    m = l;
                    y = p;
                    break e;
                  } else {
                    if (b >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    }

                    u = b + 16 | 0;

                    if ((o[u >> 2] | 0) == (g | 0)) {
                      o[u >> 2] = M;
                    } else {
                      o[b + 20 >> 2] = M;
                    }

                    if ((M | 0) == 0) {
                      m = l;
                      y = p;
                      break e;
                    }
                  }
                } while (0);

                if (M >>> 0 < (o[212] | 0) >>> 0) {
                  Ee();
                }

                o[M + 24 >> 2] = b;
                g = o[e + (d + 16) >> 2] | 0;

                do {
                  if ((g | 0) != 0) {
                    if (g >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    } else {
                      o[M + 16 >> 2] = g;
                      o[g + 24 >> 2] = M;
                      break;
                    }
                  }
                } while (0);

                g = o[e + (d + 20) >> 2] | 0;

                if ((g | 0) == 0) {
                  m = l;
                  y = p;
                  break;
                }

                if (g >>> 0 < (o[212] | 0) >>> 0) {
                  Ee();
                } else {
                  o[M + 20 >> 2] = g;
                  o[g + 24 >> 2] = M;
                  m = l;
                  y = p;
                  break;
                }
              } else {
                m = r;
                y = s;
              }
            } while (0);

            r = m;

            if (r >>> 0 >= f >>> 0) {
              Ee();
            }

            M = e + (s - 4) | 0;
            n = o[M >> 2] | 0;

            if ((n & 1 | 0) == 0) {
              Ee();
            }

            do {
              if ((n & 2 | 0) == 0) {
                if ((c | 0) == (o[214] | 0)) {
                  x = (o[211] | 0) + y | 0;
                  o[211] = x;
                  o[214] = m;
                  o[m + 4 >> 2] = x | 1;

                  if ((m | 0) == (o[213] | 0)) {
                    o[213] = 0;
                    o[210] = 0;
                  }

                  if (x >>> 0 <= (o[215] | 0) >>> 0) {
                    return;
                  }

                  Jt(0) | 0;
                  return;
                }

                if ((c | 0) == (o[213] | 0)) {
                  x = (o[210] | 0) + y | 0;
                  o[210] = x;
                  o[213] = m;
                  o[m + 4 >> 2] = x | 1;
                  o[r + x >> 2] = x;
                  return;
                }

                x = (n & -8) + y | 0;
                I = n >>> 3;

                e: do {
                  if (n >>> 0 < 256) {
                    _ = o[e + s >> 2] | 0;
                    a = o[e + (s | 4) >> 2] | 0;
                    t = 872 + (I << 1 << 2) | 0;

                    do {
                      if ((_ | 0) != (t | 0)) {
                        if (_ >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        }

                        if ((o[_ + 12 >> 2] | 0) == (c | 0)) {
                          break;
                        }

                        Ee();
                      }
                    } while (0);

                    if ((a | 0) == (_ | 0)) {
                      o[208] = o[208] & ~(1 << I);
                      break;
                    }

                    do {
                      if ((a | 0) == (t | 0)) {
                        j = a + 8 | 0;
                      } else {
                        if (a >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        }

                        i = a + 8 | 0;

                        if ((o[i >> 2] | 0) == (c | 0)) {
                          j = i;
                          break;
                        }

                        Ee();
                      }
                    } while (0);

                    o[_ + 12 >> 2] = a;
                    o[j >> 2] = _;
                  } else {
                    t = f;
                    i = o[e + (s + 16) >> 2] | 0;
                    g = o[e + (s | 4) >> 2] | 0;

                    do {
                      if ((g | 0) == (t | 0)) {
                        b = e + (s + 12) | 0;
                        w = o[b >> 2] | 0;

                        if ((w | 0) == 0) {
                          h = e + (s + 8) | 0;
                          u = o[h >> 2] | 0;

                          if ((u | 0) == 0) {
                            B = 0;
                            break;
                          } else {
                            R = u;
                            P = h;
                          }
                        } else {
                          R = w;
                          P = b;
                        }

                        while (1) {
                          b = R + 20 | 0;
                          w = o[b >> 2] | 0;

                          if ((w | 0) != 0) {
                            R = w;
                            P = b;
                            continue;
                          }

                          b = R + 16 | 0;
                          w = o[b >> 2] | 0;

                          if ((w | 0) == 0) {
                            break;
                          } else {
                            R = w;
                            P = b;
                          }
                        }

                        if (P >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        } else {
                          o[P >> 2] = 0;
                          B = R;
                          break;
                        }
                      } else {
                        b = o[e + s >> 2] | 0;

                        if (b >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        }

                        w = b + 12 | 0;

                        if ((o[w >> 2] | 0) != (t | 0)) {
                          Ee();
                        }

                        h = g + 8 | 0;

                        if ((o[h >> 2] | 0) == (t | 0)) {
                          o[w >> 2] = g;
                          o[h >> 2] = b;
                          B = g;
                          break;
                        } else {
                          Ee();
                        }
                      }
                    } while (0);

                    if ((i | 0) == 0) {
                      break;
                    }

                    g = e + (s + 20) | 0;
                    _ = 1136 + (o[g >> 2] << 2) | 0;

                    do {
                      if ((t | 0) == (o[_ >> 2] | 0)) {
                        o[_ >> 2] = B;

                        if ((B | 0) != 0) {
                          break;
                        }

                        o[209] = o[209] & ~(1 << o[g >> 2]);
                        break e;
                      } else {
                        if (i >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        }

                        a = i + 16 | 0;

                        if ((o[a >> 2] | 0) == (t | 0)) {
                          o[a >> 2] = B;
                        } else {
                          o[i + 20 >> 2] = B;
                        }

                        if ((B | 0) == 0) {
                          break e;
                        }
                      }
                    } while (0);

                    if (B >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    }

                    o[B + 24 >> 2] = i;
                    t = o[e + (s + 8) >> 2] | 0;

                    do {
                      if ((t | 0) != 0) {
                        if (t >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        } else {
                          o[B + 16 >> 2] = t;
                          o[t + 24 >> 2] = B;
                          break;
                        }
                      }
                    } while (0);

                    t = o[e + (s + 12) >> 2] | 0;

                    if ((t | 0) == 0) {
                      break;
                    }

                    if (t >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    } else {
                      o[B + 20 >> 2] = t;
                      o[t + 24 >> 2] = B;
                      break;
                    }
                  }
                } while (0);

                o[m + 4 >> 2] = x | 1;
                o[r + x >> 2] = x;

                if ((m | 0) != (o[213] | 0)) {
                  T = x;
                  break;
                }

                o[210] = x;
                return;
              } else {
                o[M >> 2] = n & -2;
                o[m + 4 >> 2] = y | 1;
                o[r + y >> 2] = y;
                T = y;
              }
            } while (0);

            y = T >>> 3;

            if (T >>> 0 < 256) {
              r = y << 1;
              n = 872 + (r << 2) | 0;
              M = o[208] | 0;
              B = 1 << y;

              do {
                if ((M & B | 0) == 0) {
                  o[208] = M | B;
                  L = n;
                  C = 872 + (r + 2 << 2) | 0;
                } else {
                  y = 872 + (r + 2 << 2) | 0;
                  s = o[y >> 2] | 0;

                  if (s >>> 0 >= (o[212] | 0) >>> 0) {
                    L = s;
                    C = y;
                    break;
                  }

                  Ee();
                }
              } while (0);

              o[C >> 2] = m;
              o[L + 12 >> 2] = m;
              o[m + 8 >> 2] = L;
              o[m + 12 >> 2] = n;
              return;
            }

            n = m;
            L = T >>> 8;

            do {
              if ((L | 0) == 0) {
                O = 0;
              } else {
                if (T >>> 0 > 16777215) {
                  O = 31;
                  break;
                }

                C = (L + 1048320 | 0) >>> 16 & 8;
                r = L << C;
                B = (r + 520192 | 0) >>> 16 & 4;
                M = r << B;
                r = (M + 245760 | 0) >>> 16 & 2;
                y = 14 - (B | C | r) + (M << r >>> 15) | 0;
                O = T >>> ((y + 7 | 0) >>> 0) & 1 | y << 1;
              }
            } while (0);

            L = 1136 + (O << 2) | 0;
            o[m + 28 >> 2] = O;
            o[m + 20 >> 2] = 0;
            o[m + 16 >> 2] = 0;
            y = o[209] | 0;
            r = 1 << O;

            do {
              if ((y & r | 0) == 0) {
                o[209] = y | r;
                o[L >> 2] = n;
                o[m + 24 >> 2] = L;
                o[m + 12 >> 2] = m;
                o[m + 8 >> 2] = m;
              } else {
                if ((O | 0) == 31) {
                  N = 0;
                } else {
                  N = 25 - (O >>> 1) | 0;
                }

                M = T << N;
                C = o[L >> 2] | 0;

                while (1) {
                  if ((o[C + 4 >> 2] & -8 | 0) == (T | 0)) {
                    break;
                  }

                  U = C + 16 + (M >>> 31 << 2) | 0;
                  B = o[U >> 2] | 0;

                  if ((B | 0) == 0) {
                    D = 621;
                    break;
                  } else {
                    M = M << 1;
                    C = B;
                  }
                }

                if ((D | 0) == 621) {
                  if (U >>> 0 < (o[212] | 0) >>> 0) {
                    Ee();
                  } else {
                    o[U >> 2] = n;
                    o[m + 24 >> 2] = C;
                    o[m + 12 >> 2] = m;
                    o[m + 8 >> 2] = m;
                    break;
                  }
                }

                M = C + 8 | 0;
                x = o[M >> 2] | 0;
                B = o[212] | 0;

                if (C >>> 0 < B >>> 0) {
                  Ee();
                }

                if (x >>> 0 < B >>> 0) {
                  Ee();
                } else {
                  o[x + 12 >> 2] = n;
                  o[M >> 2] = n;
                  o[m + 8 >> 2] = x;
                  o[m + 12 >> 2] = C;
                  o[m + 24 >> 2] = 0;
                  break;
                }
              }
            } while (0);

            m = (o[216] | 0) - 1 | 0;
            o[216] = m;

            if ((m | 0) == 0) {
              q = 1288;
            } else {
              return;
            }

            while (1) {
              m = o[q >> 2] | 0;

              if ((m | 0) == 0) {
                break;
              } else {
                q = m + 8 | 0;
              }
            }

            o[216] = -1;
            return;
          }

          function Ht(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0;

            do {
              if ((e | 0) == 0) {
                r = 0;
              } else {
                n = ae(t, e) | 0;

                if ((t | e) >>> 0 <= 65535) {
                  r = n;
                  break;
                }

                r = ((n >>> 0) / (e >>> 0) | 0 | 0) == (t | 0) ? n : -1;
              }
            } while (0);

            t = Kt(r) | 0;

            if ((t | 0) == 0) {
              return t | 0;
            }

            if ((o[t - 4 >> 2] & 3 | 0) == 0) {
              return t | 0;
            }

            en(t | 0, 0, r | 0);
            return t | 0;
          }

          function Wt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0,
                a = 0;

            if ((e | 0) == 0) {
              r = Kt(t) | 0;
              return r | 0;
            }

            if (t >>> 0 > 4294967231) {
              o[($e() | 0) >> 2] = 12;
              r = 0;
              return r | 0;
            }

            if (t >>> 0 < 11) {
              n = 16;
            } else {
              n = t + 11 & -8;
            }

            i = $t(e - 8 | 0, n) | 0;

            if ((i | 0) != 0) {
              r = i + 8 | 0;
              return r | 0;
            }

            i = Kt(t) | 0;

            if ((i | 0) == 0) {
              r = 0;
              return r | 0;
            }

            n = o[e - 4 >> 2] | 0;
            a = (n & -8) - ((n & 3 | 0) == 0 ? 8 : 4) | 0;
            n = a >>> 0 < t >>> 0 ? a : t;
            Qr(i | 0, e | 0, n) | 0;
            Vt(e);
            r = i;
            return r | 0;
          }

          function Gt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0;

            if ((e | 0) == 0) {
              return 0;
            }

            if (t >>> 0 > 4294967231) {
              o[($e() | 0) >> 2] = 12;
              return 0;
            }

            if (t >>> 0 < 11) {
              r = 16;
            } else {
              r = t + 11 & -8;
            }

            t = e - 8 | 0;
            return (($t(t, r) | 0) == (t | 0) ? e : 0) | 0;
          }

          function Xt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0;

            if (e >>> 0 < 9) {
              r = Kt(t) | 0;
              return r | 0;
            } else {
              r = Zt(e, t) | 0;
              return r | 0;
            }

            return 0;
          }

          function Zt(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0;
            r = e >>> 0 < 16 ? 16 : e;

            if ((r - 1 & r | 0) == 0) {
              n = r;
            } else {
              e = 16;

              while (1) {
                if (e >>> 0 < r >>> 0) {
                  e = e << 1;
                } else {
                  n = e;
                  break;
                }
              }
            }

            if ((-64 - n | 0) >>> 0 <= t >>> 0) {
              o[($e() | 0) >> 2] = 12;
              i = 0;
              return i | 0;
            }

            if (t >>> 0 < 11) {
              a = 16;
            } else {
              a = t + 11 & -8;
            }

            t = Kt(n + 12 + a | 0) | 0;

            if ((t | 0) == 0) {
              i = 0;
              return i | 0;
            }

            e = t - 8 | 0;
            r = e;
            s = n - 1 | 0;

            do {
              if ((t & s | 0) == 0) {
                f = r;
              } else {
                c = t + s & -n;
                u = c - 8 | 0;
                d = e;

                if ((u - d | 0) >>> 0 > 15) {
                  h = u;
                } else {
                  h = c + (n - 8) | 0;
                }

                c = h;
                u = h - d | 0;
                d = t - 4 | 0;
                l = o[d >> 2] | 0;
                p = (l & -8) - u | 0;

                if ((l & 3 | 0) == 0) {
                  o[h >> 2] = (o[e >> 2] | 0) + u;
                  o[h + 4 >> 2] = p;
                  f = c;
                  break;
                } else {
                  l = h + 4 | 0;
                  o[l >> 2] = p | o[l >> 2] & 1 | 2;
                  l = h + (p + 4) | 0;
                  o[l >> 2] = o[l >> 2] | 1;
                  o[d >> 2] = u | o[d >> 2] & 1 | 2;
                  d = t + (u - 4) | 0;
                  o[d >> 2] = o[d >> 2] | 1;
                  mr(r, u);
                  f = c;
                  break;
                }
              }
            } while (0);

            r = f + 4 | 0;
            t = o[r >> 2] | 0;

            do {
              if ((t & 3 | 0) != 0) {
                h = t & -8;

                if (h >>> 0 <= (a + 16 | 0) >>> 0) {
                  break;
                }

                e = h - a | 0;
                n = f;
                o[r >> 2] = a | t & 1 | 2;
                o[n + (a | 4) >> 2] = e | 3;
                s = n + (h | 4) | 0;
                o[s >> 2] = o[s >> 2] | 1;
                mr(n + a | 0, e);
              }
            } while (0);

            i = f + 8 | 0;
            return i | 0;
          }

          function Jt(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0;

            do {
              if ((o[200] | 0) == 0) {
                t = _e(8) | 0;

                if ((t - 1 & t | 0) == 0) {
                  o[202] = t;
                  o[201] = t;
                  o[203] = -1;
                  o[204] = 2097152;
                  o[205] = 0;
                  o[319] = 0;
                  o[200] = (tt(0) | 0) & -16 ^ 1431655768;
                  break;
                } else {
                  Ee();
                  return 0;
                }
              }
            } while (0);

            if (e >>> 0 >= 4294967232) {
              r = 0;
              return r | 0;
            }

            t = o[214] | 0;

            if ((t | 0) == 0) {
              r = 0;
              return r | 0;
            }

            n = o[211] | 0;

            do {
              if (n >>> 0 > (e + 40 | 0) >>> 0) {
                i = o[202] | 0;
                a = ae((((-40 - e - 1 + n + i | 0) >>> 0) / (i >>> 0) | 0) - 1 | 0, i) | 0;
                s = t;
                f = 1280;

                while (1) {
                  c = o[f >> 2] | 0;

                  if (c >>> 0 <= s >>> 0) {
                    if ((c + (o[f + 4 >> 2] | 0) | 0) >>> 0 > s >>> 0) {
                      u = f;
                      break;
                    }
                  }

                  c = o[f + 8 >> 2] | 0;

                  if ((c | 0) == 0) {
                    u = 0;
                    break;
                  } else {
                    f = c;
                  }
                }

                if ((o[u + 12 >> 2] & 8 | 0) != 0) {
                  break;
                }

                f = Ze(0) | 0;
                s = u + 4 | 0;

                if ((f | 0) != ((o[u >> 2] | 0) + (o[s >> 2] | 0) | 0)) {
                  break;
                }

                c = Ze(-(a >>> 0 > 2147483646 ? -2147483648 - i | 0 : a) | 0) | 0;
                d = Ze(0) | 0;

                if (!((c | 0) != -1 & d >>> 0 < f >>> 0)) {
                  break;
                }

                c = f - d | 0;

                if ((f | 0) == (d | 0)) {
                  break;
                }

                o[s >> 2] = (o[s >> 2] | 0) - c;
                o[316] = (o[316] | 0) - c;
                s = o[214] | 0;
                h = (o[211] | 0) - c | 0;
                c = s;
                l = s + 8 | 0;

                if ((l & 7 | 0) == 0) {
                  p = 0;
                } else {
                  p = -l & 7;
                }

                l = h - p | 0;
                o[214] = c + p;
                o[211] = l;
                o[c + (p + 4) >> 2] = l | 1;
                o[c + (h + 4) >> 2] = 40;
                o[215] = o[204];
                r = (f | 0) != (d | 0) | 0;
                return r | 0;
              }
            } while (0);

            if ((o[211] | 0) >>> 0 <= (o[215] | 0) >>> 0) {
              r = 0;
              return r | 0;
            }

            o[215] = -1;
            r = 0;
            return r | 0;
          }

          function $t(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0;
            r = e + 4 | 0;
            n = o[r >> 2] | 0;
            i = n & -8;
            a = e;
            s = a + i | 0;
            f = s;
            c = o[212] | 0;

            if (a >>> 0 < c >>> 0) {
              Ee();
              return 0;
            }

            u = n & 3;

            if (!((u | 0) != 1 & a >>> 0 < s >>> 0)) {
              Ee();
              return 0;
            }

            d = a + (i | 4) | 0;
            h = o[d >> 2] | 0;

            if ((h & 1 | 0) == 0) {
              Ee();
              return 0;
            }

            if ((u | 0) == 0) {
              if (t >>> 0 < 256) {
                l = 0;
                return l | 0;
              }

              do {
                if (i >>> 0 >= (t + 4 | 0) >>> 0) {
                  if ((i - t | 0) >>> 0 > o[202] << 1 >>> 0) {
                    break;
                  } else {
                    l = e;
                  }

                  return l | 0;
                }
              } while (0);

              l = 0;
              return l | 0;
            }

            if (i >>> 0 >= t >>> 0) {
              u = i - t | 0;

              if (u >>> 0 <= 15) {
                l = e;
                return l | 0;
              }

              o[r >> 2] = n & 1 | t | 2;
              o[a + (t + 4) >> 2] = u | 3;
              o[d >> 2] = o[d >> 2] | 1;
              mr(a + t | 0, u);
              l = e;
              return l | 0;
            }

            if ((f | 0) == (o[214] | 0)) {
              u = (o[211] | 0) + i | 0;

              if (u >>> 0 <= t >>> 0) {
                l = 0;
                return l | 0;
              }

              d = u - t | 0;
              o[r >> 2] = n & 1 | t | 2;
              o[a + (t + 4) >> 2] = d | 1;
              o[214] = a + t;
              o[211] = d;
              l = e;
              return l | 0;
            }

            if ((f | 0) == (o[213] | 0)) {
              d = (o[210] | 0) + i | 0;

              if (d >>> 0 < t >>> 0) {
                l = 0;
                return l | 0;
              }

              u = d - t | 0;

              if (u >>> 0 > 15) {
                o[r >> 2] = n & 1 | t | 2;
                o[a + (t + 4) >> 2] = u | 1;
                o[a + d >> 2] = u;
                p = a + (d + 4) | 0;
                o[p >> 2] = o[p >> 2] & -2;
                b = a + t | 0;
                m = u;
              } else {
                o[r >> 2] = n & 1 | d | 2;
                n = a + (d + 4) | 0;
                o[n >> 2] = o[n >> 2] | 1;
                b = 0;
                m = 0;
              }

              o[210] = m;
              o[213] = b;
              l = e;
              return l | 0;
            }

            if ((h & 2 | 0) != 0) {
              l = 0;
              return l | 0;
            }

            b = (h & -8) + i | 0;

            if (b >>> 0 < t >>> 0) {
              l = 0;
              return l | 0;
            }

            m = b - t | 0;
            n = h >>> 3;

            e: do {
              if (h >>> 0 < 256) {
                d = o[a + (i + 8) >> 2] | 0;
                u = o[a + (i + 12) >> 2] | 0;
                p = 872 + (n << 1 << 2) | 0;

                do {
                  if ((d | 0) != (p | 0)) {
                    if (d >>> 0 < c >>> 0) {
                      Ee();
                      return 0;
                    }

                    if ((o[d + 12 >> 2] | 0) == (f | 0)) {
                      break;
                    }

                    Ee();
                    return 0;
                  }
                } while (0);

                if ((u | 0) == (d | 0)) {
                  o[208] = o[208] & ~(1 << n);
                  break;
                }

                do {
                  if ((u | 0) == (p | 0)) {
                    y = u + 8 | 0;
                  } else {
                    if (u >>> 0 < c >>> 0) {
                      Ee();
                      return 0;
                    }

                    v = u + 8 | 0;

                    if ((o[v >> 2] | 0) == (f | 0)) {
                      y = v;
                      break;
                    }

                    Ee();
                    return 0;
                  }
                } while (0);

                o[d + 12 >> 2] = u;
                o[y >> 2] = d;
              } else {
                p = s;
                v = o[a + (i + 24) >> 2] | 0;
                g = o[a + (i + 12) >> 2] | 0;

                do {
                  if ((g | 0) == (p | 0)) {
                    _ = a + (i + 20) | 0;
                    w = o[_ >> 2] | 0;

                    if ((w | 0) == 0) {
                      k = a + (i + 16) | 0;
                      E = o[k >> 2] | 0;

                      if ((E | 0) == 0) {
                        A = 0;
                        break;
                      } else {
                        S = E;
                        M = k;
                      }
                    } else {
                      S = w;
                      M = _;
                    }

                    while (1) {
                      _ = S + 20 | 0;
                      w = o[_ >> 2] | 0;

                      if ((w | 0) != 0) {
                        S = w;
                        M = _;
                        continue;
                      }

                      _ = S + 16 | 0;
                      w = o[_ >> 2] | 0;

                      if ((w | 0) == 0) {
                        break;
                      } else {
                        S = w;
                        M = _;
                      }
                    }

                    if (M >>> 0 < c >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[M >> 2] = 0;
                      A = S;
                      break;
                    }
                  } else {
                    _ = o[a + (i + 8) >> 2] | 0;

                    if (_ >>> 0 < c >>> 0) {
                      Ee();
                      return 0;
                    }

                    w = _ + 12 | 0;

                    if ((o[w >> 2] | 0) != (p | 0)) {
                      Ee();
                      return 0;
                    }

                    k = g + 8 | 0;

                    if ((o[k >> 2] | 0) == (p | 0)) {
                      o[w >> 2] = g;
                      o[k >> 2] = _;
                      A = g;
                      break;
                    } else {
                      Ee();
                      return 0;
                    }
                  }
                } while (0);

                if ((v | 0) == 0) {
                  break;
                }

                g = a + (i + 28) | 0;
                d = 1136 + (o[g >> 2] << 2) | 0;

                do {
                  if ((p | 0) == (o[d >> 2] | 0)) {
                    o[d >> 2] = A;

                    if ((A | 0) != 0) {
                      break;
                    }

                    o[209] = o[209] & ~(1 << o[g >> 2]);
                    break e;
                  } else {
                    if (v >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                      return 0;
                    }

                    u = v + 16 | 0;

                    if ((o[u >> 2] | 0) == (p | 0)) {
                      o[u >> 2] = A;
                    } else {
                      o[v + 20 >> 2] = A;
                    }

                    if ((A | 0) == 0) {
                      break e;
                    }
                  }
                } while (0);

                if (A >>> 0 < (o[212] | 0) >>> 0) {
                  Ee();
                  return 0;
                }

                o[A + 24 >> 2] = v;
                p = o[a + (i + 16) >> 2] | 0;

                do {
                  if ((p | 0) != 0) {
                    if (p >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                      return 0;
                    } else {
                      o[A + 16 >> 2] = p;
                      o[p + 24 >> 2] = A;
                      break;
                    }
                  }
                } while (0);

                p = o[a + (i + 20) >> 2] | 0;

                if ((p | 0) == 0) {
                  break;
                }

                if (p >>> 0 < (o[212] | 0) >>> 0) {
                  Ee();
                  return 0;
                } else {
                  o[A + 20 >> 2] = p;
                  o[p + 24 >> 2] = A;
                  break;
                }
              }
            } while (0);

            if (m >>> 0 < 16) {
              o[r >> 2] = b | o[r >> 2] & 1 | 2;
              A = a + (b | 4) | 0;
              o[A >> 2] = o[A >> 2] | 1;
              l = e;
              return l | 0;
            } else {
              o[r >> 2] = o[r >> 2] & 1 | t | 2;
              o[a + (t + 4) >> 2] = m | 3;
              r = a + (b | 4) | 0;
              o[r >> 2] = o[r >> 2] | 1;
              mr(a + t | 0, m);
              l = e;
              return l | 0;
            }

            return 0;
          }

          function Qt() {
            return o[316] | 0;
          }

          function er() {
            return o[317] | 0;
          }

          function tr() {
            var e = 0;
            e = o[318] | 0;
            return ((e | 0) == 0 ? -1 : e) | 0;
          }

          function rr(e) {
            e = e | 0;
            var t = 0,
                r = 0;

            if ((e | 0) == -1) {
              t = 0;
            } else {
              r = o[202] | 0;
              t = e - 1 + r & -r;
            }

            o[318] = t;
            return t | 0;
          }

          function nr(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0;

            do {
              if ((e | 0) == 0) {
                t = 0;
              } else {
                r = o[e - 4 >> 2] | 0;
                n = r & 3;

                if ((n | 0) == 1) {
                  t = 0;
                  break;
                }

                t = (r & -8) - ((n | 0) == 0 ? 8 : 4) | 0;
              }
            } while (0);

            return t | 0;
          }

          function ir(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0,
                a = 0;

            do {
              if ((t | 0) == 8) {
                n = Kt(r) | 0;
              } else {
                i = t >>> 2;

                if ((t & 3 | 0) != 0 | (i | 0) == 0) {
                  a = 22;
                  return a | 0;
                }

                if ((i + 1073741823 & i | 0) != 0) {
                  a = 22;
                  return a | 0;
                }

                if ((-64 - t | 0) >>> 0 < r >>> 0) {
                  a = 12;
                  return a | 0;
                } else {
                  n = Zt(t >>> 0 < 16 ? 16 : t, r) | 0;
                  break;
                }
              }
            } while (0);

            if ((n | 0) == 0) {
              a = 12;
              return a | 0;
            }

            o[e >> 2] = n;
            a = 0;
            return a | 0;
          }

          function or(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0;
            n = d;
            d = d + 8 | 0;
            i = n | 0;
            o[i >> 2] = t;
            t = cr(e, i, 3, r) | 0;
            d = n;
            return t | 0;
          }

          function ar(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            return cr(e, t, 0, r) | 0;
          }

          function sr(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0;

            if ((o[200] | 0) != 0) {
              t = o[201] | 0;
              r = Xt(t, e) | 0;
              return r | 0;
            }

            n = _e(8) | 0;

            if ((n - 1 & n | 0) != 0) {
              Ee();
              return 0;
            }

            o[202] = n;
            o[201] = n;
            o[203] = -1;
            o[204] = 2097152;
            o[205] = 0;
            o[319] = 0;
            o[200] = (tt(0) | 0) & -16 ^ 1431655768;
            t = o[201] | 0;
            r = Xt(t, e) | 0;
            return r | 0;
          }

          function fr(e) {
            e = e | 0;
            var t = 0;

            do {
              if ((o[200] | 0) == 0) {
                t = _e(8) | 0;

                if ((t - 1 & t | 0) == 0) {
                  o[202] = t;
                  o[201] = t;
                  o[203] = -1;
                  o[204] = 2097152;
                  o[205] = 0;
                  o[319] = 0;
                  o[200] = (tt(0) | 0) & -16 ^ 1431655768;
                  break;
                } else {
                  Ee();
                  return 0;
                }
              }
            } while (0);

            t = o[201] | 0;
            return Xt(t, e - 1 + t & -t) | 0;
          }

          function cr(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0;

            do {
              if ((o[200] | 0) == 0) {
                i = _e(8) | 0;

                if ((i - 1 & i | 0) == 0) {
                  o[202] = i;
                  o[201] = i;
                  o[203] = -1;
                  o[204] = 2097152;
                  o[205] = 0;
                  o[319] = 0;
                  o[200] = (tt(0) | 0) & -16 ^ 1431655768;
                  break;
                } else {
                  Ee();
                  return 0;
                }
              }
            } while (0);

            i = (e | 0) == 0;

            do {
              if ((n | 0) == 0) {
                if (i) {
                  a = Kt(0) | 0;
                  return a | 0;
                } else {
                  s = e << 2;

                  if (s >>> 0 < 11) {
                    f = 0;
                    c = 16;
                    break;
                  }

                  f = 0;
                  c = s + 11 & -8;
                  break;
                }
              } else {
                if (i) {
                  a = n;
                } else {
                  f = n;
                  c = 0;
                  break;
                }

                return a | 0;
              }
            } while (0);

            do {
              if ((r & 1 | 0) == 0) {
                if (i) {
                  u = 0;
                  d = 0;
                  break;
                } else {
                  h = 0;
                  l = 0;
                }

                while (1) {
                  n = o[t + (l << 2) >> 2] | 0;

                  if (n >>> 0 < 11) {
                    p = 16;
                  } else {
                    p = n + 11 & -8;
                  }

                  n = p + h | 0;
                  s = l + 1 | 0;

                  if ((s | 0) == (e | 0)) {
                    u = 0;
                    d = n;
                    break;
                  } else {
                    h = n;
                    l = s;
                  }
                }
              } else {
                s = o[t >> 2] | 0;

                if (s >>> 0 < 11) {
                  b = 16;
                } else {
                  b = s + 11 & -8;
                }

                u = b;
                d = ae(b, e) | 0;
              }
            } while (0);

            b = Kt(c - 4 + d | 0) | 0;

            if ((b | 0) == 0) {
              a = 0;
              return a | 0;
            }

            l = b - 8 | 0;
            h = o[b - 4 >> 2] & -8;

            if ((r & 2 | 0) != 0) {
              en(b | 0, 0, -4 - c + h | 0);
            }

            if ((f | 0) == 0) {
              o[b + (d - 4) >> 2] = h - d | 3;
              m = b + d | 0;
              y = d;
            } else {
              m = f;
              y = h;
            }

            o[m >> 2] = b;
            b = e - 1 | 0;

            e: do {
              if ((b | 0) == 0) {
                v = l;
                g = y;
              } else {
                if ((u | 0) == 0) {
                  _ = l;
                  w = y;
                  k = 0;
                } else {
                  e = l;
                  h = y;
                  f = 0;

                  while (1) {
                    d = h - u | 0;
                    o[e + 4 >> 2] = u | 3;
                    c = e + u | 0;
                    r = f + 1 | 0;
                    o[m + (r << 2) >> 2] = e + (u + 8);

                    if ((r | 0) == (b | 0)) {
                      v = c;
                      g = d;
                      break e;
                    } else {
                      e = c;
                      h = d;
                      f = r;
                    }
                  }
                }

                while (1) {
                  f = o[t + (k << 2) >> 2] | 0;

                  if (f >>> 0 < 11) {
                    E = 16;
                  } else {
                    E = f + 11 & -8;
                  }

                  f = w - E | 0;
                  o[_ + 4 >> 2] = E | 3;
                  h = _ + E | 0;
                  e = k + 1 | 0;
                  o[m + (e << 2) >> 2] = _ + (E + 8);

                  if ((e | 0) == (b | 0)) {
                    v = h;
                    g = f;
                    break;
                  } else {
                    _ = h;
                    w = f;
                    k = e;
                  }
                }
              }
            } while (0);

            o[v + 4 >> 2] = g | 3;
            a = m;
            return a | 0;
          }

          function ur(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0;
            r = e + (t << 2) | 0;

            e: do {
              if ((t | 0) != 0) {
                n = e;

                t: while (1) {
                  i = o[n >> 2] | 0;

                  r: do {
                    if ((i | 0) == 0) {
                      a = n + 4 | 0;
                    } else {
                      s = i - 8 | 0;
                      f = s;
                      c = i - 4 | 0;
                      u = o[c >> 2] & -8;
                      o[n >> 2] = 0;

                      if (s >>> 0 < (o[212] | 0) >>> 0) {
                        d = 935;
                        break t;
                      }

                      s = o[c >> 2] | 0;

                      if ((s & 3 | 0) == 1) {
                        d = 936;
                        break t;
                      }

                      h = n + 4 | 0;
                      l = s - 8 & -8;

                      do {
                        if ((h | 0) != (r | 0)) {
                          if ((o[h >> 2] | 0) != (i + (l + 8) | 0)) {
                            break;
                          }

                          p = (o[i + (l | 4) >> 2] & -8) + u | 0;
                          o[c >> 2] = s & 1 | p | 2;
                          b = i + (p - 4) | 0;
                          o[b >> 2] = o[b >> 2] | 1;
                          o[h >> 2] = i;
                          a = h;
                          break r;
                        }
                      } while (0);

                      mr(f, u);
                      a = h;
                    }
                  } while (0);

                  if ((a | 0) == (r | 0)) {
                    break e;
                  } else {
                    n = a;
                  }
                }

                if ((d | 0) == 935) {
                  Ee();
                  return 0;
                } else if ((d | 0) == 936) {
                  Ee();
                  return 0;
                }
              }
            } while (0);

            if ((o[211] | 0) >>> 0 <= (o[215] | 0) >>> 0) {
              return 0;
            }

            Jt(0) | 0;
            return 0;
          }

          function dr(e) {
            e = e | 0;
            var t = 0,
                r = 0;

            if ((o[200] | 0) != 0) {
              t = Jt(e) | 0;
              return t | 0;
            }

            r = _e(8) | 0;

            if ((r - 1 & r | 0) != 0) {
              Ee();
              return 0;
            }

            o[202] = r;
            o[201] = r;
            o[203] = -1;
            o[204] = 2097152;
            o[205] = 0;
            o[319] = 0;
            o[200] = (tt(0) | 0) & -16 ^ 1431655768;
            t = Jt(e) | 0;
            return t | 0;
          }

          function hr(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0,
                x = 0,
                I = 0,
                j = 0;

            do {
              if ((o[200] | 0) == 0) {
                t = _e(8) | 0;

                if ((t - 1 & t | 0) == 0) {
                  o[202] = t;
                  o[201] = t;
                  o[203] = -1;
                  o[204] = 2097152;
                  o[205] = 0;
                  o[319] = 0;
                  o[200] = (tt(0) | 0) & -16 ^ 1431655768;
                  break;
                } else {
                  Ee();
                }
              }
            } while (0);

            t = o[214] | 0;

            if ((t | 0) == 0) {
              r = 0;
              n = 0;
              i = 0;
              a = 0;
              s = 0;
              f = 0;
              c = 0;
            } else {
              u = o[211] | 0;
              d = u + 40 | 0;
              h = 1;
              l = d;
              p = d;
              d = 1280;

              while (1) {
                b = o[d >> 2] | 0;
                m = b + 8 | 0;

                if ((m & 7 | 0) == 0) {
                  y = 0;
                } else {
                  y = -m & 7;
                }

                m = b + (o[d + 4 >> 2] | 0) | 0;
                v = h;
                g = l;
                _ = p;
                w = b + y | 0;

                while (1) {
                  if (w >>> 0 >= m >>> 0 | (w | 0) == (t | 0)) {
                    k = v;
                    E = g;
                    A = _;
                    break;
                  }

                  S = o[w + 4 >> 2] | 0;

                  if ((S | 0) == 7) {
                    k = v;
                    E = g;
                    A = _;
                    break;
                  }

                  M = S & -8;
                  x = M + _ | 0;

                  if ((S & 3 | 0) == 1) {
                    I = M + g | 0;
                    j = v + 1 | 0;
                  } else {
                    I = g;
                    j = v;
                  }

                  S = w + M | 0;

                  if (S >>> 0 < b >>> 0) {
                    k = j;
                    E = I;
                    A = x;
                    break;
                  } else {
                    v = j;
                    g = I;
                    _ = x;
                    w = S;
                  }
                }

                w = o[d + 8 >> 2] | 0;

                if ((w | 0) == 0) {
                  break;
                } else {
                  h = k;
                  l = E;
                  p = A;
                  d = w;
                }
              }

              d = o[316] | 0;
              r = u;
              n = A;
              i = k;
              a = d - A | 0;
              s = o[317] | 0;
              f = d - E | 0;
              c = E;
            }

            o[e >> 2] = n;
            o[e + 4 >> 2] = i;
            i = e + 8 | 0;
            o[i >> 2] = 0;
            o[i + 4 >> 2] = 0;
            o[e + 16 >> 2] = a;
            o[e + 20 >> 2] = s;
            o[e + 24 >> 2] = 0;
            o[e + 28 >> 2] = f;
            o[e + 32 >> 2] = c;
            o[e + 36 >> 2] = r;
            return;
          }

          function lr() {
            var e = 0,
                t = 0,
                r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                v = 0,
                g = 0,
                _ = 0;
            e = d;

            do {
              if ((o[200] | 0) == 0) {
                t = _e(8) | 0;

                if ((t - 1 & t | 0) == 0) {
                  o[202] = t;
                  o[201] = t;
                  o[203] = -1;
                  o[204] = 2097152;
                  o[205] = 0;
                  o[319] = 0;
                  o[200] = (tt(0) | 0) & -16 ^ 1431655768;
                  break;
                } else {
                  Ee();
                }
              }
            } while (0);

            t = o[214] | 0;

            if ((t | 0) == 0) {
              r = 0;
              n = 0;
              i = 0;
            } else {
              a = o[317] | 0;
              s = o[316] | 0;
              f = s - 40 - (o[211] | 0) | 0;
              c = 1280;

              while (1) {
                u = o[c >> 2] | 0;
                h = u + 8 | 0;

                if ((h & 7 | 0) == 0) {
                  l = 0;
                } else {
                  l = -h & 7;
                }

                h = u + (o[c + 4 >> 2] | 0) | 0;
                p = f;
                b = u + l | 0;

                while (1) {
                  if (b >>> 0 >= h >>> 0 | (b | 0) == (t | 0)) {
                    m = p;
                    break;
                  }

                  v = o[b + 4 >> 2] | 0;

                  if ((v | 0) == 7) {
                    m = p;
                    break;
                  }

                  g = v & -8;
                  _ = p - ((v & 3 | 0) == 1 ? g : 0) | 0;
                  v = b + g | 0;

                  if (v >>> 0 < u >>> 0) {
                    m = _;
                    break;
                  } else {
                    p = _;
                    b = v;
                  }
                }

                b = o[c + 8 >> 2] | 0;

                if ((b | 0) == 0) {
                  r = m;
                  n = s;
                  i = a;
                  break;
                } else {
                  f = m;
                  c = b;
                }
              }
            }

            Ae(o[y >> 2] | 0, 520, (x = d, d = d + 8 | 0, o[x >> 2] = i, x) | 0) | 0;
            Ae(o[y >> 2] | 0, 488, (x = d, d = d + 8 | 0, o[x >> 2] = n, x) | 0) | 0;
            Ae(o[y >> 2] | 0, 400, (x = d, d = d + 8 | 0, o[x >> 2] = r, x) | 0) | 0;
            d = e;
            return;
          }

          function pr(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0;

            do {
              if ((o[200] | 0) == 0) {
                r = _e(8) | 0;

                if ((r - 1 & r | 0) == 0) {
                  o[202] = r;
                  o[201] = r;
                  o[203] = -1;
                  o[204] = 2097152;
                  o[205] = 0;
                  o[319] = 0;
                  o[200] = (tt(0) | 0) & -16 ^ 1431655768;
                  break;
                } else {
                  Ee();
                  return 0;
                }
              }
            } while (0);

            if ((e | 0) == (-1 | 0)) {
              o[204] = t;
              n = 1;
              return n | 0;
            } else if ((e | 0) == (-2 | 0)) {
              if ((o[201] | 0) >>> 0 > t >>> 0) {
                n = 0;
                return n | 0;
              }

              if ((t - 1 & t | 0) != 0) {
                n = 0;
                return n | 0;
              }

              o[202] = t;
              n = 1;
              return n | 0;
            } else if ((e | 0) == (-3 | 0)) {
              o[203] = t;
              n = 1;
              return n | 0;
            } else {
              n = 0;
              return n | 0;
            }

            return 0;
          }

          function br() {
            return (L = o[328] | 0, o[328] = L + 0, L) | 0;
          }

          function mr(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0,
                x = 0,
                I = 0,
                j = 0,
                B = 0,
                R = 0,
                P = 0,
                T = 0,
                L = 0,
                C = 0,
                O = 0,
                N = 0;
            r = e;
            n = r + t | 0;
            i = n;
            a = o[e + 4 >> 2] | 0;

            e: do {
              if ((a & 1 | 0) == 0) {
                s = o[e >> 2] | 0;

                if ((a & 3 | 0) == 0) {
                  return;
                }

                f = r + (-s | 0) | 0;
                c = f;
                u = s + t | 0;
                d = o[212] | 0;

                if (f >>> 0 < d >>> 0) {
                  Ee();
                }

                if ((c | 0) == (o[213] | 0)) {
                  h = r + (t + 4) | 0;

                  if ((o[h >> 2] & 3 | 0) != 3) {
                    l = c;
                    p = u;
                    break;
                  }

                  o[210] = u;
                  o[h >> 2] = o[h >> 2] & -2;
                  o[r + (4 - s) >> 2] = u | 1;
                  o[n >> 2] = u;
                  return;
                }

                h = s >>> 3;

                if (s >>> 0 < 256) {
                  b = o[r + (8 - s) >> 2] | 0;
                  m = o[r + (12 - s) >> 2] | 0;
                  y = 872 + (h << 1 << 2) | 0;

                  do {
                    if ((b | 0) != (y | 0)) {
                      if (b >>> 0 < d >>> 0) {
                        Ee();
                      }

                      if ((o[b + 12 >> 2] | 0) == (c | 0)) {
                        break;
                      }

                      Ee();
                    }
                  } while (0);

                  if ((m | 0) == (b | 0)) {
                    o[208] = o[208] & ~(1 << h);
                    l = c;
                    p = u;
                    break;
                  }

                  do {
                    if ((m | 0) == (y | 0)) {
                      v = m + 8 | 0;
                    } else {
                      if (m >>> 0 < d >>> 0) {
                        Ee();
                      }

                      g = m + 8 | 0;

                      if ((o[g >> 2] | 0) == (c | 0)) {
                        v = g;
                        break;
                      }

                      Ee();
                    }
                  } while (0);

                  o[b + 12 >> 2] = m;
                  o[v >> 2] = b;
                  l = c;
                  p = u;
                  break;
                }

                y = f;
                h = o[r + (24 - s) >> 2] | 0;
                g = o[r + (12 - s) >> 2] | 0;

                do {
                  if ((g | 0) == (y | 0)) {
                    _ = 16 - s | 0;
                    w = r + (_ + 4) | 0;
                    k = o[w >> 2] | 0;

                    if ((k | 0) == 0) {
                      E = r + _ | 0;
                      _ = o[E >> 2] | 0;

                      if ((_ | 0) == 0) {
                        A = 0;
                        break;
                      } else {
                        S = _;
                        M = E;
                      }
                    } else {
                      S = k;
                      M = w;
                    }

                    while (1) {
                      w = S + 20 | 0;
                      k = o[w >> 2] | 0;

                      if ((k | 0) != 0) {
                        S = k;
                        M = w;
                        continue;
                      }

                      w = S + 16 | 0;
                      k = o[w >> 2] | 0;

                      if ((k | 0) == 0) {
                        break;
                      } else {
                        S = k;
                        M = w;
                      }
                    }

                    if (M >>> 0 < d >>> 0) {
                      Ee();
                    } else {
                      o[M >> 2] = 0;
                      A = S;
                      break;
                    }
                  } else {
                    w = o[r + (8 - s) >> 2] | 0;

                    if (w >>> 0 < d >>> 0) {
                      Ee();
                    }

                    k = w + 12 | 0;

                    if ((o[k >> 2] | 0) != (y | 0)) {
                      Ee();
                    }

                    E = g + 8 | 0;

                    if ((o[E >> 2] | 0) == (y | 0)) {
                      o[k >> 2] = g;
                      o[E >> 2] = w;
                      A = g;
                      break;
                    } else {
                      Ee();
                    }
                  }
                } while (0);

                if ((h | 0) == 0) {
                  l = c;
                  p = u;
                  break;
                }

                g = r + (28 - s) | 0;
                d = 1136 + (o[g >> 2] << 2) | 0;

                do {
                  if ((y | 0) == (o[d >> 2] | 0)) {
                    o[d >> 2] = A;

                    if ((A | 0) != 0) {
                      break;
                    }

                    o[209] = o[209] & ~(1 << o[g >> 2]);
                    l = c;
                    p = u;
                    break e;
                  } else {
                    if (h >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    }

                    f = h + 16 | 0;

                    if ((o[f >> 2] | 0) == (y | 0)) {
                      o[f >> 2] = A;
                    } else {
                      o[h + 20 >> 2] = A;
                    }

                    if ((A | 0) == 0) {
                      l = c;
                      p = u;
                      break e;
                    }
                  }
                } while (0);

                if (A >>> 0 < (o[212] | 0) >>> 0) {
                  Ee();
                }

                o[A + 24 >> 2] = h;
                y = 16 - s | 0;
                g = o[r + y >> 2] | 0;

                do {
                  if ((g | 0) != 0) {
                    if (g >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    } else {
                      o[A + 16 >> 2] = g;
                      o[g + 24 >> 2] = A;
                      break;
                    }
                  }
                } while (0);

                g = o[r + (y + 4) >> 2] | 0;

                if ((g | 0) == 0) {
                  l = c;
                  p = u;
                  break;
                }

                if (g >>> 0 < (o[212] | 0) >>> 0) {
                  Ee();
                } else {
                  o[A + 20 >> 2] = g;
                  o[g + 24 >> 2] = A;
                  l = c;
                  p = u;
                  break;
                }
              } else {
                l = e;
                p = t;
              }
            } while (0);

            e = o[212] | 0;

            if (n >>> 0 < e >>> 0) {
              Ee();
            }

            A = r + (t + 4) | 0;
            S = o[A >> 2] | 0;

            do {
              if ((S & 2 | 0) == 0) {
                if ((i | 0) == (o[214] | 0)) {
                  M = (o[211] | 0) + p | 0;
                  o[211] = M;
                  o[214] = l;
                  o[l + 4 >> 2] = M | 1;

                  if ((l | 0) != (o[213] | 0)) {
                    return;
                  }

                  o[213] = 0;
                  o[210] = 0;
                  return;
                }

                if ((i | 0) == (o[213] | 0)) {
                  M = (o[210] | 0) + p | 0;
                  o[210] = M;
                  o[213] = l;
                  o[l + 4 >> 2] = M | 1;
                  o[l + M >> 2] = M;
                  return;
                }

                M = (S & -8) + p | 0;
                v = S >>> 3;

                e: do {
                  if (S >>> 0 < 256) {
                    a = o[r + (t + 8) >> 2] | 0;
                    g = o[r + (t + 12) >> 2] | 0;
                    s = 872 + (v << 1 << 2) | 0;

                    do {
                      if ((a | 0) != (s | 0)) {
                        if (a >>> 0 < e >>> 0) {
                          Ee();
                        }

                        if ((o[a + 12 >> 2] | 0) == (i | 0)) {
                          break;
                        }

                        Ee();
                      }
                    } while (0);

                    if ((g | 0) == (a | 0)) {
                      o[208] = o[208] & ~(1 << v);
                      break;
                    }

                    do {
                      if ((g | 0) == (s | 0)) {
                        x = g + 8 | 0;
                      } else {
                        if (g >>> 0 < e >>> 0) {
                          Ee();
                        }

                        h = g + 8 | 0;

                        if ((o[h >> 2] | 0) == (i | 0)) {
                          x = h;
                          break;
                        }

                        Ee();
                      }
                    } while (0);

                    o[a + 12 >> 2] = g;
                    o[x >> 2] = a;
                  } else {
                    s = n;
                    h = o[r + (t + 24) >> 2] | 0;
                    d = o[r + (t + 12) >> 2] | 0;

                    do {
                      if ((d | 0) == (s | 0)) {
                        f = r + (t + 20) | 0;
                        b = o[f >> 2] | 0;

                        if ((b | 0) == 0) {
                          m = r + (t + 16) | 0;
                          w = o[m >> 2] | 0;

                          if ((w | 0) == 0) {
                            I = 0;
                            break;
                          } else {
                            j = w;
                            B = m;
                          }
                        } else {
                          j = b;
                          B = f;
                        }

                        while (1) {
                          f = j + 20 | 0;
                          b = o[f >> 2] | 0;

                          if ((b | 0) != 0) {
                            j = b;
                            B = f;
                            continue;
                          }

                          f = j + 16 | 0;
                          b = o[f >> 2] | 0;

                          if ((b | 0) == 0) {
                            break;
                          } else {
                            j = b;
                            B = f;
                          }
                        }

                        if (B >>> 0 < e >>> 0) {
                          Ee();
                        } else {
                          o[B >> 2] = 0;
                          I = j;
                          break;
                        }
                      } else {
                        f = o[r + (t + 8) >> 2] | 0;

                        if (f >>> 0 < e >>> 0) {
                          Ee();
                        }

                        b = f + 12 | 0;

                        if ((o[b >> 2] | 0) != (s | 0)) {
                          Ee();
                        }

                        m = d + 8 | 0;

                        if ((o[m >> 2] | 0) == (s | 0)) {
                          o[b >> 2] = d;
                          o[m >> 2] = f;
                          I = d;
                          break;
                        } else {
                          Ee();
                        }
                      }
                    } while (0);

                    if ((h | 0) == 0) {
                      break;
                    }

                    d = r + (t + 28) | 0;
                    a = 1136 + (o[d >> 2] << 2) | 0;

                    do {
                      if ((s | 0) == (o[a >> 2] | 0)) {
                        o[a >> 2] = I;

                        if ((I | 0) != 0) {
                          break;
                        }

                        o[209] = o[209] & ~(1 << o[d >> 2]);
                        break e;
                      } else {
                        if (h >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        }

                        g = h + 16 | 0;

                        if ((o[g >> 2] | 0) == (s | 0)) {
                          o[g >> 2] = I;
                        } else {
                          o[h + 20 >> 2] = I;
                        }

                        if ((I | 0) == 0) {
                          break e;
                        }
                      }
                    } while (0);

                    if (I >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    }

                    o[I + 24 >> 2] = h;
                    s = o[r + (t + 16) >> 2] | 0;

                    do {
                      if ((s | 0) != 0) {
                        if (s >>> 0 < (o[212] | 0) >>> 0) {
                          Ee();
                        } else {
                          o[I + 16 >> 2] = s;
                          o[s + 24 >> 2] = I;
                          break;
                        }
                      }
                    } while (0);

                    s = o[r + (t + 20) >> 2] | 0;

                    if ((s | 0) == 0) {
                      break;
                    }

                    if (s >>> 0 < (o[212] | 0) >>> 0) {
                      Ee();
                    } else {
                      o[I + 20 >> 2] = s;
                      o[s + 24 >> 2] = I;
                      break;
                    }
                  }
                } while (0);

                o[l + 4 >> 2] = M | 1;
                o[l + M >> 2] = M;

                if ((l | 0) != (o[213] | 0)) {
                  R = M;
                  break;
                }

                o[210] = M;
                return;
              } else {
                o[A >> 2] = S & -2;
                o[l + 4 >> 2] = p | 1;
                o[l + p >> 2] = p;
                R = p;
              }
            } while (0);

            p = R >>> 3;

            if (R >>> 0 < 256) {
              S = p << 1;
              A = 872 + (S << 2) | 0;
              I = o[208] | 0;
              t = 1 << p;

              do {
                if ((I & t | 0) == 0) {
                  o[208] = I | t;
                  P = A;
                  T = 872 + (S + 2 << 2) | 0;
                } else {
                  p = 872 + (S + 2 << 2) | 0;
                  r = o[p >> 2] | 0;

                  if (r >>> 0 >= (o[212] | 0) >>> 0) {
                    P = r;
                    T = p;
                    break;
                  }

                  Ee();
                }
              } while (0);

              o[T >> 2] = l;
              o[P + 12 >> 2] = l;
              o[l + 8 >> 2] = P;
              o[l + 12 >> 2] = A;
              return;
            }

            A = l;
            P = R >>> 8;

            do {
              if ((P | 0) == 0) {
                L = 0;
              } else {
                if (R >>> 0 > 16777215) {
                  L = 31;
                  break;
                }

                T = (P + 1048320 | 0) >>> 16 & 8;
                S = P << T;
                t = (S + 520192 | 0) >>> 16 & 4;
                I = S << t;
                S = (I + 245760 | 0) >>> 16 & 2;
                p = 14 - (t | T | S) + (I << S >>> 15) | 0;
                L = R >>> ((p + 7 | 0) >>> 0) & 1 | p << 1;
              }
            } while (0);

            P = 1136 + (L << 2) | 0;
            o[l + 28 >> 2] = L;
            o[l + 20 >> 2] = 0;
            o[l + 16 >> 2] = 0;
            p = o[209] | 0;
            S = 1 << L;

            if ((p & S | 0) == 0) {
              o[209] = p | S;
              o[P >> 2] = A;
              o[l + 24 >> 2] = P;
              o[l + 12 >> 2] = l;
              o[l + 8 >> 2] = l;
              return;
            }

            if ((L | 0) == 31) {
              C = 0;
            } else {
              C = 25 - (L >>> 1) | 0;
            }

            L = R << C;
            C = o[P >> 2] | 0;

            while (1) {
              if ((o[C + 4 >> 2] & -8 | 0) == (R | 0)) {
                break;
              }

              O = C + 16 + (L >>> 31 << 2) | 0;
              P = o[O >> 2] | 0;

              if ((P | 0) == 0) {
                N = 1120;
                break;
              } else {
                L = L << 1;
                C = P;
              }
            }

            if ((N | 0) == 1120) {
              if (O >>> 0 < (o[212] | 0) >>> 0) {
                Ee();
              }

              o[O >> 2] = A;
              o[l + 24 >> 2] = C;
              o[l + 12 >> 2] = l;
              o[l + 8 >> 2] = l;
              return;
            }

            O = C + 8 | 0;
            N = o[O >> 2] | 0;
            L = o[212] | 0;

            if (C >>> 0 < L >>> 0) {
              Ee();
            }

            if (N >>> 0 < L >>> 0) {
              Ee();
            }

            o[N + 12 >> 2] = A;
            o[O >> 2] = A;
            o[l + 8 >> 2] = N;
            o[l + 12 >> 2] = C;
            o[l + 24 >> 2] = 0;
            return;
          }

          function yr(e) {
            e = e | 0;
            var t = 0,
                r = 0,
                n = 0;
            t = (e | 0) == 0 ? 1 : e;

            while (1) {
              r = Kt(t) | 0;

              if ((r | 0) != 0) {
                n = 1164;
                break;
              }

              e = (L = o[328] | 0, o[328] = L + 0, L);

              if ((e | 0) == 0) {
                break;
              }

              Tn[e & 1]();
            }

            if ((n | 0) == 1164) {
              return r | 0;
            }

            r = Ue(4) | 0;
            o[r >> 2] = 560;
            we(r | 0, 688, 6);
            return 0;
          }

          function vr(e, t) {
            e = e | 0;
            t = t | 0;
            return yr(e) | 0;
          }

          function gr(e) {
            e = e | 0;
            return;
          }

          function _r(e) {
            e = e | 0;
            return 360 | 0;
          }

          function wr(e) {
            e = e | 0;
            return 448 | 0;
          }

          function kr(e) {
            e = e | 0;
            return (L = o[328] | 0, o[328] = e, L) | 0;
          }

          function Er(e) {
            e = e | 0;
            o[e >> 2] = 560;
            return;
          }

          function Ar(e) {
            e = e | 0;
            o[e >> 2] = 592;
            return;
          }

          function Sr(e) {
            e = e | 0;

            if ((e | 0) != 0) {
              Vt(e);
            }

            return;
          }

          function Mr(e, t) {
            e = e | 0;
            t = t | 0;
            Sr(e);
            return;
          }

          function xr(e) {
            e = e | 0;
            Sr(e);
            return;
          }

          function Ir(e, t) {
            e = e | 0;
            t = t | 0;
            xr(e);
            return;
          }

          function jr(e) {
            e = e | 0;
            Sr(e);
            return;
          }

          function Br(e) {
            e = e | 0;
            Sr(e);
            return;
          }

          function Rr(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            return Pr(e, t, r, 0, 0, 0) | 0;
          }

          function Pr(e, t, r, i, a, s) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            i = i | 0;
            a = a | 0;
            s = s | 0;
            var f = 0,
                c = 0,
                u = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0,
                I = 0,
                j = 0,
                B = 0,
                R = 0,
                P = 0,
                T = 0,
                L = 0,
                C = 0,
                O = 0,
                N = 0,
                U = 0,
                D = 0,
                q = 0,
                z = 0,
                F = 0,
                Y = 0,
                K = 0,
                V = 0,
                H = 0,
                W = 0,
                G = 0,
                X = 0,
                Z = 0,
                J = 0,
                $ = 0,
                Q = 0,
                ee = 0,
                te = 0,
                re = 0,
                ne = 0;
            f = d;

            if ((r | 0) == 0) {
              c = -1;
              d = f;
              return c | 0;
            }

            u = o[44] | 0;

            if ((u | 0) == 0) {
              o[196] = 1;
              o[44] = 1;
              h = 1;
              l = 1;
              p = 1190;
            } else {
              b = o[196] | 0;
              m = o[74] | 0;

              if ((m | 0) == -1 | (b | 0) != 0) {
                h = b;
                l = u;
                p = 1190;
              } else {
                y = m;
                v = b;
                g = u;
              }
            }

            if ((p | 0) == 1190) {
              u = (Ke(344) | 0) != 0 | 0;
              o[74] = u;
              y = u;
              v = h;
              g = l;
            }

            l = n[r] | 0;

            if (l << 24 >> 24 == 45) {
              _ = s | 2;
              p = 1194;
            } else {
              h = (y | 0) != 0 | l << 24 >> 24 == 43 ? s & -2 : s;

              if (l << 24 >> 24 == 43) {
                _ = h;
                p = 1194;
              } else {
                w = r;
                k = h;
              }
            }

            if ((p | 0) == 1194) {
              w = r + 1 | 0;
              k = _;
            }

            o[198] = 0;

            if ((v | 0) == 0) {
              E = g;
              p = 1198;
            } else {
              o[50] = -1;
              o[48] = -1;
              A = g;
              S = v;
              p = 1197;
            }

            while (1) {
              if ((p | 0) == 1197) {
                p = 0;

                if ((S | 0) == 0) {
                  E = A;
                  p = 1198;
                  continue;
                } else {
                  M = A;
                }
              } else if ((p | 0) == 1198) {
                p = 0;
                v = o[40] | 0;

                if ((n[v] | 0) == 0) {
                  M = E;
                } else {
                  I = v;
                  j = E;
                  break;
                }
              }

              o[196] = 0;

              if ((M | 0) >= (e | 0)) {
                p = 1200;
                break;
              }

              B = t + (M << 2) | 0;
              R = o[B >> 2] | 0;
              o[40] = R;

              if ((n[R] | 0) == 45) {
                P = R + 1 | 0;
                T = n[P] | 0;

                if (T << 24 >> 24 != 0) {
                  p = 1232;
                  break;
                }

                if ((Be(w | 0, 45) | 0) != 0) {
                  p = 1232;
                  break;
                }
              }

              o[40] = 824;

              if ((k & 2 | 0) != 0) {
                p = 1217;
                break;
              }

              if ((k & 1 | 0) == 0) {
                c = -1;
                p = 1298;
                break;
              }

              v = o[48] | 0;

              do {
                if ((v | 0) == -1) {
                  o[48] = M;
                  L = M;
                  C = 0;
                } else {
                  g = o[50] | 0;

                  if ((g | 0) == -1) {
                    L = M;
                    C = 0;
                    break;
                  }

                  _ = g - v | 0;
                  r = M - g | 0;
                  h = (_ | 0) % (r | 0) | 0;

                  if ((h | 0) == 0) {
                    O = r;
                  } else {
                    l = r;
                    s = h;

                    while (1) {
                      h = (l | 0) % (s | 0) | 0;

                      if ((h | 0) == 0) {
                        O = s;
                        break;
                      } else {
                        l = s;
                        s = h;
                      }
                    }
                  }

                  s = (M - v | 0) / (O | 0) | 0;

                  do {
                    if ((O | 0) > 0) {
                      l = -_ | 0;

                      if ((s | 0) > 0) {
                        N = 0;
                      } else {
                        U = M;
                        D = g;
                        q = v;
                        z = 0;
                        break;
                      }

                      do {
                        h = N + g | 0;
                        y = t + (h << 2) | 0;
                        u = 0;
                        b = h;
                        h = o[y >> 2] | 0;

                        while (1) {
                          m = ((b | 0) < (g | 0) ? r : l) + b | 0;
                          F = t + (m << 2) | 0;
                          Y = o[F >> 2] | 0;
                          o[F >> 2] = h;
                          o[y >> 2] = Y;
                          F = u + 1 | 0;

                          if ((F | 0) < (s | 0)) {
                            u = F;
                            b = m;
                            h = Y;
                          } else {
                            break;
                          }
                        }

                        N = N + 1 | 0;
                      } while ((N | 0) < (O | 0));

                      U = o[44] | 0;
                      D = o[50] | 0;
                      q = o[48] | 0;
                      z = o[196] | 0;
                    } else {
                      U = M;
                      D = g;
                      q = v;
                      z = 0;
                    }
                  } while (0);

                  o[48] = U - D + q;
                  o[50] = -1;
                  L = U;
                  C = z;
                }
              } while (0);

              v = L + 1 | 0;
              o[44] = v;
              A = v;
              S = C;
              p = 1197;
            }

            do {
              if ((p | 0) == 1298) {
                d = f;
                return c | 0;
              } else if ((p | 0) == 1232) {
                C = o[48] | 0;
                S = o[50] | 0;

                if ((C | 0) != -1 & (S | 0) == -1) {
                  o[50] = M;
                  K = n[P] | 0;
                  V = M;
                } else {
                  K = T;
                  V = S;
                }

                if (K << 24 >> 24 == 0) {
                  I = R;
                  j = M;
                  break;
                }

                o[40] = P;

                if ((n[P] | 0) != 45) {
                  I = P;
                  j = M;
                  break;
                }

                if ((n[R + 2 | 0] | 0) != 0) {
                  I = P;
                  j = M;
                  break;
                }

                S = M + 1 | 0;
                o[44] = S;
                o[40] = 824;

                if ((V | 0) != -1) {
                  A = V - C | 0;
                  L = S - V | 0;
                  z = (A | 0) % (L | 0) | 0;

                  if ((z | 0) == 0) {
                    H = L;
                  } else {
                    U = L;
                    q = z;

                    while (1) {
                      z = (U | 0) % (q | 0) | 0;

                      if ((z | 0) == 0) {
                        H = q;
                        break;
                      } else {
                        U = q;
                        q = z;
                      }
                    }
                  }

                  q = (S - C | 0) / (H | 0) | 0;

                  do {
                    if ((H | 0) > 0) {
                      U = -A | 0;

                      if ((q | 0) > 0) {
                        W = 0;
                      } else {
                        G = V;
                        X = C;
                        Z = S;
                        break;
                      }

                      do {
                        z = W + V | 0;
                        D = t + (z << 2) | 0;
                        O = 0;
                        N = z;
                        z = o[D >> 2] | 0;

                        while (1) {
                          E = ((N | 0) < (V | 0) ? L : U) + N | 0;
                          v = t + (E << 2) | 0;
                          g = o[v >> 2] | 0;
                          o[v >> 2] = z;
                          o[D >> 2] = g;
                          v = O + 1 | 0;

                          if ((v | 0) < (q | 0)) {
                            O = v;
                            N = E;
                            z = g;
                          } else {
                            break;
                          }
                        }

                        W = W + 1 | 0;
                      } while ((W | 0) < (H | 0));

                      G = o[50] | 0;
                      X = o[48] | 0;
                      Z = o[44] | 0;
                    } else {
                      G = V;
                      X = C;
                      Z = S;
                    }
                  } while (0);

                  o[44] = X - G + Z;
                }

                o[50] = -1;
                o[48] = -1;
                c = -1;
                d = f;
                return c | 0;
              } else if ((p | 0) == 1200) {
                o[40] = 824;
                S = o[50] | 0;
                C = o[48] | 0;

                do {
                  if ((S | 0) == -1) {
                    if ((C | 0) == -1) {
                      break;
                    }

                    o[44] = C;
                  } else {
                    q = S - C | 0;
                    L = M - S | 0;
                    A = (q | 0) % (L | 0) | 0;

                    if ((A | 0) == 0) {
                      J = L;
                    } else {
                      U = L;
                      z = A;

                      while (1) {
                        A = (U | 0) % (z | 0) | 0;

                        if ((A | 0) == 0) {
                          J = z;
                          break;
                        } else {
                          U = z;
                          z = A;
                        }
                      }
                    }

                    z = (M - C | 0) / (J | 0) | 0;

                    do {
                      if ((J | 0) > 0) {
                        U = -q | 0;

                        if ((z | 0) > 0) {
                          $ = 0;
                        } else {
                          Q = S;
                          ee = C;
                          te = M;
                          break;
                        }

                        do {
                          A = $ + S | 0;
                          N = t + (A << 2) | 0;
                          O = 0;
                          D = A;
                          A = o[N >> 2] | 0;

                          while (1) {
                            g = ((D | 0) < (S | 0) ? L : U) + D | 0;
                            E = t + (g << 2) | 0;
                            v = o[E >> 2] | 0;
                            o[E >> 2] = A;
                            o[N >> 2] = v;
                            E = O + 1 | 0;

                            if ((E | 0) < (z | 0)) {
                              O = E;
                              D = g;
                              A = v;
                            } else {
                              break;
                            }
                          }

                          $ = $ + 1 | 0;
                        } while (($ | 0) < (J | 0));

                        Q = o[50] | 0;
                        ee = o[48] | 0;
                        te = o[44] | 0;
                      } else {
                        Q = S;
                        ee = C;
                        te = M;
                      }
                    } while (0);

                    o[44] = ee - Q + te;
                  }
                } while (0);

                o[50] = -1;
                o[48] = -1;
                c = -1;
                d = f;
                return c | 0;
              } else if ((p | 0) == 1217) {
                o[44] = M + 1;
                o[198] = o[B >> 2];
                c = 1;
                d = f;
                return c | 0;
              }
            } while (0);

            B = (i | 0) != 0;

            e: do {
              if (B) {
                if ((I | 0) == (o[t + (j << 2) >> 2] | 0)) {
                  re = I;
                  break;
                }

                M = n[I] | 0;

                do {
                  if (M << 24 >> 24 == 45) {
                    o[40] = I + 1;
                    ne = 0;
                  } else {
                    if ((k & 4 | 0) == 0) {
                      re = I;
                      break e;
                    }

                    if (M << 24 >> 24 == 58) {
                      ne = 0;
                      break;
                    }

                    ne = (Be(w | 0, M << 24 >> 24 | 0) | 0) != 0 | 0;
                  }
                } while (0);

                M = Ur(t, w, i, a, ne) | 0;

                if ((M | 0) == -1) {
                  re = o[40] | 0;
                  break;
                }

                o[40] = 824;
                c = M;
                d = f;
                return c | 0;
              } else {
                re = I;
              }
            } while (0);

            I = re + 1 | 0;
            o[40] = I;
            ne = n[re] | 0;
            re = ne << 24 >> 24;

            if ((ne << 24 >> 24 | 0) == 45) {
              if ((n[I] | 0) == 0) {
                p = 1260;
              }
            } else if ((ne << 24 >> 24 | 0) == 58) {
              p = 1263;
            } else {
              p = 1260;
            }

            do {
              if ((p | 0) == 1260) {
                k = Be(w | 0, re | 0) | 0;

                if ((k | 0) == 0) {
                  if (ne << 24 >> 24 != 45) {
                    p = 1263;
                    break;
                  }

                  if ((n[I] | 0) == 0) {
                    c = -1;
                  } else {
                    break;
                  }

                  d = f;
                  return c | 0;
                }

                j = n[k + 1 | 0] | 0;

                if (B & ne << 24 >> 24 == 87 & j << 24 >> 24 == 59) {
                  do {
                    if ((n[I] | 0) == 0) {
                      M = (o[44] | 0) + 1 | 0;
                      o[44] = M;

                      if ((M | 0) < (e | 0)) {
                        o[40] = o[t + (M << 2) >> 2];
                        break;
                      }

                      o[40] = 824;

                      do {
                        if ((o[46] | 0) != 0) {
                          if ((n[w] | 0) == 58) {
                            break;
                          }

                          qr(48, (x = d, d = d + 8 | 0, o[x >> 2] = re, x) | 0);
                        }
                      } while (0);

                      o[42] = re;
                      c = (n[w] | 0) == 58 ? 58 : 63;
                      d = f;
                      return c | 0;
                    }
                  } while (0);

                  M = Ur(t, w, i, a, 0) | 0;
                  o[40] = 824;
                  c = M;
                  d = f;
                  return c | 0;
                }

                if (j << 24 >> 24 != 58) {
                  if ((n[I] | 0) != 0) {
                    c = re;
                    d = f;
                    return c | 0;
                  }

                  o[44] = (o[44] | 0) + 1;
                  c = re;
                  d = f;
                  return c | 0;
                }

                o[198] = 0;

                do {
                  if ((n[I] | 0) == 0) {
                    if ((n[k + 2 | 0] | 0) == 58) {
                      break;
                    }

                    M = (o[44] | 0) + 1 | 0;
                    o[44] = M;

                    if ((M | 0) < (e | 0)) {
                      o[198] = o[t + (M << 2) >> 2];
                      break;
                    }

                    o[40] = 824;

                    do {
                      if ((o[46] | 0) != 0) {
                        if ((n[w] | 0) == 58) {
                          break;
                        }

                        qr(48, (x = d, d = d + 8 | 0, o[x >> 2] = re, x) | 0);
                      }
                    } while (0);

                    o[42] = re;
                    c = (n[w] | 0) == 58 ? 58 : 63;
                    d = f;
                    return c | 0;
                  } else {
                    o[198] = I;
                  }
                } while (0);

                o[40] = 824;
                o[44] = (o[44] | 0) + 1;
                c = re;
                d = f;
                return c | 0;
              }
            } while (0);

            do {
              if ((p | 0) == 1263) {
                if ((n[I] | 0) != 0) {
                  break;
                }

                o[44] = (o[44] | 0) + 1;
              }
            } while (0);

            do {
              if ((o[46] | 0) != 0) {
                if ((n[w] | 0) == 58) {
                  break;
                }

                qr(272, (x = d, d = d + 8 | 0, o[x >> 2] = re, x) | 0);
              }
            } while (0);

            o[42] = re;
            c = 63;
            d = f;
            return c | 0;
          }

          function Tr(e, t, r, n, i) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            i = i | 0;
            return Pr(e, t, r, n, i, 1) | 0;
          }

          function Lr(e, t, r, n, i) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            i = i | 0;
            return Pr(e, t, r, n, i, 5) | 0;
          }

          function Cr(e) {
            e = e | 0;
            return yr(e) | 0;
          }

          function Or(e, t) {
            e = e | 0;
            t = t | 0;
            return Cr(e) | 0;
          }

          function Nr() {
            var e = 0;
            e = Ue(4) | 0;
            o[e >> 2] = 560;
            we(e | 0, 688, 6);
          }

          function Ur(e, t, r, i, a) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            i = i | 0;
            a = a | 0;
            var s = 0,
                f = 0,
                c = 0,
                u = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0;
            s = d;
            f = o[40] | 0;
            c = o[44] | 0;
            u = c + 1 | 0;
            o[44] = u;
            h = Be(f | 0, 61) | 0;

            if ((h | 0) == 0) {
              l = tn(f | 0) | 0;
              p = 0;
            } else {
              l = h - f | 0;
              p = h + 1 | 0;
            }

            h = o[r >> 2] | 0;

            e: do {
              if ((h | 0) != 0) {
                t: do {
                  if ((a | 0) != 0 & (l | 0) == 1) {
                    b = 0;
                    m = h;

                    while (1) {
                      if ((n[f] | 0) == (n[m] | 0)) {
                        if ((tn(m | 0) | 0) == 1) {
                          y = b;
                          break t;
                        }
                      }

                      b = b + 1 | 0;
                      m = o[r + (b << 4) >> 2] | 0;

                      if ((m | 0) == 0) {
                        break e;
                      }
                    }
                  } else {
                    m = 0;
                    b = -1;
                    v = h;

                    while (1) {
                      if ((ve(f | 0, v | 0, l | 0) | 0) == 0) {
                        if ((tn(v | 0) | 0) == (l | 0)) {
                          y = m;
                          break t;
                        }

                        if ((b | 0) == -1) {
                          g = m;
                        } else {
                          break;
                        }
                      } else {
                        g = b;
                      }

                      _ = m + 1 | 0;
                      w = o[r + (_ << 4) >> 2] | 0;

                      if ((w | 0) == 0) {
                        y = g;
                        break t;
                      } else {
                        m = _;
                        b = g;
                        v = w;
                      }
                    }

                    do {
                      if ((o[46] | 0) != 0) {
                        if ((n[t] | 0) == 58) {
                          break;
                        }

                        qr(304, (x = d, d = d + 16 | 0, o[x >> 2] = l, o[x + 8 >> 2] = f, x) | 0);
                      }
                    } while (0);

                    o[42] = 0;
                    k = 63;
                    d = s;
                    return k | 0;
                  }
                } while (0);

                if ((y | 0) == -1) {
                  break;
                }

                v = r + (y << 4) + 4 | 0;
                b = o[v >> 2] | 0;
                m = (p | 0) == 0;

                if (!((b | 0) != 0 | m)) {
                  do {
                    if ((o[46] | 0) != 0) {
                      if ((n[t] | 0) == 58) {
                        break;
                      }

                      qr(208, (x = d, d = d + 16 | 0, o[x >> 2] = l, o[x + 8 >> 2] = f, x) | 0);
                    }
                  } while (0);

                  if ((o[r + (y << 4) + 8 >> 2] | 0) == 0) {
                    E = o[r + (y << 4) + 12 >> 2] | 0;
                  } else {
                    E = 0;
                  }

                  o[42] = E;
                  k = (n[t] | 0) == 58 ? 58 : 63;
                  d = s;
                  return k | 0;
                }

                do {
                  if ((b - 1 | 0) >>> 0 < 2) {
                    if (!m) {
                      o[198] = p;
                      break;
                    }

                    if ((b | 0) != 1) {
                      break;
                    }

                    o[44] = c + 2;
                    o[198] = o[e + (u << 2) >> 2];
                  }
                } while (0);

                if (!((o[v >> 2] | 0) == 1 & (o[198] | 0) == 0)) {
                  if ((i | 0) != 0) {
                    o[i >> 2] = y;
                  }

                  b = o[r + (y << 4) + 8 >> 2] | 0;
                  m = o[r + (y << 4) + 12 >> 2] | 0;

                  if ((b | 0) == 0) {
                    k = m;
                    d = s;
                    return k | 0;
                  }

                  o[b >> 2] = m;
                  k = 0;
                  d = s;
                  return k | 0;
                }

                do {
                  if ((o[46] | 0) != 0) {
                    if ((n[t] | 0) == 58) {
                      break;
                    }

                    qr(8, (x = d, d = d + 8 | 0, o[x >> 2] = f, x) | 0);
                  }
                } while (0);

                if ((o[r + (y << 4) + 8 >> 2] | 0) == 0) {
                  A = o[r + (y << 4) + 12 >> 2] | 0;
                } else {
                  A = 0;
                }

                o[42] = A;
                o[44] = (o[44] | 0) - 1;
                k = (n[t] | 0) == 58 ? 58 : 63;
                d = s;
                return k | 0;
              }
            } while (0);

            if ((a | 0) != 0) {
              o[44] = c;
              k = -1;
              d = s;
              return k | 0;
            }

            do {
              if ((o[46] | 0) != 0) {
                if ((n[t] | 0) == 58) {
                  break;
                }

                qr(248, (x = d, d = d + 8 | 0, o[x >> 2] = f, x) | 0);
              }
            } while (0);

            o[42] = 0;
            k = 63;
            d = s;
            return k | 0;
          }

          function Dr(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0;
            r = d;
            d = d + 16 | 0;
            n = r | 0;
            i = n;
            o[i >> 2] = t;
            o[i + 4 >> 2] = 0;
            zr(e, n | 0);
            d = r;
            return;
          }

          function qr(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0;
            r = d;
            d = d + 16 | 0;
            n = r | 0;
            i = n;
            o[i >> 2] = t;
            o[i + 4 >> 2] = 0;
            Fr(e, n | 0);
            d = r;
            return;
          }

          function zr(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0;
            r = d;
            n = o[($e() | 0) >> 2] | 0;
            i = o[_ >> 2] | 0;
            Ae(o[y >> 2] | 0, 432, (x = d, d = d + 8 | 0, o[x >> 2] = i, x) | 0) | 0;

            if ((e | 0) != 0) {
              i = o[y >> 2] | 0;
              Ve(i | 0, e | 0, t | 0) | 0;
              t = o[y >> 2] | 0;
              Te(472, 2, 1, t | 0) | 0;
            }

            t = o[y >> 2] | 0;
            e = ke(n | 0) | 0;
            Ae(t | 0, 384, (x = d, d = d + 8 | 0, o[x >> 2] = e, x) | 0) | 0;
            d = r;
            return;
          }

          function Fr(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0;
            r = d;
            n = o[_ >> 2] | 0;
            Ae(o[y >> 2] | 0, 376, (x = d, d = d + 8 | 0, o[x >> 2] = n, x) | 0) | 0;

            if ((e | 0) != 0) {
              n = o[y >> 2] | 0;
              Ve(n | 0, e | 0, t | 0) | 0;
            }

            Re(10, o[y >> 2] | 0) | 0;
            d = r;
            return;
          }

          function Yr(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0.0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0.0,
                k = 0,
                E = 0,
                A = 0,
                S = 0.0,
                M = 0.0,
                x = 0,
                I = 0,
                j = 0,
                B = 0.0,
                R = 0,
                P = 0,
                T = 0,
                L = 0,
                C = 0,
                O = 0,
                N = 0,
                U = 0,
                D = 0.0,
                q = 0,
                z = 0,
                F = 0.0,
                Y = 0.0,
                K = 0.0;
            r = e;

            while (1) {
              i = r + 1 | 0;

              if ((De(n[r] | 0) | 0) == 0) {
                break;
              } else {
                r = i;
              }
            }

            a = n[r] | 0;

            if ((a << 24 >> 24 | 0) == 45) {
              s = i;
              f = 1;
            } else if ((a << 24 >> 24 | 0) == 43) {
              s = i;
              f = 0;
            } else {
              s = r;
              f = 0;
            }

            r = -1;
            i = 0;
            a = s;

            while (1) {
              c = n[a] | 0;

              if (((c << 24 >> 24) - 48 | 0) >>> 0 < 10) {
                d = r;
              } else {
                if (c << 24 >> 24 != 46 | (r | 0) > -1) {
                  break;
                } else {
                  d = i;
                }
              }

              r = d;
              i = i + 1 | 0;
              a = a + 1 | 0;
            }

            d = a + (-i | 0) | 0;
            s = (r | 0) < 0;
            h = ((s ^ 1) << 31 >> 31) + i | 0;
            l = (h | 0) > 18;
            p = (l ? -18 : -h | 0) + (s ? i : r) | 0;
            r = l ? 18 : h;

            do {
              if ((r | 0) == 0) {
                b = e;
                m = 0.0;
              } else {
                if ((r | 0) > 9) {
                  h = d;
                  l = r;
                  i = 0;

                  while (1) {
                    s = n[h] | 0;
                    y = h + 1 | 0;

                    if (s << 24 >> 24 == 46) {
                      v = n[y] | 0;
                      g = h + 2 | 0;
                    } else {
                      v = s;
                      g = y;
                    }

                    _ = (i * 10 | 0) - 48 + (v << 24 >> 24) | 0;
                    y = l - 1 | 0;

                    if ((y | 0) > 9) {
                      h = g;
                      l = y;
                      i = _;
                    } else {
                      break;
                    }
                  }

                  w = +(_ | 0) * 1.0e9;
                  k = 9;
                  E = g;
                  A = 1393;
                } else {
                  if ((r | 0) > 0) {
                    w = 0.0;
                    k = r;
                    E = d;
                    A = 1393;
                  } else {
                    S = 0.0;
                    M = 0.0;
                  }
                }

                if ((A | 0) == 1393) {
                  i = E;
                  l = k;
                  h = 0;

                  while (1) {
                    y = n[i] | 0;
                    s = i + 1 | 0;

                    if (y << 24 >> 24 == 46) {
                      x = n[s] | 0;
                      I = i + 2 | 0;
                    } else {
                      x = y;
                      I = s;
                    }

                    j = (h * 10 | 0) - 48 + (x << 24 >> 24) | 0;
                    s = l - 1 | 0;

                    if ((s | 0) > 0) {
                      i = I;
                      l = s;
                      h = j;
                    } else {
                      break;
                    }
                  }

                  S = +(j | 0);
                  M = w;
                }

                B = M + S;

                do {
                  if ((c << 24 >> 24 | 0) == 69 | (c << 24 >> 24 | 0) == 101) {
                    h = a + 1 | 0;
                    l = n[h] | 0;

                    if ((l << 24 >> 24 | 0) == 43) {
                      R = a + 2 | 0;
                      P = 0;
                    } else if ((l << 24 >> 24 | 0) == 45) {
                      R = a + 2 | 0;
                      P = 1;
                    } else {
                      R = h;
                      P = 0;
                    }

                    h = n[R] | 0;

                    if (((h << 24 >> 24) - 48 | 0) >>> 0 < 10) {
                      T = R;
                      L = 0;
                      C = h;
                    } else {
                      O = 0;
                      N = R;
                      U = P;
                      break;
                    }

                    while (1) {
                      h = (L * 10 | 0) - 48 + (C << 24 >> 24) | 0;
                      l = T + 1 | 0;
                      i = n[l] | 0;

                      if (((i << 24 >> 24) - 48 | 0) >>> 0 < 10) {
                        T = l;
                        L = h;
                        C = i;
                      } else {
                        O = h;
                        N = l;
                        U = P;
                        break;
                      }
                    }
                  } else {
                    O = 0;
                    N = a;
                    U = 0;
                  }
                } while (0);

                l = p + ((U | 0) == 0 ? O : -O | 0) | 0;
                h = (l | 0) < 0 ? -l | 0 : l;

                if ((h | 0) > 511) {
                  o[($e() | 0) >> 2] = 34;
                  D = 1.0;
                  q = 88;
                  z = 511;
                  A = 1410;
                } else {
                  if ((h | 0) == 0) {
                    F = 1.0;
                  } else {
                    D = 1.0;
                    q = 88;
                    z = h;
                    A = 1410;
                  }
                }

                if ((A | 0) == 1410) {
                  while (1) {
                    A = 0;

                    if ((z & 1 | 0) == 0) {
                      Y = D;
                    } else {
                      Y = D * +u[q >> 3];
                    }

                    h = z >> 1;

                    if ((h | 0) == 0) {
                      F = Y;
                      break;
                    } else {
                      D = Y;
                      q = q + 8 | 0;
                      z = h;
                      A = 1410;
                    }
                  }
                }

                if ((l | 0) > -1) {
                  b = N;
                  m = B * F;
                  break;
                } else {
                  b = N;
                  m = B / F;
                  break;
                }
              }
            } while (0);

            if ((t | 0) != 0) {
              o[t >> 2] = b;
            }

            if ((f | 0) == 0) {
              K = m;
              return +K;
            }

            K = -0.0 - m;
            return +K;
          }

          function Kr(e, t) {
            e = e | 0;
            t = t | 0;
            return + +Yr(e, t);
          }

          function Vr(e, t) {
            e = e | 0;
            t = t | 0;
            return + +Yr(e, t);
          }

          function Hr(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            return + +Yr(e, t);
          }

          function Wr(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            return + +Yr(e, t);
          }

          function Gr(e) {
            e = e | 0;
            return + +Yr(e, 0);
          }

          function Xr(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0;
            n = d;
            d = d + 16 | 0;
            i = n | 0;
            n = i;
            o[n >> 2] = r;
            o[n + 4 >> 2] = 0;
            Jr(e, t, i | 0);
          }

          function Zr(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0;
            n = d;
            d = d + 16 | 0;
            i = n | 0;
            n = i;
            o[n >> 2] = r;
            o[n + 4 >> 2] = 0;
            $r(e, t, i | 0);
          }

          function Jr(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0,
                i = 0;
            n = o[($e() | 0) >> 2] | 0;
            i = o[_ >> 2] | 0;
            Ae(o[y >> 2] | 0, 336, (x = d, d = d + 8 | 0, o[x >> 2] = i, x) | 0) | 0;

            if ((t | 0) != 0) {
              i = o[y >> 2] | 0;
              Ve(i | 0, t | 0, r | 0) | 0;
              r = o[y >> 2] | 0;
              Te(480, 2, 1, r | 0) | 0;
            }

            r = o[y >> 2] | 0;
            t = ke(n | 0) | 0;
            Ae(r | 0, 392, (x = d, d = d + 8 | 0, o[x >> 2] = t, x) | 0) | 0;
            Oe(e | 0);
          }

          function $r(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var n = 0;
            n = o[_ >> 2] | 0;
            Ae(o[y >> 2] | 0, 440, (x = d, d = d + 8 | 0, o[x >> 2] = n, x) | 0) | 0;

            if ((t | 0) != 0) {
              n = o[y >> 2] | 0;
              Ve(n | 0, t | 0, r | 0) | 0;
            }

            Re(10, o[y >> 2] | 0) | 0;
            Oe(e | 0);
          }

          function Qr(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var i = 0;
            i = e | 0;

            if ((e & 3) == (t & 3)) {
              while (e & 3) {
                if ((r | 0) == 0) return i | 0;
                n[e] = n[t] | 0;
                e = e + 1 | 0;
                t = t + 1 | 0;
                r = r - 1 | 0;
              }

              while ((r | 0) >= 4) {
                o[e >> 2] = o[t >> 2];
                e = e + 4 | 0;
                t = t + 4 | 0;
                r = r - 4 | 0;
              }
            }

            while ((r | 0) > 0) {
              n[e] = n[t] | 0;
              e = e + 1 | 0;
              t = t + 1 | 0;
              r = r - 1 | 0;
            }

            return i | 0;
          }

          function en(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            var i = 0,
                a = 0,
                s = 0;
            i = e + r | 0;

            if ((r | 0) >= 20) {
              t = t & 255;
              r = e & 3;
              a = t | t << 8 | t << 16 | t << 24;
              s = i & ~3;

              if (r) {
                r = e + 4 - r | 0;

                while ((e | 0) < (r | 0)) {
                  n[e] = t;
                  e = e + 1 | 0;
                }
              }

              while ((e | 0) < (s | 0)) {
                o[e >> 2] = a;
                e = e + 4 | 0;
              }
            }

            while ((e | 0) < (i | 0)) {
              n[e] = t;
              e = e + 1 | 0;
            }
          }

          function tn(e) {
            e = e | 0;
            var t = 0;
            t = e;

            while (n[t] | 0) {
              t = t + 1 | 0;
            }

            return t - e | 0;
          }

          function rn(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0;
            i = e + r >>> 0;
            return (O = t + n + (i >>> 0 < e >>> 0 | 0) >>> 0, i | 0) | 0;
          }

          function nn(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0;
            i = t - n >>> 0;
            i = t - n - (r >>> 0 > e >>> 0 | 0) >>> 0;
            return (O = i, e - r >>> 0 | 0) | 0;
          }

          function on(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;

            if ((r | 0) < 32) {
              O = t << r | (e & (1 << r) - 1 << 32 - r) >>> 32 - r;
              return e << r;
            }

            O = e << r - 32;
            return 0;
          }

          function an(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;

            if ((r | 0) < 32) {
              O = t >>> r;
              return e >>> r | (t & (1 << r) - 1) << 32 - r;
            }

            O = 0;
            return t >>> r - 32 | 0;
          }

          function sn(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;

            if ((r | 0) < 32) {
              O = t >> r;
              return e >>> r | (t & (1 << r) - 1) << 32 - r;
            }

            O = (t | 0) < 0 ? -1 : 0;
            return t >> r - 32 | 0;
          }

          function fn(e) {
            e = e | 0;
            var t = 0;
            t = n[m + (e >>> 24) | 0] | 0;
            if ((t | 0) < 8) return t | 0;
            t = n[m + (e >> 16 & 255) | 0] | 0;
            if ((t | 0) < 8) return t + 8 | 0;
            t = n[m + (e >> 8 & 255) | 0] | 0;
            if ((t | 0) < 8) return t + 16 | 0;
            return (n[m + (e & 255) | 0] | 0) + 24 | 0;
          }

          function cn(e) {
            e = e | 0;
            var t = 0;
            t = n[b + (e & 255) | 0] | 0;
            if ((t | 0) < 8) return t | 0;
            t = n[b + (e >> 8 & 255) | 0] | 0;
            if ((t | 0) < 8) return t + 8 | 0;
            t = n[b + (e >> 16 & 255) | 0] | 0;
            if ((t | 0) < 8) return t + 16 | 0;
            return (n[b + (e >>> 24) | 0] | 0) + 24 | 0;
          }

          function un(e, t) {
            e = e | 0;
            t = t | 0;
            var r = 0,
                n = 0,
                i = 0,
                o = 0;
            r = e & 65535;
            n = t & 65535;
            i = ae(n, r) | 0;
            o = e >>> 16;
            e = (i >>> 16) + (ae(n, o) | 0) | 0;
            n = t >>> 16;
            t = ae(n, r) | 0;
            return (O = (e >>> 16) + (ae(n, o) | 0) + (((e & 65535) + t | 0) >>> 16) | 0, e + t << 16 | i & 65535 | 0) | 0;
          }

          function dn(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0,
                o = 0,
                a = 0,
                s = 0,
                f = 0;
            i = t >> 31 | ((t | 0) < 0 ? -1 : 0) << 1;
            o = ((t | 0) < 0 ? -1 : 0) >> 31 | ((t | 0) < 0 ? -1 : 0) << 1;
            a = n >> 31 | ((n | 0) < 0 ? -1 : 0) << 1;
            s = ((n | 0) < 0 ? -1 : 0) >> 31 | ((n | 0) < 0 ? -1 : 0) << 1;
            f = nn(i ^ e, o ^ t, i, o) | 0;
            t = O;
            e = a ^ i;
            i = s ^ o;
            o = nn((mn(f, t, nn(a ^ r, s ^ n, a, s) | 0, O, 0) | 0) ^ e, O ^ i, e, i) | 0;
            return (O = O, o) | 0;
          }

          function hn(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0,
                a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                h = 0;
            i = d;
            d = d + 8 | 0;
            a = i | 0;
            s = t >> 31 | ((t | 0) < 0 ? -1 : 0) << 1;
            f = ((t | 0) < 0 ? -1 : 0) >> 31 | ((t | 0) < 0 ? -1 : 0) << 1;
            c = n >> 31 | ((n | 0) < 0 ? -1 : 0) << 1;
            u = ((n | 0) < 0 ? -1 : 0) >> 31 | ((n | 0) < 0 ? -1 : 0) << 1;
            h = nn(s ^ e, f ^ t, s, f) | 0;
            t = O;
            e = nn(c ^ r, u ^ n, c, u) | 0;
            mn(h, t, e, O, a) | 0;
            e = nn(o[a >> 2] ^ s, o[a + 4 >> 2] ^ f, s, f) | 0;
            f = O;
            d = i;
            return (O = f, e) | 0;
          }

          function ln(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0,
                o = 0;
            i = e;
            e = r;
            r = un(i, e) | 0;
            o = O;
            return (O = (ae(t, e) | 0) + (ae(n, i) | 0) + o | o & 0, r | 0 | 0) | 0;
          }

          function pn(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0;
            i = mn(e, t, r, n, 0) | 0;
            return (O = O, i) | 0;
          }

          function bn(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            var i = 0,
                a = 0;
            i = d;
            d = d + 8 | 0;
            a = i | 0;
            mn(e, t, r, n, a) | 0;
            d = i;
            return (O = o[a + 4 >> 2] | 0, o[a >> 2] | 0) | 0;
          }

          function mn(e, t, r, n, i) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            i = i | 0;
            var a = 0,
                s = 0,
                f = 0,
                c = 0,
                u = 0,
                d = 0,
                h = 0,
                l = 0,
                p = 0,
                b = 0,
                m = 0,
                y = 0,
                v = 0,
                g = 0,
                _ = 0,
                w = 0,
                k = 0,
                E = 0,
                A = 0,
                S = 0,
                M = 0,
                x = 0,
                I = 0,
                j = 0,
                B = 0,
                R = 0,
                P = 0,
                T = 0,
                L = 0,
                C = 0,
                N = 0,
                U = 0;
            a = e;
            s = t;
            f = s;
            c = r;
            u = n;
            d = u;

            if ((f | 0) == 0) {
              h = (i | 0) != 0;

              if ((d | 0) == 0) {
                if (h) {
                  o[i >> 2] = (a >>> 0) % (c >>> 0);
                  o[i + 4 >> 2] = 0;
                }

                l = 0;
                p = (a >>> 0) / (c >>> 0) >>> 0;
                return (O = l, p) | 0;
              } else {
                if (!h) {
                  l = 0;
                  p = 0;
                  return (O = l, p) | 0;
                }

                o[i >> 2] = e | 0;
                o[i + 4 >> 2] = t & 0;
                l = 0;
                p = 0;
                return (O = l, p) | 0;
              }
            }

            h = (d | 0) == 0;

            do {
              if ((c | 0) == 0) {
                if (h) {
                  if ((i | 0) != 0) {
                    o[i >> 2] = (f >>> 0) % (c >>> 0);
                    o[i + 4 >> 2] = 0;
                  }

                  l = 0;
                  p = (f >>> 0) / (c >>> 0) >>> 0;
                  return (O = l, p) | 0;
                }

                if ((a | 0) == 0) {
                  if ((i | 0) != 0) {
                    o[i >> 2] = 0;
                    o[i + 4 >> 2] = (f >>> 0) % (d >>> 0);
                  }

                  l = 0;
                  p = (f >>> 0) / (d >>> 0) >>> 0;
                  return (O = l, p) | 0;
                }

                b = d - 1 | 0;

                if ((b & d | 0) == 0) {
                  if ((i | 0) != 0) {
                    o[i >> 2] = e | 0;
                    o[i + 4 >> 2] = b & f | t & 0;
                  }

                  l = 0;
                  p = f >>> ((cn(d | 0) | 0) >>> 0);
                  return (O = l, p) | 0;
                }

                b = (fn(d | 0) | 0) - (fn(f | 0) | 0) | 0;

                if (b >>> 0 <= 30) {
                  m = b + 1 | 0;
                  y = 31 - b | 0;
                  v = m;
                  g = f << y | a >>> (m >>> 0);
                  _ = f >>> (m >>> 0);
                  w = 0;
                  k = a << y;
                  break;
                }

                if ((i | 0) == 0) {
                  l = 0;
                  p = 0;
                  return (O = l, p) | 0;
                }

                o[i >> 2] = e | 0;
                o[i + 4 >> 2] = s | t & 0;
                l = 0;
                p = 0;
                return (O = l, p) | 0;
              } else {
                if (!h) {
                  y = (fn(d | 0) | 0) - (fn(f | 0) | 0) | 0;

                  if (y >>> 0 <= 31) {
                    m = y + 1 | 0;
                    b = 31 - y | 0;
                    E = y - 31 >> 31;
                    v = m;
                    g = a >>> (m >>> 0) & E | f << b;
                    _ = f >>> (m >>> 0) & E;
                    w = 0;
                    k = a << b;
                    break;
                  }

                  if ((i | 0) == 0) {
                    l = 0;
                    p = 0;
                    return (O = l, p) | 0;
                  }

                  o[i >> 2] = e | 0;
                  o[i + 4 >> 2] = s | t & 0;
                  l = 0;
                  p = 0;
                  return (O = l, p) | 0;
                }

                b = c - 1 | 0;

                if ((b & c | 0) != 0) {
                  E = (fn(c | 0) | 0) + 33 - (fn(f | 0) | 0) | 0;
                  m = 64 - E | 0;
                  y = 32 - E | 0;
                  A = y >> 31;
                  S = E - 32 | 0;
                  M = S >> 31;
                  v = E;
                  g = y - 1 >> 31 & f >>> (S >>> 0) | (f << y | a >>> (E >>> 0)) & M;
                  _ = M & f >>> (E >>> 0);
                  w = a << m & A;
                  k = (f << m | a >>> (S >>> 0)) & A | a << y & E - 33 >> 31;
                  break;
                }

                if ((i | 0) != 0) {
                  o[i >> 2] = b & a;
                  o[i + 4 >> 2] = 0;
                }

                if ((c | 0) == 1) {
                  l = s | t & 0;
                  p = e | 0 | 0;
                  return (O = l, p) | 0;
                } else {
                  b = cn(c | 0) | 0;
                  l = f >>> (b >>> 0) | 0;
                  p = f << 32 - b | a >>> (b >>> 0) | 0;
                  return (O = l, p) | 0;
                }
              }
            } while (0);

            if ((v | 0) == 0) {
              x = k;
              I = w;
              j = _;
              B = g;
              R = 0;
              P = 0;
            } else {
              a = r | 0 | 0;
              r = u | n & 0;
              n = rn(a, r, -1, -1) | 0;
              u = O;
              f = k;
              k = w;
              w = _;
              _ = g;
              g = v;
              v = 0;

              while (1) {
                T = k >>> 31 | f << 1;
                L = v | k << 1;
                c = _ << 1 | f >>> 31 | 0;
                e = _ >>> 31 | w << 1 | 0;
                nn(n, u, c, e) | 0;
                t = O;
                s = t >> 31 | ((t | 0) < 0 ? -1 : 0) << 1;
                C = s & 1;
                N = nn(c, e, s & a, (((t | 0) < 0 ? -1 : 0) >> 31 | ((t | 0) < 0 ? -1 : 0) << 1) & r) | 0;
                U = O;
                t = g - 1 | 0;

                if ((t | 0) == 0) {
                  break;
                } else {
                  f = T;
                  k = L;
                  w = U;
                  _ = N;
                  g = t;
                  v = C;
                }
              }

              x = T;
              I = L;
              j = U;
              B = N;
              R = 0;
              P = C;
            }

            C = I;
            I = 0;

            if ((i | 0) != 0) {
              o[i >> 2] = B;
              o[i + 4 >> 2] = j;
            }

            l = (C | 0) >>> 31 | (x | I) << 1 | (I << 1 | C >>> 31) & 0 | R;
            p = (C << 1 | 0 >>> 31) & -2 | P;
            return (O = l, p) | 0;
          }

          function yn(e, t) {
            e = e | 0;
            t = t | 0;
            jn[e & 15](t | 0);
          }

          function vn(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            Bn[e & 15](t | 0, r | 0);
          }

          function gn(e, t) {
            e = e | 0;
            t = t | 0;
            return Rn[e & 7](t | 0) | 0;
          }

          function _n(e, t, r, n) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            n = n | 0;
            Pn[e & 15](t | 0, r | 0, n | 0);
          }

          function wn(e) {
            e = e | 0;
            Tn[e & 1]();
          }

          function kn(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            return Ln[e & 1](t | 0, r | 0) | 0;
          }

          function En(e) {
            e = e | 0;
            se(0);
          }

          function An(e, t) {
            e = e | 0;
            t = t | 0;
            se(1);
          }

          function Sn(e) {
            e = e | 0;
            se(2);
            return 0;
          }

          function Mn(e, t, r) {
            e = e | 0;
            t = t | 0;
            r = r | 0;
            se(3);
          }

          function xn() {
            se(4);
          }

          function In(e, t) {
            e = e | 0;
            t = t | 0;
            se(5);
            return 0;
          }

          var jn = [En, En, Ar, En, Br, En, gr, En, Er, En, jr, En, En, En, En, En];
          var Bn = [An, An, Dr, An, zr, An, qr, An, Fr, An, An, An, An, An, An, An];
          var Rn = [Sn, Sn, _r, Sn, wr, Sn, Sn, Sn];
          var Pn = [Mn, Mn, $r, Mn, Jr, Mn, Xr, Mn, Zr, Mn, Mn, Mn, Mn, Mn, Mn, Mn];
          var Tn = [xn, xn];
          var Ln = [In, In];
          return {
            _crypto_scrypt: xt,
            _strlen: tn,
            _free: Vt,
            _realloc: Wt,
            _memset: en,
            _malloc: Kt,
            _memcpy: Qr,
            _calloc: Ht,
            runPostSets: _t,
            stackAlloc: it,
            stackSave: ot,
            stackRestore: at,
            setThrew: st,
            setTempRet0: ut,
            setTempRet1: dt,
            setTempRet2: ht,
            setTempRet3: lt,
            setTempRet4: pt,
            setTempRet5: bt,
            setTempRet6: mt,
            setTempRet7: yt,
            setTempRet8: vt,
            setTempRet9: gt,
            dynCall_vi: yn,
            dynCall_vii: vn,
            dynCall_ii: gn,
            dynCall_viii: _n,
            dynCall_v: wn,
            dynCall_iii: kn
          };
        }({
          Math: Math,
          Int8Array: Int8Array,
          Int16Array: Int16Array,
          Int32Array: Int32Array,
          Uint8Array: Uint8Array,
          Uint16Array: Uint16Array,
          Uint32Array: Uint32Array,
          Float32Array: Float32Array,
          Float64Array: Float64Array
        }, {
          abort: wa,
          assert: w,
          asmPrintInt: function asmPrintInt(e, t) {
            s.print("int " + e + "," + t);
          },
          asmPrintFloat: function asmPrintFloat(e, t) {
            s.print("float " + e + "," + t);
          },
          min: Xc,
          invoke_vi: function invoke_vi(e, t) {
            try {
              s.dynCall_vi(e, t);
            } catch (e) {
              "number" != typeof e && "longjmp" !== e && g(e), V.setThrew(1, 0);
            }
          },
          invoke_vii: function invoke_vii(e, t, r) {
            try {
              s.dynCall_vii(e, t, r);
            } catch (e) {
              "number" != typeof e && "longjmp" !== e && g(e), V.setThrew(1, 0);
            }
          },
          invoke_ii: function invoke_ii(e, t) {
            try {
              return s.dynCall_ii(e, t);
            } catch (e) {
              "number" != typeof e && "longjmp" !== e && g(e), V.setThrew(1, 0);
            }
          },
          invoke_viii: function invoke_viii(e, t, r, n) {
            try {
              s.dynCall_viii(e, t, r, n);
            } catch (e) {
              "number" != typeof e && "longjmp" !== e && g(e), V.setThrew(1, 0);
            }
          },
          invoke_v: function invoke_v(e) {
            try {
              s.dynCall_v(e);
            } catch (e) {
              "number" != typeof e && "longjmp" !== e && g(e), V.setThrew(1, 0);
            }
          },
          invoke_iii: function invoke_iii(e, t, r) {
            try {
              return s.dynCall_iii(e, t, r);
            } catch (e) {
              "number" != typeof e && "longjmp" !== e && g(e), V.setThrew(1, 0);
            }
          },
          _strncmp: function _strncmp(e, t, r) {
            for (var n = 0; n < r;) {
              var i = G[e + n | 0],
                  o = G[t + n | 0];
              if (i == o && 0 == i) break;
              if (0 == i) return -1;
              if (0 == o) return 1;
              if (i != o) return i > o ? 1 : -1;
              n++;
            }

            return 0;
          },
          _llvm_va_end: aa(),
          _sysconf: function _sysconf(e) {
            switch (e) {
              case 8:
                return 4096;

              case 54:
              case 56:
              case 21:
              case 61:
              case 63:
              case 22:
              case 67:
              case 23:
              case 24:
              case 25:
              case 26:
              case 27:
              case 69:
              case 28:
              case 101:
              case 70:
              case 71:
              case 29:
              case 30:
              case 199:
              case 75:
              case 76:
              case 32:
              case 43:
              case 44:
              case 80:
              case 46:
              case 47:
              case 45:
              case 48:
              case 49:
              case 42:
              case 82:
              case 33:
              case 7:
              case 108:
              case 109:
              case 107:
              case 112:
              case 119:
              case 121:
                return 200809;

              case 13:
              case 104:
              case 94:
              case 95:
              case 34:
              case 35:
              case 77:
              case 81:
              case 83:
              case 84:
              case 85:
              case 86:
              case 87:
              case 88:
              case 89:
              case 90:
              case 91:
              case 94:
              case 95:
              case 110:
              case 111:
              case 113:
              case 114:
              case 115:
              case 116:
              case 117:
              case 118:
              case 120:
              case 40:
              case 16:
              case 79:
              case 19:
                return -1;

              case 92:
              case 93:
              case 5:
              case 72:
              case 6:
              case 74:
              case 92:
              case 93:
              case 96:
              case 97:
              case 98:
              case 99:
              case 102:
              case 103:
              case 105:
                return 1;

              case 38:
              case 66:
              case 50:
              case 51:
              case 4:
                return 1024;

              case 15:
              case 64:
              case 41:
                return 32;

              case 55:
              case 37:
              case 17:
                return 2147483647;

              case 18:
              case 1:
                return 47839;

              case 59:
              case 57:
                return 99;

              case 68:
              case 58:
                return 2048;

              case 0:
                return 2097152;

              case 3:
                return 65536;

              case 14:
                return 32768;

              case 73:
                return 32767;

              case 39:
                return 16384;

              case 60:
                return 1e3;

              case 106:
                return 700;

              case 52:
                return 256;

              case 62:
                return 255;

              case 2:
                return 100;

              case 65:
                return 64;

              case 36:
                return 20;

              case 100:
                return 16;

              case 20:
                return 6;

              case 53:
                return 4;

              case 10:
                return 1;
            }

            return M(N.A), -1;
          },
          ___cxa_throw: rc,
          _strerror: zc,
          _abort: function _abort() {
            s.abort();
          },
          _fprintf: mc,
          _llvm_eh_exception: U,
          ___cxa_free_exception: sc,
          _fflush: aa(),
          ___buildEnvironment: wc,
          __reallyNegative: jc,
          _strchr: function _strchr(e, t) {
            e--;

            do {
              e++;
              var r = A[e];
              if (r == t) return e;
            } while (r);

            return 0;
          },
          _fputc: Bc,
          ___setErrNo: M,
          _fwrite: hc,
          _send: fc,
          _write: gc,
          _exit: function _exit(e) {
            Ac(e);
          },
          ___cxa_find_matching_catch: function ___cxa_find_matching_catch(e, t) {
            -1 == e && (e = B[U.m >> 2]), -1 == t && (t = B[U.m + 4 >> 2]);
            var r = Array.prototype.slice.call(arguments, 2);
            0 != t && !pc(t) && 0 == B[B[t >> 2] - 8 >> 2] && (e = B[e >> 2]);

            for (var n = 0; n < r.length; n++) {
              if (qc(r[n], t, e)) return 0 | (V.setTempRet0(r[n]), e);
            }

            return 0 | (V.setTempRet0(t), e);
          },
          ___cxa_allocate_exception: function ___cxa_allocate_exception(e) {
            return Oa(e);
          },
          _isspace: function _isspace(e) {
            return 32 == e || 9 <= e && 13 >= e;
          },
          __formatString: kc,
          ___resumeException: function ___resumeException(e) {
            0 == B[U.m >> 2] && (B[U.m >> 2] = e), g(e + " - Exception catching is disabled, this exception cannot be caught. Compile with -s DISABLE_EXCEPTION_CATCHING=0 or DISABLE_EXCEPTION_CATCHING=2 to catch.");
          },
          _llvm_uadd_with_overflow_i32: function _llvm_uadd_with_overflow_i32(e, t) {
            return e >>>= 0, t >>>= 0, 0 | (V.setTempRet0(4294967295 < e + t), e + t >>> 0);
          },
          ___cxa_does_inherit: qc,
          _getenv: xc,
          _vfprintf: function _vfprintf(e, t, r) {
            return mc(e, t, B[r >> 2]);
          },
          ___cxa_begin_catch: function ___cxa_begin_catch(e) {
            return oc.ta--, e;
          },
          __ZSt18uncaught_exceptionv: oc,
          _pwrite: function _pwrite(e, t, r, n) {
            if (!(e = R[e])) return M(N.$), -1;

            try {
              return Ib(e, A, t, r, n);
            } catch (e) {
              return Zb(e), -1;
            }
          },
          ___cxa_call_unexpected: function ___cxa_call_unexpected(e) {
            s.P("Unexpected exception thrown, this is not properly supported - aborting"), za = l, g(e);
          },
          _sbrk: nc,
          _strerror_r: yc,
          ___errno_location: function ___errno_location() {
            return rb;
          },
          ___gxx_personality_v0: aa(),
          ___cxa_is_number_type: pc,
          _time: function _time(e) {
            var t = Math.floor(Date.now() / 1e3);
            return e && (B[e >> 2] = t), t;
          },
          __exit: Ac,
          ___cxa_end_catch: uc,
          STACKTOP: u,
          STACK_MAX: Ta,
          tempDoublePtr: qb,
          ABORT: za,
          cttz_i8: Wc,
          ctlz_i8: Vc,
          NaN: NaN,
          Infinity: 1 / 0,
          _stderr: nb,
          __ZTVN10__cxxabiv120__si_class_type_infoE: ob,
          __ZTVN10__cxxabiv117__class_type_infoE: pb,
          ___progname: k
        }, I);

        s._crypto_scrypt = V._crypto_scrypt;
        var ic = s._strlen = V._strlen,
            tc = s._free = V._free;
        s._realloc = V._realloc;
        var tb = s._memset = V._memset,
            Oa = s._malloc = V._malloc,
            sb = s._memcpy = V._memcpy;
        s._calloc = V._calloc;
        var mb = s.runPostSets = V.runPostSets;
        s.dynCall_vi = V.dynCall_vi, s.dynCall_vii = V.dynCall_vii, s.dynCall_ii = V.dynCall_ii, s.dynCall_viii = V.dynCall_viii, s.dynCall_v = V.dynCall_v, s.dynCall_iii = V.dynCall_iii;

        var qa = function qa(e) {
          return V.stackAlloc(e);
        },
            ja = function ja() {
          return V.stackSave();
        },
            ka = function ka(e) {
          V.stackRestore(e);
        },
            lc;

        function X(e, t) {
          e != m && ("number" == typeof e ? this.p(e) : t == m && "string" != typeof e ? this.k(e, 256) : this.k(e, t));
        }

        function Yc() {
          return new X(m);
        }

        function Zc(e, t) {
          var r = $c[e.charCodeAt(t)];
          return r == m ? -1 : r;
        }

        function ad(e) {
          var t = Yc();
          return t.D(e), t;
        }

        function Y(e, t) {
          this.h = 0 | e, this.j = 0 | t;
        }

        Y.Ca = {}, Y.D = function (e) {
          if (-128 <= e && 128 > e) {
            var t = Y.Ca[e];
            if (t) return t;
          }

          return t = new Y(0 | e, 0 > e ? -1 : 0), -128 <= e && 128 > e && (Y.Ca[e] = t), t;
        }, Y.p = function (e) {
          return isNaN(e) || !isFinite(e) ? Y.ZERO : e <= -Y.Ea ? Y.MIN_VALUE : e + 1 >= Y.Ea ? Y.MAX_VALUE : 0 > e ? Y.p(-e).i() : new Y(e % Y.B | 0, e / Y.B | 0);
        }, Y.v = function (e, t) {
          return new Y(e, t);
        }, Y.k = function (e, t) {
          0 == e.length && g(Error("number format error: empty string"));
          var r = t || 10;
          if ((2 > r || 36 < r) && g(Error("radix out of range: " + r)), "-" == e.charAt(0)) return Y.k(e.substring(1), r).i();
          0 <= e.indexOf("-") && g(Error('number format error: interior "-" character: ' + e));

          for (var n = Y.p(Math.pow(r, 8)), i = Y.ZERO, o = 0; o < e.length; o += 8) {
            var a = Math.min(8, e.length - o),
                s = parseInt(e.substring(o, o + a), r);
            8 > a ? (a = Y.p(Math.pow(r, a)), i = i.multiply(a).add(Y.p(s))) : i = (i = i.multiply(n)).add(Y.p(s));
          }

          return i;
        }, Y.ea = 65536, Y.Od = 16777216, Y.B = Y.ea * Y.ea, Y.Pd = Y.B / 2, Y.Qd = Y.B * Y.ea, Y.eb = Y.B * Y.B, Y.Ea = Y.eb / 2, Y.ZERO = Y.D(0), Y.ONE = Y.D(1), Y.Da = Y.D(-1), Y.MAX_VALUE = Y.v(-1, 2147483647), Y.MIN_VALUE = Y.v(0, -2147483648), Y.cb = Y.D(16777216), q = Y.prototype, q.Z = function () {
          return this.j * Y.B + this.ob();
        }, q.toString = function (e) {
          if ((2 > (e = e || 10) || 36 < e) && g(Error("radix out of range: " + e)), this.G()) return "0";

          if (this.n()) {
            if (this.o(Y.MIN_VALUE)) {
              var t = Y.p(e);
              t = (r = this.F(t)).multiply(t).R(this);
              return r.toString(e) + t.h.toString(e);
            }

            return "-" + this.i().toString(e);
          }

          for (var r = Y.p(Math.pow(e, 6)), n = (t = this, "");;) {
            var i = t.F(r),
                o = t.R(i.multiply(r)).h.toString(e);
            if ((t = i).G()) return o + n;

            for (; 6 > o.length;) {
              o = "0" + o;
            }

            n = "" + o + n;
          }
        }, q.ob = function () {
          return 0 <= this.h ? this.h : Y.B + this.h;
        }, q.G = function () {
          return 0 == this.j && 0 == this.h;
        }, q.n = function () {
          return 0 > this.j;
        }, q.Pa = function () {
          return 1 == (1 & this.h);
        }, q.o = function (e) {
          return this.j == e.j && this.h == e.h;
        }, q.Ra = function () {
          return 0 > this.ja(Y.cb);
        }, q.qb = function (e) {
          return 0 < this.ja(e);
        }, q.rb = function (e) {
          return 0 <= this.ja(e);
        }, q.ja = function (e) {
          if (this.o(e)) return 0;
          var t = this.n(),
              r = e.n();
          return t && !r ? -1 : !t && r ? 1 : this.R(e).n() ? -1 : 1;
        }, q.i = function () {
          return this.o(Y.MIN_VALUE) ? Y.MIN_VALUE : this.xb().add(Y.ONE);
        }, q.add = function (e) {
          var t,
              r = this.j >>> 16,
              n = 65535 & this.j,
              i = this.h >>> 16,
              o = e.j >>> 16,
              a = 65535 & e.j,
              s = e.h >>> 16;
          return e = 0 + ((t = (65535 & this.h) + (65535 & e.h) + 0) >>> 16), i = 0 + ((e += i + s) >>> 16), n = (n = 0 + ((i += n + a) >>> 16)) + (r + o) & 65535, Y.v((65535 & e) << 16 | 65535 & t, n << 16 | 65535 & i);
        }, q.R = function (e) {
          return this.add(e.i());
        }, q.multiply = function (e) {
          if (this.G() || e.G()) return Y.ZERO;
          if (this.o(Y.MIN_VALUE)) return e.Pa() ? Y.MIN_VALUE : Y.ZERO;
          if (e.o(Y.MIN_VALUE)) return this.Pa() ? Y.MIN_VALUE : Y.ZERO;
          if (this.n()) return e.n() ? this.i().multiply(e.i()) : this.i().multiply(e).i();
          if (e.n()) return this.multiply(e.i()).i();
          if (this.Ra() && e.Ra()) return Y.p(this.Z() * e.Z());
          var t,
              r,
              n,
              i,
              o = this.j >>> 16,
              a = 65535 & this.j,
              s = this.h >>> 16,
              f = 65535 & this.h,
              c = e.j >>> 16,
              u = 65535 & e.j,
              d = e.h >>> 16;
          return n = 0 + ((i = 0 + f * (e = 65535 & e.h)) >>> 16), r = 0 + ((n += s * e) >>> 16), r += (n = (65535 & n) + f * d) >>> 16, n &= 65535, t = 0 + ((r += a * e) >>> 16), t += (r = (65535 & r) + s * d) >>> 16, r &= 65535, t += (r += f * u) >>> 16, r &= 65535, t = t + (o * e + a * d + s * u + f * c) & 65535, Y.v(n << 16 | 65535 & i, t << 16 | r);
        }, q.F = function (e) {
          if (e.G() && g(Error("division by zero")), this.G()) return Y.ZERO;

          if (this.o(Y.MIN_VALUE)) {
            if (e.o(Y.ONE) || e.o(Y.Da)) return Y.MIN_VALUE;
            if (e.o(Y.MIN_VALUE)) return Y.ONE;
            if ((n = this.Db().F(e).shiftLeft(1)).o(Y.ZERO)) return e.n() ? Y.ONE : Y.Da;
            var t = this.R(e.multiply(n));
            return n.add(t.F(e));
          }

          if (e.o(Y.MIN_VALUE)) return Y.ZERO;
          if (this.n()) return e.n() ? this.i().F(e.i()) : this.i().F(e).i();
          if (e.n()) return this.F(e.i()).i();
          var r = Y.ZERO;

          for (t = this; t.rb(e);) {
            for (var n = Math.max(1, Math.floor(t.Z() / e.Z())), i = 48 >= (i = Math.ceil(Math.log(n) / Math.LN2)) ? 1 : Math.pow(2, i - 48), o = Y.p(n), a = o.multiply(e); a.n() || a.qb(t);) {
              n -= i, a = (o = Y.p(n)).multiply(e);
            }

            o.G() && (o = Y.ONE), r = r.add(o), t = t.R(a);
          }

          return r;
        }, q.xb = function () {
          return Y.v(~this.h, ~this.j);
        }, q.shiftLeft = function (e) {
          if (0 == (e &= 63)) return this;
          var t = this.h;
          return 32 > e ? Y.v(t << e, this.j << e | t >>> 32 - e) : Y.v(0, t << e - 32);
        }, q.Db = function () {
          var e = this.j;
          return Y.v(this.h >>> 1 | e << 31, e >> 1);
        }, q = X.prototype, q.ga = function (e, t, r, n) {
          for (var i = 0, o = 0; 0 <= --n;) {
            var a = e * this[i++] + t[r] + o;
            o = Math.floor(a / 67108864);
            t[r++] = 67108863 & a;
          }

          return o;
        }, q.f = 26, q.u = 67108863, q.K = 67108864, q.bb = Math.pow(2, 52), q.Aa = 26, q.Ba = 0;
        var $c = [],
            bd,
            Z;

        for (bd = 48, Z = 0; 9 >= Z; ++Z) {
          $c[bd++] = Z;
        }

        for (bd = 97, Z = 10; 36 > Z; ++Z) {
          $c[bd++] = Z;
        }

        for (bd = 65, Z = 10; 36 > Z; ++Z) {
          $c[bd++] = Z;
        }

        q = X.prototype, q.copyTo = function (e) {
          for (var t = this.b - 1; 0 <= t; --t) {
            e[t] = this[t];
          }

          e.b = this.b, e.c = this.c;
        }, q.D = function (e) {
          this.b = 1, this.c = 0 > e ? -1 : 0, 0 < e ? this[0] = e : -1 > e ? this[0] = e + DV : this.b = 0;
        }, q.k = function (e, t) {
          var r;
          if (16 == t) r = 4;else if (8 == t) r = 3;else if (256 == t) r = 8;else if (2 == t) r = 1;else if (32 == t) r = 5;else {
            if (4 != t) return void this.nb(e, t);
            r = 2;
          }
          this.c = this.b = 0;

          for (var n = e.length, i = p, o = 0; 0 <= --n;) {
            var a = 8 == r ? 255 & e[n] : Zc(e, n);
            0 > a ? "-" == e.charAt(n) && (i = l) : (i = p, 0 == o ? this[this.b++] = a : o + r > this.f ? (this[this.b - 1] |= (a & (1 << this.f - o) - 1) << o, this[this.b++] = a >> this.f - o) : this[this.b - 1] |= a << o, (o += r) >= this.f && (o -= this.f));
          }

          8 == r && 0 != (128 & e[0]) && (this.c = -1, 0 < o && (this[this.b - 1] |= (1 << this.f - o) - 1 << o)), this.C(), i && X.ZERO.t(this, this);
        }, q.C = function () {
          for (var e = this.c & this.u; 0 < this.b && this[this.b - 1] == e;) {
            --this.b;
          }
        }, q.la = function (e, t) {
          var r;

          for (r = this.b - 1; 0 <= r; --r) {
            t[r + e] = this[r];
          }

          for (r = e - 1; 0 <= r; --r) {
            t[r] = 0;
          }

          t.b = this.b + e, t.c = this.c;
        }, q.jb = function (e, t) {
          for (var r = e; r < this.b; ++r) {
            t[r - e] = this[r];
          }

          t.b = Math.max(this.b - e, 0), t.c = this.c;
        }, q.Qa = function (e, t) {
          var r,
              n = e % this.f,
              i = this.f - n,
              o = (1 << i) - 1,
              a = Math.floor(e / this.f),
              s = this.c << n & this.u;

          for (r = this.b - 1; 0 <= r; --r) {
            t[r + a + 1] = this[r] >> i | s, s = (this[r] & o) << n;
          }

          for (r = a - 1; 0 <= r; --r) {
            t[r] = 0;
          }

          t[a] = s, t.b = this.b + a + 1, t.c = this.c, t.C();
        }, q.zb = function (e, t) {
          t.c = this.c;
          var r = Math.floor(e / this.f);
          if (r >= this.b) t.b = 0;else {
            var n = e % this.f,
                i = this.f - n,
                o = (1 << n) - 1;
            t[0] = this[r] >> n;

            for (var a = r + 1; a < this.b; ++a) {
              t[a - r - 1] |= (this[a] & o) << i, t[a - r] = this[a] >> n;
            }

            0 < n && (t[this.b - r - 1] |= (this.c & o) << i), t.b = this.b - r, t.C();
          }
        }, q.t = function (e, t) {
          for (var r = 0, n = 0, i = Math.min(e.b, this.b); r < i;) {
            n += this[r] - e[r], t[r++] = n & this.u, n >>= this.f;
          }

          if (e.b < this.b) {
            for (n -= e.c; r < this.b;) {
              n += this[r], t[r++] = n & this.u, n >>= this.f;
            }

            n += this.c;
          } else {
            for (n += this.c; r < e.b;) {
              n -= e[r], t[r++] = n & this.u, n >>= this.f;
            }

            n -= e.c;
          }

          t.c = 0 > n ? -1 : 0, -1 > n ? t[r++] = this.K + n : 0 < n && (t[r++] = n), t.b = r, t.C();
        }, q.vb = function (e) {
          var t = $.Xa,
              r = this.abs(),
              n = t.abs(),
              i = r.b;

          for (e.b = i + n.b; 0 <= --i;) {
            e[i] = 0;
          }

          for (i = 0; i < n.b; ++i) {
            e[i + r.b] = r.ga(n[i], e, i, r.b);
          }

          e.c = 0, e.C(), this.c != t.c && X.ZERO.t(e, e);
        }, q.Ja = function (e, t, r) {
          var n = e.abs();

          if (!(0 >= n.b)) {
            var i = this.abs();
            if (i.b < n.b) t != m && t.D(0), r != m && this.copyTo(r);else {
              r == m && (r = Yc());
              var o,
                  a = Yc(),
                  s = this.c,
                  f = (e = e.c, n[n.b - 1]),
                  c = 1;

              if (0 != (o = f >>> 16) && (f = o, c += 16), 0 != (o = f >> 8) && (f = o, c += 8), 0 != (o = f >> 4) && (f = o, c += 4), 0 != (o = f >> 2) && (f = o, c += 2), 0 != f >> 1 && (c += 1), 0 < (f = this.f - c) ? (n.Qa(f, a), i.Qa(f, r)) : (n.copyTo(a), i.copyTo(r)), 0 != (i = a[(n = a.b) - 1])) {
                o = i * (1 << this.Aa) + (1 < n ? a[n - 2] >> this.Ba : 0), c = this.bb / o, o = (1 << this.Aa) / o;
                var u = 1 << this.Ba,
                    d = r.b,
                    h = d - n,
                    l = t == m ? Yc() : t;

                for (a.la(h, l), 0 <= r.U(l) && (r[r.b++] = 1, r.t(l, r)), X.ONE.la(n, l), l.t(a, a); a.b < n;) {
                  a[a.b++] = 0;
                }

                for (; 0 <= --h;) {
                  var p = r[--d] == i ? this.u : Math.floor(r[d] * c + (r[d - 1] + u) * o);
                  if ((r[d] += a.ga(p, r, h, n)) < p) for (a.la(h, l), r.t(l, r); r[d] < --p;) {
                    r.t(l, r);
                  }
                }

                t != m && (r.jb(n, t), s != e && X.ZERO.t(t, t)), r.b = n, r.C(), 0 < f && r.zb(f, r), 0 > s && X.ZERO.t(r, r);
              }
            }
          }
        }, q.toString = function (e) {
          if (0 > this.c) return "-" + this.i().toString(e);
          if (16 == e) e = 4;else if (8 == e) e = 3;else if (2 == e) e = 1;else if (32 == e) e = 5;else {
            if (4 != e) return this.Fb(e);
            e = 2;
          }
          var t,
              r = (1 << e) - 1,
              n = p,
              i = "",
              o = this.b,
              a = this.f - o * this.f % e;
          if (0 < o--) for (a < this.f && 0 < (t = this[o] >> a) && (n = l, i = "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t)); 0 <= o;) {
            a < e ? (t = (this[o] & (1 << a) - 1) << e - a, t |= this[--o] >> (a += this.f - e)) : (t = this[o] >> (a -= e) & r, 0 >= a && (a += this.f, --o)), 0 < t && (n = l), n && (i += "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t));
          }
          return n ? i : "0";
        }, q.i = function () {
          var e = Yc();
          return X.ZERO.t(this, e), e;
        }, q.abs = function () {
          return 0 > this.c ? this.i() : this;
        }, q.U = function (e) {
          if (0 != (t = this.c - e.c)) return t;
          var t,
              r = this.b;
          if (0 != (t = r - e.b)) return 0 > this.c ? -t : t;

          for (; 0 <= --r;) {
            if (0 != (t = this[r] - e[r])) return t;
          }

          return 0;
        }, X.ZERO = ad(0), X.ONE = ad(1), q = X.prototype, q.nb = function (e, t) {
          this.D(0), t == m && (t = 10);

          for (var r = this.S(t), n = Math.pow(t, r), i = p, o = 0, a = 0, s = 0; s < e.length; ++s) {
            var f = Zc(e, s);
            0 > f ? "-" == e.charAt(s) && 0 == this.ra() && (i = l) : (a = t * a + f, ++o >= r && (this.Ia(n), this.Ha(a), a = o = 0));
          }

          0 < o && (this.Ia(Math.pow(t, o)), this.Ha(a)), i && X.ZERO.t(this, this);
        }, q.S = function (e) {
          return Math.floor(Math.LN2 * this.f / Math.log(e));
        }, q.ra = function () {
          return 0 > this.c ? -1 : 0 >= this.b || 1 == this.b && 0 >= this[0] ? 0 : 1;
        }, q.Ia = function (e) {
          this[this.b] = this.ga(e - 1, this, 0, this.b), ++this.b, this.C();
        }, q.Ha = function (e) {
          var t = 0;

          if (0 != e) {
            for (; this.b <= t;) {
              this[this.b++] = 0;
            }

            for (this[t] += e; this[t] >= this.K;) {
              this[t] -= this.K, ++t >= this.b && (this[this.b++] = 0), ++this[t];
            }
          }
        }, q.Fb = function (e) {
          if (e == m && (e = 10), 0 == this.ra() || 2 > e || 36 < e) return "0";
          var t = this.S(e),
              r = ad(t = Math.pow(e, t)),
              n = Yc(),
              i = Yc(),
              o = "";

          for (this.Ja(r, n, i); 0 < n.ra();) {
            o = (t + i.Oa()).toString(e).substr(1) + o, n.Ja(r, n, i);
          }

          return i.Oa().toString(e) + o;
        }, q.Oa = function () {
          if (0 > this.c) {
            if (1 == this.b) return this[0] - this.K;
            if (0 == this.b) return -1;
          } else {
            if (1 == this.b) return this[0];
            if (0 == this.b) return 0;
          }

          return (this[1] & (1 << 32 - this.f) - 1) << this.f | this[0];
        }, q.fa = function (e, t) {
          for (var r = 0, n = 0, i = Math.min(e.b, this.b); r < i;) {
            n += this[r] + e[r], t[r++] = n & this.u, n >>= this.f;
          }

          if (e.b < this.b) {
            for (n += e.c; r < this.b;) {
              n += this[r], t[r++] = n & this.u, n >>= this.f;
            }

            n += this.c;
          } else {
            for (n += this.c; r < e.b;) {
              n += e[r], t[r++] = n & this.u, n >>= this.f;
            }

            n += e.c;
          }

          t.c = 0 > n ? -1 : 0, 0 < n ? t[r++] = n : -1 > n && (t[r++] = this.K + n), t.b = r, t.C();
        };
        var $ = {
          abs: function abs(e, t) {
            var r = (r = new Y(e, t)).n() ? r.i() : r;
            B[qb >> 2] = r.h, B[qb + 4 >> 2] = r.j;
          },
          Ka: function Ka() {
            $.kb || ($.kb = l, $.Xa = new X(), $.Xa.k("4294967296", 10), $.sa = new X(), $.sa.k("18446744073709551616", 10), $.xe = new X(), $.ye = new X());
          },
          me: function me(e, t) {
            var r = new X();
            r.k(t.toString(), 10);
            var n = new X();
            r.vb(n), (r = new X()).k(e.toString(), 10);
            var i = new X();
            return r.fa(n, i), i;
          },
          stringify: function stringify(e, t, r) {
            return e = new Y(e, t).toString(), r && "-" == e[0] && ($.Ka(), (r = new X()).k(e, 10), e = new X(), $.sa.fa(r, e), e = e.toString(10)), e;
          },
          k: function k(e, t, r, n, i) {
            $.Ka();
            var o = new X();
            o.k(e, t), (e = new X()).k(r, 10), (r = new X()).k(n, 10), i && 0 > o.U(X.ZERO) && (n = new X(), o.fa($.sa, n), o = n), n = p, 0 > o.U(e) ? (o = e, n = l) : 0 < o.U(r) && (o = r, n = l), o = Y.k(o.toString()), B[qb >> 2] = o.h, B[qb + 4 >> 2] = o.j, n && g("range error");
          }
        },
            cd,
            dd;

        function lb(e) {
          function t() {
            if (ab || (ab = l, Va(Xa)), Va(Ya), gb = l, s._main && kb && s.callMain(e), s.postRun) for ("function" == typeof s.postRun && (s.postRun = [s.postRun]); s.postRun.length;) {
              cb(s.postRun.shift());
            }
            Va($a);
          }

          if (e = e || s.arguments, 0 < L) s.P("run() called, but dependencies remain, so not running");else {
            if (s.preRun) for ("function" == typeof s.preRun && (s.preRun = [s.preRun]); s.preRun.length;) {
              bb(s.preRun.shift());
            }
            Va(Wa), 0 < L || (s.setStatus ? (s.setStatus("Running..."), setTimeout(function () {
              setTimeout(function () {
                s.setStatus("");
              }, 1), za || t();
            }, 1)) : t());
          }
        }

        function ed(e) {
          za = l, u = cd, Va(Za), dd && g({
            type: "ExitStatus",
            value: e
          });
        }

        function wa(e) {
          e && s.print(e), za = l, g("abort() at " + Error().stack);
        }

        if (lc = $, s.callMain = s.$d = function (e) {
          function t() {
            for (var e = 0; 3 > e; e++) {
              i.push(0);
            }
          }

          w(0 == L, "cannot call main when async dependencies remain! (listen on __ATMAIN__)"), w(0 == Wa.length, "cannot call main when preRun functions remain to be called"), e = e || [], ab || (ab = l, Va(Xa));
          var r,
              n = e.length + 1,
              i = [F(J("/bin/this.program"), "i8", Ka)];
          t();

          for (var o = 0; o < n - 1; o += 1) {
            i.push(F(J(e[o]), "i8", Ka)), t();
          }

          i.push(0), i = F(i, "i32", Ka), cd = u, dd = l;

          try {
            r = s._main(n, i, 0);
          } catch (e) {
            if (e && "object" == typeof e && "ExitStatus" == e.type) return s.print("Exit Status: " + e.value), e.value;
            "SimulateInfiniteLoop" == e ? s.noExitRuntime = l : g(e);
          } finally {
            dd = p;
          }

          s.noExitRuntime || ed(r);
        }, s.run = s.we = lb, s.exit = s.de = ed, s.abort = s.abort = wa, s.preInit) for ("function" == typeof s.preInit && (s.preInit = [s.preInit]); 0 < s.preInit.length;) {
          s.preInit.pop()();
        }
        var kb = l;
        s.noInitialRun && (kb = p), lb();

        var scrypt = function () {
          var e = {};

          function t(e) {
            for (var t = new Uint8Array(e.length), r = 0; r < e.length; r++) {
              var n = e.charCodeAt(r);
              if ((255 & n) !== n) throw {
                message: "Cannot encode string in Latin1",
                str: e
              };
              t[r] = 255 & n;
            }

            return t;
          }

          function r(e) {
            for (var t = [], r = 0; r < e.length; r++) {
              t.push(String.fromCharCode(e[r]));
            }

            return t.join("");
          }

          function n(e, t) {
            var r = t || 0,
                n = scrypt_raw._malloc(e.length + r);

            scrypt_raw.HEAPU8.set(e, n + r);

            for (var i = n; i < n + r; i++) {
              scrypt_raw.HEAPU8[i] = 0;
            }

            return n;
          }

          function i(e) {
            this.length = e, this.address = scrypt_raw._malloc(e);
          }

          return i.prototype.extractBytes = function (e) {
            var t = function (e, t) {
              var r = new Uint8Array(t);
              return r.set(scrypt_raw.HEAPU8.subarray(e, e + t)), r;
            }(this.address + (e || 0), this.length - (e || 0));

            return scrypt_raw._free(this.address), this.address = null, t;
          }, e.encode_utf8 = function (e) {
            return t(unescape(encodeURIComponent(e)));
          }, e.encode_latin1 = t, e.decode_utf8 = function (e) {
            return decodeURIComponent(escape(r(e)));
          }, e.decode_latin1 = r, e.to_hex = function (e) {
            for (var t = [], r = 0; r < e.length; r++) {
              t.push("0123456789abcdef"[e[r] >> 4 & 15]), t.push("0123456789abcdef"[15 & e[r]]);
            }

            return t.join("");
          }, e.random_bytes = function (e) {
            var t = new Uint8Array(e);
            if (void 0 !== window.crypto && void 0 !== window.crypto.getRandomValues) return window.crypto.getRandomValues(t), t;
            if (void 0 !== window.msCrypto && void 0 !== window.msCrypto.getRandomValues) return window.msCrypto.getRandomValues(t), t;
            throw {
              message: "No suitable random number generator found!"
            };
          }, e.crypto_scrypt = function (e, t, r, o, a, s) {
            var f = new i(s),
                c = n(e),
                u = n(t);
            return function (e, t) {
              if (0 !== t) throw {
                message: "scrypt_raw." + e + " signalled an error"
              };
            }("_crypto_scrypt", scrypt_raw._crypto_scrypt(c, e.length, u, t.length, r, 0, o, a, f.address, f.length)), function (e) {
              for (var t = 0; t < e.length; t++) {
                scrypt_raw._free(e[t]);
              }
            }([c, u]), f.extractBytes();
          }, e;
        }();

        return scrypt;
      };
    }).call(this, __webpack_require__(7), "/", __webpack_require__(69)(module));
  }, function (e, t, r) {
    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function a(e, t) {
      return !t || "object" !== n(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function f(e, t) {
      return (f = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var c = r(84),
        u = "undefined" != typeof fetch ? fetch : r(180),
        d = function (e) {
      function t() {
        return i(this, t), a(this, s(t).apply(this, arguments));
      }

      var r, n, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && f(e, t);
      }(t, e), r = t, (n = [{
        key: "_call",
        value: function value(e, t) {
          var r = {
            jsonrpc: "2.0",
            id: Date.now(),
            method: e,
            params: this.sanitizeParams(t)
          },
              n = {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json; charset=utf-8",
              Connection: this.options.keepConnection ? "keep-alive" : "close"
            },
            body: JSON.stringify(r)
          };
          return this.options.signal && (n.signal = this.options.signal), u(this.endpoint, n).then(function (e) {
            return e.json();
          });
        }
      }]) && o(r.prototype, n), c && o(r, c), t;
    }(c);

    e.exports = d;
  }, function (e, t) {
    e.exports = fetch;
  }, function (e, t, r) {
    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function o(e, t) {
      return !t || "object" !== n(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var f = r(84),
        c = r(182),
        u = "undefined" != typeof WebSocket ? WebSocket : r(202).w3cwebsocket,
        d = function (e) {
      function t(e, r) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (n = o(this, a(t).call(this, e, r, {
          createWebSocket: function createWebSocket(e) {
            return new u(e);
          },
          packMessage: function packMessage(e) {
            return JSON.stringify(e);
          },
          unpackMessage: function unpackMessage(e) {
            return JSON.parse(e);
          },
          attachRequestId: function attachRequestId(e, t) {
            return Object.assign({
              id: t
            }, e);
          },
          extractRequestId: function extractRequestId(e) {
            return e.id;
          }
        }))).wsp = new c(n.endpoint, n.options), n;
      }

      var r, n, f;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), r = t, (n = [{
        key: "close",
        value: function value() {
          this.wsp.close();
        }
      }, {
        key: "registerEventListener",
        value: function value(e, t) {
          this.wsp[e].addListener(t);
        }
      }, {
        key: "_call",
        value: function value(e, t) {
          var r = this,
              n = {
            jsonrpc: "2.0",
            method: e,
            params: this.sanitizeParams(t)
          };
          return this.wsp.isOpened ? this.wsp.sendRequest(n) : this.wsp.open().then(function () {
            return r.wsp.sendRequest(n);
          });
        }
      }]) && i(r.prototype, n), f && i(r, f), t;
    }(f);

    e.exports = d;
  }, function (e, t, r) {
    var n = r(183),
        i = r(85),
        o = r(186),
        a = r(200),
        _r4 = r(201),
        s = _r4.throwIf,
        f = 0,
        c = 1,
        u = 2,
        d = 3;

    e.exports =
    /*#__PURE__*/
    function () {
      "use strict";

      function _class(e, t) {
        _classCallCheck(this, _class);

        this._assertOptions(t), this._url = e, this._options = Object.assign({}, a, t), this._requests = new o(), this._ws = null, this._wsSubscription = null, this._createOpeningController(), this._createClosingController(), this._createChannels();
      }

      _createClass(_class, [{
        key: "open",
        value: function open() {
          var _this4 = this;

          return this.isClosing ? Promise.reject(new Error("Can't open WebSocket while closing.")) : this.isOpened ? this._opening.promise : this._opening.call(function () {
            _this4._opening.promise.catch(function (e) {
              return _this4._cleanup(e);
            }), _this4._createWS();
          });
        }
      }, {
        key: "sendRequest",
        value: function sendRequest(e) {
          var _this5 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var r = t.requestId || "".concat(Math.random()),
              n = void 0 !== t.timeout ? t.timeout : this._options.timeout;
          return this._requests.create(r, function () {
            _this5._assertRequestIdHandlers();

            var t = _this5._options.attachRequestId(e, r);

            _this5.sendPacked(t);
          }, n);
        }
      }, {
        key: "sendPacked",
        value: function sendPacked(e) {
          this._assertPackingHandlers();

          var t = this._options.packMessage(e);

          this.send(t);
        }
      }, {
        key: "send",
        value: function send(e) {
          s(!this.isOpened, "Can't send data because WebSocket is not opened."), this._ws.send(e), this._onSend.dispatchAsync(e);
        }
      }, {
        key: "close",
        value: function close() {
          var _this6 = this;

          return this.isClosed ? Promise.resolve(this._closing.value) : this._closing.call(function () {
            return _this6._ws.close();
          });
        }
      }, {
        key: "removeAllListeners",
        value: function removeAllListeners() {
          this._onOpen.removeAllListeners(), this._onMessage.removeAllListeners(), this._onUnpackedMessage.removeAllListeners(), this._onResponse.removeAllListeners(), this._onSend.removeAllListeners(), this._onClose.removeAllListeners(), this._onError.removeAllListeners();
        }
      }, {
        key: "_createOpeningController",
        value: function _createOpeningController() {
          var e = this._options.connectionTimeout || this._options.timeout;
          this._opening = new i({
            timeout: e,
            timeoutReason: "Can't open WebSocket within allowed timeout: ".concat(e, " ms.")
          });
        }
      }, {
        key: "_createClosingController",
        value: function _createClosingController() {
          var e = this._options.timeout;
          this._closing = new i({
            timeout: e,
            timeoutReason: "Can't close WebSocket within allowed timeout: ".concat(e, " ms.")
          });
        }
      }, {
        key: "_createChannels",
        value: function _createChannels() {
          this._onOpen = new n(), this._onMessage = new n(), this._onUnpackedMessage = new n(), this._onResponse = new n(), this._onSend = new n(), this._onClose = new n(), this._onError = new n();
        }
      }, {
        key: "_createWS",
        value: function _createWS() {
          var _this7 = this;

          this._ws = this._options.createWebSocket(this._url), this._wsSubscription = new n.Subscription([{
            channel: this._ws,
            event: "open",
            listener: function listener(e) {
              return _this7._handleOpen(e);
            }
          }, {
            channel: this._ws,
            event: "message",
            listener: function listener(e) {
              return _this7._handleMessage(e);
            }
          }, {
            channel: this._ws,
            event: "error",
            listener: function listener(e) {
              return _this7._handleError(e);
            }
          }, {
            channel: this._ws,
            event: "close",
            listener: function listener(e) {
              return _this7._handleClose(e);
            }
          }]).on();
        }
      }, {
        key: "_handleOpen",
        value: function _handleOpen(e) {
          this._onOpen.dispatchAsync(e), this._opening.resolve(e);
        }
      }, {
        key: "_handleMessage",
        value: function _handleMessage(e) {
          var t = this._options.extractMessageData(e);

          this._onMessage.dispatchAsync(t), this._tryUnpack(t);
        }
      }, {
        key: "_tryUnpack",
        value: function _tryUnpack(e) {
          this._options.unpackMessage && void 0 !== (e = this._options.unpackMessage(e)) && (this._onUnpackedMessage.dispatchAsync(e), this._tryHandleResponse(e));
        }
      }, {
        key: "_tryHandleResponse",
        value: function _tryHandleResponse(e) {
          if (this._options.extractRequestId) {
            var _t4 = this._options.extractRequestId(e);

            _t4 && (this._onResponse.dispatchAsync(e, _t4), this._requests.resolve(_t4, e));
          }
        }
      }, {
        key: "_handleError",
        value: function _handleError(e) {
          this._onError.dispatchAsync(e);
        }
      }, {
        key: "_handleClose",
        value: function _handleClose(e) {
          this._onClose.dispatchAsync(e), this._closing.resolve(e);
          var t = new Error("WebSocket closed with reason: ".concat(e.reason, " (").concat(e.code, ")."));
          this._opening.isPending && this._opening.reject(t), this._cleanup(t);
        }
      }, {
        key: "_cleanupWS",
        value: function _cleanupWS() {
          this._wsSubscription && (this._wsSubscription.off(), this._wsSubscription = null), this._ws = null;
        }
      }, {
        key: "_cleanup",
        value: function _cleanup(e) {
          this._cleanupWS(), this._requests.rejectAll(e);
        }
      }, {
        key: "_assertOptions",
        value: function _assertOptions(e) {
          Object.keys(e || {}).forEach(function (e) {
            if (!a.hasOwnProperty(e)) throw new Error("Unknown option: ".concat(e));
          });
        }
      }, {
        key: "_assertPackingHandlers",
        value: function _assertPackingHandlers() {
          var _this$_options = this._options,
              e = _this$_options.packMessage,
              t = _this$_options.unpackMessage;
          s(!e || !t, "Please define 'options.packMessage / options.unpackMessage' for sending packed messages.");
        }
      }, {
        key: "_assertRequestIdHandlers",
        value: function _assertRequestIdHandlers() {
          var _this$_options2 = this._options,
              e = _this$_options2.attachRequestId,
              t = _this$_options2.extractRequestId;
          s(!e || !t, "Please define 'options.attachRequestId / options.extractRequestId' for sending requests.");
        }
      }, {
        key: "ws",
        get: function get() {
          return this._ws;
        }
      }, {
        key: "url",
        get: function get() {
          return this._url;
        }
      }, {
        key: "isOpening",
        get: function get() {
          return Boolean(this._ws && this._ws.readyState === f);
        }
      }, {
        key: "isOpened",
        get: function get() {
          return Boolean(this._ws && this._ws.readyState === c);
        }
      }, {
        key: "isClosing",
        get: function get() {
          return Boolean(this._ws && this._ws.readyState === u);
        }
      }, {
        key: "isClosed",
        get: function get() {
          return Boolean(!this._ws || this._ws.readyState === d);
        }
      }, {
        key: "onOpen",
        get: function get() {
          return this._onOpen;
        }
      }, {
        key: "onSend",
        get: function get() {
          return this._onSend;
        }
      }, {
        key: "onMessage",
        get: function get() {
          return this._onMessage;
        }
      }, {
        key: "onUnpackedMessage",
        get: function get() {
          return this._onUnpackedMessage;
        }
      }, {
        key: "onResponse",
        get: function get() {
          return this._onResponse;
        }
      }, {
        key: "onClose",
        get: function get() {
          return this._onClose;
        }
      }, {
        key: "onError",
        get: function get() {
          return this._onError;
        }
      }]);

      return _class;
    }();
  }, function (e, t, r) {
    "use strict";
    /* chnl v1.1.0 by Vitaliy Potapov @preserve */

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function a(e, t, r) {
      return t && o(e.prototype, t), r && o(e, r), e;
    }

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && function (e, t) {
        (Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }(e, t);
    }

    function f(e) {
      return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function c(e, t) {
      return !t || "object" != typeof t && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    var u = function () {
      function e(t) {
        i(this, e), this._listeners = [], this._mute = !1, this._accumulate = !1, this._accumulatedEvents = [], this._name = t || "", this._onListenerAdded = null, this._onFirstListenerAdded = null, this._onListenerRemoved = null, this._onLastListenerRemoved = null;
      }

      return a(e, [{
        key: "addListener",
        value: function value(e, t) {
          this._pushListener(e, t, !1);
        }
      }, {
        key: "addOnceListener",
        value: function value(e, t) {
          this._pushListener(e, t, !0);
        }
      }, {
        key: "removeListener",
        value: function value(e, t) {
          this._ensureFunction(e);

          var r = this._indexOfListener(e, t);

          0 <= r && this._spliceListener(r);
        }
      }, {
        key: "removeAllListeners",
        value: function value() {
          for (; this.hasListeners();) {
            this._spliceListener(0);
          }
        }
      }, {
        key: "hasListener",
        value: function value(e, t) {
          return this._ensureFunction(e), 0 <= this._indexOfListener(e, t);
        }
      }, {
        key: "hasListeners",
        value: function value() {
          return 0 < this._listeners.length;
        }
      }, {
        key: "dispatch",
        value: function value() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          this._invokeListeners({
            args: t,
            async: !1
          });
        }
      }, {
        key: "dispatchAsync",
        value: function value() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          this._invokeListeners({
            args: t,
            async: !0
          });
        }
      }, {
        key: "mute",
        value: function value(e) {
          var t = 0 < arguments.length && void 0 !== e ? e : {};
          this._mute = !0, t.accumulate ? this._accumulate = !0 : (this._accumulate = !1, this._accumulatedEvents = []);
        }
      }, {
        key: "unmute",
        value: function value() {
          this._mute = !1, this._accumulate && (this._dispatchAccumulated(), this._accumulate = !1);
        }
      }, {
        key: "_invokeListeners",
        value: function value(e) {
          var t = this,
              r = 0 < arguments.length && void 0 !== e ? e : {
            args: [],
            async: !1
          };
          this._mute ? this._accumulate && this._accumulatedEvents.push(r) : this._listeners.slice().forEach(function (e) {
            t._invokeListener(e, r), e.once && t.removeListener(e.callback, e.context);
          });
        }
      }, {
        key: "_invokeListener",
        value: function value(e, t) {
          t.async ? setTimeout(function () {
            return e.callback.apply(e.context, t.args);
          }, 0) : e.callback.apply(e.context, t.args);
        }
      }, {
        key: "_ensureFunction",
        value: function value(e) {
          if ("function" != typeof e) throw new Error("Channel " + this._name + ": listener is not a function");
        }
      }, {
        key: "_dispatchInnerAddEvents",
        value: function value() {
          var e, t;
          this._onListenerAdded && (e = this._onListenerAdded).dispatch.apply(e, arguments), this._onFirstListenerAdded && 1 === this._listeners.length && (t = this._onFirstListenerAdded).dispatch.apply(t, arguments);
        }
      }, {
        key: "_dispatchInnerRemoveEvents",
        value: function value() {
          var e, t;
          this._onListenerRemoved && (e = this._onListenerRemoved).dispatch.apply(e, arguments), this._onLastListenerRemoved && 0 === this._listeners.length && (t = this._onLastListenerRemoved).dispatch.apply(t, arguments);
        }
      }, {
        key: "_indexOfListener",
        value: function value(e, t) {
          for (var r = 0; r < this._listeners.length; r++) {
            var n = this._listeners[r],
                i = n.callback === e,
                o = void 0 === t && void 0 === n.context,
                a = t === n.context;
            if (i && (o || a)) return r;
          }
        }
      }, {
        key: "_dispatchAccumulated",
        value: function value() {
          var e = this;
          this._accumulatedEvents.forEach(function (t) {
            return e._invokeListeners(t);
          }), this._accumulatedEvents = [];
        }
      }, {
        key: "_pushListener",
        value: function value(e, t, r) {
          this._ensureFunction(e), this._listeners.push({
            callback: e,
            context: t,
            once: r
          }), this._dispatchInnerAddEvents(e, t, r);
        }
      }, {
        key: "_spliceListener",
        value: function value(e) {
          var t = this._listeners[e],
              r = t.callback,
              n = t.context,
              i = t.once;
          this._listeners.splice(e, 1), this._dispatchInnerRemoveEvents(r, n, i);
        }
      }, {
        key: "onListenerAdded",
        get: function get() {
          return this._onListenerAdded || (this._onListenerAdded = new e("".concat(this._name, ":onListenerAdded"))), this._onListenerAdded;
        }
      }, {
        key: "onFirstListenerAdded",
        get: function get() {
          return this._onFirstListenerAdded || (this._onFirstListenerAdded = new e("".concat(this._name, ":onFirstListenerAdded"))), this._onFirstListenerAdded;
        }
      }, {
        key: "onListenerRemoved",
        get: function get() {
          return this._onListenerRemoved || (this._onListenerRemoved = new e("".concat(this._name, ":onListenerRemoved"))), this._onListenerRemoved;
        }
      }, {
        key: "onLastListenerRemoved",
        get: function get() {
          return this._onLastListenerRemoved || (this._onLastListenerRemoved = new e("".concat(this._name, ":onLastListenerRemoved"))), this._onLastListenerRemoved;
        }
      }]), e;
    }(),
        d = function () {
      function e() {
        i(this, e), this._channels = new Map();
      }

      return a(e, [{
        key: "addListener",
        value: function value(e, t, r) {
          this._getChannel(e).addListener(t, r);
        }
      }, {
        key: "on",
        value: function value(e, t, r) {
          this.addListener(e, t, r);
        }
      }, {
        key: "addOnceListener",
        value: function value(e, t, r) {
          this._getChannel(e).addOnceListener(t, r);
        }
      }, {
        key: "once",
        value: function value(e, t, r) {
          this.addOnceListener(e, t, r);
        }
      }, {
        key: "removeListener",
        value: function value(e, t, r) {
          this._getChannel(e).removeListener(t, r);
        }
      }, {
        key: "off",
        value: function value(e, t, r) {
          this.removeListener(e, t, r);
        }
      }, {
        key: "hasListener",
        value: function value(e, t, r) {
          return this._getChannel(e).hasListener(t, r);
        }
      }, {
        key: "has",
        value: function value(e, t, r) {
          return this.hasListener(e, t, r);
        }
      }, {
        key: "hasListeners",
        value: function value(e) {
          return this._getChannel(e).hasListeners();
        }
      }, {
        key: "dispatch",
        value: function value(e) {
          for (var t, r = arguments.length, n = new Array(1 < r ? r - 1 : 0), i = 1; i < r; i++) {
            n[i - 1] = arguments[i];
          }

          (t = this._getChannel(e)).dispatch.apply(t, n);
        }
      }, {
        key: "emit",
        value: function value(e) {
          for (var t = arguments.length, r = new Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
            r[n - 1] = arguments[n];
          }

          this.dispatch.apply(this, [e].concat(r));
        }
      }, {
        key: "_getChannel",
        value: function value(e) {
          return this._channels.has(e) || this._channels.set(e, new u(e)), this._channels.get(e);
        }
      }]), e;
    }(),
        h = function () {
      function e(t) {
        i(this, e), this._params = t, this._isOn = !1, this._assertParams();
      }

      return a(e, [{
        key: "on",
        value: function value() {
          if (!this._isOn) {
            var e = this._params.channel,
                t = e.addListener || e.addEventListener || e.on;
            this._applyMethod(t), this._isOn = !0;
          }
        }
      }, {
        key: "off",
        value: function value() {
          if (this._isOn) {
            var e = this._params.channel,
                t = e.removeListener || e.removeEventListener || e.off;
            this._applyMethod(t), this._isOn = !1;
          }
        }
      }, {
        key: "_applyMethod",
        value: function value(e) {
          var t = this._params,
              r = t.channel,
              n = t.event,
              i = t.listener,
              o = n ? [n, i] : [i];
          e.apply(r, o);
        }
      }, {
        key: "_assertParams",
        value: function value() {
          var e = this._params,
              t = e.channel,
              r = e.event,
              i = e.listener;
          if (!t || "object" !== n(t)) throw new Error("Channel should be object");
          if (r && "string" != typeof r) throw new Error("Event should be string");
          if (!i || "function" != typeof i) throw new Error("Listener should be function");
        }
      }]), e;
    }(),
        l = function () {
      function e(t) {
        i(this, e), this._items = t.map(function (e) {
          return new h(e);
        });
      }

      return a(e, [{
        key: "on",
        value: function value() {
          return this._items.forEach(function (e) {
            return e.on();
          }), this;
        }
      }, {
        key: "off",
        value: function value() {
          return this._items.forEach(function (e) {
            return e.off();
          }), this;
        }
      }]), e;
    }(),
        p = function () {
      function e(t, r) {
        var n;
        return i(this, e), (n = c(this, f(e).call(this, r)))._overrideComponentCallback(t, "componentDidMount", "on"), n._overrideComponentCallback(t, "componentWillUnmount", "off"), n;
      }

      return s(e, l), a(e, [{
        key: "_overrideComponentCallback",
        value: function value(e, t, r) {
          var n = this,
              i = e[t];

          e[t] = function () {
            if (n[r](), "function" == typeof i) {
              for (var t = arguments.length, o = new Array(t), a = 0; a < t; a++) {
                o[a] = arguments[a];
              }

              return i.apply(e, o);
            }
          };
        }
      }]), e;
    }(),
        b = u;

    b.EventEmitter = d, b.Subscription = l, b.ReactSubscription = p, e.exports = b;
  }, function (e, t) {
    e.exports = {
      timeout: 0,
      timeoutReason: "Promise rejected by PromiseController timeout {timeout} ms.",
      resetReason: "Promise rejected by PromiseController reset."
    };
  }, function (e, t) {
    t.isPromise = function (e) {
      return e && "function" == typeof e.then;
    }, t.tryCall = function (e) {
      return "function" == typeof e ? e() : e;
    }, t.createErrorType = function (e) {
      function t(e) {
        Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e;
      }

      return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
    };
  }, function (e, t, r) {
    var n = r(85),
        i = r(187);

    e.exports =
    /*#__PURE__*/
    function () {
      "use strict";

      function _class2() {
        _classCallCheck(this, _class2);

        this._items = new Map();
      }

      _createClass(_class2, [{
        key: "create",
        value: function create(e, t, r) {
          return this._rejectExistingRequest(e), this._createNewRequest(e, t, r);
        }
      }, {
        key: "resolve",
        value: function resolve(e, t) {
          e && this._items.has(e) && this._items.get(e).resolve(t);
        }
      }, {
        key: "rejectAll",
        value: function rejectAll(e) {
          this._items.forEach(function (t) {
            return t.isPending ? t.reject(e) : null;
          });
        }
      }, {
        key: "_rejectExistingRequest",
        value: function _rejectExistingRequest(e) {
          var t = this._items.get(e);

          t && t.isPending && t.reject(new Error("WebSocket request is replaced, id: ".concat(e)));
        }
      }, {
        key: "_createNewRequest",
        value: function _createNewRequest(e, t, r) {
          var _this8 = this;

          var o = new n({
            timeout: r,
            timeoutReason: "WebSocket request was rejected by timeout (".concat(r, " ms). RequestId: ").concat(e)
          });
          return this._items.set(e, o), i(o.call(t), function () {
            return _this8._deleteRequest(e, o);
          });
        }
      }, {
        key: "_deleteRequest",
        value: function _deleteRequest(e, t) {
          this._items.get(e) === t && this._items.delete(e);
        }
      }]);

      return _class2;
    }();
  }, function (e, t, r) {
    "use strict";

    var n = r(86),
        i = r(87),
        o = r(89),
        a = r(91),
        s = r(199),
        f = n.call(Function.call, a());
    i(f, {
      getPolyfill: a,
      implementation: o,
      shim: s
    }), e.exports = f;
  }, function (e, t, r) {
    "use strict";

    var n = "Function.prototype.bind called on incompatible ",
        i = Array.prototype.slice,
        o = Object.prototype.toString;

    e.exports = function (e) {
      var t = this;
      if ("function" != typeof t || "[object Function]" !== o.call(t)) throw new TypeError(n + t);

      for (var r, a = i.call(arguments, 1), s = function s() {
        if (this instanceof r) {
          var n = t.apply(this, a.concat(i.call(arguments)));
          return Object(n) === n ? n : this;
        }

        return t.apply(e, a.concat(i.call(arguments)));
      }, f = Math.max(0, t.length - a.length), c = [], u = 0; u < f; u++) {
        c.push("$" + u);
      }

      if (r = Function("binder", "return function (" + c.join(",") + "){ return binder.apply(this,arguments); }")(s), t.prototype) {
        var d = function d() {};

        d.prototype = t.prototype, r.prototype = new d(), d.prototype = null;
      }

      return r;
    };
  }, function (e, t, r) {
    "use strict";

    var n = Array.prototype.slice,
        i = r(88),
        o = Object.keys,
        a = o ? function (e) {
      return o(e);
    } : r(190),
        s = Object.keys;
    a.shim = function () {
      Object.keys ? function () {
        var e = Object.keys(arguments);
        return e && e.length === arguments.length;
      }(1, 2) || (Object.keys = function (e) {
        return i(e) ? s(n.call(e)) : s(e);
      }) : Object.keys = a;
      return Object.keys || a;
    }, e.exports = a;
  }, function (e, t, r) {
    "use strict";

    var n;

    if (!Object.keys) {
      var i = Object.prototype.hasOwnProperty,
          o = Object.prototype.toString,
          a = r(88),
          s = Object.prototype.propertyIsEnumerable,
          f = !s.call({
        toString: null
      }, "toString"),
          c = s.call(function () {}, "prototype"),
          u = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
          d = function d(e) {
        var t = e.constructor;
        return t && t.prototype === e;
      },
          h = {
        $applicationCache: !0,
        $console: !0,
        $external: !0,
        $frame: !0,
        $frameElement: !0,
        $frames: !0,
        $innerHeight: !0,
        $innerWidth: !0,
        $outerHeight: !0,
        $outerWidth: !0,
        $pageXOffset: !0,
        $pageYOffset: !0,
        $parent: !0,
        $scrollLeft: !0,
        $scrollTop: !0,
        $scrollX: !0,
        $scrollY: !0,
        $self: !0,
        $webkitIndexedDB: !0,
        $webkitStorageInfo: !0,
        $window: !0
      },
          l = function () {
        if ("undefined" == typeof window) return !1;

        for (var e in window) {
          try {
            if (!h["$" + e] && i.call(window, e) && null !== window[e] && "object" == typeof window[e]) try {
              d(window[e]);
            } catch (e) {
              return !0;
            }
          } catch (e) {
            return !0;
          }
        }

        return !1;
      }();

      n = function n(e) {
        var t = null !== e && "object" == typeof e,
            r = "[object Function]" === o.call(e),
            n = a(e),
            s = t && "[object String]" === o.call(e),
            h = [];
        if (!t && !r && !n) throw new TypeError("Object.keys called on a non-object");
        var p = c && r;
        if (s && e.length > 0 && !i.call(e, 0)) for (var b = 0; b < e.length; ++b) {
          h.push(String(b));
        }
        if (n && e.length > 0) for (var m = 0; m < e.length; ++m) {
          h.push(String(m));
        } else for (var y in e) {
          p && "prototype" === y || !i.call(e, y) || h.push(String(y));
        }
        if (f) for (var v = function (e) {
          if ("undefined" == typeof window || !l) return d(e);

          try {
            return d(e);
          } catch (e) {
            return !1;
          }
        }(e), g = 0; g < u.length; ++g) {
          v && "constructor" === u[g] || !i.call(e, u[g]) || h.push(u[g]);
        }
        return h;
      };
    }

    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    e.exports = r(192);
  }, function (e, t, r) {
    "use strict";

    var n = Function.prototype.toString,
        i = /^\s*class\b/,
        o = function o(e) {
      try {
        var t = n.call(e);
        return i.test(t);
      } catch (e) {
        return !1;
      }
    },
        a = Object.prototype.toString,
        s = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag;

    e.exports = function (e) {
      if (!e) return !1;
      if ("function" != typeof e && "object" != typeof e) return !1;
      if ("function" == typeof e && !e.prototype) return !0;
      if (s) return function (e) {
        try {
          return !o(e) && (n.call(e), !0);
        } catch (e) {
          return !1;
        }
      }(e);
      if (o(e)) return !1;
      var t = a.call(e);
      return "[object Function]" === t || "[object GeneratorFunction]" === t;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(194),
        i = n("%Symbol.species%", !0),
        o = n("%TypeError%"),
        a = r(197),
        s = r(90);

    e.exports = function (e, t) {
      if ("Object" !== s(e)) throw new o("Assertion failed: Type(O) is not Object");
      var r = e.constructor;
      if (void 0 === r) return t;
      if ("Object" !== s(r)) throw new o("O.constructor is not an Object");
      var n = i ? r[i] : void 0;
      if (null == n) return t;
      if (a(n)) return n;
      throw new o("no constructor found");
    };
  }, function (e, t, r) {
    "use strict";

    var n = TypeError,
        i = Object.getOwnPropertyDescriptor;
    if (i) try {
      i({}, "");
    } catch (e) {
      i = null;
    }

    var o = function o() {
      throw new n();
    },
        a = i ? function () {
      try {
        return arguments.callee, o;
      } catch (e) {
        try {
          return i(arguments, "callee").get;
        } catch (e) {
          return o;
        }
      }
    }() : o,
        s = r(195)(),
        f = Object.getPrototypeOf || function (e) {
      return e.__proto__;
    },
        c = void 0,
        u = "undefined" == typeof Uint8Array ? void 0 : f(Uint8Array),
        d = {
      "%Array%": Array,
      "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
      "%ArrayBufferPrototype%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer.prototype,
      "%ArrayIteratorPrototype%": s ? f([][Symbol.iterator]()) : void 0,
      "%ArrayPrototype%": Array.prototype,
      "%ArrayProto_entries%": Array.prototype.entries,
      "%ArrayProto_forEach%": Array.prototype.forEach,
      "%ArrayProto_keys%": Array.prototype.keys,
      "%ArrayProto_values%": Array.prototype.values,
      "%AsyncFromSyncIteratorPrototype%": void 0,
      "%AsyncFunction%": void 0,
      "%AsyncFunctionPrototype%": void 0,
      "%AsyncGenerator%": void 0,
      "%AsyncGeneratorFunction%": void 0,
      "%AsyncGeneratorPrototype%": void 0,
      "%AsyncIteratorPrototype%": c && s && Symbol.asyncIterator ? c[Symbol.asyncIterator]() : void 0,
      "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
      "%Boolean%": Boolean,
      "%BooleanPrototype%": Boolean.prototype,
      "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
      "%DataViewPrototype%": "undefined" == typeof DataView ? void 0 : DataView.prototype,
      "%Date%": Date,
      "%DatePrototype%": Date.prototype,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%ErrorPrototype%": Error.prototype,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%EvalErrorPrototype%": EvalError.prototype,
      "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
      "%Float32ArrayPrototype%": "undefined" == typeof Float32Array ? void 0 : Float32Array.prototype,
      "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
      "%Float64ArrayPrototype%": "undefined" == typeof Float64Array ? void 0 : Float64Array.prototype,
      "%Function%": Function,
      "%FunctionPrototype%": Function.prototype,
      "%Generator%": void 0,
      "%GeneratorFunction%": void 0,
      "%GeneratorPrototype%": void 0,
      "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
      "%Int8ArrayPrototype%": "undefined" == typeof Int8Array ? void 0 : Int8Array.prototype,
      "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
      "%Int16ArrayPrototype%": "undefined" == typeof Int16Array ? void 0 : Int8Array.prototype,
      "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
      "%Int32ArrayPrototype%": "undefined" == typeof Int32Array ? void 0 : Int32Array.prototype,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": s ? f(f([][Symbol.iterator]())) : void 0,
      "%JSON%": "object" == typeof JSON ? JSON : void 0,
      "%JSONParse%": "object" == typeof JSON ? JSON.parse : void 0,
      "%Map%": "undefined" == typeof Map ? void 0 : Map,
      "%MapIteratorPrototype%": "undefined" != typeof Map && s ? f(new Map()[Symbol.iterator]()) : void 0,
      "%MapPrototype%": "undefined" == typeof Map ? void 0 : Map.prototype,
      "%Math%": Math,
      "%Number%": Number,
      "%NumberPrototype%": Number.prototype,
      "%Object%": Object,
      "%ObjectPrototype%": Object.prototype,
      "%ObjProto_toString%": Object.prototype.toString,
      "%ObjProto_valueOf%": Object.prototype.valueOf,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
      "%PromisePrototype%": "undefined" == typeof Promise ? void 0 : Promise.prototype,
      "%PromiseProto_then%": "undefined" == typeof Promise ? void 0 : Promise.prototype.then,
      "%Promise_all%": "undefined" == typeof Promise ? void 0 : Promise.all,
      "%Promise_reject%": "undefined" == typeof Promise ? void 0 : Promise.reject,
      "%Promise_resolve%": "undefined" == typeof Promise ? void 0 : Promise.resolve,
      "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
      "%RangeError%": RangeError,
      "%RangeErrorPrototype%": RangeError.prototype,
      "%ReferenceError%": ReferenceError,
      "%ReferenceErrorPrototype%": ReferenceError.prototype,
      "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
      "%RegExp%": RegExp,
      "%RegExpPrototype%": RegExp.prototype,
      "%Set%": "undefined" == typeof Set ? void 0 : Set,
      "%SetIteratorPrototype%": "undefined" != typeof Set && s ? f(new Set()[Symbol.iterator]()) : void 0,
      "%SetPrototype%": "undefined" == typeof Set ? void 0 : Set.prototype,
      "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
      "%SharedArrayBufferPrototype%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer.prototype,
      "%String%": String,
      "%StringIteratorPrototype%": s ? f(""[Symbol.iterator]()) : void 0,
      "%StringPrototype%": String.prototype,
      "%Symbol%": s ? Symbol : void 0,
      "%SymbolPrototype%": s ? Symbol.prototype : void 0,
      "%SyntaxError%": SyntaxError,
      "%SyntaxErrorPrototype%": SyntaxError.prototype,
      "%ThrowTypeError%": a,
      "%TypedArray%": u,
      "%TypedArrayPrototype%": u ? u.prototype : void 0,
      "%TypeError%": n,
      "%TypeErrorPrototype%": n.prototype,
      "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
      "%Uint8ArrayPrototype%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array.prototype,
      "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
      "%Uint8ClampedArrayPrototype%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray.prototype,
      "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
      "%Uint16ArrayPrototype%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array.prototype,
      "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
      "%Uint32ArrayPrototype%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array.prototype,
      "%URIError%": URIError,
      "%URIErrorPrototype%": URIError.prototype,
      "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
      "%WeakMapPrototype%": "undefined" == typeof WeakMap ? void 0 : WeakMap.prototype,
      "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet,
      "%WeakSetPrototype%": "undefined" == typeof WeakSet ? void 0 : WeakSet.prototype
    },
        h = r(86).call(Function.call, String.prototype.replace),
        l = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
        p = /\\(\\)?/g,
        b = function b(e) {
      var t = [];
      return h(e, l, function (e, r, n, i) {
        t[t.length] = n ? h(i, p, "$1") : r || e;
      }), t;
    },
        m = function m(e, t) {
      if (!(e in d)) throw new SyntaxError("intrinsic " + e + " does not exist!");
      if (void 0 === d[e] && !t) throw new n("intrinsic " + e + " exists, but is not available. Please file an issue!");
      return d[e];
    };

    e.exports = function (e, t) {
      if ("string" != typeof e || 0 === e.length) throw new TypeError("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof t) throw new TypeError('"allowMissing" argument must be a boolean');

      for (var r = b(e), o = m("%" + (r.length > 0 ? r[0] : "") + "%", t), a = 1; a < r.length; a += 1) {
        if (null != o) if (i && a + 1 >= r.length) {
          var s = i(o, r[a]);
          if (!(t || r[a] in o)) throw new n("base intrinsic for " + e + " exists, but the property is not available.");
          o = s ? s.get || s.value : o[r[a]];
        } else o = o[r[a]];
      }

      return o;
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = t.Symbol,
          i = r(196);

      e.exports = function () {
        return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
      };
    }).call(this, r(6));
  }, function (e, t, r) {
    "use strict";

    e.exports = function () {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" == typeof Symbol.iterator) return !0;
      var e = {},
          t = Symbol("test"),
          r = Object(t);
      if ("string" == typeof t) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;

      for (t in e[t] = 42, e) {
        return !1;
      }

      if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
      if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
      var n = Object.getOwnPropertySymbols(e);
      if (1 !== n.length || n[0] !== t) return !1;
      if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;

      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var i = Object.getOwnPropertyDescriptor(e, t);
        if (42 !== i.value || !0 !== i.enumerable) return !1;
      }

      return !0;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return "function" == typeof e && !!e.prototype;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return null === e ? "Null" : void 0 === e ? "Undefined" : "function" == typeof e || "object" == typeof e ? "Object" : "number" == typeof e ? "Number" : "boolean" == typeof e ? "Boolean" : "string" == typeof e ? "String" : void 0;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(45),
        i = r(91),
        o = r(87);

    e.exports = function () {
      n();
      var e = i();
      return o(Promise.prototype, {
        finally: e
      }, {
        finally: function _finally() {
          return Promise.prototype.finally !== e;
        }
      }), e;
    };
  }, function (e, t) {
    e.exports = {
      createWebSocket: function createWebSocket(e) {
        return new WebSocket(e);
      },
      packMessage: null,
      unpackMessage: null,
      attachRequestId: null,
      extractRequestId: null,
      extractMessageData: function extractMessageData(e) {
        return e.data;
      },
      timeout: 0,
      connectionTimeout: 0
    };
  }, function (e, t) {
    t.throwIf = function (e, t) {
      if (e) throw new Error(t);
    };
  }, function (e, t) {
    e.exports = WebSocket;
  }]);
});